// Auto-generated from Contentful export - DO NOT EDIT MANUALLY
// Generated on: 2026-01-14T06:32:21.647Z

export const blogPostsData = [
  {
    id: '4PxdpjIJXDNXwOzGd0dq4X',
    postTitle: 'The first mile of every import is overlooked, but expensive',
    seoTitle: 'The first mile of every import is overlooked, but expensive',
    seoUrlSlug: 'the-first-mile-of-every-import-is-overlooked-but-expensive',
    seoMetaDescription:
      'Most software systems are designed to process data that’s shaped a certain way: clear headers, consistent rows, a standard tabular layout. But incoming files often carry structural quirks.\n',
    category: 'Product updates & features',
    tags: ['ai', 'extract', 'featured'],
    sortOrder: '0',
    publishDate: '2025-07-15T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6vTr89XAgfKmMVXF9dciA0',
        type: 'Asset',
        createdAt: '2025-07-15T15:08:38.083Z',
        updatedAt: '2025-07-15T15:08:38.083Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Smart Extract blog',
        description: '',
        file: {
          url: '/img/contentful/6vTr89XA-smart_extract_blog.webp',
          details: {
            size: 2327775,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Smart Extract Blog.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'The first mile of every import is overlooked, but expensive',
    summary:
      'Before any mapping or cleanup can happen, someone on your team has to make sense of how the file is structured. You hope the files come in standard formats, ready to be imported and mapped. When that doesn’t happen, your team spends hours restructuring the data just to be ready to import—and the customer doesn’t feel the value from any of it.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7jrQyysh9kfu5myoQ6xVlz',
        type: 'Entry',
        createdAt: '2024-10-21T18:48:06.682Z',
        updatedAt: '2025-07-22T05:56:04.011Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Damon Banks',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'zlzCDF5MTezn2qILOHa48',
            type: 'Asset',
            createdAt: '2024-10-21T18:47:50.867Z',
            updatedAt: '2025-07-22T04:49:31.014Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 7,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Damon',
            description: '',
            file: {
              url: '/img/contentful/zlzCDF5M-dsc09345.webp',
              details: {
                size: 1413631,
                image: {
                  width: 1477,
                  height: 1477
                }
              },
              fileName: 'DSC09345.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Staff AI Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A customer’s spreadsheet arrives. You cross your fingers and open it—only to find it’s full of complexities like metadata, multiple header rows, and hierarchical data. And your system isn’t prepared to import any of that.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This hurdle is where a massive amount of time and effort gets spent. Compound the effects over dozens of onboarding or migration projects and you have some serious drag.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It’s the first mile of data projects. And it’s where projects risk losing momentum—and running up costs—before the “real work” even begins. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7g23zXy86sA434S3cvDMR5',
                type: 'Entry',
                createdAt: '2025-07-15T04:33:53.538Z',
                updatedAt: '2025-07-15T04:33:53.538Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 2,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'wistiaVideo'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Smart Extract',
                video: {
                  items: [
                    {
                      hashed_id: 'si6842uqfd',
                      id: 136097025,
                      duration: 35.072,
                      thumbnail: {
                        url: 'https://embed-ssl.wistia.com/deliveries/d8ffd15bd46e9373df0c8cb2a329ea261d5a6e5f.jpg?image_crop_resized=200x120',
                        width: 200,
                        height: 120
                      }
                    }
                  ]
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The work before the work',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Before any schema mapping or data cleanup can happen, someone on your team has to make sense of how the file is structured.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Where the table actually starts, whether the header is complete or split across lines, whether there’s a second table hiding further down the sheet—there’s very little you can do with the provided data until you’re able to make sense of the format.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This work isn’t always accounted for when estimating project duration. You hope the files come in standard formats, ready to be imported and mapped. When that doesn’t happen, your team spends hours manually restructuring the data just to be ready to import—and the customer doesn’t feel the value from any of it.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Why most systems miss this step',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Most software systems are designed to process data that’s shaped a certain way: clear headers, consistent rows, a standard tabular layout. But incoming files often carry structural quirks based on how they were exported, who generated them, or what context they were meant to capture.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Templates try to enforce consistency, but real-world exports don’t follow rules. Even files from the same system can vary depending on filters, report settings, and so on.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Historically, managing variability has been incredibly costly. Standardizing inputs has been the key to automation and scale. But just as AI is making personal, 1:1 software applications a viable path forward, it enables us to build solutions for data extraction that are unique to each file.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5rTrBQvvSXby6Gy1aOVWM5',
                type: 'Asset',
                createdAt: '2025-07-15T15:19:20.452Z',
                updatedAt: '2025-07-15T15:19:20.452Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Smart Extract UI',
                description: '',
                file: {
                  url: '/img/contentful/5rTrBQvv-smart_extract_what-s_new__1_.webp',
                  details: {
                    size: 1739931,
                    image: {
                      width: 1920,
                      height: 1085
                    }
                  },
                  fileName: 'Smart Extract What-s New (1).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'What Smart Extract does',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When a file is uploaded to Flatfile, Smart Extract analyzes the structure and searches for complexities that a standard import can’t handle. Specifically, it’s looking for signs of the following:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Global or local metadata',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Multiple header rows',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Multiple tables within a sheet',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Summary or total rows',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Shifted data tables',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Hierarchical data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it encounters any of the above, Smart Extract writes a custom extractor to parse the data and bring it into Flatfile ready to work.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As with all of Flatfile’s AI-powered features, you’ll see a preview before you accept any actions made by the agent. If the structure shown isn’t what you need, or if there are any other issues with the proposed extraction, you can prompt the chat assistant to refine.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'No more writing your own extractors or installing plugins to handle your more complex files—Smart Extract analyzes and executes in seconds.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'What changes when you get the structure right up front',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When Smart Extract interprets the file’s structure at upload, the rest of the process can begin immediately. There’s no need to prep the file in Excel or escalate to an analyst before you can begin the next step of mapping fields.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Implementation teams and their customers can review and adjust the extracted structure inside Flatfile instead of resolving layout issues offline. Analyst teams can reclaim the time they’d otherwise spend sorting through unique customer files. Project timelines aren’t held up waiting on reformatted versions of the same data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It makes structure something the system handles, not the team. Instead of pausing to fix each file, teams can treat uploads as the starting point and move directly into mapping and review. No extra cleanup, no external prep work.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Why this was worth building',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Smart Extract was built to handle the structural interpretation work that slows down every file import—work that’s usually manual, inconsistent, and hard to scale.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'By appropriately structuring the file at upload, it shortens the time between receiving a file and putting it to use. Teams spend less time reformatting, customers aren’t asked to resend cleaner versions, and onboarding stays on track even when file structures vary.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It’s a practical change, but a productive one—fewer delays, less back-and-forth, and a process that holds up across dozens or hundreds of incoming files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "I'll be demoing Smart Extract in a webinar on August 5 at 1 PM ET. Register to attend ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/webinars/high-variance-files-are-killing-your-data-onboarding-flow/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "In the meantime, if you'd like to learn more, find the Smart Extract Knowledge Base article ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://support.flatfile.com/articles/7144958493-how%20to%20use%20smart%20extract'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7x30zg6EDD0LGoYx1zJcra',
    postTitle: 'From reactive cleanup to proactive resolution: Transform Agent',
    seoTitle: 'From reactive cleanup to proactive resolution: Transform Agent',
    seoUrlSlug: 'from-reactive-cleanup-to-proactive-resolution-transform-agent',
    seoMetaDescription:
      "Flatfile's new Transform Agent reasons about your data, recommends actions to resolve errors, performs the data cleanup for you, and saves the transforms you approve to rerun on every project.",
    category: 'Product updates & features',
    tags: ['AI', 'featured'],
    sortOrder: '0',
    publishDate: '2025-07-08T10:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6O6S5CfQxUnHINQ32od2Iy',
        type: 'Asset',
        createdAt: '2025-07-08T18:58:21.232Z',
        updatedAt: '2025-07-08T18:58:21.232Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Transform agent blog',
        description: '',
        file: {
          url: '/img/contentful/6O6S5CfQ-transform_blog__1_.webp',
          details: {
            size: 1693714,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Transform blog (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'From reactive cleanup to proactive resolution: Transform Agent',
    summary:
      "Flatfile's new Transform Agent reasons about your data, recommends actions to resolve errors, performs the data cleanup for you, and saves the transforms you approve to rerun on every project.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3RwGqzEaxtuBBiik5VnR0z',
        type: 'Entry',
        createdAt: '2025-07-08T00:48:14.671Z',
        updatedAt: '2025-07-08T18:58:46.355Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Craig Wattrus',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '4iHsqlQs7XJBj2vefI6kT2',
            type: 'Asset',
            createdAt: '2025-07-08T00:47:44.687Z',
            updatedAt: '2025-07-08T00:47:44.687Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Craig',
            description: '',
            file: {
              url: '/img/contentful/4iHsqlQs-craig.webp',
              details: {
                size: 260264,
                image: {
                  width: 503,
                  height: 503
                }
              },
              fileName: 'craig.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Product Lead',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the several months I’ve worked at Flatfile, I’ve become intimately familiar with a core challenge in data onboarding: human judgment is hard to scale. Historically, data decisions that required nuance or context were addressable only by the people with deep business or industry expertise.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our Transform Agent is a direct response to this challenge. Flatfile has long used AI to reduce latency in data onboarding and migration projects. Now we’re harnessing AI’s ability to absorb context, weigh decisions, and collaborate with your team’s experts to empower Transform to do more than just take orders.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What my team has built is the result of observing how users have approached data cleanup within Flatfile—whether manually or with tools like bulk actions and AI Transform. The question we’ve been asking ourselves is this: “How can we replicate the context and judgment that these users apply to data cleanup with agents, while keeping the users firmly in control?” ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3xEuAu4sJAOrhWGlfaLDSb',
                type: 'Entry',
                createdAt: '2025-07-08T04:47:06.397Z',
                updatedAt: '2025-07-08T04:51:29.140Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'wistiaVideo'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'transform teaser',
                video: {
                  items: [
                    {
                      hashed_id: '3hhz0focnt',
                      id: 135820086,
                      duration: 43.797,
                      thumbnail: {
                        url: 'https://embed-ssl.wistia.com/deliveries/f8bcfa4ca41245732d4b762212cd95a471f0ec0a.jpg?image_crop_resized=200x120',
                        width: 200,
                        height: 120
                      }
                    }
                  ]
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'From one time to every time',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When we first launched AI Transform over a year ago, it brought massive efficiency gains to our customers. The ability to prompt AI to transform data—whether it was standardizing capitalization or inferring missing values—reduced manual data prep time by hours per project.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But while this was markedly more efficient than writing formulas or scripts, it still felt like we were a step short of where we needed to be. With AI Transform, AI did the work, but users were still required to prompt each and every time—even if they had typed the same command to reformat dates on the last 100 imports. ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'And simply being the best option in the market isn’t the goal; solving our customers’ most painful problems is. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In talking to customers, we found that they were well aware of the common issues in the data they received. The bigger point of friction was having to apply the same fixes again and again—without any real way to carry forward what the system should have already learned.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With the Transform features we’re launching today, you’ll never again need to repeat a prompt.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3uoHfhRdV7V0lGWhVX5q4O',
                type: 'Asset',
                createdAt: '2025-07-08T17:29:46.149Z',
                updatedAt: '2025-07-08T17:29:46.149Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Analyze & Suggestions',
                description: '',
                file: {
                  url: '/img/contentful/3uoHfhRd-analyze___suggestions.webp',
                  details: {
                    size: 945012,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'Analyze & Suggestions.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'From taking orders to taking initiative',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The shift from user prompts to agent recommendations is one of the biggest disruptors of our Transform launch. While you’re absolutely still able to prompt transforms (and more conveniently than before, more on that next), in many cases it won’t even be necessary.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now, once you’ve completed mapping and open a data sheet, you’ll have a new option for addressing the data errors highlighted in red. Clicking the Analyze button will initiate a full audit of the dataset using complex reasoning and three anchors: the schema you’ve defined, any validation rules you’ve set, and transformation patterns the system has already seen. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As the analysis runs, you’ll see Suggestions appear alongside fields. Opening a Suggestion will allow you to preview the effect the proposed action would have on your data, modify it as desired, and apply it with a click. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our philosophy here is simple: once our system has sufficient context, the burden shouldn’t be on the user to continuously bring their expertise to solve common issues.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'mdokiETnwRwdFgINq84tE',
                type: 'Asset',
                createdAt: '2025-07-08T17:34:09.261Z',
                updatedAt: '2025-07-08T17:34:09.261Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Inline Transform',
                description: '',
                file: {
                  url: '/img/contentful/mdokiETn-inline_transform.webp',
                  details: {
                    size: 1614118,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'Inline Transform.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'From out of the way to inline',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With AI Transform, actions took place within a separate interface, potentially breaking a user’s flow each time they wanted to use the feature.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our newest evolution of Transform now allows you to prompt the agent right where you’re working. Select a field, type a prompt in natural language, and preview the results—all within your sheet.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1U0IH3Oasro3vJB18Ts7gu',
                type: 'Asset',
                createdAt: '2025-07-08T17:28:58.268Z',
                updatedAt: '2025-07-08T17:28:58.268Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Saved Transforms',
                description: '',
                file: {
                  url: '/img/contentful/1U0IH3Oa-saved_transform.webp',
                  details: {
                    size: 1327986,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'Saved Transform.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'From repetitive to repeatable',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Typing the same prompt to “remove trailing zeroes” for every data project gets old, fast. Transform now eliminates this frustration in two key ways:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Your transformation decisions are remembered, and the agent can suggest and one-click apply them on future imports.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'All transforms—whether prompted by users or suggested by AI—can be saved to rerun on your next project.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Saved Transforms, your decisions accumulate in a library of actions you can repeat on every similar project. You’re able to “Run All” and watch as every action you’d typically take or prompt is applied across your dataset in a matter of seconds.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "There's much more to come for the Transform agent. Everything we're designing is intended to capture your experience and discernment and train an agent to work for you, the way that you'd do it yourself (if you had infinite capacity). ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "And—as with all of Flatfile's AI features—users remain in full control, with human-in-the-loop review and approval processes and comprehensive versioning.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "I'll be showcasing Transform (and hinting at what comes next) in a webinar on Tuesday, July 15th. ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/webinars/ai-transform-data-webinar/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Register here to attend.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4CiTGMNYekw1mbNCMDPAUG',
    postTitle: 'Reimagining services in the AI era',
    seoTitle: 'Reimagining services in the AI era',
    seoUrlSlug: 'reimagining-services-in-the-ai-era',
    seoMetaDescription:
      'What we’re living through with AI isn’t just another shift. It’s a redefinition of how services get delivered—and what “services” even means.',
    category: 'Data exchange',
    tags: ['AI'],
    sortOrder: '0',
    publishDate: '2025-04-22T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2AIQJb0Iy6x0kVmEHeNcVZ',
        type: 'Asset',
        createdAt: '2025-04-22T14:50:22.496Z',
        updatedAt: '2025-04-22T14:50:22.496Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Lori guest blog header',
        description: '',
        file: {
          url: '/img/contentful/2AIQJb0I-social_post_-_1920x1080__1_.webp',
          details: {
            size: 2728207,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'social post - 1920x1080 (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Reimagining services in the AI era, a guest blog post by Lori Williams, CEO of Caylent',
    summary:
      'If you’ve been in tech long enough, you’ve seen a few shifts. Client-server. Cloud. Mobile. Each one reshaped how we worked, built, and delivered. But what we’re living through right now with AI isn’t just another shift. It’s a wholesale redefinition of how services get delivered—and what “services” even means.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4y0fPhJiIvQsTn6zcfR8vC',
        type: 'Entry',
        createdAt: '2025-04-22T00:12:27.074Z',
        updatedAt: '2025-04-22T14:57:36.107Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Lori Williams',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'yVKpV8QdmMjHgpEC6iffs',
            type: 'Asset',
            createdAt: '2025-04-22T00:12:06.628Z',
            updatedAt: '2025-04-22T00:12:06.628Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Lori headshot',
            description: '',
            file: {
              url: '/img/contentful/yVKpV8Qd-lori_williams-bw.webp',
              details: {
                size: 9092033,
                image: {
                  width: 3752,
                  height: 3752
                }
              },
              fileName: 'Lori_Williams-bw.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'CEO at Caylent',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '2PCSCZjaVqnAZ4JifdaNET',
            type: 'Entry',
            createdAt: '2025-04-22T00:12:23.572Z',
            updatedAt: '2025-04-22T00:12:23.572Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Caylent',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5N41zzDshCAvtxYBxeCeJM',
                type: 'Asset',
                createdAt: '2025-04-22T00:10:32.808Z',
                updatedAt: '2025-04-22T00:10:32.808Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Caylent logo',
                description: '',
                file: {
                  url: '/img/contentful/5N41zzDs-caylentlogo.svg',
                  details: {
                    size: 5086,
                    image: {
                      width: 2500,
                      height: 295
                    }
                  },
                  fileName: 'caylentlogo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Lori’s keynote on these topics at Flatfile’s Axis25 executive summit resonated powerfully with our audience. We invited her to share that perspective more broadly through this guest post.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’ve been in tech long enough, you’ve seen a few shifts. Client-server. Cloud. Mobile. Each one reshaped how we worked, built, and delivered. But what we’re living through right now with AI isn’t just another shift. It’s a wholesale redefinition of how services get delivered—and what “services” even means.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Caylent, we’re not just responding to change. We’re participating in it. Building for it. And like many of you, while we have a clear framework of what we want to do things are changing so rapidly that there is a significant amount of figuring it out as we go. This post captures the questions we’re asking, the frameworks we’re leaning on, and the real-world experiments we’re running as we rethink services from the ground up.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7jl9W9f8OxgA9a6xo1LO3k',
                type: 'Asset',
                createdAt: '2025-04-22T00:00:14.304Z',
                updatedAt: '2025-04-22T00:00:14.304Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Lori slide 1 updated',
                description: '',
                file: {
                  url: '/img/contentful/7jl9W9f8-axis_-_ai_in_services_keynote_v1.webp',
                  details: {
                    size: 44339,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Axis - AI in Services Keynote v1.jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’re not in Kansas anymore: the AI Era isn’t a trend. It’s a new operating system.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI isn’t just an incremental upgrade. It’s a convergence of three major forces:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Industrial-style automation that changes how work gets done.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Renaissance-style creativity, democratizing access to creation.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'iPhone-style ubiquity, putting powerful tools into everyone’s hands.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s why ChatGPT hit 100 million users in two months. And why organizations—especially services firms—must rethink their operating model ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'now',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', not later. Because in this world, agility favors the newcomer. Legacy moats erode quickly. And what made you successful before won’t keep you relevant tomorrow.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6MyiOAs9OyPWhRrToZE0Yw',
                type: 'Asset',
                createdAt: '2025-04-22T00:01:48.313Z',
                updatedAt: '2025-04-22T00:01:48.313Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Lori slide 2',
                description: '',
                file: {
                  url: '/img/contentful/6MyiOAs9-axis_-_ai_in_services_keynote_v1__1_.webp',
                  details: {
                    size: 60788,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Axis - AI in Services Keynote v1 (1).jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What this means for your customers',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your customers want transformation—fast. But they’re also dragging a lot of baggage.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What they’re dealing with:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-4'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Tech debt built over decades',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Fragmented data landscapes',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Business processes that can’t keep pace with today’s expectations',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What they expect now:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-4'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Faster delivery of new capabilities',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Insight from their data, not just storage',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Predictive, personalized experiences from day one',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "AI isn’t a silver bullet, but it does help you “Marie Kondo” your backlog. At Caylent, we’ve seen customers cut a 65-day compliance backlog down to 4 days, modernize HVAC systems to reduce energy spend by 25%, and proactively manage water usage with AI-powered alerts. These aren't moonshots—they’re achievable outcomes when you pair the right strategy with the right technology.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '72Vou0PTVgMjUCAX72mKvI',
                type: 'Asset',
                createdAt: '2025-04-22T00:04:16.373Z',
                updatedAt: '2025-04-22T00:04:16.373Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Lori slide 3',
                description: '',
                file: {
                  url: '/img/contentful/72Vou0PT-axis_-_ai_in_services_keynote_v1__2_.webp',
                  details: {
                    size: 60136,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Axis - AI in Services Keynote v1 (2).jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Why the services industry must change',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For decades, services meant people. Hours. Staffing. The occasional IP-based accelerator. But now? We're entering a hybrid era—where agents, tooling, and orchestration layers work alongside people to deliver value. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Think of it as Services-as-Software: modular, intelligent, and increasingly autonomous.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Three critical shifts are underway:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-4'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The talent pyramid flips: AI is replacing repetitive, junior-level work. Senior talent becomes even more critical—for orchestration, architecture, and oversight.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Product management becomes core: Services teams need PMs to design offerings, manage internal tools, and evolve with the ecosystem.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Methodology goes post-agile: Delivery isn’t linear anymore. We’re validating before building, iterating everywhere, and using AI to scaffold faster than ever.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This isn’t about eliminating people. It’s about augmenting them. And rethinking what kind of work humans are best equipped to do.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1XlnnZiyewJ2rKx4QSkdFM',
                type: 'Asset',
                createdAt: '2025-04-22T00:06:53.097Z',
                updatedAt: '2025-04-22T00:06:53.097Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Lori slide 4',
                description: '',
                file: {
                  url: '/img/contentful/1XlnnZiy-axis_-_ai_in_services_keynote_v1__3_.webp',
                  details: {
                    size: 73614,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Axis - AI in Services Keynote v1 (3).jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How we’re doing it at Caylent',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’ve committed to having 80% of our projects using AI meaningfully by the end of 2025. Not just chatbots and copilots, but end-to-end tooling that accelerates everything from scoping to delivery.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Here’s what that looks like in practice:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-4'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Sales to delivery: We use AI to analyze pre-sales calls and auto-generate first-draft SOWs.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Build acceleration: From those SOWs, we generate Jira backlogs, spin up infra scaffolding, and hand engineers a head start.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Post-delivery: Self-healing systems, AI-driven bug resolution, and intelligent extensions reduce the long tail of support.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The biggest unlock? We’re no longer starting from zero. And our engineers spend more time solving business problems instead of stitching together transactional code.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4obOrTyEMut8Z7tjJ7fJSX',
                type: 'Asset',
                createdAt: '2025-04-22T00:08:34.384Z',
                updatedAt: '2025-04-22T00:08:34.384Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Lori slide 5',
                description: '',
                file: {
                  url: '/img/contentful/4obOrTyE-axis_-_ai_in_services_keynote_v1__4_.webp',
                  details: {
                    size: 50283,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Axis - AI in Services Keynote v1 (4).jpg',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Lessons we’ve learned along the way',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Scaling AI across a services organization doesn’t happen by accident. It takes focus, iteration, and a willingness to rethink the fundamentals. These lessons we’ve learned along the way continue to anchor our approach.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'You don’t need all the answers to get started. But you ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      value: 'do',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' need the conviction to try and discipline to navigate the rapid changes.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Experimentation is a muscle. Build it into your culture. Treat failure as data.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Prompt engineering is strategic thinking. It’s not just a skill; it’s a mindset.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Talent strategy must evolve. If AI handles transactional work, how will you grow your next generation of architects?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Get your house in order. Messy data, broken processes, and legacy platforms will slow you down.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’ve created internal goals, cross-functional teams, and an AI badge initiative to upskill everyone from engineers to finance. And we’re tracking adoption monthly in town halls. Because transformation doesn’t happen by osmosis—it needs visible commitment.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The takeaway: AI is creating an entirely new category of services',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Just as SaaS changed software, AI will redefine services. We’re heading toward a world where:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The line between Services and Product becomes even more blurry',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Pricing is outcome-based, not hour-based.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Services are delivered with software precision.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Teams are hybrid: human + agentic + orchestrated.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’re in services, now is the time to ask hard questions, test new approaches, and get on the train. The future’s moving fast—and the ones who learn fastest will lead.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7kycqNguI0WQM1PD8t7f5O',
    postTitle:
      'Craft obsession in practice: the art behind Flatfile’s new design system',
    seoTitle:
      'Craft obsession in practice: the art behind Flatfile’s new design system',
    seoUrlSlug: 'flatfiles-new-design-system',
    seoMetaDescription:
      'At Flatfile, we see product design not just as an aesthetic endeavor, but as an exercise in precision and relentless refinement. ',
    category: 'Product updates & features',
    tags: ['design'],
    sortOrder: '0',
    publishDate: '2025-03-13T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '53hxEGAYlcdo9uTjLmHvXB',
        type: 'Asset',
        createdAt: '2025-03-13T16:05:37.436Z',
        updatedAt: '2025-03-13T16:05:37.436Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Design system header',
        description: '',
        file: {
          url: '/img/contentful/53hxEGAY-main_blog_header_1920x1080.webp',
          details: {
            size: 996124,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Main Blog Header_1920x1080.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'The new design system is live now. While you might not consciously notice every change, you’ll feel the difference in every click, every form, and every interaction. That’s the magic of thoughtful design—and it’s just the beginning.',
    summary:
      'At Flatfile, we see product design not just as an aesthetic endeavor, but as an exercise in precision and relentless refinement. That philosophy drove our latest overhaul: a new, more powerful design system that makes Flatfile faster, more consistent, and better prepared for the future.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1r5MgxWgXJWTFmSAMAojKn',
        type: 'Entry',
        createdAt: '2025-01-14T21:19:24.023Z',
        updatedAt: '2025-07-08T00:56:10.115Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Kacey Mast',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '4T6IzAwqhpfWodClW5mYwh',
            type: 'Asset',
            createdAt: '2025-03-12T17:50:49.920Z',
            updatedAt: '2025-03-13T18:19:00.767Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 3,
            locale: 'en-US'
          },
          fields: {
            title: 'Kacey headshot',
            description: '',
            file: {
              url: '/img/contentful/4T6IzAwq-img_9001.webp',
              details: {
                size: 152292,
                image: {
                  width: 1290,
                  height: 1290
                }
              },
              fileName: 'IMG_9001.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Head of Product Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Software, at its best, should feel effortless. Every interaction should be intuitive, every motion smooth, and every function elegantly designed to serve users without friction. At Flatfile, we see product design not just as an aesthetic endeavor, but as an exercise in precision and relentless refinement. That philosophy drove our latest overhaul: a new, more powerful design system that makes Flatfile faster, more consistent, and better prepared for the future.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'I recently interviewed two members of the Flatfile team who worked on the design system updates—product designer Max Bosch and product engineer Ralph Holzmann. Their insights reveal not only the technical improvements but also the deep care and craftsmanship that went into advancing Flatfile’s user experience.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Grc3lJGBS8NKzhXEtlPVk',
                type: 'Entry',
                createdAt: '2025-03-13T21:59:08.081Z',
                updatedAt: '2025-03-14T16:16:30.299Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'figureWithCaption'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                internalTitle: 'Comparison Workbook',
                image: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'hjneo4qi4goj'
                      }
                    },
                    id: '3yyjoDVC8SlqJVxWhDYTVU',
                    type: 'Asset',
                    createdAt: '2025-03-13T15:49:39.017Z',
                    updatedAt: '2025-03-13T17:27:39.455Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    publishedVersion: 7,
                    revision: 2,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'Comparison - Workbook',
                    description:
                      'The Flatfile interface before and after the design system changes',
                    file: {
                      url: '/img/contentful/3yyjoDVC-comparison_-_workbook.webp',
                      details: {
                        size: 324368,
                        image: {
                          width: 2000,
                          height: 1000
                        }
                      },
                      fileName: 'Comparison - Workbook.png',
                      contentType: 'image/png'
                    }
                  }
                },
                caption:
                  'The Flatfile interface before and after the design system changes',
                captionAlignment: 'center'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A cross-company rally for excellence',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This new design system wasn’t the work of a single team or department—it was a company-wide initiative. From engineering to product design to customer success, teams across Flatfile contributed to shaping a system that prioritizes both usability and scalability.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    '“This wasn’t a case of design handing things off to engineering. It was a real back-and-forth collaboration.”',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We approached this as an investment in the long-term health of our product,” says Max. “It wasn’t just about making things look better—it was about enabling a smoother, faster experience for our users. When a product is designed well, people don’t notice the effort that goes into it, but their experience is a much more delightful one.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'At its core, this update shifts Flatfile’s front-end components to shadcn, a modern framework built with React, Tailwind CSS, and Radix UI. While shadcn is widely used in the broader development community, our implementation is unique in its rigorous attention to detail. “We’re not reinventing the wheel,” notes Ralph. “But we are making sure that every component we use is precisely tailored to our customers’ needs.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2VFi3eVQ5jNBLvKMaF9DNw',
                type: 'Entry',
                createdAt: '2025-03-14T16:17:53.207Z',
                updatedAt: '2025-03-14T16:17:53.207Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'figureWithCaption'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                internalTitle: 'Components',
                image: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'hjneo4qi4goj'
                      }
                    },
                    id: '5nlV1kPQcctE0ciD3RQRlN',
                    type: 'Asset',
                    createdAt: '2025-03-13T15:53:10.860Z',
                    updatedAt: '2025-03-13T17:29:32.031Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    publishedVersion: 5,
                    revision: 2,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'Components',
                    description:
                      'A look at the components built for the new design system',
                    file: {
                      url: '/img/contentful/5nlV1kPQ-components.webp',
                      details: {
                        size: 177371,
                        image: {
                          width: 2186,
                          height: 1094
                        }
                      },
                      fileName: 'Components.png',
                      contentType: 'image/png'
                    }
                  }
                },
                caption:
                  'A look at the components built for the new design system',
                captionAlignment: 'center'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The invisible advantage',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'At first glance, this update might not look like a dramatic transformation. But design excellence isn’t always about sweeping changes; it’s about refining the details that shape everyday interactions.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The best design system updates are the ones you don’t actively notice,” Max explains. “Everything just feels smoother, more natural. That’s what we were aiming for.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value: '“The best design work isn’t loud—it just works.” ',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This means buttons that respond instantly, modals that behave predictably, and typography that’s easily readable. Every piece of UI has been scrutinized and optimized to reduce friction and improve usability. Small adjustments—like more consistent spacing and refined animations and input fields—sum to a product experience that feels premium and polished.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Ralph emphasizes how even seemingly minor improvements contribute to a faster experience overall. “One of our biggest priorities as a team is reducing latency. Every millisecond we save compounds into a noticeably better experience for our users. That’s why we sweat the small stuff—it makes a real difference in how fast and fluid Flatfile feels.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1r5veuyeuEaxO2E3T4C3GJ',
                type: 'Entry',
                createdAt: '2025-03-14T16:18:31.430Z',
                updatedAt: '2025-03-14T16:18:31.430Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'figureWithCaption'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                internalTitle: 'AI Transform',
                image: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'hjneo4qi4goj'
                      }
                    },
                    id: '3lOBBEgiiTPwFjrvchsWQy',
                    type: 'Asset',
                    createdAt: '2025-03-13T15:52:35.246Z',
                    updatedAt: '2025-03-13T17:31:08.207Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    publishedVersion: 7,
                    revision: 2,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'AI Transform UI Close-up',
                    description: 'New dropdown UI as seen in AI Transform',
                    file: {
                      url: '/img/contentful/3lOBBEgi-ai_transform_ui_close-up.webp',
                      details: {
                        size: 174417,
                        image: {
                          width: 1944,
                          height: 1094
                        }
                      },
                      fileName: 'AI Transform UI Close-up.png',
                      contentType: 'image/png'
                    }
                  }
                },
                caption: 'New dropdown UI as seen in AI Transform',
                captionAlignment: 'center'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Shipping with speed and precision',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Beyond user experience, the new design system dramatically improves Flatfile’s ability to build and ship new features. Previously, minor inconsistencies in UI components could slow down development and create unnecessary complexity. With a streamlined and standardized system, engineers can now move faster, iterate with confidence, and introduce new capabilities without compromising quality.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    '“A system that moves fast but introduces chaos isn’t useful, and one that’s too rigid slows everything down. This update was about striking the right balance.”',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Having a robust, scalable design system allows us to focus more on innovation,” says Ralph. “Instead of constantly reworking UI elements, we can spend more time building the features that move the needle for our customers. It gives us a solid foundation to innovate on top of.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This shift has already led to noticeable progress in development velocity. Max adds, “There were so many instances in the past where we had to stop and solve inconsistencies. Now, we have a clear system in place, so teams aren’t second-guessing themselves—they’re just shipping.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'UXRAl5xmCdZEBQ2rjj6eB',
                type: 'Entry',
                createdAt: '2025-03-14T16:19:10.592Z',
                updatedAt: '2025-03-14T16:19:10.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'figureWithCaption'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                internalTitle: 'UI Montage',
                image: {
                  metadata: {
                    tags: [],
                    concepts: []
                  },
                  sys: {
                    space: {
                      sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'hjneo4qi4goj'
                      }
                    },
                    id: '7bLsvKadtwWTK97BVcjLQZ',
                    type: 'Asset',
                    createdAt: '2025-03-13T15:51:17.775Z',
                    updatedAt: '2025-03-13T17:31:47.013Z',
                    environment: {
                      sys: {
                        id: 'master',
                        type: 'Link',
                        linkType: 'Environment'
                      }
                    },
                    publishedVersion: 8,
                    revision: 2,
                    locale: 'en-US'
                  },
                  fields: {
                    title: 'UI Montage',
                    description:
                      "The design system changes as reflected across all of Flatfile's UI",
                    file: {
                      url: '/img/contentful/7bLsvKad-ui_montage.webp',
                      details: {
                        size: 291473,
                        image: {
                          width: 1840,
                          height: 1040
                        }
                      },
                      fileName: 'UI Montage.png',
                      contentType: 'image/png'
                    }
                  }
                },
                caption:
                  "The design system changes as reflected across all of Flatfile's UI",
                captionAlignment: 'center'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A step toward luxury business software',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'At Flatfile, we believe enterprise software should feel just as refined and intuitive as the best consumer products. This update is a testament to that belief—a meticulously crafted system that balances form and function, elegance and efficiency. It’s a reflection of our obsession with reducing latency and delivering an experience that feels effortless.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“There’s a reason we obsess over these details,” Max says. “Software isn’t just about function—it’s about how it feels to use. That’s what great design is all about.”\n\nThis also isn’t just about today and our product’s current state. It’s about setting the stage for what comes next. As Flatfile continues to evolve, the design system will serve as a foundation for future enhancements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    '“Best-in-class design systems don’t just solve today’s problems—they make it easier to solve tomorrow’s. We built this to grow with us.”',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We wanted a system that’s flexible enough to support the ambitious ideas we have for the next generation of Flatfile,” explains Max.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The new design system is live now. While you might not consciously notice every change, you’ll feel the difference in every click, every form, and every interaction. That’s the magic of thoughtful design—and it’s just the beginning.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '1ZV1lMz1AwEiPOzhFt2Hqk',
    postTitle: '2024 Flatfile Year in Review',
    seoTitle: '2024 Flatfile Year in Review',
    seoUrlSlug: '2024-flatfile-year-in-review',
    seoMetaDescription:
      "We'd like to take a moment to reflect back on the highs of 2024, including some major product releases you might have missed.",
    category: 'Flatfile News & Culture',
    tags: ['AI'],
    sortOrder: '1',
    publishDate: '2025-01-13T16:30-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1N30e5ecafHhM3aDCnoT1z',
        type: 'Asset',
        createdAt: '2025-01-14T20:42:07.946Z',
        updatedAt: '2025-01-14T20:42:07.946Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '2024 Year in Review header',
        description: '',
        file: {
          url: '/img/contentful/1N30e5ec-year_in_review_blog_header_2x__1_.webp',
          details: {
            size: 350844,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Year in review Blog header@2x (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: '2024 Flatfile Year in Review',
    summary:
      "2024 was the year that thousands of businesses took control of their data workflows with Flatfile. We'd like to take a moment to reflect back on the highs of 2024, including some major product releases you might have missed.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1r5MgxWgXJWTFmSAMAojKn',
        type: 'Entry',
        createdAt: '2025-01-14T21:19:24.023Z',
        updatedAt: '2025-07-08T00:56:10.115Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Kacey Mast',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '4T6IzAwqhpfWodClW5mYwh',
            type: 'Asset',
            createdAt: '2025-03-12T17:50:49.920Z',
            updatedAt: '2025-03-13T18:19:00.767Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 3,
            locale: 'en-US'
          },
          fields: {
            title: 'Kacey headshot',
            description: '',
            file: {
              url: '/img/contentful/4T6IzAwq-img_9001.webp',
              details: {
                size: 152292,
                image: {
                  width: 1290,
                  height: 1290
                }
              },
              fileName: 'IMG_9001.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Head of Product Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '2024 was the year that thousands of businesses took control of their data workflows with Flatfile. We saw millions of hours saved, with data onboarding and migration projects that typically took weeks or months reduced to minutes. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We'd like to take a moment to reflect back on the highs of 2024, including some major product releases you might have missed.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              sys: {
                type: 'Entry',
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'wistiaVideo'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: '2024 Year in Review',
                video: {
                  items: [
                    {
                      hashed_id: 'putd491k6t',
                      id: 0,
                      duration: 0,
                      thumbnail: {
                        url: 'https://fast.wistia.com/embed/medias/putd491k6t/swatch',
                        width: 200,
                        height: 120
                      }
                    }
                  ]
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'By the Numbers: Customer Activity in 2024',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The scale of data transformation through Flatfile in 2024 was truly remarkable:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Our customers created ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'over 750,000 data projects',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Teams imported, mapped, cleaned, and transformed ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'more than 65 billion data points',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Users ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'resolved over 2 million errors',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' directly within Flatfile',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Customers created',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: ' 1,500+ custom actions',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'AI Transform was',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: ' ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: 'used',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: ' 20,000+ times',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' to transform data using natural language',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'AI Transform: The Power of Natural Language Data Commands',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI Transform has made it easier than ever to handle complex data manipulations, with commands in natural language. Here are some of the prompts that Flatfile customers used to work more efficiently in 2024:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '“‘Convert all dates to DD-MM-YYYY”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '“Change x to true and blank to false in @subscription_status”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '“Divide @home_price by @square_footage and populate @price_per_square_foot”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '“Remove dashes from @routing_number”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '“If @start_date is 2020 or later, set @employer_contribution to 5%”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Custom Actions: How Teams Streamlined Their Workflows',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Custom actions allowed businesses using Flatfile to perform specific repeatable tasks within their data set with the click of a button. Here are a few of the custom actions our customers built in 2024:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Dedupe records',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Merge records',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "Hide extra columns that are not empty or not marked as required and that don't have errors",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Create a master sheet from data imported into multiple sheets',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Take data from one sheet with thousands of fields and split into multiple sheets for editing and exporting',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Major Product Innovations',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In 2024, our Product team launched a number of features that make Flatfile even more intuitive and powerful. Here are a few of our favorites:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'AI Transform ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'allows you to use natural language prompts to transform your data. Flatfile turns these commands into code and makes the desired changes instantly across your entire data set. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/introducing-ai-transform-your-data-transformation-copilot/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Learn more about AI Transform.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Advanced Mapping',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' enables you to manipulate your data as part of the mapping process, merging multiple source fields into a single destination field, splitting a single source field into multiple destination fields, and more. New Groups make organizing and refining your mapping tasks easier, and Data Preview allows you to view up to 1,000 records at a time for instant feedback. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/advanced-mapping-a-new-essential-tool-for-data-migration-teams/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Learn more about Advanced Mapping.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Build Mode ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                "is a no-code, AI-assisted solution for configuring and customizing Flatfile. In Build Mode, you can upload a file describing your system's requirements to generate your ideal configuration, use natural language to create validation rules for your data, and generate sample data with valid and invalid records (no dummy files needed).",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/build-mode-an-ai-powered-solution-to-configure-flatfile-in-seconds/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Learn more about Build Mode.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Collaboration',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' features like Comments, Mentions, and Reactions enable teams to work more efficiently together, without leaving Flatfile.',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/introducing-projects-collaboration-tools-to-make-data-migration-more-precise/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Learn more about our Collaboration features.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Looking Ahead to 2025',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The momentum continues as we head into a new year! Here are a few live events we hope to see you at:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "Flatfile's VP of Customer Success Becca Weiss will be co-hosting",
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: ' ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: 'a webinar on ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value:
                        '"Separating Hype from Real Value: The Impact of AI in Customer Success"',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: " with ClientSuccess's Dave Blake. ",
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://email.flatfile.com/e3t/Ctc/LW+113/cy7D604/VWjjL53KbZCWW7g78LL83kBp9W67tPB75qtSrPKqQ43qgyTW69sMD-6lZ3ngW5X3F6Q4XwrR0V3D4fT5KjtRXW6Q8jFQ4byzPnW2kK_7Z2xxy7lW1Pj8YJ2QQ8V9W5lvLcn30bykFW4GNwr61VJkVhW6Cfhjh29cQvWN7QmMYDKsztfW61JPZp7Kj1THW3FzQp26sJsh5VDwHFx25sw6JN4hWfcRqs7rYW6LcmDn1z7w4YW2GsZvV7W81SDN7p831HFvw56VKxKS45dDVx2W1YpLGB7KT19VW1rltM7382LbHW2Pv_K22J3zwdf5Bxg-C04'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          value:
                            'Register now and join us at 10:30 AM Pacific on January 30th.',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Save the Date: Our next major product announcement will be our ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Spring Release',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' event March 4-5. Tune in virtually to learn how Flatfile is building agentic AI into our core product. More info to come!',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: "We'll be back at ",
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'SaaStr',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' at the San Mateo County Events Center in the SF Bay Area from May 13-15. Be sure to find us at our booth!',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Happy New Year! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7mxlCbgmI74SJGIJ7XVIIf',
    postTitle:
      'Introducing Projects: Collaboration Tools to Make Data Migration More Precise',
    seoTitle: "Flatfile's New Collaboration Tools ",
    seoUrlSlug:
      'introducing-projects-collaboration-tools-to-make-data-migration-more-precise',
    seoMetaDescription:
      'Data is no longer just about organization — it’s about working together to solve complex problems faster, and collaborating to super-charge your onboarding process.\n',
    category: 'Product updates & features',
    tags: ['AI ', 'Collaboration tools'],
    sortOrder: '1',
    publishDate: '2024-11-02T00:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3l07Cnw78usESdqxL3PvQU',
        type: 'Asset',
        createdAt: '2024-11-04T22:03:20.920Z',
        updatedAt: '2024-11-04T22:03:20.920Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Projects',
        description: '',
        file: {
          url: '/img/contentful/3l07Cnw7-projects.webp',
          details: {
            size: 923548,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Projects.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Collaboration Tools',
    summary:
      'We unveiled a new suite of Collaboration features, including Comments, Mentions, Threads, Presence, and Reactions that will tighten your team’s workflow.\n',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4tvIaaSS8i8JTKjFpOQc1Y',
        type: 'Entry',
        createdAt: '2024-10-25T21:49:19.640Z',
        updatedAt: '2024-10-25T21:49:19.640Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Kelly Johnson',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3fkbdwtaMhjtHwP5wiz6a6',
            type: 'Asset',
            createdAt: '2024-10-22T18:37:34.262Z',
            updatedAt: '2024-10-22T18:37:34.262Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Launch Week - Dev Day',
            description: '',
            file: {
              url: '/img/contentful/3fkbdwta-zoom__main_image__1_.webp',
              details: {
                size: 755020,
                image: {
                  width: 1920,
                  height: 1080
                }
              },
              fileName: 'Zoom_ Main image (1).png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Imagine a world where data exchange projects don’t feel like wrangling chaos, but instead like conducting a symphony. That experience will soon be a reality for data migration teams.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'On the final day of Flatfile’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/fall-release/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Launch Week',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', we unveiled a suite of ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Collaboration',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' features, including ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Comments, Mentions, Threads, Presence, and Reactions',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' that will tighten your team’s workflow.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data is no longer just about organization — it’s about working together to solve complex problems faster, and collaborating to super-charge your onboarding process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In our last session, Flatfile team members – including Vice President of Product Jon Bell, and Front-end Engineering Lead Henry Jordan – took attendees through an in-depth overview and hands-on demo of each new feature.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Read our recap to see how Collaboration tools will streamline your projects.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Bringing Collaboration to Life',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Every data exchange team has experienced a miscommunication that sidelined a project. Our new ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Comments',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' feature fills in information gaps by providing real-time communication capabilities directly in the project. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now, you can dive into a data set, drop a comment exactly where it matters, and instantly connect with your team member to solve an issue.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3IQXgzFUa6ahAlrgSBzNwW',
                type: 'Asset',
                createdAt: '2024-11-06T13:53:06.242Z',
                updatedAt: '2024-11-06T13:53:06.242Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Add a comment',
                description: '',
                file: {
                  url: '/img/contentful/3IQXgzFU-add_a_comment.webp',
                  details: {
                    size: 13916,
                    image: {
                      width: 413,
                      height: 166
                    }
                  },
                  fileName: 'Add a comment.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'You can now add a comment directly in your projects',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "“You can leave comments on sheets, records, or even specific cells, and every comment is tied directly to the data point of preferences so that feedback, questions and instructions happen exactly where they're needed,” Jordan explained.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With this new tool, feedback is no longer left to linger. Every question or instruction will be attached to the specific data point in question – helping your team make better, more informed decisions faster.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There may be times when a Comment isn’t enough to move a project forward. Enter ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Mentions',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ': a new feature that allows you to at-mention one of your collaborators to bring them into the conversation.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1rF0fSFCsvjyfPm61S1BHS',
                type: 'Asset',
                createdAt: '2024-11-06T13:56:13.847Z',
                updatedAt: '2024-11-06T13:56:13.847Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Projects - Mentions',
                description: '',
                file: {
                  url: '/img/contentful/1rF0fSFC-mentions.webp',
                  details: {
                    size: 43276,
                    image: {
                      width: 698,
                      height: 285
                    }
                  },
                  fileName: 'Mentions.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Mention a teammate in a project to expedite communication',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Now you can loop in the right person right where the issue is so that problems are resolved faster and with less friction,” added Jordan.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your team no longer needs to wait for emails to cross, or endlessly search for the right data. They will be notified instantly, keeping momentum high and resolutions swift.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'However, it can be easy for information to get lost in back-and-forth conversations with several collaborators. That’s where ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Threads',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' can help keep discussions organized and linked directly to their relevant data points. This feature alleviates clutter and confusion and your team will have clarity where they need it most.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7CPCXxWn1APnTamV1mtQrT',
                type: 'Asset',
                createdAt: '2024-11-06T13:57:03.157Z',
                updatedAt: '2024-11-06T13:57:03.157Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Projects - Threads',
                description: '',
                file: {
                  url: '/img/contentful/7CPCXxWn-threads.webp',
                  details: {
                    size: 39835,
                    image: {
                      width: 454,
                      height: 247
                    }
                  },
                  fileName: 'threads.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'Keep conversations organized with Threads',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Jordan added in his presentation that “Threads keep discussions organized by allowing replies to specific comments so that longer conversations stay connected to the data point that started them. You can have a focused back-and-forth without cluttering the entire space.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'And with ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Presence',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', collaboration becomes even more seamless. Presence lets you know who is currently active in your sheet so you can see who is making real-time changes alongside you. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You’ll know who is active in your data set at any given moment, allowing for real-time feedback and collective problem-solving without missing a beat.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6iW0PCewt8hzcv62NJFr9h',
                type: 'Asset',
                createdAt: '2024-11-06T13:58:23.048Z',
                updatedAt: '2024-11-06T13:58:23.048Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Projects - Presence',
                description: '',
                file: {
                  url: '/img/contentful/6iW0PCew-presence.webp',
                  details: {
                    size: 5066,
                    image: {
                      width: 218,
                      height: 89
                    }
                  },
                  fileName: 'Presence.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'See which team member is in your project with Presence',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Streamlined Reactions and Shared Views: Keeping It Simple',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There may be occasions when a full comment isn’t necessary, or you may want to send a quick signal of acknowledgement. For quick feedback, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Reactions',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' provides an intuitive way to send an emoji – a small gesture that moves communication and the project  forward.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4lZyGWF9glcpajCYtcOPqk',
                type: 'Asset',
                createdAt: '2024-11-06T14:00:31.280Z',
                updatedAt: '2024-11-06T14:00:31.280Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Reactions',
                description: '',
                file: {
                  url: '/img/contentful/4lZyGWF9-reactions.webp',
                  details: {
                    size: 75399,
                    image: {
                      width: 1020,
                      height: 370
                    }
                  },
                  fileName: 'Reactions.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'Easily give feedback with Reactions',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For large-scale projects with massive data sets, teams must stay aligned on the data sets that matter. Our new tool, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Shared Views, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'keeps the team focused on the important data points by allowing them to apply filters and search criteria to projects and then save them as shareable views. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Once saved, a view can easily be applied to your data set at any time, and they can also be shared with members of your team, which keeps everyone in sync and ensures everyone can view the data in the same ways,” said Jordan.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now, everyone sees the same data similarly, which is critical when precision and consistency are essential.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Enhanced Security to Prevent Data Leaks',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Rest assured that data and conversations within Flatfile are secure. By keeping all discussions inside the platform, we minimize the risk of data leaks or accidental exposure through external tools. Only authorized users can access and make changes, ensuring privacy and control over the data. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Jordan reinforced that the platform “lets you control who sees and interacts with your data, ensuring that only authorized team members, clients or partners can view or make changes. This guarantees that collaborative conversations are private and restricted to the right individuals.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Data Clips: Solving Problems Without Disruptions',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What if your team could isolate a challenging data issue and resolve it without disrupting the project? Our new tool, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Data Clips',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', enables this.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data Clips is a faster, secure solution within Flatfile. With this tool, you can quickly sort through reams of data, select problematic or incorrect records (manually or with advanced filtering), and share them with team members or customers for review.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Users can comment, edit and transform data directly in the interface, making updates easy to review and merge back into the original dataset – all without leaving the platform. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Once the data updates are made, you can review the final changes and merge them back into the original set of data,” explained VP of Product, Jon Bell.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your team no longer needs to use their bandwidth to download and send over files, wait for replies and then re-import the corrections.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Additionally, Data Clips operates in Flatfile’s secure environment with the “same access controls provided in the space to ensure maximum data privacy,” continued Bell.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Designed for flexibility, transparency and security, Data Clips streamlines your project’s workflows and gives visibility into changes – allowing your team to focus on progress. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Pre-processing: Smarter Data from the Start',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'During the presentation, Jordan pointed out that starting a migration project can be the source of several challenges. The reason: Initial data tends to be messy, non-uniform, and nuanced, making mapping extremely difficult.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s Workbook reduces this complexity but we boosted these pre-existing features with ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Pre-processing.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Pre-processing automatically changes any file you upload into a fully featured, configuration capable, AI-powered workbook – giving you access to tools such as manual edits, searching, filtering and AI Transform.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5NfomaUUcptB0UM93cAoKr',
                type: 'Asset',
                createdAt: '2024-11-06T14:06:09.495Z',
                updatedAt: '2024-11-06T14:06:09.495Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Projects - Preprocessing',
                description: '',
                file: {
                  url: '/img/contentful/5NfomaUU-preprocessing.webp',
                  details: {
                    size: 76495,
                    image: {
                      width: 1291,
                      height: 412
                    }
                  },
                  fileName: 'Preprocessing.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Change files into a configuration-cable workbook with Pre-processing',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Treating all uploaded files as workbooks means we have unlocked the entire suite of tools that were previously reserved for mapped data. You can now create custom jobs and actions exclusive to uploaded files, you can run AI transformations, or use our new set of native column actions to address your specific needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Additionally, we want you to be in full control of your data configuration and output, so we’ve built in the ability to revert or restore your file to its original state. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "“We've never made it our mission to tell you how to run your migration projects. We provide you with powerful, industry-leading tools that allow you to automate, streamline and simplify your processes according to your specific needs,” Jordan said.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The Power of AI at Your Fingertips',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For years, Excel has been the incumbent for building data exchange projects. The application required manual edits, scripted workflows and complex formulas, which took hours. As the data becomes more complex, the need for technical expertise becomes more urgent.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We built ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'AI Transform',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " to let you manipulate data by describing what you want using natural language instructions — no coding required. Whether you're merging values, cleaning data or performing calculations, AI Transform works at the speed of thought, writing code and delivering results in just a few tries.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3FGTv2XNUMhE5L8z8JvYlo',
                type: 'Asset',
                createdAt: '2024-11-06T14:07:07.871Z',
                updatedAt: '2024-11-06T14:07:07.871Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Projects - AI Transform',
                description: '',
                file: {
                  url: '/img/contentful/3FGTv2XN-image__8_.webp',
                  details: {
                    size: 138732,
                    image: {
                      width: 1260,
                      height: 601
                    }
                  },
                  fileName: 'image (8).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'AI Transform lets you manipulate data using natural language instructions',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“[At the core of AI Transform]  is Natural language input,” said Bell. “Whether you need to merge values, clean up data, run calculations or format fields, all you have to do is describe it.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "When you give AI transform instructions, it's actually writing and running code to execute your instructions, and we believe that this is the most practical, efficient and safe way to transform your data,” he concluded.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI Transform is intelligent and precise. It targets specific fields, handles multi-step transformations and understands instructions in any language. Features like ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Smart Fill',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' predict your next move, and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Snapshots',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " let you roll back changes easily. It's more than a feature — it’s your assistant, who can streamline data migration and empower smarter, faster decisions.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Stay Tuned. This is Only the Beginning',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We have more AI-powered solutions and automation on the horizon. Stay tuned for our Winter Release to see how we’re tackling data transformation challenges.  Eager to learn more or see the full Projects presentation? Watch the recording.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5JE8EuEWcnthiRB1H7Upc9',
                type: 'Entry',
                createdAt: '2024-10-25T21:16:46.564Z',
                updatedAt: '2024-11-04T21:57:43.691Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 21,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Launch Week ',
                text: 'Our major feature release includes announcements, personalized consultations, and customer panels.',
                ctaText: 'Watch the Recording',
                href: '/fall-release/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n\n\n\n\n\n\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '31Mpd9YJFwVx6mIJbNEsm8',
    postTitle:
      'Build Mode: An AI-powered Solution to Configure Flatfile in Seconds',
    seoTitle:
      'Flatfile Introduces a Reimagined BuildMode to Configure Projects in Seconds',
    seoUrlSlug:
      'build-mode-an-ai-powered-solution-to-configure-flatfile-in-seconds',
    seoMetaDescription:
      'Build Mode is a streamlined, AI-assisted solution for configuring Flatfile, enabling your team to create and manage data validation rules, workflows and updates in real-time',
    category: 'Product updates & features',
    tags: ['Featured', 'AI-Powered'],
    sortOrder: '1',
    publishDate: '2024-10-25T00:00-04:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7C3frvfIKzP6EwfayIQRSo',
        type: 'Asset',
        createdAt: '2024-10-24T18:43:32.077Z',
        updatedAt: '2024-10-24T18:43:32.077Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile Release Week - Build Mode',
        description: '',
        file: {
          url: '/img/contentful/7C3frvfI-build_mode.webp',
          details: {
            size: 834179,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Build Mode.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile Launch Week - Build Mode',
    summary:
      'Build Mode is a streamlined, AI-assisted solution for configuring Flatfile, enabling your team to create and manage data validation rules, workflows and updates in real-time. No coding, no delays — just fast, intuitive customization that puts you in control.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4tvIaaSS8i8JTKjFpOQc1Y',
        type: 'Entry',
        createdAt: '2024-10-25T21:49:19.640Z',
        updatedAt: '2024-10-25T21:49:19.640Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Kelly Johnson',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3fkbdwtaMhjtHwP5wiz6a6',
            type: 'Asset',
            createdAt: '2024-10-22T18:37:34.262Z',
            updatedAt: '2024-10-22T18:37:34.262Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Launch Week - Dev Day',
            description: '',
            file: {
              url: '/img/contentful/3fkbdwta-zoom__main_image__1_.webp',
              details: {
                size: 755020,
                image: {
                  width: 1920,
                  height: 1080
                }
              },
              fileName: 'Zoom_ Main image (1).png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Your enterprise data exchange needs are dynamic and ever-changing. However, your migration team may struggle to keep pace with project requirements. Why? They’re handcuffed by legacy development processes that won’t allow them to customize data transformation applications to fit their needs – impacting their onboarding workflow. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'That’s where Build Mode changes everything. Build Mode is a streamlined, AI-assisted solution for configuring Flatfile, enabling your team to create and manage data validation rules, workflows and updates in real-time. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It significantly reduces the time and complexity of onboarding, making it accessible for users that don’t have coding experience.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'No coding, no delays — just fast, intuitive customization that puts you in control, with no need to wait on developer assistance.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile Product Lead Alnoor Pirani introduced this new addition to the platform on the third day of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/fall-release/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Launch Week',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' – a celebration of the largest feature release in the company’s history.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here’s our Build Mode session recap and a primer about this powerful new tool.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'AutoBuild: Your First Step to Configuring Flatfile',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The Flatfile team reimagined our platform to give you an option to kick off your desired configuration using ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Autobuild ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '– an important first step in the process that is more straightforward. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For instance, if you have a file that describes your system’s requirements, you only need to upload it to AutoBuild, which will generate a configuration that matches your requirements in seconds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "“[It] does a deep dive into your file, and it's almost like having a brilliant analyst who can understand your document and says, ‘I see exactly what you’re aiming for here.’ And then creates a complete data onboarding application custom tailor to your specific needs by translating your documentation into a functional system,” Pirani explained.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'However, what makes ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'AutoBuild',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' truly impressive is the intuitive user interface that lets you make quick adjustments to your configuration without a code deployment. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AutoBuild also features a live, interactive preview that shows you real-time changes to your project in a fully functional sandbox. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With this new feature, your team will be empowered to build a data onboarding process that precisely matches your needs. While AutoBuild automates the technical implementation, you still retain complete control of the output. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Powerful AI-Driven Data Validations at Your Fingertips',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Do you want to dictate that addresses use a specific format or that dates have a designated range? With AutoBuild’s ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Intelligent Validation Handling,',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' simply describe your requirements using natural language and it will generate the validation rules. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You can quickly identify valid and incorrect data with an integrated sandbox – giving you confidence that your validation rules are precise.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5AcXiyO0V7drypiSITeVxX',
                type: 'Asset',
                createdAt: '2024-10-25T21:13:42.257Z',
                updatedAt: '2024-10-25T21:13:42.257Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'AutoBuild - Intelligent Validation Handling',
                description: '',
                file: {
                  url: '/img/contentful/5AcXiyO0-image__2_.webp',
                  details: {
                    size: 217802,
                    image: {
                      width: 2876,
                      height: 1716
                    }
                  },
                  fileName: 'image (2).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A sneak preview of Validation Handling in Flatfile.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'During the Launch Week sessions, Pirani continued to explain how “Flatfile operates on code, [and that] you can simply express your needs in everyday language while our system translates. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The result has custom-coded functionality, so you get the power of custom-coding without having to write a single line yourself.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Automatic Sample Data Generation: Taking the Tedium Out of Testing',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Testing is a vital part of the data onboarding process, but it's tedious, time-consuming and painful. Enter Auto Build’s Automatic Sample Data Generation feature: an innovative solution that will generate representative sample data, so you’re not beleaguered by prep work.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Automatic Sample Data Generation creates realistic sample data to match your data. And it can also generate sample data with both valid and invalid records, so you can see exactly how your configuration behaves across a variety of data scenarios. Essentially, it’s a ready-made sandbox for your data migration team. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3UTv7zVoUqZPGFdo6HvLol',
                type: 'Asset',
                createdAt: '2024-10-25T21:15:44.657Z',
                updatedAt: '2024-10-25T21:21:19.101Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Automatic Sample Data Generation',
                description: '',
                file: {
                  url: '/img/contentful/3UTv7zVo-image__3_.webp',
                  details: {
                    size: 699545,
                    image: {
                      width: 1736,
                      height: 1302
                    }
                  },
                  fileName: 'image__3_.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A side-by-sideview of Sample Data Generation in action.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“No more dummy files, no more hours spent on test data. Whether you need numbers, dates or text, Auto Build has got you covered,” said Pirani.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In fact, you’ll see that the sample data appears side-by-side in the user interface when you’re setting validation rules. This gives you the opportunity to quickly adjust your rules so you can refine your configuration.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Pirani added that “the result is a more efficient development process. You're able to test and optimize your system before going live with real data.” ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Build Mode Puts AI-driven Power in Your Hands',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Build Mode is designed to place developer-level tools into the hands of your data migration team. We have worked around the clock to create and configure a platform that fits your team’s exact needs. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'From data validation to workflow enforcement, Build Mode lets you customize your data onboarding process to drive better outcomes.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Start using Build Mode today and experience the future of AI-driven configuration. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5JE8EuEWcnthiRB1H7Upc9',
                type: 'Entry',
                createdAt: '2024-10-25T21:16:46.564Z',
                updatedAt: '2024-11-04T21:57:43.691Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 21,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Launch Week ',
                text: 'Our major feature release includes announcements, personalized consultations, and customer panels.',
                ctaText: 'Watch the Recording',
                href: '/fall-release/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'jch753wpbiYByWI7Qnhb4',
    postTitle:
      'Advanced Mapping – A New Essential Tool for Data Migration Teams',
    seoTitle:
      'Advanced Mapping – A New Essential Tool for Data Migration Teams',
    seoUrlSlug:
      'advanced-mapping-a-new-essential-tool-for-data-migration-teams',
    seoMetaDescription:
      'Flatfile retooled mapping to make it more flexible. Advanced Mapping offers enhanced control and visibility over how your data is mapped – meaning faster, smarter workflows with fewer headaches.',
    category: 'Product updates & features',
    tags: ['Advanced Mapping ', 'Flatfile Launch Week 2024', 'Featured'],
    sortOrder: '1',
    publishDate: '2024-10-24T00:00-04:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6N1jMNmYMpFNI4swDs8Oae',
        type: 'Asset',
        createdAt: '2024-10-18T22:13:53.277Z',
        updatedAt: '2024-10-24T14:39:35.837Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Fall Release 2024 Press Release Image',
        description:
          "Flatfile's Fall 2024 release is the largest in the company's history.",
        file: {
          url: '/img/contentful/6N1jMNmY-advanced_mapping.webp',
          details: {
            size: 1190150,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Advanced Mapping.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile Introduces Advanced Mapping',
    summary:
      'We unveiled Advanced Mapping on the first day of our Launch Week event.  In the session, Flatfile Engineering Lead Damon Banks  explained how this features expands your options for mapping data -- saving time and cost and streamlining your team’s workflow.  \n',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3mVo2rzJFJOUveOg0BvKft',
        type: 'Entry',
        createdAt: '2024-10-24T14:12:17.812Z',
        updatedAt: '2024-10-24T14:12:17.812Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Kelly Johnson',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6N1jMNmYMpFNI4swDs8Oae',
            type: 'Asset',
            createdAt: '2024-10-18T22:13:53.277Z',
            updatedAt: '2024-10-24T14:39:35.837Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Fall Release 2024 Press Release Image',
            description:
              "Flatfile's Fall 2024 release is the largest in the company's history.",
            file: {
              url: '/img/contentful/6N1jMNmY-advanced_mapping.webp',
              details: {
                size: 1190150,
                image: {
                  width: 1920,
                  height: 1080
                }
              },
              fileName: 'Advanced Mapping.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In data transformation, mapping is where every migration project begins — and often where frustration escalates. Without the right tools, navigating through the complexity of this process can slow your project to a crawl. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Flatfile team has been vigorously working to solve this problem. After several experiments and epiphanies, we revamped a key platform feature — Advanced Mapping — to transform this critical process. Thanks to this breakthrough, we removed the guesswork and hassle from data migration.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We unveiled this new tool on the inaugural day of our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/fall-release/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Launch Week ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                "event, a four-day conference that marks Flatfile's largest feature release ever. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the session, Engineering Lead Damon Banks expertly explained how Advanced Mapping will expand your options for mapping data, saving time and cost and streamlining your team’s workflow. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Read our session recap to get key highlights of what you can expect with Advanced Mapping.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Gain Confidence, Control and Visibility. Lose the Complexity',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile retooled mapping from the ground up to make it more intuitive and flexible. Advanced Mapping offers enhanced control and visibility over how your data is mapped – meaning faster, smarter workflows with fewer headaches.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'One of the more notable features of Advanced Mapping is ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Groups',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '. Previously, basic mapping only offered a left-to-right assignment without a simple mechanism to track what was mapped or what remains – Groups solved this problem. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When you use Advanced Mapping, you could see as many as five new groupings — ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Recommendations, Exact Matches, Previously Mapped, Unmapped, and Empty Fields',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' — that will make organizing, tracking and refining your mapping tasks easier.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Here’s a quick breakdown of what comprises Groups:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Recommendations',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' is our advanced AI-mapping engine trained on billions of decisions that provides incredibly accurate mapping suggestions.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Exact Matches ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'auto-suggests simple matches such as “first name” and “last name.” ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Previously Mapped ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'is an AI-driven feature that learns your preferences. Anything you previously matched is retained, so you can use it the next time you map schemas.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Unmapped ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "helps your team understand what's done and what’s left to do when mapping large data sets. With this group type, you no longer have to constantly check to see if mapping is complete.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Empty Fields ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'shows you any empty columns without information and groups them together so you can clearly gauge the accuracy of your incoming data. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4Zy63eKdX3zgWGtJG6oFfg',
                type: 'Asset',
                createdAt: '2024-10-23T22:32:50.755Z',
                updatedAt: '2024-10-23T22:32:50.755Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Advanced Mapping - Recommendations Example',
                description: '',
                file: {
                  url: '/img/contentful/4Zy63eKd-recommendations.webp',
                  details: {
                    size: 723493,
                    image: {
                      width: 2440,
                      height: 1368
                    }
                  },
                  fileName: 'Recommendations.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "Here's a preview of the Recommendations grouping",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5o5b07kh9KtPKhdmJMyvNF',
                type: 'Asset',
                createdAt: '2024-10-23T22:34:06.235Z',
                updatedAt: '2024-10-23T22:34:06.235Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Advanced Mapping - Previously Mapped Example',
                description: '',
                file: {
                  url: '/img/contentful/5o5b07kh-previouslymapped.webp',
                  details: {
                    size: 460252,
                    image: {
                      width: 2452,
                      height: 1374
                    }
                  },
                  fileName: 'PreviouslyMapped.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Take a look at the Previously Mapped grouping',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                ' Groups will give you a holistic view of your data migration – giving you confidence that nothing is overlooked and quickly identifying any fields that need additional scrutiny.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data Preview – Your Best Friend in Data Mapping',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Another exciting development in Advanced Mapping is the enhanced Data Preview feature. This feature will help your team have a better understanding of how information is mapped between the source data and the destination data. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'By removing simple data samples and placing them in tabular form, your team will see the data exactly as it will appear in its final form, simplifying the validation process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Think about that for a minute: No more testing mapping to see desired outputs. You can now quickly see if what you have done is what’s needed. This instant feedback is going to be your best friend in data mapping, and we’re very proud of it,” said Banks.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What’s more, you could only view 10 records previously. Now, you can view up to 1,000 records at a time –  a massive upgrade for the feature. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This expanded view offers a richer context for how data is being mapped, providing more clarity and confidence in the process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Killing the Pain of Managing Gigantic Data Sets ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Are you working with large and complex datasets or what we call Wide File Ergonomics? Advanced Mapping alleviates the endless scroll nightmare your team may experience and other administrative burdens accompanying navigating gigantic files. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We incorporated new features like',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' Scroll to Field, Search ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: 'and',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' Auto Save',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' into Advanced Mapping to streamline the experience and ensure every field is accounted for and accurately mapped. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Here’s how it works:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Scroll to Field Mapping: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "When you hover over a field, Data Preview will auto-scroll to it. You’ll now have real-time previews of your source data and destination data, so you don't have to scroll to the field; it auto-scrolls for you.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Search:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' Your team can now search for any column, and data preview will dynamically show the result.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Auto Save:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' Lost work is now a thing of the past. With Auto Save, you can be confident that you can save your work and pick up where you left off after you close a browser or shut down your computer.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "“We've tested this new Wide File Ergonomics on large schemas of well over 1,000 fields, and the results are simply amazing. Data Mapping is efficient, and the outcome is greater accuracy,” said Banks.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As a result, you won’t waste time searching for specific data points or making adjustments to wide datasets.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Introducing Data Transformation Rules',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Advanced Mapping goes beyond simple field-to-field matching. Where the old mapping uses a manual approach, the new mapping relies on data transformation rules. Today, you can  manipulate your data as part of the mapping process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Do you need to split full names into first and last names or combine multiple data points into a single field? No problem. Now, you can customize how your data is transformed –  giving you full flexibility to match your destination schema.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Banks offered this example: “You now have five new options for mapping your data. Plus, we removed the restriction of mapping only one source field to one destination field. Meaning, if you need to map a phone number to both primary phone and primary contact, you can do it!”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Take a look at the five new key rules:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Combine Fields:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' Allows you to merge multiple source fields into one destination field.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Single Value',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': Lets you set a constant value for the destination field.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'First available value',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': Provides flexibility by mapping the first non-empty value from a list of source fields to a destination field.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'List rule: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'Gives you the power to aggregate multiple source fields into an array within a single destination field. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Split Rule: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'Separates a single source field into multiple destination fields based on delimiters or patterns. The Split rule uses AI to understand the content of the source field, and then it uses the context of all available destination fields to suggest the best way to split your data with accuracy.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2UVMt6wd3hnLQuw9GuWPK8',
                type: 'Asset',
                createdAt: '2024-10-23T22:35:34.258Z',
                updatedAt: '2024-10-23T22:35:34.258Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Advanced Mapping -- Split Mapping Example',
                description: '',
                file: {
                  url: '/img/contentful/2UVMt6wd-splitexample.webp',
                  details: {
                    size: 773097,
                    image: {
                      width: 2466,
                      height: 1380
                    }
                  },
                  fileName: 'SplitExample.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Here's what you'll see when using the Split Mapping Rule ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Banks added that “by leveraging these powerful rules, advanced mapping is going to empower you to handle even the most complex data transformation much easier, no more detours into Excel for complex formulas or manual data. Everything you need is right at your fingertips, making data mapping more efficient and less error prone.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your team will be inspired to adjust data directly within Flatfile, eliminating the need for cumbersome pre-processing steps.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A Foundation for Future Innovation',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Advanced Mapping isn’t just a new feature; it's the foundation for how Flatfile will continually improve data mapping. Additionally, it’s one of the most meaningful tools for removing latency from data transformation, and we’re dogmatic about reducing this friction to accelerate your projects.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This tool and the robust features within it will evolve with every use, providing more options and better outcomes for even the most complex data scenarios. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As we announce more updates to the Flatfile platform, you will see enhancements that will continue to simplify and expedite the mapping process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Watch the recording of our Advanced Mapping session, which included a demo. Get a sneak preview of the tool in action. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '22nv2JPLljtPC4TFlR1PsH',
                type: 'Entry',
                createdAt: '2024-10-23T23:09:02.110Z',
                updatedAt: '2024-10-24T19:38:48.074Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 39,
                revision: 12,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Launch Week Advanced Mapping Session',
                text: 'Smarter, better data transformation',
                ctaText: 'Watch the Recording',
                href: '/resources/webinars/advanced-mapping-fall-release/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '1e9zJ07qbw7BhdbwfqmSY0',
    postTitle:
      '4 key customer success metrics to watch for better data onboarding',
    seoTitle:
      '4 key customer success metrics to watch for better data onboarding',
    seoUrlSlug: '4-customer-success-metrics-better-data-onboarding',
    seoMetaDescription:
      'By paying attention to these metrics, companies can improve data onboarding and migration, reducing costs and accelerating revenue.',
    category: 'Data exchange',
    tags: [
      'Data onboarding',
      'Data migration',
      'Data exchange',
      'Customer success',
      'Customer experience',
      'Customer satisfaction'
    ],
    sortOrder: '1',
    publishDate: '2024-08-08T09:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1wtMxas4AsD44qFAaZOZpd',
        type: 'Asset',
        createdAt: '2024-08-08T15:45:09.455Z',
        updatedAt: '2024-08-08T15:45:09.455Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Better data onboarding 4 key metrics to watch',
        description:
          '"Better data onboarding 4 key metrics to watch" on a white background with icons on a graph representing customer success metrics',
        file: {
          url: '/img/contentful/1wtMxas4-better_data_onboarding__4_key_metrics_to_watch.webp',
          details: {
            size: 70164,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Better data onboarding_ 4 key metrics to watch.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Better data onboarding 4 key metrics to watch" on a white background with icons on a graph representing customer success metrics',
    summary:
      'With these metrics, companies can improve data onboarding and migration, reducing costs, accelerating revenue and increasing customer satisfaction.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'bz1819JFLCzgCuaIcgEt2',
        type: 'Entry',
        createdAt: '2024-06-21T15:44:13.272Z',
        updatedAt: '2024-06-21T15:44:13.272Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Andy Feldman',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5kR6u3INP8RxJ2Zb1RYOw9',
            type: 'Asset',
            createdAt: '2024-06-21T15:44:02.737Z',
            updatedAt: '2024-06-21T15:44:02.737Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'andy-feldman-headshot',
            description: 'Andy Feldman headshot',
            file: {
              url: '/img/contentful/5kR6u3IN-andy-feldman-headshot.webp',
              details: {
                size: 351466,
                image: {
                  width: 493,
                  height: 502
                }
              },
              fileName: 'andy-feldman-headshot.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Customer Success Manager'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Do you know whether your customers hate your onboarding process?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Are you sure?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you offer a product or service that requires data from your customers, you probably see those customers getting stuck trying over and over to get their data in shape so that it can be used. Migrating data from legacy systems and external sources to your product or service (a.k.a. data onboarding) is a critical first step in the overall experience a new customer will have working with your offering, and customer success leaders are very aware that any ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/fastest-way-onboard-data/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'glitches and delays',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' from poor data onboarding and migration can derail a new relationship before it’s even begun. Improving your onboarding process will directly impact your overall customer success metrics.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It’s those metrics that will give you real insights into the critical first steps of your customers’ experience.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'By ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'improving your data onboarding and migration process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and keeping an eye on these specific metrics, companies can reduce costs, accelerate revenue and significantly increase customer satisfaction. If you want to improve your onboarding process, pay attention to these customer success metrics:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/4-customer-success-metrics-better-data-onboarding/#retentionRates'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Retention rates',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/4-customer-success-metrics-better-data-onboarding/#productAdoption'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Product adoption',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/4-customer-success-metrics-better-data-onboarding/#timeToValue'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Time to value',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/4-customer-success-metrics-better-data-onboarding/#netPromoterScore'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Net promoter score',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here’s how understanding these metrics can help you figure out ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/10-data-onboarding-problems-cs-leaders-face-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'what’s happening during your onboarding process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' and how to improve your customer experience:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Retention rates',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This metric provides the most direct insight into whether your customers are happy with your product and service. A ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/why-customer-success-leaders-hate-their-customer-onboarding-processes/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'poor data onboarding experience',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' will hurt your customer relationship and general customer satisfaction and can impact your retention rates. Conversely, a streamlined data onboarding or migration process can positively impact your retention rates because those who can get started and derive value quicker will be more satisfied customers as a result.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Product adoption',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Consider the speed and volume of usage of your product. How long did it take customers to use it for the very first time? Are they using it daily? Is usage growing or shrinking? These could be indicators of a solid or weak customer experience during onboarding.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Time to value',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Time to value (TTV) measures the time from signup to the time users activate. If your data onboarding or migration process relies on time-consuming spreadsheet uploads and follow-up emails to handle the inevitable data errors that arise, you can expect a delay in activations.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The more steps in your activation process, the longer it will take individuals to begin successfully using your product. You may have a clear checklist that takes users through an activation process, but if one of the items is “import data” and the data onboarding process isn’t up to par, customers will experience delayed time to value.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Net promoter score',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'CS leaders often track the Net Promoter Score (NPS) throughout the customer journey to better understand how customers feel about their product. A painful data onboarding process will not only negatively impact the early engagement period but also leave lingering bad impressions that can affect scores going forward.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-1',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The easy way to improve customer success metrics',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Onboarding and migrating data are difficult processes that require ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-onboarding-workarounds-cost-you/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'careful planning, execution and follow-up',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. However, when you’re laser-focused on these metrics, tying the value of data onboarding back to them can make a significant difference in the quest for customer satisfaction and successful product adoption.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once you analyze your onboarding process, you might find that it’s challenging to implement the improvements you need, especially at scale. Fortunately, a dedicated data onboarding and migration solution can help ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/6-ways-implementation-teams-can-conquer-data-migration/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'quickly resolve common issues',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and help teams safely and efficiently onboard data files of all sizes and numerous types, improving customer success metrics across the board. By leveraging a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding and migration solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', you can avoid the costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining complicated workarounds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn more about how Flatfile can improve your customer success metrics? ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Book a demo with Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' today.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2xRVtX29i5WS9rGt83YGyY',
    postTitle: 'The fastest way to onboard data',
    seoTitle: 'The fastest way to onboard data',
    seoUrlSlug: 'fastest-way-onboard-data',
    seoMetaDescription:
      'Find out how to accelerate time to value, reduce resource costs and increase revenue opportunities by building a faster data onboarding process.',
    category: 'Data exchange',
    tags: [
      'Data onboarding',
      'Customer onboarding',
      'Data exchange',
      'Customer experience',
      'Artificial intelligence'
    ],
    sortOrder: '1',
    publishDate: '2024-07-31T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5kVMXqcYvqOCixIzt4TVjI',
        type: 'Asset',
        createdAt: '2024-07-31T03:20:02.297Z',
        updatedAt: '2024-07-31T03:20:02.297Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'How to accelerate data onboarding',
        description:
          '"How to accelerate data onboarding" on a white background with an icon representing a fast onboarding experience',
        file: {
          url: '/img/contentful/5kVMXqcY-how_to_accelerate_data_onboarding.webp',
          details: {
            size: 35278,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'How to accelerate data onboarding.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"How to accelerate data onboarding" on a white background with an icon representing a fast onboarding experience',
    summary:
      'Find out how to accelerate time to value, reduce resource costs and increase revenue opportunities by building a faster data onboarding process.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2idPOfVSoosDk1m4NwOQG6',
        type: 'Entry',
        createdAt: '2024-03-20T16:50:45.144Z',
        updatedAt: '2024-03-20T16:50:45.144Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Kyle Costa',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1HmNp0mV8EVOHBtuFBq9lk',
            type: 'Asset',
            createdAt: '2024-03-20T16:49:44.410Z',
            updatedAt: '2024-03-20T16:49:44.410Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Kyle headshot',
            description: '',
            file: {
              url: '/img/contentful/1HmNp0mV-t0ap8ur47-u037vqt9w3v-d7a3d83f6ed3-512.webp',
              details: {
                size: 49031,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U037VQT9W3V-d7a3d83f6ed3-512.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Enterprise Account Executive'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data onboarding has a tendency to be a slow, painful, painstaking process, but it doesn’t have to be that way! There’s a fast, safe and powerful way to improve your data onboarding process.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Right now, you’re probably dealing with boilerplate processes that don't fit, you have little to no flexibility to respond to unique challenges and customer needs, and you have to be on top of the excessive back-and-forth of onboarding-related emails. And then there are the complicated (frequently manual) data cleaning requirements.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Just thinking about it is exhausting.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here’s what you can do to streamline and accelerate your data onboarding process:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How to speed up data onboarding',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Luckily, there’s a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'fast, safe and efficient way to collect and onboard data',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. Instead of getting stuck trying to make a boilerplate template or process work for each unique customer, file type and use case, implementing a robust data onboarding solution will not only ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-onboarding-workarounds-cost-you/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'lower your operational costs',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', but also accelerate time to value, increase revenue opportunities and help you make better decisions faster.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " will help you convert and onboard your customers' data effortlessly. It can help you eliminate costly, services-heavy processes and can enable seamless collaboration between customers and teams. Ultimately, you’ll be able to reduce resource costs, accelerate revenue and enhance data quality and compliance.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How do you choose a data onboarding solution?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You’re looking for a solution that will support your specific requirements and use case and one that can easily fit into your tech stack and development tooling. Choosing the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'best solution for your needs',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is critical because it directly impacts the outcome and success of your operations.  By using the ideal solution for your use case, you can avoid the high costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining complex workarounds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But how do you know which solution is ideal for your specific needs and requirements? We created a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/checklist-accelerated-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'clear and comprehensive checklist',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that will guide you through the decision-making process. The checklist walks you through:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Critical data onboarding capabilities',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Key factors to keep in mind',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to select the solution that makes sense for you',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4s4lVHE61LPQIfUKpf9SDU',
                type: 'Asset',
                createdAt: '2024-07-23T16:27:16.231Z',
                updatedAt: '2024-07-23T17:56:35.703Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 17,
                revision: 3,
                locale: 'en-US'
              },
              fields: {
                title: 'Checklist for accelerated data onboarding',
                description:
                  'Image of the accelerated data onboarding checklist',
                file: {
                  url: '/img/contentful/4s4lVHE6-checklist_for_faster_data_onboarding_cover.webp',
                  details: {
                    size: 316199,
                    image: {
                      width: 2001,
                      height: 1230
                    }
                  },
                  fileName: 'checklist for faster data onboarding cover.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Download your free copy of the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/checklist-accelerated-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'checklist for accelerated data onboarding',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can accelerate your data workflow? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your data challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Adding superpowers to data onboarding with AI',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Don’t ignore the power AI has to accelerate the onboarding process! AI is changing how companies ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'import, manage and leverage data',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', giving technical and non-technical users new capabilities. Using AI in the onboarding process opens up levels of automation, data quality and speed that used to be almost impossible to reach.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Integrating ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/introducing-ai-transform-your-data-transformation-copilot/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'AI-enhanced features',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' into data onboarding processes offers enormous benefits in terms of speed, efficiency and accuracy. These technologies can help you automate file formatting, extract relevant data, optimize bandwidth usage, enhance security measures, facilitate collaboration and provide personalized recommendations.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Unprecedented accuracy and speed',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AI can speed up the onboarding process in numerous ways. It can, for example, accelerate data cleaning by automatically identifying and fixing inconsistencies, errors and missing values within datasets. Algorithms learn from patterns in the data and can automate the process of validating information against predefined rules, ensuring data accuracy and reliability.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Another key challenge of importing data is the need to extract information from unstructured sources like documents, websites, PDFs or images. AI can interpret unstructured data from invoices, forms or contracts and automatically convert them into structured formats for easy integration into databases or analytics platforms.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Usually, speed, efficiency and quality are impossible to achieve together simultaneously, but AI has put this in much closer reach. By using AI, users can perform more and more complex data review, validation and transformation actions than ever before, and even less tech-savvy users can manipulate data faster and more efficiently.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Mapping data',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' from multiple sources into a unified format can be complicated and often requires human oversight. However, AI can recognize patterns and relationships within datasets, facilitating a much faster and more precise mapping of source to target formats.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "AI's role in the data onboarding process revolutionizes how businesses collect, manage and utilize information. By leveraging AI's capabilities, companies can enhance their decision-making processes, drive innovation and gain a competitive edge in today's data-driven landscape.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The benefits of an accelerated data onboarding process',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Quickly and successfully navigating the data onboarding process is critical for ensuring a positive first impression. If customers ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/why-customer-success-leaders-hate-their-customer-onboarding-processes/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "hate how they're onboarded",
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", it's unlikely that they'll feel satisfied or stick around for long. Besides keeping your teams and customers happy, there are more key business reasons to speed up your onboarding process:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Accelerating time to value',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The sooner your solution can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/10-data-onboarding-problems-cs-leaders-face-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'solve a problem',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', the sooner your customers can derive value from it. The sooner you have a strong data onboarding solution in place, the faster you will streamline and accelerate the process of getting data into your systems. Additionally, your customers and users will benefit from having an improved user experience and gaining access to their data much more quickly.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With a data onboarding solution, you can get customer data into your systems faster with an onboarding experience your company needs and your users will love -- without delay or compromises.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Accelerating data availability and timely decision-making',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If expert users, managers and decision-makers in your company aren't able to quickly and efficiently access relevant data, your company's ability to derive value from that data will also be delayed or even lost. Inefficient data import processes can cause bottlenecks in data handling, slowing down all processes that depend on timely access to accurate data. A data onboarding solution will ensure that data is collected, cleaned, transformed and ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'validated',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' rapidly and accurately.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Reducing in-house development time and cost',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data, especially data from countless unmanaged sources, will likely be full of errors, come in a variety of formats or have unclear data definitions. A data onboarding solution will help you check, clean and validate data efficiently and thoroughly to minimize data errors and ensure that all stakeholders have reliable data to work with. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Additionally, the time and effort required to design, develop, test and maintain a data onboarding solution can quickly tie up software development resources and divert your team away from focusing on core strategic initiatives that deliver greater ROI. Typically, implementing a proven data onboarding solution provides more comprehensive functionality much faster and at a fraction of the in-house development cost, enabling your team to start working with the data they need immediately. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How Flatfile can help',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When you really examine your customer onboarding process, you'll probably find that it's difficult to implement the improvements you need on your own, especially at scale. Fortunately, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " is designed to help you build the ideal data onboarding experience for your use case and requirements. It's a collaborative, secure platform that helps companies speed up every aspect of onboarding. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile accelerates data onboarding by providing highly customizable automation and advanced data collection, mapping, transformation and validation capabilities. It also offers ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'AI-powered features',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that will speed up your customer onboarding process, enabling you to deal efficiently with all of the real-world data your customers have.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn more about how Flatfile can accelerate and streamline your data onboarding processes? ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Book a demo with a Flatfile expert today',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '16wTQJN18j5xV4yot3X8Pg',
                type: 'Entry',
                createdAt: '2024-07-11T23:37:57.343Z',
                updatedAt: '2024-07-30T23:58:59.601Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 18,
                revision: 8,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Ease the pain of data onboarding',
                text: 'Get your free copy of "The CS leader’s guide to successful data onboarding."',
                ctaText: 'Download now',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2DjffmKE8kiCP99nvXvKkw',
    postTitle: 'A new way to tackle data onboarding',
    seoTitle: 'A new way to tackle data onboarding',
    seoUrlSlug: 'new-way-tackle-data-onboarding',
    seoMetaDescription:
      "Problems during data onboarding reduce time to value, damage trust and lead to opportunity costs. Fortunately, there's a better way to handle onboarding.",
    category: 'Data exchange',
    tags: ['Data onboarding', 'Data exchange', 'ETL', 'Customer experience'],
    sortOrder: '9',
    publishDate: '2024-07-24T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1Tt8PYNr48zFbFkdiRKJ2Q',
        type: 'Asset',
        createdAt: '2024-07-24T01:29:37.657Z',
        updatedAt: '2024-07-24T01:29:37.657Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'A new way to tackle data onboarding',
        description:
          '"A new way to tackle data onboarding" on a white background with icons representing data onboarding',
        file: {
          url: '/img/contentful/1Tt8PYNr-a_new_way_to_tackle_data_onboarding.webp',
          details: {
            size: 82731,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'A new way to tackle data onboarding.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"A new way to tackle data onboarding" on a white background with icons representing data onboarding',
    summary:
      "Problems during data onboarding reduce time to value, damage your customers' trust and lead to opportunity costs. Fortunately, there's a better way to handle onboarding.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4QvsXEF0J1d3saiLVIv030',
        type: 'Entry',
        createdAt: '2024-07-24T03:32:44.675Z',
        updatedAt: '2024-07-24T03:32:44.675Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Prashant Kaw',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '43LMol7oXjsv1fYhCRtTwM',
            type: 'Asset',
            createdAt: '2024-07-24T01:15:46.261Z',
            updatedAt: '2024-07-24T01:15:46.261Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Prashant Kaw',
            description: 'Prashant Kaw headshot',
            file: {
              url: '/img/contentful/43LMol7o-prashant_kaw.webp',
              details: {
                size: 359598,
                image: {
                  width: 508,
                  height: 512
                }
              },
              fileName: 'Prashant Kaw.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data onboarding and migration processes cause a lot of pain for companies everywhere and they can be a huge drag on your team. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Problems during ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/10-data-onboarding-problems-cs-leaders-face-and-how-to-fix-them/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/6-ways-implementation-teams-can-conquer-data-migration/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'migration',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " reduce time to value, damage your customers' trust and lead to opportunity costs. Improving these processes can reduce costs, accelerate revenue & increase customer satisfaction. Keep reading to find out how you can eliminate drag from data onboarding, cut out time consuming cycles and collect, onboard and migrate data faster.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A new way to onboard data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "There's a critical missing piece in most enterprise IT stacks that common integration systems don't solve, and it's holding your data onboarding and migration back and costing companies millions of dollars.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Unlock accelerated data onboarding by addressing a critical missing piece in your enterprise integration architecture: How to efficiently and safely collect, validate, transform and collaborate on data from sources with a high degree of variance in structure and quality that come from customers, suppliers, partners, agents or other unmanaged external sources. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1SdYoRJPQpFw0B3aaMjjPC',
                type: 'Asset',
                createdAt: '2023-12-20T01:06:58.309Z',
                updatedAt: '2024-05-01T19:48:59.397Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 10,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Image missing piece',
                description:
                  'Image of cover and pages from the Introduction to Data Exchange',
                file: {
                  url: '/img/contentful/1SdYoRJP-updated_title_page.webp',
                  details: {
                    size: 150559,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'Updated Title Page.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/guides/the-missing-piece-in-enterprise-integration/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Download this in-depth report',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to understand how data exchange platforms streamline the data onboarding and migration process, making it more efficient, secure and faster than ever before.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Free tool: Checklist for accelerated data onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Don't let your data onboarding process derail your new customer relationship before it's begun! A data onboarding solution is the fastest way to safely and securely speed up the onboarding process. But how do you choose the ideal solution for your use case and needs? This ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/guides/checklist-accelerated-data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'clear and comprehensive checklist',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' will guide you through the decision-making process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4s4lVHE61LPQIfUKpf9SDU',
                type: 'Asset',
                createdAt: '2024-07-23T16:27:16.231Z',
                updatedAt: '2024-07-23T17:56:35.703Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 17,
                revision: 3,
                locale: 'en-US'
              },
              fields: {
                title: 'Checklist for accelerated data onboarding',
                description:
                  'Image of the accelerated data onboarding checklist',
                file: {
                  url: '/img/contentful/4s4lVHE6-checklist_for_faster_data_onboarding_cover.webp',
                  details: {
                    size: 316199,
                    image: {
                      width: 2001,
                      height: 1230
                    }
                  },
                  fileName: 'checklist for faster data onboarding cover.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/assets/contentful/48Lc582z-Checklist_for_accelerated_data_onboarding_final.pdf'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Download the checklist',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '6 ways implementation teams can conquer data migration',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Implementation teams have to deal with many frustrating moments that can impact data migration success, and these pain points can have serious business implications. Find out ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/6-ways-implementation-teams-can-conquer-data-migration/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value:
                    'how implementation teams can streamline data migration',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', accelerating projects and reducing costs and resource demands.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Like chocolate and peanut butter: When to use ETL, data file exchange (or both!) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Knowing when to take advantage of the benefits that data exchange and ETL offer can help you make informed decisions and stay competitive. Pairing a data exchange solution with a traditional ETL tool offers considerable advantages for managing and transferring data and a number of key capabilities to your data integration stack. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Here’s what you need to know',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2TZP8p9TQ8i57KVitJyFZD',
    postTitle:
      'CS leaders: Those data onboarding workarounds are going to cost you',
    seoTitle:
      'CS leaders: Those data onboarding workarounds are going to cost you',
    seoUrlSlug: 'data-onboarding-workarounds-cost-you',
    seoMetaDescription:
      "Here's why those data onboarding workarounds are hurting and not helping you and what you can do about it.",
    category: 'Data exchange',
    tags: [
      'Data onboarding',
      'Customer success',
      'Data exchange',
      'Customer onboarding',
      'Costs'
    ],
    sortOrder: '3',
    publishDate: '2024-07-17T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'ejr2rzrub9RQ3BPVmaWUR',
        type: 'Asset',
        createdAt: '2024-07-17T00:17:47.967Z',
        updatedAt: '2024-07-17T00:17:47.967Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data onboarding workarounds will cost you',
        description:
          '"Those data onboarding workarounds are going to cost you" on a white background with icons representing workarounds and costs',
        file: {
          url: '/img/contentful/ejr2rzru-data_onboarding_workarounds_will_cost_you.webp',
          details: {
            size: 69025,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Data onboarding workarounds will cost you.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Those data onboarding workarounds are going to cost you" on a white background with icons representing workarounds and costs',
    summary:
      "Here's why those data onboarding workarounds are hurting and not helping you (and what you can do about it).",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3CihjjFSaXut3Hb9eI0XVM',
        type: 'Entry',
        createdAt: '2021-10-28T15:29:06.628Z',
        updatedAt: '2021-10-28T15:29:06.628Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Becca Weiss',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1BLXrFTRCL0lKeEq9FSYym',
            type: 'Asset',
            createdAt: '2021-10-28T15:28:39.305Z',
            updatedAt: '2021-10-28T15:28:39.305Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Becca Weiss headshot',
            description: 'Becca Weiss headshot',
            file: {
              url: '/img/contentful/1BLXrFTR-197-0-4.webp',
              details: {
                size: 31079,
                image: {
                  width: 170,
                  height: 170
                }
              },
              fileName: '197-0-4.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Director of Customer Success & Implementation',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We know data onboarding can be a nightmare. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'How bad that nightmare is depends on the solutions you have in place.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'There are a lot of ways companies try to tackle ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/why-customer-success-leaders-hate-their-customer-onboarding-processes/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data onboarding problems',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' like files that refuse to cooperate, incompatible data formats and the countless hours it takes to manually clean data. Usually, teams are tasked with creating and implementing complicated workarounds. Those workarounds, however, come at a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'high cost',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Personnel and manual work costs, supporting engineering resources and long-term maintenance are just the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/4-key-ways-cs-leaders-tackle-data-chaos-customer-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'tip of the iceberg',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. The opportunity cost of lost and delayed revenue can be millions of dollars.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '20jamk5zaD8c7M4sOLK5GY',
                type: 'Entry',
                createdAt: '2024-06-04T16:02:34.659Z',
                updatedAt: '2024-07-30T23:58:59.565Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Data onboarding shouldn't hurt",
                text: 'Download our free guide to discover how CS leaders can address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download now',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What’s wrong with data onboarding workarounds?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Data mapping',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', review, cleanup and validation often aren’t easy to handle, and there are several common ways CS leaders attempt to solve data onboarding complications. These workarounds include:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#usingTraditionalIntegrationTools'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Using traditional integration tools',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#relyingOnTemplatesAndDocumentation'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Relying on templates and documentation',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#internallyBuiltDataOnboardingSolutions'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value:
                            'Building data onboarding solutions internally',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Why don’t they work? Keep reading to find out.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Using traditional integration tools',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data integration and management tools have been around for decades, but they aren’t designed to support the data onboarding and data migration use cases that CS teams struggle with every day. Traditional ETL (',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Extract Transform Load',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ') and iPaaS (integration Platform as a Service) solutions are built on the idea that data is only ever safely and securely transferred between tightly managed IT systems. Unfortunately, they ignore the reality that data is messy! The data you need from your customers will often require complicated data mapping, review, cleanup and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'validation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' before it can be migrated and imported into your target system. Additionally, data often needs human review and oversight, which may involve deeper collaboration between the CS team and the customer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Relying on templates and documentation',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One popular solution that companies rely on to address data onboarding challenges is providing pre-made templates to customers and having them manipulate their data to fit a specific, fixed data model before uploading. In this scenario, an end user handles the work, but your organization needs to provide documentation, tutorials, FAQs and other how-to documents to walk a customer through the data import and migration process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Companies often ask users to adhere to one very specific spreadsheet format, and even the slightest deviation from that format results in the rejection of the data import attempt. Unfortunately, after the second or third attempt, users become highly frustrated, which can make an already challenging situation even more difficult. The impact of this process on customer satisfaction, conversion rates and missed top-line revenue is one of the most overlooked issues in data integration.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7JeQ4bgUGNy4KkheWrm8Qz',
                type: 'Asset',
                createdAt: '2024-07-17T00:41:37.321Z',
                updatedAt: '2024-07-17T00:41:37.321Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'credit-cards',
                description: 'Credit card icons',
                file: {
                  url: '/img/contentful/7JeQ4bgU-credit-cards.webp',
                  details: {
                    size: 29445,
                    image: {
                      width: 1420,
                      height: 732
                    }
                  },
                  fileName: 'credit-cards.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Do data onboarding templates waste customer time? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One team found that their customers were experiencing significant upload failures with their data files, which caused delays and required client operations and IT to get involved to solve the issues. They ended up spending a lot of time going back and forth with many of their customers, having them fix their files and resend them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If the data migration experience is manual and your process relies heavily on templates and on customers to update and fix files for onboarding, it may be time to reevaluate and examine how much time and energy are being dedicated to the process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Internally built data onboarding solutions',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Initially, many teams gravitate toward building their own solutions for importing data files, filtering data, flagging anomalies and correcting information. At first glance, this might seem like a practical choice that offers the most control over the finished product and frees up data management resources. Unfortunately, custom solutions introduce their own set of difficulties. As many CS leaders already know, if you're dealing with non-trivial needs, a homegrown solution often ties up limited and expensive resources, introduces dependencies on other internal teams with different priorities and usually costs more in the long run.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Many companies are convinced that building internally is necessary due to their unique data onboarding requirements, but it's becoming increasingly rare that companies actually need to build data import capabilities on their own. Enterprise-scale data onboarding solutions are built to address different organizations' varied needs. They're created and maintained to enable flexible workflows and configurations, and they bottle up the experience of domain experts, which is impossible to develop in a one-off project.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' isn’t a set-it-and-forget-it process. The business and your customers will require ongoing enhancements and maintenance of your data onboarding solution. Any team that takes on the responsibility of building a solution is also committing to support and maintain it over time. It typically becomes the responsibility of the team that created it and this ongoing maintenance is almost guaranteed to be a distraction from the core business functions that attracted your customer in the first place.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The simple solution',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Once you analyze your customer onboarding process, you may find it difficult to implement the necessary improvements, especially at scale. You might need to find the right balance between truly personal one-on-one onboarding and automated processes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A data file exchange platform like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is the easy painkiller for your data onboarding headaches. It’s designed to help you build the ideal data onboarding experience for your use case and requirements. Flatfile is a collaborative, secure ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' platform that helps companies speed up every part of data migration, from data submission to cleaning, mapping, validation and transformation.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You spent the time, energy, and resources to acquire a new client. If you can help them find value quickly and easily, your team will have a much easier time of keeping that customer for life, and you’ll have a customer onboarding experience that can set your software apart from the competition.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6HIqvj4ME90ORiwX37naXh',
                type: 'Entry',
                createdAt: '2024-01-12T01:19:47.604Z',
                updatedAt: '2024-07-30T23:58:59.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 32,
                revision: 7,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Watch Flatfile in action',
                text: 'We can help you spend 70% less time onboarding data. Discover how',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3P1ExagTzmDAb5xvaDmJIL',
    postTitle:
      '10 data onboarding problems CS leaders face and how to fix them',
    seoTitle: '10 data onboarding problems CS leaders face and how to fix them',
    seoUrlSlug:
      '10-data-onboarding-problems-cs-leaders-face-and-how-to-fix-them',
    seoMetaDescription:
      'By improving the data onboarding process, CS leaders can reduce costs, accelerate revenue and significantly increase customer satisfaction.',
    category: 'Data exchange',
    tags: [
      'Customer success',
      'Data exchange',
      'CS leader',
      'Data onboarding',
      'Customer onboarding'
    ],
    sortOrder: '2',
    publishDate: '2024-07-12T08:11-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3qfzrZt1mg05dpSKAiZR5M',
        type: 'Asset',
        createdAt: '2024-07-10T22:42:46.768Z',
        updatedAt: '2024-07-10T22:42:46.768Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '10 common data onboarding challenges CS leaders face',
        description:
          '"10 common data onboarding problems (and how to solve them" on a white background with icons representing common errors',
        file: {
          url: '/img/contentful/3qfzrZt1-10_common_data_onboarding_challenges_and_use_cases.webp',
          details: {
            size: 97965,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '10 common data onboarding challenges and use cases.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"10 common data onboarding problems (and how to solve them" on a white background with icons representing common errors',
    summary:
      'By improving the data onboarding process, CS leaders can reduce costs, accelerate revenue and significantly increase customer satisfaction.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1qOClOfOQUMbZ2onagvrK7',
        type: 'Entry',
        createdAt: '2024-07-10T23:47:35.858Z',
        updatedAt: '2024-07-10T23:52:23.540Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anastasia Gilbaugh',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '4nKlar1h7qsJhD8DjC24R1',
            type: 'Asset',
            createdAt: '2024-07-10T23:47:16.834Z',
            updatedAt: '2024-07-10T23:47:16.834Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Anastasia Gilbaugh',
            description: 'Anastasia Gilbaugh headshot\n',
            file: {
              url: '/img/contentful/4nKlar1h-anastasia.webp',
              details: {
                size: 381288,
                image: {
                  width: 507,
                  height: 510
                }
              },
              fileName: 'anastasia.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Enterprise Customer Success Manager'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer Success (CS) leaders know that any software application that requires data ingestion comes with a serious challenge to user satisfaction: ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/why-customer-success-leaders-hate-their-customer-onboarding-processes/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The data your customers supply might come from a previous software vendor or a legacy database and it might reside in spreadsheets or a whole range of other applications or files. Getting that data in shape for your product almost certainly requires complicated ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data mapping',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', review, cleanup and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'validation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', and might even need human oversight before it can be imported into your target system.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Unfortunately, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/4-key-ways-cs-leaders-tackle-data-chaos-customer-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'poor onboarding processes',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " can lead to reduced time to value, damage your customers' trust in the company and lead to ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'opportunity costs',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', especially for CS teams that have to dedicate valuable time to managing onboarding issues. By improving the onboarding process, you can reduce costs, accelerate revenue and significantly increase customer satisfaction.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '16wTQJN18j5xV4yot3X8Pg',
                type: 'Entry',
                createdAt: '2024-07-11T23:37:57.343Z',
                updatedAt: '2024-07-30T23:58:59.601Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 18,
                revision: 8,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Ease the pain of data onboarding',
                text: 'Get your free copy of "The CS leader’s guide to successful data onboarding."',
                ctaText: 'Download now',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What are the most common data collection, import, transformation and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/keep-teams-aligned-with-shared-views/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'collaboration',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' challenges and use cases that CS leaders deal with?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#1AssistedDataOnboardingByImplementationOrSupportTeams'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Data onboarding for implementation projects',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#2SelfserviceDataOnboardingViaFileImportByEndUsers'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Data onboarding via file import by end users',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#3DataOnboardingForInternalUse'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Data onboarding for internal use',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#4DataOnboardingAndOngoingDataFeeds'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Data onboarding and ongoing data feeds',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There are also specific data problems that CS leaders may need to tackle during the onboarding process. The most common ones include:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#1LargeFileSize'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Large file size',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#2SourceToTargetMapping'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Source to target mapping',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#3DataTransformation'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Data transformation',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#4ValueIssues'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Value issues',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#5MissingData'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Missing data',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '#6NondigestibleFormats'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Non-digestible formats',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Keep reading to find out what’s causing these problems and what CS leaders can do about them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Common data onboarding challenges and use cases',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '1. Assisted data onboarding by implementation or support teams',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you have customers using your software applications, loading those apps with data is a necessary first step before customers can get any value from your software or service. For enterprise applications, support, customer success or implementation teams often help customers securely and efficiently collect, import, transform and customize their data to integrate it into their specific environment. Delayed or complicated processes will affect your users’ ROI, decrease customer satisfaction and, in some cases, can cause customer churn. Providing the means to effectively onboard data during implementation projects is a critical first step toward making sure your customers will derive the most value from your software or service.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '2. Self-service data onboarding via file import by end users',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "If you have applications where customers, partners, prospects, employees or vendors can upload data files via self-service, you’ve probably encountered delays, errors and complaints from users. Unfortunately, if those users can’t complete the simple task of importing their data files, they will almost certainly leave and won't return.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '3. Data onboarding for internal use',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Getting a normalized view of your data can be tough. Data from external and internal systems needs to be shared seamlessly, which often involves emailing Excel files back and forth over long periods for review and data cleanup. This process almost always introduces data errors, versioning issues, time delays and frustration. Also, sharing CSV and Excel files via email carries enormous data privacy and security risks - team members need to be able to send and receive data through a safe and secure process and not rely on email for sharing data files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '4. Data onboarding and ongoing data feeds',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You might need to collect data from partners, agents or remote employees or aggregate data from remote departments or divisions. These files could be emailed, dropped into a shared folder or sent via FTP. Some might be ready for a seamless import into a system or database, but more often, they require you to dedicate resources to a mapping, formatting, cleaning and review process before you can combine them with other data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The human factor',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Making sure that the right people with the right access control manage the right data at the right time is critical. There’s a good chance you need to orchestrate complicated data workflows and deliver seamless implementation projects, but orchestrating those workflows can be incredibly challenging with the involvement of multiple teams, systems and processes. If, for example, you need to coordinate 122 exhibitors, 17 external vendors and 11 different teams that are working on 37 separate Excel files, you would need an intricate workflow for importing, validating, editing and approving data with complex transformations to split, combine and merge data easily. Users can't be expected to have technical skills or read lengthy instructions. They need to be able to upload a file, look through it, fill in any blanks, make simple mapping decisions and move on. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In addition to those four use cases and their respective challenges, there are also data-specific issues that can make life more difficult for CS leaders and their teams. What are they? Keep reading to find out.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'What data issues can cause problems for CS leaders during onboarding?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The most common challenges that CS leaders may need to address and resolve when dealing with data during onboarding are:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '1. Large file size',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A file provided by a customer for data onboarding, such as spreadsheet or CSV file, is often too big, which can be the result of too many fields, records, columns, or rows in the file. This typically triggers import errors which may be caused by limits set by the program using the file or lack of available memory on the systems.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '2. Source to target mapping',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Columns that don't match expected field names, which can be caused by different values, field names not on the first line, or the complete absence of column names, cause errors. Mapping errors can occur when the expected columns are in the wrong order or required columns are missing. Another common problem is the existence of multi-row field names that bury the actual data under a secondary header. Merged cells can also hamper the process of mapping the source data in a file to the desired target format.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '3. Data transformation',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data transformation is the process of converting data from one format, structure, or system to another, which is often necessary when integrating data from diverse sources during the onboarding process. Some of the possible challenges CS teams might face include inconsistent schemas, diverse formats, complex transformation and validation rules, and numerous data quality issues like missing values, duplicates and inaccuracies.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '4. Value issues',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data value issues can be a major cause of data errors during the data onboarding process. Value issues can be caused by unacceptable characters, like text in a numbers-only column, for example, or numbers in a boolean (a data type with two possible values: true or false). Other value issues include having related fields with conflicting data, such as records with multiple types of unique identifiers when only one is allowed. For example, the city/state names differ from their actual zip code or even a related field without required data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '5. Missing data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Missing data is one of the most common errors. Examples include incomplete data like invoices that have month and day but no year or missing city/state data with zip codes present. Any required value that is missing will trigger an error, block the next step and require manual intervention.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '6. Non-digestible formats',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These include simple format mismatches that need format normalization, such as phone numbers or social security numbers, which are numbers only without symbols. For example, “July 31st 2020” or “June twentieth 19.” Charts and pivot tables also can’t be imported.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Minimizing these errors can be a time-consuming process and highlights the challenges of the data onboarding process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How data exchange can help',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Fortunately, a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/guides/the-missing-piece-in-enterprise-integration/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data file exchange solution',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' can help teams resolve these common issues and safely and efficiently onboard the data your customers and users need. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' provides highly customizable automation and advanced data collection, mapping, transformation and validation capabilities, as well as ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'AI-powered features',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' that will speed up your customer onboarding process This enables CS leaders to deal efficiently with all of the real-world data that customers have.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Want to learn more about how Flatfile can accelerate and simplify your data onboarding processes? ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Book a demo with a Flatfile expert',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' today.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6wp2qwIqga7AnYQNKx80Gt',
    postTitle: '6 ways implementation teams can conquer data migration',
    seoTitle: '6 ways implementation teams can conquer data migration',
    seoUrlSlug: '6-ways-implementation-teams-can-conquer-data-migration',
    seoMetaDescription:
      'Data migration can be exhausting! Find out how implementation teams can streamline, simplify and conquer the data migration process.',
    category: 'Data exchange',
    tags: ['Data exchange', 'Data migration', 'System integrators', 'SIs'],
    sortOrder: '1',
    publishDate: '2024-06-28T10:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'H9h9Zne8yfRHUnR94reqq',
        type: 'Asset',
        createdAt: '2024-06-28T17:17:01.490Z',
        updatedAt: '2024-06-28T17:19:17.502Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title:
          'How implementation teams can improve their data migration processes ',
        description:
          '"How implementation teams can improve their data migration processes" with icons representing data migration',
        file: {
          url: '/img/contentful/H9h9Zne8-how_implementation_teams_can_improve_their_data_migration_processes.webp',
          details: {
            size: 75426,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'How implementation teams can improve their data migration processes.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"How implementation teams can improve their data migration processes" with icons representing data migration',
    summary:
      'Data migration can be exhausting! Find out how implementation teams can streamline, simplify and conquer the data migration process.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2OLDFXCe9O2bpoGter4iKH',
        type: 'Entry',
        createdAt: '2024-03-21T21:52:22.900Z',
        updatedAt: '2024-03-25T15:20:51.027Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Mike Denenberg',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1dAGwehVaaMDlSePbwerxY',
            type: 'Asset',
            createdAt: '2024-03-21T21:52:10.438Z',
            updatedAt: '2024-03-21T21:52:10.438Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'mike',
            description: '',
            file: {
              url: '/img/contentful/1dAGwehV-dberg.webp',
              details: {
                size: 143353,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'dberg.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Enterprise Account Executive'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data migration isn’t easy, but it’s necessary for any organization that wants to upgrade its systems, consolidate data or move to new platforms. Implementation teams and System integrators (SIs) know all too well that ensuring a seamless data migration is critical for maintaining data integrity, minimizing downtime and ensuring business continuity.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Unfortunately, implementation teams often face a number of frustrating moments during the process that can impact the success of the migration. If they aren’t ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'addressed effectively',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', these pain points can have numerous business implications.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The pain of data migration',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'During migration, companies sometimes experience delays, reduced data availability or disruptions to regular workflows, which can significantly impact productivity and customer service.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies rely heavily on their systems to carry out daily operations, and any prolonged delays can have severe consequences. Implementation teams strategize ways to minimize delays and ensure a smooth transition without disrupting business activities.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies can’t cut over to a new system until they know that system is going to run seamlessly. If migration is delayed and the target cutover date can’t be realized, the company will be forced to continue running on the legacy system longer than expected, causing enormous disruptions and forcing teams to adjust everything from timelines and resource allocation to user expectations. Because of these possible complications, implementation teams need to carefully plan the migration process to minimize delays and ensure a smooth transition.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Preparing for data migration, implementation teams can feel like they’re burning hours, going back and forth with people who know the old system and team members with varying degrees of technical proficiency who have or understand specific data needs. They need to practice the migration with the old system still running, deal with the data that’s still changing until the cutover point, get everything ready for cutover, rerun everything repeatedly and finally get the data to the right place. It’s exhausting!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But what if it didn’t have to be that hard? What if teams could easily bring in old data, take a look at it and not only fix it, but ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'use tools like AI to fix it much more easily',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' than ever before? What if they could efficiently and securely collaborate across teams and easily share data for better and simpler communication?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Projects would be ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'faster and less expensive',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', demand on resources would be reduced, implementation teams could be better organized, companies could have happier customers eager to do more with them and teams could move on to their next projects faster.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How implementation teams can streamline data migration',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Implementation teams need to be able to navigate the challenges and complexities of the migration process with precision and expertise. Fortunately, there are solutions available that allow any company to safely and efficiently migrate data from legacy databases, systems or files. Even if that data arrives in a wide variety of formats that all need mapping, review, cleanup and validation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are the key areas in which implementation teams can streamline, simplify and conquer the data migration process:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#dataMappingAndTransformation'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Data mapping and transformation',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#dataQualityAndValidation'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Data quality and validation',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#securityAndCompliance'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Security and compliance',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#collaborationAndCommunication'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Collaboration and communication',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#automation'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Automation',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#ai'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'AI',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data mapping and transformation',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the biggest stumbling blocks teams encounter during data migration is the complexity and diversity of data structures and formats. Different systems may use disparate data models, schemas and formats, making it difficult to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'accurately map and align the data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. This makes it hard to preserve the integrity and usability of the data in the new environment.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'An automated and intelligent solution for data preparation and migration can provide a framework and appropriate engine to retrieve data stored in varying formats (including proprietary databases, files or legacy systems) and transform and map it to fit the schema of the target system seamlessly. This transformation process requires careful planning and execution to avoid data distortion or loss of essential information.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data quality and validation',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the primary pain points for implementation teams during data migration is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ensuring data integrity and consistency',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. When moving data from one system to another, especially when dealing with large volumes of information, there’s a risk of data errors, loss or misalignment. Maintaining the accuracy and reliability of the data throughout the migration process is critical, and any discrepancies can have far-reaching implications for the organization.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data quality is a critical concern. Over time, data in the old system may have become outdated, redundant or inconsistent. Implementation teams need to clean and standardize the data before migrating it to the new system to ensure that poor-quality data doesn't compromise the new system. This data cleaning and validation process can significantly prolong the timeline. However, similar to mapping and transformation, intelligent automation can vastly improve and accelerate the migration process by automating the many repetitive tasks, identifying and rectifying data errors automatically and flagging issues for manual review.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Security and compliance',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data security and compliance can present even more obstacles. Implementation teams must uphold data privacy regulations, prevent unauthorized access and secure data during transit and at rest. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/annual-soc-2-type-ii-audit-complete/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Compliance with industry standards',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' like GDPR and HIPAA adds layers of complexity to data migration initiatives and requires strict measures to safeguard sensitive information.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A comprehensive, enterprise scale solution for data preparation and migration will be designed from the ground up to support appropriate data security and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/annual-soc-2-type-ii-audit-complete/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'compliance with industry standards',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', ensuring that sensitive data is protected during the migration process. This is critical for any team working with sensitive or regulated data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Collaboration and communication',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Besides technical challenges, effective communication and collaboration with stakeholders are also crucial for successful data migration. The constant back-and-forth with team members familiar with the old system and those familiar with specific segments of the data (who may or may not have deep technical knowledge) can be a significant drain on resources.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Real-time collaboration can be a definite advantage when working with complex data sets or multiple stakeholders. A data migration solution may offer enhanced collaboration across teams and diverse stakeholders as well as capabilities like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/keep-teams-aligned-with-shared-views/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'shared views',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', which is the easiest way to literally and figuratively keep your team on the same page while discussing a specific segment of data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Some solutions also take advantage of critical data security principles like Zero Trust collaboration, which implements a "never trust, always verify" model to ensure secure data sharing and manipulation across multiple users.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Automation',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Automation helps organizations streamline complex workflows by reducing or eliminating repetitive tasks and ensuring data integrity throughout the entire data migration process. It can help implementation teams automatically enforce consistent formats and structures, identify errors, quickly transform vast amounts of data and identify and provide integrations with external data sources.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By leveraging a solution that offers automation, implementation teams can streamline and accelerate the data migration process even more successfully. Automation can reduce manual effort, minimize errors and ensure that data is accurately and efficiently transferred from the old systems to the new one.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'AI',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AI unlocks entirely new possibilities in the data migration process that can improve efficiency, user experience and data quality dramatically. Some of the ways AI can improve the data migration process include enhanced data mapping, highly automated data cleaning, transformation and validation and a much more powerful user experience..',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'From real-time, context-aware guidance to natural language search that can understand queries in plain English, AI can make complex data migration tasks surprisingly simple. It can assist in data cleaning by automatically identifying and fixing inconsistencies, errors and missing values, learning from patterns in your data. It can also help to automate the process of validating information against predefined rules, ensuring accuracy and reliability. It’s a transformative force for optimizing processes.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data exchange: The future of data migration',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The evolving nature of technology and software systems is a major factor in the complexity of data migration. Migrating data from an old system to a new one demands careful planning, execution, and follow-up. By taking advantage of a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " solution that is specifically designed to support complex data preparation and migration processes, implementation teams can ensure a successful data migration, minimizing risks and maximizing the new system's benefits for the organization.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'The Flatfile Data Exchange Platform',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is designed to enhance efficiency, data accuracy and communication during the data preparation and migration process. By providing highly customizable automation and advanced data collection, mapping, transformation and validation capabilities, as well as ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/introducing-ai-transform-your-data-transformation-copilot/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'AI-powered features',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that will speed up your data migration process, Flatfile can help teams deal efficiently with all of the real-world migration challenges they face.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To learn how you can improve your data migration process, accelerate your implementation projects and significantly reduce project cost, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'contact Flatfile today',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6HIqvj4ME90ORiwX37naXh',
                type: 'Entry',
                createdAt: '2024-01-12T01:19:47.604Z',
                updatedAt: '2024-07-30T23:58:59.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 32,
                revision: 7,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Watch Flatfile in action',
                text: 'We can help you spend 70% less time onboarding data. Discover how',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '4IKuxGZKxVBN2uA8xpKoq0',
    postTitle: 'Data onboarding essentials for customer success executives',
    seoTitle: 'Data onboarding essentials for CS executives',
    seoUrlSlug: 'data-onboarding-essentials-for-customer-success-executives',
    seoMetaDescription:
      'By improving the data onboarding process, CS leaders can reduce costs, accelerate revenue and increase customer satisfaction.',
    category: 'Data exchange',
    tags: ['Customer success', 'data onboarding', 'data exchange', 'CS leader'],
    sortOrder: '4',
    publishDate: '2024-06-21T08:55-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GGaM18DWuk11WrkPBgaA3',
        type: 'Asset',
        createdAt: '2024-06-21T15:41:14.292Z',
        updatedAt: '2024-06-21T15:51:04.804Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Successful data onboarding for CS leaders',
        description:
          '"Successful data onboarding for CS leaders" with icons representing improved results from successful data onboarding',
        file: {
          url: '/img/contentful/2GGaM18D-blog_successful_data_onboarding_for_cs_leaders.webp',
          details: {
            size: 53630,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog_Successful data onboarding for CS leaders.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Successful data onboarding for CS leaders" with icons representing improved results from successful data onboarding',
    summary:
      'By improving the data onboarding process, CS leaders can reduce costs, accelerate revenue and increase customer satisfaction.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'bz1819JFLCzgCuaIcgEt2',
        type: 'Entry',
        createdAt: '2024-06-21T15:44:13.272Z',
        updatedAt: '2024-06-21T15:44:13.272Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Andy Feldman',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5kR6u3INP8RxJ2Zb1RYOw9',
            type: 'Asset',
            createdAt: '2024-06-21T15:44:02.737Z',
            updatedAt: '2024-06-21T15:44:02.737Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'andy-feldman-headshot',
            description: 'Andy Feldman headshot',
            file: {
              url: '/img/contentful/5kR6u3IN-andy-feldman-headshot.webp',
              details: {
                size: 351466,
                image: {
                  width: 493,
                  height: 502
                }
              },
              fileName: 'andy-feldman-headshot.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Customer Success Manager'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As a Customer Success (CS) leader, the last thing you want to do is implement an onboarding process that your customers hate. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Successfully navigating the data onboarding process is an important part of ensuring a positive first impression. The challenge of taking in user data from external sources — data onboarding — is a critical first step in the overall customer experience, and by improving the data onboarding process, you can reduce costs, accelerate revenue and increase customer satisfaction.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '20jamk5zaD8c7M4sOLK5GY',
                type: 'Entry',
                createdAt: '2024-06-04T16:02:34.659Z',
                updatedAt: '2024-07-30T23:58:59.565Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Data onboarding shouldn't hurt",
                text: 'Download our free guide to discover how CS leaders can address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download now',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What is data onboarding, and how does it affect your company?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data onboarding, sometimes referred to as "data import," "data collection," "data migration," or "data exchange," is the process of uploading your customer\'s required data to your product. The process must be complete for your customer to use the product and begin to experience its benefits. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you already know what data onboarding is, you’re probably also familiar with at least a few of the things that can go wrong when onboarding data…',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you have customers, prospects, employees, partners or vendors that need to supply data before they can effectively use and derive value from your product or service, you’ve probably encountered time delays, errors and complaints. Unfortunately, customers who encounter roadblocks and a lot of run-arounds in getting their software or service up and running will probably leave and not return.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That required data could come from a previous software vendor or a legacy database or it might reside in spreadsheets or a whole range of other applications or files. Getting that data in shape for your product almost certainly requires complicated data mapping, review, cleanup and validation, and might even need human oversight before it can be imported into your new target system. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "When it isn't handled correctly, onboarding data can become a long and painful process.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Why is data onboarding such an important topic for customer success leaders?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The data onboarding process has become more important as data has become a frequently exchanged currency. Companies in nearly every industry require data onboarding, from healthcare to manufacturing.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'HR solutions require comprehensive data on employees, benefits and payroll before the can be effectively used for automating HR processes',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Ecommerce providers need product and pricing details from their merchants and suppliers before they can include these products in their offering',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Service providers like cleaning or maintenance services need facilities information and other service requirements before they can send out crews and start billing their clients',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'CRM platforms need customer data like contact information or customer history before they can be used by a sales team',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Not only do many companies have products and services that require data as a starting point, but that required data can be incredibly complex. While CS leaders frequently need to migrate data into a product, the scale, scope and timing of the data onboarding process can vary greatly. For some companies, it might encompass the first two weeks of the customer relationship. For others, the process of collecting, mapping, transforming, reviewing and cleaning data can go on for months.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How CS leaders can improve the data onboarding process',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One of the simplest and most effective ways of improving the onboarding process is by taking advantage of a data file exchange platform like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ", which is designed to help you build the ideal data onboarding experience. It's a collaborative, secure platform that helps companies speed up every part of data collection and onboarding.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Its comprehensive data onboarding solution is based on a developer-friendly platform that supports highly customizable automation and advanced data collection, mapping, transformation and validation capabilities, as well as AI-powered features that will speed up your customer onboarding process. Even if your customer’s files look different from customer to customer, arrive in a wide variety of formats and need manual mapping, review, cleanup and validation before they’re imported, Flatfile can help CS leaders deal efficiently with all of the real-world data onboarding challenges that customers have. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'If you want to dig deeper into how CS leaders can improve their data onboarding processes, download your free copy of our in-depth guide, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'The CS leader’s guide to successful data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You spent the time, energy, and resources to acquire a new customer. If you can help them find value quickly and easily, your team will have a much easier time of keeping that customer for life, and you’ll have a customer onboarding experience that will set your software apart from the competition.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3rbmL4Yhum5nehYNWvvkJJ',
    postTitle: '4 ways CS leaders can tackle data chaos in customer onboarding',
    seoTitle:
      '4 key ways CS leaders can tackle data chaos in customer onboarding',
    seoUrlSlug: '4-key-ways-cs-leaders-tackle-data-chaos-customer-onboarding',
    seoMetaDescription:
      'By improving the customer onboarding process, customer success leaders can reduce costs, accelerate revenue and significantly increase customer satisfaction.',
    category: 'Data exchange',
    tags: [
      'Customer success',
      'Data onboarding',
      'Customer onboarding',
      'Data exchange',
      'CS leader'
    ],
    sortOrder: '5',
    publishDate: '2024-06-13T08:11-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7iQBoYlp9RS4Bow8alinqh',
        type: 'Asset',
        createdAt: '2024-06-13T03:28:35.205Z',
        updatedAt: '2024-06-13T03:28:35.205Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'How CS leaders can tackle data chaos in customer onboarding',
        description:
          '"How CS leaders can tackle data chaos" with icons representing data chaos transformed into an orderly spreadsheet',
        file: {
          url: '/img/contentful/7iQBoYlp-how_cs_leaders_can_tackle_data_chaos.webp',
          details: {
            size: 59385,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'How CS leaders can tackle data chaos.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"How CS leaders can tackle data chaos" with icons representing data chaos transformed into an orderly spreadsheet',
    summary:
      'By improving the customer onboarding process, customer success leaders can reduce costs, accelerate revenue and significantly increase customer satisfaction.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3CihjjFSaXut3Hb9eI0XVM',
        type: 'Entry',
        createdAt: '2021-10-28T15:29:06.628Z',
        updatedAt: '2021-10-28T15:29:06.628Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Becca Weiss',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1BLXrFTRCL0lKeEq9FSYym',
            type: 'Asset',
            createdAt: '2021-10-28T15:28:39.305Z',
            updatedAt: '2021-10-28T15:28:39.305Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Becca Weiss headshot',
            description: 'Becca Weiss headshot',
            file: {
              url: '/img/contentful/1BLXrFTR-197-0-4.webp',
              details: {
                size: 31079,
                image: {
                  width: 170,
                  height: 170
                }
              },
              fileName: '197-0-4.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Director of Customer Success & Implementation',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Poor customer onboarding will cost your company more than you think. Not only can it lead to reduced time to value, but it can also damage your customers' trust in the company and lead to opportunity costs for customer success (CS) teams, who have to dedicate valuable time to managing onboarding issues.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'CS leaders know that any software application that requires data ingestion comes with a serious challenge to user satisfaction: ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/why-customer-success-leaders-hate-their-customer-onboarding-processes/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Customer onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ". Successfully navigating the onboarding process is critical for ensuring a positive first impression, and glitches and delays from poor onboarding can derail a new relationship before it's even begun.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'By improving the customer onboarding process, companies can reduce costs, accelerate revenue and significantly increase customer satisfaction.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data might come from a previous software vendor, a legacy database, or live in spreadsheets and other ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'applications or files',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Getting that data in shape will almost certainly require complicated data mapping, review, cleanup and validation, and you may even need human oversight before it can be imported into your new target system. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Not only do many companies have products and services that require data, but this data is often complex. While CS leaders are familiar with migrating data into a product, the scale, scope and timing of the data onboarding process varies greatly for each company. For some, the process of collecting, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'mapping',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'validating',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', transforming, reviewing and cleaning data can go on for months. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '20jamk5zaD8c7M4sOLK5GY',
                type: 'Entry',
                createdAt: '2024-06-04T16:02:34.659Z',
                updatedAt: '2024-07-30T23:58:59.565Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Data onboarding shouldn't hurt",
                text: 'Download our free guide to discover how CS leaders can address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download now',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How does data chaos happen during onboarding?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data chaos is the web of confusion and missed opportunities due to the quality of your data across sources with high variance that becomes so unmanageable that it can derail your customer onboarding strategy and even cause customer churn. That problem can be exacerbated in the face of unstructured data, large volumes of data and data not stored in a meaningful or useful way.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "These problems, especially when combined with lackluster data management practices or outdated technology, leads to the chaos that can create a negative experience for new customers, both those who need to onboard their own data and those who expect white glove service from the customer success team. We've all experienced data chaos at some point in our careers, and some of us have to deal with it monthly or even weekly.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But data chaos can cause an incredible amount of pain and frustration during the customer onboarding process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Signs you're experiencing data chaos during customer onboarding",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Not sure if your organization has this common ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'customer data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' problem? Look for these sure signs:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "The customer success team's process for onboarding customer data looks different every time",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'It sometimes takes extra weeks to onboard new customers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "Customers love your product, but you've gotten negative feedback about your customer onboarding process and time to value",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Top risks of data chaos during customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '72% of companies surveyed by Forrester said ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.forrester.com/press-newsroom/72-of-businesses-name-improving-customer-experience-their-top-priority/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'customer experience is their top priority, and',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' for good reason. According to Harvard Business Review, acquiring a new customer tends to be ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://hbr.org/2014/10/the-value-of-keeping-the-right-customers'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: '5 to 25 times more expensive',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' than retaining an existing customer. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Without customer onboarding tools and processes in place to dispel the data chaos, organizations risk frustrating the new customers they should be impressing, which can result in immediate churn. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Even when contracts are in place, customers may be unsettled if there are any headaches or slowdowns in the data onboarding process as part of the broader customer onboarding. They might feel swayed by competitors who can back up their promises of fast and easy onboarding with proof of their superior processes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1bHDOi1KLNuK9wFHMxMYtH',
                type: 'Asset',
                createdAt: '2024-06-13T03:38:00.800Z',
                updatedAt: '2024-06-13T03:38:00.800Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'successful customer onboarding',
                description:
                  'Icons representing multiple data file types being successfully imported into a spreadsheet',
                file: {
                  url: '/img/contentful/1bHDOi1K-not-highlighted.webp',
                  details: {
                    size: 33443,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'not-highlighted.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Tools and techniques that prevent data chaos during customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "From marketing and sales to inventory management to HR to product development, there are thousands of software applications and SaaS tools that can't offer any value until their customers' data is ready to use.  When customers come to you — yes, especially enterprise customers — their data chaos becomes your problem. You need to offer a structured process for wrangling and utilizing their critical datasets. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Some aspects of data onboarding invariably fall on your customers' shoulders. After all, you don't have access to all their systems. However, you can give them a roadmap for the data they need and offer technical solutions to minimize the manual effort required.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What are four key tips for preventing data chaos during customer onboarding?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Create a collaborative space for customers and CSMs',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Make the onboarding process easy for your customers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Effectively communicate with customers about data requirements',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Make sure the CSM is well-trained in handling data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data onboarding tip 1: Create a collaborative space for customers and CS leaders',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Emailing spreadsheets with data and providing lengthy instructions for a manual process are not effective ways to work with customers through the data onboarding process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "These methods aren't trackable or clear to understand. For the same reason that project managers use task management tools to assign tasks instead of communicating via email, CSMs shouldn't communicate using this outdated method either. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Instead, look for a collaborative data onboarding platform that offers a central space to collaborate on data, fix issues, transform data, review changes and approve them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/projects/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', for example, offers the following features to CSMs who want to uplevel the experience they deliver to customers during the onboarding phase:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Secure team-specific, multi-user collaboration space',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Built-in data checklists',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Granular access control',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Auto source-to-target column mapping trained on millions of mapping decisions',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Powerful AI-powered data transformations, including preview AI-powered changes with inline-diff view',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Collaborative data editing',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Secure data sharing',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data version history',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data onboarding tip 2: Make it easy for your customers',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Working with customers isn’t a one-size-fits-all situation. Not only do they have varying levels of expertise and comfort with the onboarding process, but they often provide data in all shapes and sizes, whether they’re bringing CSV, XLS, PDF or other types of files, or even images. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When your customer has a wide variety of file types from numerous sources, having a solution in place that’s designed to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/projects/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'simplify and streamline the onboarding process',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' can be a game changer. If you can automate everything possible, allow for manual intervention when necessary, and provide smart tooling that makes the review process fast and easy, you’ll be able to offer a customer onboarding experience that builds trust and confidence.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data onboarding tip 3: Effectively communicate with customers about data requirements',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Communication is critical. You need to know what customer data is required to enjoy full use of your platform, what data is desirable to help your customers avoid internal issues with knowledge sharing, data utilization, and data silos, and what data is simply a "nice to have" but isn\'t a high priority.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Apply your knowledge of the industry and the data that matters to what you know about your customers' businesses to determine the data requirements.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can assign these to customers in phases based on the priority level and know which customer contact is in charge of which data source or have a single point of contact who can point you in the right direction. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/projects/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'collaborative data onboarding workspace',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is ideal for this. You can use this space to assign the right data requirement to the right person with the right deadline.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data onboarding tip 4: Make sure the CS team is well-trained in handling data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Dealing with your customers' data chaos is even more complicated than dealing with your own because it's not your data; you might not be familiar with it. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'CS teams who want to go above and beyond for their customer accounts during onboarding need to be experts in data handling and onboarding. As a team, you can create dummy data to work with to avoid jeopardizing customer data during training. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Focus your training on the type of data that yields success for customers, the format the data should be in, and handling any issues that arise during the data onboarding process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A dedicated solution for data onboarding can make this responsibility easier on your team by minimizing the required manual work. Your solution should handle collecting the data, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data mapping',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data validation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', data transformation, and data conversion but CS teams still need to be trained in helping customers collect and prepare the data and make sure they can use it successfully in their new application.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Take care of data security and data privacy',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "When it comes to touching your customers' data, security and privacy need to be top priorities.  Make sure to only exchange data with customers in a secure environment. Your collaborative workspace should have built-in security mechanisms like authentication and verification. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data from external and internal systems needs to be shared, which typically involves emailing Excel files back and forth over long periods of time for review and data cleanup. This process nearly always introduces data errors, versioning issues, time delays and frustration. Additionally, team members sharing data files via email carries enormous data privacy and security risks - they need to be able to send and receive data through a safe and secure process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "As companies create more and more data, the need for moving data from sources with a high degree of variance in structure and quality to an enterprise application isn't going away. What matters is having the right technology and systems to help your customers deal with it so they can successfully use your product - sooner rather than later!",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'By leveraging the ideal solution for your use case and requirements, you can avoid the costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'complicated workarounds',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ". If you're trying to deal with the data chaos at your organization, Flatfile has helped hundreds of companies tackle their data onboarding and migration challenges, supporting many use cases and data requirements. Reach out and ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'connect with one of our data experts',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to find out how Flatfile can help you address your customer onboarding needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '12gSoLovmstnbaINOv1Rdb',
    postTitle:
      'How customer success leaders can successfully navigate data onboarding',
    seoTitle:
      'How customer success leaders can successfully navigate data onboarding',
    seoUrlSlug: 'how-cs-leaders-successfully-navigate-data-onboarding',
    seoMetaDescription:
      'What do CS leaders need to know in order to implement successful data onboarding processes? This in-depth guide has the answers.',
    category: 'Data exchange',
    tags: [
      'Customer success',
      'Data onboarding',
      'Customer onboarding',
      'Data exchange'
    ],
    sortOrder: '3',
    publishDate: '2024-06-12T09:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1bxXEXEh1pEPu2UzalkoU9',
        type: 'Asset',
        createdAt: '2024-06-12T15:57:36.393Z',
        updatedAt: '2024-06-12T15:57:36.393Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'How CS leaders can navigate data onboarding',
        description:
          '"How CS leaders can navigate data onboarding" with an image of the downloadable guide',
        file: {
          url: '/img/contentful/1bxXEXEh-cs_leader-s_guide_announcement.webp',
          details: {
            size: 56391,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'CS leader-s guide announcement.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"How CS leaders can navigate data onboarding" with an image of the downloadable guide',
    summary:
      'What do CS leaders need to know in order to implement successful data onboarding processes? This in-depth guide has the answers.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Don't let your data onboarding process derail your new customer relationship before it's begun!",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The challenge of taking in user data from external sources is a critical first step in the overall customer experience. Customer success (CS) leaders today know that any software application that requires data ingestion comes with a unique obstacle to user satisfaction: Data onboarding. Successfully navigating the data onboarding process is critical for ensuring a positive first impression. Glitches and delays from poor onboarding processes can derail a new relationship before it’s even begun.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But what exactly do CS leaders need to know in order to implement successful data onboarding processes? This in-depth guide has the answers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '55DMNhuHv7Ed48oWdoS3Jj',
                type: 'Asset',
                createdAt: '2024-05-31T16:12:57.611Z',
                updatedAt: '2024-06-03T23:23:06.297Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 15,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: "CS leader's successful data onboarding guide",
                description:
                  "Images from the guide: The Customer Success Leader's Guide to Successful Data Onboarding",
                file: {
                  url: '/img/contentful/55DMNhuH-cs_leader-s_data_onboarding_guide_thumbnail.webp',
                  details: {
                    size: 189518,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'CS leader-s data onboarding guide Thumbnail.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Successful data onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Download your free copy of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value:
                    'The Customer Success Leader’s Guide to Successful Data Onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' to dive deep into:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The challenges inherent in the data onboarding process and why migrating data can be so complex',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'How data onboarding challenges significantly impact your team and your customers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'How you can streamline the onboarding process',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "When it isn't handled correctly, onboarding data can be painful for both your customers and team members. By improving the process, customer success leaders can reduce costs, accelerate revenue and significantly increase customer satisfaction. Download this in-depth guide to find out how CS leaders can address data onboarding challenges and help new customers become customers for life.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5sfpwnkjekd2chMcnjS3Ad',
    postTitle: 'The beginner’s guide to data validation',
    seoTitle: 'Beginner’s guide to data validation',
    seoUrlSlug: 'the-beginners-guide-to-data-validation',
    seoMetaDescription:
      "Data validation can help you ensure your data is accurate, consistent and reliable. Find out how it works and why it's critical for businesses today.",
    category: 'Data exchange',
    tags: [
      'Data validation',
      'Data exchange',
      'Data import',
      'Data management'
    ],
    publishDate: '2024-06-04T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '72EVIIDEK6WEe3rqZrEDd9',
        type: 'Asset',
        createdAt: '2024-06-04T03:17:27.559Z',
        updatedAt: '2024-06-04T03:17:27.559Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data validation',
        description:
          '"What is data validation?" on a white background with lines and checkboxes',
        file: {
          url: '/img/contentful/72EVIIDE-data_validation.webp',
          details: {
            size: 33139,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Data validation.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"What is data validation?" on a white background with lines and checkboxes',
    summary:
      "Data validation can help you ensure your data is accurate, consistent and reliable. Find out how it works and why it's critical for businesses today.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Can you trust your data?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data validation isn't just about accepting data; it's about making sure your data is trustworthy, consistent and aligned with your standards. Having strong data validation processes in place is like having an incredibly meticulous gatekeeper who checks every single piece of data ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'entering your system',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'By the end of this article, you’ll know:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#whatIsDataValidation'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'What is data validation?',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#whyIsDataValidationImportant'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Why is data validation important?',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#whatDoesDataValidationDo'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'What does data validation do?',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#whatStepsAreInvolvedInDataValidation'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'What steps are involved in data validation?',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#bestPracticesInAction'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Best practices in action',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#whatHappensIfYouSkipDataValidation'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'What happens if you skip data validation?',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#whoUsesDataValidation'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Who uses data validation?',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '#youDontHaveToDoThisYourself'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "You don't have to do this yourself",
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can conquer data validation issues and accelerate your data workflow? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your data challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'aNkln4W8HtnvwIjRaO4ra',
                type: 'Asset',
                createdAt: '2024-06-04T03:33:39.970Z',
                updatedAt: '2025-03-31T16:58:47.476Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 4,
                locale: 'en-US'
              },
              fields: {
                title: 'data validation',
                description: 'An image of data validation at Flatfile',
                file: {
                  url: '/img/contentful/aNkln4W8-data_validation.webp',
                  details: {
                    size: 81534,
                    image: {
                      width: 718,
                      height: 400
                    }
                  },
                  fileName: 'data_validation.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is data validation?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Businesses rely on data to make informed decisions and gain a competitive edge, but the volume of data being generated and processed today ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'presents a challenge',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ': Ensuring that data is trustworthy. Data validation is the process of verifying the accuracy, consistency and reliability of data. It involves checking data against predefined criteria to ensure it meets quality requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data validation works like a series of checkpoints along a data journey. At each checkpoint, data undergoes scrutiny, with validation rules acting as the criteria for acceptance or rejection. These rules can cover everything from basic data types (like numbers or dates) to complex business logic that dictates what's valid and what isn't.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why is data validation important?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Why does data validation matter so much? Well, imagine you have sales reports that are riddled with duplicate entries, incorrect figures, formatting problems and missing information. If you went ahead and made decisions based on that kind of flawed data, you’re probably going to be facing missed forecasts, lost opportunities and bad business plans.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It's not just about having data; it's about having the right data — the kind you can trust to ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'steer your business in the right direction',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. Data validation turns your data into a reliable compass that guides you toward informed decisions and actionable insights.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data validation ensures that the data you collect, process, and analyze isn't just a jumble of numbers and letters but a coherent, reliable narrative that ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/secret-to-modernizing-your-data-stack/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'informs your decisions and actions',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'It helps you ask the right questions of your data, like:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Is this data accurate and free from errors or discrepancies that could mislead me?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "Does it adhere to the expected format, structure, and standards I've set?",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Is it consistent across different sources?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Does it align with the business rules and logic that govern operations and strategies?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By using data validation to answer these questions, you can transform your data from a bunch of information into a trustworthy and reliable asset.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data validation is crucial for:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data accuracy:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Validating data ensures that it is reliable and free from errors, inconsistencies, and duplicates. Accurate data forms the foundation for reliable analysis and decision-making.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data integrity:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Validating data helps maintain data integrity by preventing the entry of invalid or inappropriate data, which could compromise the overall quality and reliability of the database or system. It upholds data quality standards, enforces data constraints, and prevents data corruption or loss.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Compliance:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Many industries and organizations have regulatory requirements or standards for data quality and integrity. Data validation helps ensure compliance with these standards and reduces the risk of penalties or legal issues. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Decision-making:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' High-quality data enables organizations to make informed decisions, identify trends, uncover insights and drive business growth.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What does data validation do?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data validation makes sure your data is accurate and consistent. It’s used in databases, spreadsheets, web forms and other software applications, and it ensures that data entered into a system is accurate, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'consistent',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' and meets certain standards. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data validation can check for:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accuracy:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data validation checks for accuracy by verifying that the data is valid and reasonable. For example, it can ensure that a date entered falls within a specific range or that numeric data is in the correct format.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Completeness:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' It ensures that all required data fields are filled in and no essential information is missing. This helps prevent incomplete records or data sets.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Consistency:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data validation ensures that data is consistent across different fields or records. For instance, it can verify that a product code matches its corresponding product name.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Format:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' It checks that data is in the correct format, such as validating email addresses, phone numbers, dates or postal codes to ensure they follow the expected structure.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Rules:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data validation can enforce rules like limits or ranges within a set of defined values. This could include a defined list of colors, for example, which will ensure that values are within acceptable boundaries.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Duplicates:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' It can identify and prevent the entry of duplicate records, reducing redundancy and maintaining data integrity.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What steps are involved in data validation?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'It’s very straightforward! ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data validation typically involves several steps:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Define validation requirements:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Determine the specific validation requirements based on the type of data, business rules, regulatory standards and user expectations. Identify the validation criteria and constraints that data must meet to be considered valid.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data collection:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Collect the data that needs to be validated from various sources, like databases, files, forms or external systems. Ensure that the data collection process captures all relevant information and attributes required for validation.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data cleaning and preprocessing:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Before validation, perform data cleaning and preprocessing tasks to address issues like missing values, duplicates, inconsistencies and data formatting errors.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Select validation methods:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Choose appropriate validation methods and techniques based on the nature of the data and validation requirements. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Implement validation rules:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Implement validation rules and logic to check the data against predefined criteria and constraints. Validation rules may include checks for data type, format, range, length, uniqueness, referential integrity and business rules. Ensure that validation rules are clear and consistent across the data set.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Perform validation checks:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Execute validation checks on the data using the selected validation methods and tools. Validate data at different stages, like data entry, data import/export, data processing and data storage to ensure accuracy and consistency throughout the data lifecycle.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Handle validation errors:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Handle validation errors that occur during the validation process. Provide informative error messages or notifications to users indicating the nature of the validation error and guidance on how to correct the data and implement error-handling mechanisms to prevent invalid data from being processed or stored.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Review and verify results:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Review the results of data validation checks to identify and resolve any issues or discrepancies. Verify that the validated data meets the validation criteria and requirements specified in the first step and conduct data profiling and analysis to assess data quality and identify areas for improvement.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Document validation procedures:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Documenting validation procedures helps ensure consistency and transparency in data validation practices. Document the procedures, rules, outcomes and any corrective actions taken and maintain your documentation for future reference, auditing and compliance purposes. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Monitor and maintain data quality:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Continuously monitor and maintain data quality by regularly performing data validation checks and quality assessments. Implement data governance practices, data quality controls and best practices to sustain high-quality, reliable data over time.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By following these steps, you can establish effective data validation processes that improve data quality, integrity and usability for decision-making and business operations.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Best practices in action',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "This doesn't have to be too complicated. When you're planning your data validation process, imagine implementing these best practices:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Start by understanding your data requirements inside out and setting clear validation goals',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Leverage automation to streamline validation processes',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Handle errors at every step, guiding users toward data accuracy instead of frustration',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Document your validation procedures, creating a trail of accountability and learning',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Regularly monitor your data to keep data quality in check',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What happens if you skip data validation?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Without validation processes in place, you risk making decisions that are based on inaccurate or incomplete data. This will probably lead to increased operational costs, compliance issues and reputational damage.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you skip or make mistakes implementing data validation, you can have problems like:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Inaccurate data: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: "Without validation, there's a higher risk of ",
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.dataversity.net/the-impact-of-poor-data-quality-and-how-to-fix-it/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'inaccurate data',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' entering the system. This can lead to errors in reports and decision-making because they’re based on flawed information',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data integrity issues:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Invalid or inconsistent data can compromise the overall integrity of the database or system. It could cause data conflicts, corruption or other integrity issues that make it unreliable or unusable',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Poor data quality:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data quality deteriorates when validation is lacking. This includes issues like missing values, incorrect formats, duplicates and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.edq.com/blog/the-consequences-of-poor-data-quality-for-a-business/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'incomplete records',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Increased errors:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Without validation checks, errors are more likely to occur. These errors can be much more time-consuming and costly to fix later in the data lifecycle',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Decreased efficiency:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Dealing with invalid or inconsistent data consumes resources and time. It requires manual effort to identify, correct and reconcile data issues',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Compliance risks:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Many industries have regulatory requirements or standards regarding data quality and integrity. Failing to validate data can result in non-compliance, which may lead to penalties, legal issues or reputational damage',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Impact on decision-making:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Inaccurate or incomplete data undermines the reliability of decision-making processes. At the very least, unreliable data can cause you to make flawed decisions and miss opportunities',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Ignoring or neglecting data validation can have far-reaching consequences, affecting data quality, system integrity, operational efficiency, regulatory compliance and ultimately, the ability of an organization to make informed decisions and achieve its goals.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Who uses data validation?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Pretty much anyone who needs to be able to rely on their data! Here are some examples:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data analysts:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data analysts rely on data validation techniques to ensure the accuracy and reliability of the data they analyze. Validated data provides a solid foundation for generating meaningful insights and making data-driven decisions',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Database administrators (DBAs):',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.techtarget.com/searchdatamanagement/definition/database-administrator'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'DBAs',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' are responsible for maintaining database systems and ensuring data integrity. They use data validation methods to enforce data quality standards, prevent data corruption and optimize database performance',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Software developers:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Developers integrate data validation mechanisms into software applications, databases and web forms to validate user input, enforce data constraints and improve overall data quality',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Business users:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Business users, including managers, executives and operational staff, rely on validated data for reporting, performance tracking, forecasting and decision-making. They need accurate and reliable data to support their business activities',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Compliance officers:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.investopedia.com/terms/c/compliance-officer.asp'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Compliance officers',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' ensure that organizations adhere to regulatory requirements and industry standards related to data quality, privacy and security. Data validation is essential for demonstrating compliance and mitigating regulatory risks',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data scientists:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data scientists use data validation techniques in machine learning and data modeling projects as part of the data preprocessing phase. Validated data enhances the accuracy and effectiveness of predictive models and analytical algorithms',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data entry operators:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data entry operators input data into systems or databases. They rely on data validation checks to ensure that the data they enter meets predefined standards and guidelines, reducing errors and improving data quality from the start',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Quality assurance (QA) teams',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ': ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.upwork.com/resources/what-can-a-quality-assurance-qa-team-do-for-you'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'QA teams',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' in software development and data management verify that data validation rules and processes function correctly. They conduct testing and validation procedures to identify and address any issues with data integrity and validation logic',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data validation is a collaborative effort that involves multiple stakeholders, including data professionals, developers, business users, compliance officers and quality assurance teams, to ensure that data is fit for use across the organization.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "You don't have to do this yourself",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If all of this seems overwhelming, remember that you aren't required to implement data validation processes on your own! There are tools and solutions that can handle the data validation process for you, and they often include powerful automations and ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'AI-enhanced features',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that can streamline your entire data integration process. Flatfile, for example, can even help you ensure that data that enters your systems from external sources via data files (e.g., ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-a-csv-file-guide-to-uses-and-benefits/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'CSV',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', XLS, PDF, TXT, XML, etc.) is validated and cleaned before it enters your database. You can rely on a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-ultimate-guide-to-modernizing-your-data-import-solution/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'high degree of automation',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/introducing-ai-transform-your-data-transformation-copilot/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'built-in intelligence',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', and your users and team members can validate, correct and import data with immediate feedback, ensuring high-quality and up-to-date data is available to everyone. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "With Flatfile, validations, transformations and custom actions are all code-based, giving you complete control of how you want your data. You and your users can review, filter and correct data to your desired format and structure with speed and ease. You don't need to worry about accidental alterations; you're in command.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data validation isn't just a technical process; it's a mindset. It's about instilling confidence in every stakeholder who relies on your data, whether executives making strategic decisions, analysts uncovering insights or customers interacting with personalized experiences.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By having strong data validation processes in place, embracing automation wherever possible and monitoring data quality metrics, you can fuel innovation and build resilience in the face of ever-evolving challenges.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile has helped hundreds of enterprise clients (and plenty of scaleups) tackle their data validation challenges, supporting just about any business or data requirement. Reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '4SUcpttpLgQ844IlLWpmmX',
    postTitle:
      'Why customer success leaders hate their customer onboarding processes',
    seoTitle:
      'Why customer success leaders hate their customer onboarding processes',
    seoUrlSlug:
      'why-customer-success-leaders-hate-their-customer-onboarding-processes',
    seoMetaDescription:
      'As a CS leader, the last thing you want to do is implement a data onboarding process customers hate. We explain how to improve your onboarding flow.',
    category: 'Data exchange',
    tags: [
      'Data onboarding',
      'Data exchange',
      'Customer onboarding',
      'Customer success'
    ],
    sortOrder: '4',
    publishDate: '2024-05-24T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5aXy14nwEgyhA90HEeV6Dg',
        type: 'Asset',
        createdAt: '2024-05-24T01:06:17.552Z',
        updatedAt: '2024-05-24T01:06:17.552Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 15,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Why CS Leaders hate their data onboarding processes',
        description:
          '"Why CS leaders hate their data onboarding processes" on a white background with icons representing data onboarding',
        file: {
          url: '/img/contentful/5aXy14nw-why_cs_leaders_hate_their_data_onboarding.webp',
          details: {
            size: 71315,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Why CS Leaders hate their data onboarding.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Why CS leaders hate their data onboarding processes" on a white background with icons representing data onboarding',
    summary:
      'As a CS leader, the last thing you want to do is implement a data onboarding process customers hate. We explain how to improve your onboarding flow.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3CihjjFSaXut3Hb9eI0XVM',
        type: 'Entry',
        createdAt: '2021-10-28T15:29:06.628Z',
        updatedAt: '2021-10-28T15:29:06.628Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Becca Weiss',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1BLXrFTRCL0lKeEq9FSYym',
            type: 'Asset',
            createdAt: '2021-10-28T15:28:39.305Z',
            updatedAt: '2021-10-28T15:28:39.305Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Becca Weiss headshot',
            description: 'Becca Weiss headshot',
            file: {
              url: '/img/contentful/1BLXrFTR-197-0-4.webp',
              details: {
                size: 31079,
                image: {
                  width: 170,
                  height: 170
                }
              },
              fileName: '197-0-4.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Director of Customer Success & Implementation',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Face it: Getting started with new software can be a pain for everyone involved.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Between cookie-cutter onboarding, manual data migration, and emailing sensitive information back and forth, a lot ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'has to go right',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " for a new customer to find value quickly. And you don't want them to feel buyer's remorse.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You know your new customers are asking themselves these questions post-purchase:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Will I get a return on my investment?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Will the product really work the way they say it will?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Will my team see this as helpful or just another step in their day-to-day duties?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "If this doesn't work out, how will it reflect on me?",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As a Customer Success (CS) leader, the last thing you want to do is implement a customer onboarding process that your customers hate.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '20jamk5zaD8c7M4sOLK5GY',
                type: 'Entry',
                createdAt: '2024-06-04T16:02:34.659Z',
                updatedAt: '2024-07-30T23:58:59.565Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Data onboarding shouldn't hurt",
                text: 'Download our free guide to discover how CS leaders can address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download now',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If your onboarding experience looks anything like this, your customers probably can't stand it:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Boilerplate processes that often don’t fit',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Very little flexibility to respond to customer’s unique needs and challenges',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excessive onboarding email back and forth',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Complicated, painful data cleaning steps and requirements',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Onboarding issues',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " like these cause a lot of pain for CS leaders everywhere. If customers hate how they're onboarded, it's unlikely that they'll feel satisfied or stick around for long, and that can cause customer success and implementation teams a lot of frustration.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'So, how can you improve your ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'onboarding flow',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: "? Let's start from the beginning.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you want to learn more about how CS leaders can improve customer experience with a successful data onboarding process, ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'download our free guide',
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' today.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The importance of customer onboarding',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-customer-onboarding'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " is how your new customer is introduced to your product or service. It involves getting comfortable with the new tool, understanding what it does, knowing what buttons to push to make it do what you need it to do, and so on. It's the hand-holding between you and your client.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'SaaS onboarding is a pivotal moment in the customer journey. You have the critical task of building and maintaining a solid relationship. You can do this by showing them value in your product as quickly as possible, and when this happens, it builds trust between you and your customer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "There will be times when a new user may feel overwhelmed or confused. However, the important thing is how you respond to alleviate those concerns as quickly as possible. What's at stake? Well, if a client isn't onboarded smoothly, they won't see the full value of your product or service and are more likely to churn, and your company will have lost valuable time, resources and relationships. Implementing a data onboarding strategy that works means dollars saved and increased revenue for the business.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How to address your customer onboarding process',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "For most business activities, it's important to test, analyze results, and iterate. The same goes for your customer onboarding process — see what's working, what needs work and switch it up.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'First, examine how quickly your customer can move through the onboarding phase and into the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.business2community.com/customer-experience/the-top-5-customer-onboarding-metrics-and-how-to-leverage-them-02196000'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'value-driven adoption phase',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. The timeframe can vary depending on the product or service, company, scope and effort required on both sides, but as a general baseline, you want to aim to keep onboarding under 30 days. Just remember: The quicker your customers see value, the better for everyone.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Next, one of the best ways to measure your onboarding process's effectiveness is simple: ASK. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As a CS leader, it can be very helpful to take the time to ask your customers about their onboarding experience. Customer feedback from simple questions like these can offer valuable insights:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Is it helpful?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What works?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What would they change?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Getting genuine answers to these questions will help you iterate your process and improve.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How to determine any weak points in your customer onboarding process',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Successful customer onboarding requires a clear plan for your new customers that is grounded in your experience of how to get a new customer up and running most effectively. It should include structured plans and guides that help your customers understand what is required. At the same time, as a CS leader you know how valuable it is to discover your customer’s specific goals, pains and problems and help them see how your product can help. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are a few onboarding metrics to help you identify any weaknesses in your client onboarding: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Product adoption',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Consider the speed and volume of usage of your product. Are they using it daily? Have they been using it since day one? These could be indicators of a solid or weak customer experience during onboarding. (Note: A client might already be satisfied with one feature of your product and happy to pay for it. It's your job to surprise and delight them by helping them realize the added benefits of other features so they never leave.)",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Look at CSAT scores',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If your Customer Satisfaction Scores are steadily dropping, you may want to take a look at your onboarding process. Satisfaction starts from the very beginning, and you only get one good first impression. Make it count. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Retention',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "This one's pretty simple: If your customers stick around, they probably had a good experience during onboarding. Sure, there are ways to turn things around after a poor start with your brand, but it's not easy. In general, better customer onboarding leads to more loyal customers and less churn.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Keep it exciting',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One underrated but very valuable thing to keep in mind is the idea of maintaining excitement. A common way that customers lose their excitement is by making them feel like data wranglers. Telling your new customers that to get fully onboarded, they have to not only take the time and effort to collect all the data needed to get the new system up and running, but that they also have to spend the time to get it in exactly the shape that is convenient for you. This can make anyone lose interest fast.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A decision-maker might have some anxiety about rolling out a new product or service, but if you approach it the right way, you can feed off the excitement post-purchase. Remind them what got them pumped about signing the dotted line and show them there's more where that came from.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How to create a customer onboarding process that CS leaders don’t hate  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once you analyze your customer onboarding process, you may find it difficult to implement the necessary improvements, especially at scale. You might need to find the right balance between truly personal one-on-one onboarding and automated processes.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "One way to approach this is to identify frequently asked questions and create guides, downloadable content or videos that answer them. That way, you don't have to type out the same answers over and over again.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Another option is to take advantage of a data file exchange platform like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", which is designed to help you build the ideal data onboarding experience for your use case and requirements. It's a collaborative, secure platform for ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that helps companies speed up every part of data migration, from data submission to cleaning, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'mapping',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', validation and transformation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You spent the time, energy, and resources to acquire a new client. If you can help them find value quickly and easily, your team will have a much easier time of keeping that customer for life, and you’ll have a customer onboarding experience that might set your software apart from the competition.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When it isn't handled correctly, onboarding data can be a painful process for both customers and team members. By improving the process, customer success leaders can reduce costs, accelerate revenue and significantly increase customer satisfaction. ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Download this in-depth guide',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how CS leaders can address data onboarding challenges, reducing costs, accelerating revenue and significantly increasing customer satisfaction.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '5QExYCMctZfMm3uBPpttcR',
    postTitle: 'Developer news: Spring 2024',
    seoTitle: 'Developer news: Spring 2024',
    seoUrlSlug: 'developer-news-spring-2024',
    seoMetaDescription:
      'Our powerful new features help business users, analysts and systems integration teams work on complex data transformations.',
    category: 'Product updates & features',
    tags: [
      'Developer news',
      'Product updates',
      'Features',
      'Shared Views',
      'AI Transform'
    ],
    sortOrder: '2',
    publishDate: '2024-05-14T06:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2wbSB618RXohz0I9qoTnVc',
        type: 'Asset',
        createdAt: '2024-05-08T22:43:17.208Z',
        updatedAt: '2024-05-08T22:43:17.208Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Developer news May 2024',
        description:
          '"Developer news" in white on a black background with a concept illustration of shared views',
        file: {
          url: '/img/contentful/2wbSB618-dev_news_may_2024.webp',
          details: {
            size: 25803,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Dev news May 2024.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Developer news" on a black background with a concept illustration of shared views',
    summary:
      'Our powerful new features help business users, analysts and systems integration teams work on complex data transformations.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6NPtFze70wi4ymsm8Xz6F',
        type: 'Entry',
        createdAt: '2024-05-08T21:44:11.343Z',
        updatedAt: '2024-05-08T22:32:09.133Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Jon Bell',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3Kt0vTUqcQyKOCJJCK7ziw',
            type: 'Asset',
            createdAt: '2024-05-08T21:43:32.312Z',
            updatedAt: '2024-05-08T21:43:32.312Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Jon Bell',
            description: '',
            file: {
              url: '/img/contentful/3Kt0vTUq-t0ap8ur47-u01dc87djqz-5423a049493d-512.webp',
              details: {
                size: 35405,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U01DC87DJQZ-5423a049493d-512.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'VP of Product'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’ve been following our changelog, you’ve seen the slew of new features that help our developer community build exceptional data exchange solutions with the Flatfile Platform. Of course, that will continue, but we also want to highlight some of the powerful new features and capabilities that help business users, data analysts and systems integration teams work on large and complex data transformations.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We've expanded the power of the Flatfile Platform with several innovative features, including AI-powered data transformation capabilities that bring dramatic efficiency gains for business users. At the same time, we continue to add tooling and productivity enhancement for developers that allow them to deliver new data exchange solutions to those users faster and easier than before. Our spring 2024 release underscores our commitment to driving value and performance advancements for business users and enterprise developers alike. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Spring 2024 release highlights',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'AI Transform: Your data transformation copilot',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5ZIvaguOZl5OWOFmKUDBr0',
                type: 'Asset',
                createdAt: '2024-04-24T03:47:45.496Z',
                updatedAt: '2024-04-24T04:11:28.442Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'AI transform - 3',
                description: 'Email addresses transformed by AI Transform',
                file: {
                  url: '/img/contentful/5ZIvaguO-ai_transform_-_3.webp',
                  details: {
                    size: 71672,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'AI transform - 3.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With AI Transform business users overcome the challenges of manually editing large data sets. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This tool allows users to describe in natural language how they\'d like to change their data and preview all potential changes in a convenient before-and-after view. It significantly simplifies and accelerates the cleanup and validation of enterprise data and ensures data privacy and security with a "Zero Trust AI" approach that allows users to verify changes and maintain control over critical data transformations. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/introducing-ai-transform-your-data-transformation-copilot/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Learn more about AI Transform here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Keep teams aligned with Shared Views',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Effective collaboration hinges on clear communication and shared context. Unfortunately, when teams work together on collecting, transforming and migrating complex data sets, even the best-organized teams are often challenged with asynchronous communication mishaps or file versioning issues that result in team frustrations, added cost and prolonged project timelines. The new “Shared Views” feature, powered by the advanced filtering and querying capabilities of Flatfile workbooks, allows data migration teams to collaborate on the same data set while dynamically sharing precise data slices with relevant team members.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Powered by Flatfile’s advanced filtering and querying capabilities, Shared Views allow you to craft and share precisely tailored views of your data. With Shared Views, you can set and save your filtering parameters and name and share these views with customers or team members. When they access the same sheet, they’ll automatically see the data that matches the saved conditions of your Shared View.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/keep-teams-aligned-with-shared-views/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Learn more about Shared Views here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Note: AI Transform and Shared Views are available with our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/pricing/feature-comparison/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Pro and Enterprise Plans',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. If you aren’t on one of those plans yet and are interested in a test drive, please ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'let us know',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'More power for developers',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Our redesigned ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/new-flatfile-dashboard/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'developer dashboard',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' simplifies and accelerates the process for software engineers to build the data exchange solutions their business needs. The updated dashboard includes new user guides and enhanced tracking and monitoring tools for detailed performance insights.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Get started quickly with pre-built apps',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The new dashboard introduces a selection of pre-built apps, offering developers a streamlined approach to customizing their Flatfile experience. These apps support common use cases, such as embedded data importers or collaborative data onboarding projects. This enables developers to dive right in and utilize the platform in the most effective way possible.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'User role assignment',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5pIiVhG7iBtXu1IgZss89b',
                type: 'Asset',
                createdAt: '2024-05-08T22:37:46.318Z',
                updatedAt: '2024-05-13T20:53:47.269Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 10,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'user-role-assignment',
                description: 'User role assignment graphic',
                file: {
                  url: '/img/contentful/5pIiVhG7-user_role_2.webp',
                  details: {
                    size: 57629,
                    image: {
                      width: 1460,
                      height: 843
                    }
                  },
                  fileName: 'user_role_2.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can now invite and manage users with more granular access control. When you want to add a user from the dashboard, simply select a role and the spaces to which you’d like to give them access.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'One-click agent deploy',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4ekKPZzyw3bCsMbQn2odKL',
                type: 'Asset',
                createdAt: '2024-05-08T22:40:11.748Z',
                updatedAt: '2024-05-08T22:40:11.748Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'one-click-agent-deploy',
                description: 'One-click agent deploy example illustration',
                file: {
                  url: '/img/contentful/4ekKPZzy-one-click-agent-deploy.webp',
                  details: {
                    size: 79272,
                    image: {
                      width: 1278,
                      height: 444
                    }
                  },
                  fileName: 'one-click-agent-deploy.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can see all available agents in the Dashboard for your space. You can also easily deploy a new agent to your space with one click. It’s never been easier to add extractor plugins to your project.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Enhanced cell-level control in records',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can now set individual cells as “Read Only,” which gives you more granular control over data manipulation by restricting editing at the cell level and improving data integrity and compliance.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Improved table usability',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can edit cell-level text in multiline mode, making engaging with large bodies of text in a call easier. Additionally, navigating to the next row is more intuitive. Just like in a traditional spreadsheet, you can hit enter, and the cell focus will automatically advance to the next row within a column.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Box integration',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We've made it even easier to get your source files into Flatfile. With our expanded file storage integrations, including Box, you can upload a file with just a few clicks. Simply connect your Box account, select the file you want to upload and it will be imported directly into Flatfile.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Need help?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As always, we’re here to help. Here are some of the best ways to learn more and connect with us:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Stay up-to-date on all of the ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/docs/changelog/platform?utm_campaign=Newsletter&utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz-9iTvsMl4BkuvDWKN3_gvfeXKCGwJbkBLSrYdgwXlIoBvHQ6Au4LUEJAtsP0c-eCPFhUpKceeoip6jDYMEPbN0nrBBcfw'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          value: 'new feature releases here',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/resources/webinars/developer-office-hours/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          value: 'Developer office hours',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' provides live support from our engineers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile-developers.slack.com/ssb/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          value: 'Join the Flatfile Developer Slack community',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Feel free to reach out to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:support@flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'support@flatfile.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' if you’re more of an email person',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '61hitXpONE9cuf7J9XQ25W',
    postTitle: 'Keep teams aligned with Shared Views',
    seoTitle: 'Keep teams aligned with Shared Views',
    seoUrlSlug: 'keep-teams-aligned-with-shared-views',
    seoMetaDescription:
      'Shared Views is the easiest way to keep your team on the same page while discussing any segment of data in a sheet.',
    category: 'Product updates & features',
    tags: ['Feature release', 'Shared Views', 'Collaboration'],
    sortOrder: '2',
    publishDate: '2024-05-07T11:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7BQFmd8H1gHz2qsA6Pu8ZR',
        type: 'Asset',
        createdAt: '2024-05-02T16:12:45.840Z',
        updatedAt: '2024-05-02T16:12:45.840Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Feature - Shared Views',
        description:
          '"Feature update - Shared Views" on a black background with icons representing data file views',
        file: {
          url: '/img/contentful/7BQFmd8H-feature_-_shared_views.webp',
          details: {
            size: 26239,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Feature - Shared Views.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Feature update - Shared Views" on a black background with icons representing data file views',
    summary:
      'Shared Views is the easiest way to literally and figuratively keep your team on the same page while discussing any segment of data in a sheet.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6jqtZuYGDkJxvNfPSp6s5V',
        type: 'Entry',
        createdAt: '2024-03-20T20:49:24.210Z',
        updatedAt: '2024-03-20T20:49:24.210Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Jon Bell',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3JOojesYtKv8J7RRMy5FJn',
            type: 'Asset',
            createdAt: '2024-03-20T20:49:10.773Z',
            updatedAt: '2024-03-20T20:49:10.773Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Jon Bell',
            description: 'Jon Bell headshot',
            file: {
              url: '/img/contentful/3JOojesY-jb-slack.webp',
              details: {
                size: 383244,
                image: {
                  width: 510,
                  height: 513
                }
              },
              fileName: 'jb-slack.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Vice President of Product'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'It’s never been easier to stay on the same page',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Effective collaboration hinges on clear communication and shared context. Unfortunately, in a data exchange project, there are way too many ways for your well-oiled team to become misaligned.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We've all been there. After going around and around through a series of exasperating exchanges, you suddenly realize that someone uploaded the wrong version of a spreadsheet to a discussion thread, and everyone has been working from different versions of a data file.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s why we created Shared Views. It’s the easiest way to literally and figuratively keep your team on the same page while discussing any segment of data in a sheet.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What are Shared Views?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Powered by Flatfile’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/introducing-ai-transform-your-data-transformation-copilot/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'advanced filtering and querying capabilities',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', Shared Views allow you to craft and share precisely tailored views of your data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Shared Views, you can not only set and save your filtering parameters but also name and share these views with customers or team members. When they access the same sheet, they’ll automatically see the data that matches the saved conditions of your Shared View.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Shared Views are dynamic',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data characteristics frequently change as information is cleaned, transformed and validated. Recognizing this, we designed Shared Views to be dynamic. They save filtering parameters, not static records, which means records will appear or disappear from a view based on whether they meet the current criteria of the filters.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Who can create Shared Views?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Shared Views can be created by anyone with access to a sheet. They simply need to filter the records in the sheet and click “Save View.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Views you create are categorized into “My Views.” Views created by others in your space will show up in “All Views.” The system is designed to be open and collaborative so all views are, by default, available for use by anyone in the space.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Shared Views save time and sanity',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We designed this feature with two goals in mind:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'To make sharing context easy and accessible',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'To eliminate repetitive tasks so teams can focus on high-value activities',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Shared Views is available today for Pro and Enterprise users. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/contact-sales/consult/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Let us know what you think',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and how else we can improve your experience.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TeslTqcCH6G3Jjogccn9K',
                type: 'Entry',
                createdAt: '2024-01-12T01:22:24.597Z',
                updatedAt: '2024-01-12T01:22:24.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Connect with an expert',
                text: 'Evaluating Flatfile for your business needs?',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6JIEIu7RIpnIhbKZuyISBJ',
    postTitle: 'A complete guide to importing data with Data Hooks',
    seoTitle: 'A complete guide to importing data with Data Hooks',
    seoUrlSlug: 'flatfileioblogdata-hooks-guide',
    seoMetaDescription:
      'Learn about data hooks and how they make Flatfile’s data onboarding platform a flexible and powerful CSV data importer.',
    category: 'Product updates & features',
    tags: ['Data hooks', 'Flatfile features'],
    publishDate: '2024-05-02T14:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3W2ybgURawXaAVhRYET7ae',
        type: 'Asset',
        createdAt: '2024-05-02T21:18:23.643Z',
        updatedAt: '2024-05-02T21:18:23.643Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data Hooks',
        description: 'Data Hooks concept representing data being transformed',
        file: {
          url: '/img/contentful/3W2ybgUR-data_hooks.webp',
          details: {
            size: 15203,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Data Hooks.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Data Hooks concept representing data being transformed',
    summary:
      'We all know about how important it is to get customers to the “Aha moment” quickly and successful customer onboarding plays a huge role there. But many in the SaaS industry are still glossing over a really important part of onboarding: data. Product teams are saddled with building out complex ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2rneYTuCHFJSJvgE3PjOMw',
        type: 'Entry',
        createdAt: '2021-08-24T18:59:00.622Z',
        updatedAt: '2021-10-07T00:11:20.944Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Randy Wiafe',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '8uXSPNgYBYpi8Ggjmlj9C',
            type: 'Asset',
            createdAt: '2021-08-24T18:57:31.293Z',
            updatedAt: '2021-08-24T18:57:31.293Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Randy Wiafe headshot',
            description: 'Randy Wiafe headshot',
            file: {
              url: '/img/contentful/8uXSPNgY-pjion4fwtieae82c03zt.webp',
              details: {
                size: 15273,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'pJIOn4fwTieAE82c03zT',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Product Designer',
        department: 'Product'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'We all know how important it is to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'quickly get customers to the "',
                  marks: [],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: 'aha moment',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: '"',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " and that successfully onboarding customers plays a huge role in that process. It sounds obvious, but what many companies don't fully recognize is that the data itself is one of the most important parts of customer data onboarding.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To deal with data import challenges, product teams are saddled with building out complex CSV importers, while customer success teams frequently have to fix customer data manually in order to make it work within the product.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flatfile's Data Hooks® are a useful data healing element for reformatting, validating and correcting data automatically during the data file import process. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "This means that your users won't need to go in manually and correct data themselves. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The challenges of importing data',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Importing data might be a nuisance or even a nightmare, depending on your product and your customers. Most software products are completely unusable without customer data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'However, importing this data in a timely manner can be a struggle for both your customers and your company. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Challenges for customers',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "If you don't think ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' is a problem, think again. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/why-isnt-my-csv-file-importing/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Importing CSV',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: " or Excel files isn't anyone's idea of a good time. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'In our ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/state-of-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'State of Data Onboarding survey',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', we discovered that 23% of companies reported that it takes weeks or months to import their data and that 96% have run into problems when importing data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'For customers, importing data can be ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'time-consuming, unintuitive and confusing',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". They often need to put serious effort into prepping their data before it's ready to upload. And data importers don't usually give useful troubleshooting tips when something goes wrong. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Worse still, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'fixing data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' requires users to leave the application, hunt for the issue in their file, and then return to the platform to re-upload it, which is a less-than-ideal experience. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Challenges for product, customer success, and engineering teams',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Today, the majority of companies importing data use an internally built tool, manual data import processes, or a combination of both. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'That means that the in-house team is responsible for data importing. They must build a quality data importer that offers a great user experience, and they also have to step in with manual assistance when that data importer inevitably fails or when an individual customer struggles to make good use of it. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Some companies even have full-time employees who are devoted entirely to preparing and onboarding customer data. This manual work isn't a necessity: It represents a lack of efficient, scalable data onboarding systems.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data Hooks is a specific feature within Flatfile's data onboarding solution that allows your team to address the data import problems that slow everyone down.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What are Data Hooks?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data Hooks allow for more fringe use cases of data healing and validation using Flatfile's data onboarding platform. When used properly, they can be used for things like automatically reformatting area codes or country codes, removing special characters, validating emails against external data and really anything a developer can write in JavaScript.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "At Flatfile, we're continually building more data healing and validation functionality, but Data Hooks covers anything that's not yet included in our core product. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'There are two types of Data Hooks:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Field hooks',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' are for columns. Field hooks run validation on a particular column of data during the matching and importing process',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Record hooks',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' are for rows. Record hooks run validation on each row of data and can be used for single-field, multi-field, or cross-field validation',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Use cases for Data Hooks',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "In our Data Hooks documentation, you'll find a growing library of code snippets you can use to handle a variety of data validation or transformation needs, including:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Reformatting specific value formats:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' As an example of single-field validation, a CSV file might state "zip," whereas your data schema calls this the "zip code." The simple Data Hook snippet would allow this to be automatically mapped, and the customer could review and accept the mapping. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Splitting specific value formats:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                " Let's say a customer has a source file with many full names on it, but your data schema only allows the first name and last name fields. A Data Hook for field splitting ensures that data imported with Flatfile's data onboarding platform is input correctly and with the minimal amount of involvement from your customer. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5AcQXhVwDG6G0YSztISbSP',
                type: 'Asset',
                createdAt: '2021-08-24T18:56:06.877Z',
                updatedAt: '2021-08-24T18:56:06.877Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Data hooks name splitting animation',
                description: 'Data hooks name splitting animation',
                file: {
                  url: '/img/contentful/5AcQXhVw-awx3kf93qclqu762ox2w.webp',
                  details: {
                    size: 25720,
                    image: {
                      width: 600,
                      height: 300
                    }
                  },
                  fileName: 'aWX3Kf93QClqu762oX2w',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Validating data with your server:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                " You wouldn't want customers uploading duplicate contact records to your CRM, for example. You can use a Data Hook to validate data with your server so that during the import process, a callback function denotes which email addresses or phone numbers already exist in the database.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Cross-field validation:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                " You may want to require a column of data only if other data isn't included. For example, if the phone number and mailing address aren't present, then an email address is required for that row of data to be uploaded.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How do Data Hooks address important issues with data onboarding?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The other good news is that we can see which Data Hooks are being used most frequently, so we know what to add to Flatfile's data onboarding platform next.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "But it's not about us. It's about your customers and your team.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'For your customers',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Customers using Flatfile's data onboarding platform and the Data Hooks snippets you've implemented from our library will enjoy a much easier importing flow. They won't have to leave your application to make the necessary changes to their files that might be required during troubleshooting. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'That means no context switching. The entire data import process becomes smoother and faster.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For your product, customer success, and engineering teams',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies using Data Hooks to solve common data importing problems save time for their customers and themselves. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Customer success teams can focus less on helping customers import data and more on building relationships to drive real value. Similarly, software engineers won't get roped into cleaning up a customer's data file; instead, they can focus on their current sprint and build out their core product.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data Hooks allows your team to scalably address data import challenges - instantly increasing efficiency!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2021 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2t6mmorte1zK6qCySnFrRC',
    postTitle: 'Security first: Our annual SOC 2 Type II audit is complete',
    seoTitle: 'Security first: Our annual SOC 2 Type II audit is complete',
    seoUrlSlug: 'annual-soc-2-type-ii-audit-complete',
    seoMetaDescription:
      'At Flatfile, your data is protected at every stage, from collection to storage and processing, and in every aspect of our operations.',
    category: 'Security & compliance',
    tags: ['Security', 'Compliance', 'SOC 2'],
    sortOrder: '1',
    publishDate: '2024-05-01T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1mKpNd6258eVVPc6jhCNww',
        type: 'Asset',
        createdAt: '2024-05-01T00:21:44.499Z',
        updatedAt: '2024-05-01T00:21:44.499Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'SOC 2',
        description:
          '"SOC 2 Compliance" on a white background with icons representing security',
        file: {
          url: '/img/contentful/1mKpNd62-soc_2.webp',
          details: {
            size: 31427,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'SOC 2.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"SOC 2 Compliance" on a white background with icons representing security',
    summary:
      'SOC 2 ensures that your data is protected at every stage, from collection to storage and processing, and in every aspect of our operations.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3pCVVbo25ZQekNxNFRCCqZ',
        type: 'Entry',
        createdAt: '2021-10-07T00:23:57.341Z',
        updatedAt: '2021-10-07T00:23:57.341Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Amber Jones',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5DDExkBQCOP2XkHojJkEtd',
            type: 'Asset',
            createdAt: '2021-10-07T00:23:00.217Z',
            updatedAt: '2021-10-07T00:23:00.217Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'MInxtUlSRRm1sCoDo8Qc',
            description: '',
            file: {
              url: '/img/contentful/5DDExkBQ-minxtulsrrm1scodo8qc.webp',
              details: {
                size: 50032,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'MInxtUlSRRm1sCoDo8Qc',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We successfully completed our annual SOC 2 Type II audit for the third consecutive year!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data security is critical, and SOC 2 is just one part of how we protect your data. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'SOC 2 is an auditing procedure that ensures service providers have proper data and privacy protections in place for sensitive data. Organizations that want to achieve this certification need to implement a series of controls and go through an audit with an external auditor. They also have to set their own standards so that they can say, "Yes, we are actually doing the things that we say we\'re doing!" when a third party comes in to audit them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What makes SOC 2 so important?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "SOC 2 is an industry-recognized certification that demonstrates our adherence to the highest standards of data security and privacy.  Flatfile's SOC 2 Type II compliance is a critical aspect of our commitment to maintaining high standards of security, availability, confidentiality, processing integrity and privacy.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The SOC 2 Type II audit is a rigorous process that assesses the effectiveness of systems over time, rather than just at a single point in time. This ongoing observation period ensures that we’re continuously improving our security measures and adapting to emerging threats. We carefully examine components like identity and access control, conduct penetration testing, and perform vendor reviews to assess our risk management processes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We're not just looking at the security of the Flatfile Platform but also at any vendors we use that might have access to any of our systems. We review whether they have a SOC 2 report in place, whether they do penetration testing and generally, whether or not they do the same things we do to protect our customers.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "At Flatfile, our compliance team includes dedicated subject matter experts from across the company. Every team at Flatfile owns security and compliance, and we don't have an isolated compliance team because data security starts with each of us.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "This process isn't just about security for the Flatfile Platform. It's also about security for our HR controls, disaster recovery, backups and more. This comprehensive approach ensures that your data is protected at every stage, from collection to storage and processing, and in every aspect of our operations.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TeslTqcCH6G3Jjogccn9K',
                type: 'Entry',
                createdAt: '2024-01-12T01:22:24.597Z',
                updatedAt: '2024-01-12T01:22:24.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Connect with an expert',
                text: 'Evaluating Flatfile for your business needs?',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4aiXTkum9sHJKykCU8valp',
    postTitle: 'Introducing AI Transform: Your data transformation copilot',
    seoTitle: 'Introducing AI Transform',
    seoUrlSlug: 'introducing-ai-transform-your-data-transformation-copilot',
    seoMetaDescription:
      "We'd like to introduce you to AI Transform: A fast and safe way to make bulk edits to your data at scale.",
    category: 'Product updates & features',
    tags: ['AI Transform', 'AI', 'Search', 'Featured'],
    sortOrder: '1',
    publishDate: '2024-04-24T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1VmvQQqUYpKiSMmCTowTo0',
        type: 'Asset',
        createdAt: '2024-04-22T22:10:13.416Z',
        updatedAt: '2024-04-22T22:10:13.416Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Blog Post - AI Transform',
        description:
          '"AI Transform" on a white background with an image representing AI transforming data',
        file: {
          url: '/img/contentful/1VmvQQqU-blog_post_-_ai_transform.webp',
          details: {
            size: 23056,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - AI Transform.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"AI Transform" on a white background with an image representing AI transforming data',
    summary:
      "We'd like to introduce you to AI Transform: A fast and safe way to make bulk edits to your data at scale.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6jqtZuYGDkJxvNfPSp6s5V',
        type: 'Entry',
        createdAt: '2024-03-20T20:49:24.210Z',
        updatedAt: '2024-03-20T20:49:24.210Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Jon Bell',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3JOojesYtKv8J7RRMy5FJn',
            type: 'Asset',
            createdAt: '2024-03-20T20:49:10.773Z',
            updatedAt: '2024-03-20T20:49:10.773Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Jon Bell',
            description: 'Jon Bell headshot',
            file: {
              url: '/img/contentful/3JOojesY-jb-slack.webp',
              details: {
                size: 383244,
                image: {
                  width: 510,
                  height: 513
                }
              },
              fileName: 'jb-slack.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Vice President of Product'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI will be an invaluable tool for the next generation of data exchange. Today, we’re announcing AI Transform -- a fast and safe way to make bulk edits to your data at scale.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A data transformation copilot for everyone',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When your team begins a data transformation or data onboarding project, they start with messy data. While you know what the end state of the data needs to be, the path to getting there is often unclear. What is abundantly clear, however, is that editing large data files is cumbersome and slow. The tools for the job were built for granular editing and require specialized knowledge, deep experience and considerable time.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s why we built AI Transform – your data transformation copilot.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI Transform lets teams use natural language to describe how they’d like their data to change. Flatfile takes this prompt and generates and executes the code necessary to make the desired changes instantly across the entire data set.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'ERduImIiaktT9f5pRbyOL',
                type: 'Asset',
                createdAt: '2024-04-24T03:43:00.150Z',
                updatedAt: '2024-04-24T03:43:00.150Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'AI transform - 1',
                description: 'Image of AI Transform in action',
                file: {
                  url: '/img/contentful/ERduImIi-ai_transform_-_1.webp',
                  details: {
                    size: 106025,
                    image: {
                      width: 2600,
                      height: 1440
                    }
                  },
                  fileName: 'AI transform - 1.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What makes AI Transform so powerful?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We believe the most powerful way to make complex and precise changes to large data files is through code. But not everyone knows how to write code. So we created a transformation copilot that uses AI in the background to turn your team’s commands into code that runs automatically––giving you data editing superpowers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Here are a few of the capabilities your team gets with AI Transform:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Combine data:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Combine data from two or more columns to create a new value to populate another column. For example, use first name, last name, and domain name to create an email address.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5zGLqLAfPa843uV9baZhnX',
                type: 'Asset',
                createdAt: '2024-04-24T03:43:49.435Z',
                updatedAt: '2024-04-24T04:05:33.313Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 15,
                revision: 3,
                locale: 'en-US'
              },
              fields: {
                title: 'AI Transform-2',
                description:
                  'Using AI Transform to fill values in an email field',
                file: {
                  url: '/img/contentful/5zGLqLAf-email_transform3.webp',
                  details: {
                    size: 31578,
                    image: {
                      width: 1284,
                      height: 720
                    }
                  },
                  fileName: 'email_transform3.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5ZIvaguOZl5OWOFmKUDBr0',
                type: 'Asset',
                createdAt: '2024-04-24T03:47:45.496Z',
                updatedAt: '2024-04-24T04:11:28.442Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'AI transform - 3',
                description: 'Email addresses transformed by AI Transform',
                file: {
                  url: '/img/contentful/5ZIvaguO-ai_transform_-_3.webp',
                  details: {
                    size: 71672,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'AI transform - 3.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Calculate a final value:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' You can easily generate values by calculating them. For example, imagine multiplying the property value by the property tax rate to determine the amount of property taxes owed on each property.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Extract parts of your data:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Sometimes, the values you need are embedded in a longer string. With AI Transform, you can simply describe the portion you want and what you want to do with it. For example, imagine having a full name field you want to divide into first, middle, and last names. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can do the above and so much more -- move data from one column to another, change data formatting, delete values, etc. If you can describe it, you can likely do it. You can even string multiple commands together into a single prompt.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Not another chatbot',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The last thing any of us want is ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'another',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' chatbot, especially when we need to do complex business operations on sensitive data. That’s why AI Transform is a copilot, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'not',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' a bot. Instead, we designed an interface fine-tuned for teams working directly with their data in a table. Here are a few features we think you’ll love:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Filter & prompt:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Filter your data down using our flexible filtering tools then click AI Transform to begin your data editing workflow on only the records in view.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Prompt ideas:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Not sure what you can do? AI Transform provides examples of prompts to get you started.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Tips:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Using AI can sometimes feel like a black box, so AI Transform provides tips for getting the best results quickly.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Designed for humans:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Easily see how a record has changed, auto-scroll to affected columns, and quickly toggle between all records and only records with changes. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Edit 1M records, instantly:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Editing large data files has never been so easy or fast.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Never trust, always verify',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI in the enterprise has great promise but also meaningful risks. When transforming sensitive or proprietary data, it’s essential that your team controls and verifies changes before records are permanently updated. AI Transform was designed with this fundamental product principle at its core.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4kWF6inRtWxGSOuMSqAZQM',
                type: 'Asset',
                createdAt: '2024-04-24T03:49:35.257Z',
                updatedAt: '2024-04-24T03:49:35.257Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'AI transform - 4',
                description: 'Version history with AI transform',
                file: {
                  url: '/img/contentful/4kWF6inR-ai_transform_-_4.webp',
                  details: {
                    size: 57314,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'AI transform - 4.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Preview changes:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' AI Transform presents your team with a preview of all possible changes after a command is submitted. This feature means you never have to wonder how the AI interpreted your prompt. You can verify beforehand exactly how your data will change.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Iterative prompting:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Sometimes, the first attempt doesn’t yield the expected result, or you might decide to make additional multi-step changes to the data. In the change preview view, your team can easily edit or add to their prompts and instantly see how the change in command changes the data. You can tweak the prompt to get closer to your desired outcome.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Remember everything:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Even after you’ve committed changes, you’re not locked in. AI Transform takes a snapshot of the data before each change so you can easily go back to any point in time and restore your data to its prior form.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Designed for sensitive data requirements:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' AI Transform prioritizes keeping customer data private and secure. The AI models that power this experience are hosted by Flatfile. Your data is never transmitted to third-party model providers like OpenAI and Anthropic. You can be confident that your customer data won’t end up in a training set for third-party models or be accessible to other Flatfile customers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3qqLcKUHz2xfYknjy2Fnme',
                type: 'Asset',
                createdAt: '2024-04-24T03:50:38.753Z',
                updatedAt: '2024-04-24T03:50:38.753Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'AI transform - 5',
                description: 'AI Transform keeps your data secure',
                file: {
                  url: '/img/contentful/3qqLcKUH-ai_transform_-_5.webp',
                  details: {
                    size: 107354,
                    image: {
                      width: 2600,
                      height: 1440
                    }
                  },
                  fileName: 'AI transform - 5.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5jsKDgflvyHeV0UjarX20y',
                type: 'Entry',
                createdAt: '2024-04-22T21:57:43.895Z',
                updatedAt: '2024-04-23T00:07:03.368Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'AI Transform',
                text: 'Find out how Flatfile can supercharge your data exchange experience.',
                ctaText: 'Connect with us',
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'AI Transform makes bulk data editing quick, accurate and effortless for teams. The feature is available now for Pro and Enterprise customers. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6aRfVr3kwZtk8hHZ42ILte',
    postTitle: '5 must-have features for a data importer',
    seoTitle: '5 must-have features for a data importer',
    seoUrlSlug: '5-must-have-features-for-a-data-importer',
    seoMetaDescription:
      'Here are the top features you should look for when choosing a data importer.',
    category: 'Data exchange',
    tags: ['Data importer', 'data exchange', 'data onboarding'],
    publishDate: '2024-04-19T09:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3oI2tc3e6qqDjNYeZDhYkH',
        type: 'Asset',
        createdAt: '2024-04-19T21:25:21.317Z',
        updatedAt: '2024-04-19T21:25:21.317Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '5 must-have features',
        description:
          '5 must-have features for a data importer concept with icons representing data imports, coding and other information',
        file: {
          url: '/img/contentful/3oI2tc3e-5_must-have_features.webp',
          details: {
            size: 90639,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '5 must-have features.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Data importer',
    summary:
      'Instead of relying on complex workarounds or home-built importers, here are the top five features you should vet when you choose a data importer for your web-based app.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "What's missing in your data import solution? ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Do you have a data importer that's as intuitive, fast and accurate as possible? Does it require the minimum amount of maintenance from your in-house engineers so you can ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'focus on building the product features your customers love',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If your answer to either of these questions was anything other than a resolute "yes," then you might want to keep reading! This article explores different methods for handling ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data file exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and explains what a pre-built data importer that requires no patchwork open-source coding can do. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Instead of relying on ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'complex workarounds',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' or home-built importers, here are the top five features you should vet when you choose a data importer for your web-based app.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is a data importer?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data importer',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' helps users upload offline data or data from another online source into an application database. The user might be a customer, an internal employee or a customer success representative offering ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'white-glove onboarding assistance',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' to a customer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies need to onboard all sorts of data, but that type of data depends on the application accepting it. Uploaded data could include email subscribers, customer contacts, inventory data, SKUs, task lists, etc.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are a few common ways businesses today handle data imports, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Custom-developed solutions:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Engineering teams often custom-build their data importer using patchwork ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-7-open-source-csv-import-libraries/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'open-source solution',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        '. This process is frequently complicated; a comprehensive importer requires UI and application code to handle data normalization, parsing and mapping. Building a solution in-house can be resource-intensive and time-consuming, often keeping engineers from ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'working on their core product features',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Pre-built data importers:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " A ready-to-go data importer from a third-party vendor is another method businesses use to handle data file imports. This reduces the need for manual uploading and means your in-house engineers won't spend months building it.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'A mix of manual and productized:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " In some cases, software companies might use a mix of manual and pre-built data importing solutions. For example, they may have a spreadsheet with templated columns and request that customers add their data according to the spreadsheet's requirements before uploading it. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Manual processes:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " Finally, there's the option of doing everything manually, which is surprisingly common. Manual processes don't just refer specifically to uploading data; they refer to everything from data preparation and cleaning to getting the data into a target software application.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What are key data import challenges?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Where to begin? ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Importing data is always full of challenges. While there can be endless technical difficulties, the core issues all come down to the effect challenges have on these three categories:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Paying customers ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Internal software users',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The engineering team',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Let's explore these issues a little further.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Time-to-value for customers',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When it's difficult for customers to import their data—either because of time-consuming manual processes or because a custom-built data importing feature is difficult to use, everyone loses. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The customer loses because they can't get value out of the product, and the business loses because this customer is more likely to churn (if they ever get started in the first place).",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Employee efficiency (in the case of internal tool usage)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Similarly, when the user is an employee and the software was built or purchased for internal use, slow data imports can cause problems. In this case, the business isn't losing money directly from churning customers but indirectly from employees who spend exorbitant amounts of time managing imports.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Work prioritization for the engineering team',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'On the flip side of the user perspective comes the engineering team. Data importers are incredibly time-consuming to build because they are technically complicated and challenging to design intuitively, with so many points of failure.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Engineers need to provide seemingly endless error messages so that customers know exactly what went wrong with their data import and how to fix the files. When the data import UX isn't elegantly crafted, end-user customers leave with more questions than answers.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Many engineering teams combine different open-source solutions to speed up the build, but challenges abound. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Open source has made it easier for people to build out homegrown solutions, but those open-source libraries only address small, discrete parts of a data import workflow. For example, you might be able to find an open-source library that does the parsing of Excel files and nothing more, leaving your team to build out the rest.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why you should consider a ready-made data importer',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A pre-built data importer can save time for both customers and the engineering team. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "While custom-built solutions cost engineering time and may or may not solve customer problems (depending on how intuitively they're built and how helpful the import error messages are), manual processes save big on engineering time but ultimately cost the customer time in a way that can negatively impact revenue. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "There's a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'lot of money to be made',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " in focusing on customer retention. For software companies, it's impossible to prioritize retention without taking a good hard look at just how simple it is for users to import their critical data during the data onboarding process. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "That's why a quality data importer is worth considering when it comes to customer retention and the overall customer experience. Consider that US companies lose ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.getfeedback.com/resources/cx/40-stats-churn-customer-satisfaction/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '$136 billion',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' per year due to customers switching, and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.forbes.com/sites/jiawertz/2018/09/12/dont-spend-5-times-more-attracting-new-customers-nurture-the-existing-ones/#1852c4c15a8e'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'increasing customer retention rates by 5%',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' has the power to lift profits by 25% to 75%.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Top data importer features to consider',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data importer features can number in the dozens. When considering implementing a pre-built data importer for your software, you must first check for the essential features.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "You're looking for something that fits naturally within your product, that will be easy for customers to use, and that will drastically reduce the time it takes for data to be useful.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Let's take a look at the five must-have features below.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data importer feature 1: Data parsing',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data parsing is the process of aggregating information (in a file) and breaking it into discrete parts. Essentially, data parsing means the separation of data. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'T',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                'he Flatfile Data Exchange Platform not only handles data parsing, but offers intelligent parsing, so a user doesn\'t have to explicitly define how a file has been aggregated, such as, "This is a UTF-8 encoded CSV." Instead, the encoding is auto-detected from the file. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "You'll want to look for a data parsing feature that not only provides the technicalities of going from a file to an array of discrete data but also streamlines this process for your customers.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data importer feature 2: Data mapping',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data mapping',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and matching often get used interchangeably, but either way, this usually refers to taking the previously unknown data that you started with and matching it to a known target. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It\'s an absolute requirement that your data importer do this very well. A good example is when you need to configure your data importer to accept contacts. Let\'s say that one of the fields is "email." The customer might choose a file where the field is labeled "email address."',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you don\'t have data mapping in the product experience, that example import will fail because "email address" does not equal "email," so the customer can\'t complete the import.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data importer feature 3: Data structuring',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Most product teams have an application database and an API, and they want to make sure the data can flow seamlessly into the database. How you get data into your system matters because you want to ensure it's labeled appropriately. APIs expect a specific format of data and will fail otherwise.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A data importer should be flexible and be able to plug data into your application or database in any way you best accept it. Flatfile's data onboarding platform offers a variety of ways to structure data that has been uploaded, mapped, and validated by users, meaning it can fit right into your preferred data flow.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data importer feature 4: Data validation',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Another important feature for a data importer is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data validation',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', which checks if the data matches an expected format or value. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Having this feature in place prevents issues from occurring down the line. For example, if special characters can't be used within a certain template or other feature, then you don't want customers to be able to import them. Otherwise, they'll be frustrated when an error message pops up during use that should have appeared during the import stage. Without data validation, your customers might end up having to remove and re-upload data. That can lead to frustration, which, of course, leads to churn.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data importer feature 5: Data transformation',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data transformation is another key feature. Data transformation means making changes to data as it flows into the system to meet an expected or desired value. Rather than sending data back to users with an error message, data transformation can make small, systematic tweaks to make data more usable. For example, when transferring a task list, prioritization data could be transformed into a different value, such as numbers instead of labels or numbers that get rounded up. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The data importer you choose should include all of these features and seamlessly integrate with your product. When it's time to ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'choose a data import solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', your goal is to save internal engineering resources and wow customers with an amazing ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data import',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' experience.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2020 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '36q7OeDpnpKsytUsp0wxvl',
    postTitle: 'The ultimate introduction to data mapping',
    seoTitle: 'The ultimate introduction to data mapping',
    seoUrlSlug: 'ultimate-introduction-data-mapping',
    seoMetaDescription:
      'Find out how what data mapping is and how it can help organize your data chaos into a structured, meaningful format.',
    category: 'Data exchange',
    tags: [
      'Data mapping',
      'Data import',
      'Data files',
      'CSV',
      'Excel',
      'Data management',
      'Introduction'
    ],
    publishDate: '2024-04-12T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'bagbW0fxFNp9PiYIGfI5s',
        type: 'Asset',
        createdAt: '2024-04-12T15:16:51.239Z',
        updatedAt: '2024-04-12T15:16:51.239Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'What is data mapping',
        description:
          '"What is data mapping?" on a white background with icons representing information being mapped into cells in a column',
        file: {
          url: '/img/contentful/bagbW0fx-what_is_data_mapping.webp',
          details: {
            size: 63507,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'What is data mapping.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"What is data mapping?" on a white background with icons representing information being mapped into cells in a column',
    summary:
      'Find out how what data mapping is and how it can help organize your data chaos into a structured, meaningful format.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data mapping is an essential ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data management process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that will help you integrate, transform and use your data effectively. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Imagine you're in charge of a company's data strategy. You've got data coming at you from all corners: Sales figures, customer profiles, inventory updates, you name it. Your job is to make sure all the data hangs together across systems and is accurate and consistent. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Fortunately, data mapping can help ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'organize that chaos',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' into a structured, meaningful format.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It\'s all about connecting the dots between different data sources so they speak the same language and play well together. For example, if one system calls a customer\'s age "Age" and another system labels it "Birth Year," data mapping is the bridge that says, "Hey, these are talking about the same thing!"',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Interestingly, the systems that capture, generate or store data have different and unique requirements. It's not just that there’s a lot of information that needs to reference the same thing (the data in the “Age” column in one system can simply populate an “Age” column in a different system), but that there are usually nuances in how data is stored.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For example, if one system calls a customer\'s age "Age" and another system has a "Birth Year" label, simple mapping would just map "age" to "birth year," and the values wouldn\'t change. But if someone is 52, they weren\'t born in \'52! That\'s where transformations come in, and it\'s where mapping can become very powerful. Taking "Age" (field) and 52 (value) and creating a mapping rule that subtracts the age value from the present year will give you a value of 1972, which can be put into the "Birth Year" field.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "You're about to get a lot more information about data mapping! Here are the key topics this article covers:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#whatIsDataMapping'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'What is data mapping?',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#keyComponentsOfDataMapping'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Key components of data mapping',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#whyIsDataMappingImportant'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Why is data mapping important?',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#howDoesDataMappingWork'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'How does data mapping work?',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#commonDataMappingTechniques'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Common data mapping techniques',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#keyChallengesAndConsiderations'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Key challenges and considerations',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#commonDataMappingSolutions'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Common data mapping solutions',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#bestPracticesForDataMapping'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Best practices for data mapping',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#whatHappensIfYouDontUseDataMapping'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'What happens if you don’t use data mapping?',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#mappingThatsMagical'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Mapping that’s magical',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can conquer data mapping issues and accelerate your data workflow? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your data challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is data mapping?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data mapping is the process of associating data elements (or attributes) from one data source to another. It defines how data in one format corresponds or relates to data in another format and involves mapping data structures, fields and relationships between source and target data sets. This process helps with things like data integration, migration, transformation and analysis. It’s commonly used in various fields, like data integration, data migration and data transformation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "For a really simple understanding of what data mapping does, picture a child's shape-sorting set with blocks shaped like triangles, squares and circles and a cylinder with cutout holes for each specific shape. If the shapes represent your data and the cylinder is the destination where those shapes need to go, data mapping is how you would define which blocks go into which cutouts.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6Q6yyUntwmnNnKGn7xOJhO',
                type: 'Asset',
                createdAt: '2024-04-12T15:11:44.151Z',
                updatedAt: '2024-04-12T15:40:13.245Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 18,
                revision: 4,
                locale: 'en-US'
              },
              fields: {
                title: 'Data mapping concept: Sorting toy',
                description:
                  "Colorful child's sorting toy as data mapping concept. Image by Nina Garman from Pixabay",
                file: {
                  url: '/img/contentful/6Q6yyUnt-graphic-3928849_1280.webp',
                  details: {
                    size: 50073,
                    image: {
                      width: 333,
                      height: 400
                    }
                  },
                  fileName: 'graphic-3928849_1280.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Image by ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://pixabay.com/users/billithecat-7996303/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=3928849'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Nina Garman',
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' from ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://pixabay.com//?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=3928849'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Pixabay',
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Key components of data mapping',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Source data:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " This just refers to the data before you do any mapping or importing. It can be stored in databases, files, APIs or other data repositories. Understanding the source data's structure, format and content is critical for effective mapping.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Target data:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' This is where the data needs to end up. The target, or destination, data is where the mapped data will be loaded or transformed. This could be another database, data warehouse, application or platform.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data elements:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' This is basically the fields and their types. You have the schema of the source and the schema of the target, and an important part of data mapping is identifying (and mapping) specific elements, or attributes, between your source and target data sets.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Mapping rules:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' These answer the question, “What needs to happen?” Mapping rules define how each of the data elements from the source maps to a corresponding element in the target. These rules cover data transformations, ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'data validations',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ', default values and the business logic applied during the mapping process.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data transformations:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' This is where the magic happens! Data mapping might include tasks (transformations) that convert, clean or aggregate data as it moves from the source to the target. Transformation rules specify how data should be modified, formatted or calculated during the data mapping process.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'There are a few basic ways you can tackle data mapping:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Manual mapping:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Totally hands-on. Here, people meticulously match data elements based on their understanding.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Automated mapping:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Automatic. In this approach, algorithms and tools do the heavy lifting, which is really useful for large-scale projects.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Semi-automated mapping:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' You guessed it – teamwork! Here, people and machines team up. Machines suggest matches based on preset rules, and people fine-tune the details.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Each has its perks, and the ideal approach really depends on what you need to accomplish.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why is data mapping important?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data mapping is incredibly important for lots of reasons, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data integration and consolidation:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Would it help your decision-making if you could combine information from different datasets? With data mapping, you can combine datasets for better insights and improved efficiency. Data mapping will let you integrate data from multiple sources (like databases, applications and APIs) into a coherent data model. It can help you consolidate data from disparate systems, helping create a single source of truth. With accurate data mappings, you can avoid data silos and ensure that all relevant data is accessible and usable across the organization.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data migration and system upgrades:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Have you ever had to move data from an old system to a new one? During data migration projects, data mapping helps you smoothly transfer data from an old system to new platforms or applications. It helps maintain data integrity, consistency, and compatibility between the old and new (source and target) environments and it helps map old data structures to new ones, which will help to ensure data compatibility and integrity. Data mapping reduces the risk of data loss or corruption, preserving continuity and your business operations.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data transformation and cleaning:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Data mapping is also essential for tasks like data cleaning and standardization! It facilitates data transformation processes by defining how data should be converted, formatted and manipulated to meet specific requirements. It allows organizations to define transformation rules and mappings to convert raw data into a clean, consistent, usable format. By mapping data elements and applying transformation logic, companies can improve data quality and reliability.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Business intelligence and analytics:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        '\nAny interest in getting the most accurate information possible from your data? Mapping data elements allows organizations to assess and improve data quality. By identifying inconsistencies, redundancies and errors, organizations can implement corrective measures to enhance data accuracy and consistency. Effective data mapping is critical for business intelligence and analytics initiatives.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data governance and compliance:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Data mapping contributes to data governance practices by establishing clear data lineage, metadata management, and data ownership. It supports regulatory compliance efforts by ensuring that data mappings adhere to industry standards, privacy regulations, and data security protocols. With documented data mappings and governance frameworks, organizations can maintain data integrity, transparency, and accountability across their data assets.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'System interoperability and integration:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Data mapping can also improve your workflows by helping you exchange data between different systems. Data mapping facilitates system interoperability by mapping data structures, formats and protocols between different software applications and platforms. Data mapping supports API integrations, data-sharing agreements and collaboration between internal and external stakeholders.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Decision-making and strategy:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'This is pretty obvious:',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'By having a clear understanding of how data elements are mapped and transformed, you can make decisions that drive growth and innovation. You can analyze mapped data to identify trends, patterns and opportunities which will help you measure key metrics, track business performance, and assess the impact of your decisions.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How does data mapping work?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data mapping works by establishing relationships and connections between data elements. The goal is to define how data should be transformed, converted or transferred from one format to another to ensure compatibility, accuracy and consistency.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Here's a basic overview of how data mapping works:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Identify source and target data sets:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'The first step in data mapping is to identify the source data set and target data set. The source might be a database, file, API response or any other data source and the target data set could be another database, data warehouse, application or analytics platform.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Define mapping requirements:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Next, you need to determine the specific data elements that need to be mapped from the source to the target. This includes fields, columns or entities like customer names, product IDs, dates, etc. You should define the mapping requirements based on business rules, data integration goals, transformation logic and data quality standards.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Create data mapping rules:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Once you\'ve identified the source and target data sets and determined the requirements, you want to define specific data mapping rules that specify how each data element from the source maps to its corresponding element in the target. Mapping rules be simple one-to-one mappings where a source field directly corresponds to a target field (sometimes called "source-to-target mapping") or involve complex transformations, calculations or lookups.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Perform data transformation (if necessary):\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Data transformations can be tasks like data type conversions, data formatting, data cleaning (for example, removing duplicates and correcting errors), data aggregation and deriving new fields. If data transformations are necessary, apply your defined mapping rules to transform data as it moves from the source to the target.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Handle data mapping challenges:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'Things might not go perfectly right away!',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'You’ll want to implement error handling mechanisms to identify and correct mapping errors or data validation failures to address challenges like handling discrepancies, resolving conflicts, managing data quality issues and ensuring consistency.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Validate and test data mapping:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Validate the data mapping by comparing sample data from the source and target to ensure that mappings are accurate and producing the expected results. Conduct testing and validation procedures to verify data integrity, completeness and correctness after applying mapping rules and transformations.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Execute the process:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'Show time!',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Execute the data mapping process using appropriate tools, software or scripts that support data integration, ETL (',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Extract, Transform, Load',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        '), or data migration tasks. Make sure to monitor the data mapping process for performance, scalability and efficiency.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Document the details:\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Write it down. Document the data mapping details, including mapping rules, transformations, source-to-target mappings, data lineage, metadata and any relevant information for future reference and maintenance. Maintaining comprehensive documentation to support data governance, regulatory compliance and knowledge sharing is a good idea.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By following these steps and best practices, organizations can effectively implement data mapping processes that enable seamless data integration, transformation and migration while ensuring data quality, consistency and reliability.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Common data mapping techniques',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Each data mapping technique has strengths and suits different data integration and transformation requirements. By understanding and leveraging these techniques effectively, organizations can ensure accurate and meaningful data mappings that drive success. Here are some of the most common data mapping techniques used today:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Schema mapping',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' has to do with mapping the structure and attributes of data schemas or models between source and target systems. This includes mapping tables, columns, relationships and data types. Mapping fields like "First Name" and "Last Name" from one database schema to corresponding fields in another schema is an example of schema mapping.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Value mapping ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'focuses on mapping actual data values or codes between systems. It can include translating codes or identifiers used in one system to their equivalents in another system, mapping country codes, product codes, customer IDs or currency values.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Relationship mapping',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' maps relationships or associations between data entities, like customer orders, product categories, or employee hierarchies. For example, mapping the relationship between a "Customer" entity and an "Order" entity in different databases.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Transformation mapping',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' defines the data transformations and business rules applied during data mapping, and that includes data conversions, calculations and validations.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Key challenges and considerations',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data mapping offers big benefits, but it isn’t foolproof. Some of the top challenges are:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data quality:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Ensuring data accuracy, completeness and consistency is a huge challenge in data mapping. Inaccurate or incomplete data can lead to mapping errors and unreliable insights.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Complex transformations:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Handling complicated data transformations requires careful planning and execution.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data security:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Protecting sensitive data and ensuring data privacy during data mapping processes is critical for your customers, your reputation and to avoid data breaches and compliance violations.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Scalability:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Scaling data mapping processes to handle large volumes of data and real-time data streams can be challenging and requires solid infrastructure and tools.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Version control:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Make sure you maintain version control and documentationmto track changes, revisions and updates over time.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Common data mapping solutions',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies often turn to data mapping solutions to address the challenges that come with DIY solutions. These tools and platforms offer features and capabilities that are tailored to meet diverse needs. Here are some widely used data mapping solutions:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'ETL and ELT tools',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ': ETL tools like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.oracle.com/middleware/technologies/data-integrator.html'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Oracle Data Integrator',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ', ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://airflow.apache.org/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apache Airflow',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://aws.amazon.com/glue/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'AWS Glue',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' include data mapping capabilities as part of their data integration and processing workflows. These tools help organizations extract data from source systems, transform data using mapping rules and transformations, and load transformed data into target systems. They also support batch and real-time data processing, making them suitable for a wide range of data integration use cases.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data integration solutions and iPaaS',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': These solutions enable end users to implement integrations between internal and external applications, services and data sources. Platforms like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.mulesoft.com/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'MuleSoft',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ', ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://boomi.com/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Boomi',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ', ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://frends.com/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Frends',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.google.com/aclk?sa=l&ai=DChcSEwicgL2R0KaFAxXCEa0GHcEtCUoYABAAGgJwdg&ase=2&gclid=CjwKCAjw_LOwBhBFEiwAmSEQAX56nrcdwIJVrNB5IJpMikaLhr7365T3FHNI22tSdMQ1t_cb8FyGsBoCXmwQAvD_BwE&ei=apkNZpDODvy80PEPpuikoAI&sig=AOD64_1KXkVsJmzxytiCkEr0iXElJI6ncg&q&sqi=2&nis=4&adurl&ved=2ahUKEwiQq7WR0KaFAxV8HjQIHSY0CSQQ0Qx6BAgJEAE'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Celigo',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' often offer features like graphical interfaces for designing data mappings, transformations and workflows. They also include connectors and adapters to easily connect to various data sources, applications, and systems.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data file exchange: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Even if your files come from tons of different sources in a wide variety of formats and need manual review, cleanup and validation before you can import them, a ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'data file exchange',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' solution will help you deal efficiently with all of the real-world data that you have. Platforms like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Flatfile',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' provide robust and even AI-enhanced data mapping capabilities as an integral part of their solutions.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Master data management (MDM) solutions:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' MDM solutions like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.informatica.com/products/master-data-management.html'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Informatica iMDM',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.ibm.com/products/ibm-infosphere-master-data-management'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'IBM InfoSphere MDM',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' incorporate data mapping capabilities to manage and reconcile master data across multiple domains and systems. These solutions enable organizations to create and maintain a single, trusted view of master data entities by mapping and consolidating data from disparate sources.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data quality tools:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' Data quality tools like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.talend.com/products/data-quality/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Talend Data Quality',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.oracle.com/assets/oracle-enterprise-data-quality-ds-430148.pdf'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Oracle Data Quality',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' provide data mapping features to ensure data accuracy, completeness and consistency. These tools allow users to define data mapping rules, perform data profiling and identify data quality issues during the mapping process and offer data cleaning, enrichment and deduplication capabilities.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Cloud data integration services:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' Cloud-based data integration services like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://azure.microsoft.com/en-us/products/data-factory'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Azure Data Factory',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://cloud.google.com/dataflow'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Cloud Dataflow',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' offer data mapping solutions in a cloud-native environment. These services provide scalable and flexible data integration capabilities, including data mapping, transformation, orchestration, and scheduling. They use cloud infrastructure and services to handle big volumes of data and can support hybrid and multi-cloud data integration.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Open source data mapping tools:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' Open source data mapping tools like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://nifi.apache.org/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apache Nifi',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://github.com/pentaho/pentaho-kettle'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Pentaho Data Integration (Kettle)',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' offer cost-effective solutions for designing and executing data mappings. These tools offer features like graphical interfaces, support for various data formats and protocols and ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-7-open-source-csv-import-libraries/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'community-driven',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' development.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Best practices for data mapping',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are a number of data mapping best practices, but these are the most important ones to keep in mind:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Understand data requirements:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Start by thoroughly understanding the requirements, business rules and objectives of your project.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Document mapping rules:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Make sure you document mapping rules, transformations and metadata for transparency and consistency.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data profiling:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Conduct data profiling to analyze data quality, patterns and relationships before you map data elements.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Use automation tools:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Use mapping tools and platforms that help you automate processes and reduce errors.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data validation:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Implement data validation checks to ensure accuracy.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Collaborate across teams:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/secret-to-modernizing-your-data-stack/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Foster collaboration',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' between data teams, business stakeholders and IT teams to make sure your mapping efforts are aligned with business objectives.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Monitor and maintain:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Continuously monitor data mappings, track data lineage and perform regular maintenance to address your needs as they evolve.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What happens if you don’t use data mapping?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you don't use data mapping, you could face some pretty tough consequences. Here are just some potential outcomes:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data inconsistency:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Without data mapping, different systems might interpret data differently, leading to ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'inconsistencies in data formats',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' and naming conventions. This can result in data duplication, data errors and conflicting information.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data silos:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' The absence of data mapping can contribute to the creation of data silos, where data is isolated and fragmented. This hinders data accessibility, collaboration and integration efforts, limiting your ability to derive insights.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Integration challenges:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'Integrating data from multiple sources is challenging',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' without data mapping, and it can cause delays, inefficiencies and increased operational costs.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data quality issues:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data mapping plays an important role in data quality assurance. Without proper mapping rules and transformations, data quality issues like duplicate records, inconsistent data formats and missing values can erode the reliability and accuracy of your data.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Misaligned business processes:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data mapping aligns data elements with business processes and objectives. Without mapping, there can be misalignment between data captured by systems and the information you need for decision-making, reporting and analytics.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ineffective analytics:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data mapping is essential for creating structured, mapped data sets that are suitable for analytics and reporting. Without mapped data, analytics will almost certainly offer incomplete or inaccurate insights.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Compliance risks:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data mapping is crucial for ensuring data governance and regulatory compliance. Without mapping, you’ll probably struggle to track data lineage, maintain data documentation and enforce data privacy and security measures (which will expose you to compliance risks and penalties).',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Operational inefficiencies:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Without data mapping, tasks like data migration, data cleaning and data integration are usually inefficient and labor-intensive. This tends to lead to increased labor costs, data processing errors and operational bottlenecks.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Limited data integration flexibility:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data mapping offers flexibility in integrating data from diverse sources and systems. Without mapping, you can face limitations in adapting to changing data sources, business requirements and technological advancements.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Missed opportunities:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Ultimately, not using data mapping will result in missed opportunities to leverage data as a strategic asset. You will probably fail to capitalize on data-driven insights, competitive advantages and growth opportunities.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By understanding the principles, techniques, challenges and best practices of data mapping, you’ll have an easier time staying competitive.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Mapping that’s magical',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If all of this seems overwhelming, remember that you aren’t required to implement data mapping on your own! There are tools and solutions that can handle the data mapping process for you, and they often include powerful automations and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'AI-enhanced features',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that can streamline your entire data integration process. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', for example, can help you ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'automatically generate rules for moving data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' between any two schemas and can easily map any two datasets. Trained on billions of user decisions, Flatfile’s mapping engine, for example, can convert data in seconds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Flatfile's interface allows you to ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.flatfile.com/en/articles/8411646-importing-data-with-flatfile-overview'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'easily upload and map your data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' from various sources, including spreadsheets, CSV files, and more with just a few clicks, which will save you time and reduce the amount of manual work you need to do.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile also offers transformations that can detect and re-create nested records in a flattened file. If you have complex requirements, you can extend rule gen with custom logic by creating your own data logic that’s written in code. Plus, because it’s trained on years of data file imports, Flatfile’s AI-based column matching provides impressive accuracy and can remember what your customers do, putting everything where it belongs, automatically.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Using mapping choices recorded from 1.8 billion (and counting!) rows processed in Flatfile, we’ve trained a machine learning model that will work alongside the memory of your and your colleagues’ past selections to accurately predict more than 90% of matching actions. These mappings can reduce the number of actions you need to make.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You can also use smart rules that help you restructure your data as needed with recommendations from our AI model that’s pre-trained on hundreds of millions of user mapping decisions. With smart rules, you can automatically:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Assign values from one column to another:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Flatfile can automatically alias source values to properties in the destination schema.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Merge multiple columns into one destination:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' When your destination model has a single property to assign values to but the source provides multiple destinations, Flatfile knows how to provide either ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'Array',
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' or ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'Concat',
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: '.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Map data to nested records:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' For collections of values, Flatfile can turn columns into an array of nested objects (or inversely, turn a collection of objects into a flattened structure).',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Use patterns to get parts of data from a source:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Easily extract substrings from source data using exact pattern matching or use regular expressions for more complex needs.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Combine multiple values with a formula:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Create text based values from multiple columns. For example, combine street, city, state and zip into a fully formatted address column.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Compute a final value from source data:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Generate numerical values using your own custom formulas, utilizing multiple columns.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Apply a default value to a column:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Apply default values wherever you’re missing data or have empty data.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Apply predefined changes to any field:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Apply any standard text based transformations to your data such as case conversion, replacing special characters, or URL encoding.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You don’t need to know how to build robust data mapping capabilities yourself. Flatfile understands your data, not just your schema, and can help you go beyond simple mapping rules with AI that understands the meaning and context of your data. You can define ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'what',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' you want to do, and Flatfile will take care of the how. If you’re interested in learning more about how Flatfile can help you with your data mapping needs, you can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/mapping/sign-up/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'get your API key and start mapping now, for free',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'get a custom demo',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for your specific use case.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '9YnKIwrHP4kBpvKoEX7ta',
    postTitle: 'Flatfile awarded 23 Spring 2024 G2 Badges ',
    seoTitle: 'Flatfile awarded 23 G2 Badges ',
    seoUrlSlug: 'flatfile-awarded-23-spring-2024-g2-badges',
    seoMetaDescription: 'Flatfile awarded 23 Spring 2024 G2 Badges',
    category: 'Flatfile news',
    tags: ['G2', 'G2 badges', 'Featured', '2024'],
    sortOrder: '2',
    publishDate: '2024-04-10T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1DvyMw5QecN4zUGd56FazQ',
        type: 'Asset',
        createdAt: '2024-04-09T22:12:58.543Z',
        updatedAt: '2024-04-10T15:21:31.854Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 15,
        revision: 3,
        locale: 'en-US'
      },
      fields: {
        title: 'Spring 2024 G2 Badges',
        description:
          '"Flatfile awarded 23 G2 Badges" on a white background with an icon representing a G2 badge',
        file: {
          url: '/img/contentful/1DvyMw5Q-blog_post_-_spring_2024_g2_badges.webp',
          details: {
            size: 51362,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - Spring 2024 G2 Badges.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Flatfile awarded 23 G2 Badges" on a white background with an icon representing a G2 badge',
    summary:
      "We're excited and honored to announce that Flatfile has been awarded 23 G2 Badges for Spring 2024.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3CihjjFSaXut3Hb9eI0XVM',
        type: 'Entry',
        createdAt: '2021-10-28T15:29:06.628Z',
        updatedAt: '2021-10-28T15:29:06.628Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Becca Weiss',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1BLXrFTRCL0lKeEq9FSYym',
            type: 'Asset',
            createdAt: '2021-10-28T15:28:39.305Z',
            updatedAt: '2021-10-28T15:28:39.305Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Becca Weiss headshot',
            description: 'Becca Weiss headshot',
            file: {
              url: '/img/contentful/1BLXrFTR-197-0-4.webp',
              details: {
                size: 31079,
                image: {
                  width: 170,
                  height: 170
                }
              },
              fileName: '197-0-4.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Director of Customer Success & Implementation',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Most companies say something like, "Customers are at the core of our product" or "We wear our customer\'s shoes," but it doesn\'t always feel like that, does it? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "While most companies see customer support as a cost center, we see it as the backbone of our business. It's a company-wide effort to make sure our customers are always feeling the Flatfile love. We want you to be excited to talk to us because you know it will be painless, incredibly helpful, and maybe even a little entertaining.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "That's why we're so excited and honored to announce that Flatfile has been awarded an impressive 23 G2 Badges for Spring 2024. ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.g2.com/products/flatfile/reviews'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'G2 scores products and vendors',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' based on reviews gathered from its user community (100% of whom rate Flatfile 4 or 5 stars out of 5!) and data from online sources and social networks, and applies its algorithm to calculate customer satisfaction and market presence scores.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Some of our Spring 2024 G2 badges include:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Data Exchange platforms: Easiest to do business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Exchange platforms: High performer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Preparation: Easiest to do business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Preparation: Highest user adoption',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Preparation: High performer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Quality: Best support',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Quality: Easiest Setup',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Quality: Easiest to do business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Quality: Easiest to use',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Quality: Highest user adoption',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data Quality: High performer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Embedded Integration platform: Best meets requirements',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Embedded Integration platform: Easiest to do business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Embedded Integration platform: High Performer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "This is particularly exciting after a year of momentous updates and changes. It's been a ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/2023-wrapped-a-year-of-remarkable-growth-and-innovation/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'landmark year for us',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " with our launch of the Flatfile Data Exchange Platform, and being awarded these badges is a sign that you're as excited about our improvements as we are. Your feedback drives our progress, and we take every piece of it to heart. We're proud to see that we're meeting your expectations and that we’re helping you easily create your ideal ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data file exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' experiences.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7ETCmdNIdATh29qvAd1Vgf',
    postTitle: 'Flatfile helps Inkit save $100K+ in data import costs',
    seoTitle: 'Flatfile helps Inkit save $100K+',
    seoUrlSlug: 'saving-inkit-100k-per-year-data-import-costs-flatfile-portal',
    seoMetaDescription:
      'Inkit integrated Flatfile’s data onboarding platform, saving $100K+ in engineering costs.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer story'],
    publishDate: '2024-04-05T09:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4HjiCQXDpzMLNJEiIjzrJH',
        type: 'Asset',
        createdAt: '2024-04-05T16:17:34.069Z',
        updatedAt: '2024-04-06T02:43:35.496Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Inkit saves $110K+ in data import costs with Flatfile',
        description:
          '"Inkit saves $110K+ in data import costs with Flatfile" on a white background with a chart representing money savings',
        file: {
          url: '/img/contentful/4HjiCQXD-inkit-featured-image.webp',
          details: {
            size: 55487,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Inkit-featured-image.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Inkit saves $110K+ in data import costs with Flatfile" on a white background with a chart representing money savings',
    summary:
      'Rather than relying on an outdated homebuilt data import tool, Inkit integrated Flatfile’s data onboarding platform, saving $100K+ in engineering costs.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It's easy to forget about the offline conversations that are critical to how companies run their businesses now that we live in a heavily digital world. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Unlike other platforms in their space, Inkit strives to eliminate the manual work involved in managing online-to-offline programs. With Inkit, every action can be automated, tracked, and analyzed in one place. The process requires less time and people overhead, resulting in cost savings and a faster time to market for Inkit's customers.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'In this post, we examine:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/saving-inkit-100k-per-year-data-import-costs-flatfile-portal/#whenBuyVsBuildIsTheBestOption'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'When buy vs. build is the best option',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/saving-inkit-100k-per-year-data-import-costs-flatfile-portal/#theDataImportRoi'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'The data import ROI',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'When buy vs. build is the best option',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Inkit's personalized and targeted direct mail approach has had a massive impact on its clients. Some of them, like ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://naturebox.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Naturebox',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", have increased revenue-per-customer by 60 percent using Inkit's automated re-engagement system. Inkit is a SaaS product that directly addresses this gap with consumers. It automates direct mail to connect hundreds of digital applications (like ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.salesforce.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Salesforce',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.hubspot.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'HubSpot',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', or ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.braze.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Braze',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ') with printers, brokers, and postal services. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Inkit frequently needed to work with customers directly to fix import issues and the Inkit team would frequently run into a variety of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'problematic edge cases',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' around data imports. With one client, they found files with a German location had EU-encoded files that could not be imported at all.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'From improper file types to bad data inputs, Inkit reached the point where the company was spending several hours a day addressing ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data import issues',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. Building their own import tool was not only ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'bogging down development resources',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', but customer support at Inkit was being stretched thin, handling data import requests left and right. As Inkit scaled, the customer support team became overwhelmed with import-related requests. By the time they came to Flatfile, the team was spending roughly 30 hours a week answering support tickets directly related to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data import challenges',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "To use Inkit's direct mail automation solution, customers need to import their clients' data from a CRM (Customer Relationship Management) platform. To handle data import, Inkit developed its own tool internally, but it quickly became apparent that the ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/making-a-build-vs-buy-decision-part-1'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'build-your-own-solution route',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' was not working well—for Inkit internally as well as its customer base.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Michael McCarthy, CEO of Inkit, describes what brought them to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ': ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '"We home-built our uploader. It was very problematic if customers uploaded files that didn\'t meet our requirements. We had to give them our exact specifications, which ended up being a huge bottleneck. Any time someone would upload a file that was not encoded properly, everything would break."',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once Inkit realized the extent to which they were losing precious productivity hours on data imports for their customers, McCarthy ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-checklist-how-to-choose-ideal-solution/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'sought a solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". Enter Flatfile. It took Inkit one week to implement Flatfile's data onboarding platform with their React front-end framework.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TeslTqcCH6G3Jjogccn9K',
                type: 'Entry',
                createdAt: '2024-01-12T01:22:24.597Z',
                updatedAt: '2024-01-12T01:22:24.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Connect with an expert',
                text: 'Evaluating Flatfile for your business needs?',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '"We were in such a bind--we bought the Flatfile\'s data onboarding platform immediately after a quick demonstration and a look at the API documentation," said McCarthy. "It was really easy once we got it up and running and a huge time saver across the board. It didn\'t make sense to continue to invest our resources on building and maintaining this core yet secondary part of our product. We stopped spending time on data import issues and now see a 100 percent data import success rate. Flatfile exceeded our expectations."',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With Flatfile up and running, Inkit no longer needs to deal with data import support tickets from customers and focuses on their more important product-related success, which has greatly impacted their business.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '"Six or seven of our clients actually had weekly issues," said McCarthy. "After adding Flatfile, all of them stopped sending in tickets for help."',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn more about the Flatfile Data Exchange Platform? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'See how it works',
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'bold'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The data import ROI',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When it comes to the return on investment of Flatfile's data onboarding platform, McCarthy went on to say:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "\"A viable data import solution easily represents a hundred thousand dollars a year in savings for Inkit. We had two clients that were paying upwards of $30,000 a year and were at risk to churn if we didn't figure this data import issue out. There's also a ton of engineering time that we saved by partnering with Flatfile. Without Flatfile, we would have had to dedicate one or two full time engineers to the development and maintenance of an internal data import solution, and honestly, it would never have been as good as Flatfile's product. I could see a bigger company looking at a million dollars a year in cost savings.\"",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '"Thanks to Flatfile, we were able to deliver a 10X better product and save hundreds of thousands of dollars."',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Inkit',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.inkit.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Inkit',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " helps companies connect to hundreds of printers with complete visibility. Instantly leverage global print infrastructure with Inkit's developer friendly APIs, dashboards, and reporting. Connect, track, and manage critical business communications faster than ever before.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Flatfile',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Flatfile's mission is to ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'remove barriers between humans and data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'automatically learns',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile's data onboarding platform, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'reach out to our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or get started for free at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flatfile.com',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: '.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2020 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '31qaBPoQeUJJCZeWR6SVe6',
    postTitle: 'Welcome to the new Flatfile dashboard ',
    seoTitle: 'The new Flatfile dashboard ',
    seoUrlSlug: 'new-flatfile-dashboard',
    seoMetaDescription:
      'Our brand-new dashboard makes creating powerful data import experiences much easier.',
    category: 'Product updates & features',
    tags: [
      'Product updates',
      'Features',
      'New releases',
      'Developers',
      'Featured'
    ],
    sortOrder: '5',
    publishDate: '2024-04-04T14:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2lbnZ6LrdLNmlEROsJVUtR',
        type: 'Asset',
        createdAt: '2024-04-04T20:33:43.906Z',
        updatedAt: '2024-04-04T21:38:09.962Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'New Flatfile dashboard',
        description:
          'The new Flatfile dashboard on a white background with icons representing a dashboard',
        file: {
          url: '/img/contentful/2lbnZ6Lr-blog_-_new_dashboard__1_.webp',
          details: {
            size: 84719,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog - New Dashboard (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'The new Flatfile dashboard on a white background with icons representing a dashboard',
    summary:
      "Our brand-new dashboard makes creating powerful data import experiences much easier, whether you're getting started or looking for new ways to manage, monitor and organize your data import activities. ",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "We've made significant improvements to the Flatfile Data Exchange Platform, and we're excited to share them with you. Our brand-new dashboard makes creating powerful data import experiences much easier, whether you're just getting started or looking for new ways to manage, monitor and organize your data import activities. If you're an existing user of the Platform, you'll see that a few things have moved, so take a minute to read through this post to find out what's changed.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4YWHQoFiVxjV0EYVIPfoTo',
                type: 'Entry',
                createdAt: '2024-04-05T18:24:45.478Z',
                updatedAt: '2024-04-05T18:25:48.694Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'iframe'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Welcome to Dashboard Video',
                src: 'https://demo.arcade.software/ilW6Suu2sIK4bGsk8Gt2?embed&show_copy_link=true',
                height: 518,
                width: 800,
                name: 'Welcome to Dashboard Video'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Platform Apps',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'SrTvCkz8GgMkfTkL1bUw8',
                type: 'Asset',
                createdAt: '2024-04-04T20:14:42.794Z',
                updatedAt: '2024-04-04T21:43:02.499Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Dashboard image -1',
                description: 'Welcome to the new dashboard',
                file: {
                  url: '/img/contentful/SrTvCkz8-landing.webp',
                  details: {
                    size: 25496,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'Landing.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Our latest dashboard update introduces a selection of pre-built apps, offering developers a streamlined approach to customizing their Flatfile experience. These apps are crafted to cater to common use cases, enabling you to dive right in and utilize the platform in the most effective way possible.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For those already familiar with Flatfile Spaces, you can think of Apps as specialized folders that group related Spaces together, giving you a tailored view of your data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Plus, with detailed usage metrics for each app, you can easily track progress towards your specific objectives, making it simpler to manage and evaluate the success of the goals for specific Spaces.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Monitor your Jobs',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '45iFggKhXxL6UVXj8AtSyV',
                type: 'Asset',
                createdAt: '2024-04-04T20:15:45.004Z',
                updatedAt: '2024-04-04T21:44:45.946Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 18,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Dashboard image -2',
                description: 'Progress bar - new dashboard',
                file: {
                  url: '/img/contentful/45iFggKh-jobs2.webp',
                  details: {
                    size: 23476,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'Jobs2.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '\nIn Flatfile, a Job is an asynchronous task performed on various resources, including files, Workbooks, or Sheets. Now, you have the capability to effortlessly track the progress and performance of jobs, enabling quick identification and resolution of any potential issues.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For each job, details such as the job’s status, the duration it ran for, and whether it operated in the foreground or background are displayed, providing a comprehensive view of your data processing activities.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'See your Agents',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '61zmFMwFiYbHixi2WdUGG5',
                type: 'Asset',
                createdAt: '2024-04-04T20:16:40.607Z',
                updatedAt: '2024-04-04T21:45:13.757Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Dashboard image -4',
                description: 'New dashboard: Agents',
                file: {
                  url: '/img/contentful/61zmFMwF-agents_-_specific_size.webp',
                  details: {
                    size: 14902,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'Agents - Specific Size.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Listeners form the backbone of the Flatfile Platform, encapsulating the essential logic that powers your Flatfile Spaces. They dictate the capabilities of your setup, encompassing everything from data transformations and custom styling to data egress.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Listeners are bundled and deployed as Agents to the Flatfile cloud. With the latest update to the Flatfile CLI, you're now able to deploy multiple agents per environment, allowing for better code organization. Moreover, the dashboard has been upgraded to allow you to effortlessly view and manage all your deployed agents and their event topics, removing the necessity to hit the API to see what’s deployed where.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Enhanced monitoring for Portal',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2R4g42aBJpDgT8NHvxD5DA',
                type: 'Asset',
                createdAt: '2024-04-04T20:17:23.896Z',
                updatedAt: '2024-04-04T21:45:48.107Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 10,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Dashboard image -5',
                description: 'New dashboard: Monitoring',
                file: {
                  url: '/img/contentful/2R4g42aB-spaces2.webp',
                  details: {
                    size: 65950,
                    image: {
                      width: 1300,
                      height: 720
                    }
                  },
                  fileName: 'Spaces2.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Everyone loves a good chart!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In the new dashboard, you’ll now see summary charts and graphs to monitor Portal usage, assess cost-effectiveness, and gain insights into user experiences for continuous improvement.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'These charts include things like:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Files uploaded',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ": This is where you can see a count of all uploaded files, including those that didn't complete field mapping. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'PDV',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': This is a count of the Processed Data Values (PDVs) in all of your Flatfile Workbooks. PDVs are the total data points, akin to spreadsheet cells, which are determined by the product of rows and columns. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'File uploaders',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': This tracks the total number of users who uploaded files, covering completed and incomplete field mapping sessions. For anonymous guests, a user is counted once per session. If they exit and start a new session, they’re counted again.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Match accuracy: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'This',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'indicates the percentage of fields accurately auto-mapped by our system. Mappings accepted by end users increase accuracy, while incorrect mappings, including those that should have been ignored, decrease it.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Wish for something else? Let us know, we are actively building more data visualizations and want to hear from you. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Ready to get started?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There’s actually nothing you have to do: all users will be automatically upgraded to the new dashboard. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'Don’t worry, absolutely zero code changes or migrations are necessary',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. The prior version of the dashboard will continue to be available for the remainder of the month, and during that time, users will be able to switch between the two versions. On May 1, all remaining old dashboards will be upgraded to the new dashboard.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Questions?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you have questions or want to learn more, contact our friendly  support team at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'support@flatfile.com',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' for all the answers.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '5VrHPWnDEGMMkeEX80Ue20',
    postTitle: 'Data normalization: Manual vs. automatic',
    seoTitle: 'Data normalization: Manual vs. automatic',
    seoUrlSlug: 'data-normalization-manual-vs-automatic',
    seoMetaDescription:
      "Data normalization is essential for clean, usable data. Find out why it's important and how it can be done automatically.",
    category: 'Data exchange',
    tags: ['Data normalization', 'Normalize data'],
    publishDate: '2024-03-29T11:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1cuqp8BbC3PUKWX4joGS7x',
        type: 'Asset',
        createdAt: '2024-03-29T17:07:52.652Z',
        updatedAt: '2024-03-29T17:07:52.652Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data normalization',
        description:
          'Data normalization concept with icons representing duplicates, errors and normalized data',
        file: {
          url: '/img/contentful/1cuqp8Bb-data_normalization.webp',
          details: {
            size: 37213,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Data normalization.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Data normalization concept with icons representing duplicates, errors and normalized data',
    summary:
      'Data normalization is essential for clean, usable data especially for customer onboarding functions. Find out how it can be done automatically instead of manually.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It's not easy to manage your data effectively, but techniques like data normalization can really help. Data in databases can reside in multiple tables, each representing different entities or concepts and redundancy is a common issue when the same data is stored in multiple places. Of course, redundancy can lead to inefficiency and an elevated risk of inconsistent data. Data normalization addresses these challenges by structuring data logically, eliminating redundancy, and ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'maintaining relationships between entities',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data normalization helps reduce redundant data and improve data integrity, and it's critical for customer ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". Without proper data normalization, data quality issues are plentiful so customers can't get much use out of the data they import. The result is time spent updating data to where they can’t achieve what they want out of your platform. Of course, this inevitably could ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'lead to customer churn',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With most data importers, building data normalization functionality is labor intensive. Thankfully, it can be done ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'automatically',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' instead of manually, so you no longer have to put customer experience at risk in order to save time.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What are the goals of data normalization?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Eliminating data redundancy',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Reducing duplicate data minimizes storage space and ensures consistency across the database.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Preventing data anomalies',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Data anomalies such as insertion, update, and deletion anomalies can occur when data is not normalized. Normalization helps mitigate these risks.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ensuring data integrity',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'By organizing data logically and enforcing rules, data integrity is preserved, and accuracy is maintained.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can tackle data normalization and accelerate your data workflow? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your data challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data normalization helps reduce redundant data and improves data integrity. It's critical for customer ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". Without proper data normalization, data quality issues are almost guaranteed, which means customers won't get much use out of the data they import. As a result, they spend too much of their available time updating data and are less likely to achieve the results promised by your platform. Of course, this often ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'leads to customer churn',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "With most data importers, building data normalization functionality is labor-intensive. Thankfully, it doesn't have to be. It can be done automatically, which means that you no longer have to put customer experience at risk to save time.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In this post, we dive into the definition of data normalization, why it matters, and your options when it comes to importing data, covering: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What is data normalization?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Why is data normalization important?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Do you always need to normalize data?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The two primary data normalization methods',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is data normalization?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are lots of slightly varied definitions, but when it comes down to it, data normalization is about organizing data in a database so that internal teams can easily use the database for queries and analysis. Database normalization represents a systematic approach to composing tables to eliminate data redundancy and is a multi-step process that puts data into tabular form, removing the duplicate data from its relational tables. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://en.wikipedia.org/wiki/Database_normalization'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Normalized databases',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' make creating, updating, and deleting rows significantly easier while ensuring data consistency and decreasing redundancy. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data normalization is especially important when importing data into a product, such as in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/flatfileio-helps-clickup-simplify-users-data-import-onboarding-experience/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'customer data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why is data normalization important?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Is data normalization really important? Or is it okay to build a CSV importer or other data import experience without data normalization baked in?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Database normalization is important for a few key reasons:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Eliminating repeated data = more space and better performance:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        " Repeated data in any software system can cause major disruptions during subsequent transactions and requests. Once duplicates are eliminated, there's more space in the database. Not only is there additional space, but without duplicate data, systems will run smoother and faster. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Get the answers you need:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        ' Once errors and redundant data are gone, the data is clean and can be organized more easily. Now that a company has organized data to work with, data analysis can happen much faster. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When it comes down to it, there has to be some form of logic with how your database is organized. If you have large sets of unorganized data, it goes to waste. It can't be merged, let alone properly utilized. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If a table is not properly normalized and has redundancies, it will not only eat up the extra memory space but also make it ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'challenging to handle database updates',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Without data normalization, you ultimately cause problems for your customers when they try to utilize the data they've ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'imported into your system',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. There can be endless data anomalies that make the database dtoo large and messy to be useful. An example of a data anomaly would be if you have an employee management system and you upload a CSV file of all employees with their managerial role written individually instead of being one form of data (role) that gets linked to the employee. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If the name of a specific role gets changed, it needs to be updated with every affected employee record instead of being changed once. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "All in all, it's critical to normalize data: updates run faster, data insertion is faster, there are smaller tables, and data is more consistent. For these reasons, a fully normalized database is always worth achieving. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When it comes to importing data and data onboarding, a lack of data normalization leads to a never-ending string of data quality problems.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Do you always need to normalize data?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Is normalizing data always necessary? Though very rare, there can be cases where you don't need to normalize data. For example, you might not normalize data because your application is read-intensive, meaning that it predominantly reads databases rather than writes. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When an application is read-intensive, normalized data can complicate the queries and make the read times slower because the data is not duplicated, necessitating table joins. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Table joins can also make indexing slower, which again makes read times slower.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If your goal is data integrity and consistency, however, database normalization is a must!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The two primary data normalization methods',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When most software engineers think of data normalization, they assume it's all manual work, but another option exists. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Manual data normalization',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Building data normalization into your ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/csv-import-tool-or-data-file-exchange-solution-how-to-pick-the-right-one-for/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'CSV importer',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " is a lot of work. Since database normalization completely changes the way table schemas are designed, it's a tedious process to go through if it's not performed correctly. You need to ensure that",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'There are no repeating forms of data',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Attributes are correctly dependent on their ',
                      marks: [],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'http://agiledata.org/essays/dataNormalization.html#1NF'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'primary key',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Teams can put the burden of manual data normalization on customers and users and require them to fix all the data quality errors if a data importer doesn't have a data normalization feature. However, having customers update data after error messages pop up as they try to import data is a terrible customer experience.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To avoid this, companies too often put the responsibility on the customer who is importing the data by having them read through a lot of complicated CSV documentation or download a CSV template and then force their data to fit into it. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If engineering teams do take on creating a data normalization feature for a data importer to help with customer data onboarding, then they could end up building something that is just as time-consuming to create as the core product they're building that customers are actually paying for. The battle of manual vs. automatic is usually a question of where you want engineers to spend time.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Automatic data normalization',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A new emerging technology helps teams save huge amounts of time on quality customer data onboarding. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'The Flatfile Data Exchange Platform',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " includes advanced import functionality like data normalization, auto-column matching, data hooks, and more. Flatfile's data onboarding platform can also be implemented in as quickly as a day instead of 3-4 engineering sprints.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Why spend months building a data importer you can implement in one day? Flatfile, the pioneer of AI-assisted data exchange, provides companies and their software development teams with the easiest, fastest, and safest way to build the ideal data file import experience for their users. If you aren't sure what the right solution is for your business, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'contact Flatfile today',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". We've worked with hundreds of customers to solve their data exchange challenges, and we can help you build the solution that's right for you.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data normalization is critical for ensuring data redundancies don't occur and that your team can work effectively with clean data. With most ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' experiences, data normalization needs to be explicitly built into the data importer as a feature.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The choice between manual and automatic is up to you! ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2020 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'zyAz4edQma5RANgHpWohk',
    postTitle: 'Data onboarding: The complete guide',
    seoTitle: 'Data onboarding: The complete guide',
    seoUrlSlug: 'what-is-data-onboarding-everything-you-need-to-know',
    seoMetaDescription:
      "What is data onboarding and how does it work? Here's everything you need to know about creating a successful data onboarding process.",
    category: 'Data exchange',
    tags: [
      'Customer onboarding',
      'Data onboarding process',
      'Data onboarding',
      'Data import'
    ],
    sortOrder: '10',
    publishDate: '2024-03-22T10:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3Dz1kvJCPk8LIOZIzikB1e',
        type: 'Asset',
        createdAt: '2024-03-22T16:36:48.376Z',
        updatedAt: '2024-03-22T16:36:48.376Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'What Is Data Onboarding',
        description:
          'Data onboarding concept: Icons representing different file types being added to a spreadsheet',
        file: {
          url: '/img/contentful/3Dz1kvJC-what_is_data_onboarding_.webp',
          details: {
            size: 41872,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'What Is Data Onboarding_.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Data onboarding process concept: Icons representing different file types being added to a spreadsheet',
    summary:
      "What is data onboarding and how does it work? Here's everything you need to know about creating a successful data onboarding process.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'What is data onboarding, and how does it work? This post will teach you everything you need to know.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Let's say you built a new SaaS platform. Congratulations! It's a hit, and your new customers are excited to start using it. However, a software application is just an empty box until data is ingested into the product. Without their ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data inside that software',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", your customers can't get much value. For many types of solutions, they won't be able to achieve anything at all until that data is actually usable. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data onboarding is the process of importing customer data into a product.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'This post explains:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/#whatIsDataOnboarding'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'What data onboarding is',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/#howDataOnboardingWorks'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'How data onboarding works',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/#whoHandlesDataOnboarding'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Who handles data onboarding',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/#elementsOfAnEffectiveDataOnboardingStrategy'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'Key elements of an effective onboarding strategy',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/#toolsAndResources'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Important tools and resources',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/#whyDataOnboardingShouldBeContinuallyImproved'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Why data onboarding is important',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is data onboarding?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data onboarding, sometimes called "data migration," "data upload" or "data import," is all about collecting, uploading, matching and validating customer data for use in a product. Data needs to be brought into the new software solution and made readily available so customers can use the product. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is a critical part of the customer onboarding experience, as is customer onboarding, which is the process of helping new customers using a new product or service improve their success rates. Industries such as marketing, HR, manufacturing, healthcare, and e-commerce usually provide customers new to their software products with onboarding, including data onboarding. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '25gVxnobRnOZ1Ssg7WHpub',
                type: 'Entry',
                createdAt: '2021-08-13T21:53:47.725Z',
                updatedAt: '2024-07-30T23:58:59.586Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 44,
                revision: 8,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Evaluating Flatfile for your business needs?',
                text: 'Reach out to our experts today to scope your data conversion, onboarding and migration processes',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is customer data onboarding?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Customer data onboarding is the process that ensures customer data is ready to use. Depending on the solution the customer used before your software product, the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " can range from fairly easy to complex. If, for example, a customer has offline data spread across multiple employees and departments, it's much more challenging to move that to an online environment than switching over to your tool from a competitor's offering.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How data onboarding works',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data onboarding is essential for a successful software product. You want to make bringing in customer data as easy as possible. It's such an essential part of any customer onboarding strategy that you can't really separate the two.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Unless your software is for brand new businesses (a website builder for first-time e-commerce store owners, for example), then you have to onboard the customer's ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'data',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' before you can truly onboard the customer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Here are some possible sources of data:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Migration from other software products:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Many companies make it easy for customers to import their data from a competitor, like switching from one platform to another. Check out this example from ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://docs.clickup.com/en/articles/1201603-importing-from-trello'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'ClickUp',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ', which has direct integration with ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://trello.com/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Trello',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' to ensure that importing tasks takes just a few minutes. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Importing spreadsheets and other file types:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'If customers previously managed data in spreadsheets, they can upload them with a',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'http://flatfile.com/platform/data-onboarding/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: ' ',
                          marks: [],
                          data: {}
                        },
                        {
                          nodeType: 'text',
                          value: 'data importer',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ', which will need to match and validate the data. For example, the owner of a martial arts school might switch from recording student memberships in Excel to bringing that data into ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.maonrails.com/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'gym membership software',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Going from offline data to online:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "In other instances, it will be necessary to onboard data that's completely offline and analog. A nursing educator, for example, might be tracking skills tests with pen and paper and now needs to enter that data into the new skills matrix software.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Mixed sources:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'In some cases, both online and offline data must be onboarded into a product. The main challenge here is to ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'match the digital and analog records',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        " using some identifying information. This is a common issue for 'phygital' (combined 'physical' and 'digital') stores that need to upload the data of their offline customers into a CRM and match it with their online transactions.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Who handles data onboarding?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'So, who owns data onboarding, and whose responsibility is it? The answer depends on your product, your price point, target market and other factors. In most cases, a combination of your engineering team, customer success representatives, and customers will handle the data onboarding process.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Product managers: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Product managers are in charge of discovering the gap between the current data onboarding experience and what customers want it to be. Then, ideally, they devise solutions for improving it.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Customer success:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'For enterprise customers and customers on higher-tier product plans, a customer success team will likely be involved in some form of ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'http://flatfile.com/platform/data-onboarding/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'collaborative data onboarding',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        },
                        {
                          nodeType: 'text',
                          value: '.',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Engineering:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'For more self-serve products, offering productized data onboarding and data importing is essential. This often results in developers and engineers building out a data importer to help customers onboard their own data.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Customers:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "Of course, customers will also have their part to play. While you'll want to make it as easy as possible for them, customers may still be required to gather their data, prep it and upload it into the product. Companies might offer CSV import templates or some kind of how-to guide and/or video to show a customer how to onboard their data. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'All of these parties come together in the data onboarding process, which usually includes these steps:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4ahtqXa2tjN6db3OmA0l9V',
                type: 'Asset',
                createdAt: '2021-08-24T16:51:53.328Z',
                updatedAt: '2021-08-24T16:51:53.328Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding steps',
                description: 'Data onboarding steps',
                file: {
                  url: '/img/contentful/4ahtqXa2-jl1pznjrn6qc7nkzpmnb.webp',
                  details: {
                    size: 10632,
                    image: {
                      width: 1320,
                      height: 120
                    }
                  },
                  fileName: 'jl1pznJRN6QC7NKzpMNB',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data collection: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'The customer success team or product guides will help customers know what to collect.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data cleaning and organizing: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Customers might need to do some basic formatting or consolidating of files.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data uploading: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'Customers should be able to use a high-quality ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'CSV importer',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' that makes the data as usable as possible. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data validation: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'The CSV import will validate the data and require the customer (or customer success manager) to make any necessary changes.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You can personalize the entire process by correctly allocating the responsibilities to the right people. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "For example, a business that serves enterprise customers will require involvement from customer success and the right customer contacts to onboard data. Meanwhile, a SaaS business that serves small business owners won't have the budget for white glove customer service and so will put as much of the onboarding process as possible on the product and engineering team so that data onboarding is fairly simple for customers. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The ideal ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/flatfiles-developer-friendly-data-importer-saves-halliganio-weeks-of-effort/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'onboarding workflow',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' has everything to do with customer expectations and pricing models.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Elements of an effective data onboarding strategy',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Whether it's importing CRM data or inventory SKUs, importing data into applications is often a frustrating experience. Let's look at some best practices for improving the onboarding experience you offer to customers. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce the need for guides and tutorials:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "Don't require customers to read extensive guides or watch long videos to understand how to onboard their data. Make the process simple by design. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Use pre-built data onboarding solutions:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Instead of worrying about dedicating engineering time and resources to improving your data importer, explore what ready-made solutions are on the market that you can integrate into your product. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Make sure error messages are helpful:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'One tenet of successful self-service data onboarding is detailed error messages. The more exact these can be, the more likely customers are to be able to fix issues themselves and try again. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Conduct user testing:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "Don't save testing and customer validation for your core product and only assign basic QA to the data onboarding side of things. Instead, record sessions with new users to learn how effective your onboarding truly is. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce bottlenecks:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "The bottlenecks in customer onboarding nearly always involve the collection of customer data. If customers onboard their own data, help them prioritize what data is essential and what doesn't need to be onboarded. If CSMs assist in data onboarding, make sure they know how to encourage and motivate their customer contact (",
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/the-customer-may-not-always-be-right-but-they-should-be-first/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'the promise of a raise or internal recognition often works',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ').',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Have CSMs serve as PMs:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Often, CSMs need to act as the point of contact between multiple customer contacts at an organization. They need to assign data collection tasks to individuals, check in with them, and offer support when issues arise.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Tools and resources',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When choosing a data onboarding provider, you should prioritize features based on the level of onboarding support your company provides. Do customers onboard their own data, or does a CSM lead the process?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Self-guided customer data onboarding',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Teams have deferred to CSV templates, lengthy documentation, video tutorials, or custom-built in-house solutions to help users import their data. But it's a complex task. Whether it's fragmented data, encoding errors, improper formatting, or lack of data normalization, the customer is often left wondering ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'why their data import failed',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Simply put, there has never been a standard for importing customer data. Data importers, specifically CSV importers, haven't been treated as key product features within the software. As a result, engineers tend to dedicate excessive effort to creating less-than-ideal solutions for customers to import their data successfully.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When members of your engineering or customer success teams spend hours cleaning and maintaining customer data to import it properly, there is a hidden cost (which is, of course, employee time).',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are solutions to reduce the pain of data onboarding, such as ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.helpnetsecurity.com/2020/09/16/infoworks-datafoundry/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'automated data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " that pulls data from disparate cloud sources and pre-built CSV importing so engineers don't have to build a best-in-class importer on their own.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Look for a CSV importer that includes the following features:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data parsing',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Data mapping',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data structuring',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data validation',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data transformation',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6T8CKadHJZWTGUbOSzXt0B',
                type: 'Asset',
                createdAt: '2021-08-24T16:53:56.236Z',
                updatedAt: '2021-08-24T16:53:56.236Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'CS-led data onboarding',
                description: 'CS-led data onboarding',
                file: {
                  url: '/img/contentful/6T8CKadH-zohp9tcws9iymlp8l5jd.webp',
                  details: {
                    size: 73639,
                    image: {
                      width: 1320,
                      height: 960
                    }
                  },
                  fileName: 'ZoHp9TCWS9iYMlp8L5Jd',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CS-led data onboarding',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What about features for an ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/28-onboarding-tools-for-delighting-new-users/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'onboarding tool',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' that supports CSMs?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you have customer success managers, look for a collaborative workspace that makes it easy to securely collect data from customer contacts and import it effectively.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Even though CSMs help manage customer data onboarding for customers, there are still hiccups. In fact, things can be even more complicated because when a CSM is involved, that usually means there's even more data and more customer contacts to work with.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A collaborative workspace for data onboarding should include these features:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'No coding required from the CS team',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Helps CSMs assign data collection tasks to the right contacts',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Includes deadlines for data collection tasks',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'SOC 2, GDPR, HIPAA compliant',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'User verification with 2FA',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Imports data directly from the collaborative workspace to your product',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Transforms CSV, XLS, TSV, and more into validated output',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why data onboarding should be continually improved',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data onboarding is critical for several reasons. If the onboarding process is not ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'fast and simple',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for your customers, your business ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'risks high churn rates',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and (if potential leads are wary) low closing rates. Data onboarding is a critical part of the overall customer experience. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Decrease time to value',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'An excellent onboarding experience has the potential to drastically cut down on the time to value for a customer. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Take that ClickUp example again. If someone uses Trello and wants to enjoy the integrated workflows with docs and lists that ClickUp provides, their existing task cards, comments, and file uploads are a huge barrier. By making it as simple as connecting your accounts and clicking "Import," the ClickUp team ensures your onboarding takes minutes, not days. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When the data onboarding experience is positive and painless, users can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-buildops-helps-keep-critical-infrastructure-running-with-flatfile/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'reach the "aha" moment',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' much faster.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Reduce churn',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A great onboarding experience can reduce churn, particularly for lower-priced SaaS products with no personalized onboarding. Self-service data migration means the data migration experience needs to be as easy as possible. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Customers may sign up for a free trial or a monthly plan with the best intentions of importing or migrating their data. If the process is anything less than simple and straightforward, it may not be worth it to the customer. Better data onboarding could have avoided churn. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Win more deals',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'An ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'effective onboarding process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " (whether productized or white glove) can help sales teams win more deals. Salespeople can handle common objections on calls and demos, but how hard will it be to start using the product easily? Data onboarding shouldn't become a barrier to successfully using a product. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "By prioritizing your onboarding experience, you may even be able to steal customers from your competitors. Even if potential prospects don't love their current solution, they might stick with it because churning would be too much of a headache. If onboarding is no longer a pain point and is rather a benefit of your product, there is more potential for companies to make a switch.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Today, data onboarding may be seen as an afterthought, but by prioritizing it, you can drastically improve the customer experience, set your company up to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'retain customers and even secure more deals',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' has solved data onboarding challenges for hundreds of companies, supporting just about any business or data requirement. Reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2020 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '1UyklYjWunBeMUSNJZ8oDc',
    postTitle: 'Developer news: March 2024',
    seoTitle: 'Developer news: March 2024',
    seoUrlSlug: 'developer-news-march-2024',
    seoMetaDescription:
      "Discover the latest Flatfile releases and updates here. We're also excited to announce that we'll be releasing our new dashboard experience soon!",
    category: 'Product updates & features',
    tags: ['Product update', 'Release', 'Developers'],
    publishDate: '2024-03-21T09:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7eWX29oEtKZ6N9JzJOi54i',
        type: 'Asset',
        createdAt: '2024-03-21T03:05:25.075Z',
        updatedAt: '2024-03-21T03:45:25.229Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Developer news March 2024',
        description:
          'Developer news March 2024 on a white background with icons representing the platform and code',
        file: {
          url: '/img/contentful/7eWX29oE-developer_newsletter_-_v2.webp',
          details: {
            size: 72105,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Developer newsletter - v2.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Developer news March 2024 on a white background with icons representing the platform and code',
    summary:
      "It's been a busy few months at Flatfile. Here are our latest releases and updates and we're excited to announce that we'll be releasing our new dashboard experience soon!",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6jqtZuYGDkJxvNfPSp6s5V',
        type: 'Entry',
        createdAt: '2024-03-20T20:49:24.210Z',
        updatedAt: '2024-03-20T20:49:24.210Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Jon Bell',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3JOojesYtKv8J7RRMy5FJn',
            type: 'Asset',
            createdAt: '2024-03-20T20:49:10.773Z',
            updatedAt: '2024-03-20T20:49:10.773Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Jon Bell',
            description: 'Jon Bell headshot',
            file: {
              url: '/img/contentful/3JOojesY-jb-slack.webp',
              details: {
                size: 383244,
                image: {
                  width: 510,
                  height: 513
                }
              },
              fileName: 'jb-slack.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Vice President of Product'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It's been a very busy few months, and we've been working hard to improve your Flatfile experience. We've built and enhanced functionalities like advanced column filtering, intuitive column management with instant feedback, customizable email theming, multi-selection and drag-and-drop file upload support and more.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "We're also excited to announce that we'll be releasing our new dashboard experience soon! Stay tuned for more details.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Product updates ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Advanced column filtering',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Beyond the existing functionalities of sorting, replacing empty values, and conducting searches within fields, we’ve now integrated a precise value filtering option for columns. This new feature includes a convenient search mechanism to effortlessly pinpoint and filter by the specific value you’re seeking.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3kkmbGh5XB5U2D0bzztr04',
                type: 'Asset',
                createdAt: '2024-03-20T20:57:21.749Z',
                updatedAt: '2024-03-21T03:18:43.874Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Advanced column filtering',
                description: 'Icons representing column filtering',
                file: {
                  url: '/img/contentful/3kkmbGh5-frame_47830.webp',
                  details: {
                    size: 38203,
                    image: {
                      width: 440,
                      height: 439
                    }
                  },
                  fileName: 'Frame 47830.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Enhanced file upload experience: Multi-selection and drag-and-drop support',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Now, you can select and upload multiple files simultaneously through the file uploader, making it quicker and easier than ever to upload your data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Email theming for Pro Plan customers',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Users can now update their space metadata object with a theme configuration to customize the look of their emails. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'sB5M50joSUr88LxhwFF1C',
                type: 'Asset',
                createdAt: '2024-03-20T20:58:24.141Z',
                updatedAt: '2024-03-20T20:58:24.141Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Email theming',
                description:
                  'Example of email theming invitation with code block',
                file: {
                  url: '/img/contentful/sB5M50jo-email__2_.webp',
                  details: {
                    size: 162138,
                    image: {
                      width: 2354,
                      height: 1792
                    }
                  },
                  fileName: 'email (2).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'You can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/guides/theming'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'learn more here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Your insight into Space dynamics: Introducing 'lastActivityAt'",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'We’re thrilled to introduce ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '`lastActivityAt`',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ', which marks the date of the last significant activity within a Space, such as adding records to a sheet, uploading files or altering the configuration of a workbook. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://reference.flatfile.com/api-reference/spaces/get'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Learn more here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Intuitive column management in real-time',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Adjustments made within the column management panel now reflect instantly, meaning you can see the impact of your selections or deselections in real-time.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Stay up-to-date on all of the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/changelog/platform'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'new feature releases here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'SDK and plugins',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '@flatfile/plugin-delimiter-extractor@0.9.1 and @flatfile/plugin-xlsx-extractor@v1.11.3',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A new update brings our extractors in line with Flatfile’s core header detection capabilities, and now offers three distinct header detection strategies: ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'default',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'explicitHeaders',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ', and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'specificRows',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '. The ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'default',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' strategy automatically scans the first 10 rows of your file to identify the header row based on the highest count of non-empty cells. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/plugins-docs/extractors/xlsx-extractor'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Learn more here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '@flatfile/plugin-export-workbook@0.1.6',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This update introduces several significant enhancements to improve your data export workflows including sheet-specific exports, customizable job names and enhanced character checks for those that may not be recognized by Excel. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/plugins-docs/export/workbook'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Learn more here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '@flatfile/plugin-webhook-egress@1.2.3',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "This update aims to offer more flexibility, reliability and a broader applicability of the webhook egress plugin. We've now transitioned from using axios to fetch for HTTP requests, extended compatibility to browser environments and integrated enhanced response rejection handling. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/plugins-docs/export/webhook'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Learn more here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Stay up-to-date on all of the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/changelog/sdks/plugins/highlights'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'plugins updates here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Need help?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As always, we’re here to help with all of your data import challenges using Flatfile. Here are some of the best ways to learn more and connect with us:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/resources/webinars/developer-office-hours/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Developer office hours',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' provides live support from our engineers',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile-developers.slack.com/ssb/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Join the Flatfile Developer Slack community',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Join our ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/resources/webinars/product-demo/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'live demo and Q&A',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Feel free to reach out to ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'mailto:support@flatfile.com'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'support@flatfile.com',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ' if you’re more of an email person',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TeslTqcCH6G3Jjogccn9K',
                type: 'Entry',
                createdAt: '2024-01-12T01:22:24.597Z',
                updatedAt: '2024-01-12T01:22:24.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Connect with an expert',
                text: 'Evaluating Flatfile for your business needs?',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '5F8PjMTy9hfJCTbAQWsW3C',
    postTitle:
      'The data file exchange checklist: How to choose the ideal solution for your needs',
    seoTitle: 'Data file exchange checklist: How to choose the ideal solution',
    seoUrlSlug: 'data-file-exchange-checklist-how-to-choose-ideal-solution',
    seoMetaDescription:
      'A data exchange solution can can help you import the data files you need. Keep these key factors in mind as you choose the right platform for your needs.',
    category: 'Data exchange',
    tags: ['Data exchange', 'Data import', 'Data exchange', 'Data management'],
    sortOrder: '9',
    publishDate: '2024-03-20T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1sLXlWpf4EE2d6NYods5oR',
        type: 'Asset',
        createdAt: '2024-03-19T22:38:16.775Z',
        updatedAt: '2024-03-19T22:38:16.775Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data Exchange Checklist',
        description:
          '"Data exchange checklist" on a white background with icons representing files and a checklist',
        file: {
          url: '/img/contentful/1sLXlWpf-blog_post_-_dg10_-_data_exchange_checklist_v3b.webp',
          details: {
            size: 42320,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - DG10 - Data exchange checklist_v3b.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Data exchange checklist" on a white background with icons representing files and a checklist',
    summary:
      'A data exchange solution is an efficient, secure and scalable solution that can help your company thrive. These are the key factors you should keep in mind as you decide which platform is right for your needs.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4ZMRKHDcdbes5qVyTJt7c1',
        type: 'Entry',
        createdAt: '2024-03-19T22:36:39.982Z',
        updatedAt: '2024-03-19T22:36:39.982Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Katie Barcelos',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7xEh8ZQc7fGFyuaqq9SVji',
            type: 'Asset',
            createdAt: '2024-03-19T22:36:24.792Z',
            updatedAt: '2024-03-19T22:36:24.792Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Katie Barcelos',
            description: 'Headshot of Katie Barcelos',
            file: {
              url: '/img/contentful/7xEh8ZQc-katie_barcelos-linkedinpic.webp',
              details: {
                size: 709853,
                image: {
                  width: 903,
                  height: 902
                }
              },
              fileName: 'Katie Barcelos-LinkedInpic.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The data files you need to run your company are everywhere. Unfortunately, they’re probably not perfectly structured, organized and ready to use. Getting all of the different data files and file types that you need into your system can be a constant and painful challenge, but they contain key information that can drive the health and success of your business. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "By now, you've discovered that traditional tools aren't an efficient solution for your needs, and you're probably spending ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'time and resources',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' on complicated workarounds. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' (sometimes referred to as “data file exchange,” "data import," "data collection," or "data onboarding") is the solution that can help you safely and efficiently import all the highly variable data files you need. Even if your files come from tons of different sources in a wide variety of formats and need manual ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'mapping, review, cleanup and validation',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' before you can import them, a data exchange solution will help you deal efficiently with all of the real-world data that you have.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you want to be able to make strong, data-driven decisions, a data exchange solution is an efficient, secure and scalable solution that can help your company thrive. Instead of creating and maintaining ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'inefficient workarounds',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' or building costly and complex customizations of traditional tools, your organization can have the functionality and reliability it needs without building and maintaining in-house tools.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "When you're ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'evaluating your options',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', make sure to find a solution that will support your specific requirements and use case and can easily fit into your tech stack and development tooling. Choosing the best data exchange and collaboration solution for your needs is critical because it directly impacts the outcome and success of your operations.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How do you choose the ideal data exchange solution for your use case?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are the key factors you should keep in mind as you make your decision: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '(To simplify your decision-making process, we also have a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-data-exchange-checklist/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'free data file exchange checklist',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' you can download anytime!)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Expertise and focus',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data import and collaboration platform providers specialize in creating solutions for data management and are committed to resolving problems and ensuring your solution operates smoothly. The right solution will invest in research, development, and ongoing improvements and maintenance to deliver robust, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'feature-rich products',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Security, compliance and reduced risk',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Modern data exchange platforms typically have built-in security features and may already comply with industry-standard regulations. The right solution will reduce the risks associated with software development, offering the assurance of established security measures and compliance adherence. These tools are thoroughly tested, refined, and continually improved based on the experiences of numerous other businesses that have used them.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. Ease of use and accessibility',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For most businesses, it makes sense to select a data exchange and collaboration solution that comes equipped with user-friendly interfaces that offer value for a broader range of employees, customers and use cases. A familiar and intuitive spreadsheet-type interface that people ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/category/data-exchange/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'immediately understand how to use',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' can make the process more streamlined and efficient. It should offer real-time validation, error handling, and transformation capabilities, empowering you to easily collaborate across diverse stakeholders and take control of your data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '4. Excellent data transformation, quality and cleaning capabilities',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Consider solutions that offer sophisticated data cleaning and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'validation features',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". These functionalities can help identify and fix inconsistencies, errors, and missing values within datasets, which ensures the imported data's accuracy and reliability. Here are some some ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/6-considerations-for-csv-import-solutions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'key capabilities',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' to look for:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Parsing data:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " Parsing is the process of aggregating information (in a file) and breaking it into discrete parts. Essentially, data parsing is the separation of data. You'll want to have a data parsing feature that not only allows you to transform a file into an array of discrete data but also streamlines this process for your users.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Structuring:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Most product teams want to make sure that data flows seamlessly into their application database via their API. Proper data structuring ensures that data is received and labeled appropriately in your system. APIs expect a certain format of data and will fail without it.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Validation:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data validation checks the data to make sure it matches an expected format or value. Having this feature in place prevents issues from occurring down the line. Data validation eliminates the need for your users to remove and re-upload data.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Transformation:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data transformation makes changes to data as it flows into the system to ensure it meets an expected or desired value. Rather than sending data back to users with an error message, data transformation makes small, systematic tweaks to ensure the data is usable.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data mapping:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " Mapping and matching are often used interchangeably and refer to taking previously unknown source data and matching it to a known target. It's an absolute requirement that your data importer do this very well. Without ",
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'data mapping',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ", imports will fail when data elements like column headings don't match exactly.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. Workflow flexibility and customization',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The workflows needed for importing, validating, editing and approving data are often complex and different from organization to organization. How do you ensure the right people manage the right data at the right time with appropriate access control? Choose a data exchange solution that offers customization to accommodate your unique business needs. This flexibility means that the solution you choose will be able to adapt to changing requirements and workflows within your organization.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '6. Developer tooling',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data import and exchange requirements are usually part of software applications, integration projects, and other system needs. A data exchange solution must be easily usable by your IT team and software engineers, integrate into your tool stack, and support your software development processes. Software developers also need in-depth technical documentation, public API references and easy access to the full data exchange tool set.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '7. Third-party integrations',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Modern platforms offer integrations with other software applications, such as databases, analytics tools, and business intelligence platforms. These integrations will streamline your data workflow, enhance data analysis capabilities, and provide seamless connectivity between various data-related tasks.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '8. Support and maintenance',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Assess each vendor's support services, including response times, availability of updates, and maintenance plans. Reliable support will ensure timely help if there are issues or concerns, minimizing disruptions in the data import process.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "By carefully considering these aspects, you'll clearly understand how the right solution will align with your unique needs now and in the future.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Whether used on its own or as a complement to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'traditional ETL solutions',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', a data exchange solution provides the missing piece in your data stack. It offers the agility to wrangle a variety of data types, the power to derive insights on the fly and the flexibility to navigate an evolving data landscape seamlessly. With the right solution in place, businesses can harness the true potential of their data, transforming it from a simple asset into a competitive advantage.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you need to choose the ideal data file exchange solution for your use case, we have a handy checklist you can ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/resources/guides/the-data-exchange-checklist/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'download for free',
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'bold'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' today!',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' has helped hundreds of companies tackle their data migration challenges, supporting just about any business or data requirement. Find out how Flatfile can help you address your ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding use case and requirements',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '6kLwwUom1T8x1ZInxyZj0P',
    postTitle:
      '9 ways a data file exchange solution can speed up CSV and Excel imports',
    seoTitle:
      '9 ways a data file exchange solution can speed up CSV and Excel imports',
    seoUrlSlug:
      '9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports',
    seoMetaDescription:
      'Traditional data file import methods usually have serious limitations. Find out how data file exchange can accelerate CSV and Excel imports.',
    category: 'Data exchange',
    tags: ['Data exchange', 'CSV', 'Excel', 'Data import'],
    publishDate: '2024-03-13T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5P9uW7LSrLlPQoZ7UCj0ig',
        type: 'Asset',
        createdAt: '2024-03-13T01:55:44.751Z',
        updatedAt: '2024-03-13T01:55:44.751Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'How data exchange can speed up CSV and Excel imports',
        description:
          '"How data exchange can speed up CSV and Excel imports" on a white background with an icon that looks like a fast file over a spreadsheet',
        file: {
          url: '/img/contentful/5P9uW7LS-blog_post_-_dg7_-_how_data_exchange_can_speed_up_csv_and_excel_imports.webp',
          details: {
            size: 49687,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'Blog Post - DG7 - How data exchange can speed up CSV and Excel imports.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"How data exchange can speed up CSV and Excel imports" on a white background with an icon that looks like a fast file over a spreadsheet',
    summary:
      'Traditional data file import methods usually have a number of limitations. Find out how data file exchange can accelerate your CSV and Excel imports.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '17qKlZvT1Co3tgeyESXwvN',
        type: 'Entry',
        createdAt: '2022-03-25T21:02:30.990Z',
        updatedAt: '2024-03-21T20:05:30.836Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Austin Brown',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6lYjJx09Bzz36Jjd4BOlr5',
            type: 'Asset',
            createdAt: '2024-03-21T20:05:23.571Z',
            updatedAt: '2024-03-21T20:05:23.571Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'austin',
            description: '',
            file: {
              url: '/img/contentful/6lYjJx09-austin.webp',
              details: {
                size: 18259,
                image: {
                  width: 288,
                  height: 288
                }
              },
              fileName: 'Austin.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Enterprise Account Executive',
        department: 'Sales'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you’re reading this, your business relies on importing data from various sources, including CSV and Excel files. However, traditional import methods often have inherent limitations, like incomplete, incorrect or slow imports and cumbersome workflows. Organizations are adopting ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data file exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' solutions to overcome these challenges and streamline data import processes. These platforms offer a range of features designed to expedite CSV and Excel imports, which will drive efficiency and productivity across the board.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For example, if you have customers using your software application, loading that app with data is often a required first step for them to realize the value your solution provides. Any ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'delay or complication',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " in getting data into your app will affect your user's ROI, decrease customer satisfaction, and, in some cases, can be the cause of customer churn.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Importing data is critical for businesses across industries, and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/state-of-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'successfully navigating the process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' of importing, mapping, cleaning and transforming data is vital to ensuring a positive first impression.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How data exchange accelerates CSV and Excel imports',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A data exchange solution will streamline, accelerate and secure your data import processes, improving your customer experience and delivering rapid and sustained ROI.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data exchange solutions significantly accelerate and improve data import by automating data file extraction, parsing, mapping, validation and transformation while allowing manual review, collaboration and oversight. This allows you to import different file types and sizes or receive data files from multiple sources like clients, partners, vendors, and team members. It reduces the amount of time your team spends on data file imports and increases the accuracy of your data. Speeding up your data import process will help you ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'avoid the high costs',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' of missed opportunities, delayed revenue and the time and resources involved in creating and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'maintaining workarounds',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Automating your data import workflows using a data exchange solution can have a significant impact on your business:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate time to value for customers and users',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Accelerate timely decision-making when normalizing disorganized data',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Accelerate data availability with quality checks baked in',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Reduce the time and skill it takes to identify data errors',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce data management time with automation',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Reduce or eliminate the time, resource requirements and cost for your product and software development team to build a robust solution from the ground up',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '9 technical data exchange components that speed up data imports',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A data file exchange solution can help you speed up the import of a wide variety of data files, including CSVs and Excel spreadsheets, by using specific techniques. Here are the nine most common technical components for a robust data file exchange solution:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Automated data cleaning and validation: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'AI can assist in data cleaning by automatically identifying and fixing inconsistencies, errors, and missing values within datasets. Algorithms learn from patterns in the data and can automate the process of validating information against predefined rules, ensuring data accuracy and reliability.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Intelligent data parsing:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Parsing data from CSV and Excel files can be complex, especially when dealing with unstructured or semi-structured data formats. Relevant information needs to be accurately and efficiently parsed and extracted. This intelligent parsing capability speeds up import times and improves data accuracy, ensuring that organizations make decisions based on reliable and high-quality data.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Enhanced data mapping:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Manual data mapping, where users define how data fields in CSV or Excel files correspond to fields in the destination database or application, can be time-consuming and error-prone. Data exchange solutions with automation capabilities streamline this process by ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'automatically mapping data fields',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' based on predefined rules or machine learning algorithms. By automating data mapping, organizations can significantly reduce the time and effort required to set up imports, accelerating the overall import process.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Intelligent error handling:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data import processes can be disrupted by errors such as missing values, formatting inconsistencies, or data integrity issues. AI-enhanced data exchange solutions employ intelligent error-handling mechanisms that automatically detect, diagnose, and resolve errors during the import process. By leveraging machine learning algorithms, these platforms can identify patterns in error occurrences and proactively suggest solutions, minimizing downtime and ensuring smooth data imports.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Batch processing:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' One of the key advantages of data file exchange solutions is their ability to handle batch processing. Instead of importing files one by one, these solutions allow users to import multiple files simultaneously. By batching imports, organizations can significantly reduce the time required to process large volumes of data, enabling faster decision-making and analysis.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Parallel processing:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' Data file exchange solutions leverage ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/processing-more-faster-with-flatfiles-new-parallel-processing/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'parallel processing',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' techniques to enhance import speeds further. By distributing import tasks across multiple cores or nodes, these platforms can process files in parallel, dramatically reducing processing times. This parallelization of tasks maximizes the utilization of available computing resources, leading to faster imports and improved overall efficiency.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data streaming:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data file exchange solutions often incorporate streaming capabilities to facilitate ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/docs/guides/handling-data'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'real-time or near-real-time data imports',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        '. This streamlined approach to data import enables organizations to react promptly to changing data requirements and make informed decisions promptly.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Caching and preprocessing:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' To further accelerate CSV and Excel imports, data file exchange solutions may ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'employ caching mechanisms',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' to store metadata or preprocessed data. By caching frequently accessed data, these platforms reduce the need for repeated processing during subsequent imports, leading to faster import speeds and improved overall performance.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Optimized file handling:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data file exchange solutions include optimized file handling capabilities to minimize disk I/O operations and reduce overhead during import. These platforms employ efficient file read and write mechanisms, ensuring seamless data transfer and processing. By optimizing file handling, organizations can minimize import times and maximize productivity.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A data exchange platform can offer a robust infrastructure that supports businesses in managing, sharing and leveraging data safely and effectively. By leveraging these solutions, businesses can avoid the high costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining complex workarounds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data file exchange solutions speed up CSV and Excel imports while driving efficiency and productivity. By leveraging automation and AI-enhanced features as well as techniques like batch processing, parallel processing, optimized algorithms, data compression and data streaming, they let organizations import data quickly and efficiently. As businesses are becoming increasingly reliant on data for critical decision-making, investing in the right solution for your company is essential for staying competitive in today's fast-paced digital landscape.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'SR1CA4tUJmo3m4SiNGTTA',
    postTitle:
      "Why you can't import data from that CSV file (and what you can do about it)",
    seoTitle:
      "Why you can't import data from that CSV file (and what you can do)",
    seoUrlSlug: 'why-isnt-my-csv-file-importing',
    seoMetaDescription:
      'There are numerous reasons your CSV file might not be uploading properly, but many are easy to fix. Find out how to solve common CSV data import problems.',
    category: 'Data exchange',
    tags: ['CSV file', 'CSV import', 'Data import', 'Data exchange'],
    publishDate: '2024-03-08T09:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '48SXmhGHTe1DFXumnnO5q4',
        type: 'Asset',
        createdAt: '2024-03-08T16:44:49.341Z',
        updatedAt: '2024-03-08T16:44:49.341Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Why you can't import data from this CSV file",
        description:
          'Icon representing a CSV file surrounded with icons representing errors',
        file: {
          url: '/img/contentful/48SXmhGH-why_can-t_i_import_data_from_this_csv_file_.webp',
          details: {
            size: 35147,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Why Can-t I Import Data from this CSV File_.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Icon representing a CSV file surrounded with icons representing data import errors',
    summary:
      'There are numerous reasons your CSV file might not be uploading properly, but some of them are very common and many are easy to fix. Find out how you can solve common CSV data import problems.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Having trouble ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'uploading a CSV',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                "? You're not alone! Even the most seasoned professionals occasionally hit an error when uploading data files. There are a number of reasons your CSV file might not be uploading properly, but some of them are very common, and most of them are fairly easy to fix.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The good news is that most CSV data import errors fall into a few basic categories. Mismatched headers or unexpected values, for example, are some of the most common issues that stop CSV file imports. Let's dive into the CSV file data structure, import process, and the most common problems you might face so that you can ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'troubleshoot your data file import',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Why can't I import this CSV file?",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Importing data is critical',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " to using a software program effectively. Unfortunately, importing a CSV file doesn't always go smoothly.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "To learn why your CSV file document isn't properly uploading into the software you're using, you need to begin with an ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-a-csv-file-guide-to-uses-and-benefits/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'understanding of the CSV and its structure',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. Understanding the basic data structure parts of a CSV file will make it easier to identify the problem.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Structure of a CSV file',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A CSV file is a comma-separated value file. What that means is that the file uses commas to separate different values. A spreadsheet program puts these values in cells in columns and rows, but if you were to look at what's happening behind the scenes, what you would see in those spreadsheet cells are actually those values separated by commas. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The appropriate CSV format guide depends on the requirements of the software you're uploading your CSV file to, so begin by checking that documentation! If you can't find the right CSV format guide, ask their customer support team. They likely already have a help desk article that tells you the requirements and steps for uploads, such as the file size or value type (like numbers, monetary value, months, etc.).",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What are the top reasons your CSV file import failed?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are the 6 most common CSV import errors and how to fix them:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'File size is too large:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " The CSV import tool of the program you're using might have a file size requirement. To reduce the file size, you can delete unnecessary data values, columns, and rows.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Matching issues:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " A good data importer should make it easy for users to match the headers in their CSV file with what the software expects, but plenty of data importers aren't built to handle this well. To succeed, you might need to rename your header rows to what is expected by the software you're using and try again. Other matching issues can occur if expected columns are in the wrong order or required fields are missing. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data translation errors:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data translation is essentially pulling the data from the CSV into what the software program can use. If there are non-standard characters or if the data is encoded, data translation (and the entire import) could fail. To fix this, pay attention to any error messages stating the presence of non-standard characters and edit them out of your file. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data value issues:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' A CSV import tool typically expects a certain type of data value. For example, if you have entered a date where there should be a dollar amount, the CSV upload could fail. Check any support documentation about expected values and edit your CSV file accordingly.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Missing data:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " Certain data sets might be required in order for the import to work. For example, if you're uploading a list of products into an inventory management system but don't have a column for SKUs, it might be a bust. Check the error messages and support docs to figure out what data is required.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Non-digestible formats:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " This simply means the data might not be in the right format. For example, let's say you have phone numbers in a column in your CSV file using the format 5555555555, but your CSV importer requires the format to be (555)555-5555. You'll need to edit all instances and try your CSV import again. ",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Addressing these common issues',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " will fix the majority of CSV import failures, so give them a go and edit out the relevant errors from your file. If you aren't sure what the problem is (there isn't an error message, and you can't find specific information in the software's help center), ask their support team for guidance. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you're part of a product team and want to resolve these import issues for customers automatically, consider using a pre-built data importer to improve the data onboarding experience.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'FAQs about uploading CSV files',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Aside from troubleshooting common errors, you might have other CSV file concerns. Here are some answers to frequently asked questions:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What characters are not allowed in a CSV file?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The answer depends on the software program you're uploading data to. For example, QuickBooks doesn't allow zeros, dollar symbols, or commas in files. In general, characters like slashes, ampersands, and commas are not recommended. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'What is the difference between a text file and a CSV file?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "File types can be confusing. A text file is not as optimized as a CSV file for a spreadsheet program, so it's not recommended that you download or upload data using a TXT file. With  comma-separated values, CSVs are a safer bet.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why does CSV not save formatting?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Because of the way they're structured, CSV files aren't able to save any formatting. If you want to create stylized headers, for example, you'll need to use a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-top-excel-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'program like Excel',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " instead. Just be aware that this type of file isn't recommended for data imports. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How do you repair a corrupt CSV file?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "To repair a corrupt CSV file, you need to make sure it's saved with UTF-8 encoding. You might also need to remove special characters like semicolons and commas that are causing data cells to be wrongfully split in two. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is a text qualifier in CSV?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A text qualifier is a way of telling Excel that values are supposed to be in separate cells. You may have seen double quotes when you click on a cell to edit it, but then these quotes aren't displayed in the spreadsheet program. These text qualifiers shouldn't create a problem when uploading, but you can also remove them if needed.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How long can a CSV file be, and how many records can it hold?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "As a file format, a CSV doesn't really have specific limitations. Instead, the limitations come from whatever spreadsheet program you're using. The maximum number of rows for an Excel file is 1,048,576 rows, and the maximum number of columns is 16,384. The chance that your CSV file isn't uploading due to too many rows or columns within the file is pretty rare, but it could happen. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are a lot of reasons why a CSV file may not import successfully, but if software users ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/csv-import-tool-or-data-file-exchange-solution-how-to-pick-the-right-one-for/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "can't import their data",
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", you'll probably lose them. Make sure you're optimizing your entire data onboarding process, prioritizing an ideal CSV ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'import experience for your customers',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile has solved CSV file import challenges for hundreds of enterprise clients (and plenty of scaleups), supporting just about any business or data requirement. Reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2021 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '25gVxnobRnOZ1Ssg7WHpub',
                type: 'Entry',
                createdAt: '2021-08-13T21:53:47.725Z',
                updatedAt: '2024-07-30T23:58:59.586Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 44,
                revision: 8,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Evaluating Flatfile for your business needs?',
                text: 'Reach out to our experts today to scope your data conversion, onboarding and migration processes',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '1OBqhdZOfBJyV2TcQBKe3P',
    postTitle: 'Flatfile: The whole story',
    seoTitle: 'Flatfile: The whole story',
    seoUrlSlug: 'flatfile-the-whole-story',
    seoMetaDescription:
      'You’ve heard of Flatfile, but do you know the whole story? Find out why David Boskovic built Flatfile, what he’s learned and his plans for the future.',
    category: 'Flatfile news',
    tags: ['Podcast', 'Code Story', 'Flatfile', 'Flatfile culture'],
    sortOrder: '3',
    publishDate: '2024-03-07T09:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '20m97Hc5ROJt2q7CKWtBL0',
        type: 'Asset',
        createdAt: '2024-03-07T03:15:53.075Z',
        updatedAt: '2024-03-07T16:57:38.606Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile-Code-Story-podcast',
        description:
          'Headshot of David Boskovic, Flatfile CEO with his name, title and Code Story podcast information',
        file: {
          url: '/img/contentful/20m97Hc5-code-story-david-boskovic.webp',
          details: {
            size: 423332,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Code-Story-David-Boskovic.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Headshot of David Boskovic, Flatfile CEO with his name, title and the Code Story podcast information',
    summary:
      'You’ve heard of Flatfile, but do you know the entire story? Find out why David Boskovic built Flatfile, what he’s learned and his plans for the future.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3g8UtF3xqMDeJcwD9zabc5',
        type: 'Entry',
        createdAt: '2022-12-05T16:44:02.752Z',
        updatedAt: '2022-12-05T16:44:02.752Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Noelle Festa',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6pb3PzTTNmEL9U8H4YaJBH',
            type: 'Asset',
            createdAt: '2022-12-05T16:42:27.684Z',
            updatedAt: '2022-12-05T16:42:27.684Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Noelle Headshot',
            description: '',
            file: {
              url: '/img/contentful/6pb3PzTT-t0ap8ur47-u03ea82my2u-d9a5ad607b89-512.webp',
              details: {
                size: 54407,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U03EA82MY2U-d9a5ad607b89-512.jpeg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You’ve probably heard of Flatfile, but do you know the entire story?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'David Boskovic, Flatfile’s CEO, recently sat down with Noah Labhart, startup founder & CTO at Code Story, to discuss the real story behind Flatfile’s creation. From growing up on a farm in a small town in Canada to building his first website, CSV importer and startup, you can learn everything you want to know about why David built Flatfile, what he’s learned along the way and his plans for Flatfile’s future in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://codestory.co/podcast/e13-david-boskovic-flatfile/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this episode of Code Story',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Designing the ideal data import experience',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'David had built CSV importers many times over, and eventually, he asked himself the important question: When does it make sense to build this as a product and launch a company? He “',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/read-why-our-ceo-is-betting-usd100m-in-venture-capital-on-the-csv/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'rage designed',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '” his ideal solution, tested it carefully and launched it. And, as rare as this is, experienced product market fit from day one.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://codestory.co/podcast/e13-david-boskovic-flatfile/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Listen to the entire episode',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to discover the steps David took to build and launch the Flatfile Data Exchange Platform, the obstacles he faced, mistakes he made and the key lessons learned along the way.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '3eKFLVjVfvQ1EmecJMFeqn',
    postTitle: 'How AI supercharges data file imports',
    seoTitle: 'How AI supercharges data imports',
    seoUrlSlug: 'how-ai-supercharges-data-file-imports',
    seoMetaDescription:
      "AI is changing how businesses import, manage, and leverage data files, giving technical and non-technical users capabilities they didn't have before.",
    category: 'Data exchange',
    tags: ['Data exchange', 'Data imports', 'AI', 'AI-enhanced', 'Featured'],
    sortOrder: '11',
    publishDate: '2024-03-06T08:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1xFb0AFIpFSuXU9nSme0wR',
        type: 'Asset',
        createdAt: '2024-03-06T02:57:35.033Z',
        updatedAt: '2024-03-06T02:57:35.033Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'AI-powered data file imports',
        description:
          '"AI-powered data file imports" on a white background with icons representing AI transforming an address',
        file: {
          url: '/img/contentful/1xFb0AFI-blog_post_-_dg8_-_ai-powered_data_file_imports.webp',
          details: {
            size: 51129,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - DG8 - AI-powered data file imports.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"AI-powered data file imports" on a white background with icons representing AI transforming an address',
    summary:
      "AI is changing how businesses import, manage, and leverage data files, giving technical and non-technical users capabilities they didn't have before. Find out how AI can unlock entirely new possibilities in the data import process that dramatically improve efficiency, user experience and data quality.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4e8VT08UTBNDVEEXyXmBEX',
        type: 'Entry',
        createdAt: '2023-04-03T18:49:21.580Z',
        updatedAt: '2024-02-09T18:50:21.687Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Gottfried Sehringer',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5KaxrJpuaiQ0f8hiCzQYVm',
            type: 'Asset',
            createdAt: '2023-04-03T18:48:38.608Z',
            updatedAt: '2023-04-03T18:48:38.608Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Gottfried Sehringer picture',
            description: '',
            file: {
              url: '/img/contentful/5KaxrJpu-1641306098983.webp',
              details: {
                size: 30320,
                image: {
                  width: 400,
                  height: 400
                }
              },
              fileName: '1641306098983.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Chief Marketing Officer'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "In today's digital age, the ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'exchange of data files',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " is a fundamental part of business operations. Whether it's sharing documents, spreadsheets, multimedia files, or any other type of data, efficient and secure file exchange mechanisms are crucial for streamlined workflows and collaboration.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AI unlocks entirely new possibilities in the data import process that improve efficiency, user experience and data quality dramatically. It’s a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'transformative force',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' in optimizing data file exchange processes, offering innovative solutions to enhance efficiency, accuracy, security, and accessibility.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5jsKDgflvyHeV0UjarX20y',
                type: 'Entry',
                createdAt: '2024-04-22T21:57:43.895Z',
                updatedAt: '2024-04-23T00:07:03.368Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'AI Transform',
                text: 'Find out how Flatfile can supercharge your data exchange experience.',
                ctaText: 'Connect with us',
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'AI-enhanced data imports',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AI is changing how businesses import, manage, and leverage data, empowering technical and non-technical users with capabilities ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "they didn't have before",
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. Using the power of AI in the data exchange process opens up previously unattainable levels of automation, data quality and speed.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AI can play a valuable role in streamlining and optimizing the data exchange process, offering ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'solutions',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that enhance efficiency, accuracy and scalability, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'New ways of data extraction',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the key challenges in importing data is the need to extract information from unstructured sources like documents, websites, PDFs or images. AI can interpret unstructured data from invoices, forms, or contracts and automatically convert them into structured formats for easy integration into databases or analytics platforms.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Enhanced data mapping',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Mapping data from multiple sources into a unified format can be complicated and often requires human oversight and decision-making. AI can automate this by recognizing patterns and relationships within datasets, facilitating a much faster and more precise mapping of source to target formats. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Automated data cleaning and validation',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'AI can assist in data cleaning by automatically identifying and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'fixing inconsistencies, errors, and missing values within datasets',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. Algorithms learn from patterns in the data and can automate the process of validating information against predefined rules, ensuring data accuracy and reliability.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Powerful user experience',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The use of AI can help users perform more and more complex data review, validation and transformation actions than ever before. Less tech-savvy business users are empowered to manipulate data faster and more efficiently',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Unprecedented speed, efficiency and data quality',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Usually, speed, efficiency and quality are impossible to achieve together simultaneously. The use of AI has put this in much closer reach for organizations. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "AI's role in the data exchange process can revolutionize how businesses collect, manage, and utilize information. By leveraging AI's capabilities, companies can enhance their decision-making processes, drive innovation, and gain a competitive edge in today's data-driven landscape.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can accelerate your data workflow with AI-enhanced tools? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your import challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Faster, better, stronger: AI and data imports',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Integrating AI technologies into ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data file exchange processes',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' offers enormous benefits in terms of efficiency, accuracy, security, and collaboration. By automating file formatting, extracting relevant data, optimizing bandwidth usage, enhancing security measures, facilitating collaboration, and providing personalized recommendations, AI empowers organizations to streamline workflows and unlock new opportunities for innovation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Using the power of AI in the data exchange process opens up previously unattainable levels of automation, data quality and speed. As AI continues to evolve, its role in data file exchange will become even more pervasive, driving greater efficiency and effectiveness in the digital ecosystem. Embracing AI-powered solutions is essential for companies that want to stay competitive.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile has helped hundreds of enterprise clients (and plenty of scaleups) tackle their data migration challenges, supporting just about any business or data requirement. Find out how Flatfile can help you address your ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding use case and requirements',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '4Av0Pr9cRsbSFmVspelkz9',
    postTitle:
      'Kolleno helps credit control teams keep their cash flows healthy with Flatfile',
    seoTitle:
      'Kolleno helps credit control teams keep their cash flows healthy with Flatfile',
    seoUrlSlug:
      'kolleno-helps-credit-control-teams-keep-their-cash-flows-healthy-with',
    seoMetaDescription:
      'Find out how Flatfile helped Kolleno reduce the time data import tasks take by 70% with a safe, secure, customizable, easy-to-use data import solution.',
    category: 'Customer stories',
    tags: [
      'Data exchange',
      'Data import',
      'Customer story',
      'Developers',
      'CSV import'
    ],
    sortOrder: '3',
    publishDate: '2024-03-05T08:45-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5dXBw0dhB19X6m6YVvFNCU',
        type: 'Asset',
        createdAt: '2024-03-05T03:59:01.677Z',
        updatedAt: '2024-03-05T03:59:01.677Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Kolleno ',
        description:
          'Kolleno helps companies get paid faster with Flatfile on a white background with credit card icons',
        file: {
          url: '/img/contentful/5dXBw0dh-kolleno_-_v1.webp',
          details: {
            size: 36806,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Kolleno - V1.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Kolleno helps companies get paid faster with Flatfile on a white background with credit card icons',
    summary:
      'Kolleno needed a safe, secure, customizable data import solution. Find out how Flatfile helped Kolleno reduce the time data import tasks take by 70%.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Kolleno is a centralized and automated receivables, payments and reconciliations provider built for finance professionals and as they grew, they realized that they needed a safe, secure, customizable and easy-to-use solution that would help them import critical CSVs for clients that required this feature. Although they built an in-house CSV importer to deal with their data import challenges, they quickly realized that they were going to need to find the right data exchange platform to help them scale.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Direct business impact',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Kolleno helps companies grow by helping them get paid faster, and when you help entire credit control teams to keep their cash flows healthy, you need data solutions you can rely on and trust. Before Flatfile, Kolleno's data import process involved getting a CSV or Excel file from any customer that did not use a standard ERP (enterprise resource planning) system, and giving it to their backend team who would then create a script with all of the necessary headings and run the script. Developer ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'time and resources',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' were required each and every time Kolleno needed to upload client data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After it became clear that tying up development resources in this way wasn’t a good long-term solution for their growing demands, Kolleno went on the lookout for a solution. After trying multiple different options including ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'building their own CSV import tool',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', they realized that Flatfile fit their needs the best. "Flatfile\'s positive impact on productivity has been apparent, as it empowers clients to easily upload substantial data sets within minutes. This not only spares our development team from shouldering the burden but also frees them to concentrate on other essential tasks,” said Adonis Damalis, Head of Customer Success at Kolleno. Due to the nature of their business, Flatfile’s customizability and user-friendly front end became invaluable to Kolleno. "Implementing Flatfile, said Damalis, “has resulted in significant time savings for both our development team and the clients that use it."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data import challenges',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Making sure that data was in the correct format was one of the most challenging parts of their data import process, but Flatfile made it simple to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'identify errors',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and amend them with ease. Another key challenge that Kolleno was facing was human error. "There\'s always human error," said Adonis Damalis, Head of Customer Success at Kolleno, "and if you aren\'t able to identify it and highlight it, it becomes a problem."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Kolleno wanted to make the data exchange experience as seamless and frictionless as possible, so they turned to Flatfile. "What impressed me about Flatfile," said Damalis, "was that I could take a CSV file or an Excel sheet and put that into software. It seems so simple, but it\'s saved us and our clients so much time."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Saving time and resources',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"All our clients that don’t utilize an ERP, use Flatfile. That\'s the biggest sign of success. For them, it’s a 100% success rate,” said Damalis. The implementation process was simple and painless. Flatfile worked directly with developers at Kolleno to train them on how to use and troubleshoot the Platform. "You guys have done such a great job of customer service that we don\'t even need to reach out to you most of the time," said Damalis. "Clients are loving it. It\'s working."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In Kolleno’s case, it was important that the solution they chose offered a great, easy-to-use user experience for their clients. "We chose Flatfile,” said Damalis, “because we could see that your customers mean everything to you, just like our customers mean everything to us." Kolleno needed a customizable solution that would fit into their existing software and decided to try Flatfile because they had heard great things about the Flatfile Data Exchange Platform. The Kolleno team knew the problem they were facing and the outcome they wanted, and Flatfile was able to look at that information and the solution they built and take it to the next level. "With Flatfile," said Damalis, “we\'ve reduced the time that data import tasks take by 70%.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TeslTqcCH6G3Jjogccn9K',
                type: 'Entry',
                createdAt: '2024-01-12T01:22:24.597Z',
                updatedAt: '2024-01-12T01:22:24.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Connect with an expert',
                text: 'Evaluating Flatfile for your business needs?',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6PbZaKLFxFC3suRcwV2XYi',
    postTitle: 'The top 6 Excel data import errors and how to fix them',
    seoTitle: 'The top 6 Excel data import errors and how to fix them',
    seoUrlSlug: 'the-top-excel-import-errors-and-how-to-fix-them',
    seoMetaDescription:
      'Learn the most common Excel data import errors and how you can avoid errors when migrating data from Excel into software applications.',
    category: 'Data exchange',
    tags: ['Excel import errors', 'Excel ', 'Excel data import'],
    publishDate: '2024-03-01T08:30-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6T4chmvpn4FRJlNX2EeJL6',
        type: 'Asset',
        createdAt: '2024-03-01T16:48:47.338Z',
        updatedAt: '2024-03-01T16:48:47.338Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Top 6 Excel data import errors',
        description: 'Icons and lines suggesting Excel data import errors',
        file: {
          url: '/img/contentful/6T4chmvp-the_top_six_excel_data_import_errors_and_how_to_fix_them.webp',
          details: {
            size: 27352,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'The Top Six Excel Data Import Errors and How to Fix Them.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'The top Excel data import errors and how to fix them concept with icons and dotted lines',
    summary:
      'Importing Excel data into SaaS applications is challenging, but an improved data onboarding experience can help companies import Excel documents more smoothly. These are the top import Excel errors and how to solve for them.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2rMBnDDtiGDAnj2CTbx7Aj',
        type: 'Entry',
        createdAt: '2021-08-13T20:14:10.860Z',
        updatedAt: '2021-10-07T00:24:36.747Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Roby Hyde',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7czu8ZQXdjXlGHJ4uoPzF2',
            type: 'Asset',
            createdAt: '2021-08-13T20:12:52.857Z',
            updatedAt: '2021-08-13T20:12:52.857Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Roby Hyde headshot',
            description: 'Roby Hyde headshot',
            file: {
              url: '/img/contentful/7czu8ZQX-53u1bewrqhwug7fqmzsi.webp',
              details: {
                size: 59448,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: '53u1bEWRQhWuG7FqmZsI',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Expert Customer Engineer',
        department: 'Customer Engineering'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you work with data in Excel spreadsheets, you know things can occasionally go wrong. Sometimes, you might even hit Excel errors right from your first data import.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Anyone who's tried to ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'import data from an Excel file',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " has, at some point, slammed into an error message. It's a maddening stumbling block for any kind of data import process, including getting your customers onboarded. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel data import errors ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'slow down the whole import process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " and require your client to do a bunch of extra work on their end to format everything according to a set template, which isn't a good look for you or your SaaS application. Any slowdown can have a material impact on your costs and speed to market.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Although many of the issues you and your customers will face importing data from CSVs or Excel spreadsheets are similar, it's important to understand that Excel is a powerful piece of software; it's not just a repository for simple data.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The underlying challenge is that, unlike simple CSVs (we also have practical tips for dealing with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'CSV import errors',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '), Excel files contain a lot of metadata, which can complicate efforts to import just the data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Excel allows you to add many formatting options, from merging cells to creating pivot tables, all of which can throw up errors when you try to import the data. A simple example: When there are multiple tabs in a workbook, you can import only a single tab at a time instead of the whole thing. Ironically, the nature of Excel's flexibility results in a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data import problem',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ". We'll explain top examples like this to be aware of.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What are the top six data import errors?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are the most common Excel import errors you and your customers will likely face during the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' process--and how to fix them:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#excelImportError1FileSize'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'File size',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#excelImportError2Matching'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Matching',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#excelImportError3TranslationData'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Translation',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#excelImportError4Values'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Values',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#excelImportError5MissingData'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Missing data',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#excelImportError6NondigestibleFormats'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Nondigestible formats',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel import error #1: File size',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the most common CSV import errors is that the file is too large, and the same applies to Excel files. It may be caused by too many fields or records in the file, columns, or rows. This Excel import error can be caused by limits set by the program using the file or the amount of available memory on the system. If your import fails because of file size issues, you need to go back and break the file up into smaller files, enabling it to avoid this file error and successfully upload.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel import error #2: Matching',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Another key Excel import error that pops up when uploading an Excel file is related to matching. This could be columns that don't match expected field names caused by different values than expected, field names not on the first line, or simply the complete absence of column names. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Additionally, a matching error occurs when the expected columns are in the wrong order or required fields – columns – are missing.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Further complicating things in Excel documents is that sometimes there are multi-row field names instead of single-row. Let's say your column headers are North, South, East, and West, but they're a subset of another header: Direction. The actual data, then, is buried under a secondary header, and that will create an Excel import error.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You should also avoid merging cells, which can confuse an importer. One tip you can employ to abate this issue is to "Select All" and then unmerge all the cells in a spreadsheet.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel import error#3: Translation (data)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A data translation error occurs if the encoding is incorrect or unexpected. Another cause could be the presence of non-standard characters that aren't usable. For example, it may be necessary to save a file with UTF-8 encoding for that file to work properly within a company's platform. Attempting to import data with different encoded files would simply not work. Check out this ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/saving-inkit-100k-per-year-data-import-costs-flatfile-portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Inkit case study',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' to see this exact example.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Fortunately, Excel typically presents its data with UTF-8 encoding, but be aware that a special character in a field within the document that isn't part of UTF-8 could break the encoding.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel import error #4: Values',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Issues with data values can be a significant cause of Excel importing errors. These include unexpected data length – either too long or too short',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'It could also mean unacceptable characters such as text in a numbers-only column or numbers in a boolean (a boolean is a data type with two possible values: true or false). Boolean values such as 1 and 0, or "yes" and "no," work well, but the importer won\'t recognize something like "yep" or "nope" as a boolean. You can fix that by converting it to a category field and setting "yep" or "nope" as category values, but if you want the entries to remain boolean, you\'ll need to change the actual values themselves.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Related fields with conflicting data, such as records with multiple types of unique identifiers when only one is allowed, will cause errors. For example, the city/state names differ from their actual zip code or even a related field without required data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Excel tends to treat text as if it's numbers. If the first digit in a zip code or GPS number is a zero, the software may strip out the leading zero(es), which will cause an error. Make sure you check the formats of your cells, and ensure you've chosen the correct format, like General or Number, that displays your data correctly.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You should also be careful to check that the column width allows all of the data to appear in the format you want. Sometimes, Excel will change the way the data ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'appears',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' in a spreadsheet, even though if you click on the cell, you can see at the top of the window that Excel "knows" the full format. However, an importer may assume that what appears in the cell is the actual data. For example, Excel may turn a long number into the scientific notation version of that number if the column is too narrow.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel import error #5: Missing data',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Missing data is one of the most common errors for Excel imports. Examples include incomplete data that can be fixed by a user, such as invoices that have month and day but no year information. Other incomplete data can be addressed by a user with help from the system they're working in. Missing city/state data with zip codes present and existing contact role information can usually be automatically appended. New contact role information, including suggestions from the systems based on matching related contacts or data, must be manually corrected.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In some cases, incomplete data must be pulled in by a person or another system. For example, real estate sales data missing the original list date or comparable property information could be pulled in from public records.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Any required value that's missing will get flagged as a required field and trigger an Excel import error.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel import error #6: Nondigestible formats',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Nondigestible formats include simple format mismatches that need format normalizations, such as phone numbers or social security numbers, which are numbers only without symbols.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Complex format mismatches would require format normalization AND data normalization, such as when the date format is different than expected, inconsistent, or includes text rather than being normalized, for example, "July 31st 2020" or "Jun twentieth 19."',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'These are common issues in both CSVs and Excel files, but because Excel has so many powerful features, it has more types of formats that are effectively nondigestible.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Charts are a common culprit, as are pivot tables. You can\'t simply import these formats, even though they\'re easy to create in Excel and provide excellent data visualization. You should also be careful with formulas. Excel may confuse a formula with actual data values, which means that instead of importing the values, it tries to import the formula. In a pinch, you can work around that problem by using "Select All" and then pasting values only, which will strip out formulas.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Minimizing Excel import errors can be a time-consuming, laborious process. However, an out-of-the-box data import solution can flag these common errors and streamline the process of fixing them.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you're spending too much time dealing with Excel import errors and not enough time focusing on your core offering, a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' can streamline, accelerate and secure your data import processes, improving your business and delivering rapid and sustained ROI.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A data exchange solution can:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce data errors',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Improve security and compliance',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce in-house development time and cost',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Increase data usability',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate timely decision-making',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate time to value',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'By ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'leveraging the right solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", you can avoid the costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining complicated workarounds. If you're having trouble importing Excel data, Flatfile has helped hundreds of enterprise clients (and plenty of scaleups) tackle their data migration challenges, supporting just about any business or data requirement. Reach out and ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2021 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '7EmIG1m8hPoVxh9jvTTBXp',
    postTitle:
      'CSV import tool or data file exchange solution: How to pick the right one for your needs',
    seoTitle:
      'CSV import tool or data file exchange solution: How to pick the right one for your needs',
    seoUrlSlug:
      'csv-import-tool-or-data-file-exchange-solution-how-to-pick-the-right-one-for',
    seoMetaDescription:
      'Choosing between a CSV importer and a data exchange solution can directly impact your success. These are the key factors to evaluate for an informed choice.',
    category: 'Data exchange',
    tags: ['Data exchange', 'CSV', 'Data import'],
    sortOrder: '12',
    publishDate: '2024-02-28T09:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'iD9i76XJb7SaXbpM8SMeo',
        type: 'Asset',
        createdAt: '2024-02-28T05:44:25.654Z',
        updatedAt: '2024-02-28T05:44:25.654Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Blog Post - DG6- Data exchange solutions vs. CSV import tools',
        description:
          '"Data exchange solutions vs. CSV import tools" on a white background with icons that represent the choices',
        file: {
          url: '/img/contentful/iD9i76XJ-blog_post_-_dg6-_data_exchange_solutions_vs._csv_import_tools__1_.webp',
          details: {
            size: 72641,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'Blog Post - DG6- Data exchange solutions vs. CSV import tools (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Data exchange solutions vs. CSV import tools" on a white background with icons that represent the choices',
    summary:
      'Choosing between a CSV importer and a data exchange solution can directly impact your success. These are the key factors to evaluate for an informed choice.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '17qKlZvT1Co3tgeyESXwvN',
        type: 'Entry',
        createdAt: '2022-03-25T21:02:30.990Z',
        updatedAt: '2024-03-21T20:05:30.836Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Austin Brown',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6lYjJx09Bzz36Jjd4BOlr5',
            type: 'Asset',
            createdAt: '2024-03-21T20:05:23.571Z',
            updatedAt: '2024-03-21T20:05:23.571Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'austin',
            description: '',
            file: {
              url: '/img/contentful/6lYjJx09-austin.webp',
              details: {
                size: 18259,
                image: {
                  width: 288,
                  height: 288
                }
              },
              fileName: 'Austin.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Enterprise Account Executive',
        department: 'Sales'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’re working on data management or integration projects, you’re going to need to transfer data between different systems or applications. Two common solutions for facilitating this data exchange are CSV import tools and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data file exchange solutions',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. While both serve the goal of transferring data, they differ significantly in their scope of functionality, automation capabilities, and integration with external systems.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What is a CSV import tool?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'CSV files are a common way of representing tabular data, where each row represents a record and data values in each row are separated by commas. A CSV import tool is a software application or feature within a software application that lets users import data from CSV files into a more structured data format, a database or application. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A CSV import tool gives users options to map the values in a CSV file to fields or attributes in the application. This ensures that data is correctly imported and aligned with the structure of the target system. Essentially, a CSV import tool simplifies the process of importing data from CSV files into other systems or applications, saving time and effort for people who need to regularly transfer data between different platforms.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While CSV import tools offer numerous benefits for transferring data between systems, they also have ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'some drawbacks',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ':',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Limited data structure:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' CSV files lack the ability to represent complex data structures like nested objects or relationships between entities. As a result, importing data from CSV files may not fully capture the complexity of the original data.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Data integrity issues:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' CSV files by definition do not include mechanisms for enforcing data integrity constraints such as uniqueness or referential integrity. As a result, data imported from CSV files may contain errors or inconsistencies that could affect the accuracy of the imported data.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Manual mapping required:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' Mapping columns from the CSV file to fields in the target system is typically a manual process. This can be time-consuming, especially for large datasets with numerous columns and complex data structures.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Limited data validation:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' While some CSV import tools offer basic ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          value: 'data validation',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' features, they may not be as comprehensive as those provided by more sophisticated data integration tools. This can increase the risk of importing inaccurate or incomplete data.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Performance issues with large datasets:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' Importing large volumes of data from CSV files can be resource-intensive and may lead to performance issues, especially if the CSV import tool lacks support for efficient batch processing or parallel processing.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Security concerns:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' CSV files are plain text files that do not include built-in security features such as encryption or access controls. Importing sensitive data from CSV files may pose security risks, especially if the files are stored or transmitted over insecure channels.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Dependency on file format:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' CSV import tools are specifically designed to work with CSV files, which may limit their ability to import data from other file formats or sources. Users may need to convert data from other formats to CSV before importing it, which adds an extra step to the data import process.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Despite these drawbacks, CSV import tools are a popular choice for transferring data between systems due to their simplicity, flexibility, and wide compatibility with various software applications and platforms. However, for more complex data integration requirements, organizations may need to consider using data file exchange solutions that offer greater functionality and support for a wider range of data formats and sources.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What is a data exchange solution?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data file exchange solutions, on the other hand, provide a broader set of functionalities beyond simple CSV file imports. These solutions are designed to support various file formats, data transformations, workflow automation, scheduling, error handling, and integration with external systems. Data file exchange solutions ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'help organizations streamline complex data workflows',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', automate repetitive tasks, and ensure data integrity throughout the entire data exchange process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A data exchange solution designed from the ground up can help any company safely and efficiently manage the data collection, import, onboarding and exchange of highly variable data files. Even if your files come from multiple sources in a wide variety of formats and need manual mapping, review, cleanup and validation before you can import them, a data exchange solution will help you deal efficiently with your real-world data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A data exchange solution can:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Streamline complicated data import processes ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Simplify elaborate data workflows ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Allow you to easily collaborate on data across teams',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'How to decide between a data exchange solution and a CSV import tool',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Choosing the solution that makes sense for your organization is a critical choice because it directly impacts your success. Your decision should involve carefully evaluating all of the key factors that are relevant to your use case so that you can make an informed choice. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While CSV import tools often lack the advanced features and capabilities of data file exchange solutions, they can still provide valuable functionality for users with more straightforward data importation needs. Choosing a CSV import tool over a data file exchange solution might be appropriate in certain scenarios where simplicity, cost-effectiveness, and specific requirements are critical.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Here are some reasons why you might choose a CSV import tool:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Simplicity',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': CSV import tools are typically simpler to implement  and require less setup and configuration compared to more comprehensive data file exchange solutions. For users with straightforward data import needs, a CSV import tool can provide a quick and intuitive solution without the complexity of a full-fledged data integration platform.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Cost considerations',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': CSV import tools are often less expensive than data file exchange solutions, especially for smaller organizations or individuals with limited budgets. Since CSV import tools focus on a narrower set of functionalities, they may offer a more affordable option for users who only need basic data importation capabilities.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Simple, fixed use cases',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': In some cases, users may have limited requirements and a fixed “one size fits all” use case that can be adequately addressed by a CSV import tool designed for exactly that use case. For example, if the primary goal is to import a very simple CSV file with just a few columns into a single system or application without complex data formats, transformations or integrations, a CSV import tool may suffice.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Existing infrastructure compatibility',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': If an organization already has systems in place that handle data transformations, validations, and workflow automation, they may choose to add a CSV import tool into the mix. While this approach requires some integration work and ongoing maintenance, it allows them to leverage their current systems and processes while addressing specific data import needs.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Time constraints',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': In situations where there is limited time available for setup and deployment, opting for a CSV import tool can be a faster and more efficient solution. CSV import tools typically have shorter learning curves and require less configuration.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Resource limitations',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': For users with limited technical expertise or resources, a CSV import tool may offer a more accessible solution compared to a data file exchange solution, which may require more technical knowledge.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You need to look at the compatibility of the tool or platform with your existing systems and infrastructure to avoid integration and customization issues. You should also consider scalability and flexibility to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'accommodate growth',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and changing business needs. Evaluating the security features and data protection measures provided by the data exchange platform or CSV import tool is another vital aspect that will help you safeguard sensitive information. By taking these factors into account, you can make a well-informed decision and select the solution that aligns with your business requirements and goals, ultimately leading to optimal results. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These are top factors to consider when evaluating your options:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Expertise and focus:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '\nData import and collaboration platform providers specialize in creating solutions for data management and are committed to resolving problems and ensuring your solution operates smoothly. Look for a solution that invests in research, development, and ongoing improvements and maintenance to deliver robust, feature-rich products.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Security, compliance and reduced risk:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '\nYou may also want to prioritize finding a solution that will reduce the risks associated with software development and offers the assurance of established security measures and compliance adherence. These tools are thoroughly tested, refined, and continually improved based on the experiences of numerous other businesses that have used them. Data exchange platforms typically come with built-in security features and may already comply with industry-standard regulations. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Ease of use and accessibility:\n',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'For most businesses, it makes sense to choose a solution that comes equipped with user-friendly interfaces that offer value for a broader range of employees, customers and use cases. A familiar and intuitive spreadsheet-type interface that people immediately understand how to use can make the process more streamlined and efficient. It should offer real-time validation, error handling, and transformation capabilities, empowering you to easily collaborate across diverse stakeholders and take control of your data.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value:
                        'Excellent data transformation, quality and cleaning capabilities:\n',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "Consider solutions that offer sophisticated data cleaning and validation features. These functionalities can help identify and fix inconsistencies, errors, and missing values within datasets, which ensures the imported data's accuracy and reliability. Here are some some ",
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/6-considerations-for-csv-import-solutions/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          value: 'key capabilities',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' to look for:',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      content: [
                        {
                          data: {},
                          content: [
                            {
                              data: {},
                              marks: [
                                {
                                  type: 'bold'
                                }
                              ],
                              value: 'Parsing data:',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [],
                              value:
                                ' Parsing is the process of taking an aggregation of information (in a file) and breaking it into discrete parts. Essentially, data parsing means the separation of data. You‘ll want to build a data parsing feature that not only provides the ability to transform a file into an array of discrete data but also streamlines this process for your users.',
                              nodeType: 'text'
                            }
                          ],
                          nodeType: 'paragraph'
                        }
                      ],
                      nodeType: 'list-item'
                    },
                    {
                      data: {},
                      content: [
                        {
                          data: {},
                          content: [
                            {
                              data: {},
                              marks: [
                                {
                                  type: 'bold'
                                }
                              ],
                              value: 'Structuring:',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [],
                              value:
                                ' Most product teams want to make sure that data flows seamlessly into their application database via their API. Proper data structuring ensures that data is received into your system and labeled appropriately. APIs expect a certain format of data and will fail without it.\t\t\t',
                              nodeType: 'text'
                            }
                          ],
                          nodeType: 'paragraph'
                        }
                      ],
                      nodeType: 'list-item'
                    },
                    {
                      data: {},
                      content: [
                        {
                          data: {},
                          content: [
                            {
                              data: {},
                              marks: [
                                {
                                  type: 'bold'
                                }
                              ],
                              value: 'Validation:',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [],
                              value:
                                ' Data validation checks the data to make sure it matches an expected format or value. Having this feature in place prevents issues from occurring down the line. Data validation eliminates the need for your users to remove and re-upload data.\t\t',
                              nodeType: 'text'
                            }
                          ],
                          nodeType: 'paragraph'
                        }
                      ],
                      nodeType: 'list-item'
                    },
                    {
                      data: {},
                      content: [
                        {
                          data: {},
                          content: [
                            {
                              data: {},
                              marks: [
                                {
                                  type: 'bold'
                                }
                              ],
                              value: 'Transformation:',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [],
                              value:
                                ' Data transformation makes changes to data as it flows into the system to ensure it meets an expected or desired value. Rather than sending data back to users with an error message, data transformation makes small, systematic tweaks to ensure the data is usable.\t\t\t',
                              nodeType: 'text'
                            }
                          ],
                          nodeType: 'paragraph'
                        }
                      ],
                      nodeType: 'list-item'
                    },
                    {
                      data: {},
                      content: [
                        {
                          data: {},
                          content: [
                            {
                              data: {},
                              marks: [
                                {
                                  type: 'bold'
                                }
                              ],
                              value: 'Data mapping:',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [],
                              value:
                                ' Mapping and matching are often used interchangeably and refer to taking previously unknown source data and matching it to a known target. It’s an absolute requirement that your data importer do this very well. Without data mapping, imports will fail when data elements like column headings don’t match exactly. ',
                              nodeType: 'text'
                            }
                          ],
                          nodeType: 'paragraph'
                        }
                      ],
                      nodeType: 'list-item'
                    }
                  ],
                  nodeType: 'unordered-list'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Workflow flexibility and customization:\n',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'The workflows needed for importing, validating, editing and approving data are often complex and vary from organization to organization. Choose a solution that offers customization to accommodate your unique business needs. This flexibility means that the solution you choose will be able to adapt to changing requirements and workflows within your organization.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Developer tooling:\n',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'Data import and exchange requirements are usually a part of software applications, integration projects and other systems needs. It’s important that the solution you choose is easily usable by your IT team and software engineers, integrates into your tool stack and supports your software development processes. Software developers also need in-depth technical documentation, public API references and easy access to the full data exchange tool set.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Third-party integrations:',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '\nSome platforms offer integrations with other software applications, like databases, analytics tools, and business intelligence platforms. These integrations can streamline your data workflow, enhance data analysis capabilities, and provide seamless connectivity between tasks.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Support and maintenance:\n',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "Assess each vendor's support services, including response times, availability of updates, and maintenance plans. Reliable support will ensure timely assistance in case of issues or concerns, minimizing disruptions in the data import process.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'By carefully evaluating these factors, you can select a solution that meets your unique needs, lowers your long-term costs, and maximizes your ROI. While CSV import tools are suitable for simple data importation tasks, data file exchange solutions offer a more comprehensive set of features and capabilities for managing complex data integration workflows efficiently.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While both CSV import tools and data file exchange solutions serve the purpose of transferring data from a CSV file into systems, organizations with more complex data integration requirements and a need for automation, workflow orchestration, and comprehensive data validation will benefit from a data file exchange solution. By leveraging the ideal solution for your needs, you can streamline data integration processes, improve data accuracy, and drive better insights from your data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile has helped hundreds of companies tackle their data file exchange challenges, supporting just about any business or data requirement. Find out how the Flatfile Data Exchange Platform can address your specific ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data onboarding use case and requirements',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4O4cuYyg5v19Y5roqCvz8K',
    postTitle: 'What is a CSV file: A comprehensive guide',
    seoTitle: 'What is a CSV file: A comprehensive guide',
    seoUrlSlug: 'what-is-a-csv-file-guide-to-uses-and-benefits',
    seoMetaDescription:
      'Learn what (exactly) a CSV file is, how they’re used in different types of software applications, and how to edit, create and import them.',
    category: 'Data exchange',
    tags: ['CSV file', 'CSV import', 'CSV'],
    publishDate: '2024-02-23T09:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'wgc6qYvhnPIPDxQFAN9oE',
        type: 'Asset',
        createdAt: '2021-08-24T19:33:30.784Z',
        updatedAt: '2024-02-23T17:20:54.414Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Defining a CSV File',
        description: 'CSV file icon surrounded by question marks in a table',
        file: {
          url: '/img/contentful/wgc6qYvh-what_is_a_csv_file__guide_to_uses_and_benefits.webp',
          details: {
            size: 41966,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'What Is a CSV file_ Guide to uses and benefits.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'CSV file icon surrounded by question marks in a black and white table',
    summary:
      'Find out what (exactly) a CSV file is, how they’re used in different types of software applications and how to edit, create and import them.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Structured data plays a critical role in data management and information exchange, and the CSV file format is one of the simplest formats for representing structured data. Whether you're a data analyst or software developer, or you work with data in any capacity, understanding what the CSV file format is, when it’s useful and how it works is a fundamental skill.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A CSV is a commonly used file extension for spreadsheets. Even software programs that don't look and feel like a spreadsheet application frequently offer a CSV file type as an output file for downloading a dataset (like a contact list, a supply list or a report of results or actions). Why? Because CSVs are incredibly easy to edit and share!",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "In this post, we dive into what (exactly) a CSV file type is, how they're used in different software applications and how to create, edit, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'export and import them',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Table of contents',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#whatIsACsvFile'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'What is a CSV file?',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#theTypesOfSoftwareThatUseTheCsvFileFormat'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'The types of software that use the CSV file format',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#benefitsOfCsvFiles'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Benefits of CSV files',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#howToOpenAndEditACsvFile'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'How to open and edit a CSV file',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#howToCreateACsvFile'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'How to create a CSV file',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#howToImportACsvFile'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'How to import a CSV file',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#beyondTheCsvOtherFileFormatsUsedForSpreadsheets'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Other file formats used for spreadsheets',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can efficiently wrangle CSVs and accelerate your data workflow? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your data challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is a CSV file?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“CSV” refers to the CSV file extension, meaning any file that ends in ".csv." The .csv file extension stands for "comma-separated value” file, and it\'s one of the most common outputs for any spreadsheet program. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A comma-separated value file refers to a file where the data is input as data separated by commas. A spreadsheet application converts those comma-separated pieces of data into cells in tables to make them easier to read and edit. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In Windows, you can click on any file to see a preview of it in the file explorer folder on the right. If you click on an Excel CSV file, you can actually see what it looks like behind the scenes: A mess of data separated by commas. Thank goodness for programs like Microsoft Excel and Google Sheets, which make this data much more manageable than just a block of text with a ton of commas!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The types of software that use the CSV file format',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Many types of software use the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://medium.com/@martindrapeau/the-state-of-csv-and-json-d97d1486333'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'CSV file format',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. The two most common ways a CSV file would be used are inputting and outputting. On the input side, a CSV file will be imported, bringing data in to be utilized within a software program. As for outputting, a CSV is a standard output file format because software users can easily edit and share CSV file reports or datasets. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Let's look at some examples to better understand how software utilizes CSV files. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Common use cases for importing CSV files',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the most common reasons to import a CSV file in the business world is to upload a list of customer contacts. You might do this when ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-to-tackle-data-chaos-in-customer-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' data to a new email marketing software like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.activecampaign.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Active Campaign',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3UM9Wih56YJEokc0s8yUJ',
                type: 'Asset',
                createdAt: '2021-08-24T19:29:06.790Z',
                updatedAt: '2021-08-24T19:29:06.790Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Active Campaign CSV upload',
                description: 'Active Campaign CSV upload',
                file: {
                  url: '/img/contentful/3UM9Wih5-hoscjjoaqra5t8xnapwx.webp',
                  details: {
                    size: 44031,
                    image: {
                      width: 512,
                      height: 261
                    }
                  },
                  fileName: 'HOSCJJoAQra5T8XnapwX',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Another type of software that could require you to upload a list of customer contacts would be a CRM like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.hubspot.com/?__hstc=164574496.a5cc0fa9ee384d7025bf88f0154ff560.1700505683779.1703711127232.1703714171852.103&__hssc=164574496.1.1703714171852&__hsfp=3857295638'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Hubspot',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.nutshell.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Nutshell',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. Referral marketing software like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://growsurf.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'GrowSurf',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' could also require you to upload customer lists to add customers to your referral program so they can generate a unique referral link to share your business with their friends.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "There are, of course, numerous other datasets you might want to upload beyond customer lists. For example, if you're an ecommerce company, you might need to upload a list of your product SKUs to an inventory management system or order fulfillment software.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Common use cases for exporting CSV files',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Not only do many software programs input CSVs, but they also output them. A CSV file format is a standard exporting format because it's ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'well-recognized and widely used',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Its simplicity has led to its adoption by so many programs that few software developers want to stray from CSVs with a different file format when exporting spreadsheet data. Some programs will give you the option of exporting CSV or PDF, such as ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://gusto.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "Gusto's custom report builder",
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', but when it comes to spreadsheet data, a CSV export is the most common file format.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5TfKMTVSaEk7nSthvWVETK',
                type: 'Asset',
                createdAt: '2021-08-24T19:29:38.408Z',
                updatedAt: '2021-08-24T19:29:38.408Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Gusto custom report builder',
                description: 'Gusto custom report builder',
                file: {
                  url: '/img/contentful/5TfKMTVS-lzd97vqprse3srtd0xoa.webp',
                  details: {
                    size: 187063,
                    image: {
                      width: 1600,
                      height: 869
                    }
                  },
                  fileName: 'LZD97VqPRSe3SRtd0xoa',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Key benefits of CSV files',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Why use CSV files? Let's take a look at the most important benefits:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Widely adopted',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': People within your organization will likely be accustomed to using CSV files. Most importantly, this file type is not unique to Macs or PCs but can be used by any desktop device and operating system. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Easy to organize and edit:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'CSV files are editable',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ', and the changes are not locked unless, of course, a user locks a specific set of cells from editing. The good news is that, unlike PDF downloads of spreadsheet data, CSVs can be changed later. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Utilized by many business software programs',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': Many enterprise software programs rely on CSV imports for onboarding user data. At the same time, plenty of programs have CSVs as their primary output for reports.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Used by major spreadsheet applications',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': When you use CSV files, you can create and edit them in any major spreadsheet application like Microsoft Excel or Google Sheets.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '25gVxnobRnOZ1Ssg7WHpub',
                type: 'Entry',
                createdAt: '2021-08-13T21:53:47.725Z',
                updatedAt: '2024-07-30T23:58:59.586Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 44,
                revision: 8,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Evaluating Flatfile for your business needs?',
                text: 'Reach out to our experts today to scope your data conversion, onboarding and migration processes',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How to open and edit a CSV file',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Excel is the most commonly used spreadsheet application for opening and editing CSV files. You can download a CSV file from many software programs. If you have Excel installed on your computer, your computer will automatically default to it as your spreadsheet application. So, after downloading the CSV file, just double-click to open it in Excel. If you already have it in a file folder, you can simply double-click to open it. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To edit any piece of data, just click once on the cell that contains the data. You can edit the cell content directly in that cell or in the area called fx, which stands for "',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.mrexcel.com/excel-tips/excel-2020-discover-new-functions-by-using-fx/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Excel Functions',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '." In this area, you can write standard characters and text or any functions and formulas you want to use.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How to create a CSV file',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Want to create a brand new CSV file? Here's how:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Open up Microsoft Excel and save a new file as a CSV. You can then edit it, and it will continue to save as a CSV whenever you click save. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The most common way to get started is to create the headings for your columns. Let's say you want to create a contact information list for the people on your team. You can make one column for first names, another for last names, another for phone numbers, and another for email addresses.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How to import a CSV file',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Thousands of software programs utilize CSV files. The CSV import process will differ slightly for each one, but due to the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://medium.com/@tiffinewang/the-consumerization-of-enterprise-tech-344ba7fbfc58'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'consumerization of enterprise tech',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', even business programs should have easy-to-use CSV import features. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Most CSV importers follow this process:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Select the file you want to upload:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' From your computer, select the correct CSV file you want to import to your software program. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Match the columns to the appropriate fields:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' The next step is to ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'match the headings',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' in your CSV columns to the data fields used and understood by your software. This is a key step towards making sure your imported CSV data is usable. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Address any errors: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'A quality CSV importer should be able to ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'explain if anything goes wrong',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value:
                        " clearly. This way, you can edit the data and try the import again. Without details on the CSV import issues, it's tough for users to know how to fix them. Unfortunately, many software programs lack quality CSV importers who provide ",
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.axiomdatascience.com/best-practices/DataandFileFormatting.html'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'troubleshooting',
                          marks: [],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Beyond the CSV: Other file formats used for spreadsheets',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Besides CSV files, there are a few other file formats that can be read and understood by spreadsheet programs or can be used to download data sets ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'from',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' a spreadsheet program. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When working in Google Sheets, you can download the file in several different formats besides CSVs:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Microsoft Excel (.xlsx)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'OpenDocument format (.ods)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'PDF document (.pdf)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Web page (.html)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Tab-separated values (.tsv)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5RTmEnstYFyu5KFl5yXMvD',
                type: 'Asset',
                createdAt: '2021-08-24T19:31:05.251Z',
                updatedAt: '2021-08-24T19:31:05.251Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Microsoft Excel CSV import screenshot',
                description: 'Microsoft Excel CSV import screenshot',
                file: {
                  url: '/img/contentful/5RTmEnst-ky2hpyyprqebhh8h6qdw.webp',
                  details: {
                    size: 34225,
                    image: {
                      width: 512,
                      height: 278
                    }
                  },
                  fileName: 'KY2hPyypRQeBHH8H6qdw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As for Microsoft Excel, there are even more file formats available for saving data from your spreadsheet, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel Workbook (.xlsx)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel Macro-Enabled Workbook (.xlsm)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel Binary Workbook (.xlsb)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel 97-2003 Workbook (.xls)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'XML Data (.xml)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Single File Web Page (.mht or .mhtml)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Web Page (.htm or .html)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel Template (.xltx)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel Macro-Enabled Template (.xltm)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel 97-2003 Template (.xlt)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Text tab-delimited (.txt)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Unicode text (.txt)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'XML Spreadsheet 2003 (.xml)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Microsoft Excel 5.0/95 Workbook (.xls)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Formatted Text space-delimited (.prn)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Text Macintosh (.txt)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Text Ms-DOS (.txt)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'CSV Macintosh (.csv)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'CSV MS-DOS (.csv)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'DIF (.dif)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'SYLK (.slk)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel Add-in (.xlam)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Excel 97- 2003 Add-in (.xla)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'PDF Document (.pdf)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'XPS Document (.xps)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Strict Open XML Spreadsheet (.xlsx)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'OpenDocument Spreadsheet (.ods)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3yEiL3W1Bcqy3fgrBETd3e',
                type: 'Asset',
                createdAt: '2021-08-24T19:31:51.621Z',
                updatedAt: '2021-08-24T19:31:51.621Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Microsoft CSV file types',
                description: 'Microsoft CSV file types',
                file: {
                  url: '/img/contentful/3yEiL3W1-lesq9qqqgiuoex96ulzm.webp',
                  details: {
                    size: 72033,
                    image: {
                      width: 512,
                      height: 472
                    }
                  },
                  fileName: 'lEsq9QqQgiuOEX96ulzM',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "CSV files are popular for a reason. They're simple, minimalistic, widely understood and utilized by many different types of software. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2020 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6HIqvj4ME90ORiwX37naXh',
                type: 'Entry',
                createdAt: '2024-01-12T01:19:47.604Z',
                updatedAt: '2024-07-30T23:58:59.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 32,
                revision: 7,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Watch Flatfile in action',
                text: 'We can help you spend 70% less time onboarding data. Discover how',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2TrdmU4PNTAhbS4kzC2nuB',
    postTitle: '6 common CSV import errors and how to fix them',
    seoTitle: '6 Common CSV Import Errors and How to Fix Them',
    seoUrlSlug: 'top-6-csv-import-errors-and-how-to-fix-them',
    seoMetaDescription:
      'Discover the top 6 most common CSV import errors that companies experience when uploading data and how to fix them.',
    category: 'Data exchange',
    tags: [
      'CSV import',
      'CSV import errors',
      'data import',
      'data exchange',
      'Popular'
    ],
    publishDate: '2024-02-16T09:25-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4ypglbXcRpzjqRMkSAzNk5',
        type: 'Asset',
        createdAt: '2024-02-16T17:14:00.254Z',
        updatedAt: '2024-02-16T17:14:00.254Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '6 common CSV Import Errors and How to Fix Them',
        description:
          'Image depicting 6 common CSV import errors and a rectangular box that says "CSV Import failed"',
        file: {
          url: '/img/contentful/4ypglbXc-6_csv_import_errors_and_how_to_fix_them.webp',
          details: {
            size: 42138,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '6 CSV Import Errors and How to Fix Them.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Image depicting 6 common CSV import errors and a rectangular box that says "CSV Import failed"',
    summary:
      'Despite advances in nearly every aspect of technology, getting a CSV file from one system to another is still a major stumbling block. But the first step toward fixing a CSV import error is understanding the problem clearly. Here are the 6 most common CSV import errors that companies experience when uploading data and how to fix them.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Importing data files like CSVs and Excel spreadsheets isn’t for the faint of heart. There are plenty of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'things that can go wrong',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' in the data import process, but luckily, these common errors are easy to fix.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '"Upload failed"',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '"Missing required field"',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '"Invalid data for field" ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '"Maximum error count has been reached, or a system error occurred!" ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '...look familiar?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If you’ve ever had to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/category/data-exchange/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'import a CSV',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", you've probably seen these common import error messages. Despite advances in nearly every aspect of technology, getting a CSV file from one system to another is still a major stumbling block. And since clients can't use your application without being able to populate their data, the CSV file import problem usually happens at the worst time: During the ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-customer-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'customer onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' process.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "You might think you've solved the problem by creating client instructions for properly formatting a CSV for import or providing a pre-made CSV template so they can manipulate their data to meet your import needs. But you really haven't haven't \"solved\" anything. You've just ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'shifted the burden',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " of fixing the CSV import error to your client just when you're trying to impress them with your technological expertise.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The first step toward ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'solving the CSV import ',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: 'error is understanding it clearly.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to learn how you can efficiently wrangle CSVs and accelerate your data workflow? ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Schedule a free demo now',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for a personalized look into how Flatfile can solve your data challenges.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'What are the top CSV import issues that can cause major headaches when importing data files?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#1FileSize'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'File size',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#2Matching'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Matching',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#3TranslationData'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Translation',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#4Values'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Values',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#5MissingData'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Missing data',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: '#6NondigestibleFormats'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Non-digestible formats',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. File size',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the most common CSV import errors is that the file is simply too large. That can be caused by too many fields or records in the file, too many columns, or too many rows. The import error can be caused by limits set by the program using the file or the amount of available memory on the system. If your import fails because of file size issues, you need to go back and break the file up into smaller files, which will enable it to upload successfully. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Matching',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Another key import error that pops up when uploading a CSV file is related to matching. This could be ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "columns that don't match expected field names",
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' caused by different values than expected, field names not on the first line, or simply the complete absence of column names.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A matching error could also occur when the expected columns are in the wrong order or required fields – columns – are missing.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. Translation (data)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "A data translation error could occur if the encoding is incorrect or unexpected. Another cause could be the presence of non-standard characters that aren't usable. For example, it may be necessary to save a file with UTF-8 encoding for that file to work properly within a company's platform. Attempting to import data with different encoded files would simply not work. Check out this ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/saving-inkit-100k-per-year-data-import-costs-flatfile-portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Inkit case study',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' to see this exact example.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Values',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Issues with data values can be a significant cause of CSV importing errors. These include unexpected data length – either too long or too short. It could also mean unacceptable characters such as text in a numbers-only column or numbers in a boolean (a boolean is a data type with two possible values: True or false.)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Related fields with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'conflicting data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', such as records with multiple types of unique identifiers when only one is allowed, will cause errors. For example, the city/state names are different from their actual zip code or even a related field that does not have required data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. Missing data',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Missing data is one of the most common errors for CSV imports. Examples include incomplete data that can be fixed by a user, such as invoices that have month and day but no year information. Other incomplete data can be addressed by a user with help from the system they're working in. Missing city/state data with zip codes present and existing contact role information can usually be automatically appended. New contact role information, including suggestions from the systems based on matching related contacts or data, must be manually corrected in the system.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In some cases, incomplete data must be pulled in by a person or another system. For example, real estate sales data that is missing the original list date or comparable property information could be pulled in from public records. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '6. Non-digestible formats',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Non-digestible formats include simple format mismatches that need format normalizations, such as phone numbers or social security numbers, which are numbers only without symbols. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Complex format mismatches would need format normalization AND data normalization, such as when the date format is different than expected, inconsistent, or includes text rather than being normalized, for example, "July 31st 2020" or "Jun twentieth 19."',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Minimizing CSV import errors can be a time-consuming, laborious process, but there's a better way: leveraging an out-of-the-box CSV data exchange solution can eliminate these common errors and streamline the import process. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you’re spending too much time dealing with CSV import errors and not enough time on your core focus, a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' can streamline, accelerate and secure your data import processes, improving your business and delivering rapid and sustained ROI.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The right solution will:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce data errors',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate timely decision-making',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce in-house development time and cost',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Increase data usability',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate time to value',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Improve security and compliance ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'By ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'leveraging a data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', you can avoid the costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining complicated workarounds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flatfile, the pioneer of AI-assisted data exchange, provides companies and their software development teams with the easiest, fastest, and safest way to build the ideal data file import experience for their users. If you aren't sure what the right solution is for your business, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'contact Flatfile today',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". We've worked with hundreds of customers to solve their data exchange challenges, and we can help you build the solution that's right for you.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6HIqvj4ME90ORiwX37naXh',
                type: 'Entry',
                createdAt: '2024-01-12T01:19:47.604Z',
                updatedAt: '2024-07-30T23:58:59.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 32,
                revision: 7,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Watch Flatfile in action',
                text: 'We can help you spend 70% less time onboarding data. Discover how',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Editor's note:",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' This post was originally published in 2020 and has been updated for comprehensiveness.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '6vtkY1aDshYmmMBGFta39r',
    postTitle:
      'Like chocolate and peanut butter: When to use ETL, data file exchange (or both!)',
    seoTitle:
      'Like chocolate and peanut butter: When to use ETL, data file exchange (or both!)',
    seoUrlSlug:
      'like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both',
    seoMetaDescription:
      'Knowing when to take advantage of the benefits that data exchange and ETL offer can help you make informed decisions and stay competitive in a data-centric world.',
    category: 'Data exchange',
    tags: ['data exchange', 'ETL', 'data import', 'data cleaning', 'Featured'],
    sortOrder: '3',
    publishDate: '2024-02-14T08:11-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5uHvl7LD2L3PKYcAlVlWI8',
        type: 'Asset',
        createdAt: '2024-02-14T02:55:59.362Z',
        updatedAt: '2024-02-14T02:55:59.362Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'ETL and data file exchange',
        description:
          '"ETL and data file exchange" on a white background with images that represent ETL and data exchange',
        file: {
          url: '/img/contentful/5uHvl7LD-blog_post_-_dg2_-_top_6_data_import_challenges.webp',
          details: {
            size: 80043,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - DG2 - Top 6 data import challenges.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"ETL and data file exchange" on a white background with images that represent ETL and data exchange',
    summary:
      'Combining the strengths of a data exchange platform with the advantages of a traditional ETL tool will create an ideal data integration and management ecosystem that can handle data exchange, transformation, and loading processes and help you seamlessly communicate and collaborate.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4e8VT08UTBNDVEEXyXmBEX',
        type: 'Entry',
        createdAt: '2023-04-03T18:49:21.580Z',
        updatedAt: '2024-02-09T18:50:21.687Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Gottfried Sehringer',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5KaxrJpuaiQ0f8hiCzQYVm',
            type: 'Asset',
            createdAt: '2023-04-03T18:48:38.608Z',
            updatedAt: '2023-04-03T18:48:38.608Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Gottfried Sehringer picture',
            description: '',
            file: {
              url: '/img/contentful/5KaxrJpu-1641306098983.webp',
              details: {
                size: 30320,
                image: {
                  width: 400,
                  height: 400
                }
              },
              fileName: '1641306098983.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Chief Marketing Officer'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A strong flow of information can drive decision-making and innovation. But what makes that flow possible is the infrastructure that directs the movement and transformation of data. Two critical components of this data ecosystem are ETL (Extract, Transform, Load) and data file exchange (collecting, transforming and importing data files), and each plays an important role in ensuring data accessibility, accuracy, and usability.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'ETL processes are responsible for automatically and regularly extracting data from specific sources, transforming it into a desired target format, and loading it into systems for analysis and reporting. ETL is perfect for well-structured data and highly managed systems and databases. You can use an ETL tool to do things like synchronizing master customer data between a CRM system and an accounting system or loading data from a transactional system into a data warehouse. However, these systems are built on the idea that data is only ever transferred between tightly managed IT systems.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', on the other hand, helps with all the other data, specifically how to efficiently, quickly and securely collect, transform and load data files into your structured IT systems. If such files come from tons of different sources or arrive in a variety of formats and need ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data mapping',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', review, cleanup and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'validation',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' before you can import them, a data exchange solution will help you collect and load them into different systems, applications or databases, data file exchange is the solution you need.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Enterprise-class data exchange solutions ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'can cover a range of use cases',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", from simple file imports to complex data onboarding workflows. Whether you're collecting data from millions of remote users, exchanging data with business partners or sharing information between departments within an organization, data file exchange offers you the flexibility, security and ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/category/data-exchange/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'speed you need',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'to efficiently get your data in the right shape to the right place.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Why not use both?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data exchange solutions are actually designed to work seamlessly alongside traditional integration solutions. ETL tools integrate structured systems and databases and manage the ongoing transfer and synchronization of data records between these systems. If you add a data exchange solution to your ETL tool, you’ll have the power to import and exchange highly variable data files from sources that aren’t managed by a professional IT organization. They can be implemented either on separate independent and parallel tracks or so that the data file exchange solution feeds the restructured, cleaned and validated data into the ETL system for further consolidation in downstream systems.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Like chocolate and peanut butter: Data exchange and ETL',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Pairing a data exchange solution with a traditional ETL tool offers a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'lot of advantages',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' for managing and transferring data and a number of key capabilities to your data integration stack, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Human-in-the-loop:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data exchange solutions are designed for human interaction and adding this capability can improve efficiency and data quality and reduce error rates.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data collaboration: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Effective data exchange often requires review and interaction between the person who submits the data and the person who reviews it. ETL tools are optimized for automated system-to-system data synchronization. The use of data exchange systems provides a solution for a data collaboration use case securely, efficiently and at scale.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Any source:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' ETL tools can provide strong connections between known systems and data exchange solutions are great for receiving data from any type of source without the need for fixed integration points and long, drawn-out implementation projects.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ephemeral data integration:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data imports can sometimes come from individual users that only drop in one file at a time. The integration and interaction with a single user may only be for seconds, and then that single-user integration will never be needed again. Providing this “disposable” integration from both known users and anonymous website visitors can be a critical capability that data exchange solutions provide.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Data collection from many (small and large) sources:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' The wide variety of potential data sources, often across thousands or millions of data submitters, is a challenge for any system that requires traditional integration credentials and specifications. Data exchange solutions are built on the idea that data sources are variable, unreliable and unpredictable. They can act as a filter and provide structure and order for incoming data, no matter what type and how many sources.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Intelligent and scalable data cleaning and validation:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Data exchange tools can handle large volumes of data that might otherwise require a lot of time and manual effort to clean, validate and process. This supports a much more timely and efficient flow of data in parallel to other data streams that are managed with ETL tools.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Secure gate for external data:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' A data exchange solution provides an effective entrance gate to any organization’s data ecosystem. This helps enforce governance and compliance standards for data sharing and privacy and provides a secure pathway for new data entering your systems.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Combining the strengths of a data exchange platform with the advantages of a traditional ETL tool will create an ideal data integration and management ecosystem that can handle data exchange, transformation, and loading processes and help you seamlessly communicate and collaborate.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile, the pioneer of AI-assisted data exchange, provides companies and their software development teams with the easiest, fastest and safest way to build the ideal data file integration experience for their users. Hundreds of companies rely on Flatfile’s extensible, API-first platform to create enterprise-scale, intelligent, file-based data import solutions, increase developer productivity, reduce cost and improve data quality. Reach out today to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'In the constantly changing and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'evolving world of data management',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', understanding ETL and data file exchange processes is like holding the keys to a data-driven kingdom. Taking advantage of the benefits of each can help you make sure that the right data reaches the right places in the right format, helping you make informed decisions and stay competitive in a data-centric world.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '622ONGpVPgQVrSV2c7gQKX',
    postTitle:
      'The high cost of not addressing your CSV, Excel and file-based import problems',
    seoTitle:
      'The high cost of not addressing your CSV, Excel and file-based import problems',
    seoUrlSlug: 'high-cost-not-addressing-csv-excel-file-based-import-problems',
    seoMetaDescription:
      "If you're struggling with CSVs, Excel spreadsheets or other file formats, your costs will mount quickly. Here’s how you can avoid the expense of having the wrong solution in place.",
    category: 'Data exchange',
    tags: [
      'data exchange',
      'data import',
      'CSV',
      'Excel',
      'costs',
      'data quality',
      'data files'
    ],
    sortOrder: '6',
    publishDate: '2024-02-07T08:11-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3jCTy5xo2OcSq4okoSOlFk',
        type: 'Asset',
        createdAt: '2024-02-05T23:21:50.685Z',
        updatedAt: '2024-02-05T23:21:50.685Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'The high costs of CSV and Excel import tools',
        description:
          '"The high cost of outdated tools" on a white background with icons representing the mounting costs of the wrong CSV or Excel import tool',
        file: {
          url: '/img/contentful/3jCTy5xo-blog_post_-_dg4-high_costs_of_outdated_csv_and_excel_import_tools.webp',
          details: {
            size: 85421,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'Blog post - DG4-high costs of outdated CSV and Excel import tools.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"The high cost of outdated tools" on a white background with icons representing the mounting costs of the wrong CSV or Excel import tool',
    summary:
      "If you're struggling to wrangle CSVs, Excel spreadsheets, pdfs or other file formats that are coming at you from every direction, it's time to take a serious look at your data import process. Find out how you can avoid the mounting costs that come with not having the right solution in place.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4ILxnejz6ixLikTPf2SSQE',
        type: 'Entry',
        createdAt: '2021-10-07T00:43:23.240Z',
        updatedAt: '2021-10-07T00:43:23.240Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Mike Denenberg',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '1DXkrFcFWLDkvIgiRadJ8h',
            type: 'Asset',
            createdAt: '2021-10-07T00:42:40.353Z',
            updatedAt: '2021-10-07T00:42:40.353Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'c92CMlBMR9uM9GIVkW2E',
            description: '',
            file: {
              url: '/img/contentful/1DXkrFcF-c92cmlbmr9um9givkw2e.webp',
              details: {
                size: 62980,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'c92CMlBMR9uM9GIVkW2E',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Even though you know how important it is to have the right data integration tools and processes in place, there's a good chance you're missing an important aspect that can save your business millions of dollars. Unless you already have the ideal solution in place for your use case and requirements, it's time to take a serious look at your data import process.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you're struggling to wrangle CSVs, Excel spreadsheets, PDFs or other file formats that are coming at you from everyone from internal team members to external vendors while juggling compliance issues and data security concerns, there's a good chance you're looking at delayed projects, missed opportunities, lost revenue and customer churn. There are a number of ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'workarounds you can try',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', but the costs of having no proper solution or the wrong tool add up quickly.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How can you tell that the costs of your current data import solution are too high?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are several signs you can watch out for, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#highSoftwareDevelopmentAndMaintenanceCosts'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'High software development and maintenance costs',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#overwhelmingDataVolumeAndDelayedDecisionmaking'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'Overwhelming data volume and delayed decision-making',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#accuracyAndDataQualityIssues'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Accuracy and data quality issues',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#dataSecurityConcerns'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Data security concerns',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#noncomplianceWithRegulations'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Noncompliance with regulations',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#missingOversightAndAuditLogs'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Missing oversight and audit logs',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/#distractionFromCoreCompetencies'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Lost focus on core competencies',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'High software development and maintenance costs',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "One of the most common workarounds to data import challenges is to build an in-house tool to import CSVs. That can seem like a smart move at first, but developing your own tool can be a time-consuming and expensive process, especially when you look at how your costs will build up over time. At the very least, you'll need a dedicated team of developers and testers, plus people who can handle ongoing maintenance and updates.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If your labor costs for using your talented team members to troubleshoot data import problems, research and create solutions, resolve errors, proactively address compliance and security issues, and update the tool have been climbing, it may be time to reevaluate your solution. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Overwhelming data volume and delayed decision-making',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Do you need to coordinate complex workflows with multiple teams and vendors, each working with their own data files? As your company grows, the volume of data you need to manage will grow, too. If you can see that your team is spending a ton of time manually inputting and processing data, it's a clear sign that modernization is necessary.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "An outdated or less-than-ideal data import tool can make data acquisition and processing slow and inefficient, and it can lead to customer churn. If, for example,  you have customers who can't use your application because your in-house tool is slowing or stopping progress, it's unlikely you'll retain those customers, and you may want to look at whether you have the right solution in place.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Accuracy and data quality issues',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If your team is spending unnecessary time ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'struggling with common data import issues',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " like duplicate entries, inconsistent formats, or missing information, it's time to consider upgrading your solution. If your current solution doesn't support automation, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'enforce consistent formats and structures',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', automatically identify and remove duplicate records from incoming data and provide integrations with external data sources, it may be time to upgrade your data implementation process. For speed and ease of use, some platforms even offer features like version control, AI-enhanced features and automated data mapping.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data security concerns',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "An outdated tool probably doesn't offer comprehensive, advanced security features like encryption, access controls, and audit trails that protect your data during the import process. Your sensitive information could be more vulnerable to breaches, which can lead to data theft, regulatory noncompliance, and reputational damage, all of which can come with major financial consequences.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Noncompliance with regulations',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Many industries are also subject to strict data governance regulations, including GDPR, HIPAA, and SOX, and failing to comply with those regulations can result in severe penalties. You could face expensive consequences if your current solution doesn't provide features that track data lineage, enforce data retention policies, and generate audit reports.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Missing oversight and audit logs',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Can you see what's happening during your data import process? Outdated and homegrown tools often don't have a user-friendly interface with easy-to-understand reporting and analytics features.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Unless they offer real-time monitoring, traceability, accountability, and compliance verification, workarounds and outdated data import tools won't help you meet the challenges of data protection regulations, and the costs of separately creating and maintaining this critical information can be high.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Distraction from core competencies',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Developing and maintaining your own solution can divert time, energy and other resources from your business's core competencies. If your team can't concentrate on your core focus and you have to devote the developer's time to your data import workaround or outdated tool, the costs of reduced and delayed productivity can add up quickly.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How can you lower your data import costs?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you're finding that your data import process is regularly becoming a time-consuming task, choosing the right ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' can help you lower your data import costs over time. In addition to solving the problems listed above, there are even more ways the right solution can help your business, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reducing labor costs: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        "The need for extra staff to maintain and improve workarounds and in-house tools is an ongoing expense, which can impact your company's financial health over time and eat into your company's profitability.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reducing inefficiencies: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Inefficient data import processes can cause bottlenecks in data handling, which slows down all of the other processes that depend on timely access to accurate data. This can reduce your ability to adapt to changes and take advantage of new opportunities.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Supporting growth and scalability: ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'Most in-house solutions and workarounds solve a specific problem, but what if things change? As your business grows, managing increasing data volumes and complexities will just become more challenging. Without the right tool, your current processes may struggle to scale effectively, which will almost certainly lead to lost business opportunities.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Avoiding the consequences of data errors:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        " Without the right data exchange solution, you're more susceptible to data errors and inaccuracies and all of the consequences that come with them. Employees and customers make mistakes, and homegrown tools and workarounds quickly become outdated and error-prone, which will lead to security risks, data inaccuracies, duplicate entries, and inconsistencies in data formats. Inaccurate data can also lead you to make misguided decisions, which will affect your business strategy, marketing campaigns, and financial planning. Correcting these errors after they happen can be time-consuming and expensive.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What you can do next',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Deciding if and when you should ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'consider a comprehensive data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' should be guided by not just the information here but also your specific needs and requirements. The long-term benefits of such a data exchange solution, like automation and time savings, data quality and accuracy and improved decision-making, will far outweigh your investment very quickly. And your ability to focus on your core business rather than on building and maintaining outdated tools or complicated in-house data import workarounds will set you up to thrive in today’s competitive market.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '5cLgtDLFGy4EMHFk85SG6u',
    postTitle:
      'How BuildOps helps keep critical infrastructure running with Flatfile',
    seoTitle:
      'How BuildOps helps keep critical infrastructure running with Flatfile',
    seoUrlSlug:
      'how-buildops-helps-keep-critical-infrastructure-running-with-flatfile',
    seoMetaDescription:
      'BuildOps helps people who keep power plants and hospitals running and is responsible for a lot of moving targets. Here’s how Flatfile helped clear their data import bottleneck.',
    category: 'Customer stories',
    tags: [
      'data exchange',
      'customer story',
      'BuildOps',
      'data import',
      'automation',
      'Featured'
    ],
    sortOrder: '1',
    publishDate: '2024-02-06T08:11-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2ojABDbniLvusr7pozOQeE',
        type: 'Asset',
        createdAt: '2024-02-05T22:12:52.456Z',
        updatedAt: '2024-02-05T22:16:42.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title:
          'Featured image: How BuildOps help keep critical infrastructure running with Flatfile',
        description:
          '"BuildOps clears its data import bottleneck with Flatfile" on a white background with an abstract design',
        file: {
          url: '/img/contentful/2ojABDbn-buildops-blog-post.webp',
          details: {
            size: 54271,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'BuildOps-blog-post.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"BuildOps clears its data import bottleneck with Flatfile" on a white background with an abstract design',
    summary:
      "When your company works with the people who keep power plants, hospitals and commercial real estate running, you're responsible for a lot of moving targets. Find out how Flatfile helped BuildOps clear its data import bottleneck.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3g8UtF3xqMDeJcwD9zabc5',
        type: 'Entry',
        createdAt: '2022-12-05T16:44:02.752Z',
        updatedAt: '2022-12-05T16:44:02.752Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Noelle Festa',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6pb3PzTTNmEL9U8H4YaJBH',
            type: 'Asset',
            createdAt: '2022-12-05T16:42:27.684Z',
            updatedAt: '2022-12-05T16:42:27.684Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Noelle Headshot',
            description: '',
            file: {
              url: '/img/contentful/6pb3PzTT-t0ap8ur47-u03ea82my2u-d9a5ad607b89-512.webp',
              details: {
                size: 54407,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U03EA82MY2U-d9a5ad607b89-512.jpeg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'BuildOps customers serve data centers, hospitals, power plants, and other large-scale critical infrastructure and BuildOps has been enjoying steady growth with its recession-proof business model. However, with data files and records coming in from people and teams across the country, the volume of data was becoming overwhelming.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "When your company works with the people who keep power plants, hospitals and commercial real estate running, you're responsible for a lot of moving targets. With new contractors coming on board every day, BuildOps realized it was time to find a solution for managing the ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'challenges of data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'BuildOps decided to implement ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to streamline its workflow, which removed their data flow bottleneck and decreased time to launch by about 15%-20%. They now have a faster onboarding process that lets their customers get their focus back on what matters.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Flatfile is one of the levers we’re pulling to make our process more scalable, repeatable, and automated,” said Scott Patterson, Director of Implementation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Growing pains',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As their business grew, BuildOps knew they had to automate. BuildOps customers come to them with in-house database files, spreadsheets, and even handwritten records. This "master data" includes information about their customers\' properties, vendors, and the products their teams use to get their jobs done. All of that data needs to be imported into BuildOps before customers can get started on the platform. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '"There’s a wide degree of variability between customers," said Arjun Karande, Chief Architect at BuildOps. "We request that our customers share data in a standard format, but that doesn\'t always happen. Often, they\'ll send it to us in whatever format they have, and it becomes our job to clean it up. And we have to be very careful not to introduce new errors that could further delay their rollout, costing everyone more money."',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Implementation managers at BuildOps used to perform this task manually, which sometimes took weeks. "We ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'considered building a data import solution on our own',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '," said Karande. "But that was just going to be another piece of software for us to develop and manage. Eventually, we decided that it would be better to look for a ready-made solution built by a team whose core focus was this particular task. That is how we came to choose Flatfile.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TeslTqcCH6G3Jjogccn9K',
                type: 'Entry',
                createdAt: '2024-01-12T01:22:24.597Z',
                updatedAt: '2024-01-12T01:22:24.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Connect with an expert',
                text: 'Evaluating Flatfile for your business needs?',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Automating data import provides direct business impact',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'BuildOps now automates its customer data import process using Flatfile, which uses machine learning to automate decisions about how data is formatted based on thousands of previous use cases. Now, users can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'sort through and correctly format large data sets in minutes',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' (rather than weeks). A human-in-the-loop layer suggests corrections and remembers decisions for later reuse. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The best part was that getting started with Flatfile was easy.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The implementation process was fantastic,” said Karande. “The Flatfile support team was always available and super responsive to our needs. It wasn’t long before we got comfortable using it on our own.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The real power of Flatfile is its highly customizable APIs that allow developers to customize Flatfile for their specific business and to trigger its functionality from within other applications. Using Flatfile APIs and the Flatfile Software Development Kit (SDK), developers can create highly specialized solutions that integrate seamlessly with their existing workflows.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“It really helps that Flatfile is an API-first platform,” said Karande. “It has a great mix of human-in-the loop operation and deeply embedded APIs that make using it easy, flexible, and powerful.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Since implementing Flatfile into its workflow, with the reduction in onboarding time and reduced reliance on engineering resources, BuildOps has seen an average 20%-25% decrease in per-project person hours, estimating that Flatfile is saving 60-90 person hours per month across the team.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“It’s one of the more important tools in our implementation toolbox,” said Patterson. “Without tools like Flatfile, scaling would be almost impossible.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' has helped hundreds of companies tackle their data onboarding challenges, supporting just about any business or data requirement. Reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2BmO9S0V58DxNlkzwEiXgt',
    postTitle: '2023 wrapped: A year of remarkable growth and innovation',
    seoTitle: '2023 wrapped: A year of remarkable growth and innovation',
    seoUrlSlug: '2023-wrapped-a-year-of-remarkable-growth-and-innovation',
    seoMetaDescription:
      '2023 was a landmark year! We hit important milestones, launched new features and saw our community grow. Here are just some of the highlights, and we have more in store for 2024.',
    category: 'Product updates & features',
    tags: [
      'Developers',
      'Developer community',
      'Data exchange',
      'Features',
      'Releases',
      '2023',
      'Featured'
    ],
    sortOrder: '4',
    publishDate: '2024-01-31T08:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1uTSHYs7Iwkh17qFfuarS1',
        type: 'Asset',
        createdAt: '2024-01-30T19:25:36.414Z',
        updatedAt: '2024-01-30T19:25:36.414Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '2023 Wrapped: blog post featured image',
        description: '"2023 in review" in Flatfile colors',
        file: {
          url: '/img/contentful/1uTSHYs7-2023.webp',
          details: {
            size: 18208,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '2023.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: '"2023 in review" in black, white and purple',
    summary:
      '2023 was a landmark year at Flatfile! We hit important milestones, launched new features and saw our community grow. Here are just some of last year’s highlights, and we have much more in store for 2024.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "As we embrace the new year, it's the perfect time to reflect on the incredible journey we had in 2023. This was a year where we hit important milestones, launched new features and saw our community grow, and now we're well-positioned to make 2024 our best year yet.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A new chapter',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '2023 was a landmark year for us! We ended 2022 with a $52 million Series B investment, fueling our ambition to redefine data file exchange. This financial milestone paved the way for 2023’s exciting launch of Flatfile as a platform with a powerful set of APIs, open-source plugins, and event streams that allow developers to use the building blocks of Flatfile to solve nearly any data exchange problem. We also ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/flatfile-acquires-ai-start-up-chatcsv/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'acquired ChatCSV',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' (this AI-powered app acts as a personal data analyst that allows users to “chat” with their CSV files. Check it out directly at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://chatcsv.co/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'chatcsv.co',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '!), were selected by Forbes as one of the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/flatfile-among-forbes-americas-best-startup-employers-2023/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'top startup employers',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' in the U.S. and were awarded numerous G2 badges, including best support, easiest to use, easiest setup and more.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Developers first',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With the launch of the Flatfile Data Exchange Platform in 2023, we created a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-flatfile-data-exchange-platform/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'developer-first platform',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that empowers organizations to build the ideal data exchange solution tailored to their unique needs. You have complete control of each step of the user experience, workflow, and data logic without the challenges of building it yourself from scratch.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We made a few basic but very important decisions that are the foundation for this strategy, including:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'API-first:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Ensures seamless integration into any existing application or system and adaptability to meet future needs or changes.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Event-driven architecture:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Provides complete control at every step of the data flow and user journey while also offering easier testing, monitoring and debugging.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Yes, code:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Offers the ultimate flexibility to collect, clean, validate, and convert data. Every process is driven by reusable code – roll your own or use community plugins.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A new developer experience',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '457AFNdQ0V9x9qjRRSg3Wk',
                type: 'Asset',
                createdAt: '2024-01-31T16:24:22.598Z',
                updatedAt: '2024-01-31T16:24:22.598Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal Start Video',
                description: '',
                file: {
                  url: '/assets/contentful/457AFNdQ-portal-start.gif',
                  details: {
                    size: 21247566,
                    image: {
                      width: 1172,
                      height: 720
                    }
                  },
                  fileName: 'portal-start.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "We're always focused on customer and user feedback, using what we’ve learned from you to add new features and enhance Flatfile's capabilities. Recognizing the huge range of data import, collection, exchange, and onboarding requirements our users have, we've been concentrating our most recent efforts on making different use cases much easier and faster to implement.  Read all about the ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/new-dashboard/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'new developer experience in this recent post',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Powerful data exchange features galore',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3MOMrX23h7G8x1SeWfM5C',
                type: 'Asset',
                createdAt: '2024-01-31T16:17:48.952Z',
                updatedAt: '2024-01-31T16:17:48.952Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Features Vide',
                description: '',
                file: {
                  url: '/img/contentful/3MOMrX23-features.gif',
                  details: {
                    size: 13170842,
                    image: {
                      width: 1172,
                      height: 720
                    }
                  },
                  fileName: 'features.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Since the initial platform launch six months ago, we've continually introduced new features. Here are some of the standout highlights:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'A better data experience for your end users:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Enable value-based filtering, pin columns in the view or hide them, effortlessly resolve errors with a robust find and replace function, and streamline data search and filtering in Sheets using our UI-based filter or FFQL (Flatfile Query Language), a user-friendly, composable query language. This makes working with the Flatfile Platform smoother than ever.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Enterprise features:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' From user roles to permissions to data retention policy configuration, we have added powerful management options for our enterprise plan customers.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Customization:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' From localization, i.e., language support for 18 languages, standalone web pages (via Documents) and advanced theming, you can make your Flatfile-powered data exchange look and feel exactly the way you need it to.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Dynamic everything:',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Configure your schema and update it anytime as things change. For example, you can use data from a precise moment in time from an external API to determine the appearance of your Workbook.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Orchestration for customizable data workflows',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "We've also introduced ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/orchestration/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'orchestration',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', which harnesses our Actions and Jobs frameworks to enable the seamless creation of customized workflows tailored to your unique use cases. Orchestration not only grants you visibility into the status and progression of asynchronous and long-running jobs but also equips you to effectively manage and troubleshoot the data processing pipeline. As a result, you can create data exchange workflows that offer your end users real-time UI-based updates on progress and outcomes.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'SDKs for Node.js, GO, Java and Python',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Ip648mJReMZE396N9604q',
                type: 'Asset',
                createdAt: '2024-01-31T15:35:59.190Z',
                updatedAt: '2024-01-31T15:35:59.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'API SDK Usage Video',
                description: '',
                file: {
                  url: '/img/contentful/5Ip648mJ-api-sdk.gif',
                  details: {
                    size: 13042976,
                    image: {
                      width: 944,
                      height: 720
                    }
                  },
                  fileName: 'api-sdk.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Our new Node.js library (',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '@flatfile/api',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ") marked a significant upgrade. It's crafted to feel natural to developers, mirroring the code you'd write yourself. Experience the difference of our resource-based approach and advanced features like native support for union types. We also expanded our API SDKs into GO, Java, and Python, ensuring Flatfile integrates seamlessly into your preferred tech stack.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'There is also now ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '@flatfile/listener',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. This core library empowers you to dynamically build your workflow, adapting to events as they happen.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Plugins for ultimate extensibility',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'vzCYzxJacSOiyi836Hunt',
                type: 'Asset',
                createdAt: '2024-01-31T15:24:40.112Z',
                updatedAt: '2024-01-31T15:24:40.112Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Plugins Video',
                description: '',
                file: {
                  url: '/img/contentful/vzCYzxJa-plugins.gif',
                  details: {
                    size: 12276842,
                    image: {
                      width: 1168,
                      height: 720
                    }
                  },
                  fileName: 'Plugins.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '2023 was also the year for platform extensibility. We added 18 new plugins in 2023, and here are just a few examples:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Extractor plugins let you embrace versatility by handling almost any file type. From XLSX to XML, PDF, JSON and even custom delimiters, our extractor plugins efficiently extract structured data, saving you time without sacrificing the ability to inform how extraction should take place. If you don’t see one that’s just right for you, you can make your own!',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Schema plugins automatically convert your schema to the Flatfile Blueprint, a powerful DDL (Data Definition Language) with a focus on validation and data preparation. Schema plugins currently support JSON schema, YAML schema, SQL DDL, and OpenAPI.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Additional plugins, including dedupe, finds duplicate records in a sheet on command while automapping listens for and responds to file extraction jobs and then creates a mapping job automatically.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Some of our favorite moments of 2023 involved seeing what people in our Slack and open-source communities were building. We love that people are contributing and helping each other and are excited to see some of you build your own plugins! If you're interested in getting involved, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/FlatFilers/flatfile-plugins'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'check out our library of open-source plugins',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', and feel free to build your own to help Flatfile fit your specific use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Self-service guides and API references',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5GwLcJsL1JidkbC4mxwAnk',
                type: 'Asset',
                createdAt: '2024-01-31T15:10:59.157Z',
                updatedAt: '2024-01-31T15:10:59.157Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'API Reference Video',
                description: '',
                file: {
                  url: '/img/contentful/5GwLcJsL-api-reference.gif',
                  details: {
                    size: 8617750,
                    image: {
                      width: 1168,
                      height: 720
                    }
                  },
                  fileName: 'api-reference.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One important building block behind the developer-first principle is that our developer users need to be self-sufficient. From the self-service sign-up to unlimited free development environment usage to complete and open documentation. We continued to create hundreds of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/overview'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'new docs pages',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that will help guide you smoothly through all of our features. Our revamped ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://reference.flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'API reference',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " now offers a clearer, more detailed guide to our API. We also added a groundbreaking addition, ChatGPT-powered search, to our docs, which provides instant, intelligent support. Watching the weekly npm installs of the Flatfile CLI grow from 1,000 to over 5,000 has been a testament to developers' trust and reliance on our tools.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A lively and engaged Flatfile community',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3Lc742ZU7jzR8845xKUhY0',
                type: 'Asset',
                createdAt: '2024-01-31T15:20:00.291Z',
                updatedAt: '2024-01-31T15:20:00.291Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Changelog Video',
                description: '',
                file: {
                  url: '/img/contentful/3Lc742ZU-changelog.gif',
                  details: {
                    size: 7094926,
                    image: {
                      width: 1168,
                      height: 720
                    }
                  },
                  fileName: 'changelog.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'We’re also happy to say that our ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://join.slack.com/t/flatfile-developers/shared_invite/zt-1zlexssv9-z5XT3MIPh09uuJBz5nBblQ'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Slack community',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", launched late in 2023, has been growing tremendously. Slack is where developers can engage with our team, request features, seek advice, and even get code reviews. If you haven't joined yet, now's the perfect time!",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "If you're curious about what's in store for 2024, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://join.slack.com/t/flatfile-developers/shared_invite/zt-1zlexssv9-z5XT3MIPh09uuJBz5nBblQ'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'join our Slack community',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' and keep an eye on our ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'blog',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' and our ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://flatfile.com/docs/changelog'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'changelog',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " for the latest updates. It's going to be an exciting year, so stay tuned!",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Your support and feedback have been pivotal in shaping Flatfile into what it is today, and we wouldn't be where we are without you. Thank you so much for being part of this incredible journey, and here's to a fantastic 2024 filled with more innovation, growth, and community engagement!",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '5qy54WcCNhh49V1yKgrGe0',
    postTitle: '3 most common workarounds for data import challenges',
    seoTitle: '3 most common workarounds for data import challenges',
    seoUrlSlug: '3-most-common-workarounds-for-data-import-challenges',
    seoMetaDescription:
      "If you’ve fought with data files that won’t cooperate or spent hours manually cleaning data, you're not alone. Here are the most common workarounds for data file import challenges.",
    category: 'Data exchange',
    tags: ['Data exchange', 'Data import', 'Data integration', 'Workarounds'],
    sortOrder: '10',
    publishDate: '2024-01-30T10:02-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1P2uLwSx0NJ4qLrMDrUX3V',
        type: 'Asset',
        createdAt: '2024-01-30T17:39:49.923Z',
        updatedAt: '2024-01-30T17:39:49.923Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 15,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '3 most common workarounds for data import challenges',
        description:
          '"3 common data import workarounds" on a white background with a graphic that represents workarounds',
        file: {
          url: '/img/contentful/1P2uLwSx-blog_post_-_dg3_-_3_common_data_import_workarounds.webp',
          details: {
            size: 60917,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - DG3 - 3 common data import workarounds.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"3 common data import workarounds" on a white background with a triangular graphic that represents workaroundss',
    summary:
      "If you’ve ever grappled with CSV files that refuse to cooperate, struggled with incompatible data formats, or spent hours manually cleaning up data, you're not alone. Here are the most common workarounds businesses use to solve data file import challenges.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2UnR0eowiVAdHFWpoI1Svz',
        type: 'Entry',
        createdAt: '2021-10-07T04:49:05.728Z',
        updatedAt: '2021-10-07T04:49:05.728Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sam Sorbo',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3hX1lP432oQ8xDVXROixMX',
            type: 'Asset',
            createdAt: '2021-10-07T04:48:49.337Z',
            updatedAt: '2021-10-07T04:48:49.337Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'T0AP8UR47-U0297QNFVL2-7fa1dbab798f-512',
            description: '',
            file: {
              url: '/img/contentful/3hX1lP43-t0ap8ur47-u0297qnfvl2-7fa1dbab798f-512.webp',
              details: {
                size: 47476,
                image: {
                  width: 409,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U0297QNFVL2-7fa1dbab798f-512',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data might be the power that fuels decision-making, analytics, and growth, but working with your data can be a nightmare. Just importing the data files you need can be a brutal task. I’ve spoken with a lot of companies about the challenges that they’re facing, and I’ve seen firsthand how many businesses struggle with issues like formats, sizes, and other complexities when dealing with data imports.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Trying to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'successfully import data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " into your systems can be painfully frustrating, but just because importing data files is hard doesn't mean companies aren't importing data. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Businesses constantly import data with the help of workarounds. Unfortunately, what I keep hearing is that those workarounds often cause data quality issues and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'come at a high cost',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. Personnel and manual work costs, supporting engineering resources and long-term maintenance are just the tip of the iceberg. The opportunity cost of lost and delayed revenue can be millions of dollars.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you’ve ever grappled with CSV files that refuse to cooperate, struggled with incompatible data formats, or spent countless hours manually cleaning up data, you're not alone. Here are the most common workarounds that businesses use to solve their ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data file import challenges',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ':',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'What workarounds do businesses use to solve data import challenges?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/#payingForServices'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Paying for services',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/#restrictiveEnduserTemplatesAndRules'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Restrictive end-user templates and rules',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/#customBuilds'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Custom builds',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Read on to discover why these solutions aren’t right for the long term and how you can avoid the problems inherent in complicated workarounds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2UgbNMPOFF2r5s1Zl3aalF',
                type: 'Asset',
                createdAt: '2024-01-30T17:35:29.144Z',
                updatedAt: '2024-01-30T17:35:29.144Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title:
                  'Common workarounds for data import challenges and their costs',
                description:
                  'A black and white table that displays common workarounds for data import challenges and their costs',
                file: {
                  url: '/img/contentful/2UgbNMPO-costs-of-workarounds.webp',
                  details: {
                    size: 96416,
                    image: {
                      width: 1097,
                      height: 1032
                    }
                  },
                  fileName: 'costs-of-workarounds.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Paying for services',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Some businesses deploy teams of employees or contractors to perform ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data validation',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " and cleaning so that necessary data can be imported. This is a time-consuming and error-prone process, but it's often the easiest solution, at least at first. This approach comes with large, ongoing personnel costs, and it has a direct impact on the company's bottom line. It can also lead to major time delays in data availability, delaying important decisions and revenue opportunities.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Restrictive end-user templates and rules',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One way to minimize manual work for your company is to require that your end-users (your customers, prospects and partners) do the work to make sure data always arrives in perfect condition. Companies ask users to adhere to one very specific spreadsheet format, and even the slightest deviation from that format results in the rejection of the data file import attempt. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Unfortunately, after the second or third attempt, users often give up and move on. The impact of this process on customer satisfaction, conversion rates and missed top-line revenue is one of the most overlooked issues in data integration.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Custom builds',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Given the issues above, there are a lot of companies that end up building their own solution to import CSV files, filter data, flag anomalies, and correct information. At first glance, this might seem like a practical choice that gives you the most control over the finished product and frees up data management resources. Unfortunately, custom solutions introduce their own set of difficulties. In fact, if you're dealing with non-trivial needs, building your own solution ties up limited and expensive software engineering resources and usually costs more in the long run. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Building a new feature or functionality means that you’re committing to supporting and maintaining it over time. It typically becomes the responsibility of the team that created it and this ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/sweat-based-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ongoing maintenance',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is almost guaranteed to be a distraction from your core business function. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data import workarounds vs. data exchange solutions',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Even though businesses sometimes rely on workarounds to address data import problems, depending on makeshift solutions can wind up being time-consuming, error-prone, and unsustainable. Whether you're dealing with incompatible file formats, data inconsistencies, or the need for manual data transformation, these workarounds can lead to frustration and slow down or even stop productivity.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How can a data exchange solution solve data import challenges? ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A modern ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' will streamline, accelerate and secure your data import processes, improving your business and delivering rapid and sustained ROI.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The right solution will:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce data errors',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate timely decision-making',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reduce in-house development time and cost',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Increase data usability',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Accelerate time to value',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Improve security and compliance ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'By leveraging the right solution, you can avoid the costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining complicated workarounds.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Making sure you have accurate and timely data is a requirement for success, and investing in a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " can help you stay competitive. If you're looking to overcome data import challenges and improve your data implementation projects, avoid wasting time on workarounds and find the solution that's right for you! ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' has helped hundreds of companies tackle their data file exchange challenges, supporting just about any business or data requirement. Find out how the Flatfile Data Exchange Platform can address your specific ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding use case and requirements',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '6dVx8oJjfpZQ94QqwJVcRN',
    postTitle: 'Top 6 data file import challenges that companies face',
    seoTitle: 'Top 6 data file import challenges that companies face',
    seoUrlSlug: 'top-6-data-file-import-challenges-that-companies-face',
    seoMetaDescription:
      'Even data file imports that seem straightforward can challenge seasoned professionals. Conquering these common data import challenges will give you data your business can trust.',
    category: 'Data exchange',
    tags: ['data exchange', 'data import', 'data integration', 'Popular'],
    sortOrder: '7',
    publishDate: '2024-01-24T08:35-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4nH0lRZ3JAGFZp4jwZOVhn',
        type: 'Asset',
        createdAt: '2024-01-23T17:43:37.822Z',
        updatedAt: '2024-01-23T17:43:37.822Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Top 6 data file import challenges',
        description:
          '"Top 6 data file import challenges" written on a white background with six data-related icons',
        file: {
          url: '/img/contentful/4nH0lRZ3-dg2_-_top_6_data_import_challenges.webp',
          details: {
            size: 42588,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'DG2 - Top 6 data import challenges.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Top 6 data file import challenges" written on a white background with six data-related icons',
    summary:
      'Even data file imports that seem straightforward can challenge seasoned professionals. Conquering these common data import challenges will give you data your business can trust.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "The ability to import, manage, and analyze data files efficiently is essential in today's data-driven world. Data import plays an incredibly important role in making sure that businesses can harness the power of their data for making informed decisions, optimizing operations, and driving growth. But even data file import tasks that seem straightforward ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/5-data-onboarding-challenges-developers-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'have challenges',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' that can trip up the most seasoned data professionals.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4ZMmAR7liivbeOu0KuPYih',
                type: 'Asset',
                createdAt: '2024-01-24T04:23:13.644Z',
                updatedAt: '2024-01-24T04:23:13.644Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "What's unique about data import?",
                description:
                  'Description of data import and what makes data imports unique.',
                file: {
                  url: '/img/contentful/4ZMmAR7l-missing-piece-unique-about-data-import-img2.webp',
                  details: {
                    size: 184362,
                    image: {
                      width: 1681,
                      height: 726
                    }
                  },
                  fileName: 'missing-piece-unique-about-data-import-img2.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It may not always be easy, but if you're trying to make sense of your data, understanding and ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'overcoming these challenges',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' is necessary.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'What are the six most common data file import challenges that businesses face today?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/#1ImplementationProjects'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Implementation projects',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/#2FileImportFeatures'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'File import features',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/#3OrchestratingComplexDataWorkflowsAcrossDiverseStakeholders'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'Orchestrating complex data workflows across diverse stakeholders',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/#4PreparingDataForLargeItMigrationProjects'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'Preparing data for large IT migration projects',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/#5FileFeeds'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'File feeds',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [
                        {
                          type: 'underline'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/#6Humanintheloop'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Managing the human-in-the-loop',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. Implementation projects',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "If you have customers using your software applications, loading those apps with data is a necessary first step before the customer will get any value from using your software or service. Any delay or complication in getting their data into your app will affect your user's ROI, decrease customer satisfaction and, in some cases, can be ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/why-your-customers-hate-your-onboarding-experience/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'the cause of customer churn',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Implementation projects like onboarding customers and their data are an important task for businesses everywhere, and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/state-of-data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'successfully navigating the implementation process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' is key to ensuring a great first impression. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. File import features ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you have applications where customers, prospects, employees, partners, or vendors can upload data files via self-service, you’ve probably encountered time delays, errors, and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/why-isnt-my-csv-file-importing/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'complaints from end users',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". Unfortunately, users who can't complete the simple task of importing their data files will almost certainly leave and won't return.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '3. Orchestrating complex data workflows across diverse stakeholders',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Businesses often need to be able to orchestrate complicated data workflows and deliver seamless implementation projects. Orchestrating these workflows can be incredibly challenging with the involvement of multiple teams, systems, and processes. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you need to coordinate, for example, 122 exhibitors, 17 external vendors, and 11 different teams that are working on 37 separate Excel files, that will require an intricate workflow for importing, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'validating',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', editing and approving data with complex transformations to split, combine and merge data easily. Making sure that the right people with the right access control manage the right data at the right time is critical.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Preparing data for large IT migration projects ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Preparing data for large IT migration projects can be a complicated task. Data onboarding projects that support data migration from legacy systems to a new business system require extensive data review between business stakeholders and experts. Data from old systems needs to be prepared for import into a new system, which often involves emailing Excel files back and forth over long periods for review and data cleanup. This process nearly always introduces data errors, versioning issues, time delays and frustration.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. File feeds',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Most businesses need to collect data from partners, agents, or remote employees or aggregate data from remote departments or divisions. These files might be emailed, dropped into a shared folder in Dropbox or Sharepoint, or sent via FTP. Some of them might be ready for a seamless import into a system or database, but more often, they require resources to be dedicated to a mapping, formatting, cleaning and review process before they can be combined with other data. The volume and complexity of available data constantly grow, turning data collection, import and processing into clunky and error-prone tasks. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '6. Human-in-the-loop',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "One unique characteristic of data imports is that they frequently require manual review with exception handling and approvals on both the sending and receiving ends. On the sending end, a user who submits a file needs to review what they're submitting. Users can't be expected to have technical skills or read lengthy instructions. They need to be able to upload a file, look through it, fill in any blanks, make simple mapping decisions, and move on. The receiving side may need to review exceptions, review data in a consolidated form or even send back requests to users to fix or update certain parts of data.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The human-in-the-loop component in the data integration process can pose significant challenges, and it requires an entirely new approach to managing data exchange. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'TGcP9VW5Z5pTWuQKkLys2',
                type: 'Asset',
                createdAt: '2024-01-23T18:51:21.329Z',
                updatedAt: '2024-01-24T04:25:21.414Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Infographic: Top 6 data file import challenges',
                description:
                  'This infographic explains the top six data file import challenges that companies face.',
                file: {
                  url: '/img/contentful/TGcP9VW5-dg2_-_top_6_-_final.webp',
                  details: {
                    size: 84889,
                    image: {
                      width: 679,
                      height: 1204
                    }
                  },
                  fileName: 'DG2 - Top 6 - final.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The solution: Data file exchange designed from the ground up',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you keep running into these common data file import issues, your organization is most likely using cumbersome workarounds and incomplete solutions. As a result, you are ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'incurring significant costs',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', missed opportunities and compliance issues, and these issues are distracting you and your team from focusing on what matters. You can address these challenges with a dedicated ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data file exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " solution designed from the ground up to safely and efficiently manage the data collection, import, onboarding and exchange of all such diverse data files. Data file exchange can work as a stand-alone solution, and it's also an ideal partner for traditional integration systems such as ETL tools. By leveraging the right solution, you can avoid the costs of missed opportunities, delayed revenue and the time and resources involved in creating and maintaining workarounds and homegrown tools.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data imports are about more than just moving information from one place to another. They're about unlocking the potential of your data. Safe, simple and efficient data import processes are the foundation for having timely and accurate data across your entire organization. By conquering these common data import challenges, you'll have data your business can run on and trust, be able to make informed, data-driven decisions and seize the opportunities you might otherwise miss. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' has solved data file import challenges for hundreds of enterprise clients (and plenty of scaleups), supporting just about any business or data requirement. Reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '7mtAwMWMnFNba4oOUvEbzf',
    postTitle:
      "Data file exchange: What it is and why it's essential for businesses today",
    seoTitle:
      "Data file exchange: What it is and why it's essential for businesses today",
    seoUrlSlug:
      'data-file-exchange-what-it-is-why-its-essential-for-businesses-today',
    seoMetaDescription:
      'Importing data files from a wide variety of sources is a challenge, but it’s a necessary process. Data file exchange can help you safely and efficiently import the variable data files you need.',
    category: 'Data exchange',
    tags: ['data exchange', 'data import', 'data onboarding', 'ETL', 'Popular'],
    sortOrder: '5',
    publishDate: '2024-01-17T08:11-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '98kpQi7qGDeErRYfNgsE3',
        type: 'Asset',
        createdAt: '2024-01-12T18:18:46.041Z',
        updatedAt: '2024-01-12T18:18:46.041Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'What is data exchange?',
        description: 'Featured image for "What is data exchange?" blog post',
        file: {
          url: '/img/contentful/98kpQi7q-what-is-data-exchange-final.webp',
          details: {
            size: 52895,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'what-is-data-exchange-final.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"What is data exchange?" on a white background with rectangles, lines and arrows designed to look like files going into an unknown solution',
    summary:
      'Getting data files from numerous sources into your system can be a constant and painful challenge, but they contain crucial data that can drive the health and success of your business. Data file exchange is the solution that can help any company safely and efficiently import all the highly variable data files it needs.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data files are everywhere. They seem invisible most of the time, but you’ll find them inside your business with employees, teams and departments, and outside with customers, prospects, partners, suppliers, and service providers. Unfortunately, when you need to import them into your system, they’re probably not ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'perfectly structured, organized and ready to use',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Getting all of those different data files and file types into your system can be a constant and painful challenge, but they contain key information that can drive the health and success of your business. By now, you've discovered that traditional tools aren't an efficient solution for your needs, and you're probably spending ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'time and resources',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'complicated workarounds',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data file exchange',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' (sometimes referred to as “data exchange,” "data import," "data collection," or "data onboarding") is the solution that can help any company safely and efficiently import all the highly variable data files it needs. Even if your files come from tons of different sources in a wide variety of formats and need manual ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/ultimate-introduction-data-mapping/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data mapping',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', review, cleanup and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'validation',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' before you can import them, a data exchange solution will help you ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/category/data-exchange/9-ways-data-file-exchange-solution-can-speed-up-csv-excel-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'deal efficiently with all of the real-world data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' that you have.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3fh4NoTz4Ft3mlsfZNtgIb',
                type: 'Asset',
                createdAt: '2024-01-12T18:42:06.260Z',
                updatedAt: '2024-01-12T18:42:06.260Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 10,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Data file exchange, data management, ETL graphic',
                description:
                  'Data file exchange, data management, ETL concept graphic',
                file: {
                  url: '/img/contentful/3fh4NoTz-missing-piece-data-file-exchange-img1.webp',
                  details: {
                    size: 199671,
                    image: {
                      width: 1804,
                      height: 1021
                    }
                  },
                  fileName: 'missing-piece-data-file-exchange-img1.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How is data exchange different from solutions like ETL?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Even though you need to collect and import data from your customers, suppliers, partners, agents, and any number of other sources, you probably haven't found the right way to simplify that process. Data integration and management tools may have been around for decades, but they don't always make life easy…",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/like-chocolate-peanut-butter-when-to-use-etl-data-file-exchange-or-both/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Traditional ETL',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' (Extract Transform Load) and iPaaS (integration Platform as a Service) solutions are great for connecting highly structured systems and databases. You can use an ETL solution to do things like synchronize master customer data between a CRM system and an accounting system. You could use a data management tool to ensure and enforce data retention policies across an extensive corporate database of employee data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'But do they actually simplify ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'your',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' data imports?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "These systems are built on the idea that data is only ever safely and securely transferred between tightly managed IT systems. They ignore today's ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data import and onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' reality: Data is messy! Your data files almost certainly require complicated data mapping, review, cleanup and validation and may even need human oversight before they can be imported into managed databases and business systems.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is data exchange?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data exchange is the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/csv-import-tool-or-data-file-exchange-solution-how-to-pick-the-right-one-for/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'safe, fast, and efficient upload of data files',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' that are:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Highly variable in structure and quality and frequently vary from file to file',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Often external to professionally managed IT systems',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Saved in a wide variety of formats, like ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/what-is-a-csv-file-guide-to-uses-and-benefits/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'CSV',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ', ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://flatfile.com/blog/the-top-excel-import-errors-and-how-to-fix-them/'
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'XLS',
                          marks: [
                            {
                              type: 'underline'
                            }
                          ],
                          data: {}
                        }
                      ]
                    },
                    {
                      nodeType: 'text',
                      value: ', PDF, etc.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Received from multiple sources, like end users, partners, customers, agents and suppliers',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data exchange is the solution that lets businesses safely and efficiently import a range of data file types from thousands or even millions of different sources. It can work on its own, and it's also incredibly helpful when you pair it with traditional integration tools. If your business has a traditional tool in place, pairing it with a data exchange solution can improve every step of your data integration process, particularly if you’re dealing with multiple file types and data files from external sources.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are a few real-life examples of data exchange solutions in action:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Healthcare providers can safely import and quickly analyze prescription data from independent medical facilities. By analyzing this data more quickly, they can identify trends in patient outcomes, rapidly optimize treatment plans, and improve diagnosis and patient care.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'E-commerce marketplaces use these easy-to-use solutions to import, clean and validate data from a wide variety of sources and file formats. By improving the import time and cleanliness of data, they can quickly get new vendors and products up and running.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Manufacturing companies can collect and consolidate supply chain data from a wide network of vendors. By analyzing this data, they can quickly identify bottlenecks, optimize production schedules and reduce costs.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'AI-powered data exchange',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Using the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/how-ai-supercharges-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'power of AI in the data exchange process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' can open up levels of automation, data quality and speed that were previously unattainable. A good data file exchange solution will use technology like AI to provide the speed, efficiency and quality that can help you quickly make important decisions. AI-powered data exchange solutions can also help less technical users import data files successfully.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The right data exchange solution will: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Streamline complicated data import processes ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Simplify elaborate data workflows ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Allow you to truly collaborate on data across team',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Data file exchange isn't just a convenience; it's a strategic necessity. It helps organizations quickly share information, make informed decisions, and adapt to market conditions. With the right solution, businesses report a 50% improvement in onboarding time and processes that used to take months can be completed in weeks or even days.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", the pioneer of AI-assisted data exchange, provides companies and their software development teams with the easiest, fastest, and safest way to build the ideal data file import experience for their users. If you aren't sure what the right solution is for your business, ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/contact-us/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'contact Flatfile today',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ". We've worked with hundreds of customers to solve their data exchange challenges, and we can help you build the solution that's right for you.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '6v0A6xBKB28dfWYowLcRb0',
    postTitle:
      'This missing piece in your data integration stack is costing you millions',
    seoTitle:
      'This missing piece in your data integration stack is costing you millions',
    seoUrlSlug:
      'this-missing-piece-in-your-data-integration-stack-costing-you-millions',
    seoMetaDescription:
      "Companies spend millions of dollars on workarounds to cope with complex data imports. This in-depth guide explains what's missing from your data stack and how to add that missing piece.",
    category: 'Data exchange',
    tags: [
      'data',
      'data exchange',
      'missing piece',
      'data import',
      'data management',
      'ETL',
      'Popular'
    ],
    sortOrder: '2',
    publishDate: '2024-01-10T08:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3oJdXXDYZRVgPfWrW9QBqj',
        type: 'Asset',
        createdAt: '2024-01-09T20:05:19.492Z',
        updatedAt: '2024-01-09T20:05:19.492Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 15,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data exchange: The missing piece that could save you millions',
        description:
          '"Data exchange: The missing piece that could save you millions" written on a white background with purple tiles, one missing piece represented by a dotted line.',
        file: {
          url: '/img/contentful/3oJdXXDY-data-exchange-missing-piece-post.webp',
          details: {
            size: 51566,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Data-exchange-missing-piece-post.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Data exchange: The missing piece that could save you millions" written on a white background with purple tiles and with one piece missing',
    summary:
      'Even the best workarounds for data import challenges come at a high cost. There’s no shortage of data import and onboarding tools for businesses with highly structured data and IT departments, but what should everyone else do? This in-depth report explains.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4e8VT08UTBNDVEEXyXmBEX',
        type: 'Entry',
        createdAt: '2023-04-03T18:49:21.580Z',
        updatedAt: '2024-02-09T18:50:21.687Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Gottfried Sehringer',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5KaxrJpuaiQ0f8hiCzQYVm',
            type: 'Asset',
            createdAt: '2023-04-03T18:48:38.608Z',
            updatedAt: '2023-04-03T18:48:38.608Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Gottfried Sehringer picture',
            description: '',
            file: {
              url: '/img/contentful/5KaxrJpu-1641306098983.webp',
              details: {
                size: 30320,
                image: {
                  width: 400,
                  height: 400
                }
              },
              fileName: '1641306098983.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Chief Marketing Officer'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Collecting and importing data files from customers, suppliers, partners, agents or other external sources is a necessary business process. It's also a process that many organizations struggle with. Some companies spend millions of dollars on manual workarounds and expensive development projects to cope with these challenges. Others live with the extra cost, security risk and negative revenue impact of poor data quality and availability.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "But there's a better way…",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Integration should be simple: ETL tools have been around for decades',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "There are, of course, robust ETL (Extract, Transform, Load) solutions available today, but they all rely on highly structured data and well-managed IT systems. They get tripped up as soon as companies need to receive and import data files that aren't well organized, like files that come from countless sources like end users, partners, suppliers, or customers and arrive in a range of file formats like ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'CSV',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', XLS, PDF, or JSON.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "These traditional systems ignore a piece of the puzzle that's become exponentially more important as our connected world has exploded with decentralized business IT and users worldwide across all types of devices.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The cost of the missing piece',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Just because importing data files is an overlooked component of most data integration stacks doesn't mean companies aren't importing data.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Businesses import data constantly with the help of countless workarounds. Unfortunately, these workarounds introduce data quality issues and come at a high cost. The direct costs of personnel and manual work, supporting engineering resources and long-term maintenance are just the tip of the iceberg. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Any delay or complication in collecting, importing and onboarding data not only affects data quality and data cleaning costs but is also often the source of considerable user frustration.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Worse, these workarounds can lead to security and compliance issues and delay or prevent critical decision-making. The opportunity cost of lost and delayed revenue seriously increases the impact of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/sweat-based-data-file-imports/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data import challenges',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Considering all this, the lack of a solid data exchange solution can quickly add up to millions of dollars.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How to add the missing piece',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "How can businesses safely and efficiently collect, clean and import data that traditional tools can't easily handle?",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies need a solution that will help them import data files from many different sources in various file formats that might include end-user interactions and detailed workflows. A solution that can work independently or with traditional integration tools and uses advanced technology like AI to provide the speed, efficiency, and quality businesses need to make decisions accurately and quickly. That solution, generally referred to as "data import," "data collection," "data onboarding," or, more broadly, "',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '," is the missing piece in most enterprise integration architectures.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Fortunately, that solution exists! Download this ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/the-missing-piece-in-enterprise-integration/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'in-depth guide',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how businesses of all sizes can safely and efficiently import a wide range of data file types from thousands or even millions of different sources.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/the-missing-piece-in-enterprise-integration/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Introduction to Data Exchange: The Missing Piece in Enterprise Integration Architectures',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' covers:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How common data file exchange challenges significantly impact businesses today',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Key considerations for adding data file exchange to your integration architecture',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why and how ETL and data exchange complement each other',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How AI can drastically improve data exchange processes (and when to be cautious)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How data exchange can help you maximize revenue opportunities, eliminate expensive workarounds, save resources, reduce data errors, accelerate decision-making and improve security and compliance',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/the-missing-piece-in-enterprise-integration/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Download the guide today',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/the-missing-piece-in-enterprise-integration/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '!',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' has helped hundreds of enterprise clients (and plenty of scaleups) tackle their data migration challenges, supporting just about any business or data requirement. Reach out and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '7woYqPQNFx5uOm1d8QnImU',
    postTitle: 'Flatfile’s new and improved website!',
    seoTitle: 'Flatfile’s new improved website!',
    seoUrlSlug: 'flatfiles-new-improved-website',
    seoMetaDescription:
      'Our website has a new look and feel! Learn more about what we offer, and discover how these changes will make your specific use case much faster and easier to implement.\n',
    category: 'Flatfile news',
    tags: ['website', 'announcement', 'update'],
    publishDate: '2023-12-21T10:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2na9kFJ4Ro174EfmEbxQ70',
        type: 'Asset',
        createdAt: '2023-12-21T16:23:11.992Z',
        updatedAt: '2023-12-21T16:23:11.992Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Flatfile's new website",
        description:
          'The words "Flatfile\'s new and improved website!" with a few black and white images of the website',
        file: {
          url: '/img/contentful/2na9kFJ4-flatfile-s-new-website.webp',
          details: {
            size: 486247,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Flatfile-s-new-website.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'The words "Flatfile\'s new and improved website" on a purple background with black and white images of the website',
    summary:
      "Our website has a new look and feel! Recognizing the wide range of data import, collection, exchange, and onboarding requirements our users have, we've been focusing on making different use cases much faster and easier to implement.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "You may have noticed that our website has a new look and feel! We've been hard at work making sure our website tells the complete story of the Flatfile Platform and everything it offers. Recognizing the wide range of data import, collection, exchange, and onboarding requirements our users have, we've been focusing on making different use cases much faster and easier to implement.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'What’s new',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1j4Py50JrJDfiKLAdJQXlx',
                type: 'Asset',
                createdAt: '2023-12-21T16:17:57.057Z',
                updatedAt: '2023-12-21T16:17:57.057Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile new website ',
                description:
                  'A picture of the new options in the Flatfile website menu',
                file: {
                  url: '/img/contentful/1j4Py50J-flatfile-platform-apps.webp',
                  details: {
                    size: 238261,
                    image: {
                      width: 2582,
                      height: 1005
                    }
                  },
                  fileName: 'Flatfile-platform-apps.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Platform section on the website showcases improved functionality designed to help you get up and running as quickly as possible, including:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/platform/portal/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          value: 'Portal',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: ' ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: 'will help you quickly build',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: ' ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'an import button that gives your users the ideal data import experience',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/platform/projects/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          value: 'Projects',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' lets you onboard new customers or solve any collaborative need for importing, validating, editing and approving data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/platform/workbooks/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          value: 'Workbooks',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' (coming soon!) is a powerful tool that you can use anywhere you need to edit, validate, transform, or integrate data into your workflow',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/platform/mapping/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          value: 'Mapping',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' (coming soon!) is for people who want to map source-to-target columns outside of the Flatfile Platform and database',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/platform/orchestration/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          value: 'Orchestration',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' lets you control the entire process of importing, validating, cleaning, and approving your data with custom, code-built workflows tailored to your exact needs',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/docs/plugins/overview'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          value: 'Plugins',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' can help you quickly add functionality to your Flatfile data engine',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "The new website also highlights some exciting new features that we're releasing soon, including:",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'AI-powered data manipulation',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'The ability to revert data modifications',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Built-in third-party integrations',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Improved mapping functionality',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We didn’t just update the website, though. We have an entirely refreshed dashboard. You can learn about everything the dashboard offers in this ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/new-dashboard/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'in-depth post',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Questions?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We made these changes to help you quickly see exactly how Flatfile can help you get up and running from your first login. If you have questions or want to learn more, contact the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/contact-sales/consult/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'customer support team',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' for all the answers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6AuxoqFPoyA4XywIgFQrgZ',
    postTitle: 'Introducing a new platform developer experience',
    seoTitle: 'New Flatfile Platform Apps and Dashboard',
    seoUrlSlug: 'new-dashboard',
    seoMetaDescription:
      "Recognizing the wide range of data import, collection, exchange, and onboarding use cases we're launching a new dashboard and platform apps - making it much easier and faster to implement. \n",
    category: 'Product updates & features',
    tags: ['dashboard', 'Featured'],
    publishDate: '2023-12-20T01:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7r3RVXd7cWA4Fwv20mAmRj',
        type: 'Asset',
        createdAt: '2023-12-19T20:15:14.501Z',
        updatedAt: '2023-12-19T20:25:03.105Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'new platform blog image',
        description: '',
        file: {
          url: '/img/contentful/7r3RVXd7-blog-post-new-dashboard-v2.webp',
          details: {
            size: 97841,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog-Post-New-Dashboard-v2.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Announcing Flatfile Platform apps and our new dashboard!',
    summary: 'Announcing Flatfile Platform apps and our new dashboard!\n',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '94TukpVikX5FkBoBayX8e',
        type: 'Entry',
        createdAt: '2023-08-09T19:52:27.239Z',
        updatedAt: '2023-08-09T19:52:27.239Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ophir Prusak',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5Oy3cDYeA7xRSsr6VvCf2W',
            type: 'Asset',
            createdAt: '2023-08-09T19:52:02.083Z',
            updatedAt: '2023-08-09T19:52:02.083Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Ophir Prusak',
            description: '',
            file: {
              url: '/img/contentful/5Oy3cDYe-t0ap8ur47-u052w8wclth-935a0258cf96-512.webp',
              details: {
                size: 27611,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U052W8WCLTH-935a0258cf96-512.jpg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Since the launch of the Flatfile Data Exchange Platform six months ago, our engineering team has dedicated countless hours enhancing its capabilities and adding new features. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Recognizing the wide range of data import, collection, exchange, and onboarding use cases our users have, we've focused our recent efforts on making the different use cases much easier and faster to implement. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Introducing a new developer experience which includes "Platform Apps” and an improved dashboard. This offers a curated experience designed around typical use cases, allowing you to get started quickly and leverage the platform in the way that best suits your needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'New Dashboard',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5sadLOTmdZulXRF6xuN8zS',
                type: 'Asset',
                createdAt: '2023-12-18T21:11:19.683Z',
                updatedAt: '2023-12-20T21:02:39.800Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'new dashboard screenshot',
                description: '',
                file: {
                  url: '/img/contentful/5sadLOTm-new_dash_pika.webp',
                  details: {
                    size: 727475,
                    image: {
                      width: 3232,
                      height: 1796
                    }
                  },
                  fileName: 'new_dash_pika.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the updated dashboard, you\'ll find a new "Platform Apps" section, which includes ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Portal',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Projects',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Workbooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Mapping',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ':',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Portal',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/portal/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Portal',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', or as we like to call it, "The Flatfile import button our users know and love” provides a simple and efficient data import option for end users. This lets you give your users the import experience you always dreamed of but never had time to build. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "With Portal, we've made the getting started process a whole lot faster and easier with step-by-step instructions.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6TSVWfWkYPJiMLpUOXcLST',
                type: 'Asset',
                createdAt: '2023-12-19T17:46:17.968Z',
                updatedAt: '2023-12-19T17:46:17.968Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'portal screenshot pika',
                description: '',
                file: {
                  url: '/img/contentful/6TSVWfWk-portal_screenshot-2x.webp',
                  details: {
                    size: 659868,
                    image: {
                      width: 3232,
                      height: 1800
                    }
                  },
                  fileName: 'portal_screenshot-2x.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Projects  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/projects/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Projects',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' lets you collaborate on data your way. ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'When you’re dealing with complex data workflows across diverse stakeholders, Projects lets you onboard new customers or solve any collaborative need for importing, validating, editing and approving data. Granular access control and powerful data transformations ensure the right people manage the right data at the right time.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Everyone has specific data onboarding workflows and needs, so please let us know if you want to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/contact-sales/consult/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'learn more about Projects',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Workbooks (coming soon)',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For when you want to utilize Flatfile’s spreadsheet experience to edit, validate, transform, or integrate data into your workflow, and you don't need to import a CSV or Excel file manually. ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/workbooks/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Workbooks',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is perfect for working with existing data or for manual data entry',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Mapping',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A new dedicated ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/mapping/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Mapping',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " API solution if you need to map schemas in your own systems without sending your data to Flatfile, whether it's in data pipelines, API integrations or data conversion workflows.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'More Dashboard Updates',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With the new dashboard, switching between environments is easier than ever with the dropdown menu at the top of the page.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6RSYji8skgtR8ssnxnXrYy',
                type: 'Asset',
                createdAt: '2023-12-19T17:47:18.995Z',
                updatedAt: '2023-12-19T17:47:18.995Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'envs screenshot',
                description: '',
                file: {
                  url: '/img/contentful/6RSYji8s-envs_screenshot-2x.webp',
                  details: {
                    size: 381691,
                    image: {
                      width: 3232,
                      height: 1540
                    }
                  },
                  fileName: 'envs_screenshot-2x.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Upgrading to the New Dashboard',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "If you're a new Flatfile user, you’ll automatically get the new dashboard when you login.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For existing users, you'll soon see a link in your dashboard that will allow you to check out the new experience and switch between the new and current dashboard.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Questions?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you have questions or want to learn more, contact the support team at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:support@flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'support@flatfile.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' for all the answers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'Tw6JHeSEWCzbSNvv0UyHx',
    postTitle: 'Top 7 open source CSV import libraries',
    seoTitle: 'Top 7 open source CSV import libraries',
    seoUrlSlug: 'top-7-open-source-csv-import-libraries',
    seoMetaDescription:
      'Are you looking to add CSV import functionality to your web-based solution and want to take advantage of open-source options? These are the options you should be checking out.',
    category: 'Data exchange',
    tags: ['csv import', 'csv parsers'],
    sortOrder: '11',
    publishDate: '2023-12-06T01:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6SowpGSCQpVAMiC908lrLo',
        type: 'Asset',
        createdAt: '2023-12-05T20:04:32.402Z',
        updatedAt: '2023-12-05T20:04:32.402Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Blog Post - The Ultimate Guide to Modernizing Your Data Import Solution Image',
        description: '',
        file: {
          url: '/img/contentful/6SowpGSC-blog_post_-_the_ultimate_guide_to_modernizing_your_data_import_solution.webp',
          details: {
            size: 43001,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'Blog Post - The Ultimate Guide to Modernizing Your Data Import Solution.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Top 7 CSV Import Libraries',
    summary:
      'This article outlines steps for integrating CSV or Excel import functionality using open-source tools. It focuses on CSV parsing solutions, with recommendations for best open-source options.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '94TukpVikX5FkBoBayX8e',
        type: 'Entry',
        createdAt: '2023-08-09T19:52:27.239Z',
        updatedAt: '2023-08-09T19:52:27.239Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ophir Prusak',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5Oy3cDYeA7xRSsr6VvCf2W',
            type: 'Asset',
            createdAt: '2023-08-09T19:52:02.083Z',
            updatedAt: '2023-08-09T19:52:02.083Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Ophir Prusak',
            description: '',
            file: {
              url: '/img/contentful/5Oy3cDYe-t0ap8ur47-u052w8wclth-935a0258cf96-512.webp',
              details: {
                size: 27611,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U052W8WCLTH-935a0258cf96-512.jpg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If you’re looking to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'add CSV import functionality to your web-based solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and want to take advantage of open source options, you’ve come to the right place. I did a deep dive on the topic, spoke to multiple software engineers, went down several rabbit holes, and found myself spending ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'way',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' too many hours researching the topic. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'These are the options you should definitely be looking at based on the number of GitHub stars, forks, overall development status, and looking at public mentions on Reddit and Stack Overflow, as well as a couple of up-and-coming projects worth checking out.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Keep in mind that the overall data file import process involves several steps, determined by how much customization and cleaning the data needs and where it ultimately needs to go. Assuming you’re using a framework like React or Angular, the process will usually look something like this:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV import steps',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Frontend upload interface',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Develop a component for file upload, like a drag-and-drop area or file input field. For example, ',
                              marks: [],
                              data: {}
                            },
                            {
                              nodeType: 'hyperlink',
                              data: {
                                uri: 'https://github.com/react-dropzone/react-dropzone/'
                              },
                              content: [
                                {
                                  nodeType: 'text',
                                  value: 'React Dropzone',
                                  marks: [
                                    {
                                      type: 'underline'
                                    }
                                  ],
                                  data: {}
                                }
                              ]
                            },
                            {
                              nodeType: 'text',
                              value: ' is a very popular option.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Implement client-side validation for CSV format checking.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'CSV parsing',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Client-side parsing: Utilize a library like ',
                              marks: [],
                              data: {}
                            },
                            {
                              nodeType: 'hyperlink',
                              data: {
                                uri: 'https://www.papaparse.com/'
                              },
                              content: [
                                {
                                  nodeType: 'text',
                                  value: 'Papa Parse',
                                  marks: [
                                    {
                                      type: 'underline'
                                    }
                                  ],
                                  data: {}
                                }
                              ]
                            },
                            {
                              nodeType: 'text',
                              value:
                                ' to parse the CSV file into a JavaScript object or array.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Server-side parsing: Alternatively, handle parsing on the backend, which can be more secure and reduces client-side processing.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Column mapping interface ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: '(if required)',
                      marks: [],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Design a UI component for users to map CSV columns to target fields in your system, particularly useful for variable CSV formats.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Allow users to define, modify, and save these mappings.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data mapping and transformation',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Apply user-defined or predefined mappings to the parsed CSV data.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Perform necessary data transformations, including format changes and data sanitization.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data review interface',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Implement a UI component that displays the mapped and transformed data for user review.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Allow users to confirm the accuracy of the data or make adjustments before final processing.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Data transmission',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Send the reviewed and confirmed data or the CSV file to the server.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Server-side processing',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Conduct server-side validation and sanitization for security.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'If not done on the client side, perform the final mapping and transformation of the CSV data.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Database integration ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: '(if you’re pushing the data to a DB)',
                      marks: [],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Design a database schema that accommodates the data.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Develop functionality for inserting the processed data into your database, considering aspects like handling duplicates.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Feedback and error handling',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'ordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Provide clear user feedback for both successful and unsuccessful operations.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Implement comprehensive error handling on both frontend and backend.',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Besides the above, you’ll still need to consider security, testing, and performance optimization, though that’s beyond the scope of this article.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Please note: Some of the projects attempt to be end-to-end solutions which include multiple CSV import steps and some only cover a single step, such as parsing the CSV data.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With that being said, here are the top 7 open source solutions for importing CSV files:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'React-csv-importer (Beamworks)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Papa Parse',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'fast-csv (C2FO)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'csv-parser',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'CSV for Node.js',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'CSV42',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'uDSV',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'React-csv-importer (Beamworks)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/beamworks/react-csv-importer'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/beamworks/react-csv-importer',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '29C2abIk9r7BZzAkEqaNLJ',
                type: 'Asset',
                createdAt: '2023-12-04T21:49:37.325Z',
                updatedAt: '2023-12-04T22:09:31.284Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'react csv importer star history',
                file: {
                  url: '/img/contentful/29C2abIk-star-history-20231129_react-csv-importer.webp',
                  details: {
                    size: 298688,
                    image: {
                      width: 3152,
                      height: 2274
                    }
                  },
                  fileName: 'star-history-20231129_react-csv-importer.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'React-csv-importer is an end-to-end solution from Beamworks, a front-end development team located in Toronto, Canada.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'According to their website, “We build and extend web-based React UIs for enterprises and startups in finance and healthcare.” I must say that providing an open source solution for the common problem of importing data into web applications is a great way to create awareness. This blog post is proof 🙂',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The repo has been around since late 2020, with fairly regular updates, though no updates have been made since May 2023. Under the hood, they rely on several other open source solutions, such as ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.papaparse.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Papa Parse',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for CSV parsing, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/react-dropzone/react-dropzone/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'react-dropzone',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for file uploads, and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/pmndrs/use-gesture'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'use-gesture/react',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for drag-and-drop.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Papa Parse',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/mholt/PapaParse'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/mholt/PapaParse',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2uZhqPmlPwI1sCsQ8qNF78',
                type: 'Asset',
                createdAt: '2023-12-04T22:09:08.949Z',
                updatedAt: '2023-12-04T22:09:08.949Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'papa parse star history',
                file: {
                  url: '/img/contentful/2uZhqPml-star-history-20231129_papaparse.webp',
                  details: {
                    size: 324485,
                    image: {
                      width: 3152,
                      height: 2274
                    }
                  },
                  fileName: 'star-history-20231129_papaparse.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Papa Parse is one of the most (if not THE most) popular open source CSV parsers. With over 11k stars, this repo has been around since 2014, and it’s one of the fastest Javascript-based CSV parsers. If all you need to do is parse a CSV file and have no need to validate, transform or edit the data, you won’t go wrong with Papa Parse. Even Flatfile (the leading paid solution) uses Papa Parse internally ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'fast-csv (C2FO)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/C2FO/fast-csv'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/C2FO/fast-csv',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2nvg8cSxRAZ5BubIVW0paD',
                type: 'Asset',
                createdAt: '2023-12-06T17:17:32.233Z',
                updatedAt: '2023-12-06T17:17:32.233Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'fast csv star history',
                file: {
                  url: '/img/contentful/2nvg8cSx-star-history-20231129_fast-csv.webp',
                  details: {
                    size: 320358,
                    image: {
                      width: 3152,
                      height: 2274
                    }
                  },
                  fileName: 'star-history-20231129_fast-csv.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This CSV parser comes to us as the result of a C2FO (a commercial company) open-sourcing their internal technology. While the repo got off to a slow start, it’s been around for a while, and the star history has been constantly growing in a very organic manner. As the name suggests, it aims to be a fast solution, though based on ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://leanylabs.com/blog/js-csv-parsers-benchmarks/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'csv parser benchmarks',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', it’s actually not as fast as some of the alternatives.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'csv-parser',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/mafintosh/csv-parser'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/mafintosh/csv-parser',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'B0vMK7S2clU3G9yFZM6cJ',
                type: 'Asset',
                createdAt: '2023-12-04T22:10:06.939Z',
                updatedAt: '2023-12-04T22:10:06.939Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'csv parser star history',
                file: {
                  url: '/img/contentful/B0vMK7S2-star-history-20231129_csv-parser.webp',
                  details: {
                    size: 330199,
                    image: {
                      width: 3152,
                      height: 2274
                    }
                  },
                  fileName: 'star-history-20231129_csv-parser.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Another very popular option, csv-parser also aims to be the fastest. While it’s pretty fast, it still trails behind Papa Parse in the benchmark we previously mentioned. Where it does stand out, though, is in size. It’s a mere 1.5k when zipped!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV for Node.js',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/adaltas/node-csv/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/adaltas/node-csv/',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4HDS9VO34kQMWxyeElxU2f',
                type: 'Asset',
                createdAt: '2023-12-04T22:14:55.609Z',
                updatedAt: '2023-12-04T22:14:55.609Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'node csv star history',
                file: {
                  url: '/img/contentful/4HDS9VO3-star-history-20231129_node-csv.webp',
                  details: {
                    size: 299443,
                    image: {
                      width: 3152,
                      height: 2274
                    }
                  },
                  fileName: 'star-history-20231129_node-csv.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This one is a super popular and comprehensive CSV suite that combines four well-tested packages to generate, parse, transform and stringify CSV data for Node.js and the web. The project has been around for a while and is sponsored by Adaltas, a Big Data consulting firm based in Paris, France.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV42',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/josdejong/csv42'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/josdejong/csv42',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is a  small and fast CSV parser with support for nested JSON. While nowhere as popular as the other projects mentioned above (',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'I’m not including the number of stars on purpose)',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ', I was pleasantly surprised when I came across this little gem. In the words of the author: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“One limitation that most of the CSV libraries for JavaScript out there have in common is no built-in support for nested JSON objects. To me this is an essential feature since nested data structures are just so common in JavaScript. You can solve it with a pre- and post-processing step to flatten your data, but that feels like something a CSV library can do for you.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Surprisingly, it’s also ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/josdejong/csv42/tree/main/benchmark'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'quite fast compared',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to mainstream alternatives such as Papa Parse or fast-csv.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'uDSV',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/leeoniya/uDSV/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://github.com/leeoniya/uDSV/',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1UCgu4aEHbSuARsx61WmCx',
                type: 'Asset',
                createdAt: '2023-12-04T22:15:51.283Z',
                updatedAt: '2023-12-04T22:15:51.283Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'uDSV star history',
                file: {
                  url: '/img/contentful/1UCgu4aE-star-history-2023121-usdv.webp',
                  details: {
                    size: 332327,
                    image: {
                      width: 3152,
                      height: 2274
                    }
                  },
                  fileName: 'star-history-2023121-uSDV.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Wow … ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '\nThis one caught me off guard. While many of the existing csv parsers claim to be very fast, this is the one you want if you have the need for speed, claiming to be faster than all of the well known options. And he has ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/leeoniya/uDSV/tree/main/bench'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'the benchmarks to prove it!',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It very new on the scene, so it's not super popular yet, though with these benchmarks, I can't help but think it will get very popular soon.\n\nAs the author put it:\nuDSV has Ludicrous Speed™; it's faster than the parsers you recognize and faster than those you've never heard of.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Most CSV parsers have one happy/fast path -- the one without quoted values, without value typing, and only when using the default settings & output format. Once you're off that path, you can generally throw any self-promoting benchmarks in the trash. In contrast, uDSV remains fast with any datasets and all options; its happy path is every path.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What’s next?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In a follow up article, I’ll cover some popular grid/table components that you’ll need if you want to allow users to review or edit the data online.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Are paid options worth it?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If all you need is vanilla CSV uploads and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'don’t',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' need any column mapping, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/the-beginners-guide-to-data-validation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'validations',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', transformations, inline review/editing, collaboration, or support for very large files, then open source solutions should be fine. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'On the other hand, paid options provide end-to-end CSV import solutions that are ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'way',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' more powerful and feature rich than the open source alternatives. Depending on your needs and your budget, commercial offerings could be a better choice than going down the OSS route. Many paid options also include a free tier so you can easily try them out yourself.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'And if you want a developer-first solution that combines the best of both worlds; the flexibility of building it yourself together with the enhanced efficiency and time to value of a SaaS solution, then you should definitely consider ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. We’ve solved this specific problem for hundreds of enterprise clients (and plenty of scaleups), supporting just about any business or data requirement, so please feel free to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/demo/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'reach out and ',
                  marks: [],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: 'connect with one of our data experts',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' to find out how Flatfile can help you address your data onboarding use case and requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'NicEIY3hMaz3zTDUdyZMK',
    postTitle: 'The secret to modernizing your data stack',
    seoTitle: 'The Secret to Modernizing Your Data Stack',
    seoUrlSlug: 'secret-to-modernizing-your-data-stack',
    seoMetaDescription:
      'What’s the best way to modernize your data stack and ease your data import pains? This in-depth report explains everything you need to know.',
    category: 'Data exchange',
    tags: [
      'data exchange',
      'whitepaper',
      'modernization',
      'data stack',
      'data import'
    ],
    publishDate: '2023-11-29T08:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'ylDoibAAnfarYCO8CXmvq',
        type: 'Asset',
        createdAt: '2023-11-28T18:14:32.323Z',
        updatedAt: '2023-11-28T18:14:32.323Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Blog Post - The Ultimate Guide to Modernizing Your Data Import Solution (1)',
        description:
          'Image of the whitepaper cover page: From Outdated to Outstanding: The Ultimate Guide to Modernizing Your Data Import Solution',
        file: {
          url: '/img/contentful/ylDoibAA-blog_post_-_the_ultimate_guide_to_modernizing_your_data_import_solution__1_.webp',
          details: {
            size: 50201,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'Blog Post - The Ultimate Guide to Modernizing Your Data Import Solution (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Image of the cover page of "The Ultimate Guide to Modernizing Your Data Import Solution"',
    summary:
      'You’ve probably been frustrated by how hard it can be to import, clean, and correctly format the data you need for your business. What’s the best way to tackle this problem? This in-depth whitepaper explains exactly what you need to know to modernize your data import solution.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1B2gCVn9ZDi1gPwufhVk3d',
        type: 'Entry',
        createdAt: '2023-11-22T18:15:16.497Z',
        updatedAt: '2025-03-11T19:01:03.764Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Anne Bonner',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '49BF1yAWwP3qpiQl0IGkeW',
            type: 'Asset',
            createdAt: '2023-11-22T18:15:04.060Z',
            updatedAt: '2023-11-29T17:33:03.039Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 14,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'Anne',
            description: 'Profile picture of Anne Bonner',
            file: {
              url: '/img/contentful/49BF1yAW-me2023small.webp',
              details: {
                size: 236831,
                image: {
                  width: 576,
                  height: 759
                }
              },
              fileName: 'me2023small.jpeg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Writer',
        department: 'Marketing',
        company: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5FDircUDiIDh70lymrJI6f',
            type: 'Entry',
            createdAt: '2024-05-08T23:34:48.371Z',
            updatedAt: '2025-01-07T20:32:14.605Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 13,
            revision: 2,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'company'
              }
            },
            locale: 'en-US'
          },
          fields: {
            name: 'Flatfile',
            logo: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoBlack: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Pjev3W45f5gEOO1TEczt1',
                type: 'Asset',
                createdAt: '2025-01-07T20:30:04.773Z',
                updatedAt: '2025-01-07T20:30:04.773Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New logo',
                description: '',
                file: {
                  url: '/img/contentful/5Pjev3W4-final_logo.svg',
                  details: {
                    size: 2694,
                    image: {
                      width: 648,
                      height: 150
                    }
                  },
                  fileName: 'Final_logo.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            logoWhite: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5DNClD4reUBKoF7u01OgKF',
                type: 'Asset',
                createdAt: '2022-12-28T18:43:23.263Z',
                updatedAt: '2022-12-28T18:43:23.263Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'flatfile-white',
                file: {
                  url: '/img/contentful/5DNClD4r-flatfile-white.svg',
                  details: {
                    size: 12234,
                    image: {
                      width: 104,
                      height: 24
                    }
                  },
                  fileName: 'flatfile-white.svg',
                  contentType: 'image/svg+xml'
                }
              }
            },
            website: 'https://flatfile.com/'
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Your data is everywhere. And it’s a mess.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You already know that the data you need might be in the hands of your teammates or employees, vendors, customers, agents, and partners, and it could be hanging out in remote offices and on personal devices. There’s a good chance that a lot of it is pretty questionable in terms of quality, structure, and format, and different people might even be working with different versions of the same files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How much time are you spending on this?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’re using an outdated or homegrown tool to deal with the frustrations of getting your data ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'in one place and ready to use',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', it might be time to consider modernizing your data stack. But how do you know what kind of solution will be right for your business?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We developed this ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/the-ultimate-guide-to-modernizing-your-data-import-solution/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'in-depth report',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to help you understand everything you need to know about upgrading your data import solution.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: "Don't let your data go to waste",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’re running any kind of business, you probably need to build complicated workflows and collaborate with various people and teams. If you’re working with data at all, you’ve almost certainly been frustrated by how hard it can be just to get the data you need cleaned, correctly formatted, and ready to use.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We know a lot of businesses hang on to outdated solutions or build their own data import tools, but an outdated or in-house tool is unlikely to be the best long-term solution, especially as your business grows and your needs change. Some companies keep outdated solutions in place because of cost concerns or a lack of resources, but choosing the right data exchange solution at the right time is almost always a better choice in the long run (and this report explains why).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Here at Flatfile, we've worked closely with a ton of development teams to understand exactly what problems businesses are facing and what the ideal data import solution would look like, and we’ve learned a lot about what businesses need and where people run into the biggest problems. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We created ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/the-ultimate-guide-to-modernizing-your-data-import-solution/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value:
                    'The Ultimate Guide to Modernizing Your Data Import Solution',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " to help you figure out precisely what you need to know so that you can confidently make the choice that's right for you.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This whitepaper explains:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The high costs of using outdated and homegrown tools',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The importance of modernizing your data stack at the right time (and how you can tell when it’s the right time!)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Exactly what you need to consider as you’re evaluating your options',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'How to choose the solution that’s right for you',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Download ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/the-ultimate-guide-to-modernizing-your-data-import-solution/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value:
                    'The Ultimate Guide to Modernizing Your Data Import Solution',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " now to learn everything you need to know to successfully modernize your data stack with the data import solution that's right for you.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'XOsTwfEGuV9O7hWifgkp4',
    postTitle: 'Chat with your data: Flatfile acquires AI startup ChatCSV',
    seoTitle: 'Flatfile acquires AI startup ChatCSV',
    seoUrlSlug: 'flatfile-acquires-ai-start-up-chatcsv',
    seoMetaDescription:
      "I'm thrilled to announce that we have recently acquired an AI startup called ChatCSV. Here's a glimpse into why this is so exciting, what it means for our users and how it aligns with our vision.",
    category: 'Flatfile news',
    tags: ['AI', 'data exchange'],
    sortOrder: '4',
    publishDate: '2023-10-17T09:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1vCANXW1I7E1TMigbq68W2',
        type: 'Asset',
        createdAt: '2023-10-16T22:27:59.593Z',
        updatedAt: '2023-10-16T22:27:59.593Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'ChatCSV',
        description: '',
        file: {
          url: '/img/contentful/1vCANXW1-frame_27640__3_.webp',
          details: {
            size: 73985,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 27640 (3).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'I am thrilled to announce that we have acquired an AI start-up called Chatcsv. "Flatfile acquires AI startup ChatCSV" on a dark background with colorful confetti',
    summary:
      "I'm thrilled to announce that we have recently acquired an AI startup called ChatCSV. I want to give you a glimpse into why this move is particularly interesting, what it means for our users and how it aligns with our vision of AI and data exchange as a whole.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Today, I’m excited to announce Flatfile’s recent acquisition of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://chatcsv.co/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'ChatCSV',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and share a glimpse into what this means for our customers and the future of LLMs in data exchange.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From the moment we found ChatCSV, I was impressed by the enthusiastic user feedback, the elegant user experience, and the practical hybrid of chat and data frames — meaningfully exceeding the built-in capabilities of OpenAI while maintaining a much higher degree of data privacy.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In a chat interface, users can simply ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-a-csv-file-guide-to-uses-and-benefits/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'upload a CSV',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and start a conversation with their data, asking specific questions to extract insights, write queries, or display charts.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Given the millions of CSV files Flatfile customers work with each year, I reached out to ChatCSV’s founder, Sam Barrowclough. I was excited about the product, but Sam was even more impressive. His entrepreneurial spirit, thoughtful intuition about the problem space, and pragmatic approach to product theory made it obvious how, in just a few months, he had built an unarguable breakout success. Over the course of several hours, Sam and I connected over our shared and unbridled passion for this problem and his hair-raising pace of thought and action.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In just a few months since its launch, ChatCSV had garnered 5000+ users, ranging from individual operators to large enterprises such as Procter & Gamble and McKinsey and successful startups like Zapier, Quora, and Vimeo.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I shared the roadmap of what our AI team at Flatfile has been developing, from built-in natural language queries to AI data cleaning and the world’s best-trained AI model for schema mapping. I shared my excitement with Flatfile’s board of directors, and it was obvious to all of us that we needed to find a way to work with Sam.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Fast forward to today’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/news/flatfile-acquires-chatcsv'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'announcement',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' - we’ve closed on the acquisition and are thrilled to welcome Sam to our growing AI engineering team, responsible for delivering powerful AI capabilities to some of the most challenging data exchange problems on the planet. If you’re interested in learning more about Flatfile’s beta release of AI Assist, natural language queries, or our upcoming roadmap, reach out to our support team!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Give it a try',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We're excited to welcome all ChatCSV users to the Flatfile family. As a welcome gift, starting today, we’re making ChatCSV entirely free with unlimited usage for all users. If you're interested in what ChatCSV can do for you, feel free to check it out directly at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://chatcsv.co/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'chatcsv.co',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. And, of course, if you’re building data import, exchange, or onboarding solutions for your business, you can begin building on the Flatfile Data Exchange Platform',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/start'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Flatfile, we are committed to making data exchange effortless, and this acquisition is a significant step in that direction. Stay tuned for more updates in the coming weeks, and thank you for being a part of our journey toward a better data future.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'IER3446IzuP2dPiFh6p4T',
    postTitle: ' How to handle the unknown: Dynamic configurations in Flatfile',
    seoTitle: 'Dynamic configurations in Flatfile',
    seoUrlSlug: 'dynamic-configurations-in-flatfile',
    seoMetaDescription:
      'This article explores dynamic configurations in the Flatfile Data Exchange Platform, a powerful feature that allows you to configure a Space, Workbook or Sheet at runtime based on any use case.',
    category: 'Product updates & features',
    tags: [
      'configurations',
      'space',
      'workbook',
      'sheet',
      'dynamic configurations'
    ],
    publishDate: '2023-08-10T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '69924m30binUVmSngBPc2l',
        type: 'Asset',
        createdAt: '2023-08-09T19:53:57.205Z',
        updatedAt: '2023-08-09T19:53:57.205Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Coding Image',
        description: '',
        file: {
          url: '/img/contentful/69924m30-frame_2.webp',
          details: {
            size: 1317948,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 2.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Dynamic configurations concept: Person with headphones coding on a computer at a desk',
    summary:
      'This article explores dynamic configurations in the Flatfile Data Exchange Platform, a powerful feature that allows you to configure a Space, Workbook or Sheet at runtime based on any use case.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '94TukpVikX5FkBoBayX8e',
        type: 'Entry',
        createdAt: '2023-08-09T19:52:27.239Z',
        updatedAt: '2023-08-09T19:52:27.239Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ophir Prusak',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5Oy3cDYeA7xRSsr6VvCf2W',
            type: 'Asset',
            createdAt: '2023-08-09T19:52:02.083Z',
            updatedAt: '2023-08-09T19:52:02.083Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Ophir Prusak',
            description: '',
            file: {
              url: '/img/contentful/5Oy3cDYe-t0ap8ur47-u052w8wclth-935a0258cf96-512.webp',
              details: {
                size: 27611,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U052W8WCLTH-935a0258cf96-512.jpg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flexibility and customization are crucial for any developer working with data ingestion to handle data's diverse and dynamic nature. This article explores ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/guides/dynamic-configurations'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'dynamic configurations',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' in the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile Data Exchange Platform',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', a powerful feature that allows you to configure a Space, Workbook or Sheet at runtime based on any data or use case you want.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Some examples of dynamic configurations include:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "Location-based: You can adjust the type of currency, phone numbers, or address format in the Sheet configuration based on a user's location.",
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'User type: Provide different configurations for different types of users. For example, admins can view and edit all fields, while non-admins have limited access to the data or view-only access for certain fields.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Live data: Call an external API and use the returned data to determine how your Workbook should look. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "I know it's cliche, but the possibilities are indeed endless.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'You can even dynamically update a live ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/concepts/workbooks'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Workbook',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/concepts/spaces'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Space',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/concepts/workbooks#anatomy'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Sheet',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' in place. A common use case is with workflows that involve multiple people who edit and/or approve the data. Once a user finishes with their edits, clicking on a "submit for review" button runs configuration code that changes data from editable to view-only, locking down the Sheet from further changes and notifying the person who needs to review it.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Sheets that update themselves',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One Flatfile customer uses data from one Sheet to configure another Sheet on the fly. An admin user first uploads information about the data that will be ingested by end-users, then uses a custom action that creates a space for end-users based on the data the admin uploaded. This example shows just how flexible Flatfile is in solving data file import challenges, and in some cases, even reduces the dependency on developers.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flexibility is the name of the game',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Let's consider an alternate scenario of not having dynamic configurations in which your data import settings are static and predefined. In some cases, static configurations are the right solution, so this won't be an issue. But in other use cases, like if you need to adapt to changing scenarios or needs at runtime, you'll be stuck. Having to define configurations in a fixed manner leaves no room for modification without changing the code.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "However, dynamic configurations change the game entirely. This allows you to be responsive to the needs of a user or a situation. For instance, if a user's location requires a different kind of currency in your Sheet, you can adjust the configurations dynamically to accommodate this not only when you initially set up your data import but even when certain events are triggered or data changes. Dynamic configurations allow you to adjust at runtime as well.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Consider the following JavaScript example demonstrating how dynamic configurations work in response to data updates:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7x09ZijbHzte3iBV0cFIdO',
                type: 'Entry',
                createdAt: '2023-08-08T22:15:59.397Z',
                updatedAt: '2023-08-08T22:15:59.397Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Blog Post Code',
                language: 'javascript',
                code: '```\nlistener.filter({ sheet: "Contacts" }, (...)=> {\n  listener.on("commit:created", async (...)=> {\n    // make changes after cells in Sheet are updated\n  });\n});\n```'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "This piece of code captures the essence of dynamic configurations. Once data in the 'Contacts' Sheet is updated (an event of 'commit:created'), the system moves on to perform the necessary configuration changes. This would not have been possible with static configurations.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How does it work?',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile utilizes event-driven architecture, allowing code to be run at any point in time based on any activity, user interaction, or data logic. That code can validate or modify data and also update configurations.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "For example, let's say you are configuring a new Space from the Flatfile dashboard.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When the “Create New Space” button is clicked on the platform, it triggers a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/concepts/events'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'job ',
                  marks: [],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: 'event',
                  marks: [
                    {
                      type: 'code'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'within the space ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'domain',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' that initiates a configure ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'operation',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. This operation is analogous to performing a POST request to the endpoint ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://reference.flatfile.com/docs/api/25e20c8ab61c5-create-a-space'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '/api/v1/spaces',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' with the parameter ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'autoconfigure',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' set to true.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Filter on the ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'domain',
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' (space) and the ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'operation',
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' (configure).',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Listen for a ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'job:ready',
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' event.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Build your Space ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Complete the job',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Optionally, listen for new events that are spawned from within your ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'space:configure',
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ' job.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Next steps',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Since everything is in code, Flatfile fully integrates into ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'your',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' software development lifecycle processes, making it easy to keep your app code and your Flatfile code totally in sync. Flatfile even supports ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/developer-tools/environment'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'multiple development environments',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' like dev, staging, and production.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Want to try it out yourself with a detailed code example? Check out the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/guides/dynamic-configurations'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Dynamic Configurations',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' guide in our developer docs for some working examples, complete with links to the code in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/FlatFilers'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'GitHub',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '6FdXSF7Cn410D72xJ87tN0',
    postTitle:
      "How we're building a world-class user experience in a developer platform",
    seoTitle:
      "How we're building a world-class user experience in a developer platform",
    seoUrlSlug:
      'building-a-world-class-user-experience-in-a-developer-platform',
    seoMetaDescription:
      'A developer platform should be powerful, user-friendly, intuitive and delightful to use. Delivering capabilities is only half the battle. The other half is providing an exceptional user experience.\n',
    category: 'Product updates & features',
    tags: ['user experience', 'data file import', 'developers'],
    publishDate: '2023-07-25T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7jANisxTrNyVXmQdiAY2Y4',
        type: 'Asset',
        createdAt: '2023-07-24T18:11:06.855Z',
        updatedAt: '2023-07-24T18:11:06.855Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Building a World-Class User Experience in a Developer Platform',
        description: '',
        file: {
          url: '/img/contentful/7jANisxT-building_a_world-class_user_experience_in_a_developer_platform_-_1920x1080.webp',
          details: {
            size: 55156,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'Building a World-Class User Experience in a Developer Platform - 1920x1080.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      '"Building a World-Class User Experience in a Developer Platform for Data File Import" on black background with colorful stars and lines',
    summary:
      'We built the Flatfile Data Exchange Platform to solve complex data exchange challenges, but as we’ve discovered, providing capabilities is only half the battle. The other half is providing an exceptional user experience. We know that a developer platform should not only be powerful but also user-friendly, intuitive, and yes, delightful to use.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Flatfile, our mission has always been to eliminate manual data work. We built the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Flatfile Data Exchange Platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " to solve complex data exchange challenges, but we've discovered that providing capabilities is only half the battle. The other half is providing an exceptional user experience. We know that a developer platform should be not only powerful but also user-friendly, intuitive, and, yes, delightful to use.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Developer platforms aren't typically associated with great user experiences. They're often seen as tools for the technical elite, filled with jargon and complex workflows that are incomprehensible to the average user. At Flatfile, we know that capabilities for developers are necessary but not sufficient.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our developer tools help customers wrangle disparate data formats, standardize fields, and onboard data effortlessly. The potency of these tools is evident in how our customers can easily handle even the most complex data tasks.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Empowering end users to solve data exchange challenges',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "At Flatfile, we're providing a solution for developers and every end-user who interacts with the data. This includes teachers, accountants, lawyers, plumbers, truck drivers, social workers, and more, all interacting with the Flatfile Data Exchange Platform. The user experience has far-reaching implications.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "End-users shouldn't have to wrestle with the complexity of the technology underlying the product. Instead, they should be able to focus on achieving their goal with the product. With this principle in mind, we designed the front-end components of our platform to be intuitive to non-experts. Further, though our customers can build their own UX on top of the Flatfile Platform, we generally see them leverage our customizable elements tested by hundreds of thousands of users.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Why does the end user matter so much?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In a world where "AI" is capitalized more than it is not, you may wonder why it is so important to accommodate a non-technical end-user. The answer lies in the problem we solve: we are shepherding those users\' real data. Last month\'s ACH transactions, a historical record of every patient seen, and full employee rosters are just three of hundreds of types of datasets exchanged in the data transactions we broker.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As a result, the type of collaboration the end-user has with Flatfile must be "zero-trust." We ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'want',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' them to check our work and engage in the process. Not only does this build trust, but it helps them lend their subject-matter expertise, which is lacking in most AI-driven solutions.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "This allows us to provide guidance for a process that would otherwise be untouchable and gather insight on how we could perform data tasks better on their behalf. It's a positive feedback loop in which the end customer has a better experience, and we learn how to make it better for them -- and all others like them -- as we go.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'UI examples',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For example, you can attach errors, warnings, or comments (info) to specific records. These messages provide visual status and contextual information or alerts to users interacting with the record, helping them understand any required issues or actions.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Adding an error using ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/docs/guides/handling-data#flatfilerecord-adderror'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'FlatfileRecord.addError()',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6fDY7yTpVz7ZSW549S0HZ9',
                type: 'Asset',
                createdAt: '2023-07-20T23:16:08.293Z',
                updatedAt: '2023-07-20T23:16:08.293Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Image3',
                description: '',
                file: {
                  url: '/img/contentful/6fDY7yTp-image3.webp',
                  details: {
                    size: 40432,
                    image: {
                      width: 520,
                      height: 410
                    }
                  },
                  fileName: 'image3.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Adding a warning using ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/docs/guides/handling-data#flatfilerecord-addwarning'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'FlatfileRecord.addWarning()',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4xSnbvKOZig2ZY1XERarI5',
                type: 'Asset',
                createdAt: '2023-07-20T23:17:45.778Z',
                updatedAt: '2023-07-20T23:17:45.778Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Image4',
                description: '',
                file: {
                  url: '/img/contentful/4xSnbvKO-image4.webp',
                  details: {
                    size: 38963,
                    image: {
                      width: 516,
                      height: 472
                    }
                  },
                  fileName: 'image4.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n\nAdding info using ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/docs/guides/handling-data#flatfilerecord-addinfo'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'FlatfileRecord.addInfo()',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'xJhLpNjMugBwWyNDSDLPL',
                type: 'Asset',
                createdAt: '2023-07-20T23:18:30.344Z',
                updatedAt: '2023-07-20T23:18:30.344Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Image1',
                description: '',
                file: {
                  url: '/img/contentful/xJhLpNjM-image1.webp',
                  details: {
                    size: 61693,
                    image: {
                      width: 520,
                      height: 492
                    }
                  },
                  fileName: 'image1.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The specific styling of each of these statuses is also fully customizable using ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/docs/guides/theming'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: "Flatfile's theme capabilities",
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile also makes it easy for end users to find and optionally update data with built-in options for "search," "find and replace," and "Replace empty values," making it easy to find what you\'re looking for.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1Ev1wF5cFji8qjkbLhi9ln',
                type: 'Asset',
                createdAt: '2023-07-20T23:19:12.362Z',
                updatedAt: '2023-07-20T23:19:12.362Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Image2',
                description: '',
                file: {
                  url: '/img/contentful/1Ev1wF5c-image2.webp',
                  details: {
                    size: 125086,
                    image: {
                      width: 930,
                      height: 688
                    }
                  },
                  fileName: 'image2.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Building a world-class user experience in a developer platform is a tough but rewarding challenge. We believe that by prioritizing user experience alongside powerful capabilities, we can deliver products that solve complex data challenges and delight our users.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Ultimately, the best measure of success for a developer tool is not the number of features it has but the success of the customers who use it. And by focusing on user experience, we're confident we can continue to drive customer success at Flatfile.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4WJlSPf8hxt863OQ3gyCTz',
    postTitle:
      'Revolutionizing data import (again!): The birth of the Flatfile Data Exchange Platform',
    seoTitle:
      'Revolutionizing Data Import (again!): The Birth of the Flatfile Data Exchange Platform',
    seoUrlSlug: 'the-flatfile-data-exchange-platform',
    seoMetaDescription:
      'Four years ago, Flatfile set out on a mission to make data import an exceptional and simple experience for customers. Today we are releasing the extensible, API-first Flatfile Data Exchange Platform.',
    category: 'Flatfile news',
    tags: ['Flatfile', 'Data Exchange', 'Data Onboarding', 'Data File Import'],
    publishDate: '2023-07-12T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6H4G6IdLR7nPhysgh2HKT7',
        type: 'Asset',
        createdAt: '2023-07-10T22:44:03.906Z',
        updatedAt: '2023-07-10T23:00:02.378Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile Data Exchange Platform',
        description: 'testing',
        file: {
          url: '/img/contentful/6H4G6IdL-frame_27638.webp',
          details: {
            size: 144268,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 27638.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile Data Exchange Platform',
    summary:
      'Four years ago, Flatfile set out on a mission to provide businesses a solution that solves the challenge of importing “flat files” (file formats like CSV or Excel) from end-users: Turning messy data into clean, API ready data in a way that empowers developers, and delights end-users.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Four years ago, Flatfile set out on a mission....',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To bring to life the idea that data import could be an exceptional and simple experience for customers. In my first blog post I talked about how my personal frustration with the status quo cascaded into a passion project, and floods of feedback from users asking for more. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That solution has scaled over the last few years to be the file-based data import experience for some of the largest software companies in the world. With millions of end users importing CSV and excel files each year, we’ve learned so much. But consistently, our customers and prospects have led the way.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Today, I’m super excited to announce that we’re releasing the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Flatfile Data Exchange Platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. A powerful set of APIs, open source plugins, and event streams that allow developers to use the building blocks of Flatfile to solve nearly any ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' problem, from one-click import buttons to complex, multi-stage enterprise workflows.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1UiKxih8QRhnJVulmzGpSn',
                type: 'Entry',
                createdAt: '2023-07-27T23:03:19.188Z',
                updatedAt: '2024-02-27T23:12:51.766Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'wistiaVideo'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Data Exchange Platform',
                video: {
                  items: [
                    {
                      hashed_id: 'nz0a9oaexk',
                      id: 116098617,
                      duration: 2956.46,
                      thumbnail: {
                        url: 'https://embed-ssl.wistia.com/deliveries/e50364d5f756c9a43d97abb8f86f1695022b128c.jpg?image_crop_resized=200x120',
                        width: 200,
                        height: 120
                      }
                    }
                  ]
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is the result of working closely with hundreds of customers and thousands of developers, from small startups to fortune 100 companies. We’ve researched every aspect of the data import journey, learning about technical implementation considerations, ecosystem integration challenges, customizations, workflows and approvals, business logic, access control and more.   ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'I’m extremely proud of what we built, but how did we get here',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We’ve all been there, dealing with the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'inevitable misery of handling file imports',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ". Be it an attempt to import a file, only to end up with a jumble of incorrect dates (I’m looking at you Excel), or the struggle of handling a customer's uploaded file riddled with inconsistencies, incorrect formats, and missing fields. The world of importing data-files often looks like a chaotic mess of information and constant back and forth.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It was this recurring frustration, faced at multiple companies, that ignited the spark to create Flatfile. We knew there had to be a better way.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We started our journey with an embeddable CSV importer solution. The overwhelming response from companies eager to become customers showed us that our solution resonated deeply with the market's pain points.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As Flatfile grew, we recognized that simply validating, cleaning, transforming, and standardizing data was insufficient. Our customer’s expressed the need to handle more complex scenarios, especially those involving multiple stakeholders, necessitating intricate workflows and human intervention.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'We needed to build something that met ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'all',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' of our customer’s needs',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The challenge is that data importing is inherently an edge-case problem. Each legacy file type, each audit requirement, each validation, each integration are essential pieces to the puzzle.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The reason building software for this is hard (and valuable) is that every company has such unique needs and constraints that ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'must be solved',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' in order for them to operate. For Flatfile to keep meeting the needs of our customers, we needed to expand our one-size-fits most solution into something more.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'So about a year ago, we went back to the drawing board',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Instead of trying to create a universal solution, which would be applicable to all businesses with some “customization”, we pivoted towards creating a developer-first platform that empowers organizations to build ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'their',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' own ideal solution, tailored specifically to their unique needs. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We took what was bottled up inside of our existing solutions as a baseline (Flatfile Portal and Workspaces), incorporated everything we learned across hundreds of customers, and made it fully extensible.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The Flatfile Data Exchange Platform provides ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'developers',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'full control',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' of each step of the user experience, business, and data logic, without having to deal with the challenges of building it yourself from scratch.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Key decisions for the new platform:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'API-first',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '\nEnabling seamless integration into any existing application or system, and adaptability to meet future needs or changes.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Event-driven architecture',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '\nProviding complete control at every step of the data flow and user journey, while also offering easier testing, monitoring and debugging.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Yes code',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '\nThe ultimate flexibility to collect, clean, validate, and convert data. Every process is driven by reusable code - roll your own or use community plugins.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Fast forward to a few months ago, the Platform was ready for feedback. We started extensive beta testing with existing customers and developers across a wide range of use cases. The feedback has been overwhelmingly positive, reaffirming our confidence in the Platform’s potential.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In addition to the numerous high-fives we received from developers, end-users also appreciated the familiar workbook-style user interface, the option for collaborative microsites, and customizable workflows.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From an enterprise perspective, larger organizations told us the Flatfile Platform checks all their boxes: ability to handle any business use case, privacy and compliance adherence, robust security, scalability, and a clear Return on Investment (ROI).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Up until now the build-vs-buy equation was tilted towards “build” for most enterprises. There was no “buy” option that could fully support their complex and ever changing needs, giving them full control and flexibility without the headaches of building it in-house from scratch.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    '“I believe the Flatfile Platform is truly a game-changer by finally providing a solution that enables any organization to solve their data import and collaboration needs.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Which brings us to today, the official release of the Flatfile Data Exchange Platform for ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                },
                {
                  type: 'underline'
                }
              ],
              value: 'everyone',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The platform so significantly increases the scope and value of problems Flatfile solves for our largest customers, that today we’re not only launching a new product, but we’re also doing something I’ve dreamed of being possible for a long time.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'now starts completely free for everyone',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', with a simple ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'pay-as-you-grow ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/pricing/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    },
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'pricing',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' model for when you need more than what the free plan provides. Flatfile is now accessible to companies of ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'all',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' sizes, from large enterprises, to one person startups. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’re making it easy for anyone to start building and I invite developers to',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://platform.flatfile.com/account/sign-up'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: ' try the platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and experience its capabilities first-hand. Watching the huge unlock this has created for our customers has been one of the most exciting product moments at Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I can’t wait to see the remarkable things you build with Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4qkSVl3UintZbZ7VeMWys7',
                type: 'Entry',
                createdAt: '2023-07-07T16:18:03.020Z',
                updatedAt: '2023-08-29T16:41:20.436Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 7,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Official Launch Webinar! July 19th!',
                text: 'Watch as our CEO, David Boskovic, unveils the next generation of the Flatfile Data Exchange Platform. New features, more customization, and developer-first functionality.',
                ctaText: 'Watch here',
                href: '/webinar/launch-flatfile-data-exchange-platform/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2qPLN8TP44CAlRIOuy4lYc',
    postTitle: 'How to avoid the pitfalls of sweat-based data file imports',
    seoTitle: 'How to avoid sweat-based data file imports',
    seoUrlSlug: 'sweat-based-data-file-imports',
    seoMetaDescription:
      "Don't waste time allocating more resources to moving data files between people and incompatible, outdated systems. There's a better way to exchange data and collaborate across companies and teams.",
    category: 'Data exchange',
    tags: ['data-file imports', 'data file', 'data onboarding'],
    publishDate: '2023-04-04T09:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4WcWgOQxejEpSpoIbikmEd',
        type: 'Asset',
        createdAt: '2023-04-03T18:50:50.162Z',
        updatedAt: '2023-04-03T18:50:50.162Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Sweat Based Solutions image',
        description: '',
        file: {
          url: '/img/contentful/4WcWgOQx-elisa-ventur-bmjaxaz6ads-unsplash-1920x1080.webp',
          details: {
            size: 711155,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'elisa-ventur-bmJAXAz6ads-unsplash-1920x1080.jpg',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText:
      'Sweat-based data file imports concept: person in front of a laptop with their head in their hands.',
    summary:
      "Don't waste time allocating more resources to moving data files between people and incompatible, outdated systems. There's a better way to exchange data and collaborate across companies and teams. Flatfile makes it simpler and safer for developers to create a data import process that makes it easy for businesses to collaborate and exchange data.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4e8VT08UTBNDVEEXyXmBEX',
        type: 'Entry',
        createdAt: '2023-04-03T18:49:21.580Z',
        updatedAt: '2024-02-09T18:50:21.687Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 10,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Gottfried Sehringer',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5KaxrJpuaiQ0f8hiCzQYVm',
            type: 'Asset',
            createdAt: '2023-04-03T18:48:38.608Z',
            updatedAt: '2023-04-03T18:48:38.608Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Gottfried Sehringer picture',
            description: '',
            file: {
              url: '/img/contentful/5KaxrJpu-1641306098983.webp',
              details: {
                size: 30320,
                image: {
                  width: 400,
                  height: 400
                }
              },
              fileName: '1641306098983.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Chief Marketing Officer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Rolling up your sleeves is the American way. It's the embodiment of the can-do spirit that fuels our innovation and discovery. But sometimes, putting more effort into solving a problem isn't the smartest way to work.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to moving data files between people and incompatible, outdated systems, businesses worldwide often approach the problem by allocating ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/secret-to-modernizing-your-data-stack/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'more effort and resources',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to the project. We call these "sweat-based solutions," and they often result in a significant waste of effort for a solution that offers no future return on that investment. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "It's time to think of new ways to solve old problems. Ways that will continue to deliver benefits well beyond today.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Data file imports: Getting down to business',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Consider the moment your business enters a new business partnership. After signing the deal, you have to act fast to share important data that will fuel the partnership, such as joint customers, prospects, products or projects. You need to hit the ground running and show your new business partner that they chose the right people to partner with. This mission-critical time lays the foundation for your future business relationship.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "It's often during this critical time that you'll learn about obstacles: Your partner's data is offline in a proprietary system with no way to access it directly, or it's in a spreadsheet, but there's ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/why-isnt-my-csv-file-importing/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'no consistent structure',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' for how it is formatted. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To transfer that data into your own system, you end up receiving the data in various files and formats and have to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/7-scary-excel-errors-your-team-is-probably-making/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'review every column and row of data',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to ensure everything is in its right place before you make the transfer. Your team may go back and forth with the partner, combing through thousands upon thousands of rows of data in an effort to get it in shape for import into your systems.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So, what do you do? You assign members of your team to tackle the problem and give them a tight deadline. They work late hours for weeks trying to make sense of the data and massage it into proper form, neglecting their core duties. Maybe you hire part-time workers to help them. Maybe they ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/secret-to-modernizing-your-data-stack/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'build an automated data file importer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " to make the job go faster. As a result, they are wasting an enormous amount of time doing something that will have no benefit for them later on. Even if they complete the project in record time, they've only completed this one task (monumental though it was), and they will be unable to capitalize on it in future projects.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "Don't sweat it: There's an easier way to import data files",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "The smarter way to work is one that permits you to reap the benefits of all this effort. It understands your needs and comes with predesigned solutions and the flexibility to override and edit those solutions at any moment in the process. A smarter system that's built to work for your current problem and all your future problems. One that's based on a comprehensive repository of real-world use cases from thousands of companies that have had to do this before and uses artificial intelligence to learn from all previous decisions to support the data import process. It formats names, dates, and other information perfectly and according to the rules you have established; it matches column names and their contents to your own and validates the data, making it easy for your team to review and clean any outliers or collaborate with your partner's team to fix any source data issues. It's simple enough for anyone in your office to use, and yet fully customizable, allowing your software developers to get under the hood and integrate it into your existing systems. It's a solution that works for enterprises of every type and size.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "The smarter system described above is the one we have spent years building. The Flatfile Data Exchange Platform makes it simpler, faster and more secure for developers to create a data file import process that makes it easy and seamless for business users to exchange data and collaborate across companies and teams. It's the culmination of decades of experience doing things the harder way, followed by extensive research and discovery on how to do it better. It's a solution that will save you time and money and allow you to get back to the core business of your enterprise.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Sure, hard work is often what's needed to get the job done. But, sometimes, it's simply better to rethink the problem and consider a new way of doing things. Replacing hard work with smarter, more efficient methods can streamline your business and add to your bottom line. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So, keep your sleeves down and save your sweat for the gym.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6psbcWqRLAoNwsy1VfkK1R',
    postTitle: 'How to navigate the bumpy first mile of healthcare IT data',
    seoTitle: 'Flatfile: The first mile of healthcare IT data',
    seoUrlSlug: 'healthcare-it-data',
    seoMetaDescription: 'Flatfile: The first mile of healthcare IT data',
    category: 'Data exchange',
    tags: [
      'health tech',
      'healthcare data',
      'data exchange',
      'data onboarding'
    ],
    publishDate: '2023-03-21T10:08-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '44X81MWocLKpn5MSgZEjWT',
        type: 'Asset',
        createdAt: '2023-03-20T19:31:12.802Z',
        updatedAt: '2023-03-20T19:31:12.802Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'HealthTech Image',
        description: '',
        file: {
          url: '/img/contentful/44X81MWo-hush-naidoo-jade-photography-yo01z-9hqaw-unsplash_1920x1080.webp',
          details: {
            size: 600841,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName:
            'hush-naidoo-jade-photography-yo01Z-9HQAw-unsplash_1920x1080.jpg',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText: 'Healthcare',
    summary:
      'Making data available more quickly and more efficiently is important for any business. In the healthcare industry, however, time is an extremely valuable resource. The sooner doctors can diagnose illnesses, the sooner they can begin treating them. The sooner institutions have access to real data, the sooner they can make life-saving decisions.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We’re experiencing the impact of technology on the healthcare industry now more than ever. Doctors can visit their patients on computer screens; the results of x-rays, CT scans, blood tests and other data can be shared among remotely located specialists with ease and immediacy; prescriptions can be delivered to a local pharmacy in a matter of seconds with just the click of a button; and patients can access their own medical records in the cloud and share them with approved healthcare providers using an app on their phone. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'While these advances have revolutionized the healthcare industry, they have also created new requirements, including the need for fast, secure exchange of massive volumes of data. Some of this data is being synchronized via fixed links between large and tightly managed IT systems. But more often than you may expect, data arrives in these systems in the form of data files: CSVs, spreadsheets built from a template, legacy database loads, and more. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Getting data transferred from variable and inconsistent sources, often from vastly disparate systems, typically requires an arduous process of manually assessing, parsing, and cleaning the data in preparation for use in the target system of record. This creates delays that ultimately slow down an effective healthcare delivery system: order for new equipment, the customer to a new EMR, reimbursement from a carrier, and anywhere else that relies on a file-based data transaction. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The efficiency of AI-assisted data exchange',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To allow healthcare organizations and their staff to share data files, the best option has long been to write code and maintain a data import solution themselves or to deploy an army of manual resources. This approach is both costly and inefficient. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile solves this problem with their flexible, file-based data exchange platform. The artificial intelligence (AI) assisted platform intelligently determines how to repair, replace, and format data for its intended purpose on the fly. With the added guidance of a “human in the loop” — a designated individual or team assigned the task of resolving one-off or unique data issues —  these decisions are remembered and automatically applied in future workflows. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Data is the lifeblood of the healthcare industry',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Manual review of data files is not only tedious and prone to human error, it is also very inefficient, time consuming and expensive. Flatfile addresses all of these issues by providing powerful data validation tools within a configurable environment. This means an organized data review and approval process that is easy to use for health care staff and at the same time more secure, faster and consistent than ever before. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Making data available more quickly and more efficiently is important for any business. In the healthcare industry, however, time is an extremely valuable resource. The sooner doctors can diagnose illnesses, the sooner they can begin treating them. The sooner institutions have access to real data, the sooner they can make life-saving decisions. Don’t let the data import process become your bottleneck. Loosen the hold that your data has on you by learning how to move it from your files to other systems faster, cleaner, and more efficiently. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2fUq4kUM15DR4mU2qqOktK',
    postTitle:
      "Flatfile among Forbes’ “America's Best Startup Employers 2023” list",
    seoTitle: "Forbes’ “America's Best Startup Employers 2023” list",
    seoUrlSlug: 'flatfile-among-forbes-americas-best-startup-employers-2023',
    seoMetaDescription:
      'It was a nice surprise this week to learn that we were selected by Forbes as one of the top startup employers in the U.S. As Flatfile continues to grow, we will continue to strive for excellence.',
    category: 'Flatfile news',
    tags: ['Forbes', 'Best Startup Employers'],
    publishDate: '2023-03-09T00:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4YAT8tzdAeuXmwOOLSCeyG',
        type: 'Asset',
        createdAt: '2023-03-09T16:44:07.774Z',
        updatedAt: '2023-03-09T16:44:07.774Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Forbes list image',
        description: '',
        file: {
          url: '/img/contentful/4YAT8tzd-forbes_blog_post_confetti__1_.webp',
          details: {
            size: 74814,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Forbes blog post confetti (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Forbes list',
    summary:
      "It was a nice surprise this week to learn that we were selected by Forbes as one of the top startup employers in the U.S. It's a very special honor for us because it shows that our corporate values are not mere rhetoric, but how we operate as a company. It also reflects our commitment to creating an exciting workplace environment.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This week we were selected by Forbes as one of the top startup employers in the U.S. It is a very special honor for us because it shows that our corporate values are not mere rhetoric, but how we operate as a company. It also reflects our commitment to creating an exciting workplace and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'attracting the best talent',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. \n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "Forbes' annual ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.forbes.com/lists/americas-best-startup-employers/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: "America's Best Startup Employers",
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' list recognizes startups who are committed to maintaining a good reputation, investing in employee satisfaction and pursuing steady growth. Forbes partnered with the market research firm Statista to create the list based on three criteria: employer reputation, employee satisfaction and growth. Statista analyzed public sources, including articles, blogs and social media posts, for specific phrases such as “corporate culture” and “employee engagement,” using text analysis to assess those as positive, negative or neutral. Further research included evaluation of online reviews and examination of each organizations’ website traffic and head counts over a two-year period.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '\nAs Flatfile continues to grow and expand, we are confident that we will continue to prove our excellence. Great things are happening here, and we encourage you to join our innovative team in building the best data exchange platform in the world. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5b60jRsf4TZ9MMotOPsPkx',
    postTitle:
      'Who’s in charge of all that Fintech data anyway? Flatfile is on it.',
    seoTitle:
      'Flatfile for Fintech: Flatfile is a system that learns from customized guidance and repeats the mundane task of data cleansing with speed, security and efficiency to ensure that your data gets to where it’s going intact.',
    seoUrlSlug:
      'whos-in-charge-of-all-that-fintech-data-anyway-flatfile-is-on-it',
    seoMetaDescription:
      'Who’s in charge of all that Fintech data anyway? Flatfile is on it.',
    category: 'Data exchange',
    tags: ['fintech', 'data onboarding'],
    publishDate: '2023-02-16T00:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7gs1Rl5ML5RT0qKn0UYUMA',
        type: 'Asset',
        createdAt: '2023-02-16T17:45:12.335Z',
        updatedAt: '2023-02-16T17:45:12.335Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Fintech Picture',
        description: '',
        file: {
          url: '/img/contentful/7gs1Rl5M-m-w7weqy01k3s-unsplash-1920x1080.webp',
          details: {
            size: 537677,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'm-W7wEqy01K3s-unsplash-1920x1080.jpg',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText: 'Fintech',
    summary:
      "Flatfile was created to eliminate that initial data onboarding bottleneck by facilitating the transfer of massive data sets with little need for human supervision. It's a system that learns from customized guidance and repeats the mundane task of data cleansing with speed, security and efficiency to ensure that your data gets to where it’s going.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3g8UtF3xqMDeJcwD9zabc5',
        type: 'Entry',
        createdAt: '2022-12-05T16:44:02.752Z',
        updatedAt: '2022-12-05T16:44:02.752Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Noelle Festa',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6pb3PzTTNmEL9U8H4YaJBH',
            type: 'Asset',
            createdAt: '2022-12-05T16:42:27.684Z',
            updatedAt: '2022-12-05T16:42:27.684Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Noelle Headshot',
            description: '',
            file: {
              url: '/img/contentful/6pb3PzTT-t0ap8ur47-u03ea82my2u-d9a5ad607b89-512.webp',
              details: {
                size: 54407,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U03EA82MY2U-d9a5ad607b89-512.jpeg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the short time it took financial services platforms like Paypal, Venmo, and ApplePay to become household names, there has been an explosion of digital apps, brokerages, and blockchain-based trading platforms onto the market. Just take a look at any app store on your device of choice: opportunities to buy and trade local currency, foreign currency, and digital currency abound. Then there are apps for payroll processing, benefits, asset management, digital banking, fraud protection, retail loans, and much more. The amount of data being passed from one system to another is astounding. So, who is making sure that all this data is transferred quickly and securely?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '\nMuch of this data transfer happens “in the cloud,” that ubiquitous euphemism that means it occurs over a vast network of databases connected over the Internet using application programming interfaces (APIs) to translate from the language of one system to another. And it truly is a marvel how quickly and conveniently it all happens, especially when you consider the number of disparate systems involved. \n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "What you may not know is that when two systems are first integrated, the process for joining them is not always as neat as you might imagine. During that first integration — well before that fintech app gets to market —  there is a data onboarding process that requires time and resources to manually process the raw data (customer info., billing addresses, vendor account information, fee percentages, tax codes, etc.) and clean, sort, and prepare it for import to the new system. This critical moment in a new customer relationship (what we call the “first mile of data'') is a potential bottleneck that can delay your product launch or worse, sabotage your projects before they have a chance to get off the ground.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '\nFlatfile was created to eliminate that initial data onboarding bottleneck by facilitating the smooth transfer of massive data sets with little need for human supervision. It is a system that learns from customized guidance and repeats the mundane task of data cleansing with speed, security and efficiency to ensure that your data gets to where it’s going intact.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From the conception of digital currencies in the 1980s to the modern day of crypto, data has provided the backbone of Fintech. This is a world with no room for errors that requires absolute trust that your data is transferred correctly the first time. After all, there is simply no value in a currency that cannot be exchanged quickly and securely. And in a business like this, there are no second chances.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Every day new companies launch with the dream of providing faster, better ways to settle accounts, pay employees, provide benefits, pay service providers, and more. Many of these businesses have no physical assets, only the code that makes them unique among their competitors. Yet, they fuel industry, inject buying power into the economy, and deliver a level of service and satisfaction that no town bank has ever been able to provide. It is a fascinatingly fast world of personalized financial empowerment that gives us the ability to secure our future from just about anywhere in the world. While we may not often think about who is making all this happen behind the scenes, maybe we should.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3mXTtPrUVZI0CAeKwOt03n',
    postTitle: 'Industry spotlight: Flatfile keeps logistics pipelines flowing',
    seoTitle: 'Flatfile keeps logistics pipelines flowing',
    seoUrlSlug: 'flatfile-keeps-logistics-pipelines-flowing',
    seoMetaDescription:
      'Flatfile keeps logistics pipelines flowing by assisting with data onboarding and data exchange. ',
    category: 'Data exchange',
    tags: ['logistics', 'data exchange', 'data onboarding'],
    publishDate: '2023-02-02T00:00-08:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6JowJKzFl3xnWCIX0ju6yz',
        type: 'Asset',
        createdAt: '2023-02-02T20:31:20.665Z',
        updatedAt: '2023-02-02T20:31:20.665Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Logistics image',
        description: '',
        file: {
          url: '/img/contentful/6JowJKzF-hannes-egler-nt4k2jdtwtq-unsplash_1920x1080.webp',
          details: {
            size: 753396,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'hannes-egler-nT4k2JDtwTQ-unsplash_1920x1080.jpg',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText: 'Logistics',
    summary:
      'Enterprise resource management (ERP) systems, warehouse tracking systems, TMS systems, handheld devices, and delivery fleet management systems can all share the same data faster and do so with greater accuracy and efficiency. In short, Flatfile greases the wheels of the logistics enterprise to keep that pipeline flowing. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3g8UtF3xqMDeJcwD9zabc5',
        type: 'Entry',
        createdAt: '2022-12-05T16:44:02.752Z',
        updatedAt: '2022-12-05T16:44:02.752Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Noelle Festa',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6pb3PzTTNmEL9U8H4YaJBH',
            type: 'Asset',
            createdAt: '2022-12-05T16:42:27.684Z',
            updatedAt: '2022-12-05T16:42:27.684Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Noelle Headshot',
            description: '',
            file: {
              url: '/img/contentful/6pb3PzTT-t0ap8ur47-u03ea82my2u-d9a5ad607b89-512.webp',
              details: {
                size: 54407,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U03EA82MY2U-d9a5ad607b89-512.jpeg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From receipt to delivery, the success of your supply chain relies on your ability to know where your inventory is at all times. The more units you need to track, the more complicated that process gets. Whether you are using a transport management system (TMS) or relying on third-party logistics vendors and apps, there will likely be a time when you need to exchange data with vendors and business partners, beyond the walls of your own operating environment. Breaking out of the confines of a closed system requires a lingua franca to ensure that no SKU, no parcel, no replacement part gets lost in the shuffle.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'It’s messy out there',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Maybe you have hundreds of customers; maybe even thousands. It is likely that none of them manage their data in the same way. They each have different products with different specifications. Even the way they refer to similar products and services can vary widely. Your job, as the logistics enterprise, is to get these goods from point A to point B and beyond. You also need to do it quickly and without missing a beat. If you are spending too much time preparing data to be entered into your system, time is being wasted. That time would be better spent focusing on your core skills (moving things), rather than preparing data. And yet that data is critical to your success. You’ve got to move the products AND move the data. It’s just that sometimes it’s the latter that can cause the most trouble.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Many roads, no rules',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For many companies, the standard procedure for exchanging data is to export it to .csv (comma separated values) files. These simple text files containing raw data are the backbone of spreadsheet applications like Microsoft Excel and Google Sheets. However, because there is no standard that defines the content of columns, merging data from two systems requires data managers to reconcile like content, format it correctly, and place it into the correct corresponding column in the target spreadsheet. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This process is the source of great tedium, and newly introduced errors. Many businesses have shouldered the task of building a custom solution for handling this data. But that path comes with the added burden of maintaining the bespoke solution, accounting for upgrades and changes to data columns, and constant human oversight.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The smarter path to data exchange',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile uses artificial intelligence (AI) to quickly identify data types and reformat it in an intelligent way that works for your business. After prompting the human user to answer the difficult questions, Flatfile stores these decisions for future use and applies them intuitively to new problems. The result is the super swift analysis, correction, and exchange of data between systems that keeps logistics operations running smoothly all day long.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'All your data, everywhere',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile is designed for both software developers, who can use the Flatfile application programming interface (API) to integrate our technology into existing software systems, and data managers, who can easily collaborate through a web browser without special knowledge of software development. This broad usability makes the data exchange process seamless across your workflow. The result is that enterprise resource management (ERP) systems, warehouse tracking systems, TMS systems, handheld devices, and delivery fleet management systems can all share the same data faster and do so with greater accuracy and efficiency. In short, Flatfile greases the wheels of the logistics enterprise to keep that pipeline flowing. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '1avW3ZuNIzZUcJYblqMisM',
    postTitle: 'In a cashless world, your data is king.',
    seoTitle: 'In a cashless world, your data is king.',
    seoUrlSlug: 'in-a-cashless-world-your-data-is-king',
    seoMetaDescription:
      'From banks to brokerage houses, lenders to insurers, vast amounts of money are traded every day without the crinkle of paper or the clink of coins. What happens when companies have to share this data?',
    category: 'Data exchange',
    tags: ['data exchange', 'finance'],
    publishDate: '2023-01-03T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3ZQdbmAIUhXLe5xU1Lj1I6',
        type: 'Asset',
        createdAt: '2023-01-03T22:06:50.445Z',
        updatedAt: '2023-01-03T22:06:50.445Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 3,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'currency',
        description: '',
        file: {
          url: '/img/contentful/3ZQdbmAI-currency.webp',
          details: {
            size: 3837400,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'currency.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'dollars currency image',
    summary:
      'From banks to brokerage houses, lenders to insurers, vast amounts of money are traded every day without the crinkle of paper or the clink of coins. Encrypted packages comprising millions of rows of data are shared between the powerbrokers of the world at lightning speed, populating trading desk terminals, spreadsheets, platforms, and more. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When was the last time you paid for something in cash? If you are like most people, you might need a few minutes to recall the answer to that question. A July 2022 Gallup ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://news.gallup.com/poll/397718/americans-using-cash-less-often-foresee-cashless-society.aspx'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'poll',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' reported that six in ten adults claim to use cash seldom to never. While the Covid epidemic may have influenced this trend, it was already a long time coming. That’s because currency has been gradually transitioning to a digital asset. Even the International Monetary Fund (IMF) is ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.imf.org/en/News/Articles/2022/02/09/sp020922-the-future-of-money-gearing-up-for-central-bank-digital-currency'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'gearing up',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' for the adoption of digital global currencies. And when your money is on the line, you are going to  want to make sure all your ledgers are balanced. You are going to want to be assured that nothing gets lost when moving it from one place to another.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The tyranny of the CSV file',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From banks to brokerage houses, lenders to insurers, vast amounts of money are traded every day without the crinkle of paper or the clink of coins. Encrypted packages comprising millions of rows of data are shared between the powerbrokers of the world at lightning speed, populating trading desk terminals, spreadsheets, analytics platforms, and more. And when these businesses share this data with external parties, it is most commonly in the form of flat files. Flat files are very simple text files with data that has no formatting information. There is nothing to state what font should be used, how large it should be, where an indent should occur — it is a pure list of data points. In its most common form, each data point in a flat file is separated by a comma. These are called comma separated values (CSV) files and are typically distinguished by the “.csv” suffix.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Anyone who has been tasked with manually transferring data from one system to another, one app to another, or one company to another has had to go through a similar process of downloading the data from one system, verifying it, correcting mistakes and missing information, and importing it to its destination system. It is a process that takes place in countless businesses every day, and it can take weeks or even months to complete. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data exchange can create a costly bottleneck in your workflow and even lead to the breakdown of collaborative projects. If data isn’t handled with care, it can lead to breaches in security that result in ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.sec.gov/news/press-release/2022-168'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'devastating legal action',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Even when it goes according to plan, data exchange can be the source of fatigue, burnout, and absent mindedness — three things you most certainly do not want when your money is at stake.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Flatfile makes it simple',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We created Flatfile as a solution to this very common problem. We built it in the fury of our own personal need and immediately knew it had to be shared with others who live and breathe by enterprise data exchange. At the outset, we knew that to succeed, Flatfile would need to be robust, secure, accurate, and easy to use. Well . . .  We succeeded. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile is built on secure cloud infrastructure for industry-leading scalability and performance. It is SOC 2, HIPAA, and GDPR compliant and it protects your data — in transit and in storage — using one of the strongest block ciphers available: AES-256 (Advanced Encryption Standard). The platform is deeply configurable to work with the systems you already have. You can access it from a browser or embed it into your own systems for seamless integration. It allows your developers to get under the hood and modify it to fit your needs. Even more important, Flatfile is breathtakingly simple to use: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Access the data importer from a button and upload your files',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Flatfile guides you through the process of cleaning your data and importing it correctly into your target system',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Flatfile uses AI to remember all of your decisions to make future imports faster ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile provides a simple, elegant solution to the messy work of data exchange. You’ll save time, money, and worry while avoiding costly mistakes and security risks. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Financial data is the coffee of Wall Street; the bread and butter of business. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you are going to put your trust into disperse digital systems for processing and reconciling your finances, you will want to make sure your coffee doesn’t spill, your bread doesn’t crumble. You are going to want to protect your data and ensure it is always exchanged quickly and securely. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Because, if data is going to ever fully replace physical currency, you will need to know how to share it with confidence.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3VznXefOQv4H8UEh3vPiJO',
    postTitle:
      'Flatfile named G2 Leader in data quality, ranked highly in 8 other categories',
    seoTitle:
      'Flatfile named G2 Leader in Data Quality, ranked highly in 8 other categories',
    seoUrlSlug: 'flatfile-g2-awards',
    seoMetaDescription:
      'We are pleased to announce that Flatfile has been named a G2 Leader in Data Quality. This award is based on Flatfile’s high customer satisfaction score and our having a large market presence.',
    category: 'Flatfile news',
    tags: ['g2'],
    publishDate: '2022-12-29T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4OUWj1rTI4iXF5I1Cr66bO',
        type: 'Asset',
        createdAt: '2022-12-30T14:49:42.024Z',
        updatedAt: '2022-12-30T14:49:42.024Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'G2 award',
        description: '',
        file: {
          url: '/img/contentful/4OUWj1rT-frame_6__4_.webp',
          details: {
            size: 108950,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 6 (4).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'image of g2 awards',
    summary:
      'Flatfile has been named a G2 Leader in Data Quality. This award is based on Flatfile’s high customer satisfaction score and our having a large market presence. A full 100% of users rated Flatfile 4 or 5 stars (out of 5), with 100% of respondents saying they believe “Flatfile is headed in the right direction.” ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We are exceptionally pleased to announce that Flatfile has been named a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.g2.com/products/flatfile/reviews'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'G2 Leader in Data Quality',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. This award is based on Flatfile’s high customer satisfaction score and our having a large market presence. A full 100% of users rated Flatfile 4 or 5 stars (out of 5), with 100% of respondents saying they believe “Flatfile is headed in the right direction.” Moreover, our users said they would be likely to recommend Flatfile at a rate of 96%.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This news comes at a time when we are getting very excited about huge updates that are coming to the Flatfile platform to help developers build and scale data exchange experiences in Typescript. We’ve worked very hard to act as good stewards of our industry-leading position in data exchange, and it means so much to us to be recognized for our efforts.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'G2 scores products and vendors based on reviews gathered from its user community, as well as data aggregated from online sources and social networks. G2 applies its unique algorithm to this data to calculate the customer satisfaction and market presence scores in real time. More than 80 million people annually use G2 to make smarter software decisions based on authentic peer reviews. \n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In addition to the Data Quality report mentioned above, Flatfile scored highly on 8 additional G2 reports:\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Ranked #2 on the Usability Index for Data Preparation Report ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This score is based on the following metrics:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of admin',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of use',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Meets requirements',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Ranked #3 on the G2 Data Preparation Implementation Index Report',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This score is based on metrics including:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of setup',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Average user adoption',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Average months to go Live',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Ranked #3 on the Data Preparation Relationship Index Report ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This score is based on the following metrics:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Likelihood to recommend',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of doing business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Quality of support',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '— Ranked #3 on the Data Preparation Results Index ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This score is based on the following metrics:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Results data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Average user adoption',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'ROI factors',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Ranked #7 on the G2 Data Quality Relationship Index Report  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'relationship',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' scores highlight some of the factors which contribute to a product’s overall Relationship score, as shown in the graphic below, including:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of doing business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Quality of support',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Likelihood to recommend data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Ranked #10 on the Relationship Index for Embedded Integration Platforms Report ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This score is based on the following metrics:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Likelihood to recommend',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of doing business with',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Quality of support',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Named High Performer on G2 Small-Business Grid® Report for Data Quality ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile was named a ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'High Performer',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' product based on its high customer satisfaction scores and low market presence compared to the rest of the category. Flatfile received the highest satisfaction score among products in the Data Quality category, with 100% of users rating it 4 or 5 stars, and 100% of users believing it is “headed in the right direction.” Also in this category, users said they would be likely to recommend Flatfile at a rate of 98%.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '— Named a High Performer on Grid® Report for Embedded Integration Platforms ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile was named a High Performer product based on its high customer satisfaction scores and its low market presence compared to others in its category. 100% of users rated Flatfile 4 or 5 stars, 100% of users believe it is “headed in the right direction,” and users said they would be likely to recommend Flatfile at a rate of 93%.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We want to thank you — our users —who have made Flatfile the number one data exchange platform through your support and feedback. We can't wait to see what great things are in store for next year.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Sincerely,',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The Flatfile Team',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6cs1Yl8paRidREj4VsCTrs',
    postTitle: 'Field Hooks Part 2: compute',
    seoTitle: 'Hello world, meet Compute Field Hooks.',
    seoUrlSlug: 'field-hooks-part-2-compute',
    seoMetaDescription:
      'In this series, we think about real-world examples to wrap our minds around the possibilities of Field Hooks, which — as their name suggests — clean up or validate data at the field level. ',
    category: 'Developers',
    tags: ['Data Hooks®', 'Field Hooks'],
    publishDate: '2022-12-22T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7dmHqMooToIrKPJmDXqBrc',
        type: 'Asset',
        createdAt: '2022-12-22T19:25:35.288Z',
        updatedAt: '2022-12-22T19:25:35.288Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Compute field hook type',
        description: '',
        file: {
          url: '/img/contentful/7dmHqMoo-field_hooks__compute.webp',
          details: {
            size: 52644,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Field Hooks_ compute.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'decorative image of compute field hooks code',
    summary:
      "Let's think about a real-world example to wrap our minds around the possibilities of Field Hooks, which (as their name suggests) clean up or validate data at the field level. ",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Let's continue thinking through more real-world examples to wrap our minds around the possibilities of Flatfile's ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Field Hooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', which — ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'as their name suggests',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' — clean up or validate data at the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'field',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' level. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "This is Part 2 of a 3-part series about Flatfile's Field Hooks. Read ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/hello-world-meet-cast-field-hooks/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Part 1 - Field Hooks: cast',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: " first if you haven't already.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Scene 2: compute',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-1'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Suppose we need',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' to convert all ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'employee names',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' to ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'lowercase ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: 'before reasoning about the  data strings.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Leveraging recordCompute Field Hooks',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "We'll use ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'compute',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' to modify the data in place before proceeding to ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'validate',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'First, ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'compute',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        " will receive data of the type determined by the field's cast hook",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Then, it will perform a transformation to the value returned from ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'cast',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                },
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      content: [
                        {
                          data: {},
                          content: [
                            {
                              data: {},
                              marks: [],
                              value: 'Note: ',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [
                                {
                                  type: 'code'
                                }
                              ],
                              value: 'compute',
                              nodeType: 'text'
                            },
                            {
                              data: {},
                              marks: [],
                              value:
                                ' will always return data of the same type',
                              nodeType: 'text'
                            }
                          ],
                          nodeType: 'paragraph'
                        }
                      ],
                      nodeType: 'list-item'
                    }
                  ],
                  nodeType: 'ordered-list'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'CODE EXAMPLE',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-4'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6bzfF3bj9ixo690766Zog3',
                type: 'Entry',
                createdAt: '2022-12-22T19:27:34.039Z',
                updatedAt: '2022-12-22T20:32:10.206Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description:
                  'Compute Field Hook > convert all employee names to lowercase',
                language: 'typescript',
                code: '```const Employees = new Sheet("Employees", {\n  name: TextField({\n    label: "Name",\n    description: "Employee\'s name",\n    required: true,\n    // convert name to lowercase\n    compute: (name: string) => {\n      return name.toLowerCase();\n    },\n  }),\n});```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While Field Hooks only clean up or validate data at the field level, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'recordCompute',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'batchRecordsCompute',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' come into play when you need to ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'run computations across all fields in a single record or in bulk operations',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '. More on Record Hooks soon.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the docs to learn more about ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://docs.flatfile.com/docs/guides/data-hooks/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'processing data with Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started not with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://docs.flatfile.com/docs/get-started/quickstart/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'CLI Quickstart',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4TG658QVkkcWjei6fEKXKl',
    postTitle: 'Field Hooks Part 1: cast',
    seoTitle: 'Hello world, meet Cast Field Hooks. Part 1: cast',
    seoUrlSlug: 'hello-world-meet-cast-field-hooks',
    seoMetaDescription:
      'In this series, we think about a real-world example to wrap our minds around the possibilities of Field Hooks, which — as their name suggests — clean up or validate data at the field level. ',
    category: 'Developers',
    tags: ['Data Hooks®', 'Field Hooks'],
    publishDate: '2022-12-21T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5t8Fkvra3zBy7cyhx4Bw0q',
        type: 'Asset',
        createdAt: '2022-12-21T19:56:16.673Z',
        updatedAt: '2022-12-22T19:21:30.561Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'cast field hook type',
        description: '',
        file: {
          url: '/img/contentful/5t8Fkvra-field_hooks__cast.webp',
          details: {
            size: 46588,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Field Hooks_ cast.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'decorative image of cast field hooks code',
    summary:
      "Let's think about a real-world example to wrap our minds around the possibilities of Field Hooks, which (as their name suggests) clean up or validate data at the field level. ",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Just as every new day begins with possibilities, it's up to us to fill it with the things that move us toward progress and peace. At Flatfile, this looks like short functions to ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 're-format',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'correct',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'validate',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'enrich',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' data automatically during a data import. These functions can run on specific fields and records (rows), or they can run across an entire batch of records.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Hello world, meet ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Field Hooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ". Field Hooks — as their name suggests — clean up or validate data at the field level. Let's think about a real-world example to wrap our minds around the possibilities of ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Field Hooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', which — ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'as their name suggests',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' — clean up or validate data at the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'field',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' level. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Scene 1: cast',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-1'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Say we want to accept data about loans, including the interest rate. We want to accept either ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'percentages',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', e.g. "',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '6.5%',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '", or ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'pure numbers',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' representing a percentage, e.g. "',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '0.065',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '", and interpret them the same way. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Later, we want to use this data to calculate monthly payments on the loan. In that case, we\'d want both "',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '6.5%',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '" and "',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '0.065',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '" to be represented as the numerical version, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '0.065',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Leveraging Cast Field Hooks',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We want to accept different kinds of incoming data (in this case ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'strings',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'numbers',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ') and cast them to ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'numbers',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' depending on how they are formatted. We will do this in three steps:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'First, we check for ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'null',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ', ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'undefined',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ', and empty strings, and then we cast them to ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'null',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Next, we check if we have a number written as a percentage. If so, we extract the numerical portion and divide it by 100.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'For other strings, we attempt to parse them directly to numbers using ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'parseFloat',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        '. If we can, we return them as-is; if we cannot, we surface an error to the user.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'CODE EXAMPLE',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-4'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7CXFcachjfVnqkCk5j2ZZJ',
                type: 'Entry',
                createdAt: '2022-12-21T19:40:43.650Z',
                updatedAt: '2022-12-21T19:40:43.650Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Cast Field Hook Function Example > Loans',
                language: 'typescript',
                code: '```const Loans = new Sheet("Loans", {\n  rate: NumberField({\n    label: "Rate",\n    cast: (val) => {\n      // Cast the value to a string and get rid of whitespace\n      const stringVal = String(val).trim();\n      let stringNumericalVal;\n      let multiplier;\n      // Check for empty values\n      if (stringVal === "null" || stringVal === "undefined" || stringVal.length === 0) {\n        return null;\n      }\n      // Check if the number is written as a percentage\n      if (stringVal.charAt(stringVal.length - 1) === "%") {\n        stringNumericalVal = stringVal.substring(stringVal.length - 1);\n        multiplier = 0.01;\n      } else {\n        stringNumericalVal = stringVal;\n        multiplier = 1;\n      }\n      // Try to parse the remaining string as a number\n      let numericalVal = parseFloat(stringNumericalVal);\n      if (isNaN(numericalVal)) {\n        throw new Error(`\'${val}\' could not be parsed as a number or percentage.`);\n      } else {\n        return numericalVal * multiplier;\n      }\n    },\n  }),\n});```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Additional details',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'cast',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' is present on every field. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'cast',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' converts the initial user-inputted data to the correct type needed for that field so it can be processed. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: "Each of Flatfile's basic ",
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://docs.flatfile.com/docs/guides/workbooks/#field-types'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'field types',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' comes prebuilt with a default ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'cast',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' hook, except for ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'OptionField',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' and ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'LinkedField',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'When ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'cast',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' cannot parse an incoming value, it will display an error message in the UI and retain the original value so users can edit that value. When ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'cast',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' receives ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'null',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' or ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'undefined',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', it returns ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'null',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '. In both cases, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'compute',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'validate',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' are not called. More on ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'compute',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'validate',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' soon.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the docs to learn more about ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://docs.flatfile.com/docs/guides/data-hooks/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'processing data with Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started not with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://docs.flatfile.com/docs/get-started/quickstart/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'CLI Quickstart',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4vn5oLlZGi5YjD9vPJC28g',
    postTitle: 'The bridge between big whales and the danger zone.',
    seoTitle: 'The bridge between big whales and the danger zone.',
    seoUrlSlug: 'the-bridge-between-big-whales-and-the-danger-zone',
    seoMetaDescription:
      "There's a critical period in the life of many software as a service (SaaS) providers - and that's when there’s a LOT of data coming from your new customer that has to get into your system.",
    category: 'Data exchange',
    tags: ['data onboarding', 'data exchange'],
    publishDate: '2022-12-07T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'x68MhApNMGMLOv14hDa32',
        type: 'Asset',
        createdAt: '2022-12-07T17:00:05.947Z',
        updatedAt: '2022-12-07T17:00:05.947Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Great Whale',
        description: '',
        file: {
          url: '/img/contentful/x68MhApN-great_whale.webp',
          details: {
            size: 1366691,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'great whale.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'a great whale image',
    summary:
      "There's a critical period in the life of many software as a service (SaaS) providers - and that's when there’s a LOT of data coming from your new customer that has to get into your system. And it’s not at all clean.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Imagine that your cloud-based app is a runaway success. Word has gotten around and the orders are coming in. You finally land that great whale of a corporate customer that you’ve dreamed about. You’ve signed the contract and now everyone's all LFG!",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your next step? To integrate your customer’s data into your own system.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But wait: there’s a LOT of data. And it’s not at all clean.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In fact, it’s',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: ' inexpressibly',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'filthy',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'verminous',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This scenario is very real. It\'s a critical period in the life of many software as a service (SaaS) providers. We call this period the “danger zone." (',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'cue the infamous Top Gun intro scene, but also not really',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ')',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The danger zone is that crucial moment in every business deal that follows the handshake and the signing of documents. It is that time when the executives leave the room and the data managers are left to make the exchange happen. It’s when the rubber meets the road.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The bad news is, time flies',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You may have the greatest app to hit the market, but if you can’t get your customer data loaded into it quickly, that won’t make much of a difference. When milestones are missed, deals are broken and business is lost.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From the moment you sign a contract with a new customer you want to prove to them that they made the right choice when they chose to work with you. You want to get them up and running fast and without hiccups so that they can see how beneficial your solution is, how much time and money you will save them. And that means integrating your customer’s data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The truth is that there is no universal standard for how data is organized. Most companies build their databases using generally-agreed-upon best practices, but without the foresight to think they will need to share that data en masse with another organization. Typically, each data store is its own entity, abiding by its own rules. When it comes time to put this data into a report or use it in another system, they export it. Usually these exports are small subsets of the database that are intended to be used to analyze a specific time frame or a narrow context, say, a sales report or a quarterly market projection. They are typically downloaded as comma separated values (.csv) files, shared, and then manually imported, requiring that each row and column be checked for erroneous and missing data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: "The good news is, you're the pilot",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the SaaS onboarding process, businesses are generally sharing much more than a quarterly sales report. It can amount to thousands and thousands of rows of data. Cleaning this data so that it will integrate properly with another system is a process that can—and often does—take weeks or months to accomplish. And all along, your big whale of a customer is just waiting . . . and  waiting.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' was built to solve this very problem.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our founders were tasked with importing a lot of data, and they knew that their frustrations were shared by businesses everywhere. So, they created a universal data exchange platform that works for any business.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The simplicity of Flatfile’s design means that it solves the data exchange conundrum for businesses large and small, for web applications, Internet of Things (IoT) manufacturers, mobile apps, and enterprise management systems. It does its job quickly and efficiently, and it even gets better at it every time it is used.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "If you are in the process of landing new business, getting your data to its new home quickly and securely simply is a must to ensure your next great whale won't get away.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Remember boys, no points for second place.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '-Goose',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' aka ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/ashley-gayle-mulligan?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAA0qWnMBWqIF56fLujvFC8j6YOEW1ci87OA'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Ashley Mulligan',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'sometimes engineer and sometimes marketer',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/company/flatfile/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '73x5lCBEY5QUOlpTJxSfrq',
    postTitle:
      'The first mile of data: Scalable data onboarding for developers',
    seoTitle:
      'Upcoming live webinar: The first mile of data: Scalable data onboarding for developers',
    seoUrlSlug:
      'the-first-mile-of-data-scalable-data-onboarding-for-developers',
    seoMetaDescription:
      'What dev teams need to consider to onboard csv, xls, pdf and other “human in the middle” data.',
    category: 'Product updates & features',
    tags: ['webinar'],
    publishDate: '2022-12-03T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1hARhGKCrOjZlFlhlyDxAK',
        type: 'Asset',
        createdAt: '2022-12-05T16:43:21.513Z',
        updatedAt: '2022-12-05T16:43:21.513Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Webinar Image',
        description: '',
        file: {
          url: '/img/contentful/1hARhGKC-frame_5__4_.webp',
          details: {
            size: 441239,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 5 (4).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'ashley and eric image for webinar',
    summary:
      'Join us December 15th for a free live webinar and hear Eric Crane and Ashley Mulligan of Flatile discuss what dev teams need to consider to get a handle on the Wild West of Data, where rules and best practices are shot from the hip.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3g8UtF3xqMDeJcwD9zabc5',
        type: 'Entry',
        createdAt: '2022-12-05T16:44:02.752Z',
        updatedAt: '2022-12-05T16:44:02.752Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Noelle Festa',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6pb3PzTTNmEL9U8H4YaJBH',
            type: 'Asset',
            createdAt: '2022-12-05T16:42:27.684Z',
            updatedAt: '2022-12-05T16:42:27.684Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Noelle Headshot',
            description: '',
            file: {
              url: '/img/contentful/6pb3PzTT-t0ap8ur47-u03ea82my2u-d9a5ad607b89-512.webp',
              details: {
                size: 54407,
                image: {
                  width: 512,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U03EA82MY2U-d9a5ad607b89-512.jpeg',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Unprecedented volumes of data — customer data, product data, statistics, financials — are being shared between organizations every day in the form of “flat files.” But how do you guarantee secure and accurate transfer of data when the foundation is as primitive as a CSV?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Wild West of Data is a place where sometimes the first name comes first and sometimes it comes last; where US postal codes may comprise 5 digits or 9 digits depending on who entered the data; where dimensions may be documented in metric or imperial units; and where the order and names of each of these columns may be spelled, designated and formatted in any number of perfectly legal and acceptable, yet maddeningly differing ways.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.zoom.us/webinar/register/WN_ODSCGb8lQSKVF0a2FNTQyA?utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz--UzmoXZ7FGWH8nL5zFU4zxRrcxvFCC6wLsosEO87E_RkZoZDKie0T0VCJ1QxBPmlAyjvmY'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Join us',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' on December 15th at 1pm EST for a free webinar and hear Eric Crane and Ashley Mulligan of Flatile discuss what dev teams need to consider to get a handle on the Wild West of Data, where rules and best practices are shot from the hip.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After more than a decade of experience across enterprise software, early stage startups, and scaling businesses, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Eric Crane ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                "co-founded Flatfile with David Boskovic to solve the ubiquitous challenge of conducting a data transaction with a human in the loop. Flatfile has since enabled more than 1 million data onboardings across dozens of industry segments under Eric's leadership making him an undeniable expert in this space.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    '"Ask any developer and they will tell you: making heads or tails of flat files can take weeks or months — and that\'s before you even get to start working with the data."\n\n- Ashley Mulligan',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In her role as both an Engineer and Head of Product Marketing, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Ashley Mulligan ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'understands that while the customer experience evolves over the course of product ownership, it is often the first mile of that journey that sets the tone for how a product will be used.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7mOnSygPEiYFq0xclnQxha',
                type: 'Entry',
                createdAt: '2022-12-05T16:48:50.711Z',
                updatedAt: '2022-12-05T16:50:03.187Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 16,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'December 15th at 1pm EST',
                text: 'Join us and learn why data onboarding is mission critical, what’s often forgotten during planning, and how to handle the data that you can’t plan for',
                ctaText: 'Save your seat',
                href: 'https://flatfile.zoom.us/webinar/register/WN_ODSCGb8lQSKVF0a2FNTQyA?utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz--UzmoXZ7FGWH8nL5zFU4zxRrcxvFCC6wLsosEO87E_RkZoZDKie0T0VCJ1QxBPmlAyjvmY',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7J9BZFhXUNgv4L6YshH1Vv',
    postTitle:
      'The one-two punch that will energize the future of data exchange',
    seoTitle:
      'The volume of information being added to the global datasphere remains at a constant upward trend',
    seoUrlSlug:
      'the-one-two-punch-that-will-energize-the-future-of-data-exchange',
    seoMetaDescription:
      'Together, AI and ML provide the one-two punch that will energize the future of data exchange and data sharing.',
    category: 'Data exchange',
    tags: ['data exchange'],
    publishDate: '2022-11-25T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4nOy5BKlb4ugTmaLFjX7Zf',
        type: 'Asset',
        createdAt: '2022-11-28T15:06:14.505Z',
        updatedAt: '2022-11-28T15:06:14.505Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'AI image ',
        description: '',
        file: {
          url: '/img/contentful/4nOy5BKl-frame_4__4_.webp',
          details: {
            size: 869422,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 4 (4).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'AI image of a person',
    summary:
      'Let’s face it: big data is a living beast with some serious boundary issues.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Let’s face it: big data is a living beast with some serious boundary issues. Economic figures may ebb and flow, but the volume of information being added to the global datasphere remains at a constant upward trend. As it continues to accumulate in mass, we have to get creative with how we store, process, and share it. If we don’t, before long we might be looking at a future that is reminiscent of a scene from the 1958 Sci-Fi classic “The Blob.” Except . . .  you know . . . with data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.bcg.com/publications/2021/broad-data-sharing-models'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'report',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' on the future of data sharing by Boston Consulting Group (BCG) envisions a scenario where data is primarily stored not in proprietary systems controlled by disparate private entities, but in a federated cloud-based system, to be accessed as needed across unlimited vertical industries and use cases. This vision of federated data offers the possibility for faster access and greater availability. But it also comes with its own bag of headaches. How do we ensure that this data is secure and how do we provide approved access to it? Assuring that your data exchange solution ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/security/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'meets all applicable security standards',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is essential if you are going to collaborate with other businesses.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'AI leads the way',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There is no denying that the big data management situation is only getting more complex and that what is needed now is a way to simplify, expedite, and secure the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data exchange process',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. This is not the time for isolated systems that meet the needs of a single customer, a single use case, but for a universal data management platform, an agnostic global solution to the big data problem that can identify, access, reformat, and securely transfer data from one application to another. It is a solution that will rely heavily on artificial intelligence (AI) to process the data quickly and machine learning (ML) to adapt to new scenarios going forward.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'AI uses algorithms to make decisions based on the data it encounters. An AI-equipped data exchange platform is going to understand how to process, manage, format, and share it. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'ML is a subset of AI that describes the ability to learn new ways of processing data based on previous AI encounters and on-the-fly decisions made with human assistance. This “human in the loop” scenario is an important aspect of machine learning that enables optimization of the system based on new rules and knowledge. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Together, AI and ML provide the one-two punch that will energize the future of data exchange and data sharing.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'A bright, not-so-distant future',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://pubmed.ncbi.nlm.nih.gov/36214629/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'recent article',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' by published in the Journal of American Medical Informatics Association touts a study of the potential of federated learning — a technique where multiple parties collaboratively train AI models using shared, disparate data sets — and suggests that federated learning models can have benefits over traditional methods, including enhanced image and text analysis and decreased time-to-market. This study, while narrow in its practical scope, has implications for the greater business world, looking forward to a time when broader distribution of data access will lead to more thorough, comprehensive analysis. Provided the industry sets a strong foundation for security, such a framework could usher in exponential growth in data processing and analysis.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the short term, however, far too many businesses are still stuck in the dark ages of downloading comma separated values (.csv) files, scrubbing them by hand, and uploading them to Internet of Things (IoT) and software as a service (SaaS) platforms to keep our ever-data-obsessed world running.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s the data exchange equivalent of hitting your space bar twice after each sentence.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Or keeping your data files on a 3.5 inch floppy disk.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Or worse yet, trying to outrun The Blob.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Goodness gracious, you can get by without ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. But why even try?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2cYhq2XV0NVsEtuwiaYds3',
    postTitle: 'Quickly get started with the new CLI Quickstart',
    seoTitle: "Quickly get started with Flatfile's new CLI Quickstart",
    seoUrlSlug: 'quickly-get-started-with-the-new-cli-quickstart',
    seoMetaDescription:
      'With the new platform SDK, you can now deploy a proof of concept in less than 5 minutes and begin adding fields relevant to your use case, all from your terminal.',
    category: 'Product updates & features',
    tags: ['developers', 'Featured'],
    publishDate: '2022-11-18T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'g48TAuQq65XbUwIjzIMdx',
        type: 'Asset',
        createdAt: '2022-11-21T14:58:46.666Z',
        updatedAt: '2022-11-21T15:10:57.330Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'npx flatfile init',
        description: '',
        file: {
          url: '/img/contentful/g48TAuQq-frame_3__8_.webp',
          details: {
            size: 67726,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 3 (8).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'code example',
    summary:
      'We recently re-architected our system for developers - finally, you can manage Templates, and more in code. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'We recently re-architected our system for developers ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '- finally, you can manage Templates, and more in code. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'A new SDK: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'All the tools, libraries, & tests you need, written from the ground up.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Git-based configs',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': Skip the dashboard. Configure and deploy directly from your code.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Typescript',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': With fewer runtime errors, reason about data in a more sane way.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Refreshed Docs',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': Migrate to the developer config, as quick and painless as possible.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Data Hooks',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ": Easily write logic right where you're building - no more GUIs.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Environments',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': Test and deploy with different environments from...you guessed it, code',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5WpX2paPajs4edXjv6oiVm',
                type: 'Asset',
                createdAt: '2022-11-21T14:47:57.514Z',
                updatedAt: '2022-11-21T14:47:57.514Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'New CLI Quickstart',
                description: '',
                file: {
                  url: '/img/contentful/5WpX2paP-frame_2__6_.webp',
                  details: {
                    size: 141758,
                    image: {
                      width: 998,
                      height: 973
                    }
                  },
                  fileName: 'Frame 2 (6).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Getting started with the new CLI Quickstart',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'With the new platform SDK, you can ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://docs.flatfile.com/docs/get-started/quickstart/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'deploy a proof of concept',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' in less than 5 minutes and begin adding fields relevant to your use case, all from your terminal.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'INITIALIZE A PROJECT',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-6'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5ITXMvcuP3lOrt6nGnTkDL',
                type: 'Entry',
                createdAt: '2022-11-21T14:48:41.164Z',
                updatedAt: '2022-11-21T15:06:08.430Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                language: 'bash',
                code: '```npx flatfile init```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Want the full kitchen sink? ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: 'We got you.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Deploy one of our new ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://docs.flatfile.com/docs/get-started/examples/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Starter Templates',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and work backwards from a more comprehensive example.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'PUBLISH EXAMPLE WORKBOOK',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-6'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1P043rPZy5tuPtaDNHf7Jf',
                type: 'Entry',
                createdAt: '2022-11-21T14:49:54.124Z',
                updatedAt: '2022-11-21T19:48:26.868Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                language: 'bash',
                code: '```npx flatfile publish ./examples/workbooks/FullExample.ts```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6XMgq9Q0sMYhlBDUtBX1oH',
    postTitle: 'Data stuck in place can’t grease the wheels of fortune.',
    seoTitle: 'Data stuck in place can’t grease the wheels of fortune.',
    seoUrlSlug: 'data-stuck-in-place-cant-grease-the-wheels-of-fortune',
    seoMetaDescription:
      'Gartner predicts that “by 2023, organizations that promote data sharing will outperform their peers on most business value metrics.” (Gartner, 2021)',
    category: 'Data exchange',
    tags: ['data exchange'],
    publishDate: '2022-11-17T00:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3S89WsLL46LtTe2ThN7yRN',
        type: 'Asset',
        createdAt: '2022-11-21T14:39:00.872Z',
        updatedAt: '2022-11-21T14:39:55.267Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Pink Bike',
        description: '',
        file: {
          url: '/img/contentful/3S89WsLL-frame_2__8_.webp',
          details: {
            size: 2268342,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 2 (8).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'A pink bike',
    summary:
      'When data is stuck in place, it can’t grease the wheels of fortune. That’s why we need to consider how we exchange data. \n',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It is hard to think of any part of modern business that can’t be improved with the help of data. That’s because it helps us understand the connected world around us. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But data simply stored in a database is stifling its ability to generate value.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'It is only through the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'sharing',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' of data that it becomes a live, viable commodity. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data exchange is quickly becoming a determining factor in overall business success. Gartner predicts that “by 2023, organizations that promote data sharing will outperform their peers on most business value metrics.” (',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.gartner.com/smarterwithgartner/data-sharing-is-a-business-necessity-to-accelerate-digital-business'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Gartner, 2021',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ')',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Data gets us going',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'retail',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', data fuels the engine of commerce from the supply chain to the point of sale. It is behind every search result on an online store, every catalog order, and every purchase confirmation. It not only informs the consumer of the latest products to hit the market, but helps the business serve up the most suitable offers to their customers, resulting in boosted sales and an enhanced customer experience.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'healthcare',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' sector, doctors and nurses collect data about our physical health. These highly sensitive records need to be shared between departments, specialists, insurance companies, and researchers. It also needs to be secured to protect the privacy of patients. Anonymizing that data can make it a valuable tool for public health without compromising the privacy of the individual.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data provides institutional ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'scientists and researchers',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' the information they need to take action to save lives, to understand our changing environment, and to explore space.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It is the prime mover of business, the economy, and the world.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When viewed in this way, data can be a source of great promise.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Get unstuck',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In nearly all sectors from manufacturing to hospitality, data is exchanged to enable better products, better services, and to analyze performance to identify new growth opportunities.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Every day, huge files are being moved between business partners, including the transfer of payment records to lending institutions, supply-chain updates from manufacturers, and local traffic and weather data to guide transportation and logistics companies.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These organizations are dynamic entities designed to grow through innovation, disruption, and fast maneuvering.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Anything that can give them an edge is going to put them in a position to outpace the competition.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'But when data is stuck in place, it can’t grease the wheels of fortune.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'That’s why we need to consider how we exchange data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "And that's why ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/get-started'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'you need Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4V6gl2MqFpl1cKcIVwXBk0',
    postTitle: 'Now more than ever, time is money',
    seoTitle: 'Now more than ever, time is money',
    seoUrlSlug: 'now-more-than-ever-time-is-money',
    seoMetaDescription:
      'With a gloomy and uncertain economic outlook, top-down directives all look about the same: find new ways to save money.',
    category: 'Data exchange',
    tags: ['data exchange', 'thought leadership'],
    publishDate: '2022-11-01T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4YPgk6Z1Har0Er0hsnnSqE',
        type: 'Asset',
        createdAt: '2022-11-01T18:44:09.092Z',
        updatedAt: '2022-11-01T18:50:41.350Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Ben Franklin Image',
        description: '',
        file: {
          url: '/img/contentful/4YPgk6Z1-frame_1947__1_.webp',
          details: {
            size: 5055597,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 1947 (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Image of Ben Franklin',
    summary:
      'With a gloomy and uncertain economic outlook, top-down directives all look about the same: find new ways to save money. How can tech companies save money while maintaining quality standards and increasing revenue to meet shareholder demands? The answer is right in front of you.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The International Monetary Fund (IMF) describes the global economic outlook as ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.imf.org/en/Publications/WEO/Issues/2022/07/26/world-economic-outlook-update-july-2022'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '"gloomy and uncertain,"',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' ushering in a multitude of top-down directives from corporate leadership, all with the same objective: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'find new ways to save money',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As tech companies tighten their belts and reduce headcount while growth targets and customer demands stay the same, words from a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://en.wikipedia.org/wiki/Time_is_money_(aphorism)'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'famous statesman, scientist, and philosopher',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' live rent free in my head: "Remember that time is money".',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'If time is money, then you can ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'buy time',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'increase revenue',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' by tackling the challenge of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', a critical business process that is universally arduous and time consuming, causing delayed customer go-lives, cost overruns, and even lost clients.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The time suck',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Imagine a distributor acquires a new business partner and needs to integrate thousands of rows of product data with its own platform. Or a SaaS (Software as a Service) provider that needs to populate its new cloud application with offline customer data. Or an insurance provider that needs to import employee data to provide benefits packages. All of these situations will require data exchange, a process that can take thousands of hours to complete at significant cost. This tedious process can delay product and service launches, or worse — result in lost opportunities altogether.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Historically, companies have chosen to solve this problem by ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'building their own data import solutions',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. But the time and resources required to build, update, and support custom software applications only adds to the burden on a business’s resources.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Buying more time',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data exchange, whether for its relative invisibility or its seeming lack of sparkle, fails to garner the attention it deserves. But make no mistake: in a business environment where data collection is the new analog to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www2.deloitte.com/global/en/pages/real-estate/articles/future-real-estate-data-new-gold.html'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'the gold rush',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', businesses are reconsidering how they think about the time and money they spend on this process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'SaaS, cloud computing, the Internet of Things (IoT): all of these would be nothing without the data they run on. To that end, businesses are acquiring and sharing data at unprecedented levels. Yet, as the technology behind cars, vacuum cleaners, and media streams is updated regularly, the data that empowers these devices and services are still exchanged in a format that predates personal computers by a decade: CSV (comma separated values) files. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "That's right — ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'the "new gold" is exchanged in flat files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From newly minted online shops that need to upload a product catalog to distributors and multinational consulting firms sharing highly sensitive business financials with a client, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/get-started'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' takes the toil out of data preparation to accelerate time-to-value and increase productivity, all while adhering to the highest international standards for secure data exchange.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'All of this leads to an extremely fast return on investment (as little as six months) and a continued savings over the life of the business. It has the promise to get businesses through economic downturns and sustain those savings in better times ahead.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4wVSq7JPIvf3WcDhXGLJia',
    postTitle: '5 questions with Lisa Mahapatra, Product Designer at Flatfile',
    seoTitle: '5 Questions with Lisa Mahapatra, Product Designer at Flatfile',
    seoUrlSlug: '5-questions-with-lisa-mahapatra-product-designer-at-flatfile',
    seoMetaDescription:
      "We're excited to introduce you to Lisa Mahapatra! Lisa is a Product Designer responsible for creating beautiful and engaging experiences for our customers.",
    category: 'Flatfile news',
    tags: ['5 questions', 'Employee spotlight', 'Product'],
    publishDate: '2022-10-12T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6xFGyiF0k3uEg1BbnYRxXz',
        type: 'Asset',
        createdAt: '2022-10-12T14:46:02.300Z',
        updatedAt: '2022-10-12T15:06:26.676Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: '5 questions with Lisa Mahapatra',
        description: '5 questions with Lisa Mahapatra',
        file: {
          url: '/img/contentful/6xFGyiF0-5_questions_with..._lisa_v2.webp',
          details: {
            size: 517214,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '5 Questions With... Lisa v2.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Flatfile introduces you to Product Designer, Lisa Mahapatra',
    summary:
      "We're excited to introduce you to Lisa Mahapatra! Lisa is a Product Designer responsible for creating beautiful and engaging experiences for our customers.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4fDBpQgo1rUtsr5NOqqrfz',
        type: 'Entry',
        createdAt: '2022-10-12T15:04:14.863Z',
        updatedAt: '2022-10-12T15:04:14.863Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Josh Marks',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7HbxwAWRvgC44dyAieKPJQ',
            type: 'Asset',
            createdAt: '2022-02-25T14:59:01.085Z',
            updatedAt: '2022-02-25T14:59:01.085Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Josh Marks headshot',
            description: 'Josh Marks headshot',
            file: {
              url: '/img/contentful/7HbxwAWR-unnamed.webp',
              details: {
                size: 7907,
                image: {
                  width: 170,
                  height: 170
                }
              },
              fileName: 'unnamed.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'People Ops'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We're excited to introduce you to Lisa Mahapatra! Lisa is a Product Designer responsible for creating beautiful and engaging experiences for our customers.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s learn more about Lisa!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q: Why Flatfile? (And what do you do here?) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A: As a Product Designer, I figure out what the product should do and how it should look. Right now, I'm working on the more functional aspects of product design, specifically data tables. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I tweeted that I was looking for a company that wanted a designer obsessed with data tables. David (Boskovic), ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '’s CEO, messaged me an hour later and now here I am!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The work I do here is really enjoyable, and I love the extreme ownership. Flatfile lets me design ridiculously complex tables, and I have a high degree of autonomy and trust. Being able to define what you want to work on while having the trust of your colleagues is incredible; there is no going back from that.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "Q: We've heard you're obsessed with data visualization and data tables. What sparked your interest in this, and how does that impact your work at Flatfile?",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A:  I started my career as a journalist and realized very quickly that I like to take my time asking people questions, which doesn't particularly make for great impromptu interviews. I started thinking, ‘I like data and mathematics, so why don’t I just interview data sets?’ I ended up leaning toward data journalism.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "At some point, I was getting frustrated that everything I was making only had a concise shelf-life because data visualization is optimized for storytelling, and stories pass away; there's an expiry date. This ultimately pushed me into Product Design; I could use my data storytelling skills to build products with a much longer shelf-life that remained useful and valid.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "At my last job at Uber I built a table component for rich data analysis, and it ended up being one of the most internally used design components for internal tooling and for Uber Freight. I wanted to do more of that, and Flatfile is a place where I can. It's very new stuff I've never seen anywhere else.\n",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: How has your background as a journalist impacted your ability to tell stories using data?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A: The process of interviewing data gives me empathy for people trying to use data products, but I think it’s more than just journalism. I spend a lot of time trying to get insights out of data. One of the gaps I've often seen with other product designers trying to build data products is that they’ve never actually needed to ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'use data',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' for any reason. One of my constant arguments is: if less is more, think about how much more is more. It sounds like a joke, but it is true. When we’re interacting with the data interface, I want it to have really high information density. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: In an interview with Data Visualization Society, you talked about ‘Retrospective Visualization’; saying ‘you don’t know what insights are going to be, and you cannot guide anyone to those insights’. Now, with almost one year at Flatfile under your belt, if you could go back in time and tell Day-One-at-Flatfile-Lisa one thing to prepare her, what would it be?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: I would write a think piece on a persona Flatfile calls the data owner. It would be about the people uploading and interacting with their data. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "I had a lot of preconceived notions about how people like to interact with data, and I hadn't quite realized I was thinking solely about users with a high level of expertise. Working at Flatfile has been super interesting because I have to be able to traverse both extremes. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For example, there could be a nun who only ever uses a spreadsheet app to keep track of her congregants. She doesn't really care about statistics and she doesn't care about the things all expert users might care about. All she cares for is ensuring she’s not discluding any of her congregants from email blasts she might send out. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "It’s a fascinating puzzle: how do people who are not super familiar with data products interact with data? How do you intuitively communicate to a person who doesn't understand the concept of mapping values between two schemas? How do you share what you're doing to their data and how are you guiding them through this process correctly? ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Ultimately, for the casual data user, Flatfile is top of the class. That's why I believe in this product so much.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You’re famous around these parts for your ‘unique’ AMA questions. Please answer one of your own AMA questions: What is the optimal spot to be in, in a human pyramid, and why?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: The worst possible spot to be in is in the middle, because not only are you putting your weight on someone, somebody else is putting their weight on you; it seems really stressful. I would rather just be at the bottom and be strong.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "So, the optimal spot is the bottom-middle of a short pyramid. If you fall, you don't have far to go, and you just need good strength. You don't need much balance, which is good because I'm clumsy. If you put me on top of someone, I will feel stressed about putting my weight on another human being.  Plus, we're all inevitably falling over because I'm not actually that strong. But no one will blame me; they'll say, “Oh, you did an excellent job, you held it together for, like, 15 seconds!”",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "If you're interested in learning more about how to join Lisa here at Flatfile, check out our job openings on our ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'careers page',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3S4rRKfIvb2eaBXmn1Y9IG',
    postTitle:
      'Flatfile raises $50 Million Series B to streamline data exchange',
    seoTitle:
      'Flatfile raises $50 Million Series B to streamline data exchange',
    seoUrlSlug:
      'flatfile-raises-usd50-million-series-b-to-streamline-data-exchange',
    seoMetaDescription:
      'Flatfile raises $50 Million Series B to streamline data exchange',
    category: 'Flatfile news',
    tags: ['funding', 'series-b', 'announcements'],
    publishDate: '2022-10-05T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '23qd4KwpAPjy5C3ec4mVe2',
        type: 'Asset',
        createdAt: '2022-10-05T15:19:03.299Z',
        updatedAt: '2022-10-05T15:36:39.078Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 3,
        locale: 'en-US'
      },
      fields: {
        title: '50m Series B Funding',
        description: '',
        file: {
          url: '/img/contentful/23qd4Kwp-frame_10__2_.webp',
          details: {
            size: 61242,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 10 (2).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Series B Video ',
    summary:
      'I’m excited to share that we have secured a Series B round of funding to accelerate our product roadmap.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I’m excited to share that we have secured a Series B round of funding to accelerate our product roadmap.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Led by Tiger Global, the oversubscribed round received investor participation from ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.gradient.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Gradient Ventures',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.scalevp.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Scale Ventures',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://ventures.workday.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Workday Ventures',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.afore.vc/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Afore Capital',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://twosigmaventures.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Two Sigma Ventures',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', and also included angel investments from founding executives and leadership from ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://airtable.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Airtable',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.docusign.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'DocuSign',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://linkedin.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'LinkedIn',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.gainsight.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Gainsight',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1MqHDTYAuYy18mqwrzGfbQ',
                type: 'Entry',
                createdAt: '2022-10-05T15:02:21.093Z',
                updatedAt: '2022-10-05T16:10:18.340Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 10,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Series B Video',
                url: 'https://www.youtube.com/embed/s50JOPdLFDI?&autoplay=1&mute=0'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This round, which brings ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/about'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' total funding to nearly $100 million, enables us to accelerate the launch of our new developer platform, allowing our customers to leverage Flatfile against more of the data exchange challenges holding their growth back.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3H8JaEMyFHoqnVsT3Nmtgc',
                type: 'Entry',
                createdAt: '2021-08-13T21:47:28.744Z',
                updatedAt: '2022-10-06T16:32:50.231Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'Transform enterprise data onboarding from complex to simple with Flatfile’s data onboarding platform',
                ctaText: 'Learn more',
                href: '/get-started',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Launching in Q4, our new platform will enable each customer to design the ideal data exchange solution for their business. Developers will be able to build directly on top of Flatfile’s core data exchange platform components — import, match, merge, clean — and a powerful suite of 3rd party building blocks such as OCR data extraction.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5iopggYe5pN3KPOHwChzZa',
                type: 'Asset',
                createdAt: '2022-10-05T14:47:13.676Z',
                updatedAt: '2022-10-05T14:47:13.676Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Tiger Global Quote from John Curtius',
                description: '',
                file: {
                  url: '/img/contentful/5iopggYe-frame_1956__1_.webp',
                  details: {
                    size: 238843,
                    image: {
                      width: 1054,
                      height: 748
                    }
                  },
                  fileName: 'Frame 1956 (1).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is just the beginning of our journey to transform how data is exchanged and I can’t wait to see where it takes us.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Thank you and stay tuned. Exciting things are happening here!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7r1fSOyWZPpm2kqgP1ATWS',
                type: 'Asset',
                createdAt: '2022-09-27T14:30:56.705Z',
                updatedAt: '2022-09-27T14:33:00.486Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'David signature',
                description: '',
                file: {
                  url: '/img/contentful/7r1fSOyW-signature.webp',
                  details: {
                    size: 1644,
                    image: {
                      width: 200,
                      height: 48
                    }
                  },
                  fileName: 'signature.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'David, Founder & CEO, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2mONn1dFBVNAZr0IzFU7fa',
    postTitle: "Why I'm betting $100M in venture capital on the CSV",
    seoTitle:
      'A memo from Flatfile CEO, David Boskovic, on $50M Series B Funding Announcement',
    seoUrlSlug:
      'read-why-our-ceo-is-betting-usd100m-in-venture-capital-on-the-csv',
    seoMetaDescription:
      'At Flatfile, we created a new category with data onboarding, and have grown rapidly by powering the data import experiences for 500 customers including some of the largest SaaS companies in the world.',
    category: 'Flatfile news',
    tags: ['funding', 'series-b', 'announcements'],
    publishDate: '2022-09-27T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6uWGr2Kl3AsOPQNttomCkE',
        type: 'Asset',
        createdAt: '2022-09-27T14:28:53.085Z',
        updatedAt: '2022-09-27T14:28:53.085Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Series B Announcement Image',
        description: '',
        file: {
          url: '/img/contentful/6uWGr2Kl-blog_image.webp',
          details: {
            size: 90166,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog image.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Looking to the future',
    summary:
      'This morning we announced $50m in Series B funding led by John Curtius at Tiger Global Management, an unequivocal recognition of the hard work this team has poured into our product and our customers.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This morning we announced $50m in Series B funding led by John Curtius at Tiger Global Management, an unequivocal recognition of the hard work this team has poured into our product and our customers. In any market, this is a feat of growth. In this new economic environment, where the bar has heightened significantly for access to capital, I am filled with a truly humbling sense of gratefulness.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We do not take this vote of confidence for granted, especially the support of our existing investors doubling down on this vision: Scale Venture Partners, Two Sigma Ventures, Afore Capital, Gradient Ventures, Two Sigma Ventures, and Workday Ventures.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This company that Eric and I founded three years ago was built out of our personal frustration with the status quo. We had been forced, time and time again, to solve the data onboarding problem at different companies along our journey.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Some express their pain through music, others through art. At Flatfile, we expressed ours through a product.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Speaking with a reporter early in our journey, I went off script and explained how Flatfile was born during a long weekend of “rage designing”. This became the headline, and ever since then, this concept has become core to our ethos at Flatfile. Data exchange might be a boring problem to some, but for the team we’ve built at Flatfile this is a problem we own to our core.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Decades ago, Gordon Moore, the founder of Intel, predicted that the number of components in integrated circuits would double every couple of years. This became known as “Moore’s law.” For nearly half a century, it’s guided the semiconductor industry, which is responsible for every technological computing innovation, from the PC, to smart watches, to self-driving cars.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But what has always fascinated me about Moore’s law isn’t so much Gordon Moore’s incredible foresight. It’s that all of these innovations that we take for granted hinged on solving one small specific technological problem: the distance between transistors on a chip.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Hardware is built on silicon. Software is built on data. The key to unlocking and unblocking the coming decades of innovation hinges on the speed, ease, and accuracy of data exchange — the new Moore’s law.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Flatfile, we created a new category with data onboarding, and have grown rapidly by powering the data import experiences for 500 customers including some of the largest SaaS companies in the world. We now employ a team of nearly 100 people who work to support the thousands of developers on our platform, and with this funding we’re broadening our horizon to be able to support nearly every exchange of data in the world. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'I can’t wait for what’s next.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7r1fSOyWZPpm2kqgP1ATWS',
                type: 'Asset',
                createdAt: '2022-09-27T14:30:56.705Z',
                updatedAt: '2022-09-27T14:33:00.486Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'David signature',
                description: '',
                file: {
                  url: '/img/contentful/7r1fSOyW-signature.webp',
                  details: {
                    size: 1644,
                    image: {
                      width: 200,
                      height: 48
                    }
                  },
                  fileName: 'signature.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'David',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2qB6ce5eivkJNzEmpcCETB',
    postTitle: 'The evolution of the primitive API',
    seoTitle: 'The evolution of the Primitive API',
    seoUrlSlug: 'the-evolution-of-the-primitive-api',
    seoMetaDescription:
      'With the explosive growth of cloud computing and the SaaS business sector, unprecedented volumes of data — customer data, product data, financials — are being shared between companies every day.',
    category: 'Data exchange',
    tags: ['data onboarding', 'data exchange', 'API'],
    publishDate: '2022-09-09T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4VETk6apmzCMKB0gIVWvj8',
        type: 'Asset',
        createdAt: '2022-09-15T18:58:15.391Z',
        updatedAt: '2022-09-15T19:00:41.152Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'An illustration of a person',
        description: '',
        file: {
          url: '/img/contentful/4VETk6ap-frame_1__21_.webp',
          details: {
            size: 507657,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 1 (21).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'An illustration of a person thinking',
    summary:
      'With the explosive growth of cloud computing and SaaS, unprecedented volumes of data — customer data, product data, financials — are being shared between organizations every day. And while it would be great if there were a universal API that could guarantee secure and accurate transfer of data, the reality is much more primitive. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With the explosive growth of cloud computing and the Software as a Service (SaaS) business sector, unprecedented volumes of data — customer data, product data, statistics, financials — are being shared between organizations every day. And while it would be great if there were a universal API that could guarantee secure and accurate transfer of data, the reality is much more primitive. In a global market built upon powerful relational and object oriented database systems, the truth is that most of the data being shared between companies are CSV (comma-separated values) files. That’s right, the world literally and metaphorically runs on flat files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Taming the Wild West of data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Back when gold was the standard currency in the United States, the relative simplicity of that precious metal presented some unique problems. First and foremost, gold is heavy and difficult to transport securely, which made it a favorite target of bandits in the Wild West. Flat files are much like the gold of that era — highly valuable to businesses and difficult to secure. Still, flat files remain the de facto standard in the Wild West of data sharing because they take up little space and are platform agnostic. But there is no standard for how we structure the data in those files and how they’re passed back and forth. That is ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'left up to the people who manage them',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’ve ever had to head up a project to wrangle data from a new business partner, you know what a chore it is to prepare it for importing into your own database. Does the first row include header information? What is the correct date format? How many digits should postal codes be? These are among the easier questions to answer. Then you have to manage data that could be rendered useless or break your system if it is not in the correct format. And this is data that is mission critical to the functionality of your applications, populates your e-commerce platforms and can ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'make the difference between profit and loss',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Faced with this problem, many businesses are forced to build their own solution to import CSV files, filter the data, flag anomalies, and correct the information. At first glance, this might seem to be an economical choice that gives you the most control over the finished product and frees up a few people from their data wrangling side job. But, turns out - custom solutions introduce their own set of difficulties. In fact, with CSV import specifically, it is a decision that could cost you more in the long run. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The hidden costs of building a CSV importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A new product or feature assumes a commitment to supporting and maintaining it throughout its life cycle. The upkeep of these products typically becomes the responsibility of the team that created them - at least until they turnover anyway. Building a CSV importer is exactly that - a long-term commitment to another product, and one that is almost guaranteed to prove a distraction from your core business function. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Add another client with a different display language, and now you need to rebuild your importer. Acquire a client with massive data files? Now your importer can’t keep up. Does your client have customers in Ireland? Now you have to figure out how to add GDPR into your importer. In short, making a flawless, scalable data onboarding solution is not as simple as it looks. (Trust us, we know.) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Remember: as far as ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' goes, it is still the Wild West out there and there is no guarantee that what is built will work for your next use case. That next upload? Well, it will probably include data of an entirely different sort, requiring you to — yet again — update your solution. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6oRfAlwTT8MXmpZidW9P6Z',
    postTitle: 'Taming the Wild West of data',
    seoTitle: 'Taming the Wild West of Data',
    seoUrlSlug: 'taming-the-wild-west-of-data',
    seoMetaDescription:
      'While understanding the nature of a CSV file is fairly easy, from this simplicity comes a world of confusion. ',
    category: 'Data exchange',
    tags: ['data exchange'],
    publishDate: '2022-08-23T10:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3V2V1cN57TUBrygOJOs8h8',
        type: 'Asset',
        createdAt: '2022-08-23T16:54:28.130Z',
        updatedAt: '2022-08-23T16:54:28.130Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Girl in Wild West Riding Horse',
        description: '',
        file: {
          url: '/img/contentful/3V2V1cN5-frame_1922.webp',
          details: {
            size: 1044208,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 1922.jpg',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText: 'Girl in Wild West riding horses',
    summary:
      'The Wild West of Data is a place where sometimes the first name comes first and sometimes it comes last; where dimensions may be documented in metric or imperial units; and where the order and names of each of these columns may be spelled, designated and formatted in any number of perfectly legal and acceptable, yet maddingly differing ways. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The world is increasingly data driven. From multinational companies with complex supply chain management (SCM) systems to regional hospitals storing sensitive patient data, global organizations large and small rely on data to keep them going.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Most of the databases that support these organizations are built and maintained by talented administrators who understand the particular needs of the organization, and can design a table structure that accommodates all the necessary security and efficiency requirements. But therein lies the root of a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'particularly nasty problem',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. These systems, for the most part, are not interconnected, nor are they built using the same structure. The result is an environment where the most coveted commodity (information) is being stored without a set standard for how it is structured. It is a Wild West of Data, where rules and best practices are shot from the hip. ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'But there’s a new sheriff in town — and their name is Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If all this data were to just stay put, we wouldn’t have much of a problem. But when companies acquire new customers, merge with other businesses or align themselves with a business partner, they need to share data. When it comes time to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'exchange that data',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', they need to export it into a file format that is reliable, universally accessible, and fast. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Developed in the age of mainframe computing, a decade before the first personal computers, the comma-separated value (CSV) file format has been the “chosen one” for this very purpose.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The anatomy of a CSV file',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Behold the humble comma. Who would have thought that this tiny mark could be the sole arbiter of where a data point begins and ends. To those of us who work with flat files, however, these marks, or more precisely, what lies between them, is the well from which we drink.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Creating a CSV file is as simple as entering data into a text file using commas to offset your data points and then saving the file with the “.csv” extension. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Here is an example of what the contents of a CSV file might look like:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value:
                'Last Name,First Name,Full Name,Birthday\nJones,William,William Jones,09-13-1954\nJones,Nancy,Nancy Jones,10-30-1998\nHadad,Sophie,Sophie Hadad,02-22-1991\nLevitt,Frank,Frank Levitt,05-11-2004',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Figure 1. Sample Contents of a CSV file\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is nothing more than a simple list of names and birthdates. The first line of the file represents the first row of the data, which may or may not be designated to hold header information. In the example above, the first line is indeed a header row that tells us what type of information is stored in each column: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'Last Name, First Name, Full Name, and Birthday',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', respectively.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Any information following the header row represents the contents of each column and row in the data table. So, if the header row already occupies the first row, then the first line of actual data is going be displayed in a spreadsheet as follows:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value:
                '[Row 2: Column A],[Row 2: Column B],[Row 2: Column C], and so on.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As you can see from Figure 1, there are no spaces between data points unless the space is explicitly part of the data, such as in the header designations “Last Name” and “First Name”, and all of the data in Column 3 (“Full Name”).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What you might also notice about a flat file is what it doesn’t have. There are no table borders, there are no visible columns or cells, there are no mechanisms to sort the information, etc. And if you imagine Figure 1 extended to include hundreds of columns and rows, you can soon understand just how daunting a CSV flat file can get when operating at the enterprise level.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Once you learn to recognize a flat file, its structure is straightforward. But reading one with the naked eye is a recipe for fatigue. And for this reason, we build user interfaces (UIs) to help us sort and present the data in a readable format or even in a visualized representation such as a chart or graph.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'There is no roadmap to CSV Formatting',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While understanding the nature of a CSV file is fairly easy, from this simplicity comes a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'world of confusion',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. The Wild West of Data is a place where sometimes the first name comes first and sometimes it comes last; where US postal codes may comprise 5 digits or 9 digits depending on who entered the data; where dimensions may be documented in metric or imperial units; and where the order and names of each of these columns may be spelled, designated and formatted in any number of perfectly legal and acceptable, yet maddingly differing ways. Ask any data manager and they will tell you: Making heads or tails of flat files can take weeks or months before you even get to start working with the data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That delay means that new customers cannot be contacted, new products cannot be sold, new research cannot be applied, and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'new business cannot be accounted for',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' — all because you are waiting for your flat files to be cleaned and imported.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The answer is simple',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile was established by people who had finally pulled enough of their own hair out trying to ride the bronco that is the Wild West of Data. Flatfile was created to solve the problem of preparing data to be exchanged and allowing work to progress quickly, efficiently, and securely. Flatfile enables you to move thousands of data records with lightning speed, time and time again. It achieves this by creating templates that can be infinitely customized to match the structure of any CSV file you might encounter and then reused the next time you need to exchange data between the same sources. Templates can also be easily modified to accommodate revisions in data structure, ensuring that your data will always be in proper order. More than just templates, however, Flatfile is an intelligent technology platform that guides you through the process of cleaning your data. It quickly identifies anomalies, errors, inconsistencies, and missing data and works to solve the problems associated with data exchanges at enterprise scale.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile isn’t an app, it isn’t a service and it isn’t an importer. It is a fully customizable engine for data exchange that you can use in-house, in the cloud, and share with your business partners. You can build our technology directly into your own applications using the Flatfile API or send your partners a simple link to a front end portal that will guide them through sharing their data with you. We’ve unleashed the underlying technology of Flatfile to make it available to any business anywhere in the world.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But all of this superlative talk means nothing until you see Flatfile in action. The short version of this story is that we set out to create a game-changer in data exchange and we are convinced that we have succeeded. Why not take a look yourself and see if you agree?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6lmf7mx647bUqY4PTzI4SC',
    postTitle: "Add a little confetti to your customer's day",
    seoTitle: 'These improvements to our CSV importer are 🔥',
    seoUrlSlug: 'add-a-little-confetti-to-your-customers-day',
    seoMetaDescription:
      'Users can now more clearly see the progress of their upload at all times, and any rejections from your system can now be displayed.',
    category: 'Product updates & features',
    tags: ['portal'],
    publishDate: '2022-07-15T00:00-04:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '57pBbRGe9qpLjxOM003NNH',
        type: 'Asset',
        createdAt: '2022-07-15T14:36:23.326Z',
        updatedAt: '2022-07-15T14:36:23.326Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Celebration State',
        description: '',
        file: {
          url: '/img/contentful/57pBbRGe-1920_x_1083__3_.webp',
          details: {
            size: 193757,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '1920 x 1083 (3).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Celebration end state of file importer experience',
    summary:
      'With our latest updates, users can now more clearly see the progress of their upload at all times, and any rejections from your system can now be displayed.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4Pn9Gux4aUZG6icugtbtGu',
        type: 'Entry',
        createdAt: '2021-10-28T15:26:17.467Z',
        updatedAt: '2021-10-28T15:26:17.467Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Tara Garnett',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '66pLjTYY9HrlOtDpMtMC7O',
            type: 'Asset',
            createdAt: '2021-10-28T15:25:45.013Z',
            updatedAt: '2021-10-28T15:25:45.013Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Tara Garnett headshot',
            description: 'Tara Garnett headshot',
            file: {
              url: '/img/contentful/66pLjTYY-t0ap8ur47-u02h5ku2eg0-5b5d54a346f3-512.webp',
              details: {
                size: 443899,
                image: {
                  width: 455,
                  height: 512
                }
              },
              fileName: 'T0AP8UR47-U02H5KU2EG0-5b5d54a346f3-512',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Product Manager',
        department: 'Product'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A roundup of recent Flatfile improvements to ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'your',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: " customer's import experience",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Using a spreadsheet template to import data isn't always a bad experience. But it would be hard to call it lovable. Even when your customer understands file encoding and can parse system-level error messages, it's still quite a chore to get the data in.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We believe ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'your second product is the onboarding experience',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '. Flatfile is here not just to help your customers through it, but to celebrate unlocking that next phase of value with you.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2YbDuOutvcPu99I7B0qjTA',
                type: 'Asset',
                createdAt: '2022-07-15T14:39:50.205Z',
                updatedAt: '2022-07-15T14:39:50.205Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Adding your logo to UI',
                description: '',
                file: {
                  url: '/img/contentful/2YbDuOut-1920_x_1080.webp',
                  details: {
                    size: 290697,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: '1920 x 1080.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Add your logo',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '\nPlacing your logo in the Flatfile importer serves as an extra reminder of the awesome product where this data is going.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7E61XVZxjpl4y1MnRFm0HK',
                type: 'Asset',
                createdAt: '2022-07-15T17:31:51.657Z',
                updatedAt: '2022-07-15T17:31:51.657Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "Guide your users on what's next",
                description: '',
                file: {
                  url: '/img/contentful/7E61XVZx-1920_x_1082.webp',
                  details: {
                    size: 309338,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: '1920 x 1082.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: "Guiding your users on what's next",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '\nProviding your own message to customers lets you describe any intricacies specific to your product.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1e2Pyq6YhyyVtFa0WtxN3V',
                type: 'Asset',
                createdAt: '2022-07-15T17:32:44.725Z',
                updatedAt: '2022-07-15T17:32:44.725Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Crystal Clear Acceptance States',
                description: '',
                file: {
                  url: '/img/contentful/1e2Pyq6Y-1920_x_1081__3_.webp',
                  details: {
                    size: 199718,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: '1920 x 1081 (3).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Crystal clear acceptance states',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '\nFlatfile makes it clear what data is ready to go, what needs their attention, and how to resolve anything that might keep them from importing their data into your system. Rejections can now be passed directly from your system!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3X4FFLeDwYd7rzdA8cfT9U',
                type: 'Asset',
                createdAt: '2022-07-15T17:33:09.599Z',
                updatedAt: '2022-07-15T17:33:09.599Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Celebration State',
                description: '',
                file: {
                  url: '/img/contentful/3X4FFLeD-1920_x_1083__3_.webp',
                  details: {
                    size: 193757,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: '1920 x 1083 (3).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Celebration state',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '\nYour customers just took a major step towards using your product - or using it more effectively. Celebremos!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's new and improved import experience makes it easier than ever to customize your importer to align with your unique use case. With 1.8 billion records processed and counting, Flatfile gives the world's best companies a centralized platform for better data onboarding.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Back soon,',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Tara',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'ERQo613OSBkxQobL5xtZe',
    postTitle: "Do more, faster with Flatfile's new parallel processing",
    seoTitle:
      "Processing larger files, faster with Flatfile's new parallel processing",
    seoUrlSlug: 'processing-more-faster-with-flatfiles-new-parallel-processing',
    seoMetaDescription:
      'Flatfile’s engineering team has been working around the clock obsessing over one thing - performance during data import. We quietly deployed parallel processing last week, and we’re thrilled to share.',
    category: 'Product updates & features',
    tags: ['parallel processing', 'portal', 'workspaces'],
    publishDate: '2022-05-17T00:00-04:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5FPtvfhxnyQOaVSix4ssUC',
        type: 'Asset',
        createdAt: '2022-05-17T21:46:49.766Z',
        updatedAt: '2022-05-17T21:46:49.766Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Parallel Processing',
        description: '',
        file: {
          url: '/img/contentful/5FPtvfhx-parallel_processing__2_.webp',
          details: {
            size: 183946,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Parallel Processing (2).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Parallel Processing Illustration',
    summary:
      'Flatfile’s engineering team has been working around the clock obsessing over one thing - performance during data import. We quietly deployed parallel processing last week, and we’re thrilled to share some early results.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From sending a Slack message while on a video call, to watching TV and scrolling Facebook before bed, most of us spend our time doing a couple things at once. For low pressure tasks, it’s mostly of little consequence, but the reality is the more things we try to do in parallel, the less efficient we are.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Computers are a different story. They can run two or more tasks simultaneously without affecting efficiency using a technique known as parallel processing.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Parallel processing can be credited for many achievements, from mapping the orbits of black holes to complex models that predict the future of the economy. Now, parallel processing can be credited with a new achievement: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'earth-shattering data import speeds in Flatfile',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s engineering team has been working around the clock obsessing over one thing - performance during data import. We quietly deployed parallel processing last week, and we’re thrilled to share some early results:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Massive files with hundreds of thousands of rows are moving through with ease, thanks to workers that dynamically scale as files increase in size.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Import times for the largest files have noticeably decreased.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5JwifA644pjJ9JeZRVcPMv',
                type: 'Entry',
                createdAt: '2022-05-18T12:32:53.719Z',
                updatedAt: '2022-05-18T12:32:53.719Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: "Flatfile's ability to process large files is just one of many reasons to ditch your homegrown importer. With enterprise compliance and security to boot, what more could you ask for?",
                ctaText: 'Request a demo',
                href: '/request-a-demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our continued commitment to speed, reliability, and compliance makes the decision to choose Flatfile over homegrown solutions easier than ever. With 1.8 billion records processed and counting, Flatfile gives the world’s best companies a centralized platform for better data onboarding. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Talk soon,',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Ashley Mulligan, Head of Marketing',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'ieT0lVbsSCgQxZGsg5Y5U',
    postTitle: 'Custom fields: a gift for your customers',
    seoTitle:
      'Flatfile gives the data owners the ability to add custom fields when importing.',
    seoUrlSlug: 'custom-fields-a-gift-for-your-customers',
    seoMetaDescription:
      'Flatfile now gives data owners the ability to easily add custom fields during the import process. ',
    category: 'Product updates & features',
    tags: ['custom fields', 'portal', 'workspaces'],
    publishDate: '2022-04-19T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5WNuH72lfYUfS2XrRW1tuU',
        type: 'Asset',
        createdAt: '2022-04-19T21:55:26.541Z',
        updatedAt: '2022-04-19T21:55:26.541Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Custom Fields',
        description: '',
        file: {
          url: '/img/contentful/5WNuH72l-1920_x_1080__6_.webp',
          details: {
            size: 439826,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '1920 x 1080 (6).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Custom fields UI shot',
    summary:
      'Flatfile now gives data owners the ability to easily add custom fields during the import process. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Each of your customers is different, and they need the ability to import information unique to their business. That’s why Flatfile now gives data owners the ability to quickly add custom fields during the import process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s take a look at how easy it is:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Activate additional fields',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ': On a template-by-template basis, you can decide if you want to allow additional fields to be added by your customers. Toggle it on if your platform can allow additional data beyond what you defined in your template.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Customer adds a new custom field: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "In one click, your customer simply chooses to add a new custom field for the columns that they can't find a field to match to. They don't have to think about the field type or format and can get back to finishing their import. ",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: "It's there for the next time: ",
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'Flatfile remembers any added custom fields so other colleagues in the same workspace (or future uploads from the same person) can map to custom fields that have been added in the past.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5p0xPKQJwiUQWEs6gHjcZ9',
                type: 'Asset',
                createdAt: '2022-04-19T21:57:47.478Z',
                updatedAt: '2022-04-19T21:57:47.478Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Match Columns Dropdown list',
                description: '',
                file: {
                  url: '/img/contentful/5p0xPKQJ-frame_1076__1_.webp',
                  details: {
                    size: 370268,
                    image: {
                      width: 1906,
                      height: 1242
                    }
                  },
                  fileName: 'Frame 1076 (1).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2IGCwq1hOX9n4tGoNuPuCC',
                type: 'Entry',
                createdAt: '2022-03-30T19:26:47.876Z',
                updatedAt: '2022-03-30T19:36:55.213Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Can your data importer do that? ',
                text: "Flatfile's experience is just one of many reasons to ditch your homegrown importer. With enterprise compliance and security to boot, what more could you ask for?",
                ctaText: 'Request a demo',
                href: '/request-a-demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's improved custom fields make it easier than ever to give your customers a world-class onboarding experience that feels as though it's uniquely built for them. With 1.8 billion records processed and counting, Flatfile gives the world's best companies A+ data onboarding and their customers love them for it.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Talk soon,',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Ashley Mulligan, Head of Growth Design',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'qlj7SONEwlnSGP27ovdz9',
    postTitle:
      'Wild Me leverages Flatfile to further their mission in fighting wildlife extinction',
    seoTitle: 'Wild Me Uses Flatfile’s Data Importer for Conservation',
    seoUrlSlug:
      'flatfile-grantee-wild-me-uses-artificial-intelligence-and-flatfiles-data-importer-to-fight-wildlife',
    seoMetaDescription:
      "Wild Me relies on artificial intelligence and Flatfile's data importer to help with conservation research efforts. Read the case study.",
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Non-profit', 'Popular'],
    publishDate: '2022-04-15T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6QlVvrfex5SIYptL5VipPs',
        type: 'Asset',
        createdAt: '2022-04-15T17:11:26.041Z',
        updatedAt: '2022-09-22T15:28:27.233Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        locale: 'en-US'
      },
      fields: {
        title: 'WIld Me',
        description: '',
        file: {
          url: '/img/contentful/6QlVvrfe-wild_me__4_.webp',
          details: {
            size: 1946127,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'WIld Me (4).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Wild Me selects the Flatfile data importer to help onboard data',
    summary:
      'The Smithsonian National Museum of National History reports that at least 15,000 species on Earth are threatened with extinction. Scientists are racing to catalogue the biodiversity on Earth, working against the clock as extinctions continue to occur. Wild Me is a non-profit organization that builds open software and leverages artificial ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Smithsonian National Museum of Natural History reports that at least 15,000 species on Earth are threatened with extinction. Scientists are racing to catalogue the biodiversity on Earth, working against the clock as extinctions continue to occur.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.wildme.org/#/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Wild Me',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a non-profit organization that builds open software and leverages artificial intelligence and machine learning to support the fight against wildlife extinction. The organization finds and identifies wildlife individually in photographs and builds mark-recapture models that provide scientists and conservationists the data they need to justify conservation action. As part of their work, Wild Me must import large amounts of data from wildlife biologists and scientists from all over the world.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Importing this vast amount of data on a regular basis manually is ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'time consuming',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. To streamline the process, Wild Me is leveraging the power of the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/products/portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' data importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We’re talking about millions of photos” said Jason Holmberg, Executive Director and Co-Founder of Wild Me. “And we only have a small slice of wildlife data at this point. Every year more and more data is available both on the web, from the public, and from researchers using digital cameras.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The Wild Me’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.wildbook.org'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Wildbook platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' serves more than 200 organizations and nearly a thousand researchers. They are tracking at least 88,000 individual animals across the globe with well north of 438,000 sightings in the database. They have also engaged in data collection with more than 10,000 public “citizen scientists.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Supporting multiple data import streams',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We have two pipelines for ingesting data,” said Ben Scheiner, Senior Engineer at Wild Me. “One is from individuals who report sightings  by  using an online form on our website. The other is from researchers who are looking to migrate their entire research system to our Wildbook database. This is called our bulk reporter upload which is Flatfile’s data importer.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Wild Me is uploading data daily as well as multiple times a week across all its platforms.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Over this past weekend I brought in 5,000 humpback whale sightings as a result of an historical catalog that came in,” said Holmberg. “All of these images have to be bulk uploaded and run through machine learning.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Prior to using the Flatfile data importer, Wild Me was considering the creation of  a universal importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The problem with the universal importer is that few of the researchers were familiar with the concept of schemas or data standards,” said Holmberg. “There wasn’t a common data standard, so we ended up building half the solution which is a common input format and then we had to rely on the users to meet us halfway. That wasn’t easy. That’s where Flatfile comes in. The ease of use of converting a legacy catalog or just a week’s worth of photographs and related metadata into a common format that we can import saves both our staff and end users huge amounts of time.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Holmberg estimates a tenfold time savings importing data since implementing Flatfile. They have also saved developers a significant amount of time since the number of support tickets is down considerably.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Users who get frustrated trying to import data end up submitting a support ticket,” said Holmberg. “We’re a non-profit and supporting these wildlife biologists is part of our mission, but the cost of that support absolutely comes out of my available financing that I’ve raised for the organization. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Managing large numbers of support tickets also limits our scalability. Flatfile eliminates many of these support requests and will allow us to grow. A user-friendly importing interface reduces a barrier to the user who is just trying to get their data into the system. It helps them clean their data, eliminates common errors, and reduce the prep time to import their data from potentially weeks to hours.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '16viln6jICTZ5fjtMixnwC',
                type: 'Entry',
                createdAt: '2022-04-15T17:08:06.946Z',
                updatedAt: '2022-04-15T17:10:38.548Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 17,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'See the technology',
                text: "Learn more about the technology behind Wild Me's data uploader",
                ctaText: 'See Portal',
                href: 'https://flatfile.com/products/portal',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Wild Me and the Flatfile impact program',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Wild Me is one of the first grantees of the Flatfile Impact program, a corporate effort to help charitable organizations that rely on data from customers or third parties to inform their work. Making that data usable is a challenge for even the most technology savvy organizations. The goal of Flatfile Impact is to help non-profit organizations struggling to build import data solutions for their product or service, or if they are having issues normalizing the data they need to run their organizations. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Being a Flatfile grantee is of enormous benefit to Wild Me.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Conservation generally is funded at about 3% globally of what is needed,” said Holmberg. “One of the greatest barriers to modernization in wildlife conservation is the inability to afford the technology. Researchers don’t have the funds to purchase AI tech that costs tens of thousands if not hundreds of thousands of dollars for data manipulation and blending or AI. All of these things are costs well above the average non-profit budget.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“So the idea that Flatfile is providing free access to its technology is critical to advancing conservation,” said Holmberg. “Most of the data we import represents photographs on a file system and data in spreadsheets. That is 30-year-old technology. Wildlife science is really behind the times so having access to a tool like the Flatfile data importer has a huge beneficial impact.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Wild Me',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Wild Me builds open software and artificial intelligence for the conservation research community. We are machine learning experts and software professionals supporting you in the fight against extinction. Our team works at the intersection of conservation, AI, engineering, and academia. We take pride in what we do, and even more pride in how we treat each other. We here at Wild Me have almost two decades of experience supporting wildlife and citizen scientist projects through software and computer vision. We work with our users to find solutions that empower the conservation community, and we strive to be representatives of how technology can be leveraged for a better world. For more information visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.wildme.org/#/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'https://www.wildme.org/#/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 1.8 billion data records for companies like Sage, CBRE, Square, HubSpot, and ClickUp. To learn more about Flatfile’s data onboarding platform email ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:sales@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'sales@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4g5MHzkVRQTKWwQz57BK8X',
    postTitle:
      'New custom styling features help Flatfile integrate even more seamlessly',
    seoTitle: 'New improvements to Flatfile importer branding',
    seoUrlSlug:
      'flatfiles-advanced-custom-styling-features-help-you-replace-your-homegrown',
    seoMetaDescription:
      "Flatfile's advanced custom styling features help you replace your homegrown importer seamlessly.",
    category: 'Product updates & features',
    tags: ['styling', 'branding', 'personalization', 'Popular'],
    publishDate: '2022-03-29T12:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '279niySPVUk0u5WTBxN72m',
        type: 'Asset',
        createdAt: '2022-03-29T17:29:25.094Z',
        updatedAt: '2022-03-30T17:36:27.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Blog Post cover for branding product update',
        description: '',
        file: {
          url: '/img/contentful/279niySP-color-wipe_1920x1080_ps.gif',
          details: {
            size: 271308,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'color-wipe_1920x1080_PS.gif',
          contentType: 'image/gif'
        }
      }
    },
    featuredImageAltText: 'Animation of branding',
    summary:
      "Modify the Flatfile importer's colors, fonts, and helper text to match the look and feel of your brand.",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Enhanced brand customization to blend right in',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-1'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "One of the key benefits of Flatfile is its ability to integrate seamlessly with your user interface. Now, we've added even more customization features to help you further match your brand.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Improvement to brand color overrides: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "We've integrated your custom colors in even more places to elevate your brand in the data import experience.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Support for custom fonts: ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        "If you include your Adobe TypeKit project id, you can reference any font within. We'll apply that font to your importer instantly.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value: 'Help content: (BETA) ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        'You can now choose to include help text for your customers on the importer screen. Standard markdown is supported for styling if you want to spice it up.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6YaDNlLTncfxqJrk5IQBgu',
                type: 'Asset',
                createdAt: '2022-03-29T17:21:47.374Z',
                updatedAt: '2022-03-29T17:21:47.374Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Beta - Upload Screen Helper Content',
                description: '',
                file: {
                  url: '/img/contentful/6YaDNlLT-frame_1073__6_.webp',
                  details: {
                    size: 48671,
                    image: {
                      width: 600,
                      height: 403
                    }
                  },
                  fileName: 'Frame 1073 (6).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2IGCwq1hOX9n4tGoNuPuCC',
                type: 'Entry',
                createdAt: '2022-03-30T19:26:47.876Z',
                updatedAt: '2022-03-30T19:36:55.213Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Can your data importer do that? ',
                text: "Flatfile's experience is just one of many reasons to ditch your homegrown importer. With enterprise compliance and security to boot, what more could you ask for?",
                ctaText: 'Request a demo',
                href: '/request-a-demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's new and improved customization features make it easier than ever to optimize your importer while maintaining alignment with your brand. With 1.8 billion records processed and counting, Flatfile gives the world's best companies a centralized platform for better ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Til next time,',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Ashley, Head of Growth Design',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5nIwJmGEIFSp2q9ubH2S4j',
                type: 'Entry',
                createdAt: '2022-03-18T21:21:22.471Z',
                updatedAt: '2022-03-30T19:31:30.825Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'Are you getting questions about industry security and compliance that you haven’t yet prioritized or considered? This is a surefire sign it’s time to replace your homegrown data importer.',
                ctaText: 'Request a demo',
                href: '/request-a-demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'SyJvteWZln8wrTc2IMg0E',
    postTitle: " We've unlocked two new levels of security and privacy.",
    seoTitle: 'SOC 2 Type II & Regional hosting are here. ',
    seoUrlSlug: 'weve-unlocked-two-new-levels-of-security-and-privacy',
    seoMetaDescription:
      "SOC 2 Type II & Regional hosting are here. Are you protecting your customer's data?",
    category: 'Security & compliance',
    tags: ['security', 'compliance'],
    sortOrder: '2',
    publishDate: '2022-03-18T15:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '52jucKWJAa83w99Tqe2gQs',
        type: 'Asset',
        createdAt: '2022-03-18T19:40:42.654Z',
        updatedAt: '2022-03-18T19:52:35.917Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        locale: 'en-US'
      },
      fields: {
        title: 'Email - SOC2 (4)',
        description: '',
        file: {
          url: '/img/contentful/52jucKWJ-frame_1943__4_.webp',
          details: {
            size: 391454,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 1943 (4).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'SOC Flatfile Image',
    summary:
      'We are excited to announce that Flatfile is now SOC 2 Type II certified. Achieving the SOC 2 Type II certification further demonstrates that our systems provide maximum security, integrity, confidentiality, and privacy of your customers’ data.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'SOC 2 Type II',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We are excited to announce that Flatfile is SOC 2 Type II certified as of March 7th, 2022. Achieving the SOC 2 Type II certification further demonstrates that our systems provide maximum security, integrity, confidentiality, and privacy of your customers’ data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4UPUX6PW9BbG3HzxUOQKDq',
                type: 'Asset',
                createdAt: '2022-03-18T19:40:35.685Z',
                updatedAt: '2022-03-18T19:40:35.685Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'compliancelogo',
                description: '',
                file: {
                  url: '/img/contentful/4UPUX6PW-compliancelogo.webp',
                  details: {
                    size: 177948,
                    image: {
                      width: 1110,
                      height: 215
                    }
                  },
                  fileName: 'compliancelogo.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The SOC 2 Type II certification complements our existing certifications - SOC 2 Type I, GDPR, HIPAA, & EU/US Privacy Shield - all of which we continue to obsessively prioritize.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5nIwJmGEIFSp2q9ubH2S4j',
                type: 'Entry',
                createdAt: '2022-03-18T21:21:22.471Z',
                updatedAt: '2022-03-30T19:31:30.825Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'Are you getting questions about industry security and compliance that you haven’t yet prioritized or considered? This is a surefire sign it’s time to replace your homegrown data importer.',
                ctaText: 'Request a demo',
                href: '/request-a-demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Regional hosting',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile is excited to announce new regional hosting options in the United Kingdom, Germany, Ireland, Australia, and the United States. International and local data laws vary widely, so where and how you collect and store your customer data can be critical.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2oBFlNcdAnqnn28AtfuA1F',
                type: 'Asset',
                createdAt: '2022-03-18T19:41:30.894Z',
                updatedAt: '2022-03-18T19:41:30.894Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Regional Hosting Countries',
                file: {
                  url: '/img/contentful/2oBFlNcd-email_-_regional__5_.webp',
                  details: {
                    size: 12470,
                    image: {
                      width: 1204,
                      height: 148
                    }
                  },
                  fileName: 'Email - Regional (5).png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Regulations such as the Global Data Protection Regulation (GDPR), which controls the movement of sensitive personal information away from EEA/EU member states, are a prime example of why regional hosting matters.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Make it easier for your company to adhere to always-changing and ever-increasing security standards with Flatfile's comprehensive ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. With 1.8 billion records processed and counting, the world’s best companies run on Flatfile and replace homegrown solutions.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: " We're ready to meet you.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '-Ashley Mulligan, Head of Growth Design',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ehr0YSOHP4QI8rDOR4Akj',
                type: 'Entry',
                createdAt: '2021-08-13T16:04:09.296Z',
                updatedAt: '2021-08-13T16:04:09.296Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's State of Data Onboarding Report",
                text: 'Learn how companies are tackling the data import challenge',
                ctaText: 'Download now',
                href: '/state-of-data-onboarding-2020/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3pVJAA9MS5TyZWOW7opk2A',
    postTitle:
      'Outbound product management: How to better engage with your customers',
    seoTitle:
      'Outbound product management: How to better engage with your customers',
    seoUrlSlug:
      'free-webinar-outbound-product-management-how-to-better-engage-with-your',
    seoMetaDescription:
      'There used to be just one type of product manager and everybody with that title mostly had the same basic key responsibilities and performed the same basic functions. But things have changed.',
    category: 'Data exchange',
    tags: ['webinar', 'product management'],
    publishDate: '2022-01-14T08:00-06:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4pppCuqDu1RRSpO6lilhpD',
        type: 'Asset',
        createdAt: '2022-01-14T15:59:14.941Z',
        updatedAt: '2022-01-14T15:59:14.941Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Webinar Banner',
        description: '',
        file: {
          url: '/img/contentful/4pppCuqD-frame_1__1_.webp',
          details: {
            size: 755870,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Frame 1 (1).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Webinar banner',
    summary:
      'It used to be the case that a "Product Manager" was… a Product Manager. There was just one type of Product Manager and everybody with that title mostly had the same basic key responsibilities and performed the same basic functions. But things have changed. Today, we\'ve seen the rise of the Outbound Product Manager.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'One of my favorite movies, ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'Field of Dreams,',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' features the unforgettable quote, “Build it and they will come.” And while my sandlot-playing younger self would like to believe that to be true, my product-managing adult self knows the fallacy in that statement.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Product teams that engage with customers gain a more comprehensive understanding of their needs. Those teams then build better products. Seems obvious, right? Every good PM I’ve learned from, worked with, and coached knows this. Yet, most product teams I’ve worked with have taken years to establish even a baseline standard for ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'how',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' they engage with customers. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Flatfile we’re happy to be part of a broader trend in product teams that have an increasing set of customer-facing interactions and obligations. Outbound Product Management (OPM) is the process of gaining a greater understanding of the market and your product’s role in it by meeting with and discussing customers’ in-depth needs. OPM takes customer feedback to the next level, developing strong strategic relationships with customers to build features that satisfy a select customer group, which can then be applied to the broader customer base.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'OPM poses two key questions: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'How can you extend your product in a way that solves more holistic problems? ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Where does your product plug into the value chain for your customers? ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Answering these questions will help you understand how you’re delivering value and identify additional opportunities to deliver even more.\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Three key areas of outbound product management ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Flatfile, we relate product management to customer outcomes. This enforces tight alignment with the needs of our market. Building our roadmap from an outcome-based perspective also democratizes the process: anyone in our business and any of our customers (or prospects) can describe what they need to accomplish. Capturing those needs directly from a representative sample of customers and keeping those customers involved throughout the product development cycle is the essence of outbound product management.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With OPM, we’re able to simultaneously define scope, priority, and commercial viability. Our strategy consists of three focus areas.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                },
                {
                  type: 'italic'
                }
              ],
              value: 'Journey Mapping',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a process that leads to a shared view of product success that transcends a contract. We use a tool called UserBit, but even a simple slide deck will do. We train our sales and success teams to devise these maps with the goal of getting customers engaged with where our product is today as well as where it’s going. The process gives us a good understanding of an objective outcome, not just a feature set that we’re serving to a particular customer. And our product team will often pair with our reps through the sales process, ensuring full transparency and lending credibility to the exercise. This is helpful especially early in the customer life cycle. \n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                },
                {
                  type: 'italic'
                }
              ],
              value: 'Customer Development',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a role within our business focused on engaging customers and prospects who stretch the limits of Flatfile’s core product abilities. This role involves gathering information about outcomes from the market and leveraging this input to prioritize and build features. The role involves working with our design partners (more below), coordinating design feedback sessions, and building out POCs (proof of concepts), all in close collaboration with those companies.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Our ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                },
                {
                  type: 'italic'
                }
              ],
              value: 'Design Partnership',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a formal collaboration between Flatfile and our customers, and is critical to our outbound product management process. This selective partnership goes beyond reaching out for feedback or gathering thoughts on product direction from the journey map. This program relies on customers engaging in design sessions, workflow diagramming, understanding strategic business direction, and actually lining up our product roadmap with their business objectives. We select customers who are representative of both the current and future Flatfile customer base to ensure our product team is always engaging directly with customers who represent the broader market we need to serve. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With each of these motions formally in play at Flatfile, we’ve built customer confidence and a market-tested roadmap. And if you’re interested in learning more about how to build an outbound product management strategy, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://us02web.zoom.us/webinar/register/WN_hEKOtCTiQDq6F54zn3uggQ'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'register here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to join my upcoming webinar with Product Collective on January 26th. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3eLxKB3KIWXNggxl6mK8ha',
    postTitle:
      'Flatfile launches updated data onboarding platform: Flatfile Workspaces now available',
    seoTitle: 'Flatfile Launches an Updated Data Onboarding Platform',
    seoUrlSlug:
      'flatfile-launches-updated-data-onboarding-platform-flatfile-projects-now',
    seoMetaDescription:
      'Flatfile launches new data onboarding platform which includes the release of Flatfile Portal 3.0 and Flatfile Workspaces to drastically improve the way companies import data.',
    category: 'Product updates & features',
    tags: ['Flatfile Projects', 'Flatfile Embeds', 'Flatfile platform'],
    publishDate: '2021-10-07T10:00-04:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1MVnAsKsCTnPghPWulLrx2',
        type: 'Asset',
        createdAt: '2021-10-07T03:31:26.285Z',
        updatedAt: '2021-10-07T03:31:26.285Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile data onboarding platform hero ',
        description:
          'Overview image of the Flatfile data onboarding platform V3',
        file: {
          url: '/img/contentful/1MVnAsKs-blog_platform_overview_hero.webp',
          details: {
            size: 200889,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'blog_platform overview hero.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile unveils updated data onboarding platform',
    summary:
      'Flatfile launches new data onboarding platform which includes the release of Flatfile Portal 3.0 and Flatfile Workspaces to drastically improve the way companies import data.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Recently, we significantly overhauled Flatfile based on everything we’ve learned from our customers over the past three years. Today, I’m excited to announce the release of Flatfile’s new data onboarding platform, along with Flatfile Workspaces and Flatfile Portal 3.0.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If you want to see the updated product, check out this ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.youtube.com/watch?v=gyNWjhr1ncw '
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'recorded webinar',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for an overview  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'David and I started Flatfile to solve a question we had asked ourselves time and time again: why is it so hard to import data into a software system? This process, which we call ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'data onboarding',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ', is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/flatfile-unveils-state-of-data-onboarding-report/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'time-consuming and tedious',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. And the cost of maintaining the status quo is frustrated users, high churn rates, and a missing link to the value of most of the world’s software. Now with hundreds of active customers and years of improving upon Flatfile’s capabilities, I can safely say we’re done paying that exorbitant price.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Previous versions of Flatfile iterated on the speed, ease, and efficiency of data onboarding for hundreds of global customers, tens of thousands of end users, and millions of data sets. Our new platform harnesses those observations into a seamless experience, and one that plugs into every data onboarding workflow.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Where we’ve been, where we’re going',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Prior to today, the only way to use Flatfile was via our Flatfile’s data onboarding platform, a drop-in SDK for web applications. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Our new platform combines the best aspects of both products - and some entirely new concepts - into a comprehensive data onboarding solution: whether you’re ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'embedding',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' data import into your SaaS app, running complex onboarding ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'projects',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' with your customers, or somewhere in between.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile Workspaces',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Beginning today, I’m excited to share that Flatfile Workspaces are publicly available. A Flatfile workspace offers a shared view of all data imports with relevant details like versions, status, owners, and validation errors. This ensures your customer has full transparency, while you have full control over data onboarding.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2wrCCQY3b3hJKS5ayLvkkw',
                type: 'Asset',
                createdAt: '2021-10-06T14:22:22.417Z',
                updatedAt: '2021-10-06T14:22:22.417Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Workspace',
                description: 'Workspace UI from V3 Flatfile Platform',
                file: {
                  url: '/img/contentful/2wrCCQY3-workspaces_ui_.webp',
                  details: {
                    size: 151889,
                    image: {
                      width: 1028,
                      height: 717
                    }
                  },
                  fileName: 'workspaces UI .png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Workspaces are for implementation teams who guide their customers through the data onboarding process. These projects can be simple, one-off requests for data as well as complex, multi-party engagements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile Portal 3.0',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With Portal 3.0, you can embed Flatfile inside of your product experience and present an elegant data onboarding workflow to your users.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'jjxBJNBfuzal1iHas8Et2',
                type: 'Asset',
                createdAt: '2021-10-07T14:02:49.177Z',
                updatedAt: '2021-10-07T14:02:49.177Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'blog-embed',
                description: '',
                file: {
                  url: '/img/contentful/jjxBJNBf-blog-embed.svg',
                  details: {
                    size: 36131,
                    image: {
                      width: 996,
                      height: 740
                    }
                  },
                  fileName: 'blog-embed.svg',
                  contentType: 'image/svg+xml'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "You can deploy Portal 3.0 using our streamlined SDK, and simply choose the type of data you want to collect. Data owners are then guided through an AI-powered data onboarding experience. Once they've reviewed the data, they can then automatically push the valid data into your system.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile Platform',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The Flatfile platform is designed to plug into both product and process. While we retain the concept of integrating Flatfile directly by embedding it, you can also leverage data templates, validation rules, and programmatic Data Hooks® across non-embedded flows. Set it up once, and it works however you need within your organization.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ImXdmchBvebfef0nP6Ugg',
                type: 'Asset',
                createdAt: '2021-10-06T14:00:02.597Z',
                updatedAt: '2021-10-06T14:00:02.597Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'No-code configuration',
                description:
                  "No-code configuration for Flatfile's data onboarding platform",
                file: {
                  url: '/img/contentful/3ImXdmch-no_code_.webp',
                  details: {
                    size: 181307,
                    image: {
                      width: 851,
                      height: 572
                    }
                  },
                  fileName: 'No code .png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We’ve designed the platform for both scale and security. Our new abstraction layer makes data retrieval and processing over 10x faster than before, and new authentication methods paired with isolated runtime environments ensure data is safe.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'An upgrade and an evolution',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With this change comes a shift in how we’re approaching the universal challenge of data onboarding. Flatfile serves every organization that accepts data from its customers. The release of Flatfile’s platform with Flatfile Workspaces and Flatfile Portal 3.0 is one step in our continued evolution and you can expect rapid iteration in the next few months.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In the near term, for example, you’ll be able to easily send customers to a Flatfile-hosted landing page where they can securely submit their data. In addition, you can take over where any customer left off, add comments, and assist your data owners (aka your customers) as they walk through the import flow.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Further, you’ll be able to extend Flatfile into whatever data exchange process you want with customers or other third parties, handle custom file types, or pull data via APIs or SFTP. You’ll discover how Flatfile is able to reference external data and handle complex incoming data structures like relational data, arrays that need to be parsed, or lookups against industry standards. Extensibility is baked in. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The scope of Flatfile’s learning capabilities will also continue to broaden. While intelligent field matching has always been part of our offering, we’ll now integrate what we’ve learned more quickly: not only into mapping decisions, but all parts of the data onboarding flow. From data set identification to validation correction to recommended enrichment, Flatfile is rapidly moving towards a one-click import experience, even in the most complex scenarios.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What’s next ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you’re an existing Flatfile customer, you’ll find a faster, higher-quality experience with Flatfile’s new data onboarding platform. We’ll be reaching out to you in the following weeks to discuss how to upgrade your account without any disruption to your customers. If you just can’t wait to get started, contact us at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:sales@flatfile.io'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'sales@flatfile.io',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Regardless of whether you’re an existing customer, newly exploring Flatfile, or simply curious about what we’ve built, check out the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.youtube.com/watch?v=gyNWjhr1ncw'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' recorded webinar. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2INzxhW33B5jmmbOyTD1Dp',
    postTitle: '3 Common Customer Onboarding Mistakes',
    seoTitle:
      'Onboarding a new customer should be a positive experience. Learn the customer onboarding mistakes to avoid in order to ensure the process is an exceptional one.',
    seoUrlSlug: '3-common-customer-onboarding-mistakes',
    seoMetaDescription:
      "Proper customer onboarding is critical to set the right tone for a company's relationship with their new customer. Here are three customer onboarding mistakes to avoid.  ",
    category: 'Data Onboarding',
    tags: ['Customer onboarding', 'Onboard.io'],
    publishDate: '2021-09-23T09:00-04:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5smHAdlXwIel6WQ6yXfu5d',
        type: 'Asset',
        createdAt: '2021-09-23T04:23:22.817Z',
        updatedAt: '2021-09-23T04:23:22.817Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '3 customer onboarding mistakes - blog post from Onboard.io',
        description:
          'Blog image for post 3 common customer onboarding mistakes',
        file: {
          url: '/img/contentful/5smHAdlX-3_customer_onboarding_mistakes_-_blog_post__2_.webp',
          details: {
            size: 1662347,
            image: {
              width: 2400,
              height: 1280
            }
          },
          fileName: '3 customer onboarding mistakes - blog post (2).png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Customer onboarding mistakes',
    summary:
      'When it comes to customer onboarding, there are lots of strategies, tools, and best practices recommended for improving the onboarding process. But what should companies avoid? Check out these three common customer onboarding mistakes, and how to avoid them. ',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This post is written by Will Stevenson, COO & Founder of ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Onboard',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://onboard.io/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', the software that helps companies organize, automate, and manage client onboarding from handoff to launch.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If you’re reading this, you’re probably looking for onboarding tips you can implement, like, yesterday. Maybe you’re the onboarding director charged with fixing an inefficient, expensive, or otherwise broken process. Our hats off to you, because we’ve been there.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In fact, that’s why we put together the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Ultimate Guide to Customer Onboarding',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://see.onboard.io/definitive-guide-to-customer-onboarding?url_source=flatfile'
              }
            },
            {
              nodeType: 'text',
              value:
                '. Read it and you’ll learn a heap of strategies, tools, and best practices that we recommend for improving the onboarding process. Today, however, I’d like to touch on another onboarding question we commonly get:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'What are some things to avoid?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Be it company or user onboarding, you deal with all kinds of people, experience, titles, and so on. Oh and don’t forget the variety of egos out there. The point is, it’s difficult to account for every single thing for every single person. But you can account for these three no-brainers and differentiate your onboarding process while you’re at it.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '1. Poor Visibility Into Onboarding Tasks',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '“Assumptions can be relationship killers.” We wrote that in ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value:
                    '7 Ways to Elevate your Customer Onboarding Experience',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://onboard.io/blog/7-ways-to-elevate-your-customer-onboarding-experience'
              }
            },
            {
              nodeType: 'text',
              value:
                '. In the context of onboarding, many organizations assume people know what to do next, or what’s expected of them. By failing to provide client visibility into the tasks that need to be done, you’ll find it difficult to ensure accountability throughout the process.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Tips for better visibility',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ': ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Build a process that can be used and reused to complete the phases required',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Create onboarding “launch plans” with detailed task lists,assignees, and due dates',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Communicate expectations clearly during the kickoff meeting',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: ', ',
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'in follow ups, and throughout the launch plans',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '2. Software That Isn’t Designed for Onboarding',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Far too many organizations hamstring their onboarding process by trying to fit a square peg into a round hole. When you use software that isn’t designed for customer onboarding—such as a project or task management tools—you end up wasting a lot of time (both your own and the clients). ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Typically companies that use project management software to onboard customers will build project templates, then duplicate those templates and customize them for each new customer and their use case. That’s incredibly time-consuming, inefficient, and it doesn’t take into consideration the dynamic use cases that clients can have. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '\nIf I may, a solution like Onboard (spoiler alert, I’m the Founder and a little biased) is built just for onboarding. It uses ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'a variable-based system',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://onboard.io/feature/organization'
              }
            },
            {
              nodeType: 'text',
              value:
                ' designed just for onboarding, and you can use this system to create custom launch plans in about 30 seconds. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '3. High Friction Right from the Beginning',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Nothing kills the onboarding vibe if the first thing your client encounters is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'CSV formatting errors',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              }
            },
            {
              nodeType: 'text',
              value: '. Data “wrangling.” Or heaven forbid, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'coding',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. And yet, data onboarding is an integral part of the overall process, one famous for tedious and time-consuming manual labor. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '\nWhile data onboarding might seem like an arduous requirement, we look at it as an opportunity. You’ll get to value so much faster—and with far fewer headaches—if you can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'automate the data onboarding process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/customer-onboarding-whats-in-your-tech-stack/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' for your clients. Moreover, you’ll position the relationship well to hit the ground running post-launch. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Our Mantra: “Make it Repeatable”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It all comes down to helping your clients succeed, now and in the future. From navigating onboarding tasks and selecting the right onboarding software, to getting your data onboarding process squared away, so much relies on those critical first phases. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '\nIf you can avoid these three common onboarding mistakes we’ve introduced here, you’ll be off to a great start. Yet, the keener, savvier organizations are finding ways to build repeatable and scalable onboarding processes that automatically account for all the best practices. No matter if they turn to Onboard, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', and another solution, the goal remains the same: vanquish a client’s doubt from the get-go by building an intuitive and repeatable onboarding program.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '4BasXEZcL0kDjUqyz4WkmT',
    postTitle:
      'Leading Indicators of Data Onboarding Success: 3 Early Metrics to Track',
    seoTitle: 'Leading Indicators of Data Onboarding Success',
    seoUrlSlug:
      'the-leading-indicators-of-data-onboarding-success-3-early-metrics-to-track',
    seoMetaDescription:
      'Are your customers onboarding data successfully? Here are three key metrics that help indicate a better data import experience is needed.',
    category: 'Data Onboarding',
    tags: ['Data onboarding', 'Onboarding metrics'],
    publishDate: '2021-08-24T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4OIkXtfYADMVPMpKPoIDYn',
        type: 'Asset',
        createdAt: '2021-08-24T20:25:25.024Z',
        updatedAt: '2021-08-24T20:25:25.024Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '3 leading metrics for data onboarding success',
        description: '3 leading metrics for data onboarding success',
        file: {
          url: '/img/contentful/4OIkXtfY-qargmh5arumszpnhvocg.webp',
          details: {
            size: 1151453,
            image: {
              width: 2400,
              height: 1280
            }
          },
          fileName: 'qaRGMh5aRumszpnHVOcG',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: '3 leading metrics for data onboarding success',
    summary:
      'Engagement: the ultimate objective for most successful products and software companies. Predicting how well users will engage, though, is more than just tracking interactions. When it comes to pointing towards successful engagement, there are plenty of leading metrics. Identifying, monitoring, and measuring these metrics ensure...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Engagement: the ultimate objective for most successful products and software companies. Predicting how well users will engage, though, is more than just tracking interactions. When it comes to pointing towards successful engagement, there are plenty of leading metrics. Identifying, monitoring, and measuring these metrics ensure your performance is on track.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'One of the first potential blockers to engagement is often overlooked, because it’s frequently before your users are even able to use your application. Easier onboarding of relevant data (your customer’s data onboarding) increases engagement through the entire product journey. Ensuring a smooth ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'data import',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/flatfileio-the-new-standard-for-data-import'
              }
            },
            {
              nodeType: 'text',
              value:
                ' process is key to achieving this early, and repeated, engagement.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'How you decide to manage your ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customer onboarding',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge/'
              }
            },
            {
              nodeType: 'text',
              value: ' - more specifically - your ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              }
            },
            {
              nodeType: 'text',
              value:
                ' can determine success or failure at a very early stage. Data might be sourced from another software vendor, or from other sources like spreadsheets, CSV files, or activity logs. Focusing on success metrics within your data onboarding is one of the first steps to these higher customer engagement and customer retention levels.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Here are three leading indicators of data onboarding success to help you uncover hidden issues that may be negatively impacting your onboarding experience for your users:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '1. Import success rate',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This data onboarding metric tracks the ability of users to ingest required or suggested data into an application. Generally, the more data a user successfully brings into your application, the higher your future engagement will be. As more data is successfully migrated or added, user commitment to the product increases, and chances of full adoption go up.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The metric is essentially pass/fail, and is calculated by dividing the number of successful data upload attempts by the total number of uploads. Related metrics can track whether that particular file was ultimately able to be uploaded, or whether the user was able to bring other data in successfully after a failure. It is helpful to look at both an overall success rate across all users, as well as the rate per individual user. This can uncover specific issues that may be resolved with additional segmentation, training, or customized user onboarding.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A low import success rate will indicate a higher churn rate risk, as users will either have to invest more time upfront to ensure they are able to upload their data. With higher product friction at the beginning of their journey, they may import less data, or they may abandon the onboarding process entirely. This will significantly degrade adoption, and can also lead to loss of the customer.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'About this metric: import success rate metrics will generally be considered as a trend, as opposed to monitoring for a specific percentage. Success will vary naturally depending on the size and complexity of the files your users are attempting to upload--but the goal should always be to continue to improve your success rate overall.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '2. User actions per record',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This metric captures the average number of actions being taken to ensure a successful file import.  Actions are essentially corrections that need to be made to the file as a result of mismatched formatting, missing data, invalid data, or any other issue that is preventing a file from uploading. This metric is calculated by taking the total number of records imported, divided by the number of actions required to complete a successful import.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This metric is a measure of the amount of friction – things that slow down data importing – that users face when cleaning data. If it takes many actions to clean data and get files ready for uploading, that friction will result in a lower success rate. The amount of heavy processing and data cleaning required of users is directly tied to how successful those users will eventually be with the data they do bring into your system - having an impact on the customer onboarding experience and the overall experience in general with your product.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'About this metric: user actions per record is frequently unable to be gathered within products, unless your system is built to allow for edits and changes of the raw, original data during onboarding. If your application isn’t able to do this (or can’t measure it), it would need to be collected periodically via interviews and walk throughs. If you are measuring manually, the best way to do this is usually an over-the-shoulder session of a user that hasn’t spent any time preparing the data yet. If any of your teams are managing the user onboard program, they may already be facilitating these sessions.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '3. Time spent per record',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This metric is related to user actions per record, but instead of focusing on the number of actions that need to be taken, it focuses on how long it takes to actually perform those actions. To calculate this metric, you’ll take the total amount of time spent cleaning the data, divided by the number of records successfully uploaded.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This metric can provide a more granular look at how much effort it takes to get files ready for import. For example, minor formatting issues may be simple to correct in bulk, but a data consistency issue that requires more extensive corrective action – or even need the expertise of a developer or data administrator – will certainly take more time and drain resources. Small companies with limited resources, or anyone with low commitment (including those interested but trying to understand how they can use your product) will be the highest impacted by a long Time Spent Per Record metric. This metric will predict low adoption and high churn due to the data onboarding process simply being too time consuming.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'About this metric: Like “User Actions per Record”, “Time Spent per Record” may be difficult to track in-app, although should be easier to collect some data on automatically. If uploaded data is fairly consistent, other related metrics may be more accessible. One of the most common would be “time spent uploading”, which if tracked on a per-file basis, can be very insightful alongside your Import Success Rate metrics.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'The Flatfile Data Onboarding Platform Can Help',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Tracking these three data onboarding metrics can provide an early warning system that your customers are struggling to import their data and that may impact engagement and ultimately result in customer churn. Having this information will enable you to initiate corrective action before you lose a customer. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile helps improve these leading indicators for clients with a data onboarding platform which quickly gets companies clean and usable data, eliminating time-consuming, manual processes around data migration. A seamless data onboarding experience for your customers ultimately increases product adoption, improves new customer engagement, and minimizes churn.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: 'YzaI0g4hoJtXr8SqWMPCR',
    postTitle: 'Customer Onboarding: What’s in your Tech Stack?',
    seoTitle: 'The customer onboarding tech stack includes data import',
    seoUrlSlug: 'customer-onboarding-whats-in-your-tech-stack',
    seoMetaDescription:
      "When you're onboarding your customers (and their data) ensure the process is as smooth as possible. Here are the must have technologies.",
    category: 'Data Onboarding',
    tags: ['Customer experience', 'Customer onboarding'],
    publishDate: '2021-08-19T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7ej6LKGhhP2lnsf80GERFx',
        type: 'Asset',
        createdAt: '2021-08-24T15:27:07.207Z',
        updatedAt: '2021-08-24T15:27:07.207Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'The ideal customer onboarding technology stack',
        description: 'The ideal customer onboarding technology stack',
        file: {
          url: '/img/contentful/7ej6LKGh-jvwgcwtt7m7t1icbvpnw.webp',
          details: {
            size: 131699,
            image: {
              width: 2400,
              height: 1280
            }
          },
          fileName: 'JVwGCWtT7m7t1iCbVpnw',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'The ideal customer onboarding technology stack',
    summary:
      'With the explosive growth of customer success and customer implementation teams, customer onboarding - the process by which customers get up and running with their new product is critical. Companies know that they can’t simply sell a product and then walk away. The first 90 days will determine if a ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With the explosive growth of customer success and customer implementation teams, customer onboarding - the process by which customers get up and running with their new product is critical. Companies know that they can’t simply sell a product and then walk away. The first 90 days will determine if a customer stays or churns. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There are lots of tools available for companies as they onboard a new customer. We covered quite a few of these tools in a previous post ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/28-onboarding-tools-for-delighting-new-users/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '28 Onboarding Tools for Delighting New Users',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to your customer onboarding tech stack, these are the tools you need in place: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Data onboarding tools:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Your customer can’t use your product if they don’t actually have their data migrated over into it. Typically ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is an overlooked process where companies provide customers with FAQ and tutorial docs and expect them to import their own data and do it successfully. Many companies also go the custom data importer route where they build an in-house tool. Unfortunately these data importers are often thrown together without much thought since data onboarding is peripheral to the product itself. Don’t kick off your new ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-onboarding-an-underrated-but-crucial-part-of-the-customer-experience/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'customer’s experience',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' with a poor data import process. Ensure you’re using a third-party data onboarding platform like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' to handle the heavy lifting here. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Conversation intelligence tools:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Hopefully (fingers crossed) your sales team is recording each and every sales call. There are tools such as Gong and Chorus where you can listen to relevant prospect and customer conversations. Before any kick-off and roadmap calls, customer success and onboarding teams should check out these critical conversations so that they have background related to how this new customer chose their company and product. Showing up prepared for the kick-off by fully understanding the customer’s use case makes an impactful first impression. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'User onboarding and workflow tools:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' Companies like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://onboard.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Onboard',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' provide solutions to help new customers get on the right track by providing automated personalized plans and workflows. User onboarding tools like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.trychameleon.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Chameleon',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' are designed for self-serve, improving product adoption. Onboarding a new customer and getting them into your product is no longer a manual effort.   ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Video training tools:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' The Zoom era means that video is expected. An easily digestible format, providing training videos to new customers ensures they can interact on their own time. Creating videos has never been easier so it’s an absolute must for your onboarding process. And the options here are plentiful. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://bombbomb.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'BombBomb',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.loom.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Loom',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' are great options for a quick video send, for example a personalized welcome from the customer success rep.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'User experience tools:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Once a customer is up and running - quickly - teams need to review the product experience from the customer’s point of view. Tools like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.pendo.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Pendo',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.fullstory.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'FullStory',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' should be part of your onboarding tech stack as they can show teams what the user experience is like at the beginning. As users log in the first few times, are they getting stuck in certain spots? Are there certain areas of the product that are confusing them? These tools are tremendously useful for product feedback because when you’re onboarding new users, you have a fresh pair of eyes on your product. With little to no experience, these new customers can point out functionality that might need an update or change...for the better. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There you have it, the ideal customer onboarding tech stack. While you may need additional tools in your toolkit for long term customer success, these suggestions can help ensure that you start the relationship off right, reduce any potential churn and generally provide the best onboarding experience possible for your new customers! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4IUrAyfm9sHe0PLAmwYI0C',
    postTitle: 'Data editing with Flatfile: 3 use cases',
    seoTitle: "How to edit data within Flatfile's data importer",
    seoUrlSlug: 'data-editing-with-flatfile-3-use-cases',
    seoMetaDescription:
      'In addition to onboarding data within Flatfile, you can edit data as well. Here are three use cases outlining how to edit existing data.',
    category: 'Data exchange',
    tags: ['Data editing', 'Flatfile use cases'],
    publishDate: '2021-08-06T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6EIbk5wkkcoQKLbQly5Vnu',
        type: 'Asset',
        createdAt: '2021-08-13T20:15:09.649Z',
        updatedAt: '2021-08-13T20:15:09.649Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data Editing with Flatfile by Roby Hyde',
        description: 'Data Editing with Flatfile by Roby Hyde',
        file: {
          url: '/img/contentful/6EIbk5wk-o2b5hqsxqeyuwzf2irow.webp',
          details: {
            size: 524438,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'O2b5HqsxQEyUwZF2IrOw',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Data Editing with Flatfile by Roby Hyde',
    summary:
      'In addition to onboarding data with Flatfile, did you know you can include data validations within your Flatfile workflow to quickly and easily edit existing data? Below is a short video that walks through a Flatfile workflow and the validation sequencing necessary to edit data with three helpful use cases. ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2rMBnDDtiGDAnj2CTbx7Aj',
        type: 'Entry',
        createdAt: '2021-08-13T20:14:10.860Z',
        updatedAt: '2021-10-07T00:24:36.747Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Roby Hyde',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7czu8ZQXdjXlGHJ4uoPzF2',
            type: 'Asset',
            createdAt: '2021-08-13T20:12:52.857Z',
            updatedAt: '2021-08-13T20:12:52.857Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Roby Hyde headshot',
            description: 'Roby Hyde headshot',
            file: {
              url: '/img/contentful/7czu8ZQX-53u1bewrqhwug7fqmzsi.webp',
              details: {
                size: 59448,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: '53u1bEWRQhWuG7FqmZsI',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Expert Customer Engineer',
        department: 'Customer Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In addition to onboarding data with Flatfile, did you know you can include data validations within your Flatfile workflow to quickly and easily edit existing data? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Below is a video that walks through a Flatfile workflow and the validation sequencing necessary to edit data with three helpful use cases. The flexibility of Flatfile is such that it can be moderated to become a data editor in these three unique situations! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '66tfhn7wmz6N56SEVtKW2g',
                type: 'Entry',
                createdAt: '2021-08-13T20:16:28.505Z',
                updatedAt: '2021-08-13T20:16:28.505Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data Editing with Flatfile: 3 Use Cases',
                url: 'https://www.youtube.com/embed/zzXiDpFFNoo'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'For more insight, check out the developers page for our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'documentation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' on how Flatfile’s platform can be used to solve your specific use case or simply reach out to us directly and we can talk through your needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Use case 1: Cleaning up user data that you already have on your server',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In this use case a user sends over a file via an SFTP or FTP server (or some other method) and instead of cleaning the data internally, you can rely on Flatfile. With Flatfile, the data is pre-populated and ready for review. The file is converted into a CSV and then Flatfile’s matching step does its job, walking the user through the data clean up process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Use case 2: Databasebase clean up with your QA team ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There may be certain scenarios where you know your data in-depth and don’t necessarily need to go through certain matching and validation steps. In this use case, data can go directly into the review step within Flatfile’s workflow. For this situation, there is data in your backend database that needs to be reviewed and cleaned by an internal data QA team. You can put a button in front of this team that launches Flatfile, preloading data from an API call to your backend database. Once the QA team goes through and edits the data directly, another API call is used to update the records directly in the database.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Use case 3: Creating a multi-step importer to remove non-US records  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A familiar use case for companies that are importing data across multiple countries, we see this use case quite a bit. If your importer is assuming all records are US records, like addresses for example, a user importing international data will break the validation logic in your importer. By creating a multi-step importer, you can edit the uploaded file, removing all non-US records before it hits your validation logic. In the Flatfile workflow, after a user uploads data, just filter out records you don’t want, like international addresses. From here you can chain together an importer. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5lU6QFkGHdHzIoohYxSlgh',
    postTitle: 'Why CRM Solutions Need a Better Data Importer',
    seoTitle: 'CRM Solutions Need a Better Data Importer',
    seoUrlSlug: 'why-crm-solutions-need-a-better-data-importer',
    seoMetaDescription:
      'The CRM market needs a better data onboarding experience for customers. Learn how companies are relying on an improved data importer.',
    category: 'Data Onboarding',
    tags: ['CRM', 'CRM solutions', 'Data importer'],
    publishDate: '2021-08-02T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1jLoXqgVpZCn8NmI7GPo0F',
        type: 'Asset',
        createdAt: '2021-08-24T16:47:14.667Z',
        updatedAt: '2021-08-24T16:47:14.667Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'CRM solutions need a better data importer',
        description: 'CRM solutions need a better data importer',
        file: {
          url: '/img/contentful/1jLoXqgV-6cwdo7zrhufzcbnqcqqa.webp',
          details: {
            size: 412601,
            image: {
              width: 2400,
              height: 1280
            }
          },
          fileName: '6cwDo7ZRHufZCbNQCqQa',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'CRM solutions need a better data importer',
    summary:
      'The CRM market has become increasingly verticalized, as industries find that they have specialized needs that are germane to their particular markets, and generalized CRM solutions aren’t serving them as well as they need. In response, there are providers that offer niche CRM solutions for specific markets, such as Digsy ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The CRM market has become increasingly verticalized, as industries find that they have specialized needs that are germane to their particular markets, and generalized CRM solutions aren’t serving them as well as they need. In response, there are providers that offer niche CRM solutions for specific markets, such as ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/flatfiles-data-importer-saves-digsy-up-to-10-hours-per-new-customer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Digsy',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' for real estate, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/cleanetto-leverages-the-flexibility-of-flatfile-portal-to-adapt-to-growing-file-import-needs'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Cleanetto',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' for cleaning companies, and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/waycool-software-enables-90-percent-of-customers-to-import-their-own-data-with-flatfiles-data-import'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'WayCool',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' for nonprofit organizations. Each industry has its own nuances and special challenges.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The customer data that gets imported into these CRM solutions is typically mission-critical regardless of the particular industry, comprising leads, contact information, and more, which necessitates fast and accurate ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. But that’s proven to be easier said than done. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These CRM solutions have a data onboarding problem - and their customers are taking notice.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Breaking templates, but finding key functionality ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In many cases, the types of data they pull into their CRM systems may be unique to their market and thus don’t fit a neat generalized template. Even customized templates for importing data are only as efficient as the data allows; usually, either the CRM provider or the customer has to spend a lot of time cleaning up the data to fit. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This is what ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://digsy.ai/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Digsy',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', a Smart Commercial Real Estate lead generation platform, ran into. Digsy enables real estate brokers to automate their workflows in order to speed up the process of converting prospects into leads. They start by uploading CSV files of customer data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The company quickly discovered that the data needed a lot of cleaning because so many of the files came from multiple sources and were inconsistently formatted. That meant using templates was insufficient, so instead of spending their own internal resources manually cleaning the data, the Digsy team built their own custom importer. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But it lacked key functionality, which hampered their ability to scale at the pace of their customer growth. To solve the problem, the company found that Flatfile’s column-matching feature in particular made it easier and faster to receive and resolve import errors.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'More fields for flexibility',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Part of the advantage of a vertically oriented CRM system is the ability to adapt quickly to changing client needs. Providers need the flexibility to add specific data types as their customers request them. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'For ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.cleanetto.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Cleanetto',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '’s cleaning company clients, flexibility in pricing options is an important feature. Initially, its system limited clients’ billing records to hourly service pricing. But cleaning companies calculate pricing in other ways sometimes, such as according to the number of bedrooms and bathrooms or by square footage. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'By using Flatfile, Cleanetto has been able to easily add these additional types of data categories. Its clients use the self-serve import tool when they migrate and onboard to Cleanetto, saving all parties hours or days of manual work. And thanks to the additional flexibility, Cleanetto has been able to grow its business, and its clients are better positioned for growth as well, such as by tackling commercial clients.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Freeing up internal resources',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Often, the largest issue that a better data importer can solve for these niche CRM companies concerns resources. Both Digsy and Cleanetto found this to be true, to degrees, and it was the primary pain point for ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.waycoolsw.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'WayCool Software',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'WayCool offers an affordable software platform for nonprofits to manage everything from donors to volunteers to client management. Nonprofits typically don’t have an abundance of funds or human time to throw at problems, so they have to be efficient. WayCool’s mission is to streamline all of the details and data that its nonprofit clients have to handle, with specialized and hands-on support. Neither party can afford the data import bottlenecks that so often emerge with manually onboarding data; they need to work smarter, not harder. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'WayCool was using its internal staff to manually import its clients’ data, which was expensive and draining. When the company’s team switched to Flatfile for data importing, they were able to recoup most of those resources and repurpose them elsewhere, in areas they needed to focus on for growth. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There have been knock-on benefits, too. Because Flatfile’s self-service importer is easy to use, WayCool’s customers can onboard their own data for the most part. The speed at which they can import that data--faster than WayCool could do it before, using its own internal resources--has enabled WayCool to offer a 15-day trial period to potential customers who want to try out the service before making a long-term commitment.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Solutions for niche CRM markets',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In order for CRM solutions to better serve vertical industries, providers need to offer customized solutions and hands-on support, and onboarding customer data has to be an optimal experience. These CRM providers need a better data importer for their customers--one that allows them to address the particulars of the market they serve quickly and smoothly, and one that removes the burden of time-consuming human labor. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '53dRHCyqCzTNWenribbBE5',
    postTitle: 'Why B2B SaaS companies need to rely on data onboarding',
    seoTitle: 'B2B SaaS companies need better data onboarding',
    seoUrlSlug: 'why-b2b-saas-companies-need-to-rely-on-data-onboarding',
    seoMetaDescription:
      'B2B SaaS companies spend too much time and effort importing customer data. Learn why these organizations need to adapt data onboarding.',
    category: 'Data Onboarding',
    tags: ['B2B SaaS', 'SaaS solutions'],
    publishDate: '2021-07-29T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6ibAMcUZQqOHU7tTV9T36y',
        type: 'Asset',
        createdAt: '2021-08-24T17:02:24.288Z',
        updatedAt: '2021-08-24T17:02:24.288Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'B2B SaaS Companies Need Data Onboarding',
        description: 'B2B SaaS Companies Need Data Onboarding',
        file: {
          url: '/img/contentful/6ibAMcUZ-qoskqpwgqskx7eoj5t4q.webp',
          details: {
            size: 94596,
            image: {
              width: 640,
              height: 341
            }
          },
          fileName: 'QOSKqpwgQSKX7eoj5t4Q',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'B2B SaaS Companies Need Data Onboarding',
    summary:
      'When you call something “low effort,” it’s usually a dig. But reducing the effort it takes to accomplish core tasks within a business is actually ideal and something to strive for. The benefits of SaaS are, in a way, all about reducing effort--and money and time--to achieve business goals faster ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When you call something “low effort,” it’s usually a dig. But reducing the effort it takes to accomplish core tasks within a business is actually ideal and something to strive for. The benefits of SaaS are, in a way, all about reducing effort--and money and time--to achieve business goals faster and more efficiently. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'B2B SaaS companies already know this. It’s part and parcel of the world in which they operate, what they offer, and why they exist at all. And they know that it’s key to remaining competitive in their respective markets. Even so, the SaaS field still has room for improvement when it comes to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'It doesn’t have to be that hard',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The fundamental action of SaaS is, after all, moving data--and doing so more swiftly than on prem. Flatfile believes data onboarding to be fast and effortless. Moving data from one place to another should be as easy as using an ATM, compared to going into a bank, waiting in line, and filling out a deposit or withdrawal slip.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'SaaS has become so prevalent because of its ease of use, especially when it comes to deployment. In many cases, you can sign some paperwork and create a login for a SaaS service and be up and running on the same day. Gone are the days of purchasing and then installing software on multiple machines on-premise. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But data onboarding is still an efficiency bottleneck for too many companies. This is especially true for mid-size B2B SaaS companies that find themselves deeper into the enterprise than ever before, where they often run into new layers of complexity that impede their usual flow. For many of them, it’s still a fairly manual process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The good news is that data onboarding doesn’t have to be that hard; it can be just as smooth and painless as other SaaS features companies have come to rely on and even take for granted.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Keeping pace',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The process should be easier for SaaS companies, because customers want to import data at the same speed as other tasks. They want to get up and running quickly in all facets of their operations, and getting their data imported faster means they can use their product sooner and begin extracting value from it in short order.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile helps B2B SaaS companies handle data onboarding at a similar pace as the rest of the SaaS environment. The ability to take in high-variance data from just about any source and get it into usable shape right away uncomplicates things and removes obstacles for business operations.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Practically speaking, Flatfile can integrate neatly into existing products, occupying a discreet middle ground. B2B SaaS companies can use Flatfile’s tools as essentially a component within a process. That’s part of what makes Flatfile’s platform so powerful and effective--it does crucial work unobtrusively even as it smoothes out otherwise difficult processes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The universal translator',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But even more than that, Flatfile’s vision is one in which there are no communication or formatting hurdles to moving data between businesses. In Star Trek, every sentient being in the universe, regardless of what planet or galaxy they were from, could conveniently communicate with one another via a universal translator. It flawlessly enabled these beings to speak clearly with one another--to pass data back and forth, as it were. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s what Flatfile aims to enable with data onboarding for B2B SaaS companies. No matter your market or the type of data transaction you’re performing, one business should be able to send a file full of data to another business, and it should “just work” within the destination system. It should be so seamless that you forget there was ever a barrier to begin with. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Increasingly, companies are going to exchange data even faster than ever before, and the nature of what that data comprises has and will continue to evolve in terms of type, volume, and complexity. Flatfile sits at the center of this low-effort revolution, enabling companies to move data for any business transaction with speed, ease, and precision.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5uCJv4OsiUIeTgnFh0hYRX',
    postTitle: 'Data Onboarding and ETL Tools: When to Use What',
    seoTitle: 'How ETL Tools and Data Onboarding Work Together',
    seoUrlSlug: 'etl-vs-data-onboarding',
    seoMetaDescription:
      'Data Onboarding can work alongside ETL tools. In this post we discuss when to use an ETL solution and/or data onboarding.',
    category: 'Data Onboarding',
    tags: ['Data onboarding', 'ETL'],
    publishDate: '2021-07-27T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4hsIJHnZnyao9acMYOOtDN',
        type: 'Asset',
        createdAt: '2021-08-13T20:18:21.550Z',
        updatedAt: '2021-08-13T20:18:21.550Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'How data onboarding complements ETL tools',
        description: 'How data onboarding complements ETL tools',
        file: {
          url: '/img/contentful/4hsIJHnZ-sza4g6wwslcdjyelms1f.webp',
          details: {
            size: 429868,
            image: {
              width: 2400,
              height: 1280
            }
          },
          fileName: 'SZa4g6wWSLCdjyelMs1f',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'How data onboarding complements ETL tools',
    summary:
      'Broadly speaking, ETL (extract, transform, load) is the process of taking data from one place, cleaning it up, organizing it, and moving it to another place - a data warehouse. It’s a data migration task that businesses of all sizes typically have to deal with. Because these companies’ ETL needs ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Broadly speaking, ETL (extract, transform, load) is the process of taking data from one place, cleaning it up, organizing it, and moving it to another place - a data warehouse. It’s a data migration task that businesses of all sizes typically have to deal with. Because these companies’ ETL needs involve a variety of data complexity and scale, they necessitate the use of different types and combinations of tools, costs, and human time and expertise.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Data onboarding',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              }
            },
            {
              nodeType: 'text',
              value:
                ' automates and streamlines much of this work, saving time, resolving complexity, and providing a user friendly interface that non-experts can use. Think of it as ETL for the masses. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'ETL projects and data onboarding',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In the ETL landscape, the need for data onboarding shows up in both large and small projects. It’s needed anywhere you have to import customer data into your products or services. That may involve migrating from other software products, importing spreadsheets and other file types like CSVs, and moving offline data online. The customer data is often messy, with errors or formatting issues, and it may need to be consolidated from multiple files.    ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Typically, large ETL projects are laborious and demand long hours of hands-on work from a data engineer or team of engineers who use precise tools and their own extensive expertise to clean up and validate that data and get it from point A to point B. Further, because of the complexity of the data work, the SMEs who understand the context and format of the data the best are, ironically, cut out of the ETL process. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Smaller ETL projects suffer from a related but different problem: Because of limited scale, it’s often cost prohibitive to bring in heavy-hitter data experts, like a data analyst and their expensive ETL solution and services. That effectively means that a customer doesn’t get the soup-to-nuts ETL treatment that they may prefer; instead, they have to spend time cleaning up their own data before handing it off to the business for importing. Even when businesses have a little more data muscle and can assume more of that janitoring work for the customer, the human labor burden isn’t eliminated--it’s just shifted somewhat to the business and off of the customer. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Data variance: when to use an ETL tool',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Another ETL challenge involves data variance. Current ETL systems were designed for high-value but low-variance data. As it pertains to data onboarding, low-variance data typically fits nicely into repeatable rule sets and specific formats. And so, even though low-variance data requires time and expertise to initially get through the ETL process, once it’s mapped, the hard part is done. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'By contrast, high-variance data is more heterogeneous. Think of transactional data, for example, which is marked by different file formats and different rules for each input--which may need to be redefined for different markets. You can’t use traditional ETL products in those cases. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The data onboarding sweet spot: how data onboarding works with ETL',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Data onboarding smoothes out most of those wrinkles. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It complements large or complex ETL projects primarily by saving human experts massive amounts of time, even in those cases when the project demands deep expertise and surgical precision. Because the data onboarding process handles so much automatically, it can knock days, weeks, or months off of an ETL project.    ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For less intensive projects, data onboarding replaces the bulk of the ETL process. It can bring ETL capabilities to businesses that previously couldn’t afford a standard ETL service, relieving burdens both from them and their customers. Because it handles so many technical aspects of ETL, including high-variance data, a data onboarding tool can give less technical people, like product managers and customer success teams, a familiar spreadsheet-like interface that they can work from so they don’t have to deal with things like SQL queries.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Data onboarding successes',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'You can probably imagine how data onboarding could benefit your customers, but here are real-life examples of companies that benefited from using Flatfile’s data onboarding tools:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Customs City',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://flatfile.com/blog/customs-city-relies-on-flatfiles-data-importer-to-improve-the-customer-data-onboarding-process-while'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Inkit',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://flatfile.com/blog/saving-inkit-100k-per-year-data-import-costs-flatfile-portal'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: '',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://flatfile.com/product/portal/'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Tablecloth',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://flatfile.com/blog/tablecloth-cuts-data-wrangling-issues-by-95-with-flatfiles-data-importer'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To sum it up: You can use expensive ETL tools and human experts to clean up and move your data--and in some cases, you have to. But that model isn’t a good fit, or even a viable option, for every business. Data onboarding automates and streamlines part of the ETL process. This can save human experts weeks or months of time, whether by automatically fixing high-variance data or just speeding up low-variance data work. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In other cases, data onboarding can reduce the need for businesses to offload preliminary manual data janitoring to their customers and allow less technical people to more effectively manage their ETL process.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '2hHCM0JNgg7KN3MOnDdAzk',
    postTitle:
      'Data Onboarding: An Underrated But Crucial Part of the Customer Experience',
    seoTitle: 'Data Onboarding is critical for the Customer Experience',
    seoUrlSlug:
      'data-onboarding-an-underrated-but-crucial-part-of-the-customer-experience',
    seoMetaDescription:
      'Providing smooth, seamless data onboarding is crucial in order to create a positive overall customer experience.',
    category: 'Data Onboarding',
    tags: ['Customer experience', 'Customer onboarding'],
    publishDate: '2021-07-22T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '72W5bm08PqIlg4rNy4D3tR',
        type: 'Asset',
        createdAt: '2021-08-24T17:04:45.289Z',
        updatedAt: '2021-08-24T17:04:45.289Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Proper customer onboarding improves the customer experience',
        description:
          'Proper customer onboarding improves the customer experience',
        file: {
          url: '/img/contentful/72W5bm08-snuipkgvrdu5ktomlm3m.webp',
          details: {
            size: 130038,
            image: {
              width: 2400,
              height: 1280
            }
          },
          fileName: 'SNuIPKgvRDu5kToMlm3m',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Proper customer onboarding improves the customer experience',
    summary:
      'A gold-standard customer experience is crucial to your business’ ongoing success. Great customer experiences can take many forms--and so can failed ones. The data onboarding process is an often overlooked but important part of the overall customer experience, and for many companies, it’s a daily challenge that they need to ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A gold-standard customer experience is crucial to your business’ ongoing success. Great customer experiences can take many forms--and so can failed ones. The data onboarding process is an often overlooked but important part of the overall customer experience, and for many companies, it’s a daily challenge that they need to solve.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'According to our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/flatfile-unveils-state-of-data-onboarding-report/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'State of Data Onboarding report',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', more than 90% of respondents have to transfer data from one system to another at some point, and 54% say they upload data every single day. Approximately 20% import customer data multiple times per day. And yet a staggering 78% have problems with their data onboarding process “sometimes” or “often.” ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A better, faster, more streamlined data onboarding process can make a huge difference in your customers’ overall experience with you.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Bottlenecks and barriers to data onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There are often bottlenecks that slow down the entire data onboarding process, like importing data manually, hunting down errors, and dealing with finicky custom importers. They create extra work for you, or the client, or both, and the tedium can be aggravating for any or all parties. None of that adds up to an optimal customer experience. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Because the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' process is one of the first meaningful interactions a customer has with your company, it functions as a critical first impression. You’re setting expectations for what it will be like to work with your company going forward. If data onboarding is a frustrating experience, what does that say to your customer about what it’s going to be like to work with you? Worst case, you’ll end up with costly churn.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'An outsized impact',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A difficult data onboarding process can have an outsized impact on the overall customer experience. A Flatfile customer learned quickly that importing data seems easy enough but can have serious consequences if not handled correctly. The team was using a homegrown importer and consistently ran into trouble with the tool’s rigid requirements. The result was a lot of back and forth with their clients. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Even though the data import was a small portion of their application - less than 10% - it was quickly becoming the number one issue that their clients were frustrated with. So, less than 10% of the application experience was resulting in 75% of the customer complaints. Thankfully the company acted swiftly - relying on Flatfile - and ensuring that their customers could seamlessly import their data and start getting value from their application.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Relieving the customer support crush',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Poor customer experiences also place an additional burden on your company’s customer support teams. When your team is tangling with complaints and problems about data issues, that’s just wasted time and expense, especially when there are ready solutions they could deploy to proactively solve them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'For ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/customs-city-relies-on-flatfiles-data-importer-to-improve-the-customer-data-onboarding-process-while/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Customs City Global Solutions',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', a company that helps other companies manage customs compliance, this was a frustrating problem until they used Flatfile to avoid upload failures and more easily validate CSV files before saving them to their database. The amount of custom support time Customs City regained with Flatfile was significant. Customs City president James May said that before, they might end up spending four or five hours troubleshooting file uploads for each client. “Add that up among a handful of clients and we’re probably saving 20-30 hours of support time per week,” he said.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Time spent on data import-related support also means that there’s less time for other support tickets. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/saving-inkit-100k-per-year-data-import-costs-flatfile-portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Inkit',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a company that makes a SaaS product to help automate direct mail to connect digital applications with the physical world of printers, brokers, and postal services. Before they switched to Flatfile, their customer support team was overwhelmed with data import requests--up to 30 hours per week as the company began to scale--and struggled to turn their attention to other support tickets.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Opportunity cost, opportunity lost',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As an organization, you don’t want to waste the abilities of your strongest swimmers in shallow waters. But that’s exactly what happens when your crack customer support team spends all their time messing about with individual customer data import issues instead of focusing on more value-add activities. They’re pulled away from developing new products, features, and services, as well as from tasks that could improve the customer experience, like creating guides that can help customers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That opportunity cost can be just as deep if your team tries to build and maintain its own custom importer. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/flatfile-importer-eliminates-onboarding-bottleneck-helps-enable-rapid-growth-for-flow/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flow',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' offers a task and project management system that streamlines companies’ workflows, but the company hit a hard bottleneck when it started to onboard customers who were jumping ship from a competitor. The lack of a smooth data onboarding process stood in the way of converting those interested parties to subscribed customers. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'All of Flow’s resources were tied up in working on their flagship product’s core features; there simply wasn’t anything left that they could devote to spinning up a custom data importer, let alone to maintain and improve one over time. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s what pushed Flow to turn to Flatfile’s data importer. “It removes a huge, long-term burden for us which allows us to focus on things that truly move the needle for our customers,” said Flow CEO Daniel Scrivner.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Lasting first impressions make for good lessons',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The data onboarding process is an experience that people have with your company, and it’s not perfunctory--it’s absolutely a critical part of the overall customer experience. It’s important that the first impression customers have with you is untainted by bottlenecks, barriers, and blocks. A smooth, efficient, and accurate data onboarding solution can also free up internal resources and allow you to focus your energy on growing your company and its products and services. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4SnBHYGidLfIVM7GLxEdsy',
    postTitle: 'An introduction to Flatfile record hooks for validation',
    seoTitle: "Flatfile's record hooks improve data exchange",
    seoUrlSlug: 'an-introduction-to-flatfiles-data-validations',
    seoMetaDescription:
      'Record Hooks within Flatfile help improve the data import process by validating data which ensures data is onboarded correctly.',
    category: 'Product updates & features',
    tags: ['Portal features'],
    publishDate: '2021-07-21T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6bX7VJItiTJVbMPKdIi4mC',
        type: 'Asset',
        createdAt: '2024-02-14T00:33:44.651Z',
        updatedAt: '2024-02-14T00:34:10.774Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Validators Image',
        description: '',
        file: {
          url: '/img/contentful/6bX7VJIt-blog_post_-_dg2_-_top_6_data_import_challenges.webp',
          details: {
            size: 80816,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Blog Post - DG2 - Top 6 data import challenges.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Flatfile goes through the different field validators within the data onboarding product',
    summary:
      "While there are many features that make Flatfile's leading data onboarding platform unique, the data healing elements, such as Data Hooks, are among the most powerful. In addition to Data Hooks, there are other validations offered in Flatfile which help ensure your data is imported seamlessly (and correctly!) In this ...",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27eaeZmIaSjzvHtSJtecoa',
        type: 'Entry',
        createdAt: '2022-03-02T15:25:45.695Z',
        updatedAt: '2024-02-09T19:08:12.571Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Ashley Mulligan',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: 'C06uIbjfkl4MCDuJSq0ua',
            type: 'Asset',
            createdAt: '2023-05-11T17:53:05.475Z',
            updatedAt: '2023-05-11T17:53:05.475Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 3,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'ashley',
            file: {
              url: '/img/contentful/C06uIbjf-ashley.webp',
              details: {
                size: 90296,
                image: {
                  width: 653,
                  height: 653
                }
              },
              fileName: 'ashley.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle:
          'Head of Growth Product & Developer Experience in Engineering',
        department: 'Engineering'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'While there are many features that make the Flatfile ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data Exchange',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' Platform unique, the data healing elements, like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/guides/handling-data'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data Hooks',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", are among the most powerful. And it's not just Data Hooks! There are other constraints offered in the Platform that help ensure your data is imported seamlessly (and correctly). ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "In this post, we'll dive into field constraints you can leverage beyond Data Hooks.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile Blueprint',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "If you haven't spent much time digging into ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/blueprint/constraints#composite-uniqueness'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile Blueprint',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ", you'll want to take a look at everything Blueprints have to offer. This is where you can set up your additional data validation. To use them, you'll add a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'constraints',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' array to a field that contains each separate validator as an object.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3vTTY1AGhqHac8PG23ZhpW',
                type: 'Entry',
                createdAt: '2021-08-24T17:39:33.417Z',
                updatedAt: '2024-02-14T00:19:02.584Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 18,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Field config with no validators',
                language: 'javascript',
                code: '```"fields": [\n  {\n    "key": "firstName",\n    "type": "string",\n    "label": "First Name",\n    "constraints": []\n  }\n]```'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Now that we've checked out the basic setup, let's talk about some of the specific constraints and what they do.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Required & unique validators',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'required',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' & ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'unique',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' validators let you easily use one of our specific constraint types to generate additional validations. The ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'required',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' type will display a validation error for any blank values for this field. The ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'unique',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                " type will throw errors for any duplicate values in a specified field, which can be especially helpful for de-duplication of records within a file. For example, we could receive an email address on every record and also ensure that an email isn't duplicated across the file.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We can set up the code as follows to obtain this behavior during imports:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1KqjDlTEKpwihFtrmokRro',
                type: 'Entry',
                createdAt: '2021-08-24T17:40:51.445Z',
                updatedAt: '2024-02-13T23:46:10.967Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 16,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Field config with keyword validators',
                language: 'javascript',
                code: '```"fields": [\n  {\n    "key": "firstName",\n    "type": "string",\n    "label": "First Name",\n    "constraints": [\n      {\n        "type": "required"\n      }\n    ]\n  },\n  {\n    "key": "email",\n    "type": "string",\n    "label": "Email",\n    "constraints": [\n      {\n        "type": "unique"\n      }\n    ]\n  }\n]```'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'External validators',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The next type of field validators allow you to specify any pattern for validating the data against using the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '@flatfile/plugin-constraints',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                " plugin. You'll want to import the plugin that you can find ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://github.com/FlatFilers/flatfile-plugins/tree/main/plugins/constraints'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'documented here',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Here's an example where we create a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'length',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' validator that sets the max length of 100 on the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'name',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' field. If the name is over 100 characters, an error message will be added:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'odelYDoTHQtAr89JJq2e6',
                type: 'Entry',
                createdAt: '2021-08-24T17:43:29.909Z',
                updatedAt: '2024-02-14T00:26:30.412Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 27,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Field config with external validator',
                language: 'javascript',
                code: "```listener.js\nlistener.use(\n  externalConstraint('length', (value, key, { config, record }) => {\n    if (value.length > config.max) {\n      record.addError(key, `Text must be under ${config.max} characters`)\n      // alternatively throw the error\n    }\n  })\n)\n```\n```blueprint.js\n\"fields\": [\n  {\n    key: 'name',\n    type: 'string',\n    constraints: [\n      { type: 'external', validator: 'length', config: { max: 100 } }\n    ]\n  },\n  {\n    key: 'age',\n    type: 'number',\n  }\n]```"
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Composite uniqueness validators',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The last type of validators are composite uniqueness validators. These Sheet-level validators can be split into two distinct strategies that define how to determine uniqueness. One is a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'concat',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' strategy and the other is a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'hash',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' strategy. An example of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'concat',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' validation could be a situation where we specify that a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'first_name',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' field and a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'last_name',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' field together have to be unique.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'concat',
              marks: [
                {
                  type: 'code'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' scenario via code is below:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5opaaP9C3YEVhBLOmcmqij',
                type: 'Entry',
                createdAt: '2021-08-24T17:45:34.647Z',
                updatedAt: '2024-02-13T23:58:49.755Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Field config with cross-field validators',
                language: 'javascript',
                code: '```"sheets": [\n  {\n    "name": "Products",\n    "description": "A list of products available for sale",\n    "slug": "products",\n    "constraints": [\n      {\n        "name": "constraint name",\n        "fields": ["first_name", "last_name"],\n        "type": "unique",\n        "strategy": "concat"\n      }\n    ],\n  }\n]```'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To learn about all the available options for fields, check out the Flatfile Blueprint documentation ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/docs/blueprint/constraints#composite-uniqueness'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'here.',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'ZITww7t7kf6CVu3EEcEVQ',
    postTitle: 'Flatfile helps Goodkind bring back face-to-face communication',
    seoTitle: "Flatfile's Data Importer Helps Goodkind with Onboarding",
    seoUrlSlug:
      'flatfile-data-importer-helps-goodkind-bring-back-face-to-face-communication',
    seoMetaDescription:
      "Goodkind uses Flatfile's data onboarding platform to improve the data import experience for Goodkind's customers.",
    category: 'Customer stories',
    tags: ['Case study', 'Customer success', 'Customer stories'],
    publishDate: '2021-07-14T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3sCVJIeJBAVKxduY6VSnIf',
        type: 'Asset',
        createdAt: '2021-08-10T20:42:58.431Z',
        updatedAt: '2022-01-05T12:20:50.812Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Goodkind case study',
        description: 'Goodkind case study',
        file: {
          url: '/img/contentful/3sCVJIeJ-ttu0hmiotpcrqzgbvdgo.webp',
          details: {
            size: 102589,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'tTU0hMIoTPCrQZgbvdGO',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Goodkind relies on Flatfile for customer data onboarding',
    summary:
      "According to industry research, 97 percent of an organization's outreach is left on the table when relying on traditional, impersonal outreach such as email and phone calls. The team at Goodkind is using personal video to bring back human connection and help businesses take advantage of all those missed opportunities ...",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "According to industry research, 97 percent of an organization's outreach is left on the table when relying on traditional, impersonal outreach such as email and phone calls. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The team at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.wearegoodkind.com/home/index.html'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Goodkind',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is using personal video to bring back human connection and help businesses take advantage of all those ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'missed opportunities',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' to solve this problem.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"Our philosophy is that over time with the growth of the Internet, people have lost the personal touch," said Michael Warshafsky, co-founder and CTO of Goodkind. "It\'s easy to send out an email blast or conduct a huge calling campaign to target people with personalized, but not personal outreach, but it\'s getting harder and harder to reach people. So we\'re bringing back the days when you walked into a local shop, and you knew the person that you bought from."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Goodkind helps companies create and send personal videos to their customers in a scalable way, allowing large numbers of employees to send one-to-one videos easily. Every Goodkind video is attached to an action: allowing you to sell products, book meetings, start chats and drive donations, right inside the video experience. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"There are many other kinds of personal video platforms out there," said Warshafsky, "but our ability to let the staff at all levels of an organization send out videos to single individuals makes us different. We are not a video platform per se but more of a ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'personal storytelling platform',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Goodkind currently has customers across education, travel, retail, and non-profit.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Overcoming data import issues with Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it came to solving the challenges of importing customer contact data, Goodkind turned to Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"We can\'t do anything without that information," said Warshafsky. "We also have integrations with other kinds of third-party software platforms, so we’re receiving data as CSVs and other formats. We need to bring it in, organize it, clean it, and get it ready to use."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Goodkind quickly found',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/product/portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' the Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' platform, a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data exchange solution',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ", to solve the problem and make it easy to ingest data from customers and third parties. One of the key benefits of using Flatfile is that Goodkind's support staff no longer have to worry about resolving data import issues like incorrect formats and missing data fields and are now free to handle more value-add activities.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"We were a Flatfile customer early on," said Warshafsky. "We went through the pains of importing data, but when we learned about Flatfile, we realized their platform was a good way to save serious time. As a startup, time is precious. We looked at some other open source solutions for importing data, but they didn\'t stack up. However, Flatfile’s level of execution was much better than anything else we found."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Warshafsky was also pleased that integrating the Flatfile data importer into the Goodkind platform was seamless. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"There is sometimes a perception of an implementation hurdle with a new platform," said Warshafsky, "but that wasn\'t true with Flatfile. With their documentation, you can get Flatfile\'s data importer going in a matter of days. The implementation process was easy."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Easing customer anxiety around importing data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Having Flatfile helped Goodkind quickly address the apprehension customers sometimes have regarding the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"After signing up, customers often have data import anxiety," said Warshafsky. "They worry that there will be too much work to get their data into our system. But when we show them the Flatfile solution, they\'re satisfied with the simplicity of the process. It\'s easier than they expected. We\'re importing data every day, and we never have a problem."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Warshafsky is pleased with his relationship with Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "\"What's rare about Flatfile is that they've been in the shoes of a startup and are very understanding of the problems a startup faces,\" said Warshafsky. \"I always get the feeling that they have our back, and they want us to succeed. That's refreshing because I think most software companies would treat us like just another customer. I don't feel that way with Flatfile.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"The ability to clean data in real-time during an import is precious," Warshafsky summed up. "Making sure that the data is correctly formatted is crucial to our customers. If the data isn\'t correct, the rest of the sequence stalls, so it\'s all about getting the first step right and knocking it out of the park, and that\'s what Flatfile does."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'About Goodkind',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Goodkind brings personal video and storytelling power to engage audiences and drive conversion across the customer journey. Goodkind brings personalized video to the masses and does it to make sense for business and with respect for the consumer. For the first time, personal video has been made scalable, measurable and customizable to the needs of modern organizations. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'For more information, visit',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.wearegoodkind.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' https://www.wearegoodkind.com/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: 'com or get started for free at',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '10yXR6mGkEUYbnXiKVRTJG',
    postTitle: 'How to Create a Vue.js CSV Data Importer in Two Minutes',
    seoTitle: 'Create a Vue.js CSV Importer in Two Minutes',
    seoUrlSlug: 'how-to-create-an-vuejs-csv-importer-in-2-minutes',
    seoMetaDescription:
      'The Flatfile Vue.js component helps companies import and manage CSV file data in minutes. Check out the tutorial to learn how.',
    category: 'Developers',
    tags: ['Flatfile tutorial', 'Vue.js'],
    publishDate: '2021-07-01T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6GuR4z1zIsgGU4fAxxkeb7',
        type: 'Asset',
        createdAt: '2021-08-10T22:03:28.220Z',
        updatedAt: '2021-08-10T22:03:28.220Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile Vue.js importer cover image',
        description: 'Flatfile Vue.js importer cover image',
        file: {
          url: '/img/contentful/6GuR4z1z-bhjj4z6qeufn4lz0mbwg.webp',
          details: {
            size: 107997,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'bHJJ4z6QeuFN4lZ0Mbwg',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Create a data importer with the Flatfile VueJS component',
    summary:
      'Vue.js is an open-source MVVM front end JavaScript framework for building user interfaces and single-page applications. With Vue.js applications, there are several ways to upload CSV files. And now, with Flatfile , the data import process is even simpler. The new Flatfile VueJS component handles all of the heavy lifting, ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1K9OykmxvXixKdJkQzQ1hu',
        type: 'Entry',
        createdAt: '2021-08-10T22:01:45.405Z',
        updatedAt: '2021-08-10T22:01:45.405Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Mark Pieszak',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '2llYg144Fu51FfzAgsodtS',
            type: 'Asset',
            createdAt: '2021-08-10T22:01:24.057Z',
            updatedAt: '2021-08-10T22:01:24.057Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Mark Pieszak headshot',
            description: 'Mark Pieszak headshot',
            file: {
              url: '/img/contentful/2llYg144-cpqiuuotjghmybiuw2vo.webp',
              details: {
                size: 12432,
                image: {
                  width: 329,
                  height: 329
                }
              },
              fileName: 'cPqiUuOTjGhmyBiUw2vO',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Vue.js is an open-source MVVM front end JavaScript framework for building user interfaces and single-page applications.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Vue.js applications, there are several ways to upload CSV files. And now, with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', the data import process is even simpler.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The new Flatfile Vue.js component handles all of the heavy lifting, letting companies import and manage ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'CSV file',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' data in minutes. Now let’s dig in and we’ll show you how.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Before we get started, let’s make sure to have a license key to use Flatfile. If you don’t have one already, you can sign up via ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://github.com/login?client_id=4264aa599bf28e2ce804&return_to=%2Flogin%2Foauth%2Fauthorize%3Fclient_id%3D4264aa599bf28e2ce804%26scope%3Duser%253Aemail%26state%3D'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'GitHub',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1YX9hAnD9YY8JGH6hKOew7',
                type: 'Entry',
                createdAt: '2021-08-11T21:45:25.624Z',
                updatedAt: '2021-08-11T21:45:25.624Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'How to create a Vue.js CSV importer in 2 minutes',
                url: 'https://www.youtube.com/embed/srH08jQaoBA'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now, let’s get the new Flatfile Vue.js library installed in our applications:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7IxvcLpvzEhIternUoQdMz',
                type: 'Entry',
                createdAt: '2021-08-11T15:45:56.797Z',
                updatedAt: '2021-08-25T16:57:31.724Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'npm install @flatfile/vuejs',
                language: 'shell',
                code: '```npm install @flatfile/vuejs```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'or ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4XPrl0vEwO76mUxTcvvLki',
                type: 'Entry',
                createdAt: '2021-08-11T15:46:31.258Z',
                updatedAt: '2021-08-25T16:57:46.556Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'yarn add @flatfile/vuejs',
                language: 'shell',
                code: '```yarn add @flatfile/vuejs```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now let’s head over to a Component we want to upload a CSV file in, and import ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'FlatfileButton',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' from ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '@flatfile/vuejs',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', and add it into our components object.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '332zooByPiZr8IdZW4wKFf',
                type: 'Entry',
                createdAt: '2021-08-11T15:47:29.994Z',
                updatedAt: '2021-08-11T15:47:29.994Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'import FlatfileButton',
                language: 'javascript',
                code: '```import { FlatfileButton } from \'@flatfile/vuejs;  // ← \n export default {\n   name: "SomeComponent",\n   components: {\n     FlatfileButton, // ← \n },```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Great! Now we’re able to use the new ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '<flatfile-button />',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' anywhere in this component.\n\nTo get started with the component, the only required inputs that need to be passed down are ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'licenseKey',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' (a String), ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'settings',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' (an Object), and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'customer',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' (an Object containing ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'userId',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' which is required). ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6RKumSdjYofugFOsspNtEC',
                type: 'Entry',
                createdAt: '2021-08-10T22:55:20.091Z',
                updatedAt: '2021-08-11T15:48:49.540Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Vue js button example 1',
                language: 'html',
                code: '```<template>\n  <div id=”app”>\n    <flatfile-button\n     :licenseKey="licenseKey"\n     :customer="customer"\n     :settings="settings"\n   >\n   <!-- note that you can put custom text/icons here if you’d like -->\n   </flatfile-button>\n  </div>\n</template>\n\n<script>\n  import { FlatfileButton } from "@flatfile/vuejs";\n  export default {\n   name: "App",\n   components: {\n     FlatfileButton,\n   },\n   data: () => ({\n     // 👇 Required\n     licenseKey: "--YOUR-LICENSE-LEY-HERE--",\n     // 👇 Required\n     customer: {\n       userId: "12345",\n     },\n     // 👇 Required\n     settings: {\n       type: "test import",\n       fields: [\n         { label: "Name", key: "name" },\n         { label: "Email", key: "email" },\n       ],\n     },\n   }),\n  };\n</script>```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Make sure to enter in your licenseKey above and now, we have a very basic and default Flatfile Vue.js behavior in our applications!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In a mere few minutes, we set up CSV import functionality and can harness the power of Flatfile to handle all of our CSV data migration needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Note: In this example we’ve passed in some arbitrary data for both customer and settings. For the customer user Id, we passed in 12345 - but this could be any value for the current user (in your system). For settings, we passed in some demo data for both “type” and “fields”. Just know that these are fully customizable, and should be designed to suit the types of columns/fields we’re expecting from our CSV imports.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So what if we want to customize everything a bit further? Let’s take a look at some of the other ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'optional',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' properties and methods that can be passed down via ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '<flatfile-button>',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' props.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the next example, we’re going to pass down a few optional values and methods via props.\n\nA ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'fieldHooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' object, that will run on the initialization of imports (between matching & review stages), and in our case we’ll set up a Field Hooks rule for the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'email',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' field. With ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'fieldHooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', we can do setup validation for columns, or even formatting data within a column (take for example, formatting a date column to transform the data in a specific way).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Next we’re going to pass down three methods to hook into lifecycle events in our import process. These prop methods we’ll be hooking into are: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'onData',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'onRecordInit',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'onRecordChange',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '. As the names imply, these are methods that we can pass down the Flatfile importer to fire off when these events occur.\n\nLastly we’re passing down another optional prop methods available to us, and this is `onCancel`. As the name suggests, we can fire off our own method here, whenever a user cancels or exits the import process entirely.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'uLANaHm5bhqRmlSAxhhD6',
                type: 'Entry',
                createdAt: '2021-08-11T15:49:43.125Z',
                updatedAt: '2021-08-11T15:49:43.125Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Vue JS button example 2',
                language: 'html',
                code: '```<template>\n\n <div id="app">\n   <flatfile-button\n     :licenseKey="licenseKey"\n     :customer="customer"\n     :settings="settings"\n     :fieldHooks="fieldHooks"\n     :onData="onData"\n     :onRecordInit="onRecordInit"\n     :onRecordChange="onRecordChange"\n     :onCancel="onCancel"\n     class="ff-button"\n  > <!-- note that you can put custom text/icons here if you’d like -->\n  </flatfile-button>\n </div>\n\n</template>\n\n<script>\n\nimport { FlatfileButton } from "@flatfile/vuejs";\n\nexport default {\n name: "App",\n\n components: {\n   FlatfileButton,\n },\n\n data: () => ({\n   // 👇 Required\n   licenseKey: "--YOUR-LICENSE-LEY-HERE--",\n   // 👇 Required\n   customer: {\n     userId: "12345",\n   },\n   // 👇 Required\n   settings: {\n     type: "test import",\n     fields: [\n       { label: "Name", key: "name" },\n       { label: "Email", key: "email" },\n     ],\n   },\n\n   // 👇 Everything else is optional 👇\n   fieldHooks: {\n     email: (values) => {\n       console.log({ values });\n       return values.map(([item, index]) => [\n         {\n           value: item + "@",\n           info: [{ message: "added @ after the email", level: "warning" }],\n         },\n         index,\n       ]);\n     },\n   },\n }),\n\n methods: {\n   onData: function (results) {\n     let errorState = false;\n     console.log("onData results{}");\n     console.log(results);\n     console.log(results.$data);\n     return new Promise((resolve, reject) => {\n       setTimeout(() => {\n         if (errorState) {\n           reject("rejected - this text is controlled by the end-user");\n           errorState = false;\n         } else {\n           resolve(\n             "Flatfile upload successful - this text is controlled by the end-user"\n           );\n         }\n       }, 3000);\n     });\n   },\n\n   onRecordInit: function (\n     record\n     /*index*/\n   ) {\n     console.log("onRecordInit");\n     return {\n       email: {\n         value: record.email + "@",\n         info: [{ message: "added @ on init", level: "info" }],\n       },\n     };\n   },\n\n   onRecordChange: function (\n     record\n     /*index*/\n   ) {\n     console.log("onRecordChange");\n     return {\n       email: {\n         value: record.email + "#",\n         info: [{ message: "added # on change", level: "warning" }],\n       },\n     };\n   },\n\n   onCancel: function () {\n     console.log("canceled!");\n   },\n },\n};\n\n</script>```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In just a few minutes, we set up CSV import functionality in a Vue.js app, and can now harness the power of Flatfile to handle all of our CSV data needs.\n\nTo view the Flatfile Vue.js importer in action, check out the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://codesandbox.io/s/nostalgic-johnson-2wgqn?file=/src/App.vue'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Codesandbox demo here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '\n\nTo view the code for the Flatfile Vue.js component, find it on ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://github.com/FlatFilers/vuejs-adapter'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'GitHub',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7EDRXhBJNsSgUC2Z4ymPhr',
    postTitle: 'Reduce customer churn with better onboarding: Here’s how',
    seoTitle: 'Better Onboarding Can Reduce Customer Churn',
    seoUrlSlug: 'how-better-onboarding-can-reduce-customer-churn',
    seoMetaDescription:
      'Flatfile is joined by the Customer Success Association, Donna Weber, and Onboard.io in a webinar focused on improving customer onboarding.',
    category: 'Data exchange',
    tags: ['Customer churn', 'Customer success'],
    publishDate: '2021-06-30T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'UvRcpifwm1AO0nWofnaEv',
        type: 'Asset',
        createdAt: '2021-08-10T19:53:13.802Z',
        updatedAt: '2021-08-10T19:53:13.802Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Secrets of customer churn reduction',
        description: 'Secrets of customer churn reduction',
        file: {
          url: '/img/contentful/UvRcpifw-qs80hrdrrssmledqf5zs.webp',
          details: {
            size: 194868,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Qs80hrdrRsSmLeDQf5zs',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Secrets of Customer Churn webinar',
    summary:
      'Avoidable customer churn is costing U.S. businesses $136 billion a year. (Check out more customer churn and onboarding stats) Companies today need to execute a flawless onboarding experience for their customers. Not only does a positive onboarding experience ensure that the relationship gets off on the right foot but better ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Avoidable customer churn is costing U.S. businesses ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.gravysolutions.io/post/customer-churn-rate-and-retention-top-25-stats-you-need-to-know'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '$136 billion',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' a year. (Check out more',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/onboarding-statistics/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: 'customer churn and onboarding stats',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.)  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Companies today need to execute a flawless onboarding experience for their customers. Not only does a positive onboarding experience ensure that the relationship gets off on the right foot but better customer onboarding can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'reduce the risk of churn',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.   ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'According to Donna Weber, consultant and author of the book ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Onboarding Matters',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ': ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Bringing customers onboard is the most important part of the customer journey. Yet, despite this being so critical, poor onboarding is the main cause of churn. It’s estimated that more than half of customer churn is related to poor customer onboarding and poor customer service.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile along with the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.customersuccessassociation.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Association',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' brought together an exciting panel discussion dedicated to the ways in which companies can reduce churn through better customer onboarding.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Below are four lessons learned from the recent webinar featuring Donna Weber, consultant and author of Onboarding Matters along with Will Stevenson, Co-Founder and COO of Onboard.io and our very own Ryan DeForest who leads Support Operations and Strategy here at Flatfile.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If interested in watching the webinar, check it out: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5pBbCeQPJYvyv6wIQHIEH0',
                type: 'Entry',
                createdAt: '2021-08-25T17:03:48.892Z',
                updatedAt: '2021-08-25T17:03:48.892Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'The Secrets of Customer Churn Reduction: Onboarding your Customers Faster, Smarter, Better',
                url: 'https://www.youtube.com/embed/geKpipHgi00'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. The hand off is not the kick off ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When most companies close a deal they jump right into the kickoff and start diving into the technical weeds. There are data migrations, APIs to connect, customizations, etc. But giant to do lists are no way to start a relationship. Your internal teams and customer-facing teams should be aligned - ideally that’s where the handoff comes in - you’ve established a relationship and now you’re showing customers the path to success. There shouldn’t be a feeling of being passed off on the customer’s side, rather it should feel like a smooth transition. This feeling can make or break trust early on in onboarding. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Visibility and accountability are key  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It’s important to provide visibility and transparency to customers early on. Customers should always know what they should be doing or who specifically should be doing what. It’s difficult to hold customers accountable without any visibility into the process. Speaking of accountability, it’s essential for effective onboarding. Customers need to be held accountable to what they agreed upon so that they can in turn be successful with your product (success = less likely to churn). If you bought a car and didn’t know how to drive, you would want to learn. The same applies to software. When a company makes a software purchase they want to use it and so they need to learn. The more you can hold them accountable early on, the better. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. Practice proactive onboarding',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are ways to proactively get ahead of the handoff and provide a more personalized onboarding experience. Before meeting with the customer there are sales calls you can listen in on, support tickets that may have been filed. Coming into a new customer relationship armed with knowledge is pretty powerful. There are technologies like Flatfile that help with the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' process, ensuring its smooth and seamless. Starting off with a good first impression means you’re building a solid relationship with the customer from day one. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '4. Onboarding roles within your company will depend on your company ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is to say that roles and responsibilities for customer onboarding are dependent on many factors such as the product you sell as well as the size of the customer within your customer base. At Flatfile, we’re fairly tech heavy from the start and work with a company’s engineering team. In this way the onboarding focus is on the implementation itself. Other companies don’t need engineers involved to get their products up and running and a Customer Success Manager role could serve as implementation specialist and trainer all rolled into one. It’s critical to make sure you know the roles and the direction you’re headed in as a business so that your customer has the best experience possible. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '2cJKagqM69o9rmCs97AKxl',
    postTitle:
      '5 questions with Saurabh (Jas) Jaiswal, Head of Growth/Scale at Flatfile',
    seoTitle: "5 Questions with Saurabh Jaiswal, Flatfile's Head of Growth",
    seoUrlSlug:
      '5-questions-with-saurabh-jas-jaiswal-head-of-growthscale-at-flatfile',
    seoMetaDescription:
      'Saurabh (Jas) Jaiswal leads Flatfile as Head of Growth and Scale. Learn more about Jas and his role at Flatfile as well as our open roles.',
    category: 'Flatfile news',
    tags: ['5 questions', 'Flatfile employee spotlight'],
    publishDate: '2021-06-25T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5JXfW8cpMmFBJ7DlmN24nI',
        type: 'Asset',
        createdAt: '2021-08-11T17:05:44.298Z',
        updatedAt: '2021-08-11T17:05:44.298Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Jas Jaiswal joins Flatfile as the head of growth',
        description: 'Jas Jaiswal joins Flatfile as the head of growth',
        file: {
          url: '/img/contentful/5JXfW8cp-s4xbedffqpwzxp9itds0.webp',
          details: {
            size: 1022543,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'S4xbEDffQPWzXP9itds0',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Jas Jaiswal joins Flatfile as the head of growth',
    summary:
      'While Flatfile scales our team, we’re excited to have Saurabh Jaiswal on board as head of growth/scale. We sat down with Jas to learn more about his background. Q: Why Flatfile? (And what do you do here?) I joined Flatfile for two reasons - data and people. As a lifelong ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'While Flatfile scales our team, we’re excited to have ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/jaspurdue/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Saurabh (Jas) Jaiswal',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' on board as head of growth/scale. We sat down with Jas to learn more about his background.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q: Why Flatfile? (And what do you do here?) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'I joined ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' for two reasons - data and people. As a lifelong data nerd, I was immediately attracted to Flatfile’s vision of enabling seamless data transactions between every organization in the world. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A few weeks of ad-hoc conversations with several members at Flatfile and I knew that this was going to be an experience like none other. I have met my fair share of founders at small and large institutions but David and Eric are unique in their ability to challenge the status quo. It's infectious and something I strongly resonate with.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At Flatfile, I’m focussed on scaling our operations in order to support more customers. This entails adopting consistent processes (first principles) to optimize the accuracy and speed with which we can serve our customers. It starts with defining team specific SMART goals that align with our overarching business objectives. My goal is to support every function within the organization but the past few months have been focussed on go-to-market strategy.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q:  With an extensive background in strategy consulting, can you talk about some of the toughest challenges you’ve faced in those roles? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I’ve been fortunate to work in a variety of different industries ranging from SaaS, healthcare, financial services, consumer products, and real estate. The biggest challenge that I personally and professionally grew from was at a dialysis company DaVita. I joined Home Dialysis (imagine a startup funded by a large corporation) with an enormous goal to change the dialysis offered in the United States. At the end of the 3 years, we not only achieved our ARR goal of $1B but more importantly impacted countless patients who were able to live a longer and healthier life. This entailed managing centralizing care to ~20k patients across 1500 clinics with a staff of ~1000 individuals ranging from dieticians, social workers, nurses, regional directors and VPs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: Measuring growth can be distracting for companies who feel overwhelmed by so much data. How do you approach measuring performance? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to KPIs, there’s no shortage of data; every click creates 10 new data points. In order to avoid analysis paralysis, I follow this 3 pronged approach:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Articulate business objective(s)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Set SMART stretch goals; should be in alignment with business objectives. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Focus on data that’s actionable/has significant ROI; lead with “Why does it matter?”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Learning quickly and failing fast is essential at a startup. The Reds and Yellows on a dashboard should direct focus to a challenging problem.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Don’t forget to set BHAG (big, hairy & audacious goals) goals with roadmap/checkpoints. Striking the right balance between daily execution and a long term strategy is critical; something that requires constant attention.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Last but not the least, analytics should be balanced through this 4 quadrant lens:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '70ooOPZP6WSLUzXznnQEu4',
                type: 'Asset',
                createdAt: '2021-08-11T17:06:51.731Z',
                updatedAt: '2021-08-11T17:06:51.731Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Analytics graphic',
                description: 'Analytics graphic',
                file: {
                  url: '/img/contentful/70ooOPZP-ombkg4wmt7uxy9ugody5.webp',
                  details: {
                    size: 89817,
                    image: {
                      width: 854,
                      height: 495
                    }
                  },
                  fileName: 'OMbkg4wMT7uXY9uGODy5',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: In addition to too much data, businesses are also dealing with a proliferation of technology tools. How do you recommend companies sift through the noise to get what they need (and will use)? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Tools are a means to an end and there’s always the next shiny one (who doesn’t want the new iPhone). However, I firmly believe that there’s simplicity on the other side of complexity and it starts with defining processes. Ask yourself, how would you do it with google docs - which will focus the attention away from tools for a minute.“You don’t always need the five course meal tool”.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Tools should justify the following criteria',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ease of maintenance as much as implementation',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Automation vs quick manual workaround (first principles) ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Integrations (future agnostic)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Healthy analytics',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: What were you binge watching during the pandemic days?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I hardly watch TV but Friends is my go to “guilty pleasure” and I will never get tired of it. So many themes that many of us can relate to. You can find Friends memorabilia all over my house!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Want to learn more about Flatfile and join our team? Check out our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'open positions',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5a8ZJkffLH1qTn9rl85aiX',
    postTitle:
      'Step Hooks help Flatfile users customize the data import process',
    seoTitle: 'Step Hooks Helps Flatfile Users Import Data',
    seoUrlSlug: 'new-data-hook-alert-step-hooks',
    seoMetaDescription:
      "Step Hooks, part of Flatfile's Data Hooks, helps users better customize the data import process. Learn more about this product feature.",
    category: 'Product updates & features',
    tags: ['Data hooks', 'Step hooks', 'Product updates'],
    publishDate: '2021-06-22T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5KAAUB6hfHDLpRFwa5CN6Y',
        type: 'Asset',
        createdAt: '2021-08-09T22:51:27.472Z',
        updatedAt: '2022-01-05T13:37:28.244Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Step hooks bulk add contacts screenshot',
        description: 'Step hooks bulk add contacts screenshot',
        file: {
          url: '/img/contentful/5KAAUB6h-rcs7tanurv2jtrb4i1uo.webp',
          details: {
            size: 207398,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'RCs7tanURv2JTrB4i1uo',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Flatfile explains the benefits of the Step Hooks feature',
    summary:
      'With Flatfile’s Data Hooks ® feature, you can run custom functions on both Fields (columns) and Records (rows) within files that are imported. They are useful for defining complex validation, transformation, and lookup logic like: "If the country is United States, the postal code must be 5 digits" "Does this ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'With Flatfile’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/flatfileioblogdata-hooks-guide/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Data Hooks',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '® feature, you can run custom functions on both Fields (columns) and Records (rows) within files that are imported. They are useful for defining complex validation, transformation, and lookup logic like:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '"If the country is United States, the postal code must be 5 digits"',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '"Does this email exist in my database?"',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '“Remove all special characters”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our next iteration of Data Hooks® now includes Step Hooks, which let you customize the import process itself. With Step Hooks you can pause the import flow at various steps, allowing your customer to review or augment the data being shared. A Step Hook, for example, allows you to perform validation based on matched headers ahead of the review step. You can also automatically append fields that might not have been included in the original data set. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Here's some example data for the code below. If you want to follow along, ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://codesandbox.io/s/vanillajs-step-hooks-playground-72ou3?file=/src/index.js'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'check out the playground',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' with this setup.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5dKJmiUrH6gQK3iZApSGqY',
                type: 'Entry',
                createdAt: '2021-08-10T16:34:33.310Z',
                updatedAt: '2021-08-27T17:13:38.430Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'table'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'People with first and last names',
                table: {
                  tableData: [
                    ['First Name', 'Last Name'],
                    ['Marshall', 'Ericson'],
                    ['Winston', 'Schmidt'],
                    ['Jim', 'Brockmire'],
                    ['Stanley', 'Hudson'],
                    ['Blonde', 'David']
                  ]
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For this example, we will assume that the schema is expecting a ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'first_name',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and a ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'last_name',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' key. When we use step hooks, we get to see what the matching status is for the user after ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'upload',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' , before ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'matching',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and/or before the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'review',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' step. We also can get a hook that runs when a user matches or de-selects a match during the matching step using ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'match_field',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' .',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Let's take a look at how to use it and what the expected output might look like for the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'review',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' step. This hook runs during the import when we click the "review" button pictured here. Whatever code you write into the below hook will run in the time between when the button is clicked and the review state loads - with the data inside of the review table.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '34m3Q6b3L1V1Tkyk0gokSE',
                type: 'Asset',
                createdAt: '2021-08-27T16:04:17.145Z',
                updatedAt: '2021-08-27T16:04:17.145Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Bulk add contacts',
                description: 'Bulk add contacts',
                file: {
                  url: '/img/contentful/34m3Q6b3-ir683bvuqjicxzw9ceyn.webp',
                  details: {
                    size: 621559,
                    image: {
                      width: 3338,
                      height: 1516
                    }
                  },
                  fileName: 'ir683BvUQjiCXZW9cEYN',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6bPI8rUPApm4wjqLpl1m4P',
                type: 'Entry',
                createdAt: '2021-08-11T16:52:13.458Z',
                updatedAt: '2021-08-11T22:15:05.551Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 10,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Step hooks example',
                language: 'javascript',
                code: '```importer.registerStepHook("review", (status) => \n  {   console.log(status) })  \n// output structure when first_name and last_name are  \n// mapped properly by the user \n{ \n  batchId: "batch-ID-of-the-import", \n  fileName: "file_name.csv", \n  fileSize: 105, \n  count_column: 2, // number of columns in the file \n  count_rows: 4, // number of records in the file \n  fileType: "text/csv", \n  headers_matched: [ \n    { \n      index: 0, \n      letter: "A", // column index order \n      matched_key: "first_name" \n    }, \n    { \n      index: 1, \n      letter: "B", \n      matched_key: "last_name" \n    } \n  ], \n  headers_raw: [ \n    { \n      index: 0, \n      value: "First Name", \n      letter: "A" \n    }, \n    { \n      index: 1, \n      value: "Last Name", \n      letter: "B" \n    } \n  ], \n  sample: [ \n    [ \n      ["First Name", "Last Name"], 0 \n    ] \n    [ \n      ["Marshall", "Erickson"], 1 \n    ], \n    [ \n      ["Winston", "Schmidt"], 2 \n    ], \n    [ \n      ["Jim", "Brockmire"], 3 \n    ], \n    [ \n      ["Stanley", "Hudson"], 4 \n    ] \n  ] \n}```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So in this example, we see what the state of the matching is compared to what the original/raw headers were, a sample set of data, and also some metadata about the file.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Here are a few examples of how Flatfile users can take advantage of Step Hooks:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "Compare the data in the upload to your system to make sure the exact same file hasn't already been uploaded.",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Confirm the number of rows in the file before receiving the results.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Determine if you need to create an additional field during this process. For example, maybe you want to accept ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'first_name',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' and ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'last_name',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' but your desired state is ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'full_name',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' . You could create the ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'full_name',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' field inside of one of these step hooks using the ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'addVirtualField',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        " method. If that final scenario interests you, we've created a ",
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: '/developers/guides/creating-virtual-fields-dynamically/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value:
                            'guide for creating virtual fields dynamically here',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With step hooks, you can follow along the import as the user is going through the process and can use that information to influence different pieces of the import with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Step Hooks are currently in Beta. If you would like access to this, please reach out to us at support@flatfile.io.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '51UriNKkIuOG6WOT29LG9o',
    postTitle: '5 data onboarding challenges developers face',
    seoTitle: 'Data Onboarding Challenges for Software Developers',
    seoUrlSlug: '5-data-onboarding-challenges-developers-face',
    seoMetaDescription:
      'Developers struggle with data onboarding challenges. Tired of building custom data importers? Flatfile helps get usable data faster.',
    category: 'Data exchange',
    tags: ['Developers', 'Software Engineers'],
    publishDate: '2021-06-02T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3FriAy3MEPRgk61NQrIlNU',
        type: 'Asset',
        createdAt: '2021-08-11T17:03:15.930Z',
        updatedAt: '2021-08-11T17:03:15.930Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '5 data onboarding questions cover photo',
        description: '5 data onboarding questions cover photo',
        file: {
          url: '/img/contentful/3FriAy3M-rsusumvxqhsxvxca6irz.webp',
          details: {
            size: 641152,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'RSUSumvXQhSxvxcA6iRz',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'A list of challenges software developers face when onboarding data',
    summary:
      'Despite advances in automation in all areas of our personal and business life, data onboarding – the task of importing customers’ required data into a new software product – has remained a mind-numbingly manual process for many companies. The lack of automation means data onboarding problems fall squarely into the ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1EJNlpgVdCqaKkPEfcBMRp',
        type: 'Entry',
        createdAt: '2021-08-11T17:02:03.675Z',
        updatedAt: '2021-10-07T00:11:51.298Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Nate Ferrero',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7LIEnmOzIoWUUfNT79aoSr',
            type: 'Asset',
            createdAt: '2021-08-11T17:00:32.925Z',
            updatedAt: '2021-08-11T17:00:32.925Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Nate Ferrero headshot',
            description: 'Nate Ferrero headshot',
            file: {
              url: '/img/contentful/7LIEnmOz-pkczul3jqfg0unqvttft.webp',
              details: {
                size: 43537,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'pKCzul3JQFG0unqvTtFt',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Senior Full-Stack Engineer',
        department: 'Engineering'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Despite advances in automation in all areas of our personal and business life, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' – the task of importing customers’ required data into a new software product – has remained a mind-numbingly manual process for many companies. The lack of automation means data onboarding problems fall squarely into the lap of the organization’s development team. In smaller companies, this translates to one or two individuals focused on importing customer data when they have many other more important tasks on their plate, such as building new product capabilities. But those responsibilities often ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'fall by the wayside',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' as harried developers drop everything to grapple with issues surrounding data importing.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'XK9Gbxev6BfqcrRSg2wm0',
                type: 'Entry',
                createdAt: '2024-07-26T21:26:45.616Z',
                updatedAt: '2024-07-31T03:35:48.735Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 12,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Spend 70% less time onboarding data',
                text: 'Join a free demo to learn how to collect, map, validate, transform and convert the data that powers your business. Faster.',
                ctaText: 'Save my seat',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are five data onboarding challenges that developers frequently face.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. Formatting data: What you see is what you get ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the biggest issues developers face when it comes to data onboarding is that they have no control over the condition of incoming data files. In particular, formats can be all over the place, making the data import process extremely difficult. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Many organizations that need to onboard data regularly try to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'mitigate this problem',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' by sending their customers templates that  standardize the formatting of files. Unfortunately this rarely works because the customer lacks the technical resources to properly use the templates. The end result is that incoming files will require manual intervention – often by a developer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Clean up in column X',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A serious resource drain for developers during the data onboarding process is the time spent wrangling with files that contain multiple errors. These messy files are often unorganized and unlabeled and must be cleaned before they are imported into a solution, otherwise they will not be able to meet the needs for which they are intended. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Issues with files that require manual correction include inconsistencies within the data for things like formatting dates, phone numbers, currency and country codes, misspellings, missing rows or columns, errors in sub value or category mapping. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '3. Reinventing the wheel: Developing a custom solution again',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Correcting file errors takes an enormous amount of time and in many cases must be manually handled for every file that comes in. Without some automated way to handle data onboarding, developers will be required to manually enter SQL queries into the database. They would have to open the file, copy out parts of it, write it into a query, and hit submit in another piece of software. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The problem is compounded since a developer must find or create a parser for each file type that arrives. Also, your team has to spend time scheduling a feature request for each new file format that needs to be imported. This process is like redeveloping a custom solution for every new import request. Once again, this wastes time and drains limited developer resources.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Need it yesterday…or sooner',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'And it’s not like developers can handle all this additional work at their leisure. There is constant pressure from the business to get data onboarded quickly. The sales team might have been working for months to land a new client and when they finally seal the deal, they want to quickly demonstrate the benefits of their product. This can’t be done without loading customer data into the software application. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For developers, that means dropping whatever project they’re doing and working with the new client to get their data onboarded quickly. This is normally the first interaction with a new client and performing flawlessly at this early stage is critical to showing the client they made the right choice. That puts the onus on developers to perform rapidly and accurately - ensuring data is migrated effectively.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. Limited developer resources',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When it comes to the data onboarding process, developers often become the most popular people in the room. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Importing data',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' into a software application can be a highly technical task, so every data import issue becomes a new problem. In smaller companies, there may be only one or two trained developers on staff, so data importing places an enormous strain on these limited resources. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'While a developer is consumed with solving data import problems, many other value added tasks like adding a new feature set requested by the organization’s customers are put off to the side to be dealt with later. This can lead to developers spending an inordinate amount of time handling short term data onboarding problems rather than focusing on longer term product development that could lead to greater organizational success.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How Flatfile can help developers',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' is an automated data importer that allows ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/teams/engineering/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'developers',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' to get to usable data faster so you can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/this-missing-piece-in-your-data-integration-stack-costing-you-millions/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'focus on more pressing to-dos',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: "Flatfile's data importer:",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Implements in hours with just a few lines of code',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Helps you set a target model for data validation, allowing users to match incoming file data',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Learns over time how data should be organized, saving time and making the process more efficient',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Provides validation features giving customers control over how data is formatted',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ensures imported data is clean and ready to use',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Are you a developer constantly dealing with data import issues? Flatfile can get you out from under the burden of data onboarding so you can focus on more value-add development tasks. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2PfjzZJzFs75bZvfCfX6Fr',
                type: 'Entry',
                createdAt: '2024-05-29T16:16:41.053Z',
                updatedAt: '2024-07-30T23:58:59.590Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 47,
                revision: 5,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding should be fast and painless',
                text: 'Our free in-depth guide will help you address data onboarding challenges and help new customers become customers for life.',
                ctaText: 'Download today',
                href: '/resources/guides/the-customer-success-leaders-guide-to-successful-data-onboarding/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '4q13CiL45VAbA2K6FgsrL5',
    postTitle:
      'Cleanetto leverages the flexibility of Flatfile to adapt to growing file import needs',
    seoTitle: 'Cleanetto uses Flatfile for Growing Import Needs',
    seoUrlSlug:
      'cleanetto-leverages-the-flexibility-of-flatfile-portal-to-adapt-to-growing-file-import-needs',
    seoMetaDescription:
      "Cleanetto's software for cleaning businesses relies of Flatfile's data importer to migrate data for clients, cleaners and bookings.",
    category: 'Customer stories',
    tags: ['Case study', 'CRM', 'Customer stories'],
    publishDate: '2021-05-25T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4y33FWuUoFlgymSMIjY17c',
        type: 'Asset',
        createdAt: '2021-08-11T23:35:05.292Z',
        updatedAt: '2021-08-11T23:35:05.292Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Cleanetto relies on Flatfile for data onboarding',
        description: 'Cleanetto relies on Flatfile for data onboarding',
        file: {
          url: '/img/contentful/4y33FWuU-lcp9p5l0tlggpp5erh4p.webp',
          details: {
            size: 93235,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'LCP9P5L0TLGgPP5ErH4P',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Cleanetto relies on Flatfile for data onboarding',
    summary:
      'In 2020, the U.S residential cleaning business was nearly $900 million, growing at an expected 2% per year. Despite ongoing growth, the industry remains largely a subscription business, subject to churn. Cleanetto has developed an all-in-one software product that provides cleaning companies with the necessary tools to keep recurring clients ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In 2020, the U.S residential cleaning business was nearly $900 million, growing at an expected 2% per year. Despite ongoing growth, the industry remains largely a subscription business, subject to churn. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.cleanetto.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Cleanetto',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' has developed an all-in-one software product that provides cleaning companies with the necessary tools to keep recurring clients for longer periods of time.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Our software helps cleaning companies create stronger connections that ultimately results in less churn,” said Miguel Zabludovsky, Founder and CEO of Cleanetto. “The average city has over 300 cleaning companies. We help our clients differentiate themselves from the other 299.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Importing data from multiple sources with ease',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Cleanetto software allows its global customers to set up and monitor bookings, cleaning personnel assignments, scheduling status, and payroll, and enables them to communicate this information both internally and externally as needed. In order for the software to provide this level of detail, data needs to be imported from multiple sources. Cleanetto partnered with Flatfile to meet this data import challenge.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We’re importing primarily three types of data,” said Zabludovsky. “Clients, cleaners, and bookings. And we do that right from the imports tab where we integrated Flatfile. That makes the entire process very easy to carry out.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Cleanetto must import data every time they land a new customer.  Migrating the names of clients and cleaners as well as booking information from other software tools into the Cleanetto platform was an ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'extremely difficult and cumbersome process',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' prior to Flatfile.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Clients would have to figure out how to get their data into our system,” said Zabludovsky. “This would take a great deal of time and effort on their part since many of them don’t have technical staff available.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The types of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '/blog/top-6-csv-import-errors-and-how-to-fix-them/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data errors',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' Cleanetto typically saw included inaccurate email addresses, a major problem since contacting residential clients and cleaners is mission critical for Cleanetto’s customers. Other issues as a result of  manually importing data included incomplete or inaccurate physical addresses, and mismatched services and rate.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Implementing ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform ',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                'streamlined the process for customers to upload their data saving critical time and resources. Zabludovsky estimates the use of Flatfile has saved customers hours and sometimes days getting their data imported into the Cleanetto application.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "“We integrated Flatfile right into our migration and onboarding process and we always highlight to customers how easy the self-serve import tool is to help them move over their data,” said Zabludovsky. “Whatever system clients are in now, whether it's Excel, Google Calendar, Launch27, Zenmaid, Jobber, whatever it is, customers can bring over their data in minutes.”",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile’s data onboarding platform',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' flexibility is key for Cleanetto',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The flexibility of the Flatfile solution has been particularly important to Cleanetto as their business – and their data importing needs – continue to expand.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“As we grow, we are realizing the need to add more fields for different pieces of data we need to import to customer records and Flatfile allows us to do that quickly,” said Zabludovsky. “It’s been simple to set up and flexible enough to evolve as we add complexity. For example when we first implemented Flatfile, we only provided customers the ability to offer clients hourly service. Now we have service type columns for other models such as pricing based on the number of bedrooms and bathrooms.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The ability to seamlessly adjust the types of data we import allows us to grow our business while still using the Flatfile tool,” said Zabludovsky. “Easily making adjustments to the platform enables us to provide important new functionality for our customers. As we grow and improve our product, and require different data sources, Flatfile can grow with us.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Flatfile’s data onboarding platform is a well built product that addresses what is often an under the radar, yet crucial problem of data onboarding,” said Zabludovsky. “I think it’s a category-defining product.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Cleanetto',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Cleanetto develops all-in-one software that provides all the tools needed for cleaning businesses to attract and retain customers. Their product helps cleaning business owners transform their service interchangeable to indispensable by automating the tasks that can often fall through the cracks and never get prioritized when using manual processes or cobbling together multiple software applications. Cleanetto’s overarching passion is to help develop meaningful relationships between business owners, their clients and employees by building thoughtful pieces of technology with that one goal in mind. For more information, visit us at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.cleanetto.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://www.cleanetto.com/',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Flatfile',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or get started for free at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flatfile.com.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '1amfjDz7IyPYCmclMqeb48',
    postTitle:
      'Flatfile’s data onboarding platform: From static to dynamic configurations',
    seoTitle: "Configuration Setup for Flatfile's Data Importer",
    seoUrlSlug: 'flatfile-portal-from-static-to-dynamic-configurations',
    seoMetaDescription:
      'When working with Flatfile’s data onboarding platform, the data importer, here are the setup configuration options to help  get you started.',
    category: 'Product updates & features',
    tags: ['Portal', 'CSV file'],
    publishDate: '2021-05-17T00:00-10:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '589GSCaGuse9xBP2aVQUZH',
        type: 'Asset',
        createdAt: '2021-05-25T18:46:13.337Z',
        updatedAt: '2022-01-05T12:49:21.291Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'GMFP: Making Flatfile Dynamic',
        description: 'Feature Image for dynamic setup post. ',
        file: {
          url: '/img/contentful/589GSCaG-gmfp_dynamic-setup.webp',
          details: {
            size: 664381,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'GMFP_Dynamic-Setup.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Get More from Flatfile: Making Flatfile’s data onboarding platform Dynamic. Presented by Brent Kulwicki. Photo of Brent Kulwicki.',
    summary:
      'When working with Flatfile’s data onboarding platform, there are a few different setup details that are required in order for it to work. You need a license key, a configuration which includes the type of import and the fields and you must identify the customer. But what if I have different ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When working with Flatfile’s data onboarding platform, there are a few different setup details that are required in order for it to work. You need a license key, a configuration which includes the type of import and the fields, and you must identify the customer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But what if I have different users and each user could potentially have their own unique fields? Will Flatfile still work for me? The answer, of course, is yes, but in the case where Flatfile needs to be dynamic, you have to ensure the user information and any different field configurations are set in your application ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'before',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " initiating the importer. Let's take a look at a static setup and then move on from there.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'w6w9wj7nbM6J7ivSmkHhG',
                type: 'Entry',
                createdAt: '2021-08-11T16:28:51.252Z',
                updatedAt: '2022-01-05T12:47:43.086Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Static setup',
                language: 'javascript',
                code: '```import FlatfileImporter from "@flatfile/adapter" \nimport $ from "jquery"  \n\nconst schemas = { \n  Brent: { \n    userId: 1, \n    name: "Brent", \n    fields: [ \n      { key: "userId", label: "User ID" }, \n      { key: "email", label: "Email" } \n    ] \n  }, \n  Roby: { \n    userId: 2,\n    name: "Roby",\n    fields: [ \n    { key: "first_name", label: "First Name" }, \n    { key: "last_name", label: "Last Name" }, \n    { key: "email", label: "Email" } \n    ] \n  }, \n  Michael: { \n    userId: 3, \n    name: "Michael", \n    fields: [ \n    { key: "first_name", label: "First Name" }, \n    { key: "last_name", label: "Last Name" }, \n    { key: "email", label: "Email" }, \n    { key: "userId", label: "User ID" } \n    ] \n  } \n};  \n\nconst importer = new FlatfileImporter("license_key", { \n  type: "import", \n  fields: schemas.Brent.fields \n}) \n\nimporter.setCustomer({ \n   userId: schemas.Brent.userId, \n   name: schemas.Brent.name \n})    \n\n // assuming there is a button in the HTML with an ID of "launch" \n$("#launch").click(() => { \n   importer.requestDataFromUser() \n   .then((results) => { \n     console.log(results); \n     importer.displaySuccess("Import is complete."); \n   })  \n})```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "In this example, you can see that we have multiple schemas set up in the code, but we don't have anything to make it dynamic. If we added some sort of prompt in this same setup, the code would still run through and things like the fields and customer might be ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'undefined',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' when we run that part of the code. That means, we need to either call the code later after we have some sort of user input (which we will do below) or we need to force the setup to wait until we have user input or (more likely in this scenario) the details about the user back from our server by using Promises.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Let's start with the easier method below to visualize how we can simply put the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'new FlatfileImporter',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' call inside of the click function.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1eOkZugIjeQv1pYqOeJd9T',
                type: 'Entry',
                createdAt: '2021-08-11T16:29:27.995Z',
                updatedAt: '2022-01-05T12:48:00.186Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Dynamic setup',
                language: 'javascript',
                code: '```// the above functions grab the a value from a dropdown, grab the info \n// based on that user and grab the schema for that user  \n// HTML dropdown of users const userSelect = $("#users");  \n\nconst schemas = { \n  Brent: { \n    userId: 1, \n    name: "Brent", \n    fields: [ \n    { key: "userId", label: "User ID" }, \n    { key: "email", label: "Email" } \n    ] \n  }, \n  Roby: { \n    userId: 2, \n    name: "Roby", \n    fields: [ \n    { key: "first_name", label: "First Name" }, \n    { key: "last_name", label: "Last Name" }, \n    { key: "email", label: "Email" } \n    ] \n  }, \n  Michael: { \n    userId: 3, \n    name: "Michael", \n    fields: [ \n    { key: "first_name", label: "First Name" }, \n    { key: "last_name", label: "Last Name" }, \n    { key: "email", label: "Email" }, \n    { key: "userId", label: "User ID" } \n    ] \n  } \n};  \n\n$("#launch").click(() => { \n   const importer = new FlatfileImporter("license_key", { \n    type: "import", \n    fields: getSchema(getUser(), schemas) \n  });  \n   importer.setCustomer(getUserInfo(getUser(), schemas)); \n   importer.requestDataFromUser() \n   .then((results) => { \n     console.log(results); \n     importer.displaySuccess("Import is complete."); \n   }) \n})```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What we have done in the above code is given the application a way to identify the end user/customer, and we\'ve put the importer inside of the "click" function which means that until the user clicks to start the upload, we aren\'t locking in the fields or customer information.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The TL:DR',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'When you initiate the Flatfile Importer (using ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'new FlatfileImporter',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ') you lock in the schema for that import reference.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'If you try to call the ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'setCustomer() ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value: 'or ',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'code'
                        }
                      ],
                      value: 'requestDataFromUser()',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' methods before initializing the importer, there will be an error.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'If you need to pass in the fields and/or customer information dynamically, you need to wait until you have the information you need before initializing the importer by either doing the above and initializing on import or by using Promise chaining to wait for data to come back from your server.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Want to dig into the code? We have this working in a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://codesandbox.io/s/dynamic-schema-customer-blog-o9ds5?file=/src/index.js'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'CodeSandbox here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '36nJkOgES8zWSrNOt6gOiw',
    postTitle:
      '5 questions with Shannon Burns, Head of Engineering at Flatfile',
    seoTitle: '5 Questions with Shannon Burns, Head of Engineering at Flatfile',
    seoUrlSlug:
      '5-questions-with-shannon-burns-head-of-engineering-at-flatfile',
    seoMetaDescription:
      'Shannon Burns joins Flatfile as the head of engineering. We ask Shannon about her career, getting women involved in engineering, and more!',
    category: 'Flatfile news',
    tags: ['5 questions', 'Flatfile leadership', 'Flatfile employee spotlight'],
    publishDate: '2021-05-14T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GW7pXtcwNfgXC0MlpjgDC',
        type: 'Asset',
        createdAt: '2021-08-11T16:57:41.360Z',
        updatedAt: '2021-08-11T16:57:41.360Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: '5 questions Shannon Burns',
        description: '5 questions Shannon Burns',
        file: {
          url: '/img/contentful/2GW7pXtc-cw4kok5qtosoobpc8etk.webp',
          details: {
            size: 845414,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'cw4kOk5QToSOObpC8eTk',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Shannon Burns, Head of Engineering at Flatfile',
    summary:
      'As we continue to grow our team, Flatfile is excited to have Shannon Burns on board as our head of engineering. In this role, Shannon will lead a team of amazing engineers who are tirelessly working to create the best data onboarding solution - ever! Let’s dive in and get ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As we continue to grow our team, Flatfile is excited to have ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/shannonkamaburns/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Shannon Burns',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' on board as our head of engineering. In this role, Shannon will lead a team of amazing engineers who are tirelessly working to create the best data onboarding solution ever! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s dive in and get to know Shannon.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q: Why Flatfile? (And what do you do here?)',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: I’m the head of engineering at Flatfile, where I’m accountable for creating and fostering a healthy engineering culture. 🌈',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What sold me on joining was Flatfile’s dedication and investment in its employees. When I was told of Flatfile’s ambition to be the best place in the world for remote first work culture, I realized I needed to be a part of that. Early on in my life, I saw so many people unhappy with their work, and considering how many hours over a lifetime we spend in service to a paycheck, this struck me as an incredibly high leverage way to make a difference in the world. I realized early on that I wanted to work on this problem; how to create a workplace that enabled people to thrive. I’m getting the opportunity to craft this vision with the engineering team here and it’s literally a dream. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Since I’ve arrived, there's been an inherent sense of trust that I haven’t encountered in any place I've worked before. There’s this incredible empowerment and trust on day one that is honestly unexpected and also extremely refreshing.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Even in healthy workplace environments, there can be a lot of friction to get things done. Oftentimes there’s lots of layers in place to review things and these layers are intended to create a sense of safety. A downside to this approach is the unintended implication that this safety net is necessary. This sends the subtle message that you can't be trusted to do the right thing. Flatfile is striving to create a culture with a sense of security, inclusion and belonging with the knowledge that people are going to fail. And they are allowed to do that. But, with trust built in employees can learn and grow.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: How did you get involved in engineering? Tell us a little bit about your career path.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: It’s a unique journey. I went to San Francisco for college and studied recreation in my undergrad. When folks hear that they think, “Oh you studied to be a PE teacher.” It’s been a very useful degree because the program was broken down: one third psychology of group dynamics, one third leadership studies and theory and one third business classes. It was all about learning how people interact and how to get things done. So, it’s been great preparation for my career. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After college I really didn’t know how to answer “what do you want to be when you grow up?” and I worked a lot of odd jobs. From makeup artist in the film industry to dressing up as Alice in Wonderland to host tea parties for children. At one point I was working for a startup in San Francisco. It was the typical startup cliche - 10 of us stuffed sitting in an attic in a terrible neighborhood working long hours. It dawned on me. If these guys could do this, so could I. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I had an idea and started talking to some investors. But then a couple of them were taking me seriously and the nerves kicked in. I was trying to build a technology company yet I didn’t have any technical skills. I stepped on the brakes and decided I needed to learn how to program. I initially taught myself how to code and fell in love. A mentor of mine then suggested that I apply to a coding bootcamp. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The bootcamp sounded like a great plan until I realized that I didn’t have the money to pay for it. I looked around and there weren’t scholarship foundations for such a thing so I ended up ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.womenwhocode.com/blog/thriving-in-tech-paying-it-forward-with-shannon-burns'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'creating the first scholarship for women',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' going into coding bootcamps. I crowdfunded the cost of my education and then accidentally created a nonprofit in the process! I partnered with women who code and now it’s the women who code scholarship. They’ve taken it over and it’s magical to see what it has become.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You’ve been involved in evangelizing coding for women. How do you think we can get more girls involved in coding today and in the future?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A: There's already a lot of effort to solve what people designate as the pipeline problem which is getting enough girls and young women excited and interested in programming while also showing them that they’re capable of doing it. This is critical because girls can now increasingly see themselves represented. This is an area where we obviously need to continue investing because that’s the future.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But what frustrates while simultaneously motivating me is women who are “grown up” in their careers being left out of tech because they never believed it was or still is an option for them. For me, I needed to be exposed to enough people telling me, “hey, you might be really good at this” to try it and then ultimately make a career move.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s where I want to see change. I want to continually speak to women who are thinking about tech and tell them to join us. It’s a beautiful time to be a woman in tech right now because there’s such a burgeoning community among other women. Women are welcoming other women into tech. We want you here. If you’re interested and able, making a career change to tech offers incredible benefits.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You spent a few years at Slack, a fast growing technology company (prior to Salesforce acquisition). What are some of the lessons learned and/or career milestones you achieved during your time there?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: There were definitely some valuable lessons learned that I took from Slack related to how the company managed and worked with their employees. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As companies grow and change over time, the individuals that you hire will also grow and change. Something that went particularly well at Slack was recognizing when folks had phased out of a role. Even though that individual may be progressing well in their career, in terms of promotions, the role no longer seemed like the right fit for them anymore. In many companies that individual solves this by looking for work at another company. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is a huge loss for the company because not only do we lose the institutional knowledge, there’s also a loss when it comes to company culture since we’re not creating a workplace where people are empowered to grow and change as individuals and get the most out of their work experience. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Slack tackled this challenge really well - recognizing individuals who needed this change and providing them with alternative paths and opportunities for them in different areas of the business. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Another area where Slack led the way was in fostering a sense of psychological safety and belonging for employees. It takes a lot of thought and intent to do this properly. Companies today talk a big game around diversity but diversity is the outcome. It’s about inclusion. How are you providing and thinking about the structure of the environment that you’re putting employees in? How can the business be really thoughtful about making sure people have safe spaces to bring their full selves to work, unapologetically? How can we encourage better communication skills? And how can we build spaces that are culturally sensitive? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is important because when employees have a sense of belonging and feel safe, they’re much more apt to speak up and share their views. A perfect example of this is when we were designing a feature in Slack where we were going to add a circle around usernames. Somebody on our team in Japan immediately spoke up and told us that a circle around a name in Japan would signify that the person is deceased. Our colleague spoke up quickly and confidently because the culture of the company encouraged this behavior.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q:  What’s been your favorite travel destination?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: Thailand is a must. How can you not love a place that offers beautiful beaches, world class rock climbing and super cheap (and good) massage?! Thailand is also a special place for me because it’s where my fiance proposed.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Want to join Shannon and her team? We’re hiring! Learn more about ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile and our open roles',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4we7boNEaND6IhUf9hwGc3',
    postTitle:
      'Flatfile named to Inc. Magazine’s annual list of best workplaces for 2021',
    seoTitle: 'Flatfile on Inc. Magazine’s List of Best Workplaces',
    seoUrlSlug:
      'flatfile-named-to-inc-magazines-annual-list-of-best-workplaces-for-2021',
    seoMetaDescription:
      "Flatfile is included on Inc. Magazine's 2021 list of the best workplaces. We're building the best remote company in the world. Learn more.",
    category: 'Flatfile news',
    tags: ['Flatfile culture', 'Inc. award', 'Remote work'],
    publishDate: '2021-05-12T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3X3RuGNxDacfyE7BOEDR0p',
        type: 'Asset',
        createdAt: '2021-08-24T17:58:44.423Z',
        updatedAt: '2021-08-24T17:58:44.423Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Flatfile named to Inc Magazine's 2021 Best Workplaces list",
        description:
          "Flatfile named to Inc Magazine's 2021 Best Workplaces list",
        file: {
          url: '/img/contentful/3X3RuGNx-ttdc0we7snikqnorqsa5.webp',
          details: {
            size: 862850,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'tTDC0WE7SnikQnoRqsA5',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      "Flatfile named to Inc Magazine's 2021 Best Workplaces list",
    summary:
      'As a remote startup working hard to build and grow the data onboarding category, we’re also working hard to create the best remote workplace possible for our employees. We’re thrilled to be recognized for our efforts as Flatfile has been included on the Inc. Magazine’s 2021 Best Workplaces list. The ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'MMYDJ7JPlpjNl7EvJj58q',
        type: 'Entry',
        createdAt: '2021-08-24T17:57:36.535Z',
        updatedAt: '2022-07-28T14:59:44.709Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Zen Mak',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '62Z5vhwRM7EBfSttrerAKr',
            type: 'Asset',
            createdAt: '2021-08-24T17:57:13.198Z',
            updatedAt: '2021-08-24T17:57:13.198Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Zen Mak headshot',
            description: 'Zen Mak headshot',
            file: {
              url: '/img/contentful/62Z5vhwR-jytpjzhlrvusdbcpbbcm.webp',
              details: {
                size: 14711,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'JYTpjzhLRVuSdBCpBBCm',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Consultant',
        department: 'Operations'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'As a remote startup working hard to build and grow the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://buttercms.com/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' category, we’re also working hard to create the best remote workplace possible for our employees. We’re thrilled to be recognized for our efforts as Flatfile has been included on the Inc. Magazine’s 2021 ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.inc.com/best-workplaces'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Best Workplaces list',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. The Inc. list is a result of a wide-ranging and comprehensive measurement of American companies that have created exceptional workplaces and company culture. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Collecting data from thousands of submissions, Inc. singled out 429 honorees this year. Each nominated company took part in an employee survey on topics including management, effectiveness, perks and fostering employee growth. The organization’s benefits were also audited to determine overall scores. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The definition of a positive workplace has changed drastically over the past year,” said Inc. magazine editor-in-chief Scott Omelianuk. “Stocked fridges and nap pods were no longer perks many companies could rely on once work went remote. So, this year’s list is even more important as it reveals organizations that continue to enrich the lives of its employees amid a pandemic.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'What makes Flatfile unique? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A few things. As companies struggled to move hundreds or thousands of workers into the remote working world, Flatfile was already there. Co-founders David Boskovic and Eric Crane made the decision years ago to forgo a headquarters and create a 100% remote company. Remote work is in our DNA.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile offers perks such as: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Home office makeover: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'An interior designer collaborates with employees to design and renovate their work spaces. Learn more about the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.inc.com/magazine/202106/jill-krasny/flatfile-remote-work-home-office-design-renovation-benefits-best-workplaces-2021.html'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'home office makeover',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Remote office stipend: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'For those who rent and can’t take advantage of the home office makeover, Flatfile pays a stipend equivalent to the average cost of 150 sq ft of real estate in their area as a way for all employees to have a dedicated office space. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Comfortable working environments:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Flatfile provides the equipment employees need from ergonomic furniture to the most up to date technology to help get the job done. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In addition to perks and benefits, which you can ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://buttercms.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'check out here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', we’ve created a “million dollar role” initiative. When it comes to employees at Flatfile, every single one is equivalent to a million dollar investment. This ensures that Flatfile invests in career development, planning and training, in addition to all the company benefits. Career growth at Flatfile is a commitment to employees.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With our dedication to building an exceptional remote first workplace, we’re excited by the Inc. recognition and look forward to continuing to build our team.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If interested in learning more about Flatfile, check out our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://buttercms.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'open roles',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4X4JPd1VKfp9PXKgQVSkQp',
    postTitle:
      'Green Check Verified uses Flatfile to drop customer data import time from minutes to seconds',
    seoTitle: 'Green Check Verified Migrates Data with Flatfile',
    seoUrlSlug:
      'green-check-verified-cut-customer-data-import-time-from-minutes-to-seconds-with-flatfile',
    seoMetaDescription:
      'Green Check Verified partnered with Flatfile and uses the data importer to reduce time to migrate data from minutes to seconds.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Finance'],
    publishDate: '2021-05-07T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2r7k29wZzJGoJiKIY9NL6z',
        type: 'Asset',
        createdAt: '2021-08-11T23:39:19.196Z',
        updatedAt: '2022-01-05T13:19:07.184Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: "Green Check Verified uses Flatfile's data importer",
        description: "Green Check Verified uses Flatfile's data importer",
        file: {
          url: '/img/contentful/2r7k29wZ-pmw2rr1rt169zrn5qzzg.webp',
          details: {
            size: 221853,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'pmW2rr1RT169ZRn5qZzg',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Green Check Verified uses Flatfile's data importer",
    summary:
      'Banking in the cannabis industry can be extremely challenging. Green Check Verified is the only RegTech platform that enables transparent, verifiable, compliant banking for the cannabis industry—to solve issues that both banks and cannabis businesses have been wading through for years. Banks need to verify that every dollar deposited is ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Banking in the cannabis industry can be extremely challenging. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.greencheckverified.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Green Check Verified',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is the only RegTech platform that enables transparent, verifiable, compliant banking for the cannabis industry—to solve issues that both banks and cannabis businesses have been wading through for years. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Banks need to verify that every dollar deposited is coming from a legitimate transaction. It’s so difficult to comply that Green Check Verified has a captive audience of bank and business users who rely on the platform to translate sales data into compliance records. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While most customers use ERPs or other systems that integrate directly with Green Check Verified to transform their sales data, some don’t. Their sales system either ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'doesn’t have an API',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' or there aren’t enough users yet to justify building the direct integration. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Green Check Verified turned to Flatfile to help them create a smooth ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' experience for their customers:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Addressing a lackluster CSV import experience',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Quickly implementing a ready-built importer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Cutting import time from minutes to seconds',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Avoiding development that pulls the team away from important features',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Partnering with Flatfile’s collaborative customer success team',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Addressing a lackluster CSV import experience',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Because compliant cannabis banking relationships aren’t easy, Green Check Verified customers were more than willing to format their CSV data as required in order to use the platform. However, the company wants to provide an exceptional customer experience, not just meet minimum requirements. When co-founder and Head of Product Mike Kennedy discovered Flatfile on ProductHunt, he was curious to find out if it could address their so-so CSV importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Like most applications, we had a file import feature that required our users to manually format their files before uploading them to Green Check Verified. They had to match our template, and if there were issues they had to fix those in their CSV and try again. It created a pretty poor user experience,” explained Kennedy.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Quickly implementing a ready-built importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Soon after learning about Flatfile, the team at Green Check Verified decided to give it a try and implemented the whitelabeled importer quickly.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“It only took a couple of days to get Flatfile implemented in our environment and ready for user testing, with just one developer working on it,” Kennedy says. “That was the first indicator that this tool was very easy for us to work with. We got it in front of users quickly, which helped us validate that the experience was better than what we were previously asking them to do.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Cutting import time from minutes to seconds',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There were some immediate and noticeable results with Flatfile’s data importer. “Something that took the customers five to ten minutes previously, will take them five to ten seconds now,” says Kennedy. One of the fundamental differences is Flatfile’s data-mapping capabilities. “Flatfile is able to easily parse that data, put it into columns, and then allow the user to map it. The speed and efficiency of getting data into the importer is definitely a feature that stands out.” ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile also remembers common data mapping structures so that customers don’t have to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'map them every time',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' they upload a new CSV. They only need to map something if their file has a new column, which is rare, since cannabis businesses upload similar files, like sales data on a routine basis.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What’s more, should there be any necessary changes to the file, customers don’t have to wrangle their CSV and try again. They can make those changes right inside of the import experience.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Kennedy also points out how useful it is that Flatfile has manual entry capabilities, in addition to the CSV importer. “For some of our users, it doesn't even make sense to upload the file, because they only have a dozen sales for the period. They can just copy and paste the data from their system, without having to create a CSV file.”",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Avoiding development that pulls the team away from important features',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "One of the biggest benefits of partnering with Flatfile was not only getting a top-notch CSV importer, but saving on development time. “It would have taken weeks or even months to build a solution that wouldn't be even nearly as robust as what we have with Flatfile,” says Kennedy.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That time would’ve taken the Green Check Verified team away from building something that is potentially unique to their business. “It makes sense to outsource data importing to Flatfile, an expert in the field, so we can focus on what differentiates us,” says Kennedy.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Partnering with Flatfile’s collaborative customer success team',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "When implementing anything into your SaaS platform, you want to go beyond customer support and receive a great customer success partnership. Kennedy has been impressed with just how hands-on Flatfile’s CS team is. Kennedy explains, “We've got a shared Slack channel where we can pop in and ask questions. The Flatfile team is very responsive and collaborative. They always copy in the right person immediately and brainstorm solutions with us. It's not just a typical support center, \"Here's a question, here's an answer, rate my response.\" ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Ultimately, Kennedy is appreciative that the team at Flatfile took on the problem of CSV importing. “People might not think it’s a sexy product or problem to work on. But I can tell you firsthand that Flatfile is a huge improvement to our user experience. Our product is no doubt leaps and bounds stronger because of our use of Flatfile.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Green Check Verified',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Green Check Verified (GCV) offers a suite of compliant regulatory banking technology solutions and advisory services for financial institutions. Founded in 2017 by a team of technology, banking, and regulatory experts, we focus on the intersection between community banking and the emerging legal cannabis industry. Our goal is to provide the services and technology needed to connect these two industries in compliant and profitable ways. For more information about Green Check Verified, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://www.greencheckverified.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'www.greencheckverified.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2mbDR2GtCbtmIzibnR7GVr',
    postTitle:
      'Peoplelogic cuts customer onboarding time by 83 percent with Flatfile',
    seoTitle: 'Peoplelogic cuts data onboarding time with Flatfile',
    seoUrlSlug:
      'peoplelogic-cuts-customer-onboarding-time-by-83-percent-with-flatfile',
    seoMetaDescription:
      'Peoplelogic implemented Flatfile’s data importer to improve the onboarding experience cutting customer onboarding time by 83 percent.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'HR'],
    publishDate: '2021-05-03T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7lIbHLrLGXXNBiB8QqnpuL',
        type: 'Asset',
        createdAt: '2021-08-11T23:41:52.561Z',
        updatedAt: '2022-01-05T13:42:01.501Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: "Peoplelogic uses Flatfile's Data Importer",
        description: "Peoplelogic uses Flatfile's Data Importer",
        file: {
          url: '/img/contentful/7lIbHLrL-sv3fvl32qvmg0onyxxkz.webp',
          details: {
            size: 106838,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'SV3fvl32QVmg0ONYxXKZ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Peoplelogic uses Flatfile's Data Importer",
    summary:
      'Burnout is a huge hurdle when it comes to managing a team. According to a Deloitte survey , 70 percent of professionals say their employer isn’t doing enough to prevent burnout, and burnout rates are up due to the stress of working throughout the pandemic. Peoplelogic , the first true ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Burnout is a huge hurdle when it comes to managing a team. According to a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www2.deloitte.com/us/en/pages/about-deloitte/articles/burnout-survey.html'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Deloitte survey',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', 70 percent of professionals say their employer isn’t doing enough to prevent burnout, and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.techrepublic.com/article/covid-19-has-exacerbated-a-75-job-burnout-rate-study-says/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'burnout rates are up',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' due to the stress of working throughout the pandemic.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://peoplelogic.ai/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Peoplelogic',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', the first true People Intelligence platform, cultivates a data-driven culture by unlocking the insights hidden in an organization’s data. Its actionable analysis offers solutions for improving employee engagement and performance, while reducing burnout and turnover. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Soon after launching, the company knew they had a customer onboarding challenge, but Peoplelogic weren’t keen on building a CSV data importer from scratch. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Peoplelogic turned to Flatfile to help quickly onboard new customers and reduce churn for users whose data sources don’t have direct integrations yet:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Choosing a ready-made CSV importer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Cutting customer onboarding from 3 hours to 30 minutes',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Reducing churn for customers whose data sources don’t have an API',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Buying time for more direct integrations',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Choosing a ready-made CSV importer ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I initially heard about Flatfile from another local startup, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/employus-referral-system-employs-flatfile-for-data-imports/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'EmployUS',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. They were quite happy with the tool, and I quickly realized it made sense for us as well,” said Matthew Schmidt, CEO and founder of Peoplelogic, which launched in March of 2020. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Because their product was still new, Peoplelogic hadn’t built out a CSV data importer yet. Rather than attempting to create a tool themselves, they went straight for the ready-made solution that Flatfile offers. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile is a CSV data importer that’s simple for Peoplelogic’s customers to use themselves. Users can make any necessary data changes from inside the importer, such as employees roles and teams, without having to constantly reupload updated CSV files. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We chose an out-of-the-box solution because we’ve suffered the pain of building CSV importers in our past. Additionally, it wasn’t a core piece of our product functionality. We make a deliberate choice to focus our development on the pieces of the product that drive our core platform forward. We always strive to plug and play existing solutions where it makes sense,” explained Schmidt.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Cutting customer onboarding from 3 hours to 30 minutes',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In order for Peoplelogic customers to start getting insights on how to better manage and engage their teams, the first step is to onboard their employees and data sources. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Before Flatfile, a customer might sign up for our free plan, expecting to see insights quickly,” explained John Hathorn, VP of Growth at Peoplelogic. “For larger organizations, they would dig in and then realize that it could take a few hours to manually add all of their employees. Many would churn immediately. Flatfile gives us a way to keep those people in our funnel.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The team at Peoplelogic implemented Flatfile soon after launching to quickly address the onboarding issue. Now, it takes managers or department heads about 30 minutes to import a CSV file of all employees and then hook up their additional data sources, such as Slack, G Suite, and other tools.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Reducing churn for customers whose data sources lack an API',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In addition to onboarding a CSV file of all employees, Peoplelogic customers can use Flatfile to import data on a weekly or monthly basis. For the most part, users can rely on direct integrations to bring in people data from various sources to help analyze what’s going on with employees. But sometimes this isn’t possible. Using Flatfile for quick uploads lets managers analyze data from their teams that would otherwise be lost, or difficult to pull insights from.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“One of our customers has an SDR team in Peopleogic, but their power dialer doesn’t have an API, so we can’t natively pull data from it,” said Hathorn. “Without a great CSV importer, we would’ve lost this customer. Fortunately, they can use Flatfile to quickly add this data every week.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s data importer ensures Peoplelogic can retain customers who otherwise might not have been able to achieve the full value of their insights platform.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Buying time for more direct integrations',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Not all data sources have an API and the team at Peoplelogic can’t build direct integrations for every tool under the sun. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With a simple, user-friendly CSV importer, the Peoplelogic team can keep customers while also considering whether or not it makes sense to build an integration. “Having our customers upload their CSV files from the tools they’re using is a nice interim solution while we justify building out a new integration. We need to have enough paying customers requesting an integration with a specific tool for us to prioritize the work,” said Schmidt.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Of course, a CSV data importer is only successful if people use it. “Flatfile has impressive conditional logic and walks people through the steps to make sure data is mapped appropriately,” added Hathorn. “It looks great from a UI perspective, and is very modern compared to so many archaic data importers I’ve seen with other tools.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We’re so glad we went with Flatfile. The tool is really customizable, and the ROI of buying a quality importer versus building is substantial,” says Schmidt.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'About Peoplelogic',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Peoplelogic, the first true People Intelligence platform, cultivates a data-driven culture by unlocking the insights hidden within your organization’s people data. By automatically aggregating and analyzing vast amounts of data being generated across cloud-enabled tools, the platform surfaces insights and actionable recommendations that ensure growth and stability. Businesses must empower everyone to make better decisions, faster, and Peoplelogic makes that a scalable reality. Providing leaders and managers with an unprecedented vantage point into the inner workings of how work gets done, Peoplelogic makes sure no leader has to make a blind decision based on a gut feeling again. To learn more and start a free trial, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://peoplelogic.ai/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'peoplelogic',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '1kDmpd1dlXlwjChNFJYc3Z',
    postTitle:
      "JumpRope saves hundreds of hours in data mapping validation time with Flatfile's data importer",
    seoTitle: 'Flatfile Helps JumpRope Import and Map Data Faster',
    seoUrlSlug:
      'jumprope-saves-hundreds-of-hours-in-data-mapping-validation-time-with-flatfile-data-importer',
    seoMetaDescription:
      'Learn how Flatfile customer JumpRope improved the data onboarding process to successfully map and validate their data with Flatfile Portal.',
    category: 'Customer stories',
    tags: ['Case study', 'EdTech', 'Customer stories'],
    publishDate: '2021-04-26T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '44djYkk760jyN5RWuf6Knc',
        type: 'Asset',
        createdAt: '2021-08-04T23:55:52.137Z',
        updatedAt: '2021-08-04T23:55:52.137Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Jump rope case study featured image',
        description: 'Jump rope case study featured image',
        file: {
          url: '/img/contentful/44djYkk7-1iorxitgsqkvfnm23nht.webp',
          details: {
            size: 96300,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '1iorXiTGSqKVFNm23NhT',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "JumpRope uses Flatfile's data importer",
    summary:
      'Teachers continue to seek the answer to the central question regarding education: What is the best way to reach students to help them learn? One method gaining acceptance is the system of standards-based grading (SBG). SBG is an educational innovation that focuses on learning and helps increase achievement. It is ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Teachers continue to seek the answer to the central question regarding education: What is the best way to reach students to help them learn? One method gaining acceptance is the system of standards-based grading (SBG). SBG is an educational innovation that focuses on learning and helps increase achievement. It is often combined with updated instructional practices and culture to better engage students and foster a positive environment.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Jesse Olsen, a former educator determined to engage students with active pedagogy, purposeful planning, and authentic learning experiences, began creating custom software tools for his New York City classroom. He then built a team of seasoned teachers and engineers to create a gradebook steeped in authentic assessment principles. Along with co-founder Justin Meyer, Olsen founded ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.jumpro.pe/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'JumpRope',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', which helps school districts across the country transform their teacher practice and is now the premier partner for successful standards-based grading implementation.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'JumpRope provides software that tailors teacher practice to the way students learn. The team’s background as educators combined with a strong track record of successful implementations is helping JumpRope facilitate a paradigm shift that empowers students, teachers, and entire school districts.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Our product is about getting teachers to be really explicit about their students learning goals,” said Meyer, JumpRope’s Chief Executive Officer. “Our software helps teachers evaluate student work and enables them to provide feedback to students through standards-based grading.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Flatfile helps JumpRope overcome the data import challenge',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One of the critical components to the successful use of JumpRope’s software is ingesting large amounts of data. To streamline the data import process, JumpRope engaged ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and implemented Flatfile’s data onboarding platform, its data import tool.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Schools typically have too few people with too little training in charge of too many databases,” said Olsen, also the company’s Chief Technology Officer. “We store millions of rows of data involving scores, student information, assessments, standards, and emails. We operate with 68 different data types. Schools might have anywhere between 10 and 4,000 standards that need to be tracked. Getting this data from the school into our software can be a challenge.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'JumpRope employs a significant ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding process',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' involving a Google Sheets template that schools must fill out manually. The data is then imported from Google Sheets into JumpRope. The problem became validating the mapping of the data to ensure it had been imported properly.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Olsen began the process of building a data importer but quickly decided against it.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We built a basic importer but it wasn’t handling the validation process very well,” he said. “We considered rebuilding it but decided that the mapping of fields and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://try.flatfile.com/csv-validator-for-web-apps'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'validation of CSVs',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' was not in our wheelhouse, so we chose to outsource it. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We scoured the internet looking desperately for a solution so we wouldn’t have to build it ourselves,” said Meyer. “Fortunately we found that solution in Flatfile.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Saving time with the Flatfile data importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The greatest value of Flatfile is that we don’t have to think about text and coding and parsing the hundred different formats in which people might have saved their semi-structured data,” said Olsen. “Plus the Flatfile interface allows a customer to do some amount of cleaning, error checking, and error correction when they export their data.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Olsen feels Flatfile fits in with JumpRope’s move to help make customers more self-sufficient.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“That’s the direction we’re going in as a company,” he said. “We used to do a lot of handholding and as we mature and grow, we have to provide tools to do less of that. Flatfile is helping us make that shift.” ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The time savings for JumpRope as a result of using the Flatfile data importer has been significant.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I would say the time we save has been substantial based on the ability of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to quickly identify rows that are not importable or have errors,” said Hayley Tanler, Head of Customer Success at JumpRope. “Being able to detect and fix errors without having to wait for the entire import to run is ten times faster than it used to be. It could add up to hundreds of hours saved.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The use of the Flatfile data importer has also expanded the range of data types JumpRope is able to import.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We can now import all types of data,” said Meyer. “In the past when a customer asked us to import a different format we would have to say no. But with Flatfile, the development time to accommodate a new import is so much less we can say yes more often. It really increases the breadth of file types we can import.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'JumpRope realizes benefits putting Flatfile in their customer’s hands',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Flatfile allows our users to be more self-sufficient by giving them the information they need to correct data mistakes,” said Tanler. “It helps them look at their data in a way they can understand and better work with.” ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In addition to self-sufficiency for their users, having JumpRope’s customers interact more with their data files results in more long term benefits for the company. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The Flatfile data importer increases our margin by allowing our customers to do more of their own work,” said Meyer. “That allows our developers to focus on more higher impact functionality that differentiates us from our competition.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Looking to the future with Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The team at JumpRope will next look to implement ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' – the company’s no-code, data onboarding solution built to handle complex data importing challenges. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We’ve developed a fairly complicated data import process collaborating with Google sheets and dropdowns we’ve created,” said Olsen. “It’s been an effective process, but we think Flatfile’s data onboarding platform could replace that in the coming year.” ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Olsen continued: “One of the main benefits is that the Flatfile product continues to get better and new features just show up without us having to do anything. This has really helped when it comes to import issues like data validation and preventing duplicate data. Overall, Flatfile has taken on a great deal of complexity that I would normally have to deal with - that’s precious to me.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About JumpRope',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'JumpRope makes an easy-to-use, web-based learning management system geared for the K-12 market. Our core product is a standards-based gradebook integrated with attendance and behavior tracking, curriculum design tool, and administrative dashboard. It provides teachers, students, parents, administrators, networks and districts with access to real-time data so they can collaborate on student learning.​',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'JumpRope was created from a teacher’s perspective to be a singular resource with all the tools necessary to maximize the impact of standards-based grading. We remove the headache of trying to fit innovative grading and assessment practices into existing systems by having seamless integrations with the school’s SIS (PowerSchool, Infinite Campus, etc). For more information, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.jumpro.pe/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'https://www.jumpro.pe/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile\n',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'Q78TKp1uvWiqJsCU4jtya',
    postTitle: 'Four ways to get data from Flatfile’s data onboarding platform',
    seoTitle:
      'Several ways to get data from Flatfile’s data onboarding platform',
    seoUrlSlug: 'four-ways-to-get-data-from-flatfile-portal',
    seoMetaDescription:
      'When it comes to Flatfile’s data onboarding platform, there are multiple options for customers to get their data. In this post we walk through four options.',
    category: 'Product updates & features',
    tags: ['Portal', 'Portal features'],
    publishDate: '2021-04-16T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2EmpaclfF3lPS1Nn48GpfB',
        type: 'Asset',
        createdAt: '2021-08-13T20:23:38.337Z',
        updatedAt: '2022-01-05T13:15:23.575Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title:
          'An overview of how to get data out of Flatfile’s data onboarding platform',
        description:
          'An overview of how to get data out of Flatfile’s data onboarding platform',
        file: {
          url: '/img/contentful/2Empaclf-dtzeg8a2r8mn9mshxoyd.webp',
          details: {
            size: 662932,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'DtZEG8a2R8mn9mshXoyd',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'An overview of how to get data out of Flatfile’s data onboarding platform',
    summary:
      'One common question we consistently get from our customers is "How can I get my data?" With Flatfile’s data onboarding platform, the answer to this question is essentially "How would you like it?" The flexibility of Flatfile to process data on the spot, asynchronously, or whenever else you need it is just one ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One common question we get from our customers is "How can I get my data?" With Flatfile’s data onboarding platform, the answer to this question is essentially "How would you like it?" The flexibility of Flatfile to process data on the spot, asynchronously, or whenever else you need it is just one of the many product features that provide an exceptional data onboarding experience. Now, let\'s dive into all the possibilities of how data you can get your data in Flatfile’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' platform.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '1) Webhooks',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With a simple setting in your configuration, you can send data to an endpoint of your choosing at the end of the import. In order to get started with this, you need an API endpoint that is ready to accept the data. You can mock the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/options/#webhookurl'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'webhookUrl setting',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' by using a tool like webhook.site.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '2) Pull from our API',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You might want to have someone upload the data and then grab it at your convenience. This workflow is available by using our API. We have both a REST API and a GraphQL API, but you can ONLY use this if the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'managed',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' setting is set to ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'true',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' . You can learn more out about the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'managed',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' setting ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/options/#managed'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. To get started with our API, we created a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/guides/working-with-the-api'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'guide here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' to help.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '3) Handle in the flow of the application',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "This is where I'll dig into the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'FlatfileImporter.requestDataFromUser()',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' call. If you use our React or Angular packages, you have access to the same results inside of the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'onData',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' properties. When you start an import, you will call the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '.requestDataFromUser()',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' method which will return a JavaScript promise that resolves with the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'results',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' of the import that I can then use a ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '.then()',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " block to do whatever I need to do with this raw JSON. We've had customers turn this back into a CSV file with the results. We've had customers do a POST to their API with the results. We've also had customers convert the results from JSON to another format. The moral of the story is that you get the results in the code where you can do something with them. The rest is up to you.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '4) From our dashboard',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While this does limit having your clients access these files, using the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'managed: true',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' setting (you can find out more about this setting ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/options/#managed'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ') is one simple way to find and grab your data. You can use your login at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://app.flatfile.com/login'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'app.flatfile.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', go to your imports and download either the finished version of the file or the original data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7ChCONGlCkKH89evIgczDi',
                type: 'Asset',
                createdAt: '2021-08-13T20:22:35.236Z',
                updatedAt: '2021-08-13T20:22:35.236Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Getting data from the Flatfile dashboard',
                description: 'Getting data from the Flatfile dashboard',
                file: {
                  url: '/img/contentful/7ChCONGl-8crhtknzrva3bpasq9ua.webp',
                  details: {
                    size: 1008936,
                    image: {
                      width: 1672,
                      height: 935
                    }
                  },
                  fileName: '8crhtkNzRva3BPAsq9uA',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In summary',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's data onboarding solution is flexible enough to get companies clean and usable data, how they need it, and when and where they need it. All you have to figure out is your ideal workflow!",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'htuMQ5abe21AH9eNr8UjP',
    postTitle:
      'Flatfile helps Benevity expedite data onboarding for corporate volunteering initiatives',
    seoTitle:
      'Flatfile Data Importer Helps Benevity Expedite Data Onboarding for Corporate Volunteering Initiativ',
    seoUrlSlug:
      'flatfile-data-importer-helps-benevity-expedite-data-onboarding-for-corporate-volunteering-initiative',
    seoMetaDescription:
      'Doing well by doing good has been a mantra for many companies that strive not only to run a profitable business, but that also want to drive',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Non-profit'],
    publishDate: '2021-04-15T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'MbO2QjGVWUhzqgFXTxBZI',
        type: 'Asset',
        createdAt: '2021-08-11T23:43:47.752Z',
        updatedAt: '2021-08-11T23:43:47.752Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Benevity relies on Flatfile for data onboarding',
        description: 'Benevity relies on Flatfile for data onboarding',
        file: {
          url: '/img/contentful/MbO2QjGV-y5pq7rlrrti2qtzmnvds.webp',
          details: {
            size: 89879,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'y5pq7rLrRti2QTZMnVds',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Benevity relies on Flatfile for data onboarding',
    summary:
      'Doing well by doing good has been a mantra for many companies that strive not only to run a profitable business, but that also want to drive social impact in the world. Making that happen can be a challenge, but thanks to Canadian-based company Benevity , enabling businesses to engage ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Doing well by doing good has been a mantra for many companies that strive not only to run a profitable business, but that also want to drive social impact in the world. Making that happen can be a challenge, but thanks to Canadian-based company ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://benevity.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Benevity',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', enabling businesses to engage their people in doing good has never been easier.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Benevity is the leader in global corporate purpose software, providing the only integrated suite of community investment and employee, customer and nonprofit engagement solutions. The company’s suite of products enables more than 650 companies to transform their workplace culture, communities, and customer connections. Their software is trusted by the world’s most purpose-driven brands such as Coca-Cola, Google, Microsoft, and Visa to engage their people and communities in doing good.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We are committed to spreading Goodness around the world,” said Rosemary Sanchez, Software Development Manager at Benevity. “That means increasing the ability for people to give, volunteer, and take action on social issues that matter to them ranging from environmental sustainability, equal rights, health & wellness, and more.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Benevity’s software helps companies process billions of annual donations, volunteer activities and grant applications to support millions of nonprofit organizations around the world. Spark, Benevity’s employee engagement solution, offers people a single destination for giving, volunteering and taking positive actions which helps build culture and drive engagement by offering a place for people to do good and grow both personally and professionally.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Managing a diverse client base',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Benevity has a wide-ranging client base and that can present unique onboarding challenges, especially when it comes to importing data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We want to enable companies of all shapes and sizes to create maximum social impact in their communities, regardless of how many teammates or resources they have dedicated to running their programs,” said Sanchez. “This is where having the right tools and technology plays a big role in empowering people to do good.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“With our larger clients, we can be ingesting lists of hundreds of thousands of employees into our system,” said Brynn Hawker, Front End Developer at Benevity. “There is also a lot of unique data related to specific requests and configurations. Our goal is to become more data agnostic.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile helps improve data import validation',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Benevity tried a number of options to solve their data import challenge. They looked at several bulk uploading tools and conducted market research prior to building their own custom data import tool. Last year, they decided to take things to the next level and needed something more complex.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Benevity then implemented the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' data importer for bulk file uploading.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The Flatfile data importer makes it easier for our clients to upload up to 100 volunteering entries at a time and create shifts and sign-ups for employees working in various locations around the world,” said Hawker. “For example, one of our multi-national clients is getting ready to launch a global volunteering campaign and uploading all of the files ahead of time. It’s a huge time saver in the lead up to their big launch day.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The validation functionality in Flatfile is really slick,” Sanchez continued. “The built-in ability to detect input issues and provide clients with the correct error message is particularly helpful. It has a really pleasing, easy to use interface and when we demo it for people it really blows their minds.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The Flatfile ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' platform also simplified the work the Benevity client support team has to do.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We pride ourselves on developing software with an exceptional user experience that makes it easy for our clients to self-serve,” said Hawker. “They can now upload their own data without needing extra support to get things done.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Benevity',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Benevity, Inc., a certified B Corporation, is the leader in global corporate purpose software, providing the only integrated suite of community investment and employee, customer and nonprofit engagement solutions. A finalist in Fast Company’s 2020 Changing Ideas Awards, many iconic brands rely on Benevity’s cloud solutions to power their purpose in ways that better attract, retain and engage today’s diverse workforce, embed social action into their customer experiences and positively impact their communities. With software that is available in 20 languages, Benevity has processed more than 7 billion dollars in donations and 38 million hours of volunteering time, facilitated 340,000 positive actions and awarded over one million grants to 303,000 nonprofits worldwide. For more information, visit ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.benevity.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://www.benevity.com/',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Flatfile',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or get started for free at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flatfile.io.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'AbTxK0uqYjhXMACANFTSn',
    postTitle:
      'Flatfile importer eliminates onboarding bottleneck, helps enable rapid growth for Flow',
    seoTitle: 'Flatfile Importer Rids Onboarding Bottleneck for Flow',
    seoUrlSlug:
      'flatfile-importer-eliminates-onboarding-bottleneck-helps-enable-rapid-growth-for-flow',
    seoMetaDescription:
      'Project management software Flow uses Flatfile to improve the customer data onboarding experience. Learn more in the case study.',
    category: 'Customer stories',
    tags: ['Case study', 'CRM', 'Customer stories', 'Project management'],
    publishDate: '2021-04-13T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1LtsgKSnN40A1VP7U82VTU',
        type: 'Asset',
        createdAt: '2021-08-11T23:46:32.016Z',
        updatedAt: '2021-08-11T23:46:32.016Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Flow uses Flatfile's data importer",
        description: "Flow uses Flatfile's data importer",
        file: {
          url: '/img/contentful/1LtsgKSn-uqw8ltzmsl6r7ht7nvko.webp',
          details: {
            size: 90272,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'uqw8LTZmSl6r7Ht7NvKo',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Flow uses Flatfile's data importer",
    summary:
      'As businesses have rapidly shifted to a remote world – a trend that is likely to continue – connecting, communicating, and collaborating has become even more difficult. While the growth of project management tools help, many of these solutions force teams to conform to rigid workflows that may not fit ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As businesses have rapidly shifted to a remote world – a trend that is likely to continue – connecting, communicating, and collaborating has become even more difficult. While the growth of project management tools help, many of these solutions force teams to conform to rigid workflows that may not fit every organizational culture. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.getflow.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flow',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' solves that problem by providing a flexible, modern task and project management system that enables teams to get organized, stay on track, and achieve more by providing insight into what’s happening at every level. Flow X, the company’s flagship product, combines five apps in one – task management, project management, calendar, chat, and newsfeed – that makes it easy to organize work into projects with clear goals, files, and timelines. Over 300,000 teams in more than 140 countries around the world now use Flow.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Flow X does more of the hard, tricky, cumbersome work so that it takes less effort to get more things done,” said ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.danielscrivner.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Daniel Scrivner',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', CEO of Flow. “We’ve developed ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.getflow.com/flow-x'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flow X',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' so every user and every organization can find and use the workflow that makes sense for them.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Solving the data import challenge for customers making the switch to Flow',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As Flow continues to quickly grow, the challenge of importing data has become more acute. According to Daniel, having an importing tool is the number one request from customers. The need for a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'comprehensive data exchange solution',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is especially critical when it comes to attracting and onboarding new customers. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“As we started onboarding larger companies with lots more people, the lack of an easy way for them to transfer data into our tool had become a showstopper,” said Daniel.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flow chose ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data importer',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' to solve that problem. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The majority of our customers are moving from another competitor over to Flow so making importing simple is essential for us,” said Daniel. “The import issue is literally make or break for companies in the trial phase. They want to know they will be able to move their data without an issue before they commit to a subscription. Incorporating Flatfile was an important step for us.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Daniel explored the option of building a data importer but decided against it.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“For the past 18 months all of our resources have been focused on improving the core features of our product and developing Flow X, the new version of our product,” said Daniel. “We just didn’t have time to build a data importer. And it’s not only building it but also maintaining it and adapting it as CSV formats change. That’s why we chose Flatfile. It removes a huge, long-term burden for us which allows us to focus on things that truly move the needle for our customers.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flow was able to quickly implement Flatfile’s data onboarding platform, Flatfile’s data importer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“In terms of total time to get the product and connect it, it was under 10 days, which is pretty incredible,” said Daniel.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flow began using Flatfile’s data importer to ingest customer files on a project by project basis where customers were able to extract the data from a previous project management tool, import the data into a spreadsheet, sort it by project, and chunk it out into separate CSV files. Using Flatfile made it much easier to import the data from previous project management tools into Flow.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Helping to streamline the customer onboarding process',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flow is now integrating Flatfile into its Flow X product which has provided significant benefits to customers.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Having the functional capabilities of Flatfile’s data importer has been a huge benefit,” said Daniel. “When we get asked by a customer if we have a data import solution we can quickly say we do. That’s important because once a customer signs up they’re incredibly excited about Flow, but they quickly get to the point where they realize that they have to set it up and get their data into it. We provide them with the Flatfile solution and the import problem is solved.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Daniel also sees having Flatfile as a significant marketing advantage and is touting it in its onboarding emails.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Being able to reliably claim that it’s easy to import data as part of the onboarding process is a big advantage,” he says. “The question comes up a lot and Flatfile makes it a simple box to check when the customer asks about it.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We expect that Flatfile will significantly help our growth going forward,” said Daniel. “Flatfile’s data onboarding platform removes a huge bottleneck that could prevent us from growing by making it easy for customers to choose Flow and take their tasks with them. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“What’s great about Flatfile and what I was really drawn to about it is that it creates an importing experience that handles the complexity behind the scenes and all the customer sees is a drop dead, simple user interface that makes the importing process easy for anyone on their team to handle,” added Daniel. “It’s been a powerful solution for us.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Flow',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flow is modern task and project management software for teams. It brings together your tasks, projects, timelines, and conversations, and integrates with your favorite tools, to help you achieve more. Flow’s flexible team project management software is designed for any project or workflow. Plan ahead, set priorities and track projects from start to finish. From simple checklists to Kanban boards, we’ve got you covered. Over 300,000 teams in more than 140 countries rely on Flow every day including Shopify, Apple, and Harvard University. For more information, visit us at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.getflow.com'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://www.getflow.com',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Flatfile',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or get started for free at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flatfile.com.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '7gNpHJqPzvgURRBw3ShdO2',
    postTitle: 'Using custom fonts in Flatfile’s data onboarding platform',
    seoTitle: 'How to use custom fonts in Flatfile’s data onboarding platform',
    seoUrlSlug: 'importing-and-using-custom-fonts-in-flatfile-portal',
    seoMetaDescription:
      'Customization is possible in the Flatfile data importer. In this post, we share how to use custom fonts in the product.',
    category: 'Product updates & features',
    tags: ['Flatfile Portal features'],
    publishDate: '2021-03-11T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4Jaz8bZzuFPyGuqJT604hG',
        type: 'Asset',
        createdAt: '2021-08-13T20:28:19.065Z',
        updatedAt: '2022-01-05T13:25:55.068Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Get more from Flatfile’s data onboarding platform',
        description: 'Get more from Flatfile’s data onboarding platform ',
        file: {
          url: '/img/contentful/4Jaz8bZz-qczjimqtaiekhgsb779k.webp',
          details: {
            size: 662542,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'QCzJiMQTaieKHGSb779K',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Get more fromFlatfile’s data onboarding platform',
    summary:
      'One thing we love to brag about with our Flatfile’s data onboarding platform is that by adding a little bit of styling, it looks and feels like just another piece of your application. Companies can use their own colors, similar padding, border radius, etc,and Flatfile’s data onboarding platform is "on brand" quickly. One styling element ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'One thing we love to brag about with our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                'product is that by adding a little bit of styling, it looks and feels like just another piece of your application. Companies can use their own colors, similar padding, border radius, etc, and Flatfile’s data onboarding platform is "on brand" quickly. One styling element you might be missing - until now - is custom fonts for Flatfile’s data onboarding platform. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In this post, we’ll walk you through how to use custom fonts within our ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'integrations',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'theme',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' settings to bring in the fonts that match your application. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Let's first note that we currently allow you to grab fonts from Adobe Fonts or from Google Fonts. When bringing fonts in from Adobe Fonts, you will need your TypeKit Project Id. For Google Fonts, you will need to pull the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'family',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' from the query parameter inside the URL you can grab after adding which fonts to import. The link should look something like ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value:
                'https://fonts.googleapis.com/css2family=Roboto:wght@400;700&display=swap',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: " and you'll need to pull out the everything between the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'family=',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '&',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' to get ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'Roboto:wght@400;700',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For both Adobe and Google fonts, you will first need to import the fonts using the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'integrations',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' option in your Flatfile config. Below is the JavaScript implementation, but you can use the same settings object inside the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'settings',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' property for both the React and Angular packages.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '11JaJSDHHdq3yQouIjOGgs',
                type: 'Entry',
                createdAt: '2021-08-13T20:25:22.488Z',
                updatedAt: '2021-08-13T20:25:39.738Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description:
                  'Setting custom fonts using the integrations field',
                language: 'javascript',
                code: '```import FlatfileImporter from "@flatfile/adapter"\n\nconst importer = new FlatfileImporter("LICENSE_KEY", {\n  type: "Import",\n  fields: [...],\n  integrations: {\n    // For Google Fonts\n    googleFonts: "Roboto:wght@400;700"\n    // For Adobe Fonts\n    adobeFontsWebProjectId: "Project_ID"\n  }\n})```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'As we stated, the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'integrations',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " setting is how we import the fonts into Flatfile’s data onboarding platform. To use the fonts, you'll also need to call the font family inside the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'theme',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' setting. Again, the below example is in JavaScript, but you can add themes to the object inside the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'settings',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' property for our React and Angular packages as well.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Add7emQkTP2sXYcJw3isZ',
                type: 'Entry',
                createdAt: '2021-08-13T20:26:52.273Z',
                updatedAt: '2021-08-13T20:26:52.273Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Setting custom fonts using the theme field',
                language: 'javascript',
                code: '```import FlatfileImporter from "@flatfile/adapter"\n\nconst importer = new FlatfileImporter("LICENSE", {\n  type: "Import",\n  fields: [...],\n  integrations: {\n    // For Google Fonts\n    googleFonts: "Roboto:wght@400;700"\n    // For Adobe Fonts\n    adobeFontsWebProjectId: "Project_ID"\n  },\n  theme: {\n    global: {\n      fontFamily: "Roboto"\n    }\n  }\n})```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "With custom fonts that match your application, your users won’t be able to tell that importing data isn't just another piece of your solution!",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7sF8qOkGNenazpi5CSNtI5',
                type: 'Entry',
                createdAt: '2021-08-11T22:56:04.229Z',
                updatedAt: '2021-08-11T22:56:04.229Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The elegant data import button is here',
                ctaText: 'See it in action',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6IyONXnh9ESq9JNaK1ojHC',
    postTitle: 'Announcing Flatfile’s Series A: Investing $35m in you',
    seoTitle: 'Flatfile announces series A funding of $35M',
    seoUrlSlug: 'announcing-flatfiles-series-a-investing-35m-in-you',
    seoMetaDescription:
      'Flatfile raises $35M in series A funding. The investment will be used for talent acquisition and product development.',
    category: 'Flatfile news',
    tags: ['Funding'],
    publishDate: '2021-03-10T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '77eRO3SLsXYde3asWrAmb1',
        type: 'Asset',
        createdAt: '2021-08-24T15:29:35.884Z',
        updatedAt: '2021-08-24T15:29:35.884Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile announces series A funding',
        description: 'Flatfile announces series A funding',
        file: {
          url: '/img/contentful/77eRO3SL-qah2gmvyqmujgsdjsyme.webp',
          details: {
            size: 89578,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Qah2gMVyQMujgSdjSyme',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile announces series A funding',
    summary:
      'Two years ago, Flatfile launched as a labor of love. Our first small team, Randy, Eric, JP, Liz, Daniel and I dedicated our evenings, weekends and holidays to crafting a salve for a painful experience we’d all had and cared about. In the last two years, the obsession this team ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Two years ago, Flatfile launched as a labor of love. Our first small team, Randy, Eric, JP, Liz, Daniel and I dedicated our evenings, weekends and holidays to crafting a salve for a painful experience we’d all had and cared about. In the last two years, the obsession this team has for our customers has not only blown my mind but also pushed the company into hyperscale mode.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When Eric and I first decided it was time to raise capital, we spent three months traveling around the country, talking to any investor who’d listen about why we thought data onboarding - we didn’t even know to call it that - was a huge opportunity. We learned so much about fundraising, and more than we wanted about each other. Pinching pennies on hotel rooms and Airbnbs. Eric had to wear earplugs so he could sleep through my snoring. At least once we had to run a pitch call from an Airbnb bathroom with the only working outlet. And iterating on our pitch over and over, at least 50 times. With an aggressive bet from Afore and our incredible pre-seed investors, we finally were off to the races. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Fast forward 16 months, an extra $7.6M from Frances at Two Sigma and sustained 1500% YoY growth: we found ourselves in a unique situation - pushing back on some of the best investors in the world, looking to bet more capital on our team, a mere six months after our previous round. When those investors started stealthily doing their diligence, they learned how much our team had cracked the code on data onboarding. “We’ve never seen customers who are so clearly in love with a company as they are with Flatfile. Consistently ranking their experience with Flatfile a 10/10.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Those investors soon were reaching out, and Eric and I had a decision to make: should we keep pushing back or lean into the strong demand signals coming from the market.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When we landed our first Fortune 500 client, and earned our first paying contracts for our second product, we realized we could start deploying more capital and keep this momentum going. Within just a couple weeks of opening the door to investor interest, we had signed a term sheet. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I’m excited to welcome Scale Venture Partners to the Flatfile family, and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.scalevp.com/team/rory-odriscoll'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Rory O’Driscoll',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to the Flatfile board. With early bets on companies like Bill.com, Box, Docusign, and OneLogin Rory brings a wealth of experience to the team.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.businesswire.com/news/home/20210310005153/en/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'With $35M in fresh capital',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ", some might stop to throw a party. For us, we realize that this signals a new challenge, one more significant than any we’ve faced before. With nearly 100 open roles on the hiring roadmap for the next year, we’re eager to Scale - no pun intended - not only as a company but as leaders and operators. We're also thankful have Workday Ventures, Afore Capital, Gradient Ventures, Two Sigma Ventures, and HNVR involved in this round.  ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s precisely how we’re going to deploy this capital. I’m humbled by the unequivocal confidence our investors have expressed in this company and deeply proud of the work our team has done to earn this trust. This company is nothing but the grand sum of the best of each of us.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Today I’m announcing a commitment to approach every hire on our team like we’re investing a million dollars in your success. Because we are. When we succeed together, that’s just table stakes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With our million dollar roles, we’re going to invest in you and help you scale alongside the company. We’ll deploy both equity and capital to enable your success. We’ll approach every new role with a thoughtful commitment to your ideal path at Flatfile, enabling you to constantly learn and grow. Working at a startup can not just be a job, but a career. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Too many companies see their people as “resources” to be traded for outcomes. We’ve banned referring to people that way. We demand the absolute best from you, and we will give everything for that to happen. If you’re ready to do the best work of your life, and you’re missing that commitment, come talk to me.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Some people might look at this commitment with disbelief. But let me explain why.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'On the rarest of occasions, an opportunity emerges to create a new category. There are no competitors. There’s a huge problem. The right people, the right time, the right product. That’s where Flatfile is today. We’re tackling a blue ocean market worth hundreds of billions.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you’re thinking “why does he think a data import widget matters that much?,” hold onto your hat.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the next decade, you won’t be able to transact business without exchanging data. Flatfile will be where that happens. Today we have grocery stores, children’s hospitals, financial institutions, and Fortune 500 companies all using Flatfile on a daily basis. What do they all have in common? They need to exchange data. Farmers feeding the world, investment bankers driving strategy, researchers curing diseases, teachers adapting to a digital learning environment: they all realize the importance and need of seamless data exchange.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’re a data company. You may have heard that data is the new oil. We disagree.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data is the new sunlight.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Everything grows in the light.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5qo35umND0LfeD0aOgD1tE',
    postTitle:
      'Implementing Flatfile’s data onboarding platform: Avoid the coulda, woulda, shoulda',
    seoTitle:
      'Advice for effectively implementing Flatfile’s data onboarding platform',
    seoUrlSlug: 'implementing-flatfile-portal-avoid-the-coulda-woulda-shoulda',
    seoMetaDescription:
      'Follow these helpful steps (in addition to Flatfile’s developer documentation) to improve your implementation of Flatfile’s data importer.',
    category: 'Product updates & features',
    tags: ['Portal'],
    publishDate: '2021-03-02T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2ZsQqqiRBUiYb6FnARPd8C',
        type: 'Asset',
        createdAt: '2021-08-13T20:33:17.091Z',
        updatedAt: '2022-01-05T13:23:13.542Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 6,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title:
          'Flatfile provides tips for implementing Flatfile’s data onboarding platform',
        description:
          'Flatfile provides tips for implementing Flatfile’s data onboarding platform',
        file: {
          url: '/img/contentful/2ZsQqqiR-rtyqn4frtgb3nfcbt9dw.webp',
          details: {
            size: 662150,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'rTyQn4fRTGb3NFcBt9dw',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Flatfile provides tips for implementing Flatfile’s data onboarding platform',
    summary:
      'Upon hearing “You should…” you may automatically think you’re getting unsolicited advice, but in the case of implementing Flatfile’s data onboarding platform, we put together a list of ways to help guide you to a faster, easier, and better implementation. You should... Set your managed option to true . This is ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Upon hearing “You should…” you may automatically think you’re getting unsolicited advice, but in the case of implementing ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', we put together a list of ways to help guide you to a faster, easier, and better implementation. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'You should...set your managed option to true .',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is an optional setting that when omitted, defaults to false. When you set this to true, you open up the ability to have .xls and .xlsx files work in the importer. You also get more visibility in the Flatfile Dashboard to see both the original file and the final version. If omitted, you will see an import history on this tab, but the files will appear blank and only have the headers in them. Check out more about the',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/options#managed'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' managed setting',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' in our documentation.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "You should...set devMode to true while you're getting things set up.",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "When in development, you might be importing files to test things out. You might upload dozens or even hundreds of test files to ensure it's configured properly and ready to go. You don’t want to be charged for these test imports, right? Without the devMode setting set to true, you will be. What's the actual difference between this being true or false? The UI displays messaging that will let you know that it’s in development mode. Once you’re done and ready to deploy to your application, you can either set this key to false or remove the key all together and you'll be locked and loaded for your production Flatfile’s data onboarding platform usage.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'You should...use Data Hooks instead of regex validation to help out your users.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "I’m not saying that you shouldn't use our regex validations. (You totally should. They're powerful and make sense to use in lots of places.) What I am saying here is that if you can use ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/flatfile-portal-normalizing-imported-csv-with-data-hooks'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Data Hooks',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " and reformat something or do something automatically with a few simple lines of code, then you should 1000000% do it that way. Consider this from a user's perspective and having a dates column where you set up your regex validation to be in MM/DD/YYYY format and the user brings you a file that is MM/DD/YY. Using regex validation, you can display an error message to let the user know their format isn't correct. You can even tell them the proper format for the date field, but in this scenario, they will still have to make the corrections. Using something like",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://date-fns.org/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' date-fns',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', you can re-format on their behalf and let them know you already took care of it. You still get clean data and now your users get an improved experience.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'You should...use our field validations.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This might seem like a simple concept, but fields have the opportunity for lots of validation built into them with simple keys and values. You can make fields required, make fields unique, use regex (I promise it still makes sense to use in some cases) and then even do things like requiring one field if another field is present. We dedicated a ton of time into building out these validations. Digging into the product and setting these up will ensure that your clients have a solid experience importing their data - and that you get clean data. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to implementing these “you should” steps, it’s a win, win, win situation where your clients win for having an easy import experience, you win because you get clean data and I win for having successfully guided you to set up Flatfile’s data onboarding platform more effectively from the start.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Interested in learning more about Flatfile’s data onboarding platform? Check out this short ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.youtube.com/watch?v=d7-u2fUCLsk'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'product overview video',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and stop wasting precious time and energy importing messy data files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3Ih0q7kpI2UeyItAh3KWy2',
    postTitle: 'How to create an Angular CSV importer in 2 minutes',
    seoTitle: 'Create an Angular CSV Data Importer in two minutes',
    seoUrlSlug: 'how-to-create-an-angular-csv-importer-in-2-minutes',
    seoMetaDescription:
      'Familiar with the Angular JavaScript framework? Learn how to create an Angular CSV data importer with Flatfile in minutes.',
    category: 'Product updates & features',
    tags: ['Angular', 'Developers', 'Tutorial'],
    publishDate: '2021-02-25T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '14BOBxLeC8DesHSrnwxhmc',
        type: 'Asset',
        createdAt: '2021-08-13T20:40:46.500Z',
        updatedAt: '2021-12-09T11:23:14.839Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Creating an Angular CSV data importer with Flatfile',
        description: 'Creating an Angular CSV data importer with Flatfile',
        file: {
          url: '/img/contentful/14BOBxLe-wax0axggqjenzoyqnder.webp',
          details: {
            size: 372981,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'wAX0AXggQjenZoYqNDeR',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Creating an Angular CSV data importer with Flatfile',
    summary:
      'Angular is a JavaScript framework and application development platform for creating efficient and sophisticated single-page apps. With Angular applications, there are several ways to upload CSV files. Now, with Flatfile, the data import process is much simpler! Introducing the brand new Flatfile Angular component. The new Flatfile Angular ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1K9OykmxvXixKdJkQzQ1hu',
        type: 'Entry',
        createdAt: '2021-08-10T22:01:45.405Z',
        updatedAt: '2021-08-10T22:01:45.405Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Mark Pieszak',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '2llYg144Fu51FfzAgsodtS',
            type: 'Asset',
            createdAt: '2021-08-10T22:01:24.057Z',
            updatedAt: '2021-08-10T22:01:24.057Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Mark Pieszak headshot',
            description: 'Mark Pieszak headshot',
            file: {
              url: '/img/contentful/2llYg144-cpqiuuotjghmybiuw2vo.webp',
              details: {
                size: 12432,
                image: {
                  width: 329,
                  height: 329
                }
              },
              fileName: 'cPqiUuOTjGhmyBiUw2vO',
              contentType: 'image/jpeg'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Angular is a JavaScript framework and application development platform for creating efficient and sophisticated single-page apps.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Angular applications, there are several ways to upload CSV files. Now, with Flatfile, the data import process is much simpler! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '38m19BEiE8miqN0SSrtKez',
                type: 'Entry',
                createdAt: '2022-01-10T17:19:17.808Z',
                updatedAt: '2022-01-10T21:07:03.376Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 16,
                revision: 4,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Get started with Flatfile',
                text: 'Create an account using Github',
                ctaText: 'Sign up with Github',
                href: 'https://app.flatfile.com/auth/github',
                directSignup: true
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\nIntroducing the brand new Flatfile Angular component.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The new Flatfile Angular component handles all of the heavy lifting, letting companies import and manage CSV file data in minutes. Now let’s dig in and we’ll show you how.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Before we get started, let’s make sure to have a license key to use the Flatfile’s data onboarding platform. If you don’t have one already, you can ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://app.flatfile.com/sign-up'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'sign up for it here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '78sQeaL80Wk8Nhj2f4UrSP',
                type: 'Entry',
                createdAt: '2021-08-13T20:34:49.180Z',
                updatedAt: '2021-08-13T20:34:49.180Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'How to Create an Angular CSV Importer in 2 Minutes',
                url: 'https://www.youtube.com/embed/FsvejtngpuU'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Getting Started with Flatfile and Angular:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'First, let’s get the new Flatfile angular library installed in our applications:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7e4tP06r7kXSy1SmYBIZyY',
                type: 'Entry',
                createdAt: '2021-08-13T20:35:42.404Z',
                updatedAt: '2021-08-13T20:36:39.265Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Install flatfile angular library (npm)',
                language: 'shell',
                code: '```npm install @flatfile/angular --save```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'or',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6o00urk59XwKeHTMRQnyda',
                type: 'Entry',
                createdAt: '2021-08-13T20:36:28.707Z',
                updatedAt: '2021-08-13T20:36:28.707Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Install flatfile angular library (yarn)',
                language: 'shell',
                code: '```yarn add @flatfile/angular```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Now let’s head over to our AppModule (or whatever module you want to upload a CSV in) and import the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'FlatfileAdapterModule',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2sw4DUU4DKb9fQVVExnJec',
                type: 'Entry',
                createdAt: '2021-08-13T20:37:25.577Z',
                updatedAt: '2021-08-13T20:44:01.910Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Import FlatfileAdapterModule',
                language: 'javascript',
                code: "```import { FlatfileAdapterModule } from '@flatfile/angular';\n\n// Add to your Modules imports: []\nimports: [\n  FlatfileAdapterModule\n]\n```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Great! Now we’re able to use the new ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '<flatfile-button />',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: " anywhere in this module's components.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Let’s head over to a component and add it, along with a few optional properties and methods that can be passed down to the Flatfile library.\n\nTo get started with the component, the only required Inputs that need to be passed down are ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'licenseKey',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' (a String), ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'settings',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' (an Object), and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'customer',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' (an Object containing ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'userId',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' which is required).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You can find more information on those properties, and all of the other optional Input methods and Output methods that can come from the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/angular/getting-started'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile adapter here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6Ix2Hl6kqH2XGh9i548sEV',
                type: 'Entry',
                createdAt: '2021-08-13T20:38:21.777Z',
                updatedAt: '2021-08-13T20:38:21.777Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Demo of flatfile-button in Angular',
                language: 'javascript',
                code: "```@Component({\n  template: `\n    <flatfile-button\n      [licenseKey]=\"licenseKey\"\n      [settings]=”settings”\n      [customer]=”customer”>\n    </flatfile-button>\n  `\n}) export class BasicDemoComponent {\n  customer = { userId: '12345' };\n  licenseKey = 'LICENSE_KEY_HERE';\n}\n```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Just like that, we have a very basic and default Flatfile adapter behavior in our applications!\n\nBut what if we want to customize this a bit further? Let’s take a look at some of the other ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'optional',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' properties and methods that can be passed down as Inputs, and some Output methods we can hook into the component with.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the next example, we’re going to pass down a few things.\n\nA ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'settings',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Object, which will let Flatfile know some information about the types of columns/fields we’re expecting from our CSV imports.\n\nA ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'fieldHooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' object, that will run on the initialization of imports (between matching & review stages), and in our case we’ll setup a ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'fieldHooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' rule for the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'email',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' field. With ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: 'fieldHooks',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', we can do setup validation for columns, or even formatting data within a column (take for example, formatting a date column to transform the data in a specific way).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Next we’re going to pass down 3 methods to hook into lifecycle events in our import process. These Input methods we’ll be hooking into are: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '[onData]',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '[onRecordInit]',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '[onRecordChange]',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '. As the names imply, these are methods that we can pass down the Flatfile importer to fire off when these events occur.\n\nOne important thing to note here is that since these methods we pass down will be invoked ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'inside of the library',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', it is crucial that we pass down our methods utilizing the JavaScript ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '.bind(this)',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' method, so that the methods closure context is our current class here (MyDemoComponent). This ensures we avoid errors if we’re trying to access properties/methods/dependencies within our component here.\n\nLastly we’re showing one of the optional Output methods available to us, and this is ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'code'
                }
              ],
              value: '(cancel)',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', as the name suggests, we can fire off our own method here, whenever a user cancels or exits the import process entirely.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5NW5psjckXrv6eKpFIYwhw',
                type: 'Entry',
                createdAt: '2021-08-13T20:39:04.375Z',
                updatedAt: '2021-08-13T20:39:04.375Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Angular CSV importer',
                language: 'javascript',
                code: "```@Component({\n  template: `\n    <flatfile-button\n      [customer]=\"customer\"\n      [licenseKey]=\"licenseKey\"\n      [settings]=\"settings\"\n      [fieldHooks]=\"fieldHooks\"\n      [onData]=\"onData.bind(this)\"\n      [onRecordInit]=\"onRecordInit.bind(this)\"\n      [onRecordChange]=\"onRecordChange.bind(this)\"\n      (cancel)=\"onCancel()\">\n      This text is coming from the end-user of this component\n    </flatfile-button>\n  `\n}) export class MyDemoComponent {\n\n  customer = { userId: '12345' };\n  licenseKey = 'LICENSE_KEY_HERE';\n  settings = {\n    type: 'test import',\n    fields: [\n      { label: 'Name', key: 'name' },\n      { label: 'Email', key: 'email' },\n    ],\n  };\n\n  fieldHooks: Record<string, FieldHookCallback> = {\n    email: (values) => {\n      return values.map(([item, index]) => [\n        { value: item + '@', info: [{message: 'added @ after the email', level: 'warning'}] },\n        index\n      ]);\n    }\n  };\n\n  /*\n   * @Input() methods\n   */\n  onData(results: FlatfileResults): Promise<string> {\n    let errorState = false;\n\n    return new Promise((resolve, reject) => {\n      setTimeout(() => {\n        if (errorState) {\n            reject('rejected - this text is controlled by the end-user');\n            errorState = false;\n          } else {\n            resolve('Flatfile upload successful - this text is controlled by the end-user');\n          }\n      }, 3000);\n    });\n  }\n\n  onRecordInit(record: ScalarDictionaryWithCustom, index: number): IDataHookResponse | Promise<IDataHookResponse> {\n    return {\n      email: {\n        value: record.email + '@',\n        info: [{ message: 'added @ on init', level: 'info' }]\n      }\n    };\n  }\n\n  onRecordChange(record: ScalarDictionaryWithCustom, index: number): IDataHookResponse | Promise<IDataHookResponse> {\n    return {\n      email: {\n        value: record.email + '#',\n        info: [{ message: 'added # on change', level: 'warning' }]\n      }\n    };\n  }\n\n  /*\n   * @Output() handlers\n   */\n  onCancel(): void {\n    console.log('canceled!');\n  }\n}\n```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Just like that, in minutes, we set up CSV import functionality and can harness the power of  Flatfile to handle all of our CSV data needs.\n\nTo view the Flatfile Angular importer in action, check out the CodeSandbox demo ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://codesandbox.io/s/angular-component-example-jgjly'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '.\n\nTo view the code for the Flatfile Angular component, find it on ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://github.com/FlatFilers/angular-adapter'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Github',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3b9BmOqlGhc684i5UUn4bp',
    postTitle:
      '3 Ways to Identify Overwhelmed Customer Success Managers (and Deliver More Value)',
    seoTitle: 'Identifying an Overwhelmed Customer Success Manager',
    seoUrlSlug: 'identify-overwhelmed-csms-with-megan-costello',
    seoMetaDescription:
      'Megan Costello of UpMetrics shares her methods to address Customer Success burnout as well as the evolution of the Customer Success role.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2021-02-23T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'sMgHCtxxEvansLwfcVkcw',
        type: 'Asset',
        createdAt: '2021-08-13T18:26:43.741Z',
        updatedAt: '2021-08-13T18:26:43.741Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Megan Costello of UpMetrics joins Flatfile's podcast",
        description: "Megan Costello of UpMetrics joins Flatfile's podcast",
        file: {
          url: '/img/contentful/sMgHCtxx-l8jjkrbtsnsmpdo8p3sv.webp',
          details: {
            size: 79397,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'l8JjKrBtSNSMpDo8P3sv',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      "Megan Costello of UpMetrics joins Flatfile's podcast",
    summary:
      'Scaling a customer success gameplan is unique to every organization. And, in order to offer customers the most value, it’s essential to keep customer success managers from becoming overwhelmed and overworked. Megan Costello , Director of Client Success at UpMetrics , shares her three methods for identifying overworked CSMs, as ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Scaling a customer success gameplan is unique to every organization. And, in order to offer customers the most value, it’s essential to keep customer success managers from becoming overwhelmed and overworked.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Megan Costello',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/megcos/'
              }
            },
            {
              nodeType: 'text',
              value: ', Director of Client Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'UpMetrics',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.upmetrics.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', shares her three methods for identifying overworked CSMs, as well as… ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Her views on the evolution of CS',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Her mental model for helping customers find value',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The importance of diversity in the CS role',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The best CS advice she’s ever received',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'This post is based on a Customer Success Leader episode featuring ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Megan Costello',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/megcos/'
              }
            },
            {
              nodeType: 'text',
              value: ' and host ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Eric Crane',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/ericcranetech/'
              }
            },
            {
              nodeType: 'text',
              value: '. To hear more interviews like this one, subscribe to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: '/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657'
              }
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Spotify',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: ', or wherever you listen to podcasts.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7gS79ls4ndlPYItD1tGGXA',
                type: 'Entry',
                createdAt: '2021-08-12T17:23:23.240Z',
                updatedAt: '2021-08-12T17:23:23.240Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'How to Identify Overworked CSMs & Deliver More Value',
                sounderLink: 'https://embed.sounder.fm/play/113995',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-to-identify-overworked-csms-deliver-more-value/id1528594709?i=1000509236255',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/OWJlYjY2ODQtNzhhZC00OGQ0LWFkMTMtYTcwMzBiOTdhOTJl?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-to-identify-overworked-csms-deliver-more-value-81687770',
                spotifyLink:
                  'https://open.spotify.com/episode/7nexObNJI2jIvlpl3Pt0FP?si=3wHfRfVGRpmO2IW2VfkMxw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'The Evolution of Customer Success',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Being a customer success pioneer, Megan has helped CS morph into an extremely valuable role. It’s her opinion that no matter what a SaaS tool is capable of, the CSM is always going to be necessary.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'One reason she feels so strongly about this is because customers need a CSM to help them get into the right mental model. In other words, clients need a human being to lay out the roadmap to their end goal.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1A2WISB8BcONqJGPWXyJb6',
                type: 'Asset',
                createdAt: '2021-08-13T18:28:24.594Z',
                updatedAt: '2021-08-13T18:28:24.594Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Megan Costello 1',
                description: 'Podcast quote by Megan Costello 1',
                file: {
                  url: '/img/contentful/1A2WISB8-s5swfvwirsyfxlzdogey.webp',
                  details: {
                    size: 45834,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 's5SWFvWiRsyfxlzdogEy',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'The Mental Model',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Megan’s mental model works like this:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Start with ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'questions ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'of impact. What do you want to accomplish with the tool? What does success look like to you and your company as a whole? What’s the point in which you know you’ve gotten value from our tool?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Then, work backwards from their ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'answer',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        '. Take note of each step it’s going to take to get to their answer (aka, point of success).',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Make the ',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value: 'roadmap ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        'clear to your customer. Show them the journey you’re going to go on together in order to reach their specific point of success.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Doing this helps you set expectations with your client. Also, everyone will be clear on what value looks like with your tool.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The other important to-do is informing the rest of your organization about what customers see as valuable.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Being the Customer Advocate',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Animosity can manifest if the Product or Engineering teams see CS requests coming in from their co-workers and not from the actual customers.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'So, it’s vital to frame your CS team as advocates of your customers. Don’t ask for product alterations as a member of your organization — ask for them as ambassadors of your clients.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3P4U3xmiIOqz69SW5jnhaF',
                type: 'Asset',
                createdAt: '2021-08-13T18:29:12.089Z',
                updatedAt: '2021-08-13T18:29:12.089Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Megan Costello 2',
                description: 'Podcast quote by Megan Costello 2',
                file: {
                  url: '/img/contentful/3P4U3xmi-2nvhemyrueolndq5efq0.webp',
                  details: {
                    size: 36335,
                    image: {
                      width: 961,
                      height: 540
                    }
                  },
                  fileName: '2nvhEMyRuEOlnDQ5EfQ0',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Make sure those in charge of your product understand that you have your customers’ best interests at heart. You are there to advocate for them, not to boss your co-workers around.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Scaling Customer Success in Your Organization',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'There’s a fine balance between exceptional support from your CS team and CSMs becoming overwhelmed and overworked.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When you’re attempting to scale your CS operations, there will likely be times when a new support feature needs to be added to your tool. The difficult part is identifying when that should happen.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Fortunately, Megan shared how she goes about identifying overwhelmed CSMs.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: '3 Ways to Identify Overworked CSMs',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If you hired the best people, you’re likely going to have to be proactive about recognizing overwhelmed employees. Particularly in a highly empathetic role like CS, you should have a plan for identifying overworked team members.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Here are three ways to proactively identify CSMs who are doing too much:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Time-tracking data.',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' It may sound old school or maybe even punitive, but time-tracking is one of the most effective ways to see if employees are being overworked. The important thing is to make it clear to CSMs that tracking time isn’t meant to scare them into working more. It’s actually for their benefit.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Regular one-on-one’s.',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Having weekly meetings with your CSMs is imperative to understanding what’s on their plate. In these meetings, Megan suggests asking a potentially overwhelmed employee what they think could be pushed back to make room for a prioritized item. This can be much more effective than asking the CSM what they could use help with (because they probably won’t say anything).',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Observe your employees.',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ' Of course, this is a little more difficult in the era of remote work. However, you can still take note of how long it’s taking CSMs to onboard new customers and if anything is slipping between the cracks. If you notice things taking longer than usual, it’s likely that your CSM is overwhelmed.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'These methods of recognizing overworked CSMs might sound a little traditional or quantitative, but they’re some of the best ways of keeping your team from getting swamped.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5Nuydkl6fzW68JBLKLYqsf',
                type: 'Asset',
                createdAt: '2021-08-13T18:30:01.837Z',
                updatedAt: '2021-08-13T18:30:01.837Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Megan Costello 3',
                description: 'Podcast quote by Megan Costello 3',
                file: {
                  url: '/img/contentful/5Nuydkl6-xrwa74v1qwcxwgkycbcx.webp',
                  details: {
                    size: 35458,
                    image: {
                      width: 961,
                      height: 540
                    }
                  },
                  fileName: 'xRWa74v1QwCxwgkycbCx',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Through these methods, Megan believes that CS leaders should be able to determine whether or not an additional support feature should be added to the product itself. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As you’re scaling your CS efforts, you should be looking for opportunities to automate menial tasks in order for your team to do what they’re best at. Additionally, as your CS team grows, you should be looking for ways to bring in more diverse perspectives.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Diversity in Customer Success',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Being a pioneer in the CS field, Megan sees the importance of scaling teams to bring on more diverse points of view, especially as the industry evolves.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Customer success is an empathetic role. If your CS team is unable to empathize with diverse customers, those customers aren’t going to glean the most value from your solution. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Megan points out that “products being designed, developed, supported by people who share the experience of the user is extremely important.” Essentially, as your customer base becomes more diverse, so should your CS team.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'The Big Advice & Takeaways',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Being someone who helped customer success evolve into what it is today, Megan has a wealth of knowledge in many areas of the role. She plans on being integral in the future of CS as well.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The most impactful piece of advice she’s taking with her into the future is this:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In customer success, your job isn’t to deliver what your customers ask for. It’s to deliver what they need.',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Before we close out today, here are the things to keep top-of-mind:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Get your customers into the right mindset, working backwards from their point of success.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Be your customers’ advocate.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Use the tried and true ways of identifying overworked CSMs.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'In order to scale your CS efforts, you need to prioritize diversity.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Until next time!',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more CS insights, subscribe to',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: '/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657'
              }
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Spotify',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: ', or wherever you listen to podcasts.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '3mlizbDUTspEsGwbh4T6OY',
    postTitle:
      'Meenta accelerates COVID-19 testing and reporting with Flatfile data importer',
    seoTitle: 'Meenta Relies on Flatfile to Improve Testing',
    seoUrlSlug:
      'meenta-accelerates-covid-19-testing-and-reporting-with-flatfile-data-importer',
    seoMetaDescription:
      'Meenta uses Flatfile’s data importer to help rapidly accelerate the COVID-19 testing process. Learn more in the case study.',
    category: 'Customer stories',
    tags: ['Biotech', 'Case study', 'Life sciences', 'Customer stories'],
    publishDate: '2021-02-22T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6yXqNktJkRrAQaoyXluCVw',
        type: 'Asset',
        createdAt: '2021-08-11T22:38:24.128Z',
        updatedAt: '2021-08-11T22:38:24.128Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Meenta uses Flatfile's data importer",
        description: "Meenta uses Flatfile's data importer",
        file: {
          url: '/img/contentful/6yXqNktJ-c6euyinfsqutltjvuuys.webp',
          details: {
            size: 80943,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'c6eUyInfSquTlTJVUUYs',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Meenta uses Flatfile's data importer",
    summary:
      'Biotech, life sciences, and other high-tech companies often need expensive instruments to conduct research and carry out testing. The problem? They don’t have a use for this equipment all the time, so it often sits idle. If shared properly, this available bandwidth could be used by many different companies, reducing ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Biotech, life sciences, and other high-tech companies often need expensive instruments to conduct research and carry out testing. The problem? They don’t have a use for this equipment all the time, so it often sits idle. If shared properly, this available bandwidth could be used by many different companies, reducing their need to buy the equipment themselves. The obstacle is that companies with available equipment and the companies that need to use that equipment can’t easily connect.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://meenta.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Meenta',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' was founded as a way to solve that problem by striving to make every scientific instrument in the world universally accessible. Recent advances in scientific equipment don’t have the impact that they should have because the infrastructure required to access these technologies simply does not exist. Meenta decided to create an infrastructure on which science can be more scalable with increased liquidity',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We think of ourselves as the Airbnb for science equipment,” said Stephan Smith, co-founder and CTO of Meenta. “Just as people rent available housing space that the owners aren’t using, we match up unused equipment time with those organizations who need it.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Meenta provides biotech companies and academia the ability to outsource services while offering contract research organizations (CROs) and other instrument owners a way to maximize the use of its equipment.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As the COVID-19 pandemic hit, Meenta expanded their platform  to help employers, universities, schools, organizations and families access affordable testing options from a range of clinical laboratories and diagnostic companies with guaranteed results in 24-48 hours.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We took everything that we built as a marketplace for the research side and applied it to the clinical side,” said Smith. “We added HIPAA compliance and began focusing on helping labs scale up to offer more COVID-19 testing.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Meenta makes a critical buy vs build decision for importing data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Meenta platform needs to be able to support the importing of around 15,000 to 20,000 testing data records a month. They attempted to solve the data import challenge by building their own data importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We built an importer to handle our data ingestion needs but it was not ideal,” said Smith. “We ran into the usual import problems such as customers choosing the wrong column, linking data improperly, incorrect mapping, and data coming in with foreign language characters.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'After meeting with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', Smith realized that buying a comprehensive data import solution was a better choice than using an in-house system.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Developers always like to make things, but it doesn’t make sense when someone else has exactly what you need and it works much better,” said Smith. “Our importer got canned within a week of finding the Flatfile data importer. We implemented and integrated Flatfile within a few days and I told my developers to get rid of the one we built - which we were proud of - until we saw the Flatfile data importer.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Meenta customers benefit from the Flatfile data importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/product/portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile data importer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' has been a key driver of customer satisfaction for Meenta.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I can present Flatfile’s data importer to my customers and I’m confident that it will make us look good,” said Smith. “With COVID-19, we have hundreds of universities coming on and if I use a bad solution, I’ll feel the pain in my support line which will light up like a Christmas tree.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We find that every human error that can occur, does occur when you don’t have a structured way to move data fluidly,” Smith continued. “We now tell people they can upload an Excel file and grab whatever tab they want and pull the columns in and they look at me like I just invented the wheel. I have to tell them it’s not us, it’s Flatfile.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Flatfile helps Meenta accelerate the COVID-19 testing process',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Flatfile data importer has helped Meenta achieve the goal of rapidly accelerating the testing process, something critically needed in the time of the pandemic.“ Companies like Flatfile have been the secret sauce that has allowed us to rapidly implement our public platform,” said Smith. “I was on a call recently and realized we needed the ability to import tracking numbers for our test labs to accelerate getting tests to labs faster. Within an hour of the call, we rolled out the Flatfile data importer and started importing hundreds of tracking codes at once so we could identify where things were. We were able to report back to the client in an hour. That’s not something we could have ever done with a hand-built importer.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Meenta also helps labs generate mandatory COVID-19 test reports to allow state and federal government bodies to track the spread of the disease. “Importing data to be able to report back to the states about COVID-19 numbers and how they are changing at the county and local level would normally be a year-long data science project,” said Smith. “Using tools like Flatfile and others allow us to report in days and hours versus months and years.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Cost reduction implications with Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Controlling costs is a major issue for any startup, and for a tech company, every line of code comes with a cost. Developing a solution, supporting it, and fixing bugs all add to the cost of ownership.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Meenta estimates that using Flatfile has saved the company at least three to four months of development time and the equivalent of the cost of one full time developer. As a fast growing company, Meenta can easily put the resources that would have been dedicated to a data importer and use them in a more effective way.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The fewer lines of code we have to support, the lower our cost,” said Smith.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Meenta impressed with the Flatfile data importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I’m glad I’m not building and supporting a data importer,” said Smith. “Every developer who’s been around for five years has built his or her own importer and thought they got it right, but none of them want to go back and fix problems in the system they have created.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I probably built this importer seven or eight times at scale and hated it every single time. It’s like cleaning bathrooms,” Smith summed up. “It’s nice when it’s clean but it’s going to get dirty again. When it comes to importing files, it will work well for a little while and then it breaks again. When you buy the Flatfile data importer solution, you never have to worry about that happening. It’s simple: don’t build a data importer, buy it.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Meenta',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Meenta is the leading platform for on-demand access to scientific and clinical testing equipment. Meenta’s platform helps simplify transactions by creating a global virtual network of research services and clinical tests available on-demand. Our customers can order a variety of test kits, instruments, and supplies from hundreds of labs nationwide. Meenta has rapidly adapted its technology platform to connect COVID-19 testing labs with employers and health care partners to streamline access to clinical testing. To learn more, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://ff6483ae28419811dfea3ccb8158c2b2.tinyemails.com/819bacaded3b11c574423595f3532af6/fd44bff4ed3a971edd2714f8e9edb933.html'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'https://meenta.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '\n',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile\n',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                "Flatfile's vision is to enable seamless data transactions between every organization in the world. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data exchange fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 700 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '1twnvGGebOpcu0MQNkOzMB',
    postTitle: 'How to Make Customer Success a Discipline',
    seoTitle: 'Making Customer Success a Discipline',
    seoUrlSlug: 'customer-success-as-a-discipline-tanya-strauss',
    seoMetaDescription:
      'In the latest Flatfile podcast episode, Tanya Strauss who leads success at ServiceNow discusses Customer Success as a strict discpline.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2021-02-16T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '74IiGikwGYACwQez1Skytf',
        type: 'Asset',
        createdAt: '2021-08-13T18:34:46.770Z',
        updatedAt: '2021-08-13T18:34:46.770Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Tanya Strauss joins the Flatfile Customer Success Podcast',
        description:
          'Tanya Strauss joins the Flatfile Customer Success Podcast',
        file: {
          url: '/img/contentful/74IiGikw-zivccuqjsuwpmxgupp44.webp',
          details: {
            size: 83095,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'ZIVcCUqJSUWPmxgUPP44',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Tanya Strauss joins the Flatfile Customer Success Podcast',
    summary:
      'Walk in to almost any corporate office in the United States, or anywhere in the world for that matter, and you’re likely to find some sort of propaganda claiming their dedication to customer service. Maybe it’s a poster in the break rooms. Maybe it’s painted on the walls of the ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Walk in to almost any corporate office in the United States, or anywhere in the world for that matter, and you’re likely to find some sort of propaganda claiming their dedication to customer service. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Maybe it’s a poster in the break rooms. Maybe it’s painted on the walls of the cafeteria. Maybe it’s even an official part of the company’s mission statement. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But real customer success comes from something much deeper than a simple mantra printed on a t-shirt or a strategically placed dposter. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'On this episode of Customer Success Leaders, we sit down with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Tanya Strauss',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/tanyastrauss'
              }
            },
            {
              nodeType: 'text',
              value:
                '. Tanya is the Director of Customer Success Strategy and Operations at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'ServiceNow',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.servicenow.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', and she joined us for this episode to talk all about, among other things, the 4 components that define customer success.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7p7uOW97pNNLdQ4a0f7oDY',
                type: 'Entry',
                createdAt: '2021-08-12T17:21:35.503Z',
                updatedAt: '2021-08-12T17:23:40.589Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'How to Make Customer Success a Discipline',
                sounderLink: 'https://embed.sounder.fm/play/113994',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-to-make-customer-success-a-discipline/id1528594709?i=1000508313587',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MWZmMzJlMTUtN2Q4Yi00ODc1LWI4NDYtNzYyNmE5OWFjNDJi?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-to-make-customer-success-a-discipline-81490700',
                spotifyLink:
                  'https://open.spotify.com/episode/6bjiOpirLtouS9vDmjVVLD?si=7mXbWXrmSvazaOFMWYykjA&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Customer Success is a Job',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'It’s a job. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Meaning, it’s something that individual people do. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Hopefully they’re doing it well by delivering outcomes and helping customers deliver outcomes, but before customer success is anything else, it’s a job. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'All the talk of placing customers first is pointless if there’s not anybody on the ground to actually do the job.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Customer Success is a Department',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The next logical step is creating a customer success department. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s a job, yes, but it’s also a department, meaning there need to be strategies, processes, budgets, and resources made available to enable customer success.  ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'And the COVID-19 pandemic has made customer success and customer experience all the more crucial, because companies are relying on each and every one of their customers to keep the business running. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Having a bunch of people really dedicated to customer success means nothing if your organization isn’t putting for the resources to actually enable your customers to be successful.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Customer Success is a Discipline',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Enabling great customer success isn’t automatic. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'No company, on day one, is the expert of delivering unparalleled customer success. It’s not in anyone’s veins, or DNA.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1xkgmj6MYBDeGfSuVlkzHf',
                type: 'Asset',
                createdAt: '2021-08-13T18:35:55.971Z',
                updatedAt: '2021-08-13T18:35:55.971Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Tanya Strauss 1',
                description: 'Podcast quote by Tanya Strauss 1',
                file: {
                  url: '/img/contentful/1xkgmj6M-7u4ickfhtwo6oywzinkd.webp',
                  details: {
                    size: 47728,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: '7U4ickfHTwO6OywZinKD',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Customer success is, like most other things in business, a discipline. Meaning that it’s something that needs to be practiced, honed, perfected, and constantly improved on. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This also means that your customer success is never perfected. You never reach a point where you say, “We’ve got this figured out, we don’t need to work on this anymore.” ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Imagine Lebron James winning another NBA title and saying, “I don't need to practice anymore. I don’t need to train. I’ve got this game mastered, there’s nothing left for me to improve on.” ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Sounds absurd right? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Of course it does. Because Lebron understands that there is ALWAYS room for improvements.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Customer Success is a Cultural Value',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Bottom line: if customer success isn’t baked into your company’s culture, it’s going to be really hard for you to get it right. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6jU9KOajecUsVaf8qKQVaF',
                type: 'Asset',
                createdAt: '2021-08-13T18:36:27.849Z',
                updatedAt: '2021-08-13T18:36:27.849Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Tanya Strauss 2',
                description: 'Podcast quote by Tanya Strauss 2',
                file: {
                  url: '/img/contentful/6jU9KOaj-tayblesjrs2kxm6qwo47.webp',
                  details: {
                    size: 47778,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'tAYBLesjRs2kXm6qwO47',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When people talk about your company, and your company’s culture, what are they saying? That the people are nice? That the office is hip? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'What if the first thing that people said about your company culture was that you were completely obsessed with delivering the ultimate customer success experience in EVERYTHING that you did? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '2NDN724mpGjewj27iddq1G',
    postTitle: 'Flatfile feature update: Dark mode with Flatfile themes',
    seoTitle: 'Dark Mode Feature Now Available with Flatfile Themes',
    seoUrlSlug: 'flatfile-feature-update-dark-mode-with-portal-themes',
    seoMetaDescription:
      'Flatfile now offers dark mode as part of the newly released themes feature. Learn how to get started with dark mode.',
    category: 'Product updates & features',
    tags: ['Portal', 'Portal tips', 'Tutorial'],
    publishDate: '2021-02-10T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2kIQEOXrp6EvneafuwA6pi',
        type: 'Asset',
        createdAt: '2021-08-13T21:24:32.032Z',
        updatedAt: '2022-01-05T12:27:23.415Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile dark mode',
        description: 'Flatfile dark mode',
        file: {
          url: '/img/contentful/2kIQEOXr-s02kk78prbclvfxwielp.webp',
          details: {
            size: 259322,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'S02kK78pRBClVFXWielp',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile dark mode',
    summary:
      'If one thing holds true across almost all software, it\'s that you can spend six months or more on an awesome, helpful feature for a product, and someone will inevitably say, "That\'s great and all, but when will dark mode be available?" With our new custom themes for Flatfile’s data onboarding platform',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If one thing holds true across almost all software, it\'s that you can spend six months or more on an awesome, helpful feature for a product, and someone will inevitably say, "That\'s great and all, but when will dark mode be available?" With our new custom themes for ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/themes'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: "Flatfile's data onboarding platform",
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', dark mode as well as better custom theming to match your application is only a few lines of code away.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For the sake of showing you how simple it is to get a solid theme together using this feature, we'll use the global and buttons styling for this. You can, however, get a lot more specific than this by styling many different stages and pieces of the importer independently of one another. For all the additional styling options, check out our ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/themes'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'documentation here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ". We will also be skipping a lot of the Flatfile setup for this, but if you need to start from the beginning, here's our getting ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/getting-started'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'started documentation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For getting a dark mode, you'll either need to pass in what the user's style preference is or detect it. Since we’re working in a simple demo environment, we'll use some JavaScript to detect their preference set in the prefers-color-scheme CSS media query.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "What you'll see in the code is that the framework is in place for us to give styling to a lightMode and also a darkMode option for styling. In this case, we won't use the lightMode one and you'll be able to see that an empty object or something that doesn't have ALL the keys will simply default to our original styling.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1CS3SLq2bBsXf6eBwk8ZK5',
                type: 'Entry',
                createdAt: '2021-08-13T21:19:34.462Z',
                updatedAt: '2021-08-13T21:19:34.462Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Set dark or light theme preference',
                language: 'javascript',
                code: '```const setTheme = () => {\n  let themePreference = false;\n  if (window.matchMedia) {\n    themePreference = window.matchMedia("(prefers-color-scheme: dark)").matches;\n  }\n  const darkTheme = {};\n  const lightTheme = {};\n  return themePreference ? darkTheme : lightTheme;\n};```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This is set up as a function that we will return the object that the theme setting is expecting to get. So when we put this into our code snippet, it will look like the below code.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6osTsqdEPNvw81S2wSJEVL',
                type: 'Entry',
                createdAt: '2021-08-13T21:19:16.905Z',
                updatedAt: '2021-08-13T21:19:16.905Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Use dark or light theme in Flatfile importer',
                language: 'javascript',
                code: '```const importer = new FlatfileImporter(LICENSE_KEY, {\n  type: "People",\n  fields: [\n    {\n      label: "Name",\n      key: "name"\n    },\n    {\n      label: "Email",\n      key: "email",\n      validators: [{ validate: "required" }]\n    }\n  ],\n  theme: setTheme()\n});```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "This is now set up to detect the user's preference for light or dark mode and then will return an object that represents the theme. First, let's pause to clarify that while the setTheme gets used here, we can pass the object directly to the theme in settings. We’re using a function since we’re trying to do this dynamically, but if you’re only looking to implement your branding, you can use the theme object.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "As previously mentioned, we’re going to use the global and buttons settings. We don't want to repeat code in the buttons so I’m going to set up some button styles to then apply across several of the buttons using the spread operator.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4cIwdlXWWdh7HzNKOOXVsB',
                type: 'Entry',
                createdAt: '2021-08-13T21:20:36.364Z',
                updatedAt: '2021-08-13T21:20:36.364Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Dark mode buttons with CSS',
                language: 'javascript',
                code: '```const primaryButton = {\n  backgroundColor: "#00D1AF",\n  color: "#002d3d",\n  border: "1px solid transparent",\n  padding: "10px 16px",\n  fontSize: "16px",\n  borderRadius: "1px",\n  ":hover": {\n    backgroundColor: "#00D1AF",\n    border: "1px solid transparent",\n    color: "#002d3d"\n  }\n};\n\nconst secondaryButton = {\n  backgroundColor: "#d9ccff",\n  border: "1px solid #ece6ff",\n  color: "#002d3d",\n  padding: "10px 16px",\n  fontSize: "16px",\n  borderRadius: "1px",\n  ":hover": {\n    backgroundColor: "#794cff",\n    border: "1px solid #794cff",\n    color: "#c2c3c3"\n  }\n};\n\nconst tertiaryButton = {\n  backgroundColor: "transparent",\n  color: "#d9ccff",\n  border: "1px solid #d9ccff",\n  padding: "10px 16px",\n  fontSize: "16px",\n  borderRadius: "1px",\n  ":hover": {\n    backgroundColor: "#d9ccff",\n    border: "1px solid #ece6ff",\n    color: "#002d3d"\n  }\n};```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Now that the button styles are set up in their own variables, we'll go ahead and add the global and buttons keys to our darkTheme variable that we set up before.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5ASS3UlO6PfZrsTSWSLsRK',
                type: 'Entry',
                createdAt: '2021-08-13T21:21:26.570Z',
                updatedAt: '2021-08-13T21:21:26.570Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Full dark mode theme example',
                language: 'javascript',
                code: '```const setTheme = () => {\n  let themePreference = false;\n  if (window.matchMedia) {\n    themePreference = window.matchMedia("(prefers-color-scheme: dark)").matches;\n  }\n  const darkTheme = {\n    global: {\n      backgroundColor: "#212327",\n      textColor: "#c2c3c3",\n      primaryTextColor: "#c2c3c3",\n      secondaryTextColor: "#c2c3c3",\n      successColor: "#c2c3c3",\n      warningColor: "#c2c3c3"\n    },\n    buttons: {\n      primary: primaryButton,\n      secondary: secondaryButton,\n      tertiary: tertiaryButton,\n      success: primaryButton,\n      headerMatchYes: {\n        ...primaryButton,\n        padding: "6px 40px"\n      },\n      headerMatchNo: {\n        ...secondaryButton,\n        padding: "6px 40px"\n      }\n    }\n  };\n  const lightTheme = {};\n  return themePreference ? darkTheme : lightTheme;\n};```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "With the above styling and variables in place, we should now see a dark theme applied to most of the elements within the Flatfile importer. Again, you can control more things like the manual input table and individual pieces separate from what we've done here, but this is a quick and simple way to apply some styling to the importer using our ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/developers/javascript/themes'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: "Flatfile's data  onboarding platform themes",
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. For more information on this, you can check out our documentation here. You can also test out what we did above in this',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://codesandbox.io/s/themes-blog-example-dark-mode-9pxt5?file=/darkMode.js'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' Codesandbox environment.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Video walkthrough',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '20skFT52fgc22z5kyhsNz0',
                type: 'Entry',
                createdAt: '2021-08-13T21:22:56.980Z',
                updatedAt: '2022-01-05T12:26:02.776Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Themes feature tutorial',
                url: 'https://www.youtube.com/embed/h8TwD41GC4Q'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'wDYjk6LNeAXJo9p8e0de1',
    postTitle: 'Customer Success: How to Curate Human-First Experiences',
    seoTitle: 'Curating Human-First Experiences for Customer Success',
    seoUrlSlug: 'customer-success-how-to-curate-human-first-experiences',
    seoMetaDescription:
      'In this episode of the Customer Success Leader podcast, Dave Blake, the CEO of ClientSuccess shares thoughts on exceptional experiences.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2021-02-09T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6yyhTPRJefHjHMAjw4Ql6d',
        type: 'Asset',
        createdAt: '2021-08-13T16:28:20.903Z',
        updatedAt: '2021-08-13T16:28:20.903Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Dave Blake of ClientSuccess on the Customer Success Leader podcast',
        description:
          'Dave Blake of ClientSuccess on the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/6yyhTPRJ-5sqplcl7qrc48wqhxwig.webp',
          details: {
            size: 68072,
            image: {
              width: 961,
              height: 540
            }
          },
          fileName: '5sQPlCl7QRC48WqHXWig',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Dave Blake of ClientSuccess on the Customer Success Leader podcast',
    summary:
      'How are you thinking about customer success? Does it include being exceptional? To help you answer these questions, I invited Dave Blake , Founder & CEO of ClientSuccess , onto the podcast to go over what exceptional customer success looks like. What is Exceptional Customer Success? While there is no ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value:
                'How are you thinking about customer success? Does it include being exceptional?',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: 'To help you answer these questions, I invited ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Dave Blake',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/davecblake/'
              }
            },
            {
              nodeType: 'text',
              value: ', Founder & CEO of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'ClientSuccess',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.clientsuccess.com/'
              }
            },
            {
              nodeType: 'text',
              value: ', onto the podcast to go over what ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'exceptional',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' customer success looks like.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '29q7CCtj2dYV24wtCiUkME',
                type: 'Entry',
                createdAt: '2021-08-13T15:56:15.993Z',
                updatedAt: '2021-08-13T15:56:15.993Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Implementing and Scaling Human-First Experiences',
                sounderLink: 'https://embed.sounder.fm/play/113038',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/implementing-and-scaling-human-first-experiences/id1528594709?i=1000507428615',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/Yzc3MGQ0MDItYWYwZi00MWE2LThkZDUtNmUwNTZlYzc2MzYz?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/implementing-and-scaling-human-first-experiences-81303933',
                spotifyLink:
                  'https://open.spotify.com/episode/4cuBuL7E1mOTE3M3v81zcW?si=uX0lKTVUQ6iOy57iMGdROA&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'What is Exceptional Customer Success?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'While there is no universal ‘look’ of exceptional customer success, there is a universal ‘feel’ of what it means to provide this exceptional level of support to your customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "That is, working towards maximizing your customers' investment in various products and services as a company, and delivering an amazing customer experience along the way. ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Simply put, exceptional customer success is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'going the extra mile.',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Varying Levels of Expected Engagement ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A great question to ask your team is “How can we make exceptional customer success possible and repeatable?”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'The answer: ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Adapt your approach to help them achieve their goals. ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Your customers are human, will ramp up at different times and will have varying levels of expected engagement from you, the seller. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'This is why having a human-first approach is critical. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7d9Np9xV9NJPTJYlsLm5qY',
                type: 'Asset',
                createdAt: '2021-08-13T16:30:52.600Z',
                updatedAt: '2021-08-13T16:30:52.600Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from David Blake',
                description: 'Podcast quote from David Blake',
                file: {
                  url: '/img/contentful/7d9Np9xV-l1ucjwnrqe0o2wmlf45q.webp',
                  details: {
                    size: 41310,
                    image: {
                      width: 960,
                      height: 541
                    }
                  },
                  fileName: 'l1UcJWNRqe0O2wMlf45Q',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'By having a human-first approach, you are able to understand your customers well enough to know what value they need and meet them where they are at. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Let’s use these two customers as an example:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Customer A: ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'Ramped up employees quickly, fully integrated your product on all their teams, and has efficiently trained their employees on their own within 3 weeks.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Customer B: ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'Interested in walkthroughs of features, implemented on some teams but not all, and wants tailored coaching for employees over the course of 3 months.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is a great example of how an amazing customer experience can vary from customer to customer. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'On one hand, Customer A might want a more hands off approach and only come to you with questions or troubleshooting. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'On the other hand, Customer B might want a more 1-on-1 approach tailored to their company and unique needs. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Both are ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'valid ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'needs!',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'By being able to acknowledge these differing journeys and understand your customers well enough to know what value they need, you are able to build a strong relationship off of respect, service, and being unique.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'How Can You Make Exceptional Customer Success Possible?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Making ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'exceptional',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' customer success the gold standard starts internally with the professionals who are on the front lines. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'These professionals need to be ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'authentic',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'passionate ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'human',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '(Again, human-first approach!)',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'By leading with authenticity and passion, these customer success professionals are then able to genuinely care about customers as ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'individuals',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'That in and of itself also means these professionals are willing to help and wanting their customers to succeed.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'When Do Customer Interactions Matter Most?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Well… all of them!',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Optimizing all of your touchpoints means you are connecting with your customers while they are moving through all stages of your pipeline, even when they churn. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'An example of some touchpoints in your business:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Sales to Onboarding ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Onboarding to Adoption ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Adoption to Usage ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Usage to Renewal ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Usage to Churn',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'By optimizing your touchpoints, you are able to connect and gauge what your client needs in that moment and what their sentiment is when making important decisions.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'These important decisions could be anything from increasing their adoption of your product or canceling it all together.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Staying in the know makes you more human and better able to provide your customer with the tools or insight they need to be successful or leave happy. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A great question to ask your organization is “How do we treat customers when they leave?”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is important because in customer success, it’s a small interconnected ecosystem that has many complimentary key players to your business.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'This post is based on the ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leaders',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' podcast with ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Dave Blake',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/davecblake/'
              }
            },
            {
              nodeType: 'text',
              value:
                '. To hear this episode, and many more like it, you can subscribe to Customer Success Leaders on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts. ',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
              }
            },
            {
              nodeType: 'text',
              value:
                'If you don’t use Apple Podcasts, you can find all our episodes ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'here.',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '6VImNPHX6L3TaBWiKx1cK7',
    postTitle: 'Why You Should Specialize in Customer Verticals',
    seoTitle: 'Why Customer Success is Specializing in Verticals',
    seoUrlSlug: 'specialize-in-customer-verticals-with-megan-piccininni',
    seoMetaDescription:
      'Customer Success professionals should have deep knowledge of industry verticals. Listen to the latest Flatfile podcast to learn more.',
    category: 'Podcast',
    tags: ['Customer Success', 'Podcast'],
    publishDate: '2021-02-01T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2vbx0LJnQLcsGzEClEAMgL',
        type: 'Asset',
        createdAt: '2021-08-13T16:26:03.658Z',
        updatedAt: '2021-08-13T16:26:03.658Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Megan Piccininni of Salesforce joins the Customer Success Leader podcast',
        description:
          'Megan Piccininni of Salesforce joins the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/2vbx0LJn-ahvmz9qzy3okqmnkytrq.webp',
          details: {
            size: 77516,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'AHVMz9Qzy3OkQMNkyTRQ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Megan Piccininni of Salesforce joins the Customer Success Leader podcast',
    summary:
      'For Customer Success professionals, product knowledge is always important. What’s equally — maybe even more — important than knowing your product? Knowing your customer’s vertical. In this episode, we sit down with Megan Piccininni , Regional VP of Customer Success at Salesforce . We covered the following... The reason why ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Product knowledge is important, it’s true. What’s equally — maybe even ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'more ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '— important than knowing your product?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Knowing your customer’s vertical.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode I sit down with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Megan Piccininni',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/meganpiccininni/'
              }
            },
            {
              nodeType: 'text',
              value: ', Regional VP of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Salesforce',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.salesforce.com/'
              }
            },
            {
              nodeType: 'text',
              value: ', to talk about:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why Salesforce is moving to a more specific vertical model',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How their CS teams have started to specialize in specific verticals',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ways Salesforce educates their customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How Megan’s team adds value to the renewal process',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Megan’s career has been mainly focused on technology, including the larger ecosystem of Salesforce. She started out in Marketing at ADP, where she got straight into working with Salesforce as they were implementing their solution. Moving forward, she worked in consultancies like Deloitte and IBM.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Megan is most passionate about being customer-facing, getting to the root of her clients’ challenges and solving them from there. Her passion for what she does is what makes this episode worthwhile.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Salesforce is focusing less on geographical location',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Before we got into the nuts and bolts of the discussion, Megan shared that Salesforce is evolving into a less geographically focused business, helped along by the pandemic. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It doesn’t mean that there’s no base of operation, but it does enable flexibility for their team and give them the opportunity to travel again, when the time is right.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Our thoughts at Flatfile, about being remote-first, was what we thought made us stand out, and now everyone’s remote by requirement, so it’s interesting to see how the world of work operates with this being a common trend. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Megan believes that we’re heading to a hybrid work model, where there’ll be more remote work widely available, with some degree of expectation to meet in person, be it with teammates or customers. Investing in face-to-face engagement with customers has its place and certainly has a unique value that’s appreciated more today because we’re limited in providing and receiving this.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'What is customer success?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To go out and find or deliver something, we all need to first make sense of it in our own minds. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Megan mentioned that Salesforce has experienced somewhat of a paradigm shift about this over time, from defining successful use of their platform, to expanding that perception from their customers’ points of view.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Customer success might look different for each customer. There are unique key metrics and performance indicators your customers have, and maybe they do or don’t overlap with what you think they are, but fundamentally Megan explains the golden thread that ties it all together: delivering customer success is making an impact on your customers’ business objectives. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The entire focus of what Salesforce does has shifted onto their customers.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If their customers meet their respective targets, they grow, and that means Salesforce grows with them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Why Salesforce is moving to a more specific vertical model:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Salesforce is known as a titan in the CRM world, but a recent report indicated that it serves a mere 14% of the CRM market at the moment. It’s no wonder the team is thinking about fresh ways to target and serve customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As massive as Salesforce is, they understand how much room there is for growth, and they’re going to keep doing what they do best, in new and exciting ways, to achieve that for their business.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The idea behind Salesforce switching gears and focusing on verticals, is in fact customer success. Although they already serve businesses in verticals like financial services, life science, public sector and retail, there’s movement toward what Megan calls ‘CMT’ — communications, media and technology as a vertical on its own. The goal is to meet customers where they are, and offer industry best practice that’s easy to adopt and see tangible impact through.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'How is Salesforce starting to specialize in specific verticals?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Initially it seems that the Salesforce team was organized according to geography, but there were hints of vertical focus. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For example, west of the Bay Area was where mostly technology-based customers and teams were situated. What’s happening now is a process of formalizing those structures of specialization in response to market activity and the competitive landscape.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As the process continues, it’s natural to have some verticals appear further ahead and more developed within Salesforce, but there’s a broader mindset shift across the business which is both positive and strategically successful. There are questions that emerge as any process is rolled out, but being able to start having already had some of those verticalized structures is a big win, I’d say.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Ways Salesforce educates their customers:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To educate a customer, you’d have to know about the industry they’re in. Sometimes, that means Salesforce team members learn about entire industries (and verticals) that are completely different from what Salesforce is and does and offers as an organization. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is closely aligned with the shift to verticalization because it’s all about finding more efficiency and effective paths to customer success.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Salesforce has both core and success enablement teams to build out central and broader plans that filter the focus from a company level down into the customer success group, for example the customer success group for CMT that Megan’s a part of. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Salesforce as a team has industry experts on board to then design and build elements like the framework and methodology, keeping in mind at all times what their customers’ priorities are. What happens next is that both the central and specific customer success teams create that model that customers can utilize for their own growth and future success.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'What I also found to be pretty awesome is that Salesforce has a learning platform called Trailhead. It’s completely free for their customers to use and it unlocks a path of further enablement for their customers. It allows Salesforce clients to create a learning journey that works for their specific pace as a team. It’s interactive, there’s no Q&A, you can earn points — the whole thing’s gamified. There’s integration of video and other media that make it engaging and a novel experience — learning through play is something that can be achieved even at this scale and that’s what Salesforce is proving with this.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Of course, there’s also physical site-based training available. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Salesforce holds training sessions for their customers, they host office hours and they’ll even bring in industry-related speakers to assist with getting maximum value from the platform for their particular scope of work. All-in-all Salesforce has a well-rounded approach to customer success and education.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'How Megan’s team adds value:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Adding value starts long before the purchase or adoption of the platform takes place. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Understanding this is what makes Megan’s team so successful at it. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'They’re asking themselves questions like:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How can we enable our clients to up-level their conversations and focus more on value for their customers?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What are our customers’ business objectives and KPIs?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How do the different success initiatives that we create align with those objectives and KPIs?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How can we ensure that we’re measuring the value and impact we have for our customers’ objectives and KPIs?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Training enablement at Salesforce is constantly taking focus into their customers’ respective business visions and that’s the key differentiator here. Every aspect of creating value is about “walking the talk around business value,” as Megan says. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s not always easy, either, focusing on business value and impact; it’s easy to get sucked into hyper-focus on tactical work. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The reality, though, is that tactical work never goes away, and while it does need attention and it needs to be taken care of, the big picture and broader objectives and KPIs are those guiding lights for the customer and those need to be taken seriously, too.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Salesforce doesn’t limit their support for their customers either — it’s not just the customer success manager present in the account management team. There’s actually a host of what Megan calls ‘peripheral representatives’ who will be available to help out or answer questions, like advisors. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is what makes it all work so well together: investing in the platform pays back value that adopts and prioritizes the customer, values, objectives and all.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'What about value that’s specific to the renewal process?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In addition to everything we’ve just spoken about, Salesforce also involves highly specialized senior technical experts, who can proactively engage with larger customers who need executive level technical support. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Megan’s customer success team sits at the core of the account and is positioned perfectly, to rope in other resources available within the Salesforce ecosystem: all for the client’s benefit. Some customers’ employees have a lot of technical aptitude, which makes the daily process of customer success management all the more intriguing and rewarding for Megan’s team: there’s such a wide range of opportunities to strengthen that customer relationship, and keep offering value.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'They’ve gone so far as to introduce their new UI/UX framework, called Lightning, that provides actionable insights to further customize how clients each use Salesforce, and most importantly benefit from it. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When it comes specifically to renewing or expanding, the customer success team is working hand in hand with the sales team; they’re aware of how much quantitative value the platform and additional initiatives have brought in for those customers who are up for renewal or upgrade. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'All efforts at the point of renewal are geared toward increasing visibility for the customer on the value they’ve obtained through their use of Salesforce as a platform and success enablement resource.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Check out the podcast to hear more. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '61qMRSNV4rJRpIcHEtYP91',
                type: 'Entry',
                createdAt: '2021-08-13T15:55:20.340Z',
                updatedAt: '2021-08-13T15:55:20.340Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Why You Should Specialize in Customer Verticals',
                sounderLink: 'https://embed.sounder.fm/play/111419',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/why-you-should-specialize-in-customer-verticals/id1528594709?i=1000506614417',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/ODc2MmQyMjItNzE4ZS00NzdjLWIwNmUtNzEyYzgwNzk3YjBk?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/why-you-should-specialize-in-customer-verticals-81114381',
                spotifyLink:
                  'https://open.spotify.com/episode/37T2uMc54eCZsEPVKaUDFb?si=mxmx6FFhQh-mSTVMFC0GKw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'To hear more interviews like this one, subscribe to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657'
              }
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Spotify',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: ', or wherever you listen to podcasts.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '71XGm4OEaD9iZeakfON4Cv',
    postTitle: 'Success Teams Align with the Customer, Not Sales',
    seoTitle: 'Success Teams Align with the Customer',
    seoUrlSlug: 'aligning-with-customers-richard-myers',
    seoMetaDescription:
      'A successful customer success team aligns with the customer - even over the business. Hear more on the Customer Success Leader podcast.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2021-01-26T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1nesq7Xy5nDAAWjXARXJOc',
        type: 'Asset',
        createdAt: '2021-08-13T16:00:12.801Z',
        updatedAt: '2021-08-13T16:00:12.801Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Richard Myers of Linode joins the Customer Success Leader podcast',
        description:
          'Richard Myers of Linode joins the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/1nesq7Xy-6vb4xlofrtcelifz1abw.webp',
          details: {
            size: 78421,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: '6vb4xlOFRTCelIFZ1ABW',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Richard Myers of Linode joins the Customer Success Leader podcast',
    summary:
      'A successful customer success team always aligns with the customer — even over the business. But you can marry customer success to business outcomes. You just need to start with the right mission and values. In this episode of Customer Success Leader, we sit down with Richard Myers , Vice ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A successful customer success team always aligns with the customer — even over the business. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But you can marry customer success to business outcomes. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'You just need to start with the right mission and values. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode of Customer Success Leader, I sit down with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Richard Myers',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/richard-myers-a1297b13a/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', Vice President of Customer Support & Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Linode',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linode.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', to discuss what customer success really looks like — and how to achieve it. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Defining ‘success’',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Richard thinks (and rightfully so) that customer success is really cool. To him, it’s about whatever you do in your organization to help your customers become successful. Sure, it’s easy to connect the dots between your customers’ success and their increased spend on your platform, but it doesn’t need to be much more complex than that.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The key is in aligning the goals of your customers with the goals of your own company. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'If they succeed, naturally so do you. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value:
                'How did Richard Myers find his way into working in customer success?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'What’s so great about this episode is Richard’s honesty. He mentioned that when he first started at Linode, he hadn’t even heard of customer success. With the company still being a startup at that time, there naturally weren’t a lot of people on the team.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As time passed, Richard says that Linode identified a need for customer success because of the growth that their sales and marketing teams were experiencing. There was a bit of research and digging around into it: the name ‘customer success’ in itself, what it was all about, how it was used elsewhere — anything to understand it more and leverage it the right way. Kicking off their own efforts in customer success, Linode began by including it as a function of marketing within the organization.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Like with most startups, this was a move akin to feeling your way around in the dark, and understanding that landscape more as time passed. Richard shared with me that, over time, Linode’s mission and values as a business evolved to become more closely aligned with what their customers actually need. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'They’re still evolving and are only a few years in to having a designated customer success team.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'What makes Linode’s customer success function unique?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As a function or tactic, customer success first appeared in the context of software companies. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Because Linode offers Infrastructure (and not software) as a Service, this means that their customers are slightly different, have different needs and consume Linode’s offering in a different way than that ‘traditional’ SaaS client-provider relationship works. Linode isn’t locking their clients into contracts either, creating more freedom for change in the mind of their customer, but also more business risk as Linode has a tougher time predicting and forecasting revenue.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Even measuring retention and growth becomes challenging in this situation, let alone improving those metrics. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Richard’s team is taking what’s available in the context of Saas and adapting it for their unique environment, which means that every step of their nuanced customer journey is considered and accommodated for. He compares it to being a gas company to consumers: customers don’t speak much to them as the provider, but they can turn their gas on or off, and it’s really only if there’s a need to then customers will reach out to talk to them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Today, though, there’s more two-way engagement, but at first it was an odd thing for the customer to receive Linode’s proactive outreach.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Why success teams are a function of support, not sales',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Richard feels super strongly about this one, more so with time. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'He shares that account management exists for a very good reason, but its purpose is different to customer success: account management engages with customers with the goal of getting customers to consume or buy more product, increase usage and so on. Customer success, though, can be counterintuitive if you place its actions next to your own company’s objectives.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A customer success team’s primary goal is to help their customers succeed. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'At times, the route toward that is not necessarily in the best interests of your organization, which is what the primary goal of sales, business development and account management is, when you think about it. Of course it’s possible to incentivize your customer success team on metrics like retention or growth of a customer, but there needs to be an understanding that their success leads to them consuming or using more of what you have to offer.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Customer success leads to customer growth, which leads to your organization’s growth in turn.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'How to align with your customer and your business goals',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Linode’s way of achieving this alignment:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Alignment begins with engagement, so I got to ask Richard about his starting point with the process. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In his mind, the logical starting point aligns with the account management route. Your biggest customers are going to influence your product roadmap the most, and probably going to want to speak with you — at least more so than someone who’s inclined to switch away at the drop of a hat.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Although Linode doesn’t lock customers into contracts, it also does kind of happen naturally. IaaS is a hassle to change, for most companies, so even though it’s possible to do, it’s not a likely scenario. This being said, though, it’s important to remember that keeping your customers starts by finding out how to make them happy and successful, and that can only come from conversations with them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Some customers will be, and are, more vocal and will actively reach out for assistance and support. Richard explained that this is pretty much what motivated Linode to create a customer success team: a big client asking for support often enough, eventually saying that they needed something like an account manager.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'How you can go about achieving the same:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Apart from engaging with customers, there are some foundational elements to think about when you’re trying to align your business with your customers’ businesses. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Your customer success team, for example, is really there to help you bridge knowledge gaps between what you see within your own organization, and what you can see within your customers’ operations. Enabling your customer success team to proactively identify value expansion opportunities that are win-win for you and your customer means creating an organizational environment and communication structure for information sharing.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'You need a strong foundation on core values and a mission statement that should be clearly understood by everyone on your team, whether or not they’re in customer success. If these things are in place then by the time a situation comes around, where customer success isn’t immediately or directly pointing to an uptick in your profit margin, there’s no uncomfortable decision-making process for you to endure. The values are clear. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'The end-goal is clear. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Everyone knows what to do.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s not an easy thing to get right, and you have to consider that absolutely everybody in your business and value chain is affected by the way you develop, articulate and strive for your organizational vision. There may be a need for iteration, just like with Linode — it took a couple of tries to get that alignment to a point where it really hummed.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'How to establish that foundation with your customer:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This comes down to setting and managing expectations, and it links back to Richard’s mention of that specific value that sales and account management really has within any organization. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'That’s who sets those expectations upfront with the customer, when it’s time to sign or renew a contract. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The customer success team can even be involved at this stage of the relationship, to advocate for both sides and make sure that the foundation is strong enough for both parties to build upon.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Why you should be your customer’s first choice — not their only choice',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Richard nailed it when he said that this is the responsible thing to do for a business like Linode. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Using the example of back-ups, he spoke about how important it is to have redundancy, and so advising their customers to consider some competing brands’ infrastructure is bold, and certainly unconventional, but it’s the right thing to do from a customer success standpoint. It goes back to what he said earlier about customer success prioritizing success for the customer, even when that isn’t a direct translation into the best interests of your organization.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Showing and proving to your customer that you’re not out to get 100% of their wallet, as Richard says, is bold and it shows that you’re fully focused on what will work for them. It’s selfless, and how many companies can really compete with you on that when you’re sincere about it? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is value creation at a level that’s far beyond ‘just doing business’ — it’s how you make your customers feel secure enough, how you win trust, and how you become their go-to for advice and likely for critical needs, expansion support and so on, in the future.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode of Customer Success Leader, we discuss: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why success teams are a function of support, not sales',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to align with your customer and your business goals',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why you should be your customer’s first choice — not their only choice',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '28Mp3tSjeoksSNdyELXDDO',
                type: 'Entry',
                createdAt: '2021-08-13T15:54:20.664Z',
                updatedAt: '2021-08-13T15:54:20.664Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Success Teams Align with the Customer, Not Sales w/ Richard Myers',
                sounderLink: 'https://embed.sounder.fm/play/108948',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/success-teams-align-with-the-customer-not-sales-w/id1528594709?i=1000505778111',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/ODJmNjc1MzktOTI3YS00Y2QxLTliOTQtNjk0NzliNzUzMGU5?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/success-teams-align-with-the-customer-not-sales-w-richard-myers-80936361',
                spotifyLink:
                  'https://open.spotify.com/episode/1QuOnadS7i83209tYoDAxc?si=qfQmIRy3T-Keyr7rmMF1Vw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'To hear more interviews like this one, subscribe to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657'
              }
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Spotify',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: ', or wherever you listen to podcasts.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5zbZpcC2bJzKoVT6YgjXM9',
                type: 'Asset',
                createdAt: '2021-08-13T16:24:41.272Z',
                updatedAt: '2021-08-13T16:24:41.272Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast Richard Myers quote',
                description: 'Podcast Richard Myers quote',
                file: {
                  url: '/img/contentful/5zbZpcC2-qlys7w0wr0qbjfenmxzu.webp',
                  details: {
                    size: 42214,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'qLyS7W0WR0qbJfenmxZU',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ehr0YSOHP4QI8rDOR4Akj',
                type: 'Entry',
                createdAt: '2021-08-13T16:04:09.296Z',
                updatedAt: '2021-08-13T16:04:09.296Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's State of Data Onboarding Report",
                text: 'Learn how companies are tackling the data import challenge',
                ctaText: 'Download now',
                href: '/state-of-data-onboarding-2020/'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '6QlO2LJNu4PgRRTu9v3QE7',
    postTitle:
      'Create a Healthy Balance of Product & Customer Success Interactions',
    seoTitle: 'Create a Healthy Balance of Product & Customer Success',
    seoUrlSlug: 'product-and-cs-team-interactions-vanessa-hannay',
    seoMetaDescription:
      "Mappping the customer journey is critical. Hear from Muck Rack's Director of Customer Success, Vanessa Hannay on the Flatfile podcast.",
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2021-01-19T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5j17Ys4Fr65fSI4FByjJH',
        type: 'Asset',
        createdAt: '2021-08-13T15:19:04.864Z',
        updatedAt: '2021-08-13T15:19:04.864Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Vanessa Hannay of Muck Rack joins the Customer Success Leader podcast',
        description:
          'Vanessa Hannay of Muck Rack joins the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/5j17Ys4F-8chwn9cvtyc19oefy5me.webp',
          details: {
            size: 171203,
            image: {
              width: 961,
              height: 540
            }
          },
          fileName: '8Chwn9cvTyC19OEfy5mE',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText:
      'Vanessa Hannay of Muck Rack joins the Customer Success Leader podcast',
    summary:
      'Serving your customer via your product and Customer Success team interactions is always a bit of a balancing act. There needs to be healthy levels of both. In this episode of Customer Success Leader, Vanessa Hannay , Sr. Director of CS at Muck Rack , talks to us about… Striking ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It can be a bit of a balancing act between serving customers via product and CS team interactions. But both are important. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode of Customer Success Leader, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Vanessa Hannay',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/vanessahannay/'
              }
            },
            {
              nodeType: 'text',
              value: ', Sr. Director of CS at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Muck Rack',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://muckrack.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', helps us find the middle ground when it comes to guiding customers to success by filling the void between problems and solutions.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Finding Harmony',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Striking a balance between customer interactions isn’t always easy. Vanessa says to not only be collaborative in the process but to also make sure customers are successful, we should understand: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Where customers are running into pain points',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Where customers are achieving great success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to capitalize especially off of the success that one customer has',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to help other customers realize the same',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Meeting Customers Halfway ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When you’re establishing relationships with customers, it’s important to build a foundation of trust. But that trusting relationship should work both ways. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'So how do we build that foundation with customers?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Open communication ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Understanding as much from the sales handoff process as possible',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Understanding why they purchased the tool ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Supporting the initiatives that customers are looking to achieve',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Trying to understand and improve the value of their work ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "\nOverall, we want to focus on asking ourselves two questions: \n1. What is the value that we're actually providing back to the business and...\n2. Can we put something justifiable and quantitative behind that value as well?",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Pro tip: a leader or senior level person should really be able to excite the team and motivate them to use the tool in the way that both you and the customer want it to be used.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Designing Team Structure to Support Your Goals ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Vanessa has a cross functional team, but each team member is dedicated to specific tasks and responsibilities that lead toward customer success. The systems in place ensure that there's a high level of communication happening internally about each customer and what their experience is like throughout the process. ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'She structures her team like this: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'One of team member is focused on customer communication',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'unordered-list',
                  content: [
                    {
                      nodeType: 'list-item',
                      content: [
                        {
                          nodeType: 'paragraph',
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Keeping customers aware of new products and features within the platform',
                              marks: [],
                              data: {}
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'list-item',
                      content: [
                        {
                          nodeType: 'paragraph',
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Keeping customers engaged ',
                              marks: [],
                              data: {}
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Another team member works strategically with our account management team',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'unordered-list',
                  content: [
                    {
                      nodeType: 'list-item',
                      content: [
                        {
                          nodeType: 'paragraph',
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Managing all of the customer renewals ',
                              marks: [],
                              data: {}
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'list-item',
                      content: [
                        {
                          nodeType: 'paragraph',
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Helping them better understand customer health ',
                              marks: [],
                              data: {}
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'The third team member on the success side is focused on onboarding. ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'unordered-list',
                  content: [
                    {
                      nodeType: 'list-item',
                      content: [
                        {
                          nodeType: 'paragraph',
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Customers receive one to one dedicated training call upfront',
                              marks: [],
                              data: {}
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'list-item',
                      content: [
                        {
                          nodeType: 'paragraph',
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Answering customer onboarding questions ',
                              marks: [],
                              data: {}
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "“Our team's job is to really make their jobs easier, and as a result, improve our customers day to day as well. So we're definitely more strategic as a cross functional team.” — Vanessa Hannay",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s a combination of tools and collaboration with the product team that allows for:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Taking things to the next level in terms of measuring account health',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Helping the account managers fund opportunities for upsells why',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Pointing out the opportunities or red flags are with different customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Staying one step ahead of any issues or decreasing in value that a customer is realizing through the product',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This carefully curated balance between CS teams and product teams is her company’s key to success and growth.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode of Customer Success Leader, Vanessa talks to us about… ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Striking a balance between customer interactions w/ the product & CS team',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Tips on establishing trusting relationships with customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Why losing a company isn’t losing a customer',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '64skLwiVGIn76zmoxryCV4',
                type: 'Entry',
                createdAt: '2021-08-13T15:53:15.629Z',
                updatedAt: '2021-08-13T15:53:15.629Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Create a Healthy Balance of Product & CS Interactions w/ Vanessa Hannay',
                sounderLink: 'https://embed.sounder.fm/play/107370',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/create-a-healthy-balance-of-product-cs-interactions/id1528594709?i=1000505073265',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MzgzYmI2ODEtMTUzMC00ZjBiLWI4YzQtNTg4MTI4ZDJhOTQ1?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/create-a-healthy-balance-of-product-cs-interactions-w-vanessa-hannay-80765350',
                spotifyLink:
                  'https://open.spotify.com/episode/1FrA4BQSGEMPfhrinAmQcH?si=VGp5jyRSSlK0MjfzbHxyxw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'To hear more interviews like this one, subscribe to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657'
              }
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Spotify',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: ', or wherever you listen to podcasts.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7elT4Wfpz5dwxvDSJZ79OH',
                type: 'Asset',
                createdAt: '2021-08-13T18:24:19.872Z',
                updatedAt: '2021-08-13T18:24:19.872Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Vanessa Hannay',
                description: 'Podcast quote from Vanessa Hannay',
                file: {
                  url: '/img/contentful/7elT4Wfp-brucrlhmtyw7f2tkbgex.webp',
                  details: {
                    size: 246103,
                    image: {
                      width: 1201,
                      height: 628
                    }
                  },
                  fileName: 'BruCRlHmTyW7F2tkBgEx',
                  contentType: 'image/jpeg'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '5fouUCnaYib2vPybkrR7tf',
    postTitle: '5 predictions for data management and data onboarding in 2021',
    seoTitle: 'Predictions for Data Management and Data Onboarding',
    seoUrlSlug: '5-predictions-for-data-management-and-data-onboarding-in-2021',
    seoMetaDescription:
      'Flatfile co-founders reveal their predictions for data management and data onboarding in 2021. Check out the top five predictions.',
    category: 'Data exchange',
    tags: ['Data management', 'Data predictions'],
    publishDate: '2021-01-14T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7fqj6dNven9nqFe1daA1Do',
        type: 'Asset',
        createdAt: '2021-08-13T21:29:07.880Z',
        updatedAt: '2021-08-13T21:29:07.880Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile presents 2021 data predictions',
        description: 'Flatfile presents 2021 data predictions',
        file: {
          url: '/img/contentful/7fqj6dNv-ea4fi7imrecmd1v64prq.webp',
          details: {
            size: 78525,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Ea4FI7IMReCmd1V64prQ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile presents 2021 data predictions',
    summary:
      "It can be difficult to predict how the business world will change in a year. I mean, look at 2020. No one could have guessed that nearly all businesses would be forced to work fully remote, at a moment's notice, with little to no infrastructure. And there’s no real timetable ...",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2dLBlxtX8ETQllCPJrcdLU',
        type: 'Entry',
        createdAt: '2021-08-13T21:28:19.412Z',
        updatedAt: '2021-10-07T04:32:30.871Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'JK Sparks',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '19PRmT7PwvC39hgE3f445U',
            type: 'Asset',
            createdAt: '2021-08-13T21:27:13.868Z',
            updatedAt: '2021-08-13T21:27:13.868Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'JK Sparks headshot',
            description: 'JK Sparks headshot',
            file: {
              url: '/img/contentful/19PRmT7P-3uyorwrxtfaobczpgisu.webp',
              details: {
                size: 40925,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: '3uYorWRxTfaoBCZpgISu',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Head of Growth Marketing',
        department: 'Growth'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It can be difficult to predict how the business world will change in a year. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'I mean, look at 2020. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "No one could have guessed that nearly all businesses would be forced to work fully remote, at a moment's notice, with little to no infrastructure. And there’s no real timetable on when (or if) the workforce will ever go back to “normal”. ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For technology companies, the way we do business is changing by the minute. So if we want to keep up in 2021 (or for some of us, recover!), we have to recognize last year’s trends, then look to the future. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'I sat down with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' founders David Boskovic and Eric Crane to talk about what we learned from 2020, what to expect in 2021 as it relates to technology and data management, and what it means for you and your customers. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are the 5 predictions for 2021 for data management and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' (with a bonus prediction at the end you should watch out for).',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. Innovation outpacing adoption (David) ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Today, individuals and companies are able to create some of the most innovative technologies at a pace we’ve never seen before. Successful startups can be built in no time, with tools and resources readily available to help bring ideas to life fast...and there’s no sign of slowing down. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But the challenge remains, how quickly are companies actually able to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'implement',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'and',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'use ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'those innovations? ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "“Every year we see new products coming in and disrupting spaces that are solving real problems really well,” says Boskovic. “The problem is that that innovation is way ahead of our ability to adopt it. So if it takes you two years to adopt any of that technology, you're two years behind at any given time.” ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'David predicts a surge in solutions and platforms like Flatfile that can close that adoption gap by helping companies ramp up to new software solutions more quickly and seamlessly. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Flatfile gets to play a part in this trend by actually decreasing the economic load of adopting new software.”  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This trend also comes with a downstream effect on software innovation. As software adoption continues to increase exponentially, so will innovation. And as tools become easier to adopt, the more verticalized software we’ll see popping up. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“I believe we’re going to see a much bigger increase of verticalized SaaS companies solving one problem really well, and enterprise-level companies adopting those products where they otherwise wouldn’t.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'To sum up: look out for more tools that help you ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'adopt ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'innovative software quicker and easier, as well as more industry/vertical-specific tools to hit the scene.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '2. The growth of non-data experts in data processes (Eric)',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Long gone are the days of putting in a request to your BI team every time you need to see data or a report. Data is becoming more and more accessible to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'everyone',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' in your organization. And into 2021, Eric believes that trend will only continue.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“You have these solutions which allow folks to actually go in and build applications, analyses, and understand their business without having to be an expert in data or software.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Eric mentions Instabase as an example. “They let you set up your own business applications, and they’re reliant on clear, understandable, usable data from someone’s perspective where they’re not actually a technical individual.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This can be a game-changing solution for your organization. Not having to ask a different department that’s already busy with mission-critical assignments for reports and data frees up time for everyone involved.   ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'There is a caveat, though. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "“The challenge is that it's reliant on an assumption that the data is good and understandable. And if the data is not good and understandable, all of that is for naught.” ",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'So, while it’s great to have your company’s data easily accessible to those who aren’t data experts, your data must be clean, usable, and identifiable so that anyone can understand it and use it effectively. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. The exchange of data in ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'every',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' transaction. (David)',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We’re just in the early innings of data being a significant part of all business transactions,” says Boskovic. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Yet, the way we ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'exchange data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is still very primitive. It’s time consuming, insecure, and even when you receive that data, you have to do a lot of work before it’s of any value to you. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'David compares the state of data transaction to how people used to exchange goods, before our modern currency system and economy. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“If you think back long enough, people used to exchange chickens and goats. Then it turned into ‘I’ll bring over a jewel for your goats’ which turned into a system of currency and economics, and so on. Right now, when it comes to how we transfer data, we’re still in the chickens and goats phase.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'But David doesn’t think that will last long. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“In the next few years, we will see a new world where exchanging data is as easy as sending a wire or exchanging money.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As a society, we’re comfortable transferring our money quickly, safely and securely with tools like Venmo and CashApp. It won’t be long until companies feel just as comfortable managing and sharing their data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Leveling the playing field (David) ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With a vast majority of companies and industries still relying on legacy software solutions, there’s always been an advantage for the top 5% of companies that have the budget and resources to adapt their workflows to cloud-based SaaS technologies.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“There is an accelerating gap between the vast majority of the global GDP and the leaders.” ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Banks, airlines, government agencies - almost every major industry struggles with outdated hardware and legacy code. Of course they would love to switch to a cloud-based solution, but not everyone has the time, money, and/or resources to get it done without shilling out millions of dollars and months (or even years) of ramp-up time. And the longer these legacy companies aren’t able to make the digital transformation, the harder it will be to keep up. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'That’s where solutions like Flatfile come in. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Flatfile helps close this gap by making it possible for companies using older legacy technology to quickly adopt newer technology and level the playing field a bit.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'This potentially has 2 major impacts: ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Help smaller companies catch up to larger companies by spending less time and money on storing, sharing, and analyzing customer data. ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Give larger companies a leg up against their competitors by allowing them to allocate time and resources on expanding into new markets, verticals, and industries.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. The rise of opinionated BI (Eric)',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Most of today’s Business Intelligence tools are great at helping companies organize, visualize, and measure their data, goals, and outcomes. But there’s still a level of manual work to be done on your end to model your own results. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“If you think about the first generation of cloud-based BI tools, those are mostly just empty canvases, right?” ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'says Crane.',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' “Like ‘Here’s the brush, the paint, and the canvas, now you have to go in and make your own painting out of this.”  ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But now, companies like Backbone.ai are coming onto the scene, which are less like a blank canvas, and more like a BI coloring book.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We’re seeing a generation of business intelligence tools that are giving you the tools to measure your business, as well as share an opinion on how to reach that measurement.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Eric predicts that more and more Business Intelligence tools of 2021 will not only help you visualize and measure your data, but come with machine learning and AI baked into their software to provide specific, actionable insights on your data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This will impact businesses in many ways, but most importantly allowing companies to iterate on software development faster, more quickly track and stop potential cybersecurity breaches, and develop stronger partner and customer relationships through data that truly captures the needs of each one.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Bonus Prediction: Potential negatives to the ease of data accessibility',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As data becomes easier and easier to access, there’s another perspective we need to be aware of: Malicious use of that data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“There’s this negative correlation to the advantages that are provided by this increase in efficiency and access,” said Boskovic. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Bad Actors are much less likely to abuse something that’s very difficult to use and access. But the easier it is for them to get a hold of, the easier it is for them to cause damage with it. This is especially true in terms of public data or governments. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In 2021, companies should not only be aware of the security risks and challenges that come with managing and sharing data, but have an ethical responsibility to evaluate their data practices for the good of their customers, and society as a whole.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '33qatlfJjIdXfdD159Tbd6',
    postTitle: 'Map the Customer Journey to Success',
    seoTitle: 'Map the Customer Journey to Success',
    seoUrlSlug: 'map-the-customer-journey-kia-puhm',
    seoMetaDescription:
      'In this episode of Customer Success leader, Flatfile and Kia Puhm discuss mapping the customer journey and avoiding random acts of success.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2021-01-12T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'U0kgitl2k7h3mUpZwhWhw',
        type: 'Asset',
        createdAt: '2021-08-13T18:18:36.205Z',
        updatedAt: '2021-08-13T18:18:36.205Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Kiam Puhm, CEO of Desired Path joins the Flatfile podcast',
        description:
          'Kiam Puhm, CEO of Desired Path joins the Flatfile podcast',
        file: {
          url: '/img/contentful/U0kgitl2-jl0322xfq724pec5163p.webp',
          details: {
            size: 87261,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'JL0322XFQ724peC5163P',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Kiam Puhm, CEO of Desired Path joins the Flatfile podcast',
    summary:
      "Do you know your customer's objectives, challenges, and timeline? If not, you might be practicing random-access customer success. Your customer could feel like you're executing acts at them rather than for them. In this episode of Customer Success Leader, Eric sits down with the Founder and CEO of DesiredPath , ...",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'What makes a customer keep coming back? Think about it: what keeps ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'you',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' loyal to your favorite brands?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The answer: We buy from companies when we feel like they understand us.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Kia Puhm',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/kiapuhm/'
              }
            },
            {
              nodeType: 'text',
              value: ', Founder and CEO of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'DesiredPath',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.thedesiredpath.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' helps companies take a customer-centric approach to achieve faster, smarter revenue growth.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Kia says to know the path of the customer is to walk in the customer’s shoes. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'And to do that, we have to think like the customer. It’s a mindset that should be adopted across an entire organization.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is where our customer journey begins.\n\nOur host Eric sits down with Kia to discuss the importance of creating a customer journey map that supports the customer down a successful path.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'See through the customer’s eyes',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Thinking from the customer's perspective is the best way to understand a customer holistically, meet them where they need to be met, and help them achieve their objectives.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In an experience economy, things are changing rapidly:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Our products and services that we deliver ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The markets ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The environment',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Customers' expectations are increasing exponentially with these changes. This puts a significant amount of pressure on businesses to be able to support customers.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "By thinking from a customer's perspective and using that as a desired path to success, you can continually gain insight about your customers.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Understand:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' What are the patterns of our most successful customers? Then, use those insights and learnings to figure out how we can replicate this to create a very prescriptive and proactive journey that allows our customers to achieve their successes.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value:
                'Understand the difference between random acts of customer success vs. holistic customer success\n',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As marketing strategy continually grows and evolves, companies are looking for better ways to do customer support. But there is often a disconnect between what customers need to be successful and the activities being executed at them in order to do that.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '"When we execute all these things ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'without that holistic context',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' of the customer, ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'we are executing acts ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'at',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' our customer, not ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'for',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' them.',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '" — Kia Puhm',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'How can we spot the difference in our approach?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: "Your customer should feel like you're executing acts ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'for',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' them rather than ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'at ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Holistic customer success looks like:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Knowing your customer’s objectives ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Knowing your customer’s timeline for reaching goals',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Aligning yourself with the customer',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Providing value that drives outcomes',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Understanding the bigger context of customers ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '“We need to be intelligent about how we are',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' aligning ourselves ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'to the customer, so that we are ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'providing value add and driving outcomes',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ', not just executing random acts of success at them.” — Kia Puhm',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Align Your Objectives ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To become intimate with customer experience, we want to feel like an extension of their business.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mapping out a customer’s holistic experience can be a challenge. But now that we understand the customer perspective and how to take an authentically holistic approach, we can start to figure out how to align activities and objectives to support the customer along their journey. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'How? Flip the structure upside down.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Instead of starting the organizational structure with our people, their roles, responsibilities, and what they will do with customers, we need to go backwards to a customer-centric approach that looks at the customer journey before anything else. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'This customer-centric approach allows clients to:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        "Discover and uncover areas that they weren't previously addressing ",
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Add value into their customer success engagement model',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Significantly impact retention and revenue',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Do you know your customer's objectives, challenges, and timeline? If not, you might be practicing random acts of customer success. Your customer could feel like you're executing acts ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'at',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' them rather than ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'for',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode of Customer Success Leader, we discuss:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What failure looks like in customer experience',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Random acts of customer success vs. Holistic customer success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why customer mapping helps CX as well as marketing',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Moving the burden of intent from human to machine',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '48Yk9uQ6JL8rEjJLsBsEpX',
                type: 'Entry',
                createdAt: '2021-08-13T15:52:01.505Z',
                updatedAt: '2021-08-13T15:52:01.505Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Map the Customer Journey to Success w/ Kia Puhm',
                sounderLink: 'https://embed.sounder.fm/play/105578',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/map-the-customer-journey-to-success-w-kia-puhm/id1528594709?i=1000504385801',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MTc1NThiYTItZGMwOC00MzQ0LTg0Y2QtNzQ5YTUyOTBkMjdl?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/map-the-customer-journey-to-success-w-kia-puhm-80610390',
                spotifyLink:
                  'https://open.spotify.com/episode/2Xm0BP0TY80yYZDsbKEabG?si=zQRj-9lnTcKu2lir4l_pxg&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6NDIGhLEeuLdS4RqjoRTNS',
                type: 'Asset',
                createdAt: '2021-08-13T18:20:00.761Z',
                updatedAt: '2021-08-13T18:20:00.761Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Kia Puhm',
                description: 'Podcast quote from Kia Puhm',
                file: {
                  url: '/img/contentful/6NDIGhLE-902mfymatjqel4lxecjq.webp',
                  details: {
                    size: 39462,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: '902mfYMaTJqeL4lXeCJQ',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '5vlth463d3sDlqXWWonqbJ',
    postTitle: "Flatfile's 2020 year in review",
    seoTitle: "Flatfile's 2020 year in data import review",
    seoUrlSlug: 'flatfiles-2020-year-in-review',
    seoMetaDescription:
      'At Flatfile we took a collective look at all the data imports across our customer base in 2020. The infographic reveals our findings.',
    category: 'Flatfile news',
    tags: ['Data import statistics', 'Year in review'],
    publishDate: '2021-01-06T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5TWiyyymdxcJWOz8ZAY1wK',
        type: 'Asset',
        createdAt: '2021-08-13T21:31:51.665Z',
        updatedAt: '2021-08-13T21:31:51.665Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile reviews data import statistics from 2020',
        description: 'Flatfile reviews data import statistics from 2020',
        file: {
          url: '/img/contentful/5TWiyyym-tir004gmryakjhzats0n.webp',
          details: {
            size: 87038,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'TiR004gmRyakJHZaTS0n',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile reviews data import statistics from 2020',
    summary:
      '2020 has been memorable...we’ll leave it at that. Here at Flatifle 2020 was a busy year marked by significant growth. Our customer base continues to expand across industries and geographies as more companies recognize the value of improving the data onboarding experience. As we build and look forward to 2021 ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '2020 has been memorable...we’ll leave it at that. Here at Flatifle 2020 was a busy year marked by significant growth. Our customer base continues to expand across industries and geographies as more companies recognize the value of improving the data onboarding experience. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As we build and look forward to 2021 (Hallelujah!) we took a collective glance back at the sheer volume of data imports from our customers. Below we pulled out a few key highlights of what we found.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1MysErCTouXjfLj1mo0kcA',
                type: 'Asset',
                createdAt: '2021-08-13T21:30:18.584Z',
                updatedAt: '2021-08-13T21:30:18.584Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile 2020 year in review graphic',
                description: 'Flatfile 2020 year in review graphic',
                file: {
                  url: '/img/contentful/1MysErCT-kr00znkoqqwsjwghwrao.webp',
                  details: {
                    size: 237930,
                    image: {
                      width: 1200,
                      height: 1470
                    }
                  },
                  fileName: 'KR00zNkoQQWSJWGhWRAo',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ehr0YSOHP4QI8rDOR4Akj',
                type: 'Entry',
                createdAt: '2021-08-13T16:04:09.296Z',
                updatedAt: '2021-08-13T16:04:09.296Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's State of Data Onboarding Report",
                text: 'Learn how companies are tackling the data import challenge',
                ctaText: 'Download now',
                href: '/state-of-data-onboarding-2020/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2zt1G1lUU53A6mWg1jxH97',
    postTitle: '5 Strategies for Winning Customer Success',
    seoTitle: 'Strategies for Improving Customer Success',
    seoUrlSlug: 'providing-long-term-value-to-skeptics-with-mike-egan',
    seoMetaDescription:
      'Mike Egan , VP of CS & Integration at BenchSci discusses how to offer long-term value to skeptical customers in the latest Flatfile podcast',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2021-01-05T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4Us7d7nIg6YxYP6Ev97fxa',
        type: 'Asset',
        createdAt: '2021-08-13T18:13:14.739Z',
        updatedAt: '2021-08-13T18:13:14.739Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Mike Egan, VP of Customer Success at BenchSci',
        description: 'Mike Egan, VP of Customer Success at BenchSci',
        file: {
          url: '/img/contentful/4Us7d7nI-xstpsgixqf2vdc7uvmfr.webp',
          details: {
            size: 73486,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'xSTPsgIXQF2vdC7uvmFR',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Mike Egan, VP of Customer Success at BenchSci',
    summary:
      'Do you struggle with providing long-term value for skeptical customers? Mike Egan , VP of CS & Integration at BenchSci , suggests driving every single conversation and customer interaction with the outcomes most important to the individual. In this episode of Customer Success Leader, Mike offers even more tips for ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Do you consider yourself a people-person?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If you enjoy building relationships and championing projects toward their greatest potential, you may enjoy a career in Customer Success.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Or perhaps you find yourself struggling to drive customer engagement and promote long-term value for your business?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Customer Success Leader',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ', Eric Crane joined Mike Egan, VP of Customer Success & Integration at',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: ' BenchSci',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.benchsci.com/'
              }
            },
            {
              nodeType: 'text',
              value: ' to discuss:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'how to effectively drive conversations and customer interaction',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'how to demonstrate value to skeptical customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'how to succeed in Customer Success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mike works with some of the world’s leading scientists to bring medicines to market. His unique customer base is known for having a healthy dose of skepticism. But, as a leader in Customer Success, Mike has some tried and true techniques for establishing value and developing effective customer relationships. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Here are 5 of his strategies for winning customer success.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: '1.  Leverage Skepticism',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Skeptical customers create a valuable opportunity to reestablish the value of your business. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mike focuses on the “show me, don’t tell me” approach. Instead of trying to convince skeptical customers, Mike demonstrates the value of their platform as it relates to the customer’s goal. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In BenchSci’s case, the customers are world-class scientists, and the goal is running successful experiments. Mike takes the initiative and the time to understand what his customers do and what would help make it easier. The value is placed not on the platform itself, but what the platform can do for the customers.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: '2.  Drive Value',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mike drives strategic interactions that show customers the value at every level. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s crucial to engage customers on a regular basis and ensure that conversations are driven by value. Mike prioritizes building trust by offering 360-degree visibility and consistent communication. He encourages Customer Success leaders to share not only the wins with their customers, but also the losses. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When it comes to fostering long-term customer relationships, transparency is key. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mike is also intentional about sharing BenchSci’s vision for the future. You can’t cultivate a long-lasting relationship with your customer if your business lacks long-term goals. BenchSci’s biomedical A.I. decodes data from over 10 million biomedical publications, increasing speed and efficiency. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But, in addition to providing immediate value for customers, Mike points out that BenchSci’s mission is to bring medicine to patients 50% faster by 2025.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: ' 3.  Refine Tools',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mike is constantly evaluating BenchSci’s customer service process to ensure that the tools they use are producing the highest impact and value for the customer. Although, Mike cautions, it’s easy to get caught up with adopting new tools and platforms too frequently.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '<"If you\'re spinning your wheels on things that are ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'not of the highest impact and the highest value',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ", then that's a lot of ",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'time wasted',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '." – Mike Egan>',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Mike recommends collecting feedback from other teams and checking for simple inefficiencies that need to be ironed out, like lack of communication between departments, before switching to a new tool or platform. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Sometimes it’s not the tool that is the issue, just the execution. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But it all goes back to the overall goal of showing value. If a tool or platform is not conducive to achieving the customer’s desired outcome in the most efficient and effective way, try something else.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: ' 4.  Celebrate Wins',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Celebrate success with your customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This keeps the relationship growing and encourages an environment that welcomes qualitative feedback. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'But don’t neglect your team. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Sharing customer wins internally is often overlooked; so, at BenchSci, Mike builds time into their QVR’s to share wins with the team, so they know that all the hard work they have been putting in is having the intended impact.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: '5.  Cultivate Knowledge',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Honing skills and best practices in Customer Success is an ongoing effort. Luckily, there’s a wealth of learning opportunities at your fingertips. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'One of Mike’s go-to reads is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'Farm, Don’t Hunt: The Definitive Guide to Customer Success, ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'by Guy Nirpaz. Mike has also noticed a growing Customer Success community online, with tons of valuable content to digest from blogs to forums to podcasts like this one. He also suggests connecting with industry coaches and mentors in networking environments like LinkedIn.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Natural relationship builders and creative thinkers are well-suited to thrive in Customer Success; but, by implementing these 5 strategies, anyone can successfully provide value to even the most skeptical of customers.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode of Customer Success Leader, Mike offers even more tips for winning over skeptical customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1j6Za1sJxBXsbrLNa8NDFZ',
                type: 'Entry',
                createdAt: '2021-08-13T15:51:04.910Z',
                updatedAt: '2021-08-13T15:51:04.910Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Providing Value to Skeptical Customers w/ Mike Egan',
                sounderLink: 'https://embed.sounder.fm/play/104553',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/providing-value-to-skeptical-customers-w-mike-egan/id1528594709?i=1000503777110',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MGY0NTU0NTUtZmU5My00NTU1LWE1ODgtYzA2YjBmZGZlM2E2?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/providing-value-to-skeptical-customers-w-mike-egan-80465053',
                spotifyLink:
                  'https://open.spotify.com/episode/008Z5qxD7PapQZMJ716hGG?si=0SjDc9HHRV6ZcglGLnqjOw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3tryAt11vGNh3JO1TqCUd6',
                type: 'Asset',
                createdAt: '2021-08-13T18:17:00.760Z',
                updatedAt: '2021-08-13T18:17:00.760Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Mike Egan',
                description: 'Podcast quote from Mike Egan',
                file: {
                  url: '/img/contentful/3tryAt11-mjzig8jura2rdsx8rtfq.webp',
                  details: {
                    size: 44675,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'mjZig8jURa2rDSX8RtFq',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ehr0YSOHP4QI8rDOR4Akj',
                type: 'Entry',
                createdAt: '2021-08-13T16:04:09.296Z',
                updatedAt: '2021-08-13T16:04:09.296Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's State of Data Onboarding Report",
                text: 'Learn how companies are tackling the data import challenge',
                ctaText: 'Download now',
                href: '/state-of-data-onboarding-2020/'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '7C4sEQHZ33Wo14VfGF5ZrW',
    postTitle:
      '25+ Onboarding Statistics for User, Customer, and Data Onboarding',
    seoTitle: '25+ Customer Onboarding Statistics to Know in 2021',
    seoUrlSlug: 'onboarding-statistics',
    seoMetaDescription:
      'User onboarding and data onboarding are all necessary across B2B software. Check out these critical onboarding statistics.',
    category: 'Data Onboarding',
    tags: ['State of Data Onboarding'],
    publishDate: '2021-01-05T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '140NGJhVIP0pKcp75aJJ5f',
        type: 'Asset',
        createdAt: '2021-08-24T19:26:42.872Z',
        updatedAt: '2021-08-24T19:26:42.872Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'customer onboarding statistics',
        description: 'customer onboarding statistics',
        file: {
          url: '/img/contentful/140NGJhV-86lbjibyret8ihwitqwn.webp',
          details: {
            size: 2108556,
            image: {
              width: 1921,
              height: 1081
            }
          },
          fileName: '86LbJibYReT8IhwitQWn',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'customer onboarding statistics',
    summary:
      'Across B2B software, onboarding statistics can cover a variety of topics, including user onboarding, data onboarding, and employee onboarding. Below we’ve rounded up the best statistics from studies conducted over the past few years, and we’ve also added in our own statistics from a recent survey which we compiled into ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Across B2B software, onboarding statistics can cover a variety of areas, including user onboarding and data onboarding. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Below we’ve rounded up the best statistics from studies conducted over the past few years, and we’ve also added in our own statistics from a recent survey which we compiled into a report entitled the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/state-of-data-onboarding-2020/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '2020 State of Data Onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. The report addresses the challenges with importing data into software systems. Since most tools are useless without customer data, successful user onboarding hinges on smooth and easy ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Keep reading for the top onboarding stats from the following categories.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Table of contents:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'User onboarding statistics',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data onboarding statistics',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Retention and churn statistics',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'User onboarding statistics',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'User onboarding is the process of getting a new software user up to speed, learning how to use the software and reaching the “aha” moment—when they achieve value from the product. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Great user onboarding increases retention and reduces churn, thus contributing to revenue gains for your organization.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'User onboarding matters (a lot)',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'It costs between 5 and 25 times more to acquire a new customer than to retain an existing one (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.invespcro.com/blog/customer-acquisition-retention/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Invesp',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '68% of customers are willing to pay more for the same thing to work with a company with a good reputation for customer service (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://cdn2.hubspot.net/hubfs/2771217/Content/2018%20Customer%20Service%20Expectations%20Gladly.pdf?__hstc=20629287.e2138b8edfeb02e2a4516aff564b1992.1602015774943.1606951022776.1607469232015.11&__hssc=20629287.1.1607469232015&__hsfp=4203475666'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Gladly',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Customers use help desk articles and knowledge libraries more than any other channel for self-service assistance (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.forrester.com/report/2018+Customer+Service+Trends+How+Operations+Become+Faster+Cheaper+And+Yet+More+Human/-/E-RES142291'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Forrester',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "74% of people will revisit your website if it's user-friendly, but 50% of customers will stop visiting your website if it isn’t (",
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.thinkwithgoogle.com/advertising-channels/mobile-marketing/what-users-want-most-from-mobile-sites-today/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Think With Google',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '90% of customers think that companies could “do better” when it comes to user onboarding (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.wyzowl.com/customer-onboarding-statistics'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Wyzowl',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Highly engaged customers buy 90% more often, spend 60% more per each transaction, and offer 3X the amount of annual revenue compared to unengaged customers (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.groovehq.com/customer-service-statistics'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'GrooveHQ',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Video is a top channel for user onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '97% of customers say that video is an effective channel for welcoming and educating new customers (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.wyzowl.com/customer-onboarding-statistics'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Wyzowl',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '87% of the time, B2B viewers watch videos on their desktop, so don’t be afraid to create detailed videos (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.vidyard.com/business-video-benchmarks/?sfc=7014O000001ibH4&utm_source=convince-and-convert&utm_medium=partner&utm_content=report&utm_campaign=benchmark2019'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Vidyard',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Webinars are the preferred format for video content, with 56% of business audiences choosing this format over shorter videos. Luckily, webinars make for great onboarding material (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.convinceandconvert.com/content-marketing/video-marketing-statistics/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Vidyard',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '74% of users have watched a video to understand how to better use a software or mobile app (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.wyzowl.com/customer-onboarding-statistics'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Wyzowl',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '69% of users say that more video should be utilized to improve software product onboarding (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.wyzowl.com/customer-onboarding-statistics'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Wyzowl',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The human brain is hardwired to remember information from video, with 95% of information retained from video and only 10% of information retained from written content (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.topyx.com/lms-blog/video-based-training-for-onboarding-programs'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Topyx',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data onboarding statistics',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/improving-customer-data-onboarding-flatfile-concierge/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Customer data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is essential in order for new customers to use a software application effectively. After all, how can you use an inventory management system to manage your inventory without first importing your inventory data?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In this section, we explore both the importance and the challenges of data importing. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Some tools require more frequent data onboarding than others. For example, marketing and CRM software tools need to import their customer's customer data in order work properly. Below are statistics from Flatfile's State of Data Onboarding report. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data imports happen frequently',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '54% of survey respondents import data every single day.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '22% of respondents import data multiple times per day.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data imports as part of the overall onboarding process can be problematic and time consuming',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '23% of respondents report that it takes weeks or months to import data.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '96% of survey respondents have run into problems when importing data into a software application.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '27% of respondents import data manually into software tools and 38% use a combination of manual methods and internally build data importer.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Data formatting and data validation are the most commonly experienced issues with data onboarding, with 76% and 69% of respondents having experienced them, respectively.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '36% of software users want to solve data importing problems with better integrations, while 29% of software users wish that data import tools were easier to use, and 26% say that more automation is the solution to data import problems.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ehr0YSOHP4QI8rDOR4Akj',
                type: 'Entry',
                createdAt: '2021-08-13T16:04:09.296Z',
                updatedAt: '2021-08-13T16:04:09.296Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's State of Data Onboarding Report",
                text: 'Learn how companies are tackling the data import challenge',
                ctaText: 'Download now',
                href: '/state-of-data-onboarding-2020/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Retention and churn statistics',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Retention and churn are affected by user onboarding and data onboarding. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If you need to communicate that connection to your team, use these retention and churn statistics to help garner support for your retention-boosting efforts.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Churn is an ongoing battle',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Customers switching to a competitor costs US companies a combined $1.6 trillion per year (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.forbes.com/sites/blakemorgan/2019/09/24/50-stats-that-prove-the-value-of-customer-experience/?sh=464e45534ef2'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Forbes',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '66% of consumers have ended their relationship with a company due to bad customer service (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.gravysolutions.io/post/customer-churn-and-retention-top-25-stats-you-need-to-know'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Gravy',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'After just one bad experience, 33% of US consumers will consider switching to another company (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.getfeedback.com/resources/cx/40-stats-churn-customer-satisfaction/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'GetFeedback',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Customer churn can be reduced by 67% if companies are able to solve customer issues during the first customer support interaction (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.gravysolutions.io/post/customer-churn-and-retention-top-25-stats-you-need-to-know'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Gravy',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Customer retention deserves more investment',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Loyal customers are five times more likely to purchase again from the same company and four times more likely to refer a friend to the company (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.forbes.com/sites/blakemorgan/2019/09/24/50-stats-that-prove-the-value-of-customer-experience/?sh=464e45534ef2'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Forbes',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'For SaaS companies, an 8-week retention rate of 35% or higher is a smart goal, however for most SaaS companies their 8-week retention rate is between 6-20% (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://mixpanel.com/topics/whats-a-good-retention-rate/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Mixpanel',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Satisfied customers are 87% more likely to purchase upgrades and additional services than unsatisfied customers (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.mycustomer.com/community/blogs/matt-moody/the-25-ultimate-customer-retention-stats-for-2020'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'MyCustomer',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'When you increase customer retention by just 5%, you can boost profits anywhere from 25-95% (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.smallbizgenius.net/by-the-numbers/customer-loyalty-statistics/#gref'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'SmallBizGenius',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        '82% of companies report that retention is cheaper than acquisition (',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.smallbizgenius.net/by-the-numbers/customer-loyalty-statistics/#gref'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'SmallBizGenius',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ').',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Onboarding statistics can help you understand and communicate the importance of an amazing onboarding experience. Onboarding is more than a first impression, it’s the foundation of a great relationship, whether that’s between your company and your employees, or your company and your customers. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ehr0YSOHP4QI8rDOR4Akj',
                type: 'Entry',
                createdAt: '2021-08-13T16:04:09.296Z',
                updatedAt: '2021-08-13T16:04:09.296Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's State of Data Onboarding Report",
                text: 'Learn how companies are tackling the data import challenge',
                ctaText: 'Download now',
                href: '/state-of-data-onboarding-2020/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5v8p3DgWw9oI74dbcvqygH',
    postTitle: 'How the Best CEOs Drive Customer-Centricity',
    seoTitle: 'How the Best CEOs Drive Customer-Centricity',
    seoUrlSlug: 'ceos-drive-customer-centricity-arjun-devgan',
    seoMetaDescription:
      'Being customer-centric is not solely the job of the Customer Success team. Tune in to hear more from the VP of Success at Amplitude.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-12-21T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6kST1GiFhmRB8Pt3iU2KIH',
        type: 'Asset',
        createdAt: '2021-08-13T18:10:30.864Z',
        updatedAt: '2021-08-13T18:10:30.864Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Arjun Devgan joins the Customer Success Podcast',
        description: 'Arjun Devgan joins the Customer Success Podcast',
        file: {
          url: '/img/contentful/6kST1GiF-ozjotkkutj6frikvlghy.webp',
          details: {
            size: 64483,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'oZJOtkKUTJ6frikvlGHY',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Arjun Devgan joins the Customer Success Podcast',
    summary:
      'Who owns the customer experience? Most would say the Customer Success team. But, in order to be truly customer-centric, it should be the entire company starting with the CEO. In this episode of Customer Success Leader, we sit down with the VP of CS at Amplitude , Arjun Devgan . ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Who owns the customer experience? Most would say the CS team. But, in order to be truly customer-centric, it should be the entire company  — starting with the CEO.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode of Customer Success Leader, Eric sits down with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Arjun Devgan',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/arjundevgan/'
              }
            },
            {
              nodeType: 'text',
              value: ', the VP of CS at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Amplitude',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://amplitude.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' who explains how customer success is a service function with a sales outcome and how he’s brought those two disciplines that are equally important together into one.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Naturally, Arjun’s passion for people and problem solving led him to customer success and eventually got him to where he is now. He lets us in on his journey and what he’s learned along the way.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Proving your value to the customer year after year',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Breaking CS into success, services, and support',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why the CEO needs to empower the organization to be customer-centric',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The importance of having a top-level metric',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Prove Your Value ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In customer success, you’re continuously aiming to generate value. And in software, you have to reprove your value every single year. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'It can be easy to get disrupted.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '"',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Disruption happens fairly quickly',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' these days... You can get disrupted providing a point solution product ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'no matter how great your product is',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '." — Arjun Devgan',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To earn the customers business every single year you have to continue to: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reprove value',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Document value ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Get acknowledgement of value (and do so in a cost-effective way.)',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'It Starts at the Top',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "As a CS leader, you want to provide customers a service that is on a critical path to making them successful. As you scale, it's important to separate that path out while understanding the importance of cross functional relationships within a company.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'One of Amplitude’s clear visions for 2021 is making a clear distinction between where all functions of the company intersect. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'No one department should be alienated in the process of customer success. The CSD might take the lead on the strategy, but each department has an important role to play.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Arjun says',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' the best CEOs empower the head of customer success to partner with all of the other departments within the company in order to create a unified experience for the customer.',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s not easy to do, but it’s vital for the company as a whole.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The CEO should be very customer centric and empower every department to think about the company’s customers first.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Arjun’s Best CS Advice ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Always have a charter',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' to make sure your CEO and CFO are in alignment when buying into the company’s top level metrics.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The top-level metric will vary year by year and from company to company, but knowing the top-level metric and the direct benefit customer success is having will provide a clear-cut path, instead of your CS team being bogged down with trying to reach seven different goals at once. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This will help your CS team avoid the identity crisis of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                "I'm responsible for everything but accountable for nothing. ",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Which can make the job more difficult than necessary. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Pick a top-level metric to hyper-focus on, measure it, and improve it. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '"Ultimately, ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'every single point in the customer experience',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' and the outcomes you deliver to that customer ends up defining ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'how long they stay with you',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '." — Arjun Devgan',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Who owns the customer experience? Most would say the Customer Success team. But, in order to be truly customer-centric, it should be the entire company starting with the CEO.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode of Customer Success Leader, we discuss:  ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to prove your value to the customer year after year',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why Arjun breaks CS into success, services, and support',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why the CEO needs to empower the organization to be customer-centric',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The importance of having a top-level metric',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3VlJTqOynq0YzKCEWebne9',
                type: 'Entry',
                createdAt: '2021-08-13T15:50:05.898Z',
                updatedAt: '2021-08-13T15:50:05.898Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'How the Best CEOs Drive Customer-Centricity w/ Arjun Devgan',
                sounderLink: 'https://embed.sounder.fm/play/103267',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-the-best-ceos-drive-customer-centricity-w-arjun-devgan/id1528594709?i=1000503186422',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MWYxODFhZTQtN2FlNC00Yjk5LWE4OTEtMjlkNGFkMGQ3NTQx?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-the-best-ceos-drive-customer-centricity-w-arjun-devgan-80333424',
                spotifyLink:
                  'https://open.spotify.com/episode/5yfvAzfsxHQAMkZ4GnbX6U?si=D9g-HCTFQOiosbMxvExsaQ&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3nwFd45Kr5WK1vQyR3Iu3M',
                type: 'Asset',
                createdAt: '2021-08-13T18:11:52.898Z',
                updatedAt: '2021-08-13T18:11:52.898Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Arjun Devgan',
                description: 'Podcast quote from Arjun Devgan',
                file: {
                  url: '/img/contentful/3nwFd45K-5urhatiyqvoymawo3exx.webp',
                  details: {
                    size: 33330,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: '5urHATIyQvOymAwO3EXx',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '3wZZpXkSab3zrflQ5l0WPE',
    postTitle:
      'Why the Best Customer Success Managers Have Transferable Skills',
    seoTitle: 'Transferable Skills Help Customer Success Managers',
    seoUrlSlug: 'transferable-skills-with-graham-gill',
    seoMetaDescription:
      "Customer Success Managers don't need traditional CSM training. Learn about transferrable skills in this Customer Success Leader podcast.",
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-12-15T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'G5PnpnKzZKxxhB608fmZe',
        type: 'Asset',
        createdAt: '2021-08-13T18:07:43.829Z',
        updatedAt: '2021-08-13T18:07:43.829Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Graham Gill joins the Customer Success Leader podcast',
        description: 'Graham Gill joins the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/G5PnpnKz-ujw6b5kkq3yn3t6uzckp.webp',
          details: {
            size: 156967,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'uJW6B5KKQ3yn3t6uZCkp',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText:
      'Graham Gill joins the Customer Success Leader podcast',
    summary:
      'Not all great Customer Success Managers have traditional Customer Success training. Some — like Graham Gill — transfer their skills from roles like product management to CS. Graham, the VP of CS & Services at Accent Technologies , shares how he found his way to customer success and brought his ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Not all great customer service managers have traditional CS training. Some — like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Graham Gill',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/gngill/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' — transfer their skills from roles like product management to CS.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Graham Gill, the VP of CS & Services at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Accent Technologies',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://accent-technologies.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', shares how he found his way to customer success and brought his knowledge of product with him. His perspective coming from the product side of operations helped him become a better CSM. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this podcast, Eric and Graham discuss the similarities in their customer success journeys as well as...',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to break down silos and build a foundation of alignment',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why it’s important for CSMs to be able to empathize ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How CSMs can create strong customer relationships in a pandemic',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Breaking Down the Silos ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'At the heart of any small team, you have a dedicated group of really smart folks who often end up wearing many hats. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But how do you get customers successfully engaged while providing a true separation of church and state between sales, implementation support, and building and cultivating customer relationships? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'And what’s the best way to figure out where people perform best? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Focus on your people and what makes them excited about their work',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Understand teammate’s and client’s communication styles',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: "Understand what's working and what isn’t",
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Find out what gaps need filling ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Graham leans in by speaking directly with his teammates in an interview style approach.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Graham says: “We started a slice and dice, almost an interview, that was hands on understanding where folks felt comfortable and then figuring out where the gaps were. It's a gap assessment. Do we have all the right players and all the right skill sets to fill these different areas within the organization?”",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Getting Some Perspective ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Customer success is a give and take. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It boils down to empathy and really seeing the value of multiple perspectives. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Coming from the product side of things and being able to transfer his knowledge of how products and services are being utilized by customers gave Graham a big advantage when it came to making his way into a CSM role.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Understanding all sides from the product perspective to the end user perspective and all the ups and downs in between is a big part of the CSM journey. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                ' "Just being able to be honest, truthful, and transparent and help folks, really gave me  understanding." — Graham',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Building empathy with customers, recognizing their needs, and knowing how they’re using your products and services is how successful relationships are formed. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s also important to journey through the various parts of the business operation.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "“I think sitting on all sides, doing a tour of duty on all sides of the organization, whether it's QA, whether it's marketing, whether it's product, whether it's, you know, account management, customer success, I think makes you a stronger person further on down the line.”  — Graham",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Understanding all of those different facets and being able to design your organization the most effective way, ultimately leads to better service to the customer.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Graham’s Best Advice',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The Covid-19 pandemic faced us with challenges in communication and made us look at new ways to establish relationships with customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Graham’s best piece of advice he offers to new and upcoming CSM’s: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Be honest, and start talking.',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "“A lot of folks hide behind emails or automation components of it. Just be honest, be transparent and build rapport. You're not going to do that through email alone.” — Graham",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "CSMs must be able to have honest conversations with customers because at the end of the day, you’ve got to get to know people. Ultimately, that's what drives businesses forward.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode, Graham discusses how he found his way to customer success and brought his product background and knowledge with him. Additionally we discuss… ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to break down silos and build a foundation of alignment',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why it’s important for CSMs to empathize with other roles',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How CSMs can create strong customer relationships in a global pandemic',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4uWbLtVqmpQ7iCdz0hmaHC',
                type: 'Entry',
                createdAt: '2021-08-13T15:49:08.301Z',
                updatedAt: '2021-08-13T15:49:08.301Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Why the Best CSMs Have Transferable Skills w/ Graham Gill',
                sounderLink: 'https://embed.sounder.fm/play/102356',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/why-the-best-csms-have-transferable-skills-w-graham-gill/id1528594709?i=1000502467637',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MmRjMDM5ODctZmMxYS00OGUwLTk5MzctMjk0ZGEyYzg0OTA1?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/why-the-best-csms-have-transferable-skills-w-graham-gill-80168128',
                spotifyLink:
                  'https://open.spotify.com/episode/2W7e8q4UOVfMqGUlYMzX4e?si=hVkwjW5rTV6xy9rWzLalxw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3yX9Qkn6GMPSenePoC1A5w',
                type: 'Asset',
                createdAt: '2021-08-13T18:09:12.625Z',
                updatedAt: '2021-08-13T18:09:12.625Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Graham Gill',
                description: 'Podcast quote from Graham Gill',
                file: {
                  url: '/img/contentful/3yX9Qkn6-mhobjbl7q8sr9icfn9wc.webp',
                  details: {
                    size: 154215,
                    image: {
                      width: 961,
                      height: 540
                    }
                  },
                  fileName: 'MHobJBL7Q8SR9ICfn9wc',
                  contentType: 'image/jpeg'
                }
              }
            }
          }
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: 'Ky0ZQJsTCll88EjIASsNv',
    postTitle:
      'WayCool Software enables 90% of customers to import their own data with Flatfile’s data importer',
    seoTitle: 'WayCool Software Helps Customers Import Data with Flatfile',
    seoUrlSlug:
      'waycool-software-enables-90-percent-of-customers-to-import-their-own-data-with-flatfiles-data-import',
    seoMetaDescription:
      "WayCool Software enables 90 percent of customers to import their own data using Flatfile's data importer. Read the case study to learn more.",
    category: 'Customer stories',
    tags: ['Case study', 'CRM', 'Customer stories'],
    publishDate: '2020-12-10T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7nnYo9zz73ZXH1vHnKtFdV',
        type: 'Asset',
        createdAt: '2021-08-11T22:41:28.116Z',
        updatedAt: '2021-08-11T22:41:28.116Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'WayCool Software uses the Flatfile data importer',
        description: 'WayCool Software uses the Flatfile data importer',
        file: {
          url: '/img/contentful/7nnYo9zz-eujzfud5sr66myeyz8zl.webp',
          details: {
            size: 89877,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'EUjzFUD5Sr66myEyz8ZL',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'WayCool Software uses the Flatfile data importer',
    summary:
      'Non-profit organizations focus most of their time on soliciting donations so they can continue to serve the particular constituency that relies on them. Managing donors, clients, and volunteers can be a time-consuming effort that can take time and resources away from their core mission. Enter WayCool Software , an Alabama-based ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Non-profit organizations focus most of their time on soliciting donations so they can continue to serve the particular constituency that relies on them. Managing donors, clients, and volunteers can be a time-consuming effort that can take time and resources away from their core mission.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Enter ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.waycoolsw.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'WayCool Software',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', an Alabama-based company that provides a comprehensive platform to simplify non-profit management in an easy-to-use solution. WayCool’s customers are all in the nonprofit industry, primarily focused on subsets of ministries such as churches, food banks, and homeless shelters. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Keeping track of all the moving parts in these organizations can be cumbersome, but WayCool Software makes it easy by integrating with QuickBooks, Excel, eGiving Systems, Zapier, and others. WayCool provides full client management tools, built-in reports, scheduling, and donor management to track contact information and pledges, and manage volunteers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We become the central information management hub for these organizations and the integration point for all the products they use to conduct their business,” said Jonathan Marbutt, Vice President of Software Development at WayCool. “As a provider in a niche market, we offer our customers the same benefits and insights they would get from a large CRM product like Salesforce, but in a way that is specialized for them. What sets us apart is how much we partner with them and provide hands on support.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Solving the data import bottleneck',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As WayCool continued to grow its business, they began to face a data import bottleneck during the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' process. Manually importing data was a complex, time-consuming process that was draining their internal resources.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The majority of our new customers use Excel, Access, and in some cases home-grown databases,” said Marbutt. “This created a heavily manual data importing process. We actually had one of our co-founders tied up 20-30 percent of his time doing nothing but working on data importing and data conversions. With this being a high growth year for us, we needed to find a way to onboard customer data faster and the manual data import process was holding us back. We found our solution with Flatfile.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Implementing the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' data importer into the WayCool process did more than just free up internal resources. It actually shifted the process back to the customer by providing them with a simple, easy-to-use data import solution. Marbutt estimates that 80 to 90 percent of WayCool customers now use Flatfile to do their own data importing. That is critical as the company continues to ramp up new business. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We’ve onboarded 30 new customers with about 50 or more scheduled over the next month,” said Marbutt. “We couldn’t do that at the pace we were going before. Data conversion was the biggest obstacle.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Marbutt estimates it would take months and bringing on additional resources to do the data importing without Flatfile because of the complexity of the customer databases many of these organizations have. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The timing of finding Flatfile couldn’t have been better,” added Marbutt. “We were looking for a better path to streamline the onboarding process and make data conversions easier. Flatfile provided that path. We are recovering the cost of Flatfile many times over.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Flatfile enables rapid prospect to customer conversion',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Marbutt estimates that before Flatfile, data importing would take anywhere from days to weeks and sometimes even a month to upload client files. Now customers are able to import their files to WayCool in a day. Implementing Flatfile enabled WayCool to initiate a 15 day trial where customers can actually get into the product and test it out for themselves.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Now only did Flatfile enable our entire team to handle data importing, but it actually allowed our customers to handle the process for themselves,” said Marbutt. “Using Flatfile allows them to review their files to quickly find issues and helps them learn our product faster because they get to efficiently work with their own data. We would never have been able to offer the 15 day trial before Flatfile since it could potentially take that long just to get the customer files imported.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“With Flatfile customers can get their data into our platform quickly and can immediately begin working with their data,” said Marbutt. “As a result, 80 to 90 percent of prospects who sign up for the trial have converted into customers.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Moving beyond data importing',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Flatfile solved the data import challenge so that we can now focus on customer business problems and meeting their needs beyond data conversion,” said Marbutt. “It allows us to scale our product and concentrate on what we’re really good at and in turn allows our customers to focus on what they are best at.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With their continued growth, WayCool is now using the Flatfile data importer for more complex data importing needs that are being requested by their customers. Flatfile continues to improve the validation and feedback that is crucial to the importing process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Flatfile, WayCool’s customers are now able to import data on their own. For example, if a customer receives a CSV file from their bank or online payment processor with donations for the month, they can simply import them directly into WayCool without WayCool needing to write a custom integration. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We view Flatfile as an extra employee,” Marbutt summed up. “Their support is outstanding. They focus on customer success just as we do with our clients. When we need support, we don’t feel like we’re dealing with some faceless support team. They are outstanding and quick to respond. We know they are there to work with us.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About WayCool Software',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'WayCool provides web-based software for nonprofit organizations providing Donor, Volunteer and Client Management solutions in one comprehensive toolset. The platform includes interfaces to QuickBooks, Word and Excel with special modules for pro-life Pregnancy Centers. The company serves hundreds of organizations across the country and is extremely affordable for small to mid-sized organizations, utilizing state-of-the-art software tools. For more information visit',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.waycoolsw.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' https://www.waycoolsw.com/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '3L9eCxxbiXkrTW09tzX8D0',
    postTitle: 'How to Scale Customized CX',
    seoTitle: 'How to Customize CX at Scale',
    seoUrlSlug: 'customize-cx-at-scale-with-teresa-anania',
    seoMetaDescription:
      'Teresa Anania, VP of Global Customer Success & Renewals at Zendesk, joins the Customer Success Leader podcast to discuss scaling CX.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-12-08T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'CyZ5dJXp3r3BQSMKHkguu',
        type: 'Asset',
        createdAt: '2021-08-13T18:04:49.181Z',
        updatedAt: '2021-08-13T18:04:49.181Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Teresa Anania joins Customer Success Leader podcast',
        description: 'Teresa Anania joins Customer Success Leader podcast',
        file: {
          url: '/img/contentful/CyZ5dJXp-sawvk7ztharuwdjwqoy6.webp',
          details: {
            size: 71328,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'saWVK7zThaRuWdjWQOy6',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Teresa Anania joins Customer Success Leader podcast',
    summary:
      'Being on the receiving end of a customized customer experience is the warm, fuzzy feeling every customer loves. But how do organizations personalize their CX at scale? Can every customer get the warm fuzzies? Teresa Anania , VP of Global Customer Success & Renewals at Zendesk , thinks — to ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Being on the receiving end of a customized customer experience is the warm, fuzzy feeling every customer loves. But how do organizations personalize their CX at scale?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Can every customer get the warm fuzzies?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Teresa Anania',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/teresa-anania/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of Global Customer Success & Renewals at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Zendesk',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.zendesk.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', thinks — to some degree — every customer can have a customized experience. She shares her CX strategy with Eric, as well as… ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Developing an outcome-based approach with high-touch customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Engaging an entirely remote CS team',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Giving us advice for new CS leaders',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Building out a differentiated customer experience for her customers and peers in the business has given Teresa the opportunity to rise to the occasion when it comes to finding outcomes to new challenges, especially within the ever-changing landscape brought upon by the Covid-19 pandemic.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But it wasn’t easy, Teresa was thrown into the fire to quickly learn: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to scale the experience',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to scale an organization ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to drive outcomes ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'And most importantly, how to combine all of the above in a way that sustains a healthy customer success practice',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Developing an Outcome-based approach ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Putting the customer first should be top priority. Listen to their vision of success and tailor their customer journey to that. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If you wait for the customer to renew before knowing the value that your customers are getting out of your solution, you’re too late.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s an exercise of developing the right data and insights to inform the right action and using that to trigger outreach.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "“It’s really building out this personalized experience, where we're blending both digital and human.” — Teresa Anania",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Ask the important questions:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Where is the customer? ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What inspired them to buy your solutions? ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What are the goals they want to have? ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Engaging a Remote CS Team ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Right now, customer success is arguably more challenging than it’s ever been. While the pandemic has made things more difficult, it’s also brought the importance of customer success to the spotlight. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Teresa says her goal is that despite all of these new challenges, that her people still love what they do. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'This is achieved by',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Caring for team members by making sure they have what they need',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ensure a good work-life balance & take breaks ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Investing in enablement ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Getting team members excited and feeling empowered in their roles ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Advice for New CS Leaders ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'How can we ensure new leaders take on the right traits to inspire their teams?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Teresa uses an approach called ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'dynamic segmentation. ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'What does this approach do?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Aligns the right person to the right account',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Protects and maintains strong relationships ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Teresa’s 3 pillars of advice for new leaders:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Realize the importance of data, and know it doesn’t have to be perfect. Use basic information about usage, utilization and the customer experience to inform how to build out engagement models.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Care for your people: create an experience in which they love what they do.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Measure, measure, measure: both human and digital engagements.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Creating collaborative, secure workspaces with your customers and their data saves you time while providing a memorable experience. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this podcast Teresa shares her CX strategy with us, as well as',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to develop an outcome-based approach with high-touch customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to engage an entirely remote CS team',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Advice for new CS leaders',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4pi3GY7T2VY3uu1LqlSobJ',
                type: 'Entry',
                createdAt: '2021-08-13T15:48:12.227Z',
                updatedAt: '2021-08-13T15:48:12.227Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'How to Scale Customized CX w/ Teresa Anania',
                sounderLink: 'https://embed.sounder.fm/play/102357',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-to-scale-customized-cx-w-teresa-anania/id1528594709?i=1000501703084',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/ZWFlZjIwNjgtZWQxMC00NTFmLTk1NTctM2NiNDY4ZTc4ZjNl?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-to-scale-customized-cx-w-teresa-anania-79985964',
                spotifyLink:
                  'https://open.spotify.com/episode/2PkyePGbpnDcI7aUqz28N3?si=_o3Nvr2RRZeVlD5fnYHorQ&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2FznrnbKWpQbuunBCeygAD',
                type: 'Asset',
                createdAt: '2021-08-13T18:06:08.796Z',
                updatedAt: '2021-08-13T18:06:08.796Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Teresa Anania',
                description: 'Podcast quote from Teresa Anania',
                file: {
                  url: '/img/contentful/2FznrnbK-byzmellaszk3iwa7gqrw.webp',
                  details: {
                    size: 52975,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'bYzmElLaSzK3iwA7gQrw',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '46jQFtWUShgE5RwSpq788r',
    postTitle: 'Flatfile unveils State of Data Onboarding report',
    seoTitle: 'State of Data Onboarding report released by Flatfile',
    seoUrlSlug: 'flatfile-unveils-state-of-data-onboarding-report',
    seoMetaDescription:
      'Flatfile unveils the first ever State of Data Onboarding survey and report to address customer data onboarding challenges.',
    category: 'Data exchange',
    tags: ['State of data onboarding'],
    publishDate: '2020-12-03T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3xKvPSzllc6Rlz51ELpjIH',
        type: 'Asset',
        createdAt: '2021-08-13T21:36:01.697Z',
        updatedAt: '2022-05-27T14:50:59.945Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile releases 2020 State of Data Onboarding report',
        description: 'Flatfile releases 2020 State of Data Onboarding report',
        file: {
          url: '/img/contentful/3xKvPSzl-sodo_blog_post.webp',
          details: {
            size: 191266,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'Sodo Blog Post.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Flatfile releases 2020 State of Data Onboarding report',
    summary:
      'Remember life pre-Uber? Hailing a cab was unpredictable and unreliable. Or what about pre-Amazon? If you needed something shipped last minute, you were out of luck. Could you live life without a predictable ride to the airport? Sure. Could you wait an extra couple of weeks to have something delivered? ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Remember life pre-Uber? Hailing a cab was unpredictable and unreliable. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Or what about pre-Amazon? If you needed something shipped last minute, you were out of luck. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Could you live life without a predictable ride to the airport? Sure. Could you wait an extra couple of weeks to have something delivered? Of course. But you don’t, because there’s a better way. Now, think about the ways in which you import customer data? Is it quick? Error-free? If not, keep reading. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [
                {
                  type: 'underline'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Data onboarding',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is the act of moving data into a software tool. Sounds easy enough, right? Wrong. The process to do this today is time-consuming, tedious, and generally not very innovative. This is the current reality despite the fact that companies with data (so, everyone) need to onboard data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In an effort to dive deeper and learn more about how companies today are addressing data onboarding, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' launched the first ever data onboarding survey and subsequent report “The State of Data Onboarding” which you can ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/state-of-data-onboarding-2020/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'read here',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '. We surveyed more than 100 companies and gathered additional data from more than 5,000 respondents via Twitter. Our goal was simply to learn more about data onboarding. For example:  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How often do companies onboard customer data? ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What kinds of data do companies onboard? ',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What specific challenges do companies face during the onboarding process?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Below are a few key highlights from the report: ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7edpeEhmoSeEhjH9WOx7fc',
                type: 'Asset',
                createdAt: '2021-08-13T21:33:10.569Z',
                updatedAt: '2021-08-13T21:33:10.569Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: '54% of respondents are importing data daily',
                description: '54% of respondents are importing data daily',
                file: {
                  url: '/img/contentful/7edpeEhm-ovmabcxjrta7bopxkng7.webp',
                  details: {
                    size: 18155,
                    image: {
                      width: 1345,
                      height: 625
                    }
                  },
                  fileName: 'oVMABCXJRta7BOPXKNg7',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Regardless of the type of data, importing data into software tools is something that happens often for businesses of all shapes and sizes and across various industries. More than half of the survey respondents are importing data every single day and 22% reported they are importing data multiple times a day.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6Z1Z4A2PASd3YBfs8EjipV',
                type: 'Asset',
                createdAt: '2021-08-13T21:34:05.027Z',
                updatedAt: '2021-08-13T21:34:05.027Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title:
                  '23% of respondents reported that it takes weeks or months to import customer data',
                description:
                  '23% of respondents reported that it takes weeks or months to import customer data',
                file: {
                  url: '/img/contentful/6Z1Z4A2P-3wqlymi1qoitxaxoctua.webp',
                  details: {
                    size: 17594,
                    image: {
                      width: 1345,
                      height: 625
                    }
                  },
                  fileName: '3WqlymI1QOiTxAXOctuA',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For nearly a quarter of the respondents surveyed, importing data isn’t exactly a speedy process. It currently ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'takes companies a long time to onboard data',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', despite the fact that  many of these companies most likely need to import data frequently. Going back to that Amazon example above - a few years ago we were accustomed to waiting quite awhile for our packages to arrive. We’ve solved that pain point. Why is it taking companies ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'months',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' to onboard data?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7MMCPFyxChDej5qfxzpQBX',
                type: 'Asset',
                createdAt: '2021-08-13T21:34:42.334Z',
                updatedAt: '2021-08-13T21:34:42.334Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title:
                  "96% of survey respondents estimate they've run into problems importing data",
                description:
                  "96% of survey respondents estimate they've run into problems importing data",
                file: {
                  url: '/img/contentful/7MMCPFyx-lab1p6bmqqwad1nfwirc.webp',
                  details: {
                    size: 20085,
                    image: {
                      width: 1345,
                      height: 625
                    }
                  },
                  fileName: 'laB1P6BMQqWAd1nfwIRc',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Onboarding customer data is a huge challenge for companies and the process is plagued with errors - especially when companies rely on customers to onboard their own data. Turns out, there’s a lot that can go wrong when importing data into applications. Most companies try to ease the data onboarding process by providing users with FAQ documentation and tutorials on how best to use their custom built data importers. Another popular method is to provide customers with templates to attempt to help them upload their data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Despite video tutorials and various step by step instructions, data onboarding leads to a lot of customer frustration. In our study, we asked companies to share the most common data issues they experience when it comes to data onboarding. Data formatting, data validation, and column matching were the most common data issues cited. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In an effort to better understand what companies expect from the data onboarding process, we asked survey participants to tell us in their own words what the ideal customer onboarding experience is…...Want to see what they said? Interested in learning more?',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/state-of-data-onboarding-2020/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: ' Download',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' the first ever State of Data Onboarding report.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: 'Z0S2NVnQb1sMLipOCmtN0',
    postTitle: 'Tips on Creating a Repeatable Onboarding Process',
    seoTitle: 'Tips on Creating a Repeatable Onboarding Process',
    seoUrlSlug: 'repeatable-onboarding-processes-with-lisa-fox',
    seoMetaDescription:
      "In this episode of Flatfile's Customer Success Leader, Monday.com's Lisa Fox discusses repeatable customer onboarding processes.",
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-12-01T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5uYfbWfkocPz821ynw6KOX',
        type: 'Asset',
        createdAt: '2021-08-13T17:55:18.282Z',
        updatedAt: '2021-08-13T17:55:18.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Monday.com leader Lisa Fox on the Flatfile podcast',
        description: 'Monday.com leader Lisa Fox on the Flatfile podcast',
        file: {
          url: '/img/contentful/5uYfbWfk-grq1m43t7wmlfzgwtrdw.webp',
          details: {
            size: 99105,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'Grq1M43T7WMlFzgWTRdw',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Monday.com leader Lisa Fox on the Flatfile podcast',
    summary:
      'When you have as many different types of customers as Monday.com has, there needs to be some consistency in the onboarding process. Monday.com Onboarding Team Manager, Lisa Fox , joins us in this episode to share how her team created a successful, repeatable onboarding process for customers. Plus, we discuss: ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'When you have as many different types of customers as ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Monday.com',
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://monday.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' has, there needs to be some consistency in the onboarding process.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Monday.com Onboarding Team Manager ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Lisa Fox',
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/lisamfox1/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' joins me in this episode to share how her team has created a repeatable onboarding process for customers. Plus, the two of us talk about… ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Obstacles in the onboarding process and how to overcome them',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Three phases for a successful onboarding',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why every CS leader should have authenticity and empathy ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'This blog post is based on a podcast hosted by Eric Crane and features Lisa Fox. To hear this episode and more like it, subscribe to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' on ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Apple Podcasts',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657'
              }
            },
            {
              nodeType: 'text',
              value: ', ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Spotify',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            },
            {
              nodeType: 'text',
              value: ', or wherever you listen to podcasts.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Defining onboarding',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'I usually ask all my guests on the show how they would define customer success, but in this episode I kicked things off a little differently. I asked Lisa how she would define onboarding, and her answer did not disappoint:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Every organization really needs to first define, for themselves, what it means to be ‘on board’ with their particular platform. For her team over at Monday.com that means empowering customers to understand the platform as a means to improving their way of working. Whatever her customers’ existing processes and workflows are, Lisa’s team sets out to help them see how it can be improved through the use of Monday.com.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Obstacles in the onboarding process and how to overcome them',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Here are some of the obstacles Lisa mentions during our conversation, along with corresponding solutions:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Resource allocation and management',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Onboarding is really a collaborative effort between Lisa’s team and their customers. It’s easy to forget that the customer’s designated project managers, who oversee the transition onto Monday.com, are not full-time onboarding or transition specialists in most cases. Those people have other full-time roles that they’re responsible for. There needs to be a designated person, though, and that person needs to have a solid understanding of the existing workflow that’s going to be built on the new platform.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Visibility and insight into onboarding progress',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Of course, small things like features not working when you’re in the middle of a live demonstration can be pretty frustrating, whether you’re watching or presenting. But what about assessing the health of an onboarding process? Lisa mentions that CSMs mostly rely on conversations with team members to gain this insight but it might be that a dashboard becomes available over time, where this information can be obtained at a glance.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Three phases for a successful onboarding',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Successful onboarding, at scale, requires a process of its own. It’s not a complex process, but it’s a formula that works, and it’s one Lisa happily shared during our conversation. What’s great about this is that Lisa’s been part of the migration from what most companies will start off doing: an ad-hoc customer-specific onboarding and customer success approach.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Today, though, she shares that they have an ‘onboarding kit’ that they rely on:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Work toward your customer understanding ‘how to think’ about building or working within your platform.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Improve this initial build process by introducing integration and optimization.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                },
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '\n',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Equip your customer with the right resources that make it easy to roll it out to their team.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Why every CS leader should have authenticity and empathy',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Everything about what a CSM does revolves around the customer. If you’re a CSM, reading this blog or listening to this episode, you already know that people can tell when you’re not being sincere. To lead a customer toward their version of success means that you need skills like empathy, focus, authenticity, flexibility and lateral thinking to immerse yourself in their world.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Their context and their journey basically becomes yours; you’re just living it through your business as a medium. You’ve got access to a specific set of resources and knowledge that’s meant to support your customer in different ways, to keep them on that path to what they define as success. For Lisa, authenticity and empathy are the key elements to help you come across as a real person to your customer, and they enable you to form that human connection that really ignites those ‘aha’ moments.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '"The ability to really',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' connect with someone',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' and a ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'desire to want to help',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' them are ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'crucial ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'aspects to CS work." — Lisa Fox',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In this episode, Lisa shares how her team created a successful, repeatable onboarding process for customers. Plus, we discuss:  ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Obstacles in the onboarding process and how to overcome them',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'The 3 phases for a successful onboarding experience',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why every CS leader should have authenticity and empathy',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5OzlVzlC3xZU33vYGZzg4n',
                type: 'Entry',
                createdAt: '2021-08-13T15:47:11.242Z',
                updatedAt: '2021-08-13T15:47:11.242Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Tips on Creating a Repeatable Onboarding Process w/ Lisa Fox',
                sounderLink: 'https://embed.sounder.fm/play/102358',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/tips-on-creating-a-repeatable-onboarding-process-w-lisa-fox/id1528594709?i=1000500934796',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MWJjNDIxZWUtODRkOS00M2Q0LTk3NjctNzFjMjllMDYzY2Q0?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/tips-on-creating-a-repeatable-onboarding-process-w-lisa-fox-79814138',
                spotifyLink:
                  'https://open.spotify.com/episode/4BAI0ltt6E5HEqEjN8Ymbm?si=8YboSOpQSCW92SK85KGcpw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1LG5ragtjaf0CRZ5so0AXG',
                type: 'Asset',
                createdAt: '2021-08-13T18:03:26.198Z',
                updatedAt: '2021-08-13T18:03:26.198Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Lisa Fox',
                description: 'Podcast quote from Lisa Fox',
                file: {
                  url: '/img/contentful/1LG5ragt-au61spqksjqcwutlntkm.webp',
                  details: {
                    size: 40420,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Au61spqKSjqcWUTlnTkM',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '1B2mgu2nmYsyC3xuT77MmS',
    postTitle: '5 Questions with Javier Matusevich, Staff Engineer at Flatfile',
    seoTitle: 'Software engineer Javier Matusevich joins Flatfile',
    seoUrlSlug: '5-questions-with-javier-matusevich-staff-engineer-at-flatfile',
    seoMetaDescription:
      "Flatfile welcomes software engineer Javier Matusevich to the team. Check out Flatfile's open roles to join the team.",
    category: 'Flatfile News & Culture',
    tags: ['5 questions', 'Employee spotlight', 'Engineers'],
    publishDate: '2020-11-24T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4dCwbAzWFmB3OO2MFjzHe4',
        type: 'Asset',
        createdAt: '2021-08-13T21:45:34.061Z',
        updatedAt: '2021-08-13T21:45:34.061Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Javier Matusevich joins Flatfile as a senior engineer',
        description: 'Javier Matusevich joins Flatfile as a senior engineer',
        file: {
          url: '/img/contentful/4dCwbAzW-pgqha4oir6agokpzpxfh.webp',
          details: {
            size: 640948,
            image: {
              width: 2401,
              height: 1257
            }
          },
          fileName: 'pGqHA4OiR6aGoKPZpXFH',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Javier Matusevich joins Flatfile as a senior engineer',
    summary:
      'Flatfile is thrilled to welcome our newest staff engineer, Javier Matusevich . Javier joins Flatfile’s fast growing engineering team, responsible for building the world’s best data onboarding solution. Let’s dig in and learn more about Javier! Q: Why Flatfile? (And what do you do here?) A: I was looking for ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile is thrilled to welcome our newest staff engineer, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/javier-matusevich-b3b70725/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Javier Matusevich',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Javier joins Flatfile’s fast growing engineering team, responsible for building the world’s best ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' solution. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s dig in and learn more about Javier! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q: Why Flatfile? (And what do you do here?) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A:  I was looking for a challenge and somewhere I could grow my skills. When it came down to it, the people at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' drew me in. I enjoyed all the conversations I was having and there was an emphasis on a people-first culture that I really respected and wanted to be a part of.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As a full stack developer, I have the ability to work on so many different problem domains both in the front and back end so I can jump in and resolve issues whenever and wherever they arise. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q:  What inspired you to become an engineer? What attracted you to the field? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A:  I can’t remember a time when I wasn’t going to be an engineer! Since I was five years old, I’ve been toying around with computers and learning how they could solve problems. I come from a family of software developers yet nobody was pushing me in that direction, so I would say my interest was natural and innate, but it definitely helps if you have the exposure and know that something like software development is a potential career option. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: Talk about a tough technical problem or challenge you’ve had to solve in the past, how did you overcome it? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: One of the toughest challenges being a developer was around juggling multiple clients and projects where the projects and industries weren’t at all related so I was frequently jumping from one request to the next. It required a lot of mental energy to reset my mind and focus quickly. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There were also non-technical people making frequent requests which meant I had to effectively translate the solutions to their problems. For example, there are many tiny technical details that roll up into a larger problem but it’s difficult to see that from the outside looking in. I had to explain that what seemed like a small problem would actually require investing millions of dollars whereas what might be perceived as a huge issue could be fixed in a few days. Over time I learned how to successfully communicate these technical problems to my clients.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You’re Flatfile’s first official international hire! Can you tell us a little bit about the tech scene in Argentina where you’re from?  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A:  There’s definitely a big developer scene here but given some of the unique ways in which the economy works in Argentina, developers are more of a service. Companies are not necessarily creating products and starting technology businesses here yet there is a lot of talent so most of the developers are doing contract work for companies around the world. That’s another reason why I was excited to join Flatfile. With Flatfile, I’m part of a fast growing company and can help build the product as opposed to working on one part of the product for a set amount of time.   ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You’re stranded on a desert island with only one movie, what do you choose? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A:  I’m taking the final cut of Blade Runner. That movie has some of the best music in film. With all the backdrops, the costumes, the sets, you can watch it over and over and still discover a new detail every time. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Want to learn more about Flatfile and join our team? Check out our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/about/#careers'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'open positions',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5jVcou0kx333A1IeWWaMoh',
    postTitle: 'Steps to Managing a Remote Customer Success Team',
    seoTitle: 'Steps to Managing a Remote Customer Success Team',
    seoUrlSlug: 'remote-cs-teams-with-benoit-bouteille',
    seoMetaDescription:
      'This episode of the Customer Success Leader podcast delivers a discussion around remote Customer Success teams.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-11-24T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '8xBLkrO40bU9Fjmijzz81',
        type: 'Asset',
        createdAt: '2021-08-13T17:52:18.774Z',
        updatedAt: '2021-08-13T17:52:18.774Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Ben Bouteille is featured on Customer Success Leader',
        description: 'Ben Bouteille is featured on Customer Success Leader',
        file: {
          url: '/img/contentful/8xBLkrO4-lorrkabqced6gs9ucuwh.webp',
          details: {
            size: 77515,
            image: {
              width: 960,
              height: 541
            }
          },
          fileName: 'LorrkaBQceD6Gs9UcUWH',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Ben Bouteille is featured on Customer Success Leader',
    summary:
      'Restructuring an organization’s Customer Success process is tough to do in-person. Now imagine doing it 100% remote! Fortunately, Benoit Bouteille , VP of Customer Experience at Tinyclues , had ample experience in leading remote CS teams before his organization decided to restructure. In this episode, we dive in and discuss: ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Restructuring an organization’s CS process is tough enough to do in-person. Imagine doing it 100% remote! ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'That’s been the reality for many organizations — and possibly yours — as the pandemic has disrupted our traditional ways of working and living. Rethinking organizational structure has become a necessity in our new normal.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Fortunately, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Benoit Bouteille',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/benoitbouteille/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of Customer Experience at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Tinyclues',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.tinyclues.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', had ample experience in leading remote CS teams before his current company decided to restructure. We recently chatted with him about the process including:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Why Tinyclues decided to undergo a reorg',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What the goals were',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How they went about designing a more collaborative organization',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Focusing on the outcomes of the customer',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Why a Reorg?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In retrospect, this might be a silly question. After all, the reason for the reorg is the same reason that many organizations have had to adapt and change the way they approach working — the pandemic.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In the case of Ben and his company, physical events — such as marketing roadshows, social events, and investment meetings — played a big role in their marketing processes pre-pandemic. Once COVID arrived, they had to shift their entire operation over to digital.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Since this massive disruption was occurring, they decided to take the opportunity to restructure their organization, and do it in a way that would better serve their target audience.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'After all, they were simply putting into practice one of their core values: “Work together to provide a better experience for our customers.”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'The Goals of the Reorg',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '“Our main job is to understand the ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'strategy of our customers',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '… their ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'long-term plans',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '… the ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'pains ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'they are facing.” — Ben Bouteille',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'There were three main goals driving the reorganization:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Better communication',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Better organization',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Better collaboration',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The CS team was at the center of making those goals a reality.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Why the CS team?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Because they were the keeper of the CRM, the experts of customer outcomes. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Leveraging their knowledge across the landscape of customer communication would be integral to success. In this 100% digital world, communication types included:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Webinars',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Lead-gen content',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Thought leadership',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Customer testimonials',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The responsibility of each of these communication types would be broken up between different departments, but each would need input from the CS team.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Breaking Down Silos',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To focus on customer outcomes, the company would need collaboration across different departments. Ben mentions a few examples where this renewed spirit of collaboration was key.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'External Review',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For social proof of the product, the company likes to present reviews by existing clients. And not just on their website — their preference is to have them pop up on third-party platforms so they carry greater credibility.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The marketing team needs these reviews to market the product effectively. Within this new environment of collaboration, the sales team steps in to ask clients to provide reviews to third-party sites giving the marketing team a stronger foundation from which to work.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'State of the CRM Report for 2021',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Another example involves the company’s work on their State of the CRM Report for 2021. The majority of the writing work was done by the CS team. And this report will mainly be used for marketing and lead gen purposes.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But it will also be shared with other departments opening up the potential for the report’s insights to be leveraged across the organization.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'The Same Metrics',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'You might think that — along with this reorganization of responsibilities and departments — the ways of measuring success would change too. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'But Ben says that from that perspective, the metrics really didn’t change much at all. In fact, from a morale perspective, Ben says, it was important to communicate to everyone that their jobs were not changing, just their ability to collaborate cross-functionally.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The sales team was still in charge of the bottom line and bringing in new customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The CS team was still in charge of minimizing churn, maximizing retention, and advocating for better usage of the platform.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The difference was the ability to truly count on other departments for help and a renewed focus on the global experience of the customer.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'The Results',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Wide-ranging progress will take time, Ben says, but in the last six months, he’s already noticed a positive effect in the simple ways teams have started to work together. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Across the organization, they have been liberated from a fear of seeking out help outside of their silos.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Sales has reached out to content and marketing teams to get advice on the best way to structure and word a sales email. Members of the CS team have reached out to the content specialists with ideas for blog topics and have even written some.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The goal of pointing the entire organization in the direction of driving positive customer outcomes is coming to fruition.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Think About Your Customer',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '“It’s really important to explain ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'why',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' we do ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'what',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' we do.” — Ben Bouteille',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Ben has one overarching piece of advice for any company setting off on the path of restructuring: put the customer at the center of everything.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '“The central point of an organization,” Ben says, “is the customer’s voice.”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Before you start restructuring, you need to understand a few things:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What experiences are your customers looking to have with your company?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What different touch points do you have with your customers?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How can you group different departments to create the best customer experience possible at these touch points?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Ultimately, the most important task is optimizing your company’s structure so that you can provide customers an incredible global experience that will keep them coming back and evangelizing to their peers on your behalf.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: "In this podcast episode we're joined by ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Benoit Bouteille',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/benoitbouteille/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of Customer Experience at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Tinyclues',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.tinyclues.com/'
              }
            },
            {
              nodeType: 'text',
              value: ', and we dive in and discuss:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How remote teams should look at CS and CX',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why Ben specifically focused on breaking down silos within his organization',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to design your organization around customer outcomes',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5kbD6Uu3Eq7hSruEXHaAVN',
                type: 'Entry',
                createdAt: '2021-08-13T15:46:14.184Z',
                updatedAt: '2021-08-13T15:46:14.184Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Steps to Managing a Remote CS Team w/ Benoit Bouteille',
                sounderLink: 'https://embed.sounder.fm/play/102359',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/steps-to-managing-a-remote-cs-team-w-benoit-bouteille/id1528594709?i=1000500049225',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/N2VjOWE0NjctZGQ5NC00NjE3LWJiZTMtNDI5YzVlM2RjOWMx?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/steps-to-managing-a-remote-cs-team-w-benoit-bouteille-79656562',
                spotifyLink:
                  'https://open.spotify.com/episode/50Y7rUyIOIzP0f18qlYzCD?si=IKzSDOdURrKXdKrkureyqA&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4IboLvXpjBfxisKZ5Rsuov',
                type: 'Asset',
                createdAt: '2021-08-13T17:53:33.543Z',
                updatedAt: '2021-08-13T17:53:33.543Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Ben Bouteille',
                description: 'Podcast quote from Ben Bouteille',
                file: {
                  url: '/img/contentful/4IboLvXp-u4surhtqzqblnef1pbzc.webp',
                  details: {
                    size: 48926,
                    image: {
                      width: 1200,
                      height: 629
                    }
                  },
                  fileName: 'U4SuRHtQZqBlnEf1pbzC',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'For more info, check out ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customersuccessleader.com',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.io/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '6o2s9mEMpibTFDTECQhbJl',
    postTitle: 'Why customers hate your customer onboarding experience',
    seoTitle: 'Your Customers Hate your Data Onboarding Process',
    seoUrlSlug: 'why-your-customers-hate-your-onboarding-experience',
    seoMetaDescription:
      'Customer onboarding is not a one size fits all process. Learn more about how to improve both data onboarding and customer onboarding.',
    category: 'Data exchange',
    tags: ['Customer onboarding'],
    publishDate: '2020-11-19T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1NDYihsNtwGNZ9bBJXHhOM',
        type: 'Asset',
        createdAt: '2021-08-13T21:49:11.393Z',
        updatedAt: '2021-08-13T21:49:11.393Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'improvements to customer onboarding process',
        description: 'improvements to customer onboarding process',
        file: {
          url: '/img/contentful/1NDYihsN-exyb6i0ryoz67lahpcdq.webp',
          details: {
            size: 308619,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'ExYB6i0RYOZ67LahPcDQ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'improvements to customer onboarding process',
    summary:
      'Let’s face it...getting started with new software can be a pain. Between cookie-cutter onboarding, hands-on data migration, and emailing sensitive information back and forth, there’s a lot that has to go right in order for your new customer to find value quickly. Not to mention, you don’t want them to ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2dLBlxtX8ETQllCPJrcdLU',
        type: 'Entry',
        createdAt: '2021-08-13T21:28:19.412Z',
        updatedAt: '2021-10-07T04:32:30.871Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'JK Sparks',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '19PRmT7PwvC39hgE3f445U',
            type: 'Asset',
            createdAt: '2021-08-13T21:27:13.868Z',
            updatedAt: '2021-08-13T21:27:13.868Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'JK Sparks headshot',
            description: 'JK Sparks headshot',
            file: {
              url: '/img/contentful/19PRmT7P-3uyorwrxtfaobczpgisu.webp',
              details: {
                size: 40925,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: '3uYorWRxTfaoBCZpgISu',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Head of Growth Marketing',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s face it...getting started with new software ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'can',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' be a pain. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Between cookie-cutter onboarding, hands-on data migration, and emailing sensitive information back and forth, there’s ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'a lot that has to go right',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' in order for your new customer to find value quickly. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Not to mention, you don’t want them to feel buyer’s remorse. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'know ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'your new customer is asking themselves these questions post-purchase:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: '- Will I get a return on my investment? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: '- Will the product really work how they say it will?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                '- Will my team see this as helpful, or just another step in their day-to-day?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                '- If this thing doesn’t work out, how will it reflect on me? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So, as a Software as a Service (SaaS) company, the last thing you want to do is deliver a customer onboarding process that doesn’t work. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Or worse yet, an experience they hate. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If your customer onboarding experience looks anything like this, your customers probably can’t stand it:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'It’s mostly automated with boilerplate processes. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'There’s not much personal outreach to discover their true pain points and struggles.  ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'You’re sending onboarding emails back and forth to your customer. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The data they have isn’t clean, making it more difficult and more time consuming to migrate it into your software.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'And if they hate the way they’re onboarded, chances are they won’t stick around for long.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'So, how can you improve your client onboarding flow? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s start from the beginning.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'What is customer onboarding?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/what-is-customer-onboarding'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Customer onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is how your new customer is introduced to your product or service. It’s getting comfortable with the new tool, understanding what it does, what buttons to push to make it do what you need it to do, etc. It’s the hand-holding between the CSM (Customer Success Manager) and the client. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'SaaS Onboarding is a pivotal moment in the customer journey. CSMs (Customer Success Managers) have the important task of building and maintaining a strong relationship. They can do this by showing them value in your product as quickly as possible. When this happens, there’s trust built between you and your customer. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'During new user onboarding, your Customer Success Team has to make sure your customers don’t feel like just another account. They need to feel like they’re your ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'only ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: 'account. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There will be times that the new user may feel overwhelmed or confused. But the important thing is how you respond to alleviate those objections as fast as possible. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What’s at stake? Well, if a client isn’t onboarded smoothly, they won’t see the full value of your tool and are more likely to churn.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'What are the benefits of analyzing your customer onboarding process?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Just like most of your business activities, it’s important to test, analyze results, and iterate. The same goes for your customer onboarding process - see what’s working, what needs work, and switch it up. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So how do you know if your client onboarding process is one your clients LOVE, or HATE? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There are a few important factors to consider when measuring the success of your client onboarding. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'First, is how quickly your customer can get through the onboarding phase, and into the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.business2community.com/customer-experience/the-top-5-customer-onboarding-metrics-and-how-to-leverage-them-02196000'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'value-driven adoption phase',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. As a general baseline, you’ll want to aim to keep onboarding less than 30 days, though this timeframe varies on product, company, scope, and effort needed on both sides. Just remember: The quicker they see value, the better. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Another way to measure the effectiveness of your onboarding process is simple: ASK. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Ask a new customer who recently went through your onboarding what their experience was like. Was it helpful? What did they like? What would they change? What key step, feature, or benefit gave them that “aha!” moment? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Getting genuine answers to these questions from real clients will help you iterate your process for the next one.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'How to determine any weak points in your customer onboarding process',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Successful customer onboarding should be a boilerplate checklist on ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'your ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'end. You need to ask your customer about their specific goals, pains, and problems, and help them see how your product can help. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Here are a few onboarding metrics to help you identify any weaknesses in your client onboarding: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Product adoption',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Consider the speed and volume of usage to your product. Are they using it daily? Have they been using it since day 1? These could be indicators of a solid or weak customer experience during onboarding. (NOTE: A client may be satisfied with one feature of your product, and happy to pay for it. It’s your job to surprise and delight them by helping them realize the added benefits of other features so they never leave.) \n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Look at CSAT scores',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If your Customer Satisfaction Scores are steadily dropping, you may want to take a look at your onboarding process. Satisfaction starts from the very beginning, and you only get one good first impression. Make it count. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Retention',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This one’s pretty simple: If your customers stick around, they probably had a good experience during onboarding. Sure, there are ways to turn things around after a poor start with your brand, but it’s not easy. But in general, better customer onboarding leads to more loyal customers and less customer churn.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'How to implement improvements to your customer onboarding process',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Once you analyze your customer onboarding, you may find it to be difficult to put those improvements into practice, especially at scale. You may need to find the right balance between truly personal 1-to-1 onboarding, and automated processes. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One way to approach this is to identify frequently asked questions, and create guides, downloadable content, or videos that answer them. That way you don’t have to type out the same answers over and over again. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'There are a number of customer onboarding ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/28-onboarding-tools-for-delighting-new-users'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'tools ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                'to help with your onboarding strategy, but remember that at the end of the day, a solid customer experience is all about relationships. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Another thing to keep in mind is maintaining excitement. On one hand, a decision-maker could have anxiety about rolling out a new product or service. But if you approach it the right way, you can feed off the excitement post-purchase. Remind them what got them pumped about signing the dotted line, and show them there’s more where that came from. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A common way that customers might lose their excitement is by making them feel like “Data Wranglers”. In other words, telling you new customers that in order for them to get fully onboarded, they have to take the time and effort to collect all their customer data and format it so that it fits. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'That’s one of the main reasons we built ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' - a collaborative, secure workspace for ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' that helps companies speed up every part of data migration, from data submission to cleaning.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3H8JaEMyFHoqnVsT3Nmtgc',
                type: 'Entry',
                createdAt: '2021-08-13T21:47:28.744Z',
                updatedAt: '2022-10-06T16:32:50.231Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'Transform enterprise data onboarding from complex to simple with Flatfile’s data onboarding platform',
                ctaText: 'Learn more',
                href: '/get-started',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your brand has spent the time, energy, and resources to acquire a new client. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Don’t spoil it by delivering an onboarding experience they hate! Help them find value quickly and easily, and you’ll have a much better chance of keeping that customer for life.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6L5YSmL6dqNKbTbKJ9YApm',
    postTitle: 'Start Speaking Your Customer’s Language',
    seoTitle: 'Start Speaking Your Customer’s Language',
    seoUrlSlug: 'clear-cs-communication-with-leigh-hamer',
    seoMetaDescription:
      "Clear communication is important for Customer Success teams. Learn more in the latest episode of Flatfile's Customer Success Leader podcast.",
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-11-17T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6v4jrBxp6sVP7RBQb5IRlT',
        type: 'Asset',
        createdAt: '2021-08-13T17:48:32.549Z',
        updatedAt: '2021-08-13T17:48:32.549Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Leigh Hamer joins the Customer Success Podcast',
        description: 'Leigh Hamer joins the Customer Success Podcast',
        file: {
          url: '/img/contentful/6v4jrBxp-pqeicpfpqbspkenf5iwj.webp',
          details: {
            size: 92540,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'pQeIcpfpQbSPkeNF5iwJ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Leigh Hamer joins the Customer Success Podcast',
    summary:
      'We’ve all heard it before: Communication is key. So why are businesses still so bad at it? Leigh Hamer , Director of Customer Success at Lumavate , shares her strategy for crafting communication dependent on the receiver in this episode of Customer Success Leader. Additionally, we dive in and talk ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Miscommunication can be deadly. It can be deadly to your customer success initiatives, the growth of your business, and your brand’s reputation.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'So, how do you avoid miscommunication and get on the same page with your customers? Start speaking ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'their',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' language.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Leigh Hamer',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/lhamer/'
              }
            },
            {
              nodeType: 'text',
              value: ', Director of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Lumavate',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.lumavate.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', has encountered some of the same communication challenges many organizations face and she recently shared some tips on how to craft effective customer messaging with us.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'The Foundation of Good Customer Communication',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '"Good communication is the ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'foundation of success',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' in any role." — Leigh Hamer',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'First and foremost, good communication is the bedrock of any successful initiative whether it’s internal or external. It sets the stage for what’s to come by managing expectations and ensuring all goals are aligned.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '“Think about your interpersonal relationships with your colleagues, your vendors, your own customers that you deal with,” says Leigh. “Clear communication makes that relationship grow and thrive so that you can avoid the strife and confusion that happens when there’s miscommunication.”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Focus on the Main Points',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Leigh has a background in PR and she brings insights from that arena into the customer success realm.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'One example: in a previous position, part of her job included writing executive summaries. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The purpose of executive summaries is to boil down large swaths of information into bite-sized bits — the key takeaways that are most important for the executive to know. They are a function of the idea that executives don’t have much time to read complete reports.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Nowadays, most people simply don’t have the time to read over tons of information. And that includes your customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'So, Leigh applies the same idea to customer communication. She asks herself questions like:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How much time will they actually have to read this email? ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How much time will they actually have to look at that powerpoint presentation?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What’s the most efficient and effective way to get them to see and understand what I need them to see and understand?',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'And then she will tailor the communication with those considerations in mind.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Delivering the Message',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When we hear people talk about good communication, there are many buzzwords that get thrown about — ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'transparent',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' communication, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'clear',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' communication, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'straightforward',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' communication. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'But what does it actually mean to deliver ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'good communication',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '“It means there is honesty, but there’s a little jujitsu going on with it,” says Leigh. To put it another way, she means that good communication is sometimes about flipping the narrative so that a negative becomes a positive — it becomes an opportunity.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Take the client-vendor relationship, for example. In its basic form, it’s merely a transactional relationship. But according to Leigh, you can frame it as a partnership so that it transforms into a more dynamic relationship. The resulting opportunity is relationship growth that benefits both parties. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Building Trust',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'It comes down to an issue of trust.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'So, in her customer communications, she works to gain the trust of her clients so that they bring her into their strategic planning sessions. She demonstrates the value she can bring if she is privy to those insights. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'She informs them that knowing their business inside and out will give her the ability to look ahead and see if there are any upcoming impediments to their growth or the success of their initiatives.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Delivering Negative Feedback',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Of course, in a partnership, you may find occasions where you need to deliver negative feedback to your clients. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'So how do you do that without damaging the relationship?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Leigh has a story for that.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'She had a mentor who taught her how to edit. Together, they were in charge of editing the directors of the organization. What struck Leigh as genius was that her mentor would always edit these documents with a pencil rather than a red pen. Since it was done in pencil, the feedback never came off as harsh to them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Leigh constantly thinks about that when she needs to deliver negative feedback to customers. She always aims to do it in a way that doesn’t insult them or put them in a defensive position. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'How does she do that?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'She engages with the client and frames the feedback as an enemy they can vanquish together so that they are able to achieve mutual goals. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It goes back to presenting the relationship as a partnership — impressing upon the customer that we’re in this together and we can both benefit from the changes that need to be made.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Case Study: Lumavate',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '"We ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'measure success',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' by how ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'easy ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'our ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'platform ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'and ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'solutions ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'are for customers to use." — Leigh Hamer',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Lumavate',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.lumavate.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', Leigh’s company, is a low-code platform for marketers that allows them to build simple apps with little to no coding knowledge.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Because their customers can and do build anything they want, it can be hard to define customer success. Ultimately, they settled on measuring how easy the platform is to use for their customers by collecting customer feedback.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Recently, they took that feedback and redesigned the app with a focus on fixing areas where people were getting hung up or spending more time than they needed to.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'So, how did she go about communicating the changes to the app to their customers?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Communicating Changes',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-4',
          content: [
            {
              nodeType: 'text',
              value: '"The ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'visual appeal ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'of your platform cannot be overlooked. When people see it, it should seem ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'welcoming',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ', not ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'intimidating',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '." — Leigh Hamer',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It started with an overhaul of the messaging on the website. That ensured that it would sound consistent to both existing customers and new customers heading to the website.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Next, they went about contacting all existing customers using email, meetings, and phone calls. Their main message: “The fundamental building blocks that you are accustomed to and have become very acquainted with in the platform are still there. They’re just in different places.”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'New can be scary to many customers. So Leigh’s goal was to allay customer concerns by demonstrating that everything they were used to was still there, it was just ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'better',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The visual design played a role in supporting that message of familiarity. In the redesign, they aimed to make it simple and welcoming, rather than overly complex and intimidating.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Other Tactics Leigh’s Team Used',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Hosted one-on-one meetings with customers to continue building the relationship and addressing concerns',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Determined which features they could never get rid of because it would alienate the customer base and avoided altering those',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Gave customers the freedom to use the platform however they wanted, but also made a “safe space” available that contained templates, training, and other resources to help them if they needed it',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Leigh Hamer',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/lhamer/'
              }
            },
            {
              nodeType: 'text',
              value: ', Director of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Lumavate',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.lumavate.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', shares her strategy for crafting communication dependent on the receiver in this episode of Customer Success Leader.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Additionally, we dive in and talk about:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Measuring success based on your platform’s ease-of-use',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Mitigating the scariness of new updates',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How Leigh has been accounting for a new customer profile',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1nw2D6NirSoFh3ZC7bde58',
                type: 'Entry',
                createdAt: '2021-08-13T15:45:14.948Z',
                updatedAt: '2021-08-13T15:45:14.948Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Start Speaking Your Customer’s Language w/ Leigh Hamer',
                sounderLink: 'https://embed.sounder.fm/play/102360',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/start-speaking-your-customers-language-w-leigh-hamer/id1528594709?i=1000498988384',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/ZGJjOGQwYjEtNDI4YS00OGNkLWE5ZjctMDY3ZjYyNGUxZDlj?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/start-speaking-your-customers-language-w-leigh-hamer-79461299',
                spotifyLink:
                  'https://open.spotify.com/episode/0t6NvnR1frCuKMoMEtm7MH?si=M33f5I4nSVuTAcmykNkwcw&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1sc6UiYFTQUAfd7xjO58vS',
                type: 'Asset',
                createdAt: '2021-08-13T17:50:25.330Z',
                updatedAt: '2021-08-13T17:50:25.330Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Leigh Hamer',
                description: 'Podcast quote from Leigh Hamer',
                file: {
                  url: '/img/contentful/1sc6UiYF-k9898jq6tbqxllz262uf.webp',
                  details: {
                    size: 30456,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'k9898JQ6TbqxlLz262UF',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '2wpFcT2UfHurUCsE18uCOl',
    postTitle:
      'Flatfile helps Discoverygarden accelerate digital preservation with a simplified data onboarding process',
    seoTitle: 'Flatfile Helps Discoverygarden with Data Onboarding',
    seoUrlSlug:
      'flatfile-helps-discoverygarden-accelerate-digital-preservation-with-a-simplified-data-onboarding-pro',
    seoMetaDescription:
      'Learn how discoverygarden, inc. uses Flatfile’s data importer for a better data onboarding experience.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories'],
    publishDate: '2020-11-12T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1JIbDs4qFAg0TXDW0gQa8N',
        type: 'Asset',
        createdAt: '2021-08-11T22:46:19.961Z',
        updatedAt: '2022-01-05T12:41:29.607Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Discovery Garden works with Flatfile to import data',
        description: 'Discovery Garden works with Flatfile to import data',
        file: {
          url: '/img/contentful/1JIbDs4q-exdj4qzgsuanxihjhgke.webp',
          details: {
            size: 77067,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'ExDj4qzGSUanXIhjhGKe',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Discovery Garden works with Flatfile to import data',
    summary:
      'It has become critically important to digitize and preserve valuable assets from government agencies, libraries, museums, historical societies, and other organizations. Discoverygarden inc. is a company dedicated to preserving cultural and mission critical digital content. Its customers include such prestigious organizations as UCONN...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It has become critically important to digitize and preserve valuable assets from government agencies, libraries, museums, historical societies, and other organizations. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.discoverygarden.ca/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Discoverygarden inc.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '  is a company dedicated to preserving cultural and mission critical digital content. Its customers include such prestigious organizations as UCONN , Baseball Hall of Fame, and UNESCO. Located in Prince Edward Island, Canada, the company has preserved over a hundred million files so far. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'In this post, we uncover:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Dealing with data import challenges with multiple data types',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Evaluating the make/buy data import decision',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: "Moving forward with Flatfile's ",
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'data exchange',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' solution',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Our focus is on building solutions for long term preservation and stewardship of data whether it was born digital or whether it is photos and physical assets that have been digitized,” said TJ Lewis, COO at Discoverygarden inc. “We’re enabling our clients to preserve, store, and easily access these assets over the long term.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One of the key differentiators for Discoverygarden inc. is the open source nature of their platform which is built on Islandora, a free, open-source digital asset management framework. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“There are a number of proprietary systems out there,” said Lewis, “but with open source software we have the advantage of being able to easily extend our platform to include custom functionality for our clients.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Dealing with data import challenges with multiple data types',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'D',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'iscoverygarden inc. performs about 125 data migration projects a year, typically working with structured metadata. However there are thousands of different metadata schemas and emerging description frameworks in use today which ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'poses a challenge when it comes to importing customer data',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Since we deal with many types of customers and many sources of data, it’s very common to encounter poorly structured or sanitized data,” explained Lewis. “We’re always having to perform deep analysis to find problems prior to data importing and having to map client data into structured schemas. That’s typically a painful process.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Lewis estimated that it often takes weeks to train a customer on how to map and import their data. To streamline the process, Discoverygarden inc. has implemented the Flatfile data importer into its new Software as a Service offering, dgspaces.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Flatfile provides us with an extremely user-friendly way to transfer the mapping and validation process to the client before it gets to us,” said Lewis. “That is a huge time saver.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Evaluating the make/buy data import decision',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The development team at Discoverygarden inc. have built multiple iterations of a data import solution using Drupal but decided that the Flatfile data importer was a better choice for our product offerings.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We built a CSV importer that had mapping functionality years ago, but it wasn’t widely adopted,” said Lewis. “We also built a spreadsheet ingest module but that still required developer intervention before the client could actually upload their data.  For dgspaces, we decided it was going to take much longer to build a data importer ourselves. We decided it was much easier to implement the solution that Flatfile offered.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Flatfile data importer provides a much more user-friendly solution that results in a better customer experience, according to Lewis.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“It’s been difficult and time consuming to troubleshoot problems that arise with client data uploads,” said Lewis. “With Flatfile’s data importer we can quickly review the file that the customer uploaded and diagnose the problem. It streamlines the process for our support team to go in and help the client. That’s a really nice addition for us.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile also greatly reduced the time the discoverygarden inc. team spent on the data importing process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“There are several people involved when it’s time to import data,” said Lewis. “Our data architect does an initial analysis of the client files and recommends any cleanup that must be done and develops mapping to our data model. It’s a great deal of manual work on our end. Flatfile’s data importer eliminated this arduous process since now the clients can do the mapping, validation and cleanup on their own.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: "Moving forward with Flatfile's data import solution",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As part of their service projects, Discoverygarden inc. is often tackling custom development such as connecting a product API to pull data out or building a custom feature or workflow for a client. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile will be working with Discoverygarden inc. to streamline these projects by ingesting database files and acting as a staging database repository that stitches files together. The discoverygarden inc. team will also be able to hook into an API to do the same thing.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The best thing about the Flatfile data importer is the ease of use for our clients to be able to map and validate a file themselves,” Lewis concluded. “That process prevents data errors from being imported into the system.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Additionally Flatfile has an impressive client and customer success team behind the scenes to ensure that everything is performing the way it should!”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About discoverygarden inc.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'D',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'iscoverygarden inc. was founded on the principle of global standards and dedicated to evolving industry leading preservation platforms. Incorporated in 2010 to support the Islandora Open Source Digital Asset Management project that had been founded three years earlier at The University of Prince Edward Island. Ongoing collaboration led to a rewrite of Islandora to allow for greater growth and integration with other software systems. Over the years we have evolved and taken the digital asset management solution beyond its initial niche market in academia and branched into a number of worldwide industries. For more information, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.discoverygarden.ca'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'https://www.discoverygarden.ca',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7hA5sxXlKpPyL1JyvkTMSG',
    postTitle: 'Stopping Churn Isn’t Your Only Job',
    seoTitle: 'Stopping Churn Isn’t Your Only Job',
    seoUrlSlug: 'more-than-a-churn-stopper-with-maranda-dziekonski',
    seoMetaDescription:
      'During this episode of Customer Success Leader, Maranda Dziekonski discusses the role of success which is more than stopping churn.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-11-10T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2ZtDXLjMeY30wyfB7iorfr',
        type: 'Asset',
        createdAt: '2021-08-13T16:57:12.443Z',
        updatedAt: '2021-08-13T16:57:12.443Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Maranda Dziekonski joins the Customer Success Leader podcast',
        description:
          'Maranda Dziekonski joins the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/2ZtDXLjM-geb4s6hsgg2zf8azqbrv.webp',
          details: {
            size: 67405,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'GeB4S6HSGG2zf8AzqBRv',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Maranda Dziekonski joins the Customer Success Leader podcast',
    summary:
      'Stopping customer churn shouldn’t be a Customer Success leader’s main concern. It should be the result of achieving more meaningful goals. In this episode of Customer Success Leader, Maranda Dziekonski , VP of CS & People Ops at Swiftly , joins us to discuss: Why CS leaders should be leveraging ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Stopping ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'customer churn',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://flatfile.com/blog/how-better-onboarding-can-reduce-customer-churn'
              }
            },
            {
              nodeType: 'text',
              value: ' shouldn’t be a CS leader’s main concern. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Admittedly, it can be tempting to place this metric on a pedestal and turn it into the north star of your CS strategy. But if you ask ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Maranda Dziekonski',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/marandaanndziekonski/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of CS & People Ops at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Swiftly',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.goswift.ly/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', she thinks one of the biggest mistakes a company can make is directing the CS team to focus solely on reducing or stopping churn.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Recently, we spoke with her about the follies of becoming — what she dubbed — a “churn-stopper” and picked her brain about other CS topics like:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What to focus on instead of stopping churn',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Evolving your CS processes to accommodate for remote work',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Where to learn more about CS',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Avoid Being a “Churn-Stopper”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '"Customer success is way ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'more ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'than just ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'churn-stoppers',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '." — Maranda Dziekonski',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Stopping customer churn is not the work of a CS team. It is ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'the result',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'of all the work the CS team should be doing',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. If you hire a team just to stop churn, then you are missing the point of customer success. Here are some initiatives you should focus on instead.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Leveraging Insights from Across Your Portfolio',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'As a CSM, one of the most robust resources you have is your customers. From your unique vantage point, you can see multiple different examples of how customers use your service. You also can see multiple different examples of how your customers operate their business as well.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Because of this perspective, you become a repository for all the best practices within an industry. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'So why not share those insights with all of your customers? Spread the wealth, as they say.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'After all, your customers are always looking for ways to upgrade their business. And as a CSM, helping them upgrade their business should be your goal too. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This is especially true for any period of great disruption — such as the COVID pandemic — when old processes no longer work and new processes need to be iterated on the fly.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Ultimately, your aim should be to build a community where your customers can share what’s working with each other so that everyone benefits.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Becoming a Better Partner',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '"The ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'experience ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'your customers get may not be the experience you ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: "think you're giving",
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: '." — Maranda Dziekonski',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Developing a deeper relationship with your customers should be another focus. This is especially true if you’re dealing with larger entities that are paying top dollar for your services. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'They aren’t just paying for the product or service; they expect you to provide something more to ensure that they will be successful.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In completing the work of understanding your customer and their business, uncover what will make you indispensable to them. Once you do, document it out so that your customers don’t just achieve ROI one single time, but over and over again. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Come to an understanding of what the customer hopes to gain out of the experience and then overdeliver on that.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value: 'Be an Internal Advocate',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'You shouldn’t only be sharing your newfound knowledge with your customers. To be a successful CSM, you should be sharing all of that knowledge internally within your own organization as well. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'After all, your company needs to evolve too so that you can offer your customers the best experience possible.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Committing to constant evolution also means that you should consistently analyze your internal processes to see what can be improved.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A lot of CS teams came to this realization after switching to remote work during COVID. Maranda’s team was one of them.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Leveling Up Your CS Process For Remote Work',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A couple of months into the switch to remote work, Maranda noticed that things felt broken. “Not everything, but a couple things just felt like the process was not scaling right,” she said.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For a while, she couldn’t figure out why it felt wrong. But then a lightbulb went off. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '“We’re remote now,” she realized. “We need to completely level up the entire team and get everybody to look at all the processes and figure out what needs to evolve.”',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Does this situation sound familiar? ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If it does, you might be wondering what exactly you should do about it. According to Maranda, a good place to start is hosting a brainstorming session to discover what’s working and what’s not. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Her team focused on two questions: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What tools aren’t working quite as well as they had before the switch to remote work? ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'And what gaps in skill sets do we need to level up? ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'That latter question is especially important. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Why? Because the answer is the key to the evolution of your company. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'By constantly looking to improve your process, technology stack, and people, you enable your organization to fill in the skill gaps and grow. Maranda recommends doing this every three to six months.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s important to note that what got you here, won’t get you there… especially in the middle of a global pandemic.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Learning Resources for Budding Customer Success Leaders',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If you’re a budding customer success leader in search of a mentor, Maranda has some recommendations for finding one:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Sign up for ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Catalyst’s Coaching Corner',
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://catalyst.io/coaching-corner?_hsmi=97809129&_hsenc=p2ANqtz--KgaTqYX0m4bjJakcHh4dJW4bDnyzwc8_TcOLvlFeVeMQ60eANt-c7lfKpGZei3OUapI02wFVIQEghIDlueo5Uyq17aSw9gbxRfybEUBqKkjPGAL0&'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: ': A CS mentorship program that recently formed.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Reach out to CS leaders on LinkedIn',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': It’s true, they might be too busy. But if someone says no, don’t be dissuaded from reaching out to others.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Join the ',
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            'Customer Success Leadership Network Slack channel',
                          marks: [
                            {
                              type: 'bold'
                            }
                          ],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://customersuccessnetwork.com/'
                      }
                    },
                    {
                      nodeType: 'text',
                      value:
                        ': Maranda helps run this community that counts people from all levels — from executives down to those aspiring to join their ranks — as members. They even have a channel dedicated to aspiring CSMs.',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode of Customer Success Leader, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Maranda Dziekonski',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/marandaanndziekonski/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of CS & People Ops at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Swiftly',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.goswift.ly/'
              }
            },
            {
              nodeType: 'text',
              value: ', joins us to discuss: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why CS leaders should be leveraging relationships they’ve built',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to be more than just a churn-stopper',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How CS leaders can act as internal advocates for customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why advising has been so important to Maranda’s career',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7v8029sg9DoppbuSOvNNCU',
                type: 'Entry',
                createdAt: '2021-08-13T15:37:38.282Z',
                updatedAt: '2021-08-13T15:37:38.282Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Stopping Churn Isn’t Your Only Job w/ Maranda Dziekonski',
                sounderLink: 'https://embed.sounder.fm/play/102361',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/stopping-churn-isnt-your-only-job-w-maranda-dziekonski/id1528594709?i=1000497942543',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MWVkODRjNGItYzY2Ny00OTI5LWJjZGEtMDU1YjhiMGRjMDcw?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/stopping-churn-isnt-your-only-job-w-maranda-dziekonski-79275196',
                spotifyLink:
                  'https://open.spotify.com/episode/6ny5XWH8hHa3CHm7YJOhy2?si=QXkChPBpR82F0gWWn_RT8g&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ZKUxOHW2uXbPSGhjBQvmk',
                type: 'Asset',
                createdAt: '2021-08-13T17:02:15.261Z',
                updatedAt: '2021-08-13T17:02:15.261Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Maranda Dziekonski',
                description: 'Podcast quote from Maranda Dziekonski',
                file: {
                  url: '/img/contentful/3ZKUxOHW-ke45les1qg2htvp8ejns.webp',
                  details: {
                    size: 36920,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'KE45LeS1QG2htVp8eJnS',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '5pJCm3f8PuXzMzK8J35yRk',
    postTitle: 'Customer Success: Does Your Product Live Up to the Hype?',
    seoTitle: 'Customer Success: Does the Product Live Up to the Hype?',
    seoUrlSlug: 'delivering-value-chad-horenfeldt',
    seoMetaDescription:
      'On the latest episode of Customer Success Leader, Chad Horenfeldt discusses the importance of delivering value in Customer Success roles.',
    category: 'Podcast',
    tags: ['Customer success', 'Podcast'],
    publishDate: '2020-11-03T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3cIVyCv2knUMhkbYrkqEmA',
        type: 'Asset',
        createdAt: '2021-08-13T16:53:28.593Z',
        updatedAt: '2021-08-13T16:53:28.593Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Chad Horenfeldt featured on Customer Success Leader',
        description: 'Chad Horenfeldt featured on Customer Success Leader',
        file: {
          url: '/img/contentful/3cIVyCv2-cupopsvsqusjswq9wkst.webp',
          details: {
            size: 63310,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'cupoPsVsQuSjSwQ9WKst',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Chad Horenfeldt featured on Customer Success Leader',
    summary:
      'Customer success is all about driving value. But that’s not limited to your customer success team. It’s company-wide. And your product better live up to what you sold it as. Today’s guest on the Customer Success Leader podcast is Chad Horenfeldt , Customer Success Coach at Kustomer . Chad has ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer success teams add incredible value to organizations and the customers they serve. They are one of the few teams that have insight into the entire customer journey — and when their work is successful, they can improve customer relationships, reduce churn, and increase revenue.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'So how can your organization harness the power of customer success? In this post, we’re covering:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'The definition of customer success',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Establishing trust with customers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Implementing a customer success strategy',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Other tips for customer success managers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What is Customer Success?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s start by defining customer success. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To help with that, we chatted with someone who has seen customer success initiatives both from a boots-on-the-ground perspective, as an individual contributor, and from a higher level, as a manager, director, and strategist. His name is ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/chadhorenfeldt'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Chad Horenfeldt',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', and he’s currently the Director of Customer Success at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.kustomer.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Kustomer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'According to Chad, it’s pretty simple. It’s about ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'driving value for customers',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Whereas customer service is a reactive approach where you respond to customer concerns, customer success is a proactive approach where you work to predict customer challenges and concerns and produce solutions for them before they ever become an issue.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your goal is to find ways to support your customers’ desired business outcomes. And Chad says that trust is a fundamental part of the equation.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Establishing Trust',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Establishing trust with your customers should be a top priority. To do that, you need to work to completely understand their needs and their goals.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your objective should be to fully integrate with their team so that you can understand more about what truly drives business value for them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'So where do you start?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Well, it’s best not to start with those hard-hitting, strategic questions. Think about any current relationship you have: did it start with deep profound questions? Probably not. It probably started with surface-level questions so that you could learn the basic facts about each other and then grew from there.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The same thing goes for building customer relationships. You’ve got to create a foundation of knowledge and understanding upon which to build a trusting relationship.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What kinds of questions should you ask? Things like:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'What makes a very valued customer?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'How does your business make money?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'What does success look like for you?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After you ask these types of questions, Chad says you’ll start to see the relationship change.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A Company Initiative',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer success is not just the domain of the customer success team. It has to be the mindset of your entire organization. And that starts with the product itself. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Does it live up to the hype? Is it meeting the expectations that your sales team set forth? Is it working as expected?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It also means cross-functional communication has to be on point. If not, it can really work against building trust. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For example, if a customer success manager isn’t made aware of the conversations that have gone on between the customer and the organization, and consequently, they ask the same questions that have already been asked, they are already behind the 8-ball.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It deteriorates the level of trust that has been built. Oftentimes, people gloss over these things — the little details of the process that don’t seem to carry much weight. But that’s where true relationship-building occurs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Knowing the Bond Is Formed',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'How do you know when you’re on good terms with the customer? It’s when they view you as a partner first and a vendor second.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Some signs to look for:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'You have more personal-life conversations during calls',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'You receive emails from clients saying how much they appreciate the CSM team',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'For younger generations, you follow each other on Instagram',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Basically, you’ve come to a place where you’re able to converse in a really easy, positive way.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Implementing a Customer Success Strategy',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There isn’t a one-size-fits-all method to customer success. According to Chad, you have to look at each situation as unique and tailor the strategy accordingly.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Building a Team',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One major consideration is the makeup of your team. It depends on your company type and even your company’s stage of development.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Depending on your situation, you might want a CSM team with technical skills because your company sells a highly-technical product. Or you might want a team that has great soft skills — like empathy — because coaching your clients to success is your company’s focus. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer success encompasses so many different moving parts, so there are many different types of roles that require different areas of expertise. The challenge is making sure you find the right people for the right roles.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Build Cross-Functional Relationships',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer success is still a relatively new function. Because of that, a lot of the role remains undefined.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To get up to speed on what the organization needs, Chad recommends reaching out to other departments to learn about the challenges they face and what’s been put on their plate. What you’re really trying to learn is how your team can help them. You’re trying to build those cross-functional relationships.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It all goes back to the concept of establishing trust. Not only should you seek to build trust with customers, but you should also seek to build it with other teams within your organization as well.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Other Tips for Customer Success Managers',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Chad has some other advice for customer success managers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Keep Learning',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To be a great manager, you need to keep learning. Chad recommends reading books on customer success, talking to other people who work in the discipline, and joining industry communities.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'You Don’t Need to Know Everything',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You might feel like you should have all the answers and be able to figure it all out on your own. Chad is familiar with that impulse. In fact, it took him some time to learn that it’s the wrong approach. What you really need to do is constantly seek help from others either on your own team, cross-functionally, or outside your organization.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Why? Because ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'it’s not about being right, it’s about getting it right',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Today’s guest on the Customer Success Leader podcast is ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/chadhorenfeldt'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Chad Horenfeldt',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', Customer Success Coach at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.kustomer.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Kustomer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Chad has experience in a variety of customer-success-centered roles and came on to share the wisdom he’s gained over his impressive career.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In this podcast episode, we discuss:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'What customer success is',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Why your product needs to live up to the hype',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Why leadership is all about a dedication to lifelong learning',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1S9QCjzpmq7kKqlMJ9MFQc',
                type: 'Entry',
                createdAt: '2021-08-13T15:36:40.068Z',
                updatedAt: '2021-08-13T15:36:40.068Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Customer Success: Does Your Product Live Up to the Hype? w/ Chad Horenfeldt',
                sounderLink: 'https://embed.sounder.fm/play/102362',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/customer-success-does-your-product-live-up-to-the/id1528594709?i=1000497027344',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/OGE2NzBlZGQtOTkxMS00MzgwLWI0MTktN2Q3ZTZhNjhiMWVj?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/customer-success-does-your-product-live-up-to-the-hype-w-chad-horenfeldt-79077244',
                spotifyLink:
                  'https://open.spotify.com/episode/5LIKJ9PlvBNBsQyMqQQIWe?si=uxZ9v3C-Q9WHxnUsr94eYQ&dl_branch=1'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6NtdBzXxjMAUmxu5lSXeJU',
                type: 'Asset',
                createdAt: '2021-08-13T16:55:28.236Z',
                updatedAt: '2021-08-13T16:55:28.236Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Chad Horenfeldt',
                description: 'Podcast quote from Chad Horenfeldt',
                file: {
                  url: '/img/contentful/6NtdBzXx-6df2guzyqksqgrdjz4vo.webp',
                  details: {
                    size: 38572,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: '6Df2gUzyQKSqGrdJz4vO',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Apple Podcasts',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Spotify',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Stitcher',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Google Podcasts',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2FmVghVRHG5LY8RUkOfnN0',
    postTitle: '7 scary Excel errors your team is probably making',
    seoTitle: '7 Scary Excel Errors Your Team is Probably Making',
    seoUrlSlug: '7-scary-excel-errors-your-team-is-probably-making',
    seoMetaDescription:
      'Excel errors are not only scary, they’re common. Learn about the common excel errors that your team is making.',
    category: 'Data exchange',
    tags: ['Excel errors', 'Microsoft Excel'],
    publishDate: '2020-10-29T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'JQHWZUUDKkmfzQE6ZTYFQ',
        type: 'Asset',
        createdAt: '2021-08-13T21:51:33.278Z',
        updatedAt: '2021-08-13T21:51:33.278Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Scary excel errors your team is making',
        description: 'Scary excel errors your team is making',
        file: {
          url: '/img/contentful/JQHWZUUD-htrmknfr9y1gl63wr2mw.webp',
          details: {
            size: 745748,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'hTrMkNfR9y1gL63wr2mW',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Scary excel errors your team is making',
    summary:
      'This Halloween is sure to be like no other (we can feel it in our bones). Because parties and trick or treating are largely off the chopping block, you’re more likely to spend the evening watching horror movies. But perhaps nothing could be scarier to watch than all the Excel ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Halloween, the scariest of holidays. But perhaps nothing could be scarier to watch than all the Excel mishaps your colleagues are committing. Excel spreadsheet errors and mistakes are far scarier than anything you could find on Huluween.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'While Hollywood is full of fake blood and fangs, these Excel errors are very real, and they’re creeping up all around you:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. Not normalizing data',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'With ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://medium.com/grid-spreadsheets-run-the-world/excel-vs-google-sheets-usage-nature-and-numbers-9dfa5d1cadbd'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '800 million',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' users of Microsoft Excel, issues are bound to happen. In fact, research estimates that somewhere around ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://eusprig.org/research-info/research-and-best-practice/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '90% of spreadsheets',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' contain errors. One of the most common of these errors is not normalizing data. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Excel is often relied on for ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://irishtechnews.ie/seven-reasons-why-excel-is-still-used-by-half-a-billion-people-worldwide'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data capture',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', but users often don’t understand just how important it is to only utilize normalized data. Data that is set up incorrectly can introduce errors into formulas, (such as dates being read as numbers, which is what happened when one employee got an ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.wired.co.uk/article/spreadsheet-excel-errors'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'accidental bonus',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' for the pound sterling equivalent of $52,000).',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Merging headers to improve design',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Uh oh! I bet a lot of people at your company are committing this terrifying Excel mistake. (By a lot, we mean ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'everyone',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '.) Merging cells to make nice-looking data headers seems innocent enough, but like my vampire jokes, it really sucks.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Unless you’ve got a very good reason to do so (such as the title of the entire tab), you should avoid merging cells as a means of giving space for a large header. The reason is you can’t easily use the “fill down” formula. Also, it can confuse others as to where the data is supposed to go, and you end up with mis-used or unused columns.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. Using Excel to solve organizational delays',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Another big Excel mistake? Using Excel when you shouldn’t. While there are many valid uses of Excel, there are also plenty of times when an organization should be making better use of software they’re already paying for. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But, employees might utilize Excel to speed up something in the short term, only to create siloed data in the long run. For example, they may not know how to run a complicated calculation in their accounting system, and instead of reaching out to the software’s support team, they download the data and run a formula they learned fifteen years ago. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Or, instead of asking someone from another department to generate a report from a software that department owns, they piece together data from systems they have access to and work with it in Excel.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Relying solely on self-taught formulas',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.accountingweb.co.uk/business/financial-reporting/worlds-largest-weed-business-makes-blazing-spreadsheet-error'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'spreadsheet error',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' caused Canopy Growth, a cannabis research and development company, to massively underreport its losses for the final quarter of 2018. The quarterly losses posted weren’t $50 million, but rather should have been stated as $114 million. Since their revenue shot up so quickly that year, it wasn’t that big of a loss difference for the highly profitable company, but it did cause its stock to drop 2% after the mistake was announced.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It all came down to a formula error. Unsurprisingly, formula mistakes are pretty common. This is likely because the vast majority of Excel users are self-taught. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To mitigate this, identify the important spreadsheet formulas used in your organization and have an expert train employees in proper calculations.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. Leaving cells out of sums (a common Excel error)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This Excel mistake is so simple and obvious, you might assume that you would never commit it. But because we have full confidence in ourselves to not leave certain cells out of sums and calculations, we’re that much more vulnerable to this beginner-status mistake. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This error frequently happens when another row is added to an existing sum formula, so when adding rows, just remember to double check the sum calculation to make sure your new data is included. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '(Boo!) Don’t pretend your organization is immune to this scary mistake. After all, some Harvard professors committed ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://blogs.oracle.com/smb/10-of-the-costliest-spreadsheet-boo-boos-in-history'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this exact same mistake',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and miscalculated their prediction for how bad economies shrink when their country’s debt reaches 90% of GDR. So, go check your important spreadsheets for this problem.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '6. Adding blank rows to make the spreadsheet easier to read',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In Word documents, it’s common to add extra whitespace between one section or another, or to even put in a page break. However, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.kinetics.co.nz/9-common-excel-mistakes/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this doesn’t translate well in Excel',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You should avoid the temptation to use blank rows as a way to enhance readability and design. Why? Doing so can affect your formulas and cause another error in your Excel spreadsheet. Depending on the functions utilized, the blank rows could be treated as data. Autofill and certain formulas will simply stop at a blank row, which means your Excel spreadsheet won’t turn out as you expected and your work will take longer than it should, as you’ll need to make manual corrections.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Instead of blank rows, make sure that everyone in your company is trained in using Excel formatting, such as fill color, borders, and font size.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '7. Not using data validation for templates and shared files',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data validation is critical to make sure that everyone who touches an Excel spreadsheet is putting the right types of data in the right places. With data validation, you can’t enter a whole number in a cell that is supposed to have a time input. Similarly, you can’t put time data where there should be a decimal. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Remember the accidental $52,000 employee bonus we mentioned in mistake #1? That likely wouldn’t have happened if the data had been ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-normalization-manual-vs-automatic'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'normalized',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' after the fact, or (better yet), if the spreadsheet had data validation for critical cells, to ensure that only numbers in the right format were entered. For example, that number would have been added as a date, and would not later have been interpreted as a dollar amount. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When you create a file explicitly for your own use, you trust yourself to put the right type of data in the right place. But what if a year later, you forget the type of data that’s supposed to be in a certain cell? It’s wise to use data validation even for spreadsheets you don’t expect to share. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "While you can't fix everything that goes bump in the night, you ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'can',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' fix these Excel errors with better training. So get to it!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'And for seamless XLS imports that developers and customers love, check out ',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    },
                    {
                      type: 'bold'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4fM3xG6h80Hl5ssEWsj9Nw',
                type: 'Entry',
                createdAt: '2023-07-25T00:33:59.649Z',
                updatedAt: '2024-07-31T03:35:48.717Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 28,
                revision: 6,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Accelerate your business with data',
                text: 'Join a free demo to discover why Flatfile is the fastest way to collect, onboard and migrate data',
                ctaText: 'Save my seat',
                href: 'https://flatfile.com/demo/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '1qBDGCt6Q2OVLAngSJRaBk',
    postTitle: 'How Organized Customer Success Decreases Churn',
    seoTitle: 'Learn How Organized Customer Success Decreases Churn',
    seoUrlSlug: 'organized-customer-success-with-jordan-silverman',
    seoMetaDescription:
      'Jordan Silverman , VP of Customer Success at MarketMan, joins the Customer Success Leader podcast to discuss organized customer success.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-10-27T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3iA6C5l9KA0lKefi4XRRbQ',
        type: 'Asset',
        createdAt: '2021-08-13T16:41:36.175Z',
        updatedAt: '2021-08-13T16:41:36.175Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Jordan Silverman joins the Customer Success Leader podcast',
        description:
          'Jordan Silverman joins the Customer Success Leader podcast',
        file: {
          url: '/img/contentful/3iA6C5l9-nrocycwctow3hrhqkwux.webp',
          details: {
            size: 76617,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'nRoCyCWCTOW3hRhQkwuX',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Jordan Silverman joins the Customer Success Leader podcast',
    summary:
      "Organization. It's critical to customer success in a myriad of ways. Jordan Silverman , VP of Customer Success at MarketMan , joins this episode of Customer Success Leader to discuss the importance of organization in customer success. Plus, we talk about the following: Unique challenges of customer success in the ...",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Organization. It's critical to customer success in a myriad of ways.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Jordan Silverman',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/jordansilverman/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'MarketMan',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.marketman.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', joins this episode of Customer Success Leader to discuss the importance of organization in customer success. Plus, we talk about the following:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Unique challenges of customer success in the hospitality industry',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Entrepreneurial skills that can be transferred to customer success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'The importance of being a good steward of customers’ businesses',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Additionally, learn more about how Jordan's entrepreneur background (fun fact - he started a toilet paper advertising company!) helps guide him in his customer success role. ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '42rnAy6j84HyCxmqYkk8gB',
                type: 'Entry',
                createdAt: '2021-08-13T15:35:21.579Z',
                updatedAt: '2021-08-13T15:35:21.579Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'How Organized Customer Success Decreases Churn w/ Jordan Silverman',
                sounderLink: 'https://embed.sounder.fm/play/102363',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-organized-customer-success-decreases-churn-w-jordan/id1528594709?i=1000496205980',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/N2M2ZjVmNzQtNzkyZS00N2I3LWFlNzQtZTdkNDMxNjVhMThj?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-organized-customer-success-decreases-churn-w-jordan-silverman-78898533',
                spotifyLink:
                  'https://open.spotify.com/episode/1arMF6xGVUurx7fjMM6stW?si=E2LzDo9aR922qVPjoybE5Q&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2Bvi3rRkYLDulKYckfLmxg',
                type: 'Asset',
                createdAt: '2021-08-13T16:50:07.690Z',
                updatedAt: '2021-08-13T16:50:07.690Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Jordan Silverman',
                description: 'Podcast quote from Jordan Silverman',
                file: {
                  url: '/img/contentful/2Bvi3rRk-y6snlo8mtisny1jj9gzo.webp',
                  details: {
                    size: 39945,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'Y6SnlO8MTISnY1JJ9GZO',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '1tayJLAi2aqcYmdlOB9Mr3',
    postTitle:
      'Customs City relies on Flatfile to improve customer data onboarding; Saves customer support team more than 20 hours a week',
    seoTitle: 'Customs City Relies on Flatfile’s Data Importer',
    seoUrlSlug:
      'customs-city-relies-on-flatfiles-data-importer-to-improve-the-customer-data-onboarding-process-while',
    seoMetaDescription:
      'Learn how Customs City uses Flatfile’s data importer to save time during the data onboarding process.',
    category: 'Customer stories',
    tags: ['Case study', 'Logistics', 'Supply chain'],
    publishDate: '2020-10-22T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4XG5OlU4XA6AvGakJsjDrc',
        type: 'Asset',
        createdAt: '2021-08-11T23:49:03.865Z',
        updatedAt: '2022-01-05T12:11:29.941Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: "Customs City uses Flatfile's data importer",
        description: "Customs City uses Flatfile's data importer",
        file: {
          url: '/img/contentful/4XG5OlU4-iloje3ks4ifhy0lsqr9s.webp',
          details: {
            size: 96985,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'ilOJe3kS4ifHY0LsqR9s',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Customs City uses Flatfile's data importer",
    summary:
      'Moving freight from one country to another takes much more than just showing up at the border unannounced. Customs requirements have been tightening for years and the events of 9/11 have complicated the process even further. Customs City Global Solutions simplifies the process by offering trade participants a single platform ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Moving freight from one country to another takes much more than just showing up at the border unannounced. Customs requirements have been tightening for years and the events of 9/11 have complicated the process even further. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.customscity.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Customs City Global Solutions',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '  simplifies the process by offering trade participants a single platform that makes crossing the border seamless, efficient, and cost effective while providing the highest level of customs compliance.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'In this post, we uncover:',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Solving the CSV data import challenges',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Smooth data importing reduces support time',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Moving forward with Flatfile',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Customs City acts as an intermediary by obtaining shipping manifest declaration data from freight forwarders, ocean and air carriers, customs brokers, and exporters and transmitting it to U.S. or Canada Customs authorities.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Information about cargo is now more important than the cargo itself and customs officials need that information before the shipment arrives at the border,” said James May, President of Customs City. “Our software collects all required data at a manifest level and submits it to customs to ensure a smooth border crossing.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“The accelerated growth of eCommerce has resulted in a higher volume of smaller packages” May continued. “Where an ocean container might have shipments for five or 10 customers, today one container might have 20, 30, or 40 thousand small packages. Many of our competitors can’t handle uploading 10,000 rows from an Excel spreadsheet. We’re focused on uploading and processing that kind of volume at a price point that makes sense for our clients.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Solving the CSV data import challenges',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Working with its customers’ agents, many of whom are overseas, Customs City found the best way to obtain the required data for their platform is with CSV files. However, the data within the files needed constant corrections and updates. Customs City wanted an ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '/blog/data-normalization-manual-vs-automatic/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'easier way to validate data',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' before saving it to the database, which would prevent the need for multiple uploads. Their search led them to Flatfile.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“We realized we needed to streamline the process,” said May. “We looked at internal options and other products on the market but soon realized that Flatfile offered the simple out-of-the-box experience we wanted for our clients. We were moving quickly into the eCommerce space and implementing Flatfile’s data importer was  the path to success. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Before Flatfile, Customs City was frequently experiencing ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'upload failures',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' which caused significant delays as it required multiple people in both client operations and IT to solve the issues. Flatfile’s ability to instantly ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '/blog/5-must-have-features-for-a-data-importer/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flag errors across rows of data',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' is a massive time saver for Customs City.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Being able to quickly see data errors and fix them on the spot means we never have to go back to the customer, asking them to fix their files and resend them,” said May. “Having that capability keeps the file transfer process moving along and significantly ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: '/blog/what-is-data-onboarding-everything-you-need-to-know/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'improves the data onboarding',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' process for our customers.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Smooth data importing reduces support time',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Support tickets at Customs City have been considerably reduced as a result of a much smoother data transfer, freeing up internal IT resources for more value-add activity. According to May, implementing Flatfile took only a couple of weeks and Customs City started seeing the benefits immediately. May estimates leveraging the Flatfile data importer has eliminated hours of back and forth effort trying to get a file properly uploaded.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“It could be four or five hours for one client,” said May. “Add that up among a handful of clients and we’re probably saving 20-30 hours of support time per week. Plus the additional time the customer is spending on their end.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Having the Flatfile data importer has also helped Customs City in the sales process. When sales reps show customers the simplicity of the file uploading process, customers are frequently impressed with the modern look and feel that the Flatfile data importer offers. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Moving forward with Flatfile',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Customs City’s platform continues to evolve adding ocean and air freight capability, other eCommerce products for customs brokers and trucking companies, and May looks forward to integrating Flatfile as they grow.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“Everything is coming into our one portal and Flatfile will continue to be a big part of facilitating the  processing, validating, and cleansing of data before it’s inserted into our application and database,” said May. “It has become a key component of our platform and greatly improves our customer onboarding process. We look forward to growing with it.”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Customs City Global Solutions',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Customs City Global Solutions was established out of a combined experience of more than 25 years of helping companies comply with Customs Compliance. We believe that by adopting modern technologies and combining with the knowledge of Customs & Trade we can deliver the optimal solutions for our customers. For more information visit ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.customscity.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'https://www.customscity.com/',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'About Flatfile',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' or get started for free at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flatfile.com.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '4GklTUB14x8u55S2nymQX4',
    postTitle:
      'The Differences Between Account Management and Customer Success',
    seoTitle: 'Differences Between Account Management and Success',
    seoUrlSlug: 'account-management-customer-success-with-bhavika-kochhar',
    seoMetaDescription:
      'Learn how Customer Success and Account Management differ in this Customer Success Leader podcast episode.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-10-20T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2SN2RBjKtZLFchZVT0yGMT',
        type: 'Asset',
        createdAt: '2021-08-13T16:39:13.734Z',
        updatedAt: '2021-08-13T16:39:13.734Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Bhavika Kochhar on Customer Success Leader podcast',
        description: 'Bhavika Kochhar on Customer Success Leader podcast',
        file: {
          url: '/img/contentful/2SN2RBjK-hsoeavkwttgguy8mhqir.webp',
          details: {
            size: 64777,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'HSOeavkWTtGguy8mhQIR',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Bhavika Kochhar on Customer Success Leader podcast',
    summary:
      'If you think customer success and account management are the same things, you’re probably not alone. There are some similarities, however, there are bigger differences that make them very distinguishable jobs. In this episode former Account Manager and iZooto’s current Customer Success Manager, Bhavika Kochhar joins me for a fun ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If you think customer success and account management are the same things, you’re probably not alone.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'There are some similarities, however, there are bigger differences that make them very distinguishable jobs.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode former Account Manager and ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'iZooto’s',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.izooto.com/'
              }
            },
            {
              nodeType: 'text',
              value: ' current Customer Success Manager, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Bhavika Kochhar',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/bhavikak/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' joins me for a fun conversation around the key differences between customer success and account management roles. Additionally we discuss:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to successfully work with customers from other geographies',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to navigate a customer’s unresponsiveness',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Why it’s okay when tech fails us sometimes',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7kdve87RT3JtXhtmrCPUbR',
                type: 'Entry',
                createdAt: '2021-08-13T15:34:14.980Z',
                updatedAt: '2021-08-13T15:34:14.980Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Differences Between Account Management & Customer Success w/ Bhavika Kochhar',
                sounderLink: 'https://embed.sounder.fm/play/102364',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/differences-between-account-management-customer-success/id1528594709?i=1000495379641',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MzRlMWZiNDAtZWI3MC00NWI1LWEzY2EtN2JiYWJiYTY3NmQx?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/differences-between-account-management-customer-success-w-bhavika-kochhar-78712553',
                spotifyLink:
                  'https://open.spotify.com/episode/4TgMiZupVsed8lQkrCVz7J?si=nt2OgUowQsysOEczYpdWQA&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'wohvYmHcFcCdeVAl4dbCN',
                type: 'Asset',
                createdAt: '2021-08-13T16:43:45.757Z',
                updatedAt: '2021-08-13T16:43:45.757Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Bhavika Kochhar',
                description: 'Podcast quote from Bhavika Kochhar',
                file: {
                  url: '/img/contentful/wohvYmHc-7iwklgkjsveqxzuzhdey.webp',
                  details: {
                    size: 37706,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: '7IWKlGkjSveqxzUzhdey',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '2Uz8aFV70vpAt3IdFSNyec',
    postTitle: '7 Customer Success Management Tips from CS Pros',
    seoTitle: '7 Customer Success Management Tips from CS Pros',
    seoUrlSlug: '7-customer-success-management-tips-from-cs-pros',
    seoMetaDescription:
      'Seven customer success tips from customer success managers and leaders who were interviewed on Flatfile’s Customer Success Leader podcast.',
    category: 'Data Onboarding',
    tags: ['Customer success'],
    publishDate: '2020-10-15T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5eT25BAn29dylmRYw3CyZq',
        type: 'Asset',
        createdAt: '2021-08-24T19:42:41.165Z',
        updatedAt: '2021-08-24T19:42:41.165Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Customer success advice from Customer Success Leader podcast',
        description:
          'Customer success advice from Customer Success Leader podcast',
        file: {
          url: '/img/contentful/5eT25BAn-bcotrfvti203yutivhhk.webp',
          details: {
            size: 25329,
            image: {
              width: 1921,
              height: 1081
            }
          },
          fileName: 'bCOTrFVTi203yUTiVhhk',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Customer success advice from Customer Success Leader podcast',
    summary:
      'In an emerging field like customer success, we see new strategies, tools, and best practices constantly pushing their way to the forefront. But some tried and true customer success tips will always work despite trends and changes. We asked seven customer success leaders to share the best advice they’ve ever ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In an emerging field like customer success, we see new strategies, tools, and best practices constantly pushing their way to the forefront. But some tried and true customer success tips will always work despite trends and changes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We asked seven customer success leaders to share the best advice they’ve ever received during their careers in CS. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This advice is pulled directly from our podcast, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/podcast/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Customer Success Leader',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' where we feature top CS industry pros breaking down their best practices, frameworks for success, and more! (If you haven’t tuned in yet, give it a listen!) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Now, let’s dive in to the customer success tips:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Get your customers recognition or a promotion at their company',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Take up a bigger seat at the table at the right time',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Understand how your customers make money',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Know what the customer wants, so they don’t have to',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Focus on progress over perfection—especially in a fast-changing industry like CS',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Measure success for your customers and yourself',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Find a way to stay up to speed with all of the changes in CS',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #1: Get your customers recognition or a promotion at their company',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“My old boss used to say, if you can help somebody get recognition or get promoted then you are going to have a connection for life. What he meant was that if our product can not only help the person but they can get recognition from inside the company, then you’re going to have a deeper relationship for a longer period of time. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Focusing on the relationship aspect has shaped a lot about how I think about CS. It’s all about getting down to the human level. If you’ve helped someone get recognition and they later move onto another company, they’re going to be thinking about you and how your company can help them. Help somebody get promoted or get recognition, and you have that relationship for life.” - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/jeffreybreunsbach/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Jeff Breunsbach',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', Director of Customer Experience at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.higherlogic.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Higher Logic',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/the-customer-may-not-always-be-right-but-they-should-be-first'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'The Customer Should Always Be First',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #2: Take up a bigger seat at the table at the right time',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“In a SaaS business, at a certain time you will reach the point where the flywheel, which is your existing business, is bigger than what the sales team can sell in a single year. When that happens, it’s time for customer success to demand a bigger seat at the table. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Prior to that, sales is generally king. When it flips over, it’s now time for customer success to be a bit more bold than we’ve been and make sure the rest of the organization is onboard with making customers successful.” - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/stacieward/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Stacie Ward',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', VP of Customer Care at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://redcanary.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Red Canary',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/customer-care-in-cybersecurity'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Customer Care in Cybersecurity',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #3: Understand how your customers make money',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "“You need to understand how your customers make money. If I know how you make money then it helps me to understand how I can better help you. If I don’t, I’m only focused on my product and its usage versus the utility that you’re going to gain. The utility is different, even if it's by a little for each business and definitely for each industry. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“If you don’t know how your clients make money, you’re never going to truly serve them or help them as much as you could. You’re not going to have a global picture of what that contact is going through or what that end user is going through because you’re not going to understand it. So you have to know how they make money, and then you can really customize their experience.” - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://skaled.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Skaled Consulting',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' CEO, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/jakedunlap/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Jake Dunlap',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/how-sales-customer-success-make-power-users'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'How Sales and Customer Success Make Power Users',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #4: Know what the customer wants, so they don’t have to',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I love Steve Jobs. He was really inspirational. He said simple but powerful things, like ‘It’s not the customer’s job to know what they want.’ I think about the Ritz Carlton, and they have a similar saying which is, ‘Know what the customer wants before they know they want it.’ ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“If you can help the customer and know them well enough that you can understand what they need before they even know they need it, then you’ve got a strong relationship. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Relationships, relationships, relationships. Everything you do is about relationships. If you’re going into customer success you need to be driven and self motivated but also know how to drive a relationship.” - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/saralauer/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Sara Lauer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', Senior Director of Customer Success at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.reflexisinc.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Reflexis Systems',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/decrease-churn-how-to-shore-up-relationships'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Decrease Churn: How to Shore Up Relationships',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #5: Focus on progress over perfection—especially in a fast-changing industry like CS',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I’m a perfectionist and have a very Type A personality. I don’t want to do anything unless it feels like it’s going to be wildly successful. One of the things I was told early on by a colleague was that it’s more important to have progress over perfection. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“This is especially true in a hyper changing industry like customer success. It’s still new. It’s still changing. Every day there’s somebody coining something or changing something. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Making progress over perfection was the best advice ever received. That has just stuck with me, encouraged me, and challenged me to fail fast, and pivot fast but I’ve also been much more successful scaling and executing in my roles as a result." - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/kristiserrano/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Kristi Faltorusso',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' Vice President of Customer Success at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://intellishift.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'IntelliShift ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/the-ambassadors-of-change-management'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Customer Success: The Ambassadors of Change Management',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #6: Measure success for your customers and yourself',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“As a customer success professional, our job is to define and measure success for our customers. But we need to be doing that ourselves as an organization and as individuals. In the same way we’re tracking things for our customers, we want to make sure that we have well-defined criteria for our own internal organization for our own career trajectory. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We need to be measuring these goals, and once they’re achieved, look for the next target condition or next milestone of success and plan how we’re going to get there and how we’re going to measure it.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It’s important to really take that model of measuring and achieving success for our customers and apply it across the board.” - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/stephen-hueber-80104241/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Steve Hueber',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', Customer Experience Strategist at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.genesys.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Genesys',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/building-and-measuring-a-customer-success-program'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Building and Measuring a Customer Success Program',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Customer success tip #7: Find a way to stay up to speed with all of the changes in CS',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“You need a fast way to stay informed. At Nuffsaid we’ve interviewed dozens of customer success leaders who have consistently said that one of the missing parts of their daily workflows is not having access to curated content that they can scan on a weekly basis to know what’s going on in the industry. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We took that feedback, we heard it and generated a newsletter that not only finds and curates the top content from the space but also includes notes from an interview that we’ve done recently with a top leader. And that’s all easy to scan in your inbox every week.” - ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/chrishicken/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Chris Hicken',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', the CEO of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.nuffsaid.com/#main'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '‘Nuffsaid',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Check out the Customer Success Leader podcast episode, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/how-to-generate-a-360-degree-view-of-your-customer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'How to Generate a 360-Degree View of Your Customer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These customer success tips can turn you into a true CS pro. Stay up to speed with the industry, focus on progress over perfection, help your organization see the value of CS, and do whatever you can to get your customers results and internal recognition. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'If you want to take the conversation deeper and uplevel your approach to customer success, tune in and subscribe to the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/podcast/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Customer Success Leader podcast.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '64SAleK6AZwRMMP97B9ERl',
    postTitle: 'Start Involving Customer Success in Sales',
    seoTitle: 'Start Involving Customer Success in Sales',
    seoUrlSlug: 'customer-success-in-sales-with-josh-fedie',
    seoMetaDescription:
      'Learn more about customer success in sales featuring Josh Fedie in this episode of the Customer Success Leader podcast.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-10-13T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1H4tewGNOFzHTaWOImcMYO',
        type: 'Asset',
        createdAt: '2021-08-13T18:38:31.853Z',
        updatedAt: '2021-08-13T18:38:31.853Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: "Josh Fedie on Flatfile's Customer Success Leader podcast",
        description: "Josh Fedie on Flatfile's Customer Success Leader podcast",
        file: {
          url: '/img/contentful/1H4tewGN-huawukpotueyt3vr0adp.webp',
          details: {
            size: 72208,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'hUAwUkpOTUeyT3Vr0aDP',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      "Josh Fedie on Flatfile's Customer Success Leader podcast",
    summary:
      'Have you ever been to a party with a friend who doesn’t introduce you to anyone? So you just stand there awkwardly and count the seconds before you can leave. It’s a less than desirable experience, right? Why do we make customers go through it then? Josh Fedie , the ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Have you ever been to a party with a friend who doesn’t introduce you to anyone? So you just stand there awkwardly and count the seconds before you can leave. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'It’s a less than desirable experience, right? Why do we make customers go through it then?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Josh Fedie',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/joshfedie/'
              }
            },
            {
              nodeType: 'text',
              value: ', the founder of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'SalesReach.io',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.salesreach.io/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', joined me on the Customer Success Leader podcast to help resolve the awkwardness that is traditional sales handoffs. Additionally, we talked about: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to mitigate buyer’s remorse for new customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why sales should be involved after the initial sale',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What B2B customer success can learn from B2C',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67kqzxqJQvELDKigEQpRRT',
                type: 'Entry',
                createdAt: '2021-08-12T17:19:51.034Z',
                updatedAt: '2021-08-12T17:42:16.892Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Start Involving Customer Success in Sales w/ Josh Fedie',
                sounderLink: 'https://embed.sounder.fm/play/102365',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/start-involving-customer-success-in-sales-w-josh-fedie/id1528594709?i=1000494558472',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/MzY3OTE4YTAtMDY5Yi00NDYwLTkwZGQtMzk1Njk5ZjlhM2E5?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/start-involving-customer-success-in-sales-w-josh-fedie-78527576',
                spotifyLink:
                  'https://open.spotify.com/episode/4tZeg59LUECGI7nnBQBffS?si=bmEusgZXSH-Yyutq_dMAWQ&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7i3gMcqcJQBeS558GizyR0',
                type: 'Asset',
                createdAt: '2021-08-13T18:39:37.211Z',
                updatedAt: '2021-08-13T18:39:37.211Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Josh Freddie',
                description: 'Podcast quote from Josh Freddie',
                file: {
                  url: '/img/contentful/7i3gMcqc-clecryxfqywpjg6tnier.webp',
                  details: {
                    size: 40635,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'cLEcRYxFQYWPJG6TnIEr',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'BONUS - Check out Josh’s show, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'The Buyer Enablement Podcast',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy8xM2VkN2Y5OC9wb2RjYXN0L3Jzcw=='
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '33027NQII023DMnTGpoGh6',
    postTitle:
      'What is customer onboarding? Defining the customer onboarding process',
    seoTitle: 'What is customer onboarding?',
    seoUrlSlug: 'what-is-customer-onboarding',
    seoMetaDescription:
      'Learn more about the customer onboarding process, including various customer onboarding elements and metrics.',
    category: 'Data exchange',
    tags: ['Customer onboarding', 'Customer onboarding process'],
    publishDate: '2020-10-11T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3wwTUNvlPx33o712IQA4vh',
        type: 'Asset',
        createdAt: '2021-08-13T21:56:19.132Z',
        updatedAt: '2021-08-13T21:56:19.132Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Customer onboarding process definition',
        description: 'Customer onboarding process definition',
        file: {
          url: '/img/contentful/3wwTUNvl-ohzryssvszexbixossxq.webp',
          details: {
            size: 1142630,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'ohZrYssvSzexBIxoSsxQ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Customer onboarding process definition',
    summary:
      'We’ve all heard the phrase, “You never get a second chance to make a good first impression.” This is true for just about every human interaction, and the rule is no different for your newly-acquired customer. The first few hours, days, and weeks of customer onboarding are critical to your ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'We’ve all heard the phrase, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '“You never get a second chance to make a good first impression.”',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is true for just about every human interaction, and the rule is no different for your newly-acquired customer. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The first few hours, days, and weeks of customer onboarding are ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'critical',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' to your customer’s success and experience with your product and service. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Sure, they’ve probably seen your website, chatted or emailed with someone from your team, and spoken with a sales rep to get signed up. (And hopefully, those resources made a good first impression, too!) But ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'customer onboarding lays the groundwork for how they’ll feel about your product or service going forward. ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Failure to onboard your customers quickly, effectively, and smoothly can lower NPS scores, decrease customer lifetime value, and skyrocket churn.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Let’s dive a little deeper into customer onboarding, the elements of a successful customer onboarding process, and how to make sure ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'you ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'make a good first impression with your new customer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'What is customer onboarding? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding is the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.entrepreneur.com/article/274848'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'make-or-break moment',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that introduces your new customers to your product or service. CSMs (Customer Success Manager) have the important task of building and maintaining a strong relationship, making sure the customer has everything they need to be successful with their new tool, and quickly sees value in what they purchased (the “aha!” moment). ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The onboarding process must feel seamless. If at any point your new customer feels overwhelmed, confused, or has to jump through hoops to see success...you’re gonna have a bad time. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A customer who’s not properly onboarded might never use your tool to its fullest potential, and likely won’t renew 12 months down the road.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'How does customer onboarding work? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'So your team has acquired a new customer - Great! But as we all know, customer acquisition is only a part of the customer journey. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Now the customer or client onboarding process begins. And it’s just as important (if not MORE important) than getting new business.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The customer onboarding workflow can happen in a number of different ways. Many teams go with automated onboarding emails, which could be somewhat effective if segmented based on usage, persona, team size, product, etc. But personal one-on-one touches are the most effective, through personal email exchange, phone calls, or virtual meetings. When you have their undivided attention, they’re more likely to see value and continue using it. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'When you can’t meet one-to-one, many customer success managers take advantage of existing resources to help their customer get onboarded. Content like training videos, FAQs, case studies, testimonials, or any other information to help them be successful. (Here’s a list of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/28-onboarding-tools-for-delighting-new-users/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: '28 Onboarding Tools for Delighting New Users',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A solid customer onboarding program leads to more success down the road, smoother quarterly business review meetings (QBRs), and a higher likelihood of retention.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding vs. user onboarding',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Before we go any further, let’s examine the difference between customer onboarding and user onboarding. These two ideas may sound similar, but there’s one important difference to keep in mind. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding is focused on making sure the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'purchaser(s) ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'of your product sees value so they’re more likely to upgrade and renew. Your customer has higher expectations that your product will solve their specific business problem in exchange for money.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'User onboarding is aimed to help ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'end users or future customers ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'use your product to successfully solve their problems. New users are typically more flexible since they have less skin in the game, but should not be forgotten about.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '6 key elements of the customer onboarding process',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There are the technical basics of SaaS onboarding, like completing a user profile, how to view dashboards, etc. and these very first steps are important for the overall customer onboarding process. But there’s more to it than just showing them what buttons to push. Here are some ways to provide the best customer onboarding experience possible. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. Build trust',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The first step to creating a positive customer experience is to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'build trust ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'with your customer. Your expertise and know-how mean nothing if they don’t feel like you’re an honest, trustworthy person that’s there to help. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Use personal touches that show your new user they’re more than just a number. Make this a priority in your client onboarding flow. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Listen. Listen. Listen. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Every customer has different struggles, pain points, and goals. It’s your job to listen to what your customer is trying to solve and help them see how using your product can help. Be sure that you understand your customer’s definition of “success” from the very beginning so you know what to deliver on.  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Remember: Company and Org goals can change quickly. Make sure you can react accordingly to continue building trust and showing value.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. Get them to “Aha!”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'In the SaaS world of CS and onboarding, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://userpilot.com/blog/the-aha-moment-for-product-onboarding-activation/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'the “aha!” moment',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is the second your customer realizes and understands the true value of your product. A lightbulb goes off in their mind where they’ve made a connection between the reason they purchased and the expected outcome actually taking place. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The quicker your customer can get to the “Aha!” moment, the better.   ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How can you find your “Aha!” moment? You can start by speaking with existing customers, and seeing what made them continue using your product (though, as listed above, not every customer’s experience is the same, and should be personalized for each customer’s goals).  ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Help them build a habit',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once your product “clicks” with your customer, you have to make sure they continue using it and seeing success with your product. And the best way to do that is to help them develop a habit of using it. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Offer a roadmap and a process to success',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '. When your customer can see the journey with specific milestones in order to be successful, it’s easier for them to develop a habit of use. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Just like going to the gym every morning, it takes time and consistency to keep at something until it becomes second nature. Same goes for your product’s onboarding journey. You want to be their “personal trainer” that motivates your customer to keep coming back. Show them how your product is already starting to help them get six-pack abs, and they’ll keep doing crunches, so to speak.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '5. Provide consistent motivators and reminders ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The name of the game here is “surprise and delight”. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you go out of your way to offer a helpful reminder they’re not expecting, that shows that you’re thinking of them and showing value even outside of planned meetings and communication. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Giving your customer a little extra push at the right time can go a long way. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'And, of course, be as responsive as possible when they reach out to you for help. If you can’t solve the problem, get them in touch with someone who can. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '6. Consider their existing workflows and data',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Chances are, your product or service won’t end up replacing everything your customer uses. It’s probably another tool in their toolbelt. So ask yourself: Does your product play nicely with the tools, workflow, and data that’s already in place? ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For adoption to take place, introducing your product has to be seamless. Decision-makers could feel concerned about migration, and that’s not a great first impression to make after the sale. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'This is why ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'customer data onboarding',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' is so important. Your customer’s data needs to migrate to your product quickly and easily, but that data could still be housed by a previous vendor, offline spreadsheets, activity logs, etc. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you can onboard your customer’s data quickly without frustration, you’ll decrease time to value, reduce your churn rate, and get to the “aha!” moment faster. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Don’t have the time, resources, or know-how to onboard customer data? We get that, a lot of customer success teams don’t know how or where to start. Especially if your organization doesn’t have the luxury of having a dedicated Customer Onboarding Specialist. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'That’s why we created ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: "Flatfile's data onboarding platform",
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' - a collaborative, secure workspace for data onboarding that helps companies speed up every part of data migration, from data submission to cleaning.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '25gVxnobRnOZ1Ssg7WHpub',
                type: 'Entry',
                createdAt: '2021-08-13T21:53:47.725Z',
                updatedAt: '2024-07-30T23:58:59.586Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 44,
                revision: 8,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Evaluating Flatfile for your business needs?',
                text: 'Reach out to our experts today to scope your data conversion, onboarding and migration processes',
                ctaText: "Let's talk",
                href: '/contact-sales/consult/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4 customer onboarding metrics to track',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It may feel like you’ve onboarded your customer, provided value, and built a strong relationship. But how do you ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'know?',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here are a few customer onboarding metrics to measure during the client onboarding process to achieve long term success. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '1. Activation',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Neil Patel describes ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://neilpatel.com/blog/doubling-your-activation-rate/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'activation',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' as “a measure of how many users take a specific action to get value out of a product.” For example, with Twitter, that action might be following six other accounts, or sending two tweets. Get a good grasp on which actions need to take place in order for them to find value. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '2. Progress',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As you lay out a system and a process for your customer, keep track of how quickly they’re able to progress through these milestones. Make note of any roadblocks or hurdles your customers consistently come to. Then, make moves on making those steps easier to accomplish. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '3. Adoption',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is a big one. And there are many ways to measure and calculate your product adoption rate. Daily Active Users (DAU) and Monthly Active Users (MAU) show how many users are on your platform on a daily/monthly basis. Keeping track of this data will show trends into how valuable your tool is to your customer, and should help you identify triggers to get them back in and using it. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '4. Retention',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Of course, we wish customers would stick around forever (wouldn’t that be nice). But in reality, churn is a statistic that all CSMs must track and be held accountable for. If you have a high retention rate, you probably have a good grasp of onboarding your customers successfully so they see value and stay your customer. On the flip side, if churn is an issue, you might want to revisit your customer onboarding strategy.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'It’s true. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You only get one chance at making a good first impression. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But if you lead with value, build and maintain a strong relationship, and make migration a priority, your customer onboarding process can be top-notch.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '4gUFtzax0cnB5MSHaR6wgl',
    postTitle: 'Empowering Entrepreneurs Takes Educational Content',
    seoTitle: 'Empowering Entrepreneurs Takes Educational Content',
    seoUrlSlug: 'empowering-entrepreneurs-takes-educational-content',
    seoMetaDescription:
      'Head of Customer Success Lynne Zagami joins the Customer Success Leader podcast to discuss empowering entrepreneurs and more.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-10-06T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3xMQbDHpLkk7fldvzIP7Rp',
        type: 'Asset',
        createdAt: '2021-08-13T18:43:56.768Z',
        updatedAt: '2021-08-13T18:43:56.768Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Head of Customer Success Lynne Zagami',
        description: 'Head of Customer Success Lynne Zagami',
        file: {
          url: '/img/contentful/3xMQbDHp-rcaenyw8r9acwf7vjbap.webp',
          details: {
            size: 74579,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'RcAENyw8R9aCWf7vjbap',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Head of Customer Success Lynne Zagami',
    summary:
      'Being in and around a startup can be a stressful place, especially when you’re trying to land investors. Automation helps complete repeatable tasks in these kinds of situations. However, there are areas where a founder needs more specialized content and assistance. Lynne Zagami, a former lawyer and Head of ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Being in and around a startup can be a stressful place, especially when you’re trying to land investors. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Automation helps complete repeatable tasks in these kinds of situations. However, there are areas where a founder needs more specialized content and assistance.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Lynne Zagami',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/lynnezagami/'
              }
            },
            {
              nodeType: 'text',
              value: ', a former lawyer and Head of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Shoobx',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.shoobx.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', joined me to chat about empowering entrepreneurs through educational content. Tune in to hear a discussion around: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How relationship management skills have helped Lynne shift from law to customer success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The importance of having a responsive culture',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to manage great customer success without causing burnout',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why you should be answering client questions before they’re even asked',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4snHgZrI3tMNepq5fKcDbv',
                type: 'Entry',
                createdAt: '2021-08-13T15:32:52.490Z',
                updatedAt: '2021-08-13T15:32:52.490Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Empowering Entrepreneurs Takes Educational Content w/ Lynne Zagami',
                sounderLink: 'https://embed.sounder.fm/play/102366',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/empowering-entrepreneurs-takes-educational-content/id1528594709?i=1000493748831',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/Yjk3MTUwN2YtNDBkZC00OGMxLWE4MjEtMzViNTZiNWY2ZDk1?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/empowering-entrepreneurs-takes-educational-content-w-lynne-zagami-78347421',
                spotifyLink:
                  'https://open.spotify.com/episode/6mdgcM7Z1YocdyIy5AIwuS?si=Ktcpdc56REOMrjw_URPo9Q&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7Moit4gXV5KHAUTx6fqGkY',
                type: 'Asset',
                createdAt: '2021-08-13T18:45:06.277Z',
                updatedAt: '2021-08-13T18:45:06.277Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Lynne Zagami',
                description: 'Podcast quote from Lynne Zagami',
                file: {
                  url: '/img/contentful/7Moit4gX-yjobahdrkmopw64dqodq.webp',
                  details: {
                    size: 42990,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: 'YjoBaHDRkmoPW64DQoDQ',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '1DheMqOGZbhK714IAItXVm',
    postTitle:
      'The danger zone: Losing clients in the customer onboarding process',
    seoTitle: 'Losing Clients in the Customer Onboarding Process',
    seoUrlSlug:
      'the-danger-zone-losing-clients-in-the-customer-onboarding-stage',
    seoMetaDescription:
      'It’s critically important for those in customer success to manage the transition from the signing of the deal to the start of operations. Here are the data onboarding challenges to avoid.',
    category: 'Data exchange',
    tags: ['Customer onboarding', 'Customer onboarding process'],
    publishDate: '2020-10-05T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3p1c9Fzo8w7NmL87WjcLqL',
        type: 'Asset',
        createdAt: '2021-08-13T22:00:23.856Z',
        updatedAt: '2021-08-13T22:00:23.856Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'customer onboarding process',
        description: 'customer onboarding process',
        file: {
          url: '/img/contentful/3p1c9Fzo-445vfnk1tbar2d5brbkj.webp',
          details: {
            size: 166353,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: '445VFNK1Tbar2d5BrbkJ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'customer onboarding process',
    summary:
      'The scenario is a familiar one. The sales teams exuberantly announce the closing of another client. Ringing bells, celebratory balloons, shouts of joy. Everything but the fireworks. Meanwhile the Operations team is hunkered down in a corner, skeptically looking over the scene. They exchange the usual questions among themselves. What ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The scenario is a familiar one. The sales teams exuberantly announce the closing of another client. Ringing bells, celebratory balloons, shouts of joy. Everything but the fireworks.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Meanwhile the Operations team is hunkered down in a corner, skeptically looking over the scene. They exchange the usual questions among themselves. What did sales promise this time? When did they promise go-live? Are we going to be able to deliver on what the new client expects?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It’s critically important for those in customer success to manage the transition from the signing of the deal to the start of successful operations. Call that time period business integration, customer onboarding, or customer set up and training. There is another name for it: The Danger Zone -- the delicate time when you can lose a customer before they even really begin using your product or service. It’s a time when, if the process isn’t handled properly, the customer may decide the pain of onboarding isn’t worth the promise of the sales pitch. ',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'According to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.kickstartall.com/what-is-orchestrated-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'a ',
                  marks: [],
                  data: {}
                },
                {
                  nodeType: 'text',
                  value: 'McKinsey study',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', poor onboarding, engagement, and customer service make up 52 percent of the reasons customers leave in the first 90 days. There are a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/high-cost-not-addressing-csv-excel-file-based-import-problems/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'number of issues',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' that can cause clients to churn during the customer onboarding process, costing you a new customer and the revenue stream that comes with it. Let’s explore the issues further.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding failure: Poor sales to ops handoff',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Customer onboarding is a critical early stage in the overall customer experience, and customer success teams -- the group often tasked with bridging the gap between sales and ops -- needs to deliver flawless onboarding to ensure a healthy, long-term relationship.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Step one is making sure that the customer success team fully understands the scope of the deal and the customer expectations that come with it.  Without that critical understanding, the client can be bombarded with questions and concerns that have already been discussed with the sales team. This can lead to client frustration that plants the seeds of doubt and can even have them asking, “Does this company really understand my business?”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding failure: Lack of communication',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once the deal is signed, the customer is as excited as the sales rep to begin working with your company and leveraging the promised advantages of your product or services. Each step of the customer onboarding process must be mapped out with clear target dates and every department should be committed to adhering to that schedule.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'If the onboarding process ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'begins to go sideways',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and key milestone dates get missed, the client is again going to begin questioning their decision to sign on with your company. Their thought: if you can’t meet dates when we are in the “honeymoon” stage, what is the relationship and performance going to be like once we go live?”',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The customer onboarding process is a time when you should be over-communicating since this is a time that sets the tone of the overall customer experience. In the old days of car buying, you’d receive a full-court press from the sales rep and sales manager in an effort to purchase one of their automobiles. Once you signed and then drove off the lot, you’d be hard pressed to ever be able to contact that rep again. Fortunately, times have changed as even car dealers now recognize the lifetime value of a customer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Your organization needs to have a similar mindset as customers go through the onboarding process. During the honeymoon phase, your team needs to be as proactive as possible to ensure everything goes smoothly. The customer should know the proper contact person at every stage and be aware of what to expect next as part of their overall experience.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The sales rep was likely diligent in staying in touch with the prospect and lavished constant attention in an effort to close the deal. Your customer success team must be just as conscientious with its attentiveness as they guide the customer from signing the deal to operational execution. Nothing could sink the deal faster than long gaps of silence, leaving the customer wondering where they are in the process and feeling the pangs of abandonment. Again this can lead them to a dangerous conclusion that they made a mistake in choosing your company’s product or service.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding failure: Data onboarding challenges',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the more overlooked steps in customer onboarding is the data onboarding process. Customer success teams are asked to deliver a flawless onboarding experience but, onboarding can’t move forward without customer data. Customers often can’t use or get value from your product or service if their data doesn’t get migrated properly. They can’t set up marketing automation without their leads. They can’t sell ecommerce products without SKUs. They can’t run payroll without accurate employee profiles.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Everyone involved in the customer onboarding process is aware of the need to get to go-live quickly, but helping your customer migrate tons of data into your systems can be a significant barrier to getting started. Discovery Garden, a company dedicated to preserving cultural and mission critical digital content, sometimes spends up to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'three months',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' mapping and uploading files during an onboarding process.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Data onboarding during the customer onboarding process is about bringing all of the customers’ required data over to a new software product in order to successfully use that new purchase. This customer data might be sourced from a previous software vendor as well as offline data sources such as spreadsheets, employee or patient files, and activity logs. In some traditional industries such as healthcare and manufacturing, customer data is very likely to come from manual sources like logs, not just other software vendors.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'To accelerate the data onboarding process, many companies leverage the use of a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'data exchange platform',
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', such as Flatfile. An advanced data onboarding platform ensures secure data transmission, establishes approval workflows, sets up data validation, and doesn’t require intervention from engineers to be used.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'is a collaborative, secure workspace for data onboarding that helps companies speed up every part of data migration, from data submission to cleaning. The Flatfile ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Complete Guide: Customer Data Onboarding for Enterprise',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'provides a comprehensive roadmap for streamlining the data import process during onboarding to ensure a successful data onboarding experience.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1dcPph7WtJ9siB2Re8LGtS',
                type: 'Asset',
                createdAt: '2021-08-13T21:59:04.431Z',
                updatedAt: '2021-08-13T21:59:04.431Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile concierge animated demo',
                description: 'Flatfile concierge animated demo',
                file: {
                  url: '/assets/contentful/1dcPph7W-H69SINGAS2O9ES7vYOTX',
                  details: {
                    size: 42242299,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'H69SINGAS2O9ES7vYOTX',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customer onboarding failure: Lack of training',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'No doubt your sales rep was effusive in his praise of your product or service and even more so when it came to the tools you provide to interact during and after go-live. However, failing to train members of your new customer on how to use those tools can be another source of enormous frustration. And that frustration can grow stronger as the customer approaches the go-live date and realizes that the key players who are going to be interacting with your company every day still do not know how to use your tools. Most experts say a lack of training during the onboarding process leads to a significant churn rate during the first 90 days of an engagement with a new customer. In ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: "https://www.wyzowl.com/customer-onboarding-statistics/#:~:text=Over%2090%25%20of%20customers%20feel,them%20after%20they've%20bought."
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'one survey',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', nearly nine of 10 respondents said they’d be more likely to stay loyal to a business that invests in onboarding content that welcomes and educates them after they’ve bought.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You should never squander the relationship-building opportunities that come during the training phase in the pre-go-live stage. During the sales process, your rep most likely dealt with a buyer or senior executive as they hammered out the deal. But the people “on the ground” on the customer side were probably left largely in the dark. The training period during customer onboarding is a perfect way not only to teach hands-on members of the new customer how to use the tools you offer, but to also begin to build relationships and establish critical touch points between your company and theirs. These are the people who could make or break the relationship between the two companies, and they are the ones you want defending you should buyers or management begin to discuss severing the relationship.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The old cliché that you only get one chance to make a good first impression still holds true, especially when you’re talking about customer onboarding. You’ve worked hard to find, pitch, and land your new customer. You should be working equally as hard to make sure you get them to go-live as quickly and smoothly as possible. Avoid the danger zone!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '7fAsgcCFVzH3j7gNl587Bt',
    postTitle: 'Data importer security: What companies should pay attention to',
    seoTitle: 'Data Importer Security: What Companies Need to Know',
    seoUrlSlug: 'data-importer-security-what-companies-should-pay-attention-to',
    seoMetaDescription:
      'When evaluating security criteria for a data importer, learn what your team should include on their security checklist.',
    category: 'Security & compliance',
    tags: ['Compliance', 'Data security', 'Featured'],
    sortOrder: '2',
    publishDate: '2020-10-01T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1uh0H8qJhJ3YglzKf1Vmpa',
        type: 'Asset',
        createdAt: '2021-08-13T22:04:57.308Z',
        updatedAt: '2022-01-05T12:13:21.255Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: "Flatfile's Data Importer security",
        description: "Flatfile's Data Importer security",
        file: {
          url: '/img/contentful/1uh0H8qJ-dbpq43as9sljzshaujw1.webp',
          details: {
            size: 70685,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'dBPQ43aS9SlJzShAuJw1',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Flatfile's Data Importer security",
    summary:
      'As if a global pandemic wasn’t scary enough, the FBI’s IC3 (Internet Crime Complaint Center) reported a 300% increase in cybercrime since the Covid pandemic began. While companies know the importance of prioritizing data security, data breaches unfortunately continue to make headlines. As businesses evaluate the technology vendors who will ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6HyhnlBCcEW8EAoyhqK0bt',
        type: 'Entry',
        createdAt: '2021-08-13T22:04:10.382Z',
        updatedAt: '2021-10-07T00:26:23.672Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sam Currie',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6zguQOfKAidYrjV5H7r8Rr',
            type: 'Asset',
            createdAt: '2021-08-13T22:03:07.217Z',
            updatedAt: '2021-08-13T22:03:07.217Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sam Currie headshot',
            description: 'Sam Currie headshot',
            file: {
              url: '/img/contentful/6zguQOfK-kqellu8tzw8wwipizgig.webp',
              details: {
                size: 60023,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'KQELLu8TzW8wWipIzGIg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Staff Engineer',
        department: 'Engineering'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As if a global pandemic wasn’t scary enough, the FBI’s IC3 (Internet Crime Complaint Center) reported a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.imcgrupo.com/covid-19-news-fbi-reports-300-increase-in-reported-cybercrimes/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: '300% increase',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' in cybercrime since the Covid pandemic began. While companies know the importance of prioritizing data security, data breaches unfortunately continue to make headlines. As businesses evaluate the technology vendors who will handle their data (or in ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                's case their customer’s data) what should they be looking for? And what criteria should be included on the initial checklist for a data processor? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'Data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' solutions like Flatfile fall into the data processor category so in this post we’ll be addressing data processor security. What’s a data processor? By definition, a data processor obtains, holds and processes data. Data processors usually process personal data, e.g., email addresses, social security numbers, phone numbers, etc. Due to the sensitive nature of personal data, there are strict legal obligations for data processors to follow or else some serious fines can be applied. There is often confusion in the area of data processor versus data controller. According to Article 4 of the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://advisera.com/eugdpracademy/gdpr/definitions/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'EU GDPR',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " (General Data Protection Regulation), a data controller is the entity (person, organization, etc.) that determines the why and the how for processing personal data. A data processor, on the other hand, is the entity that actually performs the data processing on the controller's behalf.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Laws such as the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://oag.ca.gov/privacy/ccpa'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'California Consumer Privacy Act',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' have been enacted to enhance data privacy for consumers and many other states have followed suit to ensure consumers: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Know what personal data is being collected about them ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Can access their personal data ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Know whether their personal data is being sold and to whom',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Can request a business delete any personal information about a consumer collected from that consumer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Not be discriminated against for exercising their privacy rights',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Can say no to the sale of personal data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Below we’ll dive into the necessary data security criteria you should pay attention to while reviewing a data processor and more specifically, a data importer. This is by no means an exhaustive list and depending on the industry and the type of data, companies will have various requirements in how they use a data importer but here are key areas to start as you review a vendor. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '1. Assess the risk:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' When researching the vendor you’re considering, take a look at the company’s history when it comes to data breaches. Have they had any? Has there been a breach and more importantly, how did they respond to and resolve the situation? This will help you better understand whether a company will take your data seriously. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '2. The technical basics:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' There are certain basics that should be covered by the vendor such as data encryption. Does the company encrypt data both at rest and in transit?  This is standard nowadays. In addition, application and network logging as well as access control to servers, cloud vendors, source control are all part of the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'basics',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' which should be easily covered by your vendor. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '3. A data security culture:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " It’s one thing to cover the technical basics of data security because it’s fairly straightforward. But when it comes to security breaches or incidents that have occured at a company, it typically involves a person and an error in judgement; which could be accidental or intentional and malicious. More commonly however, it is simply someone who isn't thinking and forwards an email with their credentials or uses the same simple password. While it’s a lot harder to evaluate, it’s important to understand the HR and people policies surrounding data security for the company you’re evaluating. Does the vendor have very clearly delineated policies that employees understand and put into practice? These people policies frequently get overlooked but if a vendor has data security embedded in their culture, that’s not only pretty rare (unfortunately) but impressive and a huge advantage for the vendor. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '4. Compliance certifications: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                "While some may feel that compliance certifications simply look like check marks on a vendor’s website, it’s crucial to see that the vendor is aware of their compliance obligations and is meeting them. Additionally it's important to understand what certifications they currently have and what certifications they are actively pursuing in an ongoing effort to keep customer data secure. This shows that the vendor is consistently working to become a more compliant organization. Important compliance efforts for a data processing vendor include GDPR compliance, and the CCPA, SOC2, and HIPAA.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3xpWyLneN0YzszvrL5EDRs',
                type: 'Asset',
                createdAt: '2021-08-13T22:01:37.715Z',
                updatedAt: '2021-08-13T22:01:37.715Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Compliance ceritifications',
                description: 'Compliance ceritifications',
                file: {
                  url: '/img/contentful/3xpWyLne-1gxxqgusa6usrffrm6dv.webp',
                  details: {
                    size: 255885,
                    image: {
                      width: 1344,
                      height: 712
                    }
                  },
                  fileName: '1GxXqguSa6uSrffrm6dV',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '5. Includes security as a standard product feature: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'While evaluating data importer products and vendors, be sure to get an understanding if security features come standard with the product or if these features are add-ons. Many companies will try and upsell certain privacy and security features, offering them as premium features. For example, the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://sso.tax/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'SSO Wall of Shame',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' publishes a list of companies that charge for Single Sign-On, calling them out on upselling something that is a “core security requirement.” At the end of the day, protecting a customer’s data (and their customer’s data) should be ingrained in the product. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '6. On-Premise deployment option:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' For certain highly regulated industries, it may be nearly impossible (despite all the compliance requirements being met) to store customer data anywhere other than in-house. While this option may not be necessary, it’s helpful to understand if the data importer can meet an on-prem requirement.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Additionally, here are some other helpful resources related to data protection laws and data processing security:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://oag.ca.gov/privacy/ccpa'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'California Consumer Privacy Act',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.hhs.gov/hipaa/for-professionals/privacy/guidance/business-associates/index.html'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'HIPAA: Business Associates',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://gdpr.eu/what-is-data-processing-agreement/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'GDPR Data Processor Agreement Information',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.aicpa.org/content/dam/aicpa/interestareas/frc/assuranceadvisoryservices/downloadabledocuments/trust-services-criteria.pdf'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'AICPA Trust Principles',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.nist.gov/cyberframework'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'NIST Cybersecurity Framework',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Sensitive data, aka customer data needs serious data protection to avoid a security incident such as a data breach. As your team evaluates a data importer like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' be sure to review the above key areas as a security jumping off point before implementing a data importer for your customer data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7sF8qOkGNenazpi5CSNtI5',
                type: 'Entry',
                createdAt: '2021-08-11T22:56:04.229Z',
                updatedAt: '2021-08-11T22:56:04.229Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The elegant data import button is here',
                ctaText: 'See it in action',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '59lMjDJTtRdIpg68FBZYii',
    postTitle: 'How to Generate a 360-Degree View of Your Customer',
    seoTitle: 'How to Generate a 360-Degree View of Your Customer',
    seoUrlSlug: 'how-to-generate-a-360-degree-view-of-your-customer',
    seoMetaDescription:
      "CEO Chris Hicken of Nuffsaid discusses customer success best practices on Flatfile's Customer Success Leader podcast",
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-09-29T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1tH4s0i3K271ZuPzVNhqBe',
        type: 'Asset',
        createdAt: '2021-08-13T16:37:08.481Z',
        updatedAt: '2021-08-13T16:37:08.481Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'CEO Chris Hicken of Nuffsaid on the Flatfile Customer Success Leader Podcast',
        description:
          'CEO Chris Hicken of Nuffsaid on the Flatfile Customer Success Leader Podcast',
        file: {
          url: '/img/contentful/1tH4s0i3-i08unxz3thydywy9ixvr.webp',
          details: {
            size: 66637,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'I08UnXZ3THyDyWY9IxVR',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'CEO Chris Hicken of Nuffsaid on the Flatfile Customer Success Leader Podcast',
    summary:
      'There aren’t many companies that are able to say that they have a comprehensive understanding of each of their customers. In fact, most companies are coming up short when it comes to seeing their customers wholly. In this episode, I was joined by Chris Hicken , the CEO of ‘nuffsaid ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'There aren’t many companies that are able to say that they have a comprehensive understanding of each of their customers. In fact, most companies are coming up short when it comes to seeing their customers wholly.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode, I was joined by ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Chris Hicken',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/chrishicken/'
              }
            },
            {
              nodeType: 'text',
              value: ', the CEO of ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: '‘nuffsaid',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.nuffsaid.com/#main'
              }
            },
            {
              nodeType: 'text',
              value:
                ', a team helping knowledge workers prioritize their communications.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Tune in and hear us talk about the following: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why so few companies today are measuring their customers’ success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How to continuously create value for customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How Chris’ team combines qualitative and quantitative data to get a 360-degree view of their customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Some resources mentioned during the episode include: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Value Measurement Maturity Scale',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://blog.nuffsaid.com/measuring-customer-value'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'newsletter.nuffsaid.com',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://newsletter.nuffsaid.com/'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '10NiOZmgH2QzNnTZ2zgCh1',
                type: 'Entry',
                createdAt: '2021-08-13T15:30:16.332Z',
                updatedAt: '2021-08-13T15:32:28.957Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'How to Generate a 360-Degree View of Your Customer w/ Chris Hicken',
                sounderLink: 'https://embed.sounder.fm/play/102367',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-to-generate-a-360-degree-view-of-your-customer/id1528594709?i=1000492928037',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/NmJjODU5ZjgtY2Q2Ny00MDExLTgwYTQtYTExMTQzZGJkMzJh?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-to-generate-a-360-degree-view-of-your-customer-w-chris-hicken-78125404',
                spotifyLink:
                  'https://open.spotify.com/episode/3B6GfEp9n8y79azsnfDCjQ?si=vSv4TYwrQQKq164ps8ihDA&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5IepZ2mG6WnjE2VmQXrmg5',
                type: 'Asset',
                createdAt: '2021-08-13T16:47:06.547Z',
                updatedAt: '2021-08-13T16:47:06.547Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Chris Hicken',
                description: 'Podcast quote from Chris Hicken',
                file: {
                  url: '/img/contentful/5IepZ2mG-0u9axywjtkcso7favoxa.webp',
                  details: {
                    size: 21744,
                    image: {
                      width: 960,
                      height: 540
                    }
                  },
                  fileName: '0U9aXYWjTkCso7FavoxA',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For more info, check out customersuccessleader.com or send a message to ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '5HIcaYcs2pg8fQabPSZqCA',
    postTitle: '5 Questions with Sam Currie, Staff Engineer at Flatfile',
    seoTitle: '5 Questions with Sam Currie, Staff Engineer at Flatfile',
    seoUrlSlug: '5-questions-with-sam-currie-staff-engineer-at-flatfile',
    seoMetaDescription:
      "Flatfile welcomes staff engineer Sam Currie to help build data onboarding products. Learn more about Flatfile's open roles.",
    category: 'Flatfile News & Culture',
    tags: ['5 questions', 'Employee spotlight', 'Engineer'],
    publishDate: '2020-09-23T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3pQXmFw8JdJzi0jN53XkLi',
        type: 'Asset',
        createdAt: '2021-08-13T22:07:01.832Z',
        updatedAt: '2021-08-13T22:07:01.832Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile welcomes engineer Sam Currie',
        description: 'Flatfile welcomes engineer Sam Currie',
        file: {
          url: '/img/contentful/3pQXmFw8-fjudkprax1roangehuwk.webp',
          details: {
            size: 704403,
            image: {
              width: 1920,
              height: 1005
            }
          },
          fileName: 'fJUDkPRAx1ROanGEhUwK',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile welcomes engineer Sam Currie',
    summary:
      'Flatfile is excited to welcome Sam Currie to the team as our newest staff engineer. In addition to Sam’s responsibilities on the engineering team, Sam will also lead Flatfile’s data security and compliance efforts. Let’s learn more about Sam!',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile is excited to welcome ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/sam-currie-b8a3103b/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Sam Currie',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to the team as our newest staff engineer. In addition to Sam’s responsibilities on the engineering team, Sam will also lead Flatfile’s data security and compliance efforts. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s learn more about Sam!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q: Why Flatfile? (And what do you do here?) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: Data problems are absolutely the most fun engineering problems for me to try and solve. Given ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a data company, there’s a list of data problems we’re actively working on these days on behalf of our customers that are really exciting challenges for me. It gets even more exciting when we’re talking about scalability. For example, when we’re looking at a data issue, we’re not thinking about a few hundred records but rather a few million. I personally like solving problems at that level. When it comes to the team, I immediately noticed that everyone is both very experienced and engaged. I’ve never worked on a team before that has so much commitment. Everyone wants to solve these data challenges and deliver an exceptional product. It’s motivating! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I’m in a sort of jack of all trades role right now when it comes to engineering where I can work on both front end and back end and additionally I’m helping with anything related to data security and compliance.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You were at one point in academia and in scientific programming where you co-authored two papers. How did you end up in software development? Tell us a little bit about your career path. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A:  I've been programming since high school as it’s always been a natural fit for me. My educational background is in civil engineering and I worked in the area of energy consumption, specifically determining energy consumption for buildings. This led to a lot of energy consulting roles throughout my career. As I was earning my Master’s degree, I started getting into database administration and was focused on really computational roles which I found interesting. Then I came out to Colorado and I was working as a full time engineer as well as a PhD student. I did it for a while and published papers on ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://www.ibpsa.org/proceedings/BSA2017/9788860461360_14.pdf'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    'Weather Scenario Generation for Stochastic Model Predictive Control Using Vector Autoregressive Prediction',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.infona.pl/resource/bwmeta1.element.elsevier-2b45110c-37ea-3580-8e72-7d9afa14f7bd'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    'Energy modeling of photovoltaic thermal systems with corrugated unglazed transpired solar collectors – Part 1: Model development and validation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' but it turned out that being full time at both proved to be too gruelling. I missed things like sleep! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You have a lot of experience in data analysis from previous roles, how does this skillset help you in your day to day work at Flatfile?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: During my experience in energy consulting, I helped create models to show how much energy a building would consume. I needed to literally model every surface for the building - every light, every computer and I needed to programmatically figure out how much energy a building would be consuming every hour of the day for an entire year. It was a massive data problem. I’m used to managing A LOT of data and am really familiar with data analytics on a large scale. Flatfile’s customers are similarly dealing with a tremendous amount of data and they’re dealing with data that is constantly changing. Because I’ve solved these data challenges in the past, I can empathize with our customers, especially those customers who are feeling the pain of having to clean and wrangle data at scale. I’ve been able to dig in and work with my fellow Flatfile team members to continue building our product to address this very specific pain point - and solve it! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: In addition to scientific programming, energy consulting, and architectural engineering, you also have expertise in compliance and security for technology companies, how did you get involved in compliance and security?  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: I was leading engineering at a small startup and once we started to sell enterprise deals, there were questions and concerns from larger companies on what was happening to their data. I had the technical expertise to understand the questions that were coming at us from these enterprise organizations and it turns out I would also be the point person to implement any changes. By default I became totally immersed in security and compliance so that we could serve enterprise customers. Now I’m able to bring that expertise to Flatfile which has been beneficial since we work with customers ranging from local startups to global enterprises.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Q: Where did you spend your last vacation? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: My last big trip was out to Portland back in February. It was the last trip for me before everything started to get shifty. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Shifty is a perfect way to describe the world in 2020. Thanks Sam! For more information on job openings at Flatfile check out our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'careers page',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '1mznX0fiyQf9UAmXGMS4IS',
    postTitle: 'How Sales & Customer Success Make Power Users',
    seoTitle: 'How Sales & Customer Success Make Power Users',
    seoUrlSlug: 'how-sales-customer-success-make-power-users',
    seoMetaDescription:
      "CEO Jake Dunlap of Skaled Consulting discusses the definition of customer success on Flatfile's Customer Success Leader podcast",
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-09-22T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3Npb8qQ1azE1nj5sfXe1Gz',
        type: 'Asset',
        createdAt: '2021-08-13T16:35:00.661Z',
        updatedAt: '2021-08-13T16:35:00.661Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Cover photo for Customer Success Podcast episode 6',
        description: 'Cover photo for Customer Success Podcast episode 6',
        file: {
          url: '/img/contentful/3Npb8qQ1-kajmtqoaqpm30ze2xma3.webp',
          details: {
            size: 92338,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'KAjMtQOAQpM30Ze2XMa3',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Cover photo for Customer Success Podcast episode 6',
    summary:
      'We’ve all heard about sales and marketing alignment. But, to enable your customers to reach their full potential, it takes alignment between sales and customer success, starting at leadership.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'We’ve all heard about sales and marketing alignment. But, to enable your customers to reach their full potential, it takes alignment between sales and customer success, starting at leadership.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode, I catch up with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Skaled Consulting',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://skaled.com/'
              }
            },
            {
              nodeType: 'text',
              value: ' CEO, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Jake Dunlap',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/jakedunlap/'
              }
            },
            {
              nodeType: 'text',
              value:
                '. Jake shares how leadership can help customer success and sales teams cultivate power users.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this conversation we cover: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How focusing on power users instead of new deals benefits sales orgs',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to align your customer success team w/ the business objectives of customers',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why a growth mindset outperforms a service-only mindset',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Tools to help your customer success team be more proactive',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '793BnMqX6vNQu1oey6v8qp',
                type: 'Entry',
                createdAt: '2021-08-13T15:29:08.048Z',
                updatedAt: '2021-08-13T15:29:08.048Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'How Sales & Customer Success Make Power Users w/ Jake Dunlap',
                sounderLink: 'https://embed.sounder.fm/play/102368',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/how-sales-customer-success-make-power-users-w-jake-dunlap/id1528594709?i=1000492091000',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/YTRkNzdhZGMtOWFiNS00ZjUzLTg3ZWEtMGM3NGM3NGQ4M2Ix?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/how-sales-customer-success-make-power-users-w-jake-dunlap-77914712',
                spotifyLink:
                  'https://open.spotify.com/episode/1ti9htyg9uKAqSAzqw2PMy?si=U1M57am0RkKemLPJUgLPpQ&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Resources mentioned:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Outreach.io',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.outreach.io/'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'LinkedIn Sales Navigator',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.linkedin.com/sales'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2AL54KedO2vbHGuKyH37Yf',
                type: 'Asset',
                createdAt: '2021-08-13T16:46:07.319Z',
                updatedAt: '2021-08-13T16:46:07.319Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Jake Dunlap',
                description: 'Podcast quote from Jake Dunlap',
                file: {
                  url: '/img/contentful/2AL54Ked-dscuzrckr62cdxef6q4a.webp',
                  details: {
                    size: 22486,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'DsCUzrcKR62CDxEF6q4A',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: ' with your thoughts.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '422HThDlFG7J5PKJQwkmTf',
    postTitle:
      'Flatfile saves startup ParrotMob months of data importer development to focus on sales growth',
    seoTitle: 'ParrotMob Saves Months of Data Importer Development',
    seoUrlSlug:
      'flatfile-saves-startup-parrotmob-months-of-data-importer-development-to-focus-on-sales-growth',
    seoMetaDescription:
      "Learn how ParrotMob saved months of time by using Flatfile's data importer tool to onboard customer contact data.",
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Startup'],
    publishDate: '2020-09-21T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'skCzq3XDUxX87vfRbecHD',
        type: 'Asset',
        createdAt: '2021-08-11T22:51:34.849Z',
        updatedAt: '2021-08-11T22:51:34.849Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'ParrotMob uses Flatfile for data import',
        description: 'ParrotMob uses Flatfile for data import',
        file: {
          url: '/img/contentful/skCzq3XD-ooiovkdysgctiwlhcfky.webp',
          details: {
            size: 82320,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'oOioVkDYSGCtIWlHCfKY',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'ParrotMob uses Flatfile for data import',
    summary:
      'For vendors looking to connect with their clients, research shows that open rates for email is only about 20 percent. For text messages, though, the open rate can be as high as 98%. Entrepreneur Osa Gaius enables companies to take full advantage of higher engagement avenues with his startup company ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For vendors looking to connect with their clients, research shows that open rates for email is only about 20 percent. For text messages, though, the open rate can be as high as 98 percent. Entrepreneur Osa Gaius enables companies to take full advantage of higher engagement avenues with his startup company ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/company/parrotmob'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'ParrotMob',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. With ParrotMob, businesses create SMS campaigns and connect target messages where customers naturally want to engage.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'In this post, we uncover:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'The need for a streamlined ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'data exchange',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' solution',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Flatfile’s data importer means more time to drive growth',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Future plans with Flatfile',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Gaius created ParrotMob to be a forward-leaning organization focused on creating the next generation of B2C communication. His goal: to make mobile messaging delightful for both consumers and businesses. The company’s first product is an advanced Conversational Commerce platform for eCommerce stores. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I worked for an email marketing company, and many customers would tell us they were selling to Gen Z and millennials who were not opening or responding to emails and they were looking for a better way to contact them,” Gaius said. “Some said they were texting customers but were doing it either manually or by importing a CSV into another system.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3wGB8cIyZVJuU0ZByRE6SL',
                type: 'Asset',
                createdAt: '2021-08-11T22:52:45.392Z',
                updatedAt: '2021-08-11T22:52:45.392Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Demo of ParrotMob',
                description: 'Demo of ParrotMob',
                file: {
                  url: '/img/contentful/3wGB8cIy-kmkwhods8cxuxmvhsm1o.webp',
                  details: {
                    size: 1058762,
                    image: {
                      width: 453,
                      height: 946
                    }
                  },
                  fileName: 'KmKWhodS8CxUXMVHsm1O',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'ParrotMob is an SMS conversational commerce platform ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'The need for a streamlined data import solution',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To get started with ParrotMob’s platform, customer contact data needs to be imported,  including names, phone numbers, and email addresses. Gaius attempted to handle this requirement by building an in-house data importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“There were a lot of challenges with the importer I built,” said Gaius. “We didn’t have a good fuzzy matching capability. So if a column didn’t fit a certain schema, we would just ignore it. Customers told us that was terrible. We also didn’t have a good solution for letting people manually enter contacts.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Gaius plotted out building a better version of the in-house data importer to address some of the challenges. As an alternative to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/making-a-build-vs-buy-decision-part-1'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'building a custom data importer, he also considered buying',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' an importer, but didn’t think there was one on the market with the specific ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/5-must-have-features-for-a-data-importer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'features he ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: 'needed. And then: ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' came across his desk.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“My first thought was that finding Flatfile was going to save me a few months of my summer,” Gaius recalled. “It had all the features we needed.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Flatfile provides a unique value prop for us,” Gaius continued. “High value customers have a lot more data that they want to pull into our system and Flatfile now allows us to do that easily. The initial feedback we got was a lot of excitement because our importer was simply not as good as Flatfile’s data importer. A lot of our users were incredibly happy, and we got some good responses in terms of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'customers being able to easily import their contacts',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Flatfile’s data importer means more time to drive growth',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Gaius knew that wearing the hats of both a developer and CEO was going to be tough to balance. Finding Flatfile to take a huge chunk of development time off his plate was a significant benefit.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Building out a data importer that had the features we needed was going to take a good deal of my focus,” he said, “I spend half my time writing software and the other half doing sales. Having Flatfile has been very helpful for allowing me to better utilize my time. Now I can work on features customers are asking for.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Being a developer and CEO it is crucial that I find places where I can save time and be efficient,” he went on. “Having a tool like Flatfile lets me focus on selling the product rather than building a data importer and that’s a huge service to us.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Future plans with Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Gaius sees several areas where ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/flatfile-portal-2-biggest-update-csv-importer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile can contribute',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to the growth of ParrotMob. Some customers want to import information that the company doesn’t currently support, like addresses, tags and other customer data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“That’s a place where we could really leverage Flatfile,” said Gaius. “It will essentially let people import arbitrary data they want to use within our system to segment or filter what they need, but that we don’t necessarily need ourselves. That’s a place where in the next few months Flatfile can really save us a great deal of time serving those users. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Overall, Flatfile has been a tremendous asset for us, and that’s critical for a startup like us.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About ParrotMob',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'ParrotMob helps customers jumpstart sales with text messaging. The Conversational Commerce platform allows businesses to engage customers in a channel that offers high open and click rates and helps recover abandoned carts. Leading stores like Haoma and Unapologetic partner with ParrotMob to stay up to date with their mobile campaigns. For more information visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/company/parrotmob'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'https://www.getparrot.com/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' AI-assisted data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4FQ9QIs0fY3TtFHVadWb1I',
    postTitle: 'How to tackle data chaos in customer onboarding',
    seoTitle: 'How to Tackle Data Chaos in Customer Onboarding',
    seoUrlSlug: 'how-to-tackle-data-chaos-in-customer-onboarding',
    seoMetaDescription:
      'Learn how to reduce data chaos as part of the data onboarding experience and improve customer onboarding',
    category: 'Data exchange',
    tags: ['Customer onboarding', 'Customer onboarding process'],
    publishDate: '2020-09-16T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1R3tCPBmloQ4fyZy0difpR',
        type: 'Asset',
        createdAt: '2021-08-16T21:56:31.701Z',
        updatedAt: '2021-08-16T21:56:31.701Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Data chaos in customer onboarding',
        description: 'Data chaos in customer onboarding',
        file: {
          url: '/img/contentful/1R3tCPBm-eyewtdttte6omwu3bgmz.webp',
          details: {
            size: 1130337,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'EYEWTdTTTe6OMWu3bGmz',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Data chaos in customer onboarding',
    summary:
      'Every day, humans produce 2.5 quintillion bytes of data. Your customers produce a fraction of that daily global statistic, but even a fraction is still a lot. The sheer volume of data alongside lackluster data management processes together lead to what’s known as data chaos, and it can cause a ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Every day, humans produce ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://techjury.net/blog/how-much-data-is-created-every-day/#gref'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '2.5 quintillion bytes',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' of data. Your customers produce a fraction of that daily global statistic, but even a fraction is still a lot.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The sheer volume of data alongside lackluster data management processes together lead to what’s known as data chaos, and it can cause a terrible experience for new customers, both those who need to onboard their own data and those who expect a white glove level of service from your customers success team. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'What on earth is data chaos? (You probably know it well)',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data chaos is the web of confusion and missed opportunities created by mass volumes of data, especially unstructured data and data that is not stored in a meaningful or useful way. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Truthfully, we’ve all experienced data chaos at some point in our careers, if not monthly or even weekly. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It can show up when you’re migrating from one tool to another, when you encounter challenges with internal knowledge sharing, and when you seek to make data-driven decisions. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But in this blog post, we’re looking specifically at how data chaos affects customer onboarding.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Signs you’re experiencing data chaos during customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Not sure if your organization has this common ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'customer data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' problem? Let’s take a look at these sure signs that you do:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The process for Customer Success Managers (CSMs) onboarding customers’ data looks different every time.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'You don’t have technology and procedures in place to deal with the data chaos handed over to you by customers who are eager to get onboarded quickly.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'It can take longer than a couple of weeks to onboard new customers. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Customers love your product, but you’ve gotten negative feedback about your customer onboarding process and the time to value.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Top risks of data chaos during customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Seventy two percent of companies surveyed by Forrester said that customer success is their ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.smartkarrot.com/resources/blog/20-customer-success-statistics-in-2020/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'top priority.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' And for good reason. Acquiring a new customer tends to be anywhere from 5 to 25 times more expensive than retaining an existing customer. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Without customer onboarding tools and processes in place that can dispel the data chaos, organizations risk frustrating the new customers that they should be impressing. This can result in immediate churn. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Even when contracts are in place, customers may be unsettled if there are any headaches or slow downs in the data onboarding process as part of the broader customer onboarding. They might feel swayed by competitors who can back up their promises of fast and easy onboarding with proof of their superior processes.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'How to handle data in an effective customer onboarding program',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For many different types of products, an effective customer onboarding program needs to put data in the spotlight. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'From marketing and sales to inventory management to HR to product development, there are thousands of SaaS tools that can’t offer any value until their customers’ data is ready to use. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This is especially true with enterprise customers, who…',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Already have loads of critical data (since they aren’t new or small businesses)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Need to utilize all available data and integrate it smoothly, instead of keeping it siloed in different solutions',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Expect hands-on assistance with onboarding ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'An effective customer onboarding program takes all of these factors into account and simplifies the process of data onboarding for customers as much as possible. Essential components include a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.flatfile.com/teams/customer-success/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'collaborative workspace for customers and CSMs',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', well-trained CSMs, and excellent communication throughout the process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s take a look at the top tools and techniques.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Tools and techniques that prevent data chaos during customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When customers come to you—yes, especially enterprise customers—their data chaos becomes your problem. You need to offer a structured process for wrangling and utilizing their critical datasets. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Some aspects of data onboarding invariably fall on the shoulders of your customer. After all, you don’t have access to all their systems. However, you can give them a roadmap for the data they need and offer technological solutions to minimize the amount of manual effort required from them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Data onboarding process how-to: Create a collaborative space for customers and CSMs',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Email, Google docs, and PDF handouts are ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'not',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' an effective way to communicate with customers about the data onboarding process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These methods aren’t trackable or clear to understand. For the same reason that project managers use task management tools to assign tasks instead of communicating via email, CSMs shouldn’t communicate using this outdated method either. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Instead, look for a collaborative data onboarding workspace that offers a single shared view of all pending data imports, completed data imports, expectations,and timelines.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                'for example offers the following features to CSMs who want to uplevel the experience they deliver to customers during the onboarding phase:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'A single home for all enterprise customer data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Transforms CSV, XLS, TSV, and more into clean, validated output',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Auto-matches 95% of imported data fields',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Browse and search import history',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7CDijuSQT5Ec9AzaF7AHxq',
                type: 'Asset',
                createdAt: '2021-08-16T21:53:54.473Z',
                updatedAt: '2022-01-05T13:20:32.250Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Creating Workspace',
                description: 'Creating Workspace',
                file: {
                  url: '/img/contentful/7CDijuSQ-sdu7oiuasoiokvr86eaa.webp',
                  details: {
                    size: 1207244,
                    image: {
                      width: 800,
                      height: 450
                    }
                  },
                  fileName: 'sDu7OIuASOiokVR86EAA',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Data onboarding process how-to: Offer a powerful CSV importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Depending on how tech savvy your customers are, you can upload data for them or allow them to do it themselves in your collaborative workspace. Some customers are naturally more self sufficient, which is why you’ll want this option. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Your collaborative workspace isn’t just a project management tool. It needs to include a robust CSV importer that turns requirements into uploads and into usable data that’s ready to go in your client’s account. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While the CSM is there at every step of the way, customers will often need to upload some files themselves. You should have a CSV importer that is user-friendly and intuitive. It should help users easily diagnose any issues to minimize frustration. There should also be very specific messages within the importer that help users know exactly what they might need to fix before uploading data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4mM7Nmduiwpejf1KkAJW26',
                type: 'Asset',
                createdAt: '2021-08-16T21:54:41.359Z',
                updatedAt: '2021-08-16T21:54:41.359Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Upload and reviewing data in Concierge',
                description: 'Upload and reviewing data in Concierge',
                file: {
                  url: '/img/contentful/4mM7Nmdu-fgea2edbqxgzaahfkw12.webp',
                  details: {
                    size: 105820,
                    image: {
                      width: 1280,
                      height: 1280
                    }
                  },
                  fileName: 'Fgea2EdbQXGzAahFkW12',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Data onboarding process how-to: Effectively communicate with customers about data requirements',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Communication is critical. You need to know customer data is required to enjoy full use of your platform, what data is desirable to help your customers avoid internal issues with knowledge sharing, data utilization, and data silos, and what data is simply a “nice to have” but isn’t high priority.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Apply your knowledge of the industry and the data that matters to what you know about your customers’ businesses to determine the data requirements. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You should assign these to customers in phases based on the priority level and you should also know which customer contact is in charge of which data source, or have a single point of contact who can point you in the right direction. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Again, a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/product/concierge/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'collaborative data onboarding workspace',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is ideal. You can use this platform to assign the right data requirement to the right person with the right deadline.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Data onboarding process how-to: Make sure the CSM is well-trained in handling data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Dealing with your customers’ data chaos is even more complicated than dealing with your own, because it’s not your data; you might not be familiar with it. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'CSMs who want to go above and beyond for their customer accounts during the onboarding process need to be experts in data handling and data importing. As a team, you can create dummy data to work with so that you don’t jeopardize customer data during training. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Focus your training on the type of data that yields success for customers, the format the data should be in, and handling any issues that arise during the data import process. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A great ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/product/portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'CSV importer',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' can make this responsibility easier on your team by minimizing the required manual work. Your ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/5-must-have-features-for-a-data-importer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data importer should handle',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' data parsing, data mapping, data structuring, data validation, and data transformation, but your CSMs still need to be trained in helping customers collect and prepare the data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Take care of data security and data privacy',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to touching your customers’ data, security and privacy need to be top priorities.  Make sure to only exchange data with customers in a secure environment. Your collaborative workspace should have built-in security mechanisms like authentication flow and verification. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This helps you ensure that only authenticated users can access customer data. You’ll want to make sure that outside contractors, for example, have no access to the collaborative platform with customer data, and that only internal employees are granted access. More specifically, you’ll only want people on the CS team handling customer data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As companies create more and more data, the chaos isn’t going away anytime soon. What matters is having the right technology and systems in place to help your customers deal with it so that they can successfully use your product - sooner rather than later!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4vQJgsOGXHgkFINLnX42hd',
    postTitle: 'Building and Measuring a Customer Success Program',
    seoTitle: 'Building and Measuring a Customer Success Program',
    seoUrlSlug: 'building-and-measuring-a-customer-success-program',
    seoMetaDescription:
      'In this episode of Customer Success Leader, Steve Hueber discusses how to create a customer success program.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-09-15T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3pr8IaBtCOEvSih69CjvEC',
        type: 'Asset',
        createdAt: '2021-08-13T16:32:40.134Z',
        updatedAt: '2021-08-13T16:32:40.134Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Steve Heuber feature image',
        description: 'Steve Heuber feature image',
        file: {
          url: '/img/contentful/3pr8IaBt-vsjfqhapsyoe65senvgr.webp',
          details: {
            size: 100618,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'VsJFQHAPSyOe65sENvGR',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Steve Heuber feature image',
    summary:
      'Customer Success Programs are popping up at companies everywhere, and with good reason. If you aren’t yet familiar with what goes into developing one, or have one up and running, you’ll definitely want to check out this episode. Today I talked with Steve Heuber , Customer Experience Strategist at Genesys ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Customer Success Programs are popping up at companies everywhere, and with good reason. If you aren’t yet familiar with what goes into developing one, or have one up and running, you’ll definitely want to check out this episode.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Today I talked with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Steve Hueber',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/stephen-hueber-80104241/detail/background-image/'
              }
            },
            {
              nodeType: 'text',
              value: ', Customer Experience Strategist at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Genesys',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.genesys.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', and he shared some valuable insights from his experience putting together successful CS Programs across the country.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "In this episode of the Customer Success Leader podcast, we'll cover the following: ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'An introduction of the concept of a Customer Success Program (what is it exactly) ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Tailoring programs to meet needs on a project by project basis ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Building and earning a trusted client partnership ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1msZ7twEM7bHGp8lLHE44B',
                type: 'Entry',
                createdAt: '2021-08-13T15:27:30.817Z',
                updatedAt: '2021-08-13T15:27:30.817Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Building and Measuring a Customer Success Program w/ Steve Hueber',
                sounderLink: 'https://embed.sounder.fm/play/102369',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/building-and-measuring-a-customer-success-program/id1528594709?i=1000491301554',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/YjQxNWM5NmEtNWMyZS00MGE0LTlhMWYtZmUzMWIxMWQzYjI1?sa=X&ved=0CAUQkfYCahcKEwjoxbbdp67yAhUAAAAAHQAAAAAQAQ',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/building-and-measuring-a-customer-success-program-w-steve-hueber-77722716',
                spotifyLink:
                  'https://open.spotify.com/episode/0whCvZReTxbOWshuRSq7Sd?si=VwJVcRacTfW4vXfM2ZX0Tg&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5sL5z1s9Dwk0mHNRcrxsLG',
                type: 'Asset',
                createdAt: '2021-08-13T16:45:08.031Z',
                updatedAt: '2021-08-13T16:45:08.031Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Steve Hueber',
                description: 'Podcast quote from Steve Hueber',
                file: {
                  url: '/img/contentful/5sL5z1s9-chuxxihjskq6tujod4rk.webp',
                  details: {
                    size: 27530,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'chuXXiHJSKq6TUjOD4rk',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                ' Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: ' with your thoughts.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '1EXCgm8GPEV31j3rkHj9Ne',
    postTitle: '5 Questions with Roby Hyde, Senior Sales Engineer at Flatfile',
    seoTitle: '5 Questions with Roby Hyde, Senior Sales Engineer at Flatfile',
    seoUrlSlug: '5-questions-with-roby-hyde-senior-sales-engineer-at-flatfile',
    seoMetaDescription:
      'Flatfile welcomes Senior Sales Engineer Roby Hyde to help customers solve data onboarding challenges. Check out our open job roles.',
    category: 'Flatfile News & Culture',
    tags: ['5 questions', 'Employee spotlight', 'Sales engineer'],
    publishDate: '2020-09-10T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'jQgfzT8ZsU0zFJGCb6fEw',
        type: 'Asset',
        createdAt: '2021-08-16T21:59:16.884Z',
        updatedAt: '2021-08-16T21:59:16.884Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Roby Hyde joins Flatfile as Senior Sales Engineer',
        description: 'Roby Hyde joins Flatfile as Senior Sales Engineer',
        file: {
          url: '/img/contentful/jQgfzT8Z-tycwvk6yr4ufvhe92p5e.webp',
          details: {
            size: 227646,
            image: {
              width: 1200,
              height: 628
            }
          },
          fileName: 'TycwVK6yR4uFVHE92P5e',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Roby Hyde joins Flatfile as Senior Sales Engineer',
    summary:
      'Flatfile is thrilled to welcome new teammate Roby Hyde , Senior Sales Engineer, to the team. In this role Roby will assist the sales team by helping to resolve any technical challenges for our customers. Let’s dive in and learn more about Roby! Q: Why Flatfile? (And what does a ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile is thrilled to welcome new teammate ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/robyhyde/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Roby Hyde',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', Senior Sales Engineer, to the team. In this role Roby assists the sales team by helping to resolve any technical challenges for our customers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s dive in and learn more about Roby! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: Why Flatfile? (And what does a typical day look like for you?) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A:  At Flatfile, I get to work closely with customers and help them solve all sorts of technology problems. I also get to use my skills and experience to help Flatfile continue on our massive growth trajectory. Those are key drivers for me and I’m excited that I get to do both here.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I’m focused on helping our sales team with any technical questions that a customer might have as they’re learning more about Flatfile. On a typical day I meet with customers, answer their questions, create personalized demos to show how Flatfile addresses their specific needs, put together proof-of-concepts for customers, and generally get to meet a lot of people from different industries and companies throughout my day. No two days are ever the same which is really fun. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You’ve held technical roles throughout your career. What inspired you to get involved in technology? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: Since I was first introduced to computers, I’ve been fascinated with them. I was a geek growing up. I love the challenge of getting the computer to automate a task and the logic exercise involved with doing so. In my spare time, I try to instill that same wonder of technology in high school students by mentoring a local robotics team.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: You spent time at Apple which is one of the most admired companies in the world. What are some lessons you learned during your time there? ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: I learned that you can put passion into products. You can create solutions to problems that go beyond just solving the problem--you can bring surprise and delight to users. It takes a lot of hard work to reduce complexity and add value to the product but it’s so worth it when you watch customers enjoy using it.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: Talk about a tough technical problem or challenge you’ve had to solve in the past, how did you overcome it?  ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: By relying on people smarter than me. :-)  While I love to learn and solve problems, I’ve also learned how to grow a smart team. I try to hire people who are smarter than me and I try to work with teams that have smart people on them. Solutions to problems are much easier and faster to find in that environment. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Q: If you could have dinner with anyone famous - dead or alive - who would it be?',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A: There are a few people that seem to function at a different level than the rest of us. I like to imagine that an alien race has dropped these people into our society to help us advance faster. I’m pretty sure Steve Jobs, Albert Einstein, and Elon Musk are some of those aliens. I’d love to have dinner with Elon Musk as I think I’d get along with him well and he’d probably confirm that he actually is an alien.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Want to join Roby? We’re hiring! Learn more about ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/careers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile and our open roles',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5ouWKhsl6vU9PPz8EGFpAk',
    postTitle: 'Customer Care in Cybersecurity',
    seoTitle: 'Customer Care in Cybersecurity',
    seoUrlSlug: 'customer-care-in-cybersecurity',
    seoMetaDescription:
      'In this episode of Customer Success Leader, Stacie Ward, VP of Customer Care discusses customer success within cybersecurity',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-09-08T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1zL4D2vGEjdJkL3jUA7Hy0',
        type: 'Asset',
        createdAt: '2021-08-13T18:47:10.678Z',
        updatedAt: '2021-08-13T18:47:10.678Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Stacie Ward headline image',
        description: 'Stacie Ward headline image',
        file: {
          url: '/img/contentful/1zL4D2vG-n44yr1rrsmu1k2wu4veo.webp',
          details: {
            size: 65928,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'n44YR1rRSmu1K2WU4veO',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Stacie Ward headline image',
    summary:
      'This probably isn’t a newsflash to most of us but… the customer isn’t always right. They are, however, always the hero. This is a super relevant concept, especially when it comes to cybersecurity and protecting your customers from breaches. To give us the lowdown on customer care in cybersecurity, I ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'This probably isn’t a newsflash to most of us but…the customer isn’t always right.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'They are, however, always the hero. This is a super relevant concept, especially when it comes to cybersecurity and protecting your customers from breaches.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'To give us the lowdown on customer care in cybersecurity, I sat down with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Stacie Ward',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/stacieward/'
              }
            },
            {
              nodeType: 'text',
              value: ', VP of Customer Care at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Red Canary',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://redcanary.com/'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode of the ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: '/podcast/'
              }
            },
            {
              nodeType: 'text',
              value: ' podcast, we talk about: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How customer success and all other departments create a cohesive wheel around the customer',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why it’s helpful for customer success teams to have a senior leadership ally',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to forge trusting customer relationships in cybersecurity',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Expert advice for professionals new to customer success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '74YSXLGZsmRPXtldv4YRP5',
                type: 'Entry',
                createdAt: '2021-08-12T17:15:16.523Z',
                updatedAt: '2021-08-12T17:52:44.501Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Customer Care in Cybersecurity w/ Stacie Ward',
                sounderLink: 'https://embed.sounder.fm/play/102370',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/customer-care-in-cybersecurity-w-stacie-ward/id1528594709?i=1000490437191',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/NzY5ZTRmNjQtYTdkNS00ZGJhLWI0NDEtOGFkZjA1M2NhNGZi?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/customer-care-in-cybersecurity-w-stacie-ward-77548100',
                spotifyLink:
                  'https://open.spotify.com/episode/4AZfOpxOz6uM5OLhrMJxG1?si=Ei_lCtAYSWupe41oH0G-Mg&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4PbA7zKWs6IsiA0LrTS1pb',
                type: 'Asset',
                createdAt: '2021-08-13T18:48:20.677Z',
                updatedAt: '2021-08-13T18:48:20.677Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote from Stacie Ward',
                description: 'Podcast quote from Stacie Ward',
                file: {
                  url: '/img/contentful/4PbA7zKW-gmimcwkrqhoe0h9zh4bj.webp',
                  details: {
                    size: 23136,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'gmiMcwkrQhOE0h9zH4bJ',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: ' with your thoughts. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '5sbLMzMcoeyejo4vq5g60',
    postTitle: '5 Questions with Maire Chew, Engineer III at Flatfile',
    seoTitle: '5 Questions with Maire Chew, Engineer III at Flatfile',
    seoUrlSlug: '5-questions-with-maire-chew-engineer-iii-at-flatfile',
    seoMetaDescription:
      'We’re thrilled that Maire Chew joined Flatfile as an Engineer III responsible for creating beautiful and engaging product experience.',
    category: 'Flatfile News & Culture',
    tags: ['5 questions', 'Employee spotlight', 'Engineering leadership'],
    publishDate: '2020-09-02T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '57kViW81yAKR07uENCafLx',
        type: 'Asset',
        createdAt: '2021-08-16T22:02:30.006Z',
        updatedAt: '2022-01-05T12:07:11.860Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 5,
        locale: 'en-US'
      },
      fields: {
        title: 'Maire Chew joins Flatfile',
        description: 'Maire Chew joins Flatfile',
        file: {
          url: '/img/contentful/57kViW81-tnpvoznwszosha797smo.webp',
          details: {
            size: 545536,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'tNPvozNwSzOsHA797sMo',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Maire Chew joins Flatfile',
    summary:
      'We’re thrilled that Maire Chew recently joined Flatfile as an Engineer III responsible for creating beautiful and engaging product experiences for our customers. Let’s get to know Maire! Q: Why Flatfile? (And what do you do here?) A: I was actually contracting for a while before I joined full time. ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'We’re thrilled that ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Maire Chew',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/mairechew/'
              }
            },
            {
              nodeType: 'text',
              value:
                ' recently joined Flatfile as an Engineer III responsible for creating beautiful and engaging product experiences for our customers. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Let’s get to know Maire!',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Q: Why Flatfile? (And what do you do here?)',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A: I was actually contracting for a while before I joined full time. If more companies can follow that model, I’ve found that it’s really helpful because you get insight into how the company works before you decide to come on full time.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'What attracted me to Flatfile was the pace and how everyone on the team had input that would then immediately be put into action. That really stood out for me. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'At Flatfile I’ll be owning the front end development of our ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              }
            },
            {
              nodeType: 'text',
              value: ' which I’m incredibly excited about!  ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Q: Your background in software development has been focused on UI design, how did you get involved in that particular area? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A: I was trained as a full stack developer and then I started doing front-end work and really fell in love with beautiful products and product design. I knew I wanted to be the one accountable for building something beautiful which was why I started focusing heavily on front-end work.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'I also have a dance background so there’s something about the arts and the ability to create something truly eye-catching that motivates me. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Q: What brands are knocking it out of the park when it comes to great design? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'A: Simple Habit and Headspace are mindfulness apps and I think they do a tremendous job of creating a seamless experience. The output of what you’re supposed to be getting by using these apps is clearly demonstrated in the way they’re designed. You need a mindfulness app to feel relaxed so that you feel relaxed. As you move through the app it feels very light which is intentional. Simple Habit and Headspace both do a great job of creating that “light” feeling and experience through design.  ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'I also like Pinterest because they brought back the masonry layout, an oldie but a goodie. There’s a lot of chaos on the page yet it’s very consumable at the same time. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Q: In your career, can you talk about a tough problem you’ve solved or a specific challenge you overcame that you’re particularly proud of? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "A: Transitioning from being an individual contributor to an engineering manager was a really tough transition. You go from being accountable for your work to being responsible for everyone's work. Now that I’m back in an individual contributor role I feel like I have some perspective that others might not have - unless you’ve made that transition back and forth. Even though you’re only doing your work, there’s connections to everyone else. Being accountable for others and then being accountable for yourself is an interesting career move because you’re more aware of your impact as an individual. ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Q: You only get to listen to one album for the rest of your life, what is it? ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'A: Post Malone’s Hollywood’s Bleeding',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '\nWant to join Maire? We’re hiring! Learn more about ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile and our open roles',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: '/careers/'
              }
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '2WTA3aiv9qVAfkSskgAfmZ',
    postTitle: '29 onboarding tools for delighting new users',
    seoTitle: 'Top 28 Customer Onboarding Tools for SaaS',
    seoUrlSlug: '28-onboarding-tools-for-delighting-new-users',
    seoMetaDescription:
      'Onboarding tools help new users and customers interact with the most important features, onboard their data, achieve their goals, and establish regular use habits.',
    category: 'Data exchange',
    tags: ['Customer onboarding', 'Onboarding tools'],
    publishDate: '2020-08-31T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5zytvoKf3OMnLG4aQYUHbm',
        type: 'Asset',
        createdAt: '2021-08-16T22:19:42.707Z',
        updatedAt: '2022-01-07T20:46:21.439Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Onboarding tools needed for a better customer experience',
        description: 'Onboarding tools needed for a better customer experience',
        file: {
          url: '/img/contentful/5zytvoKf-qwop7ggxrge5pkixeogi.webp',
          details: {
            size: 359550,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'QWoP7gGXRge5PkIXeogi.png',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Onboarding tools needed for a better customer experience',
    summary:
      'Onboarding tools help new users and customers quickly interact with the most important product features, establish regular use habits, and generally help new customers achieve their goals. Increasing customer retention rates by just 5% can increase profits by 25% to 75% , so the value of tools to help with ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '34XXe3V3cyS5J4mGzH4fjR',
        type: 'Entry',
        createdAt: '2021-08-03T22:16:04.658Z',
        updatedAt: '2022-01-26T21:30:37.569Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 13,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Sheila Lahar',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3PJBtHLmh1q25KN5cIXC8i',
            type: 'Asset',
            createdAt: '2021-08-03T22:12:54.167Z',
            updatedAt: '2021-08-03T22:12:54.167Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Sheila Lahar headshot',
            description: 'Sheila Lahar headshot',
            file: {
              url: '/img/contentful/3PJBtHLm-j2i9dflas8idbmbantgb.webp',
              details: {
                size: 56686,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'J2i9dflAS8iDBMbantgb?1628028753589',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Senior Manager, Content Marketing',
        department: 'Content Marketing'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Onboarding tools help new users and customers quickly interact with the most important product features, establish regular use habits, and generally help new customers achieve their goals.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Increasing customer retention rates by just 5% can increase profits by ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://media.bain.com/Images/BB_Prescription_cutting_costs.pdf'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '25% to 75%',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', so the value of tools to help with the onboarding process can’t be overstated.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to customer onboarding tools, there’s more to this type of software than meets the eye. Onboarding software can be used by dozens of different people in the company and for many different reasons. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Onboarding self-service customers. Onboarding enterprise customers. Improving the onboarding experience for both customer types. Measuring. Testing. Training. Teaching.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The list goes on.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’ve put together a list that satisfies these needs. Keep scrolling for a few of the top onboarding tools!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Why are more and more SaaS businesses turning to onboarding tools?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'It’s not uncommon for apps to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.appcues.com/blog/user-onboarding-customer-journey'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'lose 75% of their users within the first week',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. That means tens of thousands of new users will never become paying customers. For companies without a free trial or freemium plan, user onboarding is just as important. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Enterprise clients expect an exceptional onboarding experience, both with self-service product tours and hands-on support from customer success. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'SaaS companies typically need to build out some or all of the following to support an onboarding process:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data importers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'White-glove customer data onboarding collaboration workflows',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Training libraries',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Email and chat onboarding sequences',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Support documentation',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Onboarding is a lot of work. It requires a ton of effort across an organization from developers, product managers, content teams, and customer success representatives. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It’s no wonder then that more SaaS companies are turning to onboarding tools to help ensure new customers are well taken care of.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Top onboarding tools',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Since onboarding can become complicated, there’s a variety of different types of onboarding tools. These different types can overlap in functionality and SaaS companies can end up with double coverage or with a big gap.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But when it comes down to it, there are a few main functions that you should cover, no matter how you make that happen.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'User onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Video onboarding and product trainings',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Email onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Chat onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'SMS onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'User experience monitoring and testing tools',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7yJuSCVkiOsvjRYIQnDfI0',
                type: 'Asset',
                createdAt: '2021-08-16T22:12:15.071Z',
                updatedAt: '2021-08-16T22:12:15.071Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Data onboarding graphic',
                description: 'Data onboarding graphic',
                file: {
                  url: '/img/contentful/7yJuSCVk-t4cxqvx7rginnfzmrwsj.webp',
                  details: {
                    size: 35354,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: 't4cXQVX7RGiNnFZmRWSJ',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Data onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Data onboarding tools help customers get value from the product faster by getting their data ready to use as quickly as possible. Customer, business, or product data needs to be onboarded for different types of tools to be usable. Without excellent data onboarding, customers can’t move onto the core functionality of the product.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '1. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile Portal ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Best for: a seamless, quality data onboarding experience',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile Portal is a drop-in data importer that implements in hours (as opposed to weeks). With Flatfile Portal, you can save your engineering team serious time and effort as they won't have to manually build a data importer. While CSV is the most common file type, other types are accepted. Flatfile Portal handles column matching, data validation, and more.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '2. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile Workspaces',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: collaboratively working with customers to onboard their data',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Built for customer success teams who want to take the white glove onboarding experience to the next level, Flatfile Workspaces is a collaborative experience for stakeholders involved in the onboarding process. Customer facing teams can invite customer contacts, plan the onboarding schedule, request files, and handle onboarding with a lot less struggle.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '51zPEJBlYv0NRZIi95OJwI',
                type: 'Asset',
                createdAt: '2021-08-16T22:13:08.605Z',
                updatedAt: '2021-08-16T22:13:08.605Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'User onboarding graphic',
                description: 'User onboarding graphic',
                file: {
                  url: '/img/contentful/51zPEJBl-2mdxgzoittgvrdnvbaph.webp',
                  details: {
                    size: 34648,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: '2MDxGzOITtGvRDnVbAPH',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'User onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Unlike data onboarding tools, user onboarding tools might include data onboarding in their workflows, but they don’t necessarily ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'focus',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' on customer data. Rather, these tools teach new users how to use the product in an active and engaging way. Product tours, checklists, and tooltips are all popular strategies for onboarding.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '3. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://onboard.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Onboard',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: creating personalized customer onboarding experiences',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Onboard doesn't believe that one-size-fits-all when it comes to customer onboarding. The company creates dynamic launch plans (aka Maps) that are not only incredibly efficient but customized so that implementing a new customer is an effective - and amazing experience. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '4. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://userpilot.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Userpilot',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Best for: building pathways and onboarding checklists',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Userpilot is a tool that sits on top of your product’s native UI to deliver a better user onboarding experience. It helps product teams create pathways and checklists that are specific to user types and identifies drop off.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '5. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.trychameleon.com/?utm_expid=.K9nzyDAvSsuVod3I6zbXhQ.0&utm_referrer=https%3A%2F%2Fflatfile.io%2Fblog%2F27-onboarding-tools-for-delighting-new-users'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Chameleon',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Best for: building product tours',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Chameleon is a code-free tool for onboarding new users. You can easily build out product tours, onboarding checklists, tooltips and more.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '6.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://fenixrepo.fao.org/cdn/faostat/js/hopscotch/0.2.6/demo/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Hopscotch',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Best for: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                'delivering consistent, transparent, and delightful customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Hopscotch isn’t necessarily a tool, but it is a framework that developers can use to build their own in-app onboarding experiences. The framework is designed to make it easy to create',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://fenixrepo.fao.org/cdn/faostat/js/hopscotch/0.2.6/demo/#general-usage'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' product tours',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' such as welcome tours and specific feature tours.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '7.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://bit.ly/3vxkcQl'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Rocketlane',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: delivering consistent, transparent, and delightful customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Rocketlane is a purpose-built customer onboarding software that helps teams codify their best practices with templates, improve customer accountability, and elevate the customer experience with Client Portal and other customer-focused offerings. It comes with built-in CSAT, Time Tracking, and Resource Management and replaces the bundle of tools you use for project management, communication, and collaboration. Start your free 14-day trial.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'FGmiIpRA96EZSKTZK92t0',
                type: 'Asset',
                createdAt: '2021-08-16T22:14:19.200Z',
                updatedAt: '2021-08-16T22:14:19.200Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Video onboarding graphic',
                description: 'Video onboarding graphic',
                file: {
                  url: '/img/contentful/FGmiIpRA-1s1vvcewrk6fjlg3lafo.webp',
                  details: {
                    size: 32250,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: '1s1VvcEwRK6FJLG3lAfo',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Video onboarding and product trainings',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Video is becoming an increasingly popular tool in the onboarding process. Customer success managers can use it to both train customers at scale and/or send personalized tips and responses.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '8. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.vidgrid.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Vidgrid',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: sending back-and-forth videos via chat with customers',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Vidgrid is a great option for product teams that want to offer a very personalized experience to their enterprise customers. Here’s how it works: customers can easily send short video questions via chat as they’re learning to use the product and then customer service reps can send back pre-recorded or new videos in response.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '9.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.skilljar.com/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Skilljar',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: designing a comprehensive product LMS with learning pathways',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Skilljar is a robust user onboarding and LMS solution. It offers unique learning pathways, live and virtual training management, quizzes, and resource libraries for customers. Skilljar's LMS supports streaming video uploaded directly to their platform as well as video embedded from external hosts (YouTube, Wistia, etc)",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '10.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://bombbomb.com/welcome/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'BombBomb',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Best for: embedding video messages in any channel',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Bombbomb, you can add video to messages sent with any platform: Gmail, Zendesk, Active Campaign, and plenty more. You can use it both for personalized video messages and scalable videos that get sent to an entire subset of customers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '11.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.loom.com/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Loom',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: sending quick video responses to customer questions',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What started as a tool for QA testers to record bug reproductions has turned out to be one of the best examples of fast freemium growth. Many digital teams use Loom frequently for internal communications, but it can also be used for onboarding. Customer success managers can communicate with customers both reactively and proactively—sending videos to respond to quick questions during the onboarding process (or after!)',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7lyykrWTSTmIXCYUVCQcUo',
                type: 'Asset',
                createdAt: '2021-08-16T22:15:05.969Z',
                updatedAt: '2021-08-16T22:15:05.969Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Email onboarding graphic',
                description: 'Email onboarding graphic',
                file: {
                  url: '/img/contentful/7lyykrWT-pgs09l4crhubbmyrvoam.webp',
                  details: {
                    size: 35170,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: 'pGS09l4cRHubBMyrVoAm',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Email onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The star of most onboarding conversations, email is not to be ignored. Email can be used to encourage new users or customers to try out core features and go deeper into the product.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '12. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.autopilothq.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Autopilot',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: engaging with new customers at the right time on the right channel ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "A favorite with marketers, Autopilot can be used to create automated journeys for new users. Use it to create email onboarding sequences that cater to the user's behavior, including how they became a new user and what onboarding material they’ve interacted with so far.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '13.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.activecampaign.com/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'ActiveCampaign',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: all-in-one email marketing software for marketing and CS teams',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'ActiveCampaign is quickly becoming every marketer’s favorite email tool, but it absolutely can be used for product teams as well. With advanced segmenting and deep native integrations, ActiveCampaign can send behavioral and transactional emails during the onboarding process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '14. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.drip.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Drip',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: email marketing sequences based on user behavior with previous emails',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While Drip targets ecommerce companies, it’s a powerful email tool with tons of behavior-based automations and it’s a great fit for getting new users back in your app. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '15. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://keap.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Keap',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: email marketing with a built-in CRM for sales, marketing, and CS teams',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Keap (formerly InfusionSoft) is an all-in-one marketing and CRM platform that can be used for onboarding sequences and product-activity-triggered emails. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'wcHZviFlGpn1gEIXIGpHv',
                type: 'Asset',
                createdAt: '2021-08-16T22:15:49.212Z',
                updatedAt: '2021-08-16T22:15:49.212Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Chat onboarding graphic',
                description: 'Chat onboarding graphic',
                file: {
                  url: '/img/contentful/wcHZviFl-fruasyutiadhjxkkl4lg.webp',
                  details: {
                    size: 36312,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: 'FruASyUTiadhJXkkl4Lg',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Chat onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'What about chat? With chat, you can send customized messages to new users and customers that are relevant based on the actions they’ve already taken (or haven’t taken).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '16. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.drift.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Drift',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: chatbots that target individual customer accounts and segments',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While largely designed for modern sales teams, Drift can be utilized for customer onboarding as well. After all, converting someone into a customer is only half the battle. You need to retain them. With chatbots and email bots that target individual companies as well as segments, you can make sure that customers are getting the onboarding experience that best fits their needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '17.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.gosquared.com/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'GoSquared',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: live chat and chat prompts based on real product activity',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'GoSquared offers chat capabilities in their marketing automation platform. This allows you to customize in-app chat messages, such as welcome messages, re-engagement messages, churn reduction prompts, and more.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '18. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.intercom.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Intercom',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: live chat and chat prompts alongside product LMS',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Intercom is a robust solution for user onboarding and has well-known chat features that allow you to send messages and chat prompts to all customers or just a very specific segment. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '19. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://user.com/en/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'User.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: automating the customer journey with a single view of the customer for CS, marketing, and sales teams',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'User.com is a tool for automating the customer journey and is built to be used by sales teams, customer success, product, and marketing. You can send chat messages to the right person, from the right person at scale.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1y25a5ABWdAyXjpbttmKKf',
                type: 'Asset',
                createdAt: '2021-08-16T22:16:35.954Z',
                updatedAt: '2021-08-16T22:16:35.954Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'SMS onboarding graphic',
                description: 'SMS onboarding graphic',
                file: {
                  url: '/img/contentful/1y25a5AB-orke6gycsp2uwcayu6nv.webp',
                  details: {
                    size: 35273,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: 'orKE6GYcSp2UwCaYU6NV',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'SMS onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Not every SaaS company sends text messages to their new customers and users. In fact, many don’t. But there are some cases where texts are really important, or where customers might even expect them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Certain small business apps can be a fit for SMS onboarding, since small business owners might be more likely to engage via text than enterprise customers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Also, any SaaS product with a valid reason to send transactional updates via SMS might benefit from SMS onboarding sequences as well, just to get customers acquainted with how these text updates and confirmations will work.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '20. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://customer.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Customer.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: automating SMS alongside emails and push notifications',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While Customer.io also allows you to send targeted emails and push notifications, one of its top features is undoubtedly the SMS communication, simply because it’s hard to find an SMS platform built for software companies. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '21. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.twilio.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Twilio',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Best for: adding SMS as a separate onboarding channel',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The most well known SMS messaging provider, Twilio is used by businesses large and small from many different industries. With Twilio, you can also manage WhatsApp communication.  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '22. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://sakari.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Sakari',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: bringing in SMS communication to your onboarding and marketing campaigns',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Sakari is another great option for an SMS onboarding tool. The platform can send targeted reminders, alerts, confirmations, and marketing campaigns. If you need these sorts of messages for your platform’s service, it can make sense to use the same tool to manage the onboarding SMS sequence.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2o18kLRhe802OwJTSdofi1',
                type: 'Asset',
                createdAt: '2021-08-16T22:17:25.333Z',
                updatedAt: '2021-08-16T22:17:25.333Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'User experience monitoring graphic',
                description: 'User experience monitoring graphic',
                file: {
                  url: '/img/contentful/2o18kLRh-uxk5wtcirubxo8j1qby4.webp',
                  details: {
                    size: 33226,
                    image: {
                      width: 1200,
                      height: 301
                    }
                  },
                  fileName: 'uXk5wtCIRubXo8j1qBy4',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'User experience monitoring and testing tools',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'You want to know how to onboard your customers better, but first you need to know what THEY want. A critical part of onboarding improvement is understanding user journeys, gathering feedback, identifying problems, and finding solutions. These user experience tools can help with customer onboarding.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '23. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.hotjar.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Hotjar',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: shoring up product analytics with behavioral data for a deeper understanding of your users',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Hotjar is a well-known tool loved by marketers and ecommerce companies. It’s great for web applications too, because you can use it to watch real user activity recordings, see heatmaps of product engagement, and find funnel drop-offs. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '24. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.fullstory.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'FullStory',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: discovering onboarding problems and testing new solutions',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'FullStory is an enterprise-ready solution for measuring and improving digital experiences. With FullStory, you can capture recordings of user activity and use real product data to find areas of frustration in order to improve user retention.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '25. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://mixpanel.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Mixpanel',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: capturing product analytics for product, engineering, and onboarding purposes',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A popular solution for product analytics, Mixpanel can help you measure user activity to make product-wide improvements and even find users that are at risk of churn. The product is commonly used for analysis and a/b testing and for triggering personalized messages at scale.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '26. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://mouseflow.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Mouseflow',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: discovering funnel drop offs and popular pathways',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Mouseflow offers session replays, heatmaps, and funnel analytics so product and digital teams can continually improve upon the user experience. Use it to identify onboarding problems and measure the success of your updates.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: '\n',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '27. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.pendo.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Pendo',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: collecting user journey analytics and customer feedback',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Pendo is a comprehensive onboarding tool that offers user onboarding guidance and tours in addition to user journey analytics, feedback collection, and user experience issue monitoring. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '28. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://useriq.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'UserIQ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: monitoring individual customer accounts so CS teams can proactively mitigate churn',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Designed for customer success professionals, UserIQ helps you gather intelligence on individual accounts and send the right messages at the right time in order to reduce churn and strengthen the relationship. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '29. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://usersnap.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Usersnap',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Best for: collecting feedback and discovering issues with the onboarding experience',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Primarily a tool for collecting feedback, Usersnap can be used to discover how effective the onboarding experience truly is. Key features include customer feedback collection and visual QA bug reporting. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While you might not use tools across every category for your customer onboarding, one thing is clear: there’s not one single, all encompassing tool for onboarding. Your company needs to work to continuously build a better onboarding experience…..and perhaps some of these tools can help!  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '484IFnG2dK9LR3qKNt3GtQ',
                type: 'Entry',
                createdAt: '2021-08-16T22:18:16.917Z',
                updatedAt: '2021-08-16T22:18:16.917Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The data import experience is easier than ever',
                ctaText: 'Start for free',
                href: 'https://app.flatfile.com/sign-up'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5SIYbSHWxdcClpE00MZ59K',
    postTitle: 'Decrease Churn: How To Shore Up Relationships',
    seoTitle: 'Decrease Churn: How To Shore Up Relationships',
    seoUrlSlug: 'decrease-churn-how-to-shore-up-relationships',
    seoMetaDescription:
      'A new episode of Customer Success Leader features Sara Lauer, Senior Director of Customer Success at Reflexis Systems, discussing how to prevent customer churn.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-08-31T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2U2bdIgXVfnCXCiLrWsBX',
        type: 'Asset',
        createdAt: '2021-08-13T18:50:16.416Z',
        updatedAt: '2021-08-13T18:50:16.416Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Sara Lauer featured image',
        description: 'Sara Lauer featured image',
        file: {
          url: '/img/contentful/2U2bdIgX-ie9fx5datlekvt5wguey.webp',
          details: {
            size: 71870,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'Ie9fX5DATleKVt5wGuEy',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Sara Lauer featured image',
    summary:
      'Someday, when you finally purchase that Tesla you’ve always wanted, you’ll want someone to walk you through all the features before hitting the road. Things like the cruise control, the wipers, how to connect your phone to the bluetooth, etc. Product professionals like Sara Lauer , Senior Director of Customer ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Someday, when you finally purchase that Tesla you’ve always wanted, you’ll want someone to walk you through all the features before hitting the road. Things like the cruise control, the wipers, how to connect your phone to the Bluetooth, etc.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Product professionals like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Sara Lauer',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/saralauer/'
              }
            },
            {
              nodeType: 'text',
              value: ', Senior Director of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Reflexis Systems, Inc.',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.reflexisinc.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', make sure their customers know everything about the product before putting it in drive (although, they don’t sell Teslas).',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Sara joined me in this episode of Customer Success Leader to discuss',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Why it’s crucial to know all of the stakeholders in the company before pitching a solution',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'The obstacles that get in the way of building strong customer relationships',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How customer success tech has changed',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to get your customers to open up about the value they gain from your product',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6xmQyI9kWAzevpTGOysNjM',
                type: 'Entry',
                createdAt: '2021-08-12T17:13:50.637Z',
                updatedAt: '2021-08-12T17:53:25.577Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Decrease Churn: How To Shore Up Relationships w/ Sara Lauer',
                sounderLink: 'https://embed.sounder.fm/play/102371',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/decrease-churn-how-to-shore-up-relationships-w-sara-lauer/id1528594709?i=1000489739032',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/M2ZiMDE4NWQtMzQ3Ni00NmUyLTgwMzAtZTgyOTcyZGJkZWUy?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/decrease-churn-how-to-shore-up-relationships-w-sara-lauer-77377206',
                spotifyLink:
                  'https://open.spotify.com/episode/6ftyxcKegtTLrxSre2Chfv?si=eaiq8d8sSvylhKtePLon_Q&dl_branch=1'
              }
            }
          }
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5w2aW4rduXViaYw3blh9iC',
                type: 'Asset',
                createdAt: '2021-08-13T18:51:50.178Z',
                updatedAt: '2021-08-13T18:51:50.178Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Sara Lauer',
                description: 'Podcast quote by Sara Lauer',
                file: {
                  url: '/img/contentful/5w2aW4rd-jbgxllhqsywxoqsw3gwv.webp',
                  details: {
                    size: 22787,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'JBGXllhQSywxoqsW3GWv',
                  contentType: 'image/png'
                }
              }
            }
          }
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: ' with your thoughts. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '15mOaUBGVCaiayOUyKUJ4p',
    postTitle:
      'Tablecloth cuts data wrangling issues by 95% with Flatfile’s data importer',
    seoTitle: 'Cutting Data Wrangling Issues by 95% for Tablecloth',
    seoUrlSlug:
      'tablecloth-cuts-data-wrangling-issues-by-95-with-flatfiles-data-importer',
    seoMetaDescription:
      'Learn how Tablecloth relies on Flatfile to cut data wrangling issues and significantly reduce the time it takes to import data, saving tens of thousands of dollars.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Finance'],
    publishDate: '2020-08-27T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6yUwS2GjbvCMEGSDxjrewF',
        type: 'Asset',
        createdAt: '2021-08-11T22:54:52.931Z',
        updatedAt: '2022-01-05T13:46:14.083Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: "Tablecloth uses Flatfile's data importer",
        description: "Tablecloth uses Flatfile's data importer",
        file: {
          url: '/img/contentful/6yUwS2Gj-5thv2vlvrvq7rpylkmru.webp',
          details: {
            size: 160372,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: '5Thv2VLVRVq7rPylKmru',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: "Tablecloth uses Flatfile's data importer",
    summary:
      'The millennial and Gen Z generations want their investments to do more than just make money. This has led to the rise of impact investing – investments made with the intention of generating positive, measurable social and environmental impact along with financial returns. Tablecloth built a complete business intelligence and ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The millennial and Gen Z generations want their investments to do more than just make money. This has led to the rise of impact investing – investments made with the intention of generating positive, measurable social and environmental impact along with financial returns. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://about.tablecloth.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Tablecloth',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' built a complete business intelligence and data science platform founded on sound social science models for impact investors, private equity firms, and foundations. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We’re in the let’s-change-the-world business,” said Kelly Abbott, co-founder and CTO at Tablecloth. “The finance world is full of people who are good at making money. But there is a growing subsection of the industry that cares about more than making a profit. They want to matter.“',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Tablecloth helps impact investors in healthcare, banking, and workforce development and more track and help evolve the environmental and social impact of the companies. Tablecloth leverages their advanced analytics platform to provide consultative services to help identify key metrics and track them as critical elements of a sustainable growth strategy:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Accelerating data analysis by eliminating data wrangling issues',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "Flatfile's data importer streamlines the data download process",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        "Saving tens of thousands of dollars with Flatfile's data importer",
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Accelerating data analysis by eliminating data wrangling issues',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Many of our competitors don’t have the technical proficiency that we do,” said Abbott. “Most are still working with Excel spreadsheets and PDFs. Our tech stack has all these investors communicating together, looking at the same data in real time so they can react to it quickly. We designed our platform around the idea that money needs to flow to what works and any kind of inefficiency is seen as a drag on the future profitability of that investment.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The challenge for Tablecloth arose with a customer base focused on finance metrics, not outcomes-based data analytics. Rather than having customers develop methods for getting Tablecloth the data, the company developed methods for making whatever they provided fit. Flatfile is central to that effort.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'To ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/improving-customer-data-onboarding-flatfile-concierge'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'onboard clients’ data',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', Tablecloth provides them with data download templates, illustrating the kinds of metrics the company would like to analyze. Once they receive the files back, Tablecloth crunches the numbers and provides clients with the reports and analysis needed. The ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data import challenge',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' they faced was the huge variance in types and formats of reports and data files. It resulted in an enormous amount of time spent by their team normalizing, just to load the data into the platform.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "Flatfile's data importer streamlines the data download process",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Unfortunately we were spending a lot of time shaping data,” said Abbott. “With ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', we have a tool that provides immediate input on problem files before we import them. We get nearly instant feedback that we can use to format the data in a different way to quickly correct formatting errors.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile removed the data wrangling issues allowing Tablecloth to focus on areas where they can add the most value.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Just not having that drain on our resources has been really helpful,” said Abbott. “It has made us more contemplative about the data we are asking clients for. We no longer have to avoid asking for data that may require too much time to fix. Flatfile eliminates that problem and has improved our willingness to experiment with different types of data we can incorporate into our analyses. The more time we spend tinkering with different data types, the more likely we are going to uncover the insight that produces additional value in the marketplace. That is indispensable for a startup like us.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Streamlining the data download process while eliminating their data wrangling issues has enabled Tablecloth to dramatically accelerate getting key information to their clients. In an industry that is accustomed to annual reporting, the fact that Tablecloth can turn around results in days is a welcome breakthrough.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "Saving tens of thousands of dollars with Flatfile's data importer",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“Flatfile is a good tool for us,” said Abbott. “We have cut the amount of time we spend wrangling with files by 95%. We basically had all hands working to solve those problems at times. The reduction in effort has saved us tens of thousands of dollars. Flatfile is a really good value for us. We might have been able to build that kind of solution, but it would have taken resources away from other priorities. It was simpler to  buy Flatfile and use it. We’re glad we did.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Tablecloth',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Tablecloth provides consultative services to help identify key metrics and track them as critical elements of your investment strategy. We can track and help evolve the environmental and social impact of the companies you invest in. The Tablecloth platform is built on inclusion, transparency, empowerment, adaptability, and accountability. For more information, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://about.tablecloth.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'https://about.tablecloth.io/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7sF8qOkGNenazpi5CSNtI5',
                type: 'Entry',
                createdAt: '2021-08-11T22:56:04.229Z',
                updatedAt: '2021-08-11T22:56:04.229Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The elegant data import button is here',
                ctaText: 'See it in action',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4ZRgOuIfVBDKc7I8p1y4s3',
    postTitle: 'Customer Success: The Ambassadors of Change Management',
    seoTitle: 'Customer Success: The Ambassadors of Change Management',
    seoUrlSlug: 'the-ambassadors-of-change-management',
    seoMetaDescription:
      'Customer Success Leader podcast #2 with Kristi Faltorusso, Vice President of Customer Success at IntelliShift, on change management and operational efficiency.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-08-25T12:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4iRJRf9QclritrXfDAGt41',
        type: 'Asset',
        createdAt: '2021-08-13T18:53:30.702Z',
        updatedAt: '2021-08-13T18:53:30.702Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Kristi Faltorusso feature image',
        description: 'Kristi Faltorusso feature image',
        file: {
          url: '/img/contentful/4iRJRf9Q-jiokpes9qxs9lhxeeuqh.webp',
          details: {
            size: 67651,
            image: {
              width: 960,
              height: 540
            }
          },
          fileName: 'JiokpES9QXS9lhxeeUQH',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Kristi Faltorusso feature image',
    summary:
      "“I think anybody in a customer success role, you really have to be an ambassador of change management because you're effectively trying to get a company to do something differently than they've done before.  ” - Kristi Faltorusso",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer Success is not just an exit survey or ensuring that messaging is getting through. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/kristiserrano/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Kristi Faltorusso',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' Vice President of Customer Success at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://intellishift.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'IntelliShift ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                'details out how her team is involved from Day Zero through testimonials and references.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What we talk about:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Customer Success partnering with other cross-functional teams.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Driving operational efficiency, and maximizing customer assets. ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'The need for agility in customer success.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1CDYYNipdxtztYOUDKCpkB',
                type: 'Entry',
                createdAt: '2021-08-12T17:12:05.712Z',
                updatedAt: '2021-08-12T17:12:05.712Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Customer Success: The Ambassadors of Change Management w/ Kristi Faltorusso',
                sounderLink: 'https://embed.sounder.fm/play/102372',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/customer-success-the-ambassadors-of-change-management/id1528594709?i=1000488695506',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/OGU2NTc4ZDEtMjYxMi00NTI4LWEyMGQtMWMxNmNhYWFiNWY0?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/customer-success-the-ambassadors-of-change-management-w-kristi-faltorusso-77104113',
                spotifyLink:
                  'https://open.spotify.com/episode/4rKmCeQ6rHpr4LqawPnfZc'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Apple Podcasts',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Spotify',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Stitcher',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Google Play',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Google Podcasts',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' with your thoughts. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7JXbVEGeVVoWkIItmIr1HY',
                type: 'Asset',
                createdAt: '2021-08-13T18:54:31.303Z',
                updatedAt: '2021-08-13T18:54:31.303Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Kristi Faltorusso',
                description: 'Podcast quote by Kristi Faltorusso',
                file: {
                  url: '/img/contentful/7JXbVEGe-sfcv7eqirigkbbzfiue8.webp',
                  details: {
                    size: 23309,
                    image: {
                      width: 1200,
                      height: 628
                    }
                  },
                  fileName: 'SFCv7eqIRiGkbbZfiUE8',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '68tUbbhMG7qMS6EEGdxyiO',
    postTitle: 'The Customer May Not Always Be Right, But They Should Be First',
    seoTitle: 'CS Leader: The Customer Should Always Be First',
    seoUrlSlug: 'the-customer-may-not-always-be-right-but-they-should-be-first',
    seoMetaDescription:
      'Best practices for setting up and maintaining a customer success program from Jeff Breunsbach, Director of Customer Experience, in Customer Success Leader podcast.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-08-25T08:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2xAXOd4QUoixKqXEYtjl6x',
        type: 'Asset',
        createdAt: '2021-08-13T18:57:00.766Z',
        updatedAt: '2021-08-13T18:57:00.766Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Jeff Breunsback feature image',
        description: 'Jeff Breunsback feature image',
        file: {
          url: '/img/contentful/2xAXOd4Q-i0vsr0qdqo6e6nzpsw7q.webp',
          details: {
            size: 533737,
            image: {
              width: 1290,
              height: 675
            }
          },
          fileName: 'i0vSr0QDQO6e6nZPSw7q',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Jeff Breunsback feature image',
    summary:
      "“Businesses now can't necessarily think about transactional elements. They have to think about the fact that the economics of SAAS businesses have changed, and we need that customer to be with us for a long period of time. ” - Jeff Breunsbach",
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For early-stage companies, building the foundation for a customer success program can be a little daunting. It’s not enough to simply push your product out to market. An in-depth understanding of the customer experience is imperative for designing a strategic plan to support and bolster the efforts of the organization as a whole.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Things like market fit, the power behind your sales engine, and identifying the right problem to assure the right solution are all things ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.linkedin.com/in/jeffreybreunsbach/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Jeff Breunsbach',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', Director of Customer Experience at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.higherlogic.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Higher Logic',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', looks at when working with clients. In this episode, Jeff shares his insights on best practices for setting up and maintaining a customer success program.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We talk about:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Steps to stand up a successful customer success program',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'How customer success drives business outcomes',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Challenges that can prevent programs success',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4wDaWA6YNNcpIzq553SHcj',
                type: 'Entry',
                createdAt: '2021-08-12T16:56:51.139Z',
                updatedAt: '2021-08-12T17:10:24.325Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'The Customer May not Always be Right but They Should be First ',
                sounderLink: 'https://embed.sounder.fm/play/102373',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M/episode/MDUyZmQ4NzItNWQ2Ni00ZTdiLWEyNjktZWRlZjQ2YWM5NjAz?sa=X&ved=2ahUKEwjnxILk27TrAhVVCs0KHXr0DOsQkfYCegQIARAF',
                stitcherLink:
                  'https://www.stitcher.com/podcast/customer-success-leader/e/77104115',
                spotifyLink:
                  'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Apple Podcasts',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Spotify',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Stitcher',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Google Play',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Google Podcasts',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:hello@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'hello@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' with your thoughts. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4TAzPwuH9ow6Z3bRYzYYwt',
                type: 'Asset',
                createdAt: '2021-08-13T18:59:17.012Z',
                updatedAt: '2021-08-13T18:59:17.012Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Podcast quote by Jeff Breunsbach',
                description: 'Podcast quote by Jeff Breunsbach',
                file: {
                  url: '/img/contentful/4TAzPwuH-1dzhlhulsdudpmh5tqur.webp',
                  details: {
                    size: 109285,
                    image: {
                      width: 1200,
                      height: 627
                    }
                  },
                  fileName: '1DZHlHulSDuDpmh5Tqur',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '1a0rZN3Pe5MMbq0d1QVy1w',
    postTitle: 'Introducing the Customer Success Leader Podcast',
    seoTitle: 'Data Import & Customer Data Onboarding Insights',
    seoUrlSlug: 'customer-success-leader-podcast-episode-0',
    seoMetaDescription:
      'Insightful resources to help customer success leaders, product managers, and engineers build a seamless data import process ensuring smooth customer data onboarding.',
    category: 'Podcast',
    tags: ['Podcast'],
    publishDate: '2020-08-25T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '33PT3c2aoLB2GyuXOSQDZt',
        type: 'Asset',
        createdAt: '2021-08-12T17:59:26.654Z',
        updatedAt: '2021-08-12T17:59:26.654Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Customer Success Leader Ep 0',
        description: 'Customer Success Leader Ep 0',
        file: {
          url: '/img/contentful/33PT3c2a-ymmomg1it8m4p0nzjvkm.webp',
          details: {
            size: 243067,
            image: {
              width: 1201,
              height: 755
            }
          },
          fileName: 'ymmOmg1IT8m4P0NZjvKm',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Customer Success Leader Ep 0',
    summary:
      'Flatfile introduces a podcast for customer success professionals featuring customer success leaders sharing best practices, advice, and tips.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'According to ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'LinkedIn’s 2020 Emerging Jobs Report',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://business.linkedin.com/content/dam/me/business/en-us/talent-solutions/emerging-jobs-report/Emerging_Jobs_Report_U.S._FINAL.pdf'
              }
            },
            {
              nodeType: 'text',
              value:
                ', customer success professionals are in seriously high demand. With a 34 percent annual growth rate over last year, Customer Success Specialist was ranked 6th in the top 15 emerging jobs in the U.S. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Today we’re excited to launch a new podcast dedicated to the customer success community, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Customer Success Leader',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'http://customersuccessleader.com'
              }
            },
            {
              nodeType: 'text',
              value:
                ". Hosted by Flatfile’s co-founder, Eric Crane, Customer Success Leader is THE place to share ideas, stories and learn more about what it's like to be an effective customer success professional. ",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'In each episode, we speak with a strategic customer success team leader to learn about their best practices, mistakes they’ve made, and everything in between. Listeners can tune in to hear about the ways they can improve the customer experience, the tools they can implement to become a better customer success leader, and tips for creating impactful relationships with customers - at scale. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Take a listen below to hear the why behind the show and what you can expect to get out of future episodes. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2YopbDQggZaQUyeFRmqX3J',
                type: 'Entry',
                createdAt: '2021-08-12T16:35:44.986Z',
                updatedAt: '2021-08-12T17:10:00.214Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Welcome to Customer Success Leader',
                sounderLink: 'https://embed.sounder.fm/play/102374',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/welcome-to-customer-success-leader/id1528594709?i=1000488695505',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M/episode/YTE2ZTIzYTctYTY1My00N2YxLWFjNTctNWFiNDE5MGNkYTdk?sa=X&amp;ved=2ahUKEwjnxILk27TrAhVVCs0KHXr0DOsQkfYCegQIARAF',
                stitcherLink:
                  'https://www.stitcher.com/podcast/customer-success-leader/e/77104116',
                spotifyLink:
                  'https://open.spotify.com/episode/1gqLinprFg6whj8INWjn4f'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Below are the first two episodes of the Customer Success Leader. Give them a listen and let us know what you think by leaving us a rating on Apple podcasts or send feedback to hello@flatfile.io.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: ' Episode one',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value:
                'The Customer May not Always be Right but They Should be First ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Guest: Jeff Breunsbach, Director of Customer Experience, Higher Logic',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'For early-stage companies, building the foundation for a customer success program can be a little daunting. It’s not enough to simply push your product out to market. An in-depth understanding of the customer experience is imperative for designing a strategic plan to support and bolster the efforts of the organization as a whole.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Things like market fit, the power behind your sales engine, and identifying the right problem to assure the right solution are all things ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Jeff Breunsbach',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/jeffreybreunsbach/'
              }
            },
            {
              nodeType: 'text',
              value: ', Director of Customer Experience at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Higher Logic',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.higherlogic.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                ', looks at when working with clients. Jeff shares his insights and best practices for setting up and maintaining a customer success program.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode you’ll learn more about: ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'The steps to stand up a successful customer success program',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'How customer success drives business outcomes',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Challenges that can prevent programs success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4wDaWA6YNNcpIzq553SHcj',
                type: 'Entry',
                createdAt: '2021-08-12T16:56:51.139Z',
                updatedAt: '2021-08-12T17:10:24.325Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'The Customer May not Always be Right but They Should be First ',
                sounderLink: 'https://embed.sounder.fm/play/102373',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/1-customer-may-not-always-be-right-but-they-should/id1528594709?i=1000488695657',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M/episode/MDUyZmQ4NzItNWQ2Ni00ZTdiLWEyNjktZWRlZjQ2YWM5NjAz?sa=X&ved=2ahUKEwjnxILk27TrAhVVCs0KHXr0DOsQkfYCegQIARAF',
                stitcherLink:
                  'https://www.stitcher.com/podcast/customer-success-leader/e/77104115',
                spotifyLink:
                  'https://open.spotify.com/episode/1idrQC7DlscAx7EoSDlt2c'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: ' Episode two ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Customer Success: The Ambassadors of Change Management',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Guest: Kristi Faltorusso, VP of Customer Success, IntelliShift ',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Customer Success is not just an exit survey or ensuring that the messaging is getting through. ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'Kristi Faltorusso',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.linkedin.com/in/kristiserrano/'
              }
            },
            {
              nodeType: 'text',
              value: ', Vice President of Customer Success at ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'IntelliShift ',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://intellishift.com/'
              }
            },
            {
              nodeType: 'text',
              value:
                'details how her team is involved from Day Zero through testimonials, references, and more. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'In this episode, you’ll learn about:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Customer Success partnering with other cross-functional teams',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How to drive operational efficiency and maximize customer assets ',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: 'The need for agility in customer success',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1CDYYNipdxtztYOUDKCpkB',
                type: 'Entry',
                createdAt: '2021-08-12T17:12:05.712Z',
                updatedAt: '2021-08-12T17:12:05.712Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'podcastEpisode'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title:
                  'Customer Success: The Ambassadors of Change Management w/ Kristi Faltorusso',
                sounderLink: 'https://embed.sounder.fm/play/102372',
                applePodcastLink:
                  'https://podcasts.apple.com/us/podcast/customer-success-the-ambassadors-of-change-management/id1528594709?i=1000488695506',
                googlePodcastLink:
                  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGVyLmZtLzk4NTcvcnNzLnhtbA/episode/OGU2NTc4ZDEtMjYxMi00NTI4LWEyMGQtMWMxNmNhYWFiNWY0?sa=X&ved=0CAUQkfYCahcKEwjAtbzu-6vyAhUAAAAAHQAAAAAQAg',
                stitcherLink:
                  'https://www.stitcher.com/show/customer-success-leader/episode/customer-success-the-ambassadors-of-change-management-w-kristi-faltorusso-77104113',
                spotifyLink:
                  'https://open.spotify.com/episode/4rKmCeQ6rHpr4LqawPnfZc'
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Stay tuned for more episodes of the Customer Success Leader and be sure to subscribe to the podcast on Apple Podcasts, iTunes, Google Podcasts, Google Play, Stitcher, and Spotify.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-3',
          content: [
            {
              nodeType: 'text',
              value:
                'Subscribe, listen, rate, and review the Customer Success Leader podcast:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'unordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Apple Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.apple.com/us/podcast/customer-success-leader/id1528594709'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Spotify',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://open.spotify.com/show/5N7h1UbhpPH5lAzHVwhZJ7?si=aaJsVQiQS4617-LBwSvZuA'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Stitcher',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.stitcher.com/podcast/customer-success-leader'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Play',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://play.google.com/music/listen#/ps/I6gdxq6jmsj6febqa6egbbeqkai'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Google Podcasts',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://podcasts.google.com/feed/aHR0cHM6Ly9jdXN0b21lcnN1Y2Nlc3NsZWFkZXIubGlic3luLmNvbS9yc3M='
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Do you have an amazing topic idea or want to suggest a guest who will knock our socks off? Email ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'hello@flatfile.io',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'mailto:hello@flatfile.io'
              }
            },
            {
              nodeType: 'text',
              value: ' with your thoughts. ',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '2nVMY4AmiVXjb5WM4kMtz4',
    postTitle:
      'Oversight Software increases sales by simplifying file import with Flatfile',
    seoTitle: 'Oversight Software Grows Sales by Improving File Import',
    seoUrlSlug:
      'oversight-software-increases-sales-by-simplifying-file-import-with-flatfile',
    seoMetaDescription:
      'Oversight Software used Flatfile to overcome data importer challenges, helping schools simplify the equipment asset management process',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Logistics', 'Supply chain'],
    publishDate: '2020-08-17T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'AohySigY9vkjEhcmrzszh',
        type: 'Asset',
        createdAt: '2021-08-11T23:00:10.672Z',
        updatedAt: '2022-01-05T13:39:15.868Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile customer Oversight',
        description: 'Flatfile customer Oversight',
        file: {
          url: '/img/contentful/AohySigY-escokyqsqq4qfio7v9hz.webp',
          details: {
            size: 175546,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'EsCOKyQSQq4qfio7v9Hz',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile customer Oversight',
    summary:
      'Tracking and managing equipment assets pose a challenge for any organization. It can be particularly difficult for schools whose main focus is teaching and learning, not asset management. Oversight Software , a New Zealand-based company, developed a solution with its cloud-based SaaS platform purpose built for equipment and resource management ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Tracking and managing equipment assets pose a challenge for any organization. It can be particularly difficult for schools whose main focus is teaching and learning, not asset management. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://edu-oversight.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Oversight Software',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', a New Zealand-based company, developed a solution with its cloud-based SaaS platform purpose built for equipment and resource management in a school setting.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Public schools in New Zealand operate on a fixed budget provided by a grant from the government. It is up to each individual school to procure their own equipment and other resources. In most cases, schools lack a cohesive way to manage their physical assets, which can result in equipment going missing and lack of knowledge of what they have or what they really need. This can often lead to an inefficient allocation of limited resources.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Schools use a number of ways to try and gain better control of their equipment assets including electronic spreadsheets and paper records. Others try to adapt existing systems like library checkout systems or accounting packages that aren’t really fit for the purpose of equipment management.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'In this post, we uncover:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Putting a Square Peg into a Round Hole',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Overcoming the Import Obstacle',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Partnering with Flatfile for Future Growth',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Putting a square peg into a round hole',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We realized there had to be a better way,” said John Baigent, co-founder of Oversight. “School administrators were trying to put a square peg in a round hole and the systems they were using weren’t providing a clear picture of what they had and what they needed.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With over a decade of experience in the New Zealand public school system, Baigent and his team created Oversight to simplify equipment asset management for educational institutions. Schools fill out their equipment details and import their data into Oversight allowing them to print barcodes and attach them to their equipment for easy scanning and tracking. Oversight then collects all the data and provides proactive notifications on a regular basis on which items are coming up to expiration and need replacing. This proactive approach prevents costly overruns by enabling schools to procure only the equipment they need and providing one, easy-to-access, central source of information.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Overcoming the import obstacle',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As a startup, Oversight’s top priority is acquiring new customers. Eliminating barriers to closing sales therefore becomes crucial. As they began to reach out to schools to sell their product, Oversight quickly found that getting the schools to import their data properly was becoming a major obstacle. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'They ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/making-a-build-vs-buy-decision-part-1'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'built a basic CSV uploader',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' which allowed customers to hit browse, find their CSV file, and upload their data. The feature included a link to documentation to help customers with properly formatting, but importing data remained a challenge.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We just assumed customers would take the time to learn how to correctly prepare their data for input,” said Baigent. “They would know what columns needed to be in what order and it wouldn’t be much of a hurdle. But obviously it was.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Oversight felt the negative impact of the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/funding-flatfileio-to-remove-barriers-between-humans-and-data'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'importing problem',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' with one of their first customers. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“As soon as our inhouse upload feature went live, the customer just dragged and dropped their entire asset register from a completely different system,” said Baigent. “Our uploader sent out around 2,000 errors they needed to fix. They came back and said it was just too hard and they weren’t interested in engaging with us anymore. We lost the customer because of the data import problem.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Oversight was forced to handle the imports themselves with a manual CSV process and customer files began stacking up. The Oversight team would constantly field inquiries as to when data would be loaded into the system. They quickly realized they needed a much more streamlined way for customers to import their files.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“It was a real pain and we were just wasting so much time,” said Baigent. “We began searching for a solution and found Flatfile and we quickly recognized it as exactly what we needed. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' enables customers to easily upload and import their files without tripping themselves up. The upload solution relies on back end validation rather than client side validation, so it gives us control over how data is formatted and ensures imported data is clean and ready to use.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Flatfile implementation from initial signup to full operation took only a few weeks and customer feedback was overwhelmingly positive.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“I reached out to one customer to touch base to see how they were getting on and they said everything was working perfectly which is awesome,” said Baigent.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Partnering with Flatfile for future growth',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With data importing now so simple, Oversight is able to offer data uploading as a free service for same-day signup - a valuable incentive for onboarding customers quickly. Flatfile is also a crucial component to Oversight as the application user base grows, attracting larger schools, and even some commercial organizations, to use their solution.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We are looking at onboarding schools that range from tiny schools that might only put 20 or 30 bits of equipment into it right up to ones that have 20,000 pieces of equipment,” said Baigent. “There is quite a big scope that we aim to service.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Baigent sees other Flatfile offerings such as ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' with the solution’s collaborative workspace feature as important components to continue to support Oversight’s growth.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We’re always interested in reinventing our software offering,” said Baigent. “As we grow, we’ll be looking at ways to better onboard all these customers at once and then how we can handle renewals and subscriptions. Some of it is pretty manual but the more we can automate, the easier it’s going to be. Flatfile primes us for growth. We aren’t spending precious time reinventing the wheel in terms of file upload, we are spending our time developing features that our customers want to see and subsequently make their jobs easier.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We aim to be a long term customer of Flatfile and wave their flag whenever we can,” Baigent summed up. “We look forward to a long time partnership.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Oversight',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Oversight’s focus is to provide your school with the clarity that comes through oversight of resources, equipment, and assets. This data clarity helps Senior Leaders make effective decisions which in turn ensures the efficient allocation of already scarce resources. For more information, visit our website at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://edu-oversight.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'www.edu-oversight.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or drop us a line at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:info@edu-oversight.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'info@edu-oversight.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5MQfvN3MbKs9zqyZrJ0HqM',
    postTitle:
      'Learn how to create a React CSV data importer in 7 easy steps (video tutorial)',
    seoTitle: 'How to Create a React CSV Importer in 7 Easy Steps',
    seoUrlSlug:
      'learn-how-to-create-a-react-csv-importer-in-minutes-video-tutorial',
    seoMetaDescription:
      'Learn how to create a React (open-source Javascript library) CSV data importer in minutes with this video tutorial from Flatfile.',
    category: 'Product updates & features',
    tags: ['Developers', 'React', 'React CSV importer', 'Video tutorial'],
    publishDate: '2020-08-14T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '49uy68ra3Oq0AI8jhakPuV',
        type: 'Asset',
        createdAt: '2021-08-16T22:58:27.093Z',
        updatedAt: '2022-01-05T14:00:41.364Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Creating a React CSV data importer',
        description: 'Creating a React CSV data importer',
        file: {
          url: '/img/contentful/49uy68ra-fgtjtt0jtayg8qanuqdf.webp',
          details: {
            size: 2363570,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'FgtjTT0JTAyg8QANuQDF',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Creating a React CSV data importer',
    summary:
      'For those familiar with React, an open-source Javascript library, there’s a way to quickly and easily create a React CSV importer in mere minutes. Less than nine to be exact. Watch the video tutorial to see where I go from create React app to a CSV import with Flatfile.',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zy6NxFz9xgrx6ovdBXWl0',
        type: 'Entry',
        createdAt: '2021-08-03T21:41:29.274Z',
        updatedAt: '2021-10-07T00:14:57.450Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 11,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Brent Kulwicki',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5gHUMmtmhkOyjTqpC142cb',
            type: 'Asset',
            createdAt: '2021-05-25T18:42:17.563Z',
            updatedAt: '2021-05-25T18:42:17.563Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Brent_Author_Image',
            description: 'Brent Kulwicki Author Image',
            file: {
              url: '/img/contentful/5gHUMmtm-githubbk.webp',
              details: {
                size: 311303,
                image: {
                  width: 1767,
                  height: 1592
                }
              },
              fileName: 'githubbk.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Engineer'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For those familiar with React, an open-source Javascript library, there’s a way to quickly and easily create a React CSV importer - in mere minutes. Less than nine to be exact. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Below is a video tutorial where I go from create React app to a CSV import thanks to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Flatfile’s data onboarding platform is a drop-in data importer that helps users ingest, structure and validate data in minutes versus weeks. I’ve also outlined the steps. Let’s give it a try! ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Before you begin you’ll need to have a license key. You can ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://app.flatfile.com/sign-up'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'sign up here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' or if you spin up the local demos, you can use GitHub to sign up for your account.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'JXjbR1kO2o56CKGDP9kCV',
                type: 'Entry',
                createdAt: '2021-08-16T22:21:22.411Z',
                updatedAt: '2021-08-16T22:21:22.411Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'video'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'How to create a React CSV importer in under 9 minutes',
                url: 'https://www.youtube.com/embed/slBkgr1eE60'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Let’s also take a moment to check out the complete code example before breaking it down into separate sections.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'NNsWBIFz0rKLR77u3P73o',
                type: 'Entry',
                createdAt: '2021-08-16T22:43:46.607Z',
                updatedAt: '2021-08-16T22:43:46.607Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'React CSV importer',
                language: 'javascript',
                code: "```import React from 'react'\nimport FlatfileImporter from 'flatfile-csv-importer'\n\nconst flatfileConfig = {\n\ttype: 'Contracts',\n\tfields: [\n\t\t{\tkey: 'name', label: 'Full Name' },\n\t\t{ key: 'email', label: 'Email Address' }\n\t]\n}\n\nconst importer = new FlatfileImporter(licenseKey, flatfileConfig)\n\nimporter.setCustomer({\n\tuserId: '12345'\n})\n\nconst launchFlatfile = () => {\n\timporter.requestDataFromUser().then(results => {\n\t\timporter.displayLoader()\n\t\tsetTimeout(() => {\n\t\t\timporter.displaySuccess('Success message!')\n\t\t\tconsole.log(JSON.stringify(results.validData, null, 2))\n\t\t}, 1500)\n\t})\n}\n\nfunction App() {\n\treturn (\n\t\t<div className='App'>\n\t\t\t<header className='App-header'>\n\t\t\t\t<img src={logo} className='App-logo' alt='logo' />\n\t\t\t\t<p>\n\t\t\t\t\tEdit <code>src/App.js</code> and save to reload.\n\t\t\t\t</p>\n\t\t\t\t<button onClick={launchFlatfile}>\n\t\t\t\t\tLaunch Flatfile\n\t\t\t\t</button>\n\t\t\t</header>\n\t\t</div>\n\t)\n}\n\nexport default App```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                "Flatfile's data importer + React: The basics of successful implementation",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 1: NPM Install',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Before implementing flatfile, we need to install the packages using either NPM or Yarn.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '39W1K1EtrEaMjjtIMuUExP',
                type: 'Entry',
                createdAt: '2021-08-16T22:44:47.785Z',
                updatedAt: '2021-08-16T22:44:47.785Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Install Flatfile adapter (npm)',
                language: 'shell',
                code: '```npm install @flatfile/adapter```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'OR',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1Jg5mDFK8Ggt3gmBoXvQoK',
                type: 'Entry',
                createdAt: '2021-08-16T22:45:33.036Z',
                updatedAt: '2021-08-16T22:45:33.036Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Install flatfile-csv-importer (yarn)',
                language: 'shell',
                code: '```yarn install flatfile-csv-importer```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 2: Import Flatfile/setVersion',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Be sure to import the CSV importer into the project file that you intend to use this in. This gives access to the importer and all the',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/developers/sdk/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' SDK references',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " it comes with. Be sure to specify the correct version of Flatfile's data importer. To do this, we need to use",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/sdk/classes/flatfileimporter/#setcustomer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' setVersion',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and specify version 2. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'IMPORTANT NOTE:',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' If you forget to set the version to 2, this will default to version 1 and you will likely see lots of errors. Version 1 is a legacy product that we no longer actively support. Please make sure to set version 2 here. Are you currently on version 1 and want to move to version 2? ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/guides/version-2-migration-guide/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' are the differences between the two and how you can switch. Additionally, check out the full list of 30+ features in ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/flatfile-portal-2-biggest-update-csv-importer/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile Platform.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 3: Use it and provide the license key',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Next let's open an instance of Flatfile importer. We recommend defining it as a variable as you see below. The Flatfile Importer function takes in the license key and the configuration options as its two parameters. If you're following along with the demos we provided and you signed in with GitHub, you’ll notice we’re returning the license key to the demo for you as a URL Parameter. If you don’t go this route, you'll need to grab your license key from the dashboard",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://app.flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' here',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and put it in this function.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '31y8N5v8udNZxC4q2BOlzK',
                type: 'Entry',
                createdAt: '2021-08-16T22:46:21.061Z',
                updatedAt: '2021-08-16T22:46:21.061Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Create new flatfile importer',
                language: 'javascript',
                code: '```const importer = new FlatfileImporter(licenseKey, flatfileConfig)```'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 4: Configuration - type and fields required',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There are two required items for the configuration to work: ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'First is ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'type',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ". This means the type of imports you’re doing. This comes in handy if you use Flatfile's data importer for multiple parts of your application to specify which type of import is happening. ",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The second is ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'fields',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '. The fields configuration is an array of objects, each item in the array is one field or column in your data model. At a minimum, this is where you will define your data model. The only two required keys for each field are ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'key',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' (this should be what you call this data type in your database) and ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                },
                {
                  type: 'bold'
                }
              ],
              value: 'label',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " (this is what your users will see as the field type). We’ll use name and email as the fields here. If you're looking for more details on what else is available to use for the field configuration, check out the",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/fields/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' field configuration section',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' of the docs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '16uc3zrrSa3Kc57OBH353m',
                type: 'Entry',
                createdAt: '2021-08-16T22:47:24.113Z',
                updatedAt: '2021-08-16T22:47:28.430Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Set flatfileConfig',
                language: 'javascript',
                code: "```const flatfileConfig = {\n\ttype: 'Contracts',\n\tfields: [\n\t\t{\tkey: 'name', label: 'Full Name' },\n\t\t{ key: 'email', label: 'Email Address' }\n\t]\n}```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 5: Setting the customer',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "For imports to work properly, you'll have to set the customer/user in order to specify who the user is that’s uploading the file.This helps you identify who belongs to what file for your records, and also, if you've got your Flatfile dashboard set up properly, you'll be able to see the file and user there as well.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '0Mt9CnDLoLP6c0XRlxXov',
                type: 'Entry',
                createdAt: '2021-08-16T22:48:03.095Z',
                updatedAt: '2021-08-16T22:48:03.095Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'importer.setCustomer',
                language: 'javascript',
                code: "```importer.setCustomer({\n\tuserId: '12345'\n})```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 6: Launch the importer',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At a minimum, we need a way to launch the importer (this will be a button or link or some flow from your application that triggers an import), to use the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'requestDataFromUser',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' SDK reference within the importer which returns a promise with the results. We can then take the results and do with them as you please!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While the above is the minimum required to get Flatfile working and processing your files, we recommend you also include two extra pieces of the SDK (and then also check out more of the SDK to see what else you can do). One, we suggest that you use the ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'displayLoader()',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                " function. For a lot of files, this won't make a huge difference for imports, but for larger files that may take a few moments to process, this will give the UI a status bar indicator so that the application doesn't appear to be hung up or unresponsive to a user. The second thing we recommend is adding the ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'displaySuccess()',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' method. This allows you to pass a custom success message to 1) let the user know the upload was successful and 2) closes the importer when they’ve acknowledged the successful import. If this method is not used, the UI hangs on from the last step and the user would need to close out of the importer (using the ‘x’ at the top).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2mibu8m5siVKldQcnYQjZS',
                type: 'Entry',
                createdAt: '2021-08-16T22:55:26.705Z',
                updatedAt: '2021-08-16T22:55:26.705Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Launch Flatfile importer',
                language: 'javascript',
                code: "```const launchFlatfile = () => {\n\timporter.requestDataFromUser().then(results => {\n\t\timporter.displayLoader()\n\t\tsetTimeout(() => {\n\t\t\timporter.displaySuccess('Success message!')\n\t\t\tconsole.log(JSON.stringify(results.validData, null, 2))\n\t\t}, 1500)\n\t})\n}```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The final piece is assigning this function call to some UI element to open the importer. Within the context of a fresh ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'create-react-app',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' instance, we just created a button and called the function onClick, but you could build this into its own component as well.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'q4ioIhG8Md7ljKkeGCFBF',
                type: 'Entry',
                createdAt: '2021-08-16T22:56:16.611Z',
                updatedAt: '2021-08-16T22:56:16.611Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'codeBlock'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                description: 'Open importer from React app',
                language: 'javascript',
                code: "```function App() {\n\treturn (\n\t\t<div className='App'>\n\t\t\t<header className='App-header'>\n\t\t\t\t<img src={logo} className='App-logo' alt='logo' />\n\t\t\t\t<p>\n\t\t\t\t\tEdit <code>src/App.js</code> and save to reload.\n\t\t\t\t</p>\n\t\t\t\t<button onClick={launchFlatfile}>\n\t\t\t\t\tLaunch Flatfile\n\t\t\t\t</button>\n\t\t\t</header>\n\t\t</div>\n\t)\n}\n\nexport default App```"
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Step 7: Returned data',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Once the user has successfully gone through the import process, you’ll have results returned as JSON. In the example, we just logged the results to the console, but you could send them to your server or use them directly within your application here. We also used ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'validData',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', but there are multiple other options for getting the exact data needed on ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'FlatfileResults',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ', such as ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'allData',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                '. Check out the SDK docs for a complete list of those options. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'underline'
                }
              ],
              value: 'Launching Flatfile and matching data accurately',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'At this point the React app looks exactly the same but the basics have been set up for the Flatfile application and we can run Flatfile. We’ll create a button with an onClick event calling the launch function and click on that to launch Flatfile. This will take you into the normal flatfile import flow. Based on how we set this up, when that flow is complete, it will log the flatfile results to the console. Check out the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'developer documentation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' from Flatfile if you need any help. (And learn more about creating a truly ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/optimizing-csv-import-experiences-flatfile-portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'seamless CSV import experience',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' here.) ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7sF8qOkGNenazpi5CSNtI5',
                type: 'Entry',
                createdAt: '2021-08-11T22:56:04.229Z',
                updatedAt: '2021-08-11T22:56:04.229Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The elegant data import button is here',
                ctaText: 'See it in action',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '71RRuYDWprnbbXq5bPJJ3L',
    postTitle:
      'Flatfile helps ClickUp simplify users’ data onboarding experience',
    seoTitle: 'Helping ClickUp Simplify Users’ Data Onboarding',
    seoUrlSlug:
      'flatfileio-helps-clickup-simplify-users-data-import-onboarding-experience',
    seoMetaDescription:
      'By integrating the Flatfile data importer, ClickUp provides an intuitive data import and data onboarding experience for its users.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories'],
    sortOrder: '2',
    publishDate: '2020-08-06T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '1ap6rKQyd86tehMOCPEQon',
        type: 'Asset',
        createdAt: '2021-08-11T23:04:05.423Z',
        updatedAt: '2022-01-05T12:55:34.527Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'ClickUp uses Flatfile for data onboarding',
        description: 'ClickUp uses Flatfile for data onboarding',
        file: {
          url: '/img/contentful/1ap6rKQy-uexks6i5qgcgse6vmzbo.webp',
          details: {
            size: 96127,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'uEXKs6i5QgCgSe6vMzBo',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'ClickUp uses Flatfile for data onboarding',
    summary:
      'ClickUp Powered by Flatfile , the new standard for data import. By integrating Flatfile, ClickUp is able to provide an intuitive data import experience for its users. Flatfile enables ClickUp users’ to bulk-upload tasks, checklists, due dates, time estimates, and more, all from a CSV. ClickUp’s development team was able ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GghDtLBHpcFvmaS00K2bR',
        type: 'Entry',
        createdAt: '2021-05-26T14:15:04.956Z',
        updatedAt: '2022-04-25T20:38:50.331Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Bonilla',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6Vh25O0QaKYZELWrVza7Bs',
            type: 'Asset',
            createdAt: '2021-05-26T14:13:19.152Z',
            updatedAt: '2021-05-26T14:13:19.152Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Bonilla Headshet',
            description: 'David Bonilla Headshot',
            file: {
              url: '/img/contentful/6Vh25O0Q-david-bonilla.webp',
              details: {
                size: 46443,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'david-bonilla.jpg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Growth Marketer',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'ClickUp',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a project management productivity platform that helps anyone from individuals to entire teams create, plan, and organize everything. By integrating ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', ClickUp is able to provide an intuitive data import and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/improving-customer-data-onboarding-flatfile-concierge/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' experience for its users. Flatfile enables ClickUp users’ to bulk-upload tasks, checklists, due dates, time estimates, and more, all from a CSV. This makes ClickUp’s data import onboarding experience incredibly simple for new users. ClickUp’s development team was able to integrate Flatfile over the course of a week, rather than build out a data importer of their own, saving valuable engineering time.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6FsmJri6sxyeR8xQfTvi3t',
                type: 'Asset',
                createdAt: '2021-08-11T23:06:11.583Z',
                updatedAt: '2022-01-05T12:55:02.616Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Screenshot of ClickUp using Flatfile',
                description: 'Screenshot of ClickUp using Flatfile',
                file: {
                  url: '/img/contentful/6FsmJri6-1_5x6azmjbmisdwbloziounw.webp',
                  details: {
                    size: 50422,
                    image: {
                      width: 1366,
                      height: 693
                    }
                  },
                  fileName: '1*5X6AZMjBMisDWbLoziOUnw.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Zeb Evans, CEO of ClickUp, originally discovered ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: "Flatfile's",
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' data import solution and recommended it during ClickUp’s early development stage as the tool of choice for handling user-facing CSV data imports. The team was more than willing to use a turn-key data import solution, rather than build it themselves.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Jerry Krusinski, Back-end Engineer at ClickUp said: “It saved us a big task in implementing a CSV parser ourselves.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Scott Snider, Lead Front-end Engineer at ClickUp said: “I was excited to leapfrog using Flatfile rather than start from scratch on our own.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Integrating Flatfile's data importer proved to be a simple project for ClickUp’s developer team. The Flatfile ",
              nodeType: 'text'
            },
            {
              data: {
                uri: '/developers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'developer documentation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' contains a JSON configurator and snippet to quickly help teams test a Flatfile integration in their application.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'According to Snider: “Everything was pretty easy! Flatfile worked right out of the box. It was a good experience, and the data importer did what we wanted it to do."',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2NupzPWakKyo8XCEiZ2klD',
                type: 'Asset',
                createdAt: '2021-08-11T23:07:08.535Z',
                updatedAt: '2021-08-11T23:07:08.535Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "Screenshot of Flatfile's JSON configurator",
                description:
                  'Flatfile’s simple JSON configurator allows CSV fields to be mapped to specific data models seamlessly. Subsequent CSV data imports from users will adhere to this data model.',
                file: {
                  url: '/img/contentful/2NupzPWa-1_fbrbddtl1lhf-5jn3v1akq.webp',
                  details: {
                    size: 141507,
                    image: {
                      width: 1498,
                      height: 525
                    }
                  },
                  fileName: '1*FBRBddTl1LhF-5jn3V1AKQ.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Flatfile’s simple JSON configurator allows CSV fields to be mapped to specific data models seamlessly. Subsequent CSV data imports from users will adhere to this data model.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s simple configuration and detailed developer documentation allowed the team to fully integrate Flatfile into ClickUp’s angular framework within a week.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Snider went on to say, “It was really easy and didn’t take very long to integrate. We worked on a few custom things, which took at most a few hours a day. A lot of times integrations don’t work right away, but Flatfile worked almost immediately. The developer docs were easy to read and helpful.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Krusinski added: “For the majority of the features, we didn’t work on the integration for more than a week.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The team appreciated the user-friendliness of the Flatfile importer. Its neutral visual interface also helps the data importer blend seamlessly into any SaaS product.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"The thing that I noticed first was the user interface," said Krusinski. "It’s really nice and user-friendly. Flatfile also has a very neutral UI. Even though it’s not our UI specifically, it still visually fits in the product.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5bITcKPZKbQmY1OfVJH4qs',
                type: 'Asset',
                createdAt: '2021-08-11T23:07:59.244Z',
                updatedAt: '2021-08-11T23:07:59.244Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Screenshot of Flatfile UI',
                description: 'Screenshot of Flatfile UI',
                file: {
                  url: '/img/contentful/5bITcKPZ-1_pgeirwnyqn20by0g4bz97g.gif',
                  details: {
                    size: 1956490,
                    image: {
                      width: 1596,
                      height: 782
                    }
                  },
                  fileName: '1*PGEirWNYQN20BY0g4BZ97g.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'On top of requiring little to no upkeep, the team has benefited tremendously from Flatfile’s handling of support requests, and frequent improvements to the data importer, areas they would have been unable to focus on themselves.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '"Flatfile helped us out with any issues that came up and pushed the appropriate updates quickly whenever we did have an issue. We get imports all the time and never get bug reports.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About ClickUp',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'ClickUp',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a productivity platform that provides a fundamentally new way to work. More than just task management — ClickUp offers notes, reminders, goals, calendar, scheduling, and even an inbox. Fully customizable, ClickUp works for every type of team, so all teams can use the same app to plan, organize, and collaborate. To learn more about ClickUp’s productivity platform, visit',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://clickup.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: ' clickup.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: 'Q0oUK4jLIIIs52JlC40fP',
    postTitle:
      'Flatfile’s data importer saves Digsy AI up to 10 hours per new customer',
    seoTitle: 'Saving Digsy AI 10 Hours per Customer Data Import',
    seoUrlSlug:
      'flatfiles-data-importer-saves-digsy-up-to-10-hours-per-new-customer',
    seoMetaDescription:
      'Digsy.ai relies on Flatfile to effortlessly import customer data in a fraction of the time compared to their custom data importer.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Real estate'],
    publishDate: '2020-08-04T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'rZU6sGUfoRLAfuA6vKxgf',
        type: 'Asset',
        createdAt: '2021-08-11T23:09:35.334Z',
        updatedAt: '2022-01-05T13:01:42.913Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Digsy uses Flatfile for data import',
        description: 'Digsy uses Flatfile for data import',
        file: {
          url: '/img/contentful/rZU6sGUf-jsc0xryrt9iyk4d6a84y.webp',
          details: {
            size: 184333,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'jSc0xRYrT9iYk4d6a84y',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Digsy uses Flatfile for data import',
    summary:
      'Digsy.ai, Powered by Flatfile.io, the new standard for data import. Digsy.ai is a Smart Commercial Real Estate lead generation platform which helps broker teams automate their workflow to accelerate the conversion of prospects into new business leads. With Digsy, real-estate brokers can bulk-upload customer data in the form of a ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GghDtLBHpcFvmaS00K2bR',
        type: 'Entry',
        createdAt: '2021-05-26T14:15:04.956Z',
        updatedAt: '2022-04-25T20:38:50.331Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Bonilla',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6Vh25O0QaKYZELWrVza7Bs',
            type: 'Asset',
            createdAt: '2021-05-26T14:13:19.152Z',
            updatedAt: '2021-05-26T14:13:19.152Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Bonilla Headshet',
            description: 'David Bonilla Headshot',
            file: {
              url: '/img/contentful/6Vh25O0Q-david-bonilla.webp',
              details: {
                size: 46443,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'david-bonilla.jpg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Growth Marketer',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://digsy.ai/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Digsy.ai',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a Smart Commercial Real Estate lead generation platform which helps broker teams automate their workflow to accelerate the conversion of prospects into new business leads.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In this post, we uncover:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Missing critical functionality in a custom data importer',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Manually cleaning data leads to frustration and customer churn',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Flatfile’s column-matching feature to the rescue',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With Digsy, real-estate brokers can bulk upload customer data in the form of a CSV, to help them set up prospects and track lead activities. This import is a key early step for Digsy’s customers, and building a CRM for the real-estate industry meant ingesting files from a variety of data sources, many of which were formatted in an inconsistent manner.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Early on, Digsy created their own data importer for customer data. After spending countless hours of their support team’s time formatting files for upload, however, they knew they needed a solution that would scale at the rate of their own business. That’s when they found ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Meghann Quirante, Product Lead at Digsy.ai said:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    '“Our problem was: how do we get our customers’ existing CRM data which is formatted in all kinds of ways into Digsy? We didn’t want to ‘clean’ their spreadsheets.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Missing critical functionality in a custom data importer ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To address the challenge of getting customer data quickly into their CRM, the Digsy team originally built a custom CSV data importer. Although their homegrown tool got the job done, it was lacking ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/5-must-have-features-for-a-data-importer'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'important functionality',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' needed to truly automate their bulk customer data imports. One crucial missing feature was column-matching functionality.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'According to Quirante: “Our custom tool could flag errors, but it didn’t have a column-matching interface.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Their user base quickly outgrew the custom importer, and uploads were not scalable. Having column-matching functionality in place would reduce manual cleaning performed on imported spreadsheet data. It would also consistently match and format imported CSV data into Digsy — without straining the team’s internal resources, or increasing end-user import friction and frustrations.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'One alternative solution Digsy relied on, was manually placing incoming CSV data into a pre-made spreadsheet template, that would then be uploaded into their application. However, this proved to be inefficient, since their custom data importer required an exact match for the incoming data. The team constantly had to adjust their customers’ CSV data, place it within the premade import template, and finally be able to import the CSV file into Digsy.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“The incoming data was complex, we had to match it to a template, but the import required an exact match. We constantly needed to re-import spreadsheets because of the inefficient matching. It was time consuming!”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While Digsy could have asked their customers to use a pre-made spreadsheet, it would have created significant friction during the new customer experience. So much so, that some customers may reconsider using the platform entirely due to the complexity of importing their data. In today’s SaaS landscape, users expect every step of a service to be seamless from start to finish. Data imports have been historically frustrating due to the countless variables at play.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Manually cleaning data leads to frustration and customer churn  ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Digsy couldn’t take that risk as an early stage startup and instead decided to offer data import as a service for new customers. The team quickly found themselves manually cleaning customer data files prior to importing them. Although they could import up to 3,000 rows using their custom tool, the team had to consistently spend 8–10 hours on fully preparing and importing all their new customers’ data. To their mounting frustration, the Digsy team would clean a customer’s data for hours, only to see the customer churn. Their data import model was, at the time, wholly inefficient.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '“We were spending eight to ten hours helping our customers import their data, and sometimes they would churn," said Quirante. "When it happened, it was a strain on resources.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The Digsy team needed to make a decision. Would they dedicate the development manpower to building column-matching functionality into their custom data importer, or find a tool that provided this functionality?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Flatfile’s column-matching feature to the rescue',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "“When we were looking for solutions, we knew we could either build it ourselves or try to find something. Our product lead at the time heard of Flatfile. He presented it to the team, and ultimately we decided to implement Flatfile's data importer solution. We didn’t see anything else on the market.”",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The team searched high and low for alternatives prior to testing Flatfile, but could not find a comparable data importer that addressed their functionality needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3Gtt9tPWVSlTYzCqLiksOo',
                type: 'Asset',
                createdAt: '2021-08-11T23:11:01.508Z',
                updatedAt: '2021-08-11T23:11:01.508Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Integrating Flatfile data importer',
                description:
                  'Flatfile in action. The data importer can be integrated into any application using a JavaScript snippet. Take Flatfile for a spin at https://flatfile.com',
                file: {
                  url: '/img/contentful/3Gtt9tPW-1_pgeirwnyqn20by0g4bz97g.gif',
                  details: {
                    size: 1956490,
                    image: {
                      width: 1596,
                      height: 782
                    }
                  },
                  fileName: '1*PGEirWNYQN20BY0g4BZ97g.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Flatfile in action. The data importer can be integrated into any application using a JavaScript snippet. Take Flatfile for a spin at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.io/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'https://flatfile.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The team quickly created a Flatfile account, and using the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'developer documentation',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', were able to fully integrate Flatfile into Digsy within one development sprint.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Given that Flatfile is a simple Javascript based CSV data importer, the team was able to fully implement it into their technology stack, which consists of a Ruby on Rails backend, Javascript for the frontend, and a Postgres database.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Digsy’s team appreciates the simplicity of Flatfile, expressing that there is virtually no integration upkeep. At most, the team occasionally needs to manually map a new type of CSV column to Flatfile’s Javascript configuration.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7tIAzxVolfQ7RYqpPeAF1j',
                type: 'Asset',
                createdAt: '2021-08-11T23:11:52.888Z',
                updatedAt: '2021-08-11T23:11:52.888Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "Flatfile's JSON configurator",
                description:
                  'Flatfile’s simple JSON configurator allows CSV fields to be mapped to specific data models seamlessly. Subsequent CSV data imports from users will adhere to this data model.',
                file: {
                  url: '/img/contentful/7tIAzxVo-1_i-eyh00rvasio6372uky0w.webp',
                  details: {
                    size: 30560,
                    image: {
                      width: 954,
                      height: 535
                    }
                  },
                  fileName: '1*I-EYH00RVaSiO6372UKY0w.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Flatfile’s simple JSON configurator allows CSV fields to be mapped to specific data models seamlessly. Subsequent CSV data imports from users will adhere to this data model.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s column-matching feature is by far the most valuable functionality the Digsy team relies on for clean customer data imports. The team enjoys seeing import errors clearly called out, expressing that: ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: '“…it feels like a matching game!”',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' Flatfile’s fuzzy-matching algorithm ensures that over 95% of columns are matched automatically, resulting in less data import friction for everyday users, as well as significant time savings for Digsy’s support team. In addition, column mapping is saved on import, which makes subsequent CSV uploads seamless.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4N2vbCAqhuzsr2reYIlS0x',
                type: 'Asset',
                createdAt: '2021-08-11T23:12:32.699Z',
                updatedAt: '2021-08-11T23:12:32.699Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Bulk adding users',
                description: 'Bulk adding users',
                file: {
                  url: '/img/contentful/4N2vbCAq-1_tgxpymbyzb0bxlepyzbpva.webp',
                  details: {
                    size: 315667,
                    image: {
                      width: 2734,
                      height: 1630
                    }
                  },
                  fileName: '1*tGxpyMbYzB0bxLePyzbPvA.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Digsy',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To learn more about Digsy’s Smart Commercial Real Estate lead generation platform, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.digsy.ai/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'digsy.ai',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or email ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:care@digsy.ai'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'care@digsy.ai',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', and if you would like to sign up use the code DIGSY50 for $15 off per month.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about FFlatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5PGMfEAADSeaO4BkJGT6Y9',
    postTitle: 'Security Bulletin: Privacy Shield',
    seoTitle: 'Data Security Bulletin: Privacy Shield',
    seoUrlSlug: 'data-security-bulletin-privacy-shield',
    seoMetaDescription:
      'With the recent ruling on Privacy Shield, Flatfile remains committed to the highest data security standards.',
    category: 'Data Security',
    tags: ['Data privacy', 'Data security'],
    publishDate: '2020-07-18T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '3JGO5WhgMaUln0k3avaP7B',
        type: 'Asset',
        createdAt: '2021-08-16T23:44:07.627Z',
        updatedAt: '2021-08-16T23:44:07.627Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'data security around the world with Privacy Shield',
        description: 'data security around the world with Privacy Shield',
        file: {
          url: '/img/contentful/3JGO5Whg-motij5jaqcgqpejhhzd4.webp',
          details: {
            size: 130325,
            image: {
              width: 1200,
              height: 876
            }
          },
          fileName: 'MOtiJ5JAQCGQpEjhHZd4',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'data security around the world with Privacy Shield',
    summary:
      'The European Court of Justice’s recent ruling on Privacy Shield invalidated the data-sharing mechanism this week. The court’s decision, combined with their reaffirmation of the use of standard contractual clauses (SCCs), further aligns data transfers between the EU and the United States with the General Data Protection Regulation (GDPR). This ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'abJcxQKzZfgOw0p8sRWkK',
        type: 'Entry',
        createdAt: '2021-08-16T23:43:05.462Z',
        updatedAt: '2021-08-16T23:43:05.462Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'The Flatfile Security Team',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '3wm6GRfLDFWtbufLkAGtO',
            type: 'Asset',
            createdAt: '2021-08-16T23:42:54.269Z',
            updatedAt: '2021-08-16T23:42:54.269Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Flatfile security team illustration',
            description: 'Flatfile security team illustration',
            file: {
              url: '/img/contentful/3wm6GRfL-jztpdeetoyog3itrypbg.webp',
              details: {
                size: 35753,
                image: {
                  width: 1099,
                  height: 928
                }
              },
              fileName: 'jZtpDEeTOyoG3iTryPbg',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://curia.europa.eu/jcms/upload/docs/application/pdf/2020-07/cp200091en.pdf'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'European Court of Justice’s recent ruling on Privacy Shield',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' invalidated the data-sharing mechanism this week. The court’s decision, combined with their reaffirmation of the use of standard contractual clauses (SCCs), further aligns data transfers between the EU and the United States with the General Data Protection Regulation (GDPR). This follows recent efforts in the US to implement similar regulations, most notably the California Consumer Privacy Act, Maine’s Act To Protect the Privacy of Online Customer Information, and Nevada’s Internet Privacy SB 220.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’ve followed speculation over what the resulting economic impact to American and European companies will be. Companies and software users are more focused than ever on data security, even without the oversight of global governments. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' already enforces internal data compliance beyond Privacy Shield requirements including the AICPA SOC2 and HIPAA. In the same ruling invalidating Privacy Shield, another data transfer mechanism, Standards Contractual Clauses, was upheld by the court, so there is ready resolution for American companies who have prioritized data security.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'The ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.commerce.gov/news/press-releases/2020/07/us-secretary-commerce-wilbur-ross-statement-schrems-ii-ruling-and'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'US Department of Commerce',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and the ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://edps.europa.eu/press-publications/press-news/press-releases/2020/edps-statement-following-court-justice-ruling-case_en'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'EU Data Protection Supervisor',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' have released statements in light of the European Court of Justice’s ruling. In the meantime, you can expect the team here at Flatfile to continue holding our security to a higher standard than any singular certification. Flatfile provides standard contractual clauses to meet the data processing requirements of the European Commission if this is a requirement for your business. If you would like to request a SCC or have any questions, please reach out to hello@flatfile.io.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our team’s first priority is, and always will be, data security.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5db2Ro8QKS7STIt505cXsy',
    postTitle: 'Welcoming our new investors to Flatfile',
    seoTitle: 'Welcoming Our New Investors to Flatfile',
    seoUrlSlug: 'welcoming-our-new-investors-to-flatfile',
    seoMetaDescription:
      'Our new VC funding will be used to accelerate customer acquisition and launch its our enterprise focused data onboarding offering',
    category: 'Flatfile news',
    tags: ['Concierge', 'Funding'],
    publishDate: '2020-06-10T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7BARXTomcznQdMCm98jme1',
        type: 'Asset',
        createdAt: '2021-08-16T23:49:49.154Z',
        updatedAt: '2022-01-05T13:50:43.841Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile team',
        description: 'Flatfile team',
        file: {
          url: '/img/contentful/7BARXTom-ktnopxvzsqv5yxx94jot.webp',
          details: {
            size: 462775,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'ktNOpxVzSQV5yXX94jOT',
          contentType: 'image/jpeg'
        }
      }
    },
    featuredImageAltText: 'Flatfile team',
    summary:
      'And excited to announce our latest data onboarding offering Startup life is mostly a blur of solving profoundly difficult challenges, building, fixing, selling, and occasionally, sleeping. Scaling an idea into a vision, that vision into reality, and reality into success takes an incredible amount of commitment and dedication from',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We're also excited to announce our latest data onboarding offering",
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Startup life is mostly a blur of solving profoundly difficult challenges, building, fixing, selling, and occasionally, sleeping. Scaling an idea into a vision, that vision into reality, and reality into success takes an incredible amount of commitment and dedication from unequivocally talented people.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the year since we launched Flatfile, I’ve had the rare opportunity to watch a team form out of some of the best craftspeople I’ve ever met. Their energy, and astoundingly hard work has paid off with incredible results in the product, its growth, and our customer experience. Less than a year ago, a handful of some of the best early-stage funds in the world made a two million dollar bet on these people.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'A year ago, we were just getting started. Today, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.prnewswire.com/news-releases/flatfile-raises-7-6m-from-two-sigma-ventures-googles-ai-fund-and-others-to-make-data-onboarding-easy-for-enterprises-301073745.html'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'I’m thrilled to announce $7.6m in fresh funding',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' led by ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://twosigmaventures.com/blog/article/announcing-our-investment-in-flatfiles-7-6m-seed-round/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Two Sigma Ventures',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', with participation from Gradient (Google’s AI Fund), and nearly a dozen other incredible funds and individual investors I’ll share more on in a second.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Great investors don’t just write checks, they breathe fire on everything that might stop you. From the first pitch with Frances Schwiep and her team at Two Sigma Ventures, we recognized the same level of energy and conviction we see on our team every day. I’m proud to welcome Frances to our board of directors, adding another vote of confidence in each person on this team.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We have already started deploying the new investment in a couple of key ways. First, today we are officially launching ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' into beta today. Over the past year, we’ve learned from our customers how critical effective data onboarding is for their enterprise clients. Flatfile’s data onboarding platform (our “elegant import button”) works well in cases where an end user can self-serve through data import, and with Flatfile’s data onboarding platform, we’re releasing a more robust solution for complex data onboarding projects.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s data onboarding platform is designed for inter-company data sharing and collaboration. Within highly secure workspaces, you can request, share, and iterate on imported data with your customers, vendors, or any other third party. Further, there’s no code required to get started, meaning that the customer success, implementation, and services professionals often leading the data onboarding charge can jump right in. If this sounds familiar to you, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/product/concierge/#waitlist'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'join our waitlist',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and we will schedule an interview to learn more!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1XJWIKGUJFnO39sr93fLyI',
                type: 'Asset',
                createdAt: '2021-08-16T23:45:16.420Z',
                updatedAt: '2022-01-05T13:50:15.217Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile’s data onboarding platform',
                description: 'Flatfile’s data onboarding platform',
                file: {
                  url: '/img/contentful/1XJWIKGU-gb1mchk9r8ia84lajbza.webp',
                  details: {
                    size: 406038,
                    image: {
                      width: 1920,
                      height: 1080
                    }
                  },
                  fileName: 'gB1MChk9R8iA84lAJbza',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Second, along with rolling out Flatfile’s data onboarding platform, we are using our new funding to quickly expand our (distributed) team. Building beautiful, human-centric experiences to remove the barriers between people and data is not easy. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/about/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'We’re searching for diverse perspectives',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' and a desire to solve some of the most unique challenges at the intersection of data and design. Even if the role you’re looking for is not listed, I encourage you to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://boards.greenhouse.io/flatfileio/jobs/4046285003'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'submit a general application',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '; we review them all. We would love your support in making all data accessible and usable.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Finally, we want to give a few shout outs. First, to our customers for your support and feedback. We’re thrilled you share our passion for improving the human experience of working with data. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Next, to our entire investor team for believing in that passion and our vision. We’re looking forward to continued collaboration with the teams at Gradient, Afore, Designer Fund, and Founder Collective, and excited to get started with Quiet Capital, HNVR, Work Life Ventures, Basecamp Fund, and Soma Capital. We’re also grateful for the support and investment from a handful of experienced founders and angel investors such as Nat Turner & Zach Weinberg (founders of FlatIron Health), Nitesh Banta (founder of B12), and David Phillips (founder of Hackbright).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'And finally, to my co-founder Eric, and this amazing team: JP, Nate, Randy, Elizabeth, Daniel, David, JK, Robbie, Jill, Matt, Dylan, Sheila, and Amber, thank you for your support.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Additional sources covering our raise:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'TechCrunch: ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://techcrunch.com/2020/06/10/flatfile-scores-7-6m-seed-investment-to-simplify-data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'https://techcrunch.com/2020/06/10/flatfile-scores-7-6m-seed-investment-to-simplify-data-onboarding/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'VentureBeat: ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://venturebeat.com/2020/06/10/flatfile-raises-7-6-million-for-ai-that-extracts-and-transforms-spreadsheet-data/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'https://venturebeat.com/2020/06/10/flatfile-raises-7-6-million-for-ai-that-extracts-and-transforms-spreadsheet-data/',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4HbsSjO3IEZZFpcrQRycC4',
                type: 'Entry',
                createdAt: '2021-08-16T23:00:28.669Z',
                updatedAt: '2021-08-16T23:00:28.669Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'The elegant data import button is here',
                text: 'See it in action',
                ctaText: 'Request a demo',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4LjNC8QcvUXnW86Np77OZ2',
    postTitle:
      'Building a seamless CSV import experience with Flatfile’s data onboarding platform',
    seoTitle: 'Building a Seamless CSV Import Experience with Flatfile',
    seoUrlSlug: 'optimizing-csv-import-experiences-flatfile-portal',
    seoMetaDescription:
      'CSV import is broken. Messy data, edge cases, encoding formats, error resolution, non-technical users: It’s a pain! The Flatfile Data Exchange Platform can help.',
    category: 'Product updates & features',
    tags: ['CSV import', 'Flatfile features'],
    publishDate: '2020-05-22T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7FFQRaJEbYM1CFgLopj84o',
        type: 'Asset',
        createdAt: '2021-08-17T20:29:00.050Z',
        updatedAt: '2021-12-09T11:22:08.391Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Building a seamless CSV import experience with Flatfile',
        description: 'Building a seamless CSV import experience with Flatfile',
        file: {
          url: '/img/contentful/7FFQRaJE-w3k9olftsq8pqmegonlf.webp',
          details: {
            size: 1120494,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'W3K9olFTSq8pQMEGoNLF',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Building a seamless CSV import experience with Flatfile',
    summary:
      'CSV import is broken. Messy data, edge cases, encoding formats, error resolution, non-technical users: it’s a huge pain! As a result, it’s been long neglected as a software product experience, leading to user frustration and wasted cycles rebuilding what those users already expect to have. It’s a major distraction for ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GghDtLBHpcFvmaS00K2bR',
        type: 'Entry',
        createdAt: '2021-05-26T14:15:04.956Z',
        updatedAt: '2022-04-25T20:38:50.331Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Bonilla',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6Vh25O0QaKYZELWrVza7Bs',
            type: 'Asset',
            createdAt: '2021-05-26T14:13:19.152Z',
            updatedAt: '2021-05-26T14:13:19.152Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Bonilla Headshet',
            description: 'David Bonilla Headshot',
            file: {
              url: '/img/contentful/6Vh25O0Q-david-bonilla.webp',
              details: {
                size: 46443,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'david-bonilla.jpg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Growth Marketer',
        department: 'Growth'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'CSV import as a process, is broken. Messy data, edge cases, encoding formats, error resolution, non-technical users: importing data into applications is a huge pain! Ingesting data has been long neglected as a software product experience, leading to customer frustration and wasted engineering cycles rebuilding what those users already expect to have. It’s a major distraction for product teams focused on building core differentiating features.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We’re going to look at problems with turning messy spreadsheets into structured product data, how it’s typically addressed, and how Flatfile’s data onboarding platform solves the technical and user experience challenges inherent in CSV, XLS, XLSX, or XML file imports:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'ordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Building vs buying a CSV Importer',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Common problems with CSV import experiences',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Introducing Flatfile’s data onboarding platform: The elegant import button for web apps',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'CSV import issues',
                      marks: [],
                      data: {}
                    }
                  ]
                },
                {
                  nodeType: 'unordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Unclear Guidance',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Maxing Browser Memory Limits',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Vague Errors',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value: 'Inefficient CSV Column-Mapping',
                              marks: [],
                              data: {}
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Building a seamless CSV import experience with Flatfile’s data onboarding platform',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'WfpX0m5fZsmd5OpyrudDa',
                type: 'Entry',
                createdAt: '2021-08-16T23:52:04.946Z',
                updatedAt: '2021-08-16T23:52:04.946Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'Ready to get rid of CSV templates?',
                ctaText: 'Learn more',
                href: '/'
              }
            }
          },
          content: []
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Building vs buying a CSV importer',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If you’re a software developer and have built a CSV parser before, you know how frustrating it is to dedicate valuable engineering sprints to just one component of the customer onboarding. Building an entire CSV importer means addressing user experience and technical edge cases that result from involving humans in a highly technical ETL process. Trying to bake in more advanced functionality such as CSV validation, data normalization, column-matching, or even refining the interface itself results in developers building an entirely new product, before the first one is finished!',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In most cases, developers attempt to work around this friction by providing users with FAQ documentation or tutorials (even in video!) that show them how to correctly use their data importer. Another popular “solution” is to provide pre-made CSV templates, and then ask users to manipulate their data to fit this data model prior to uploading data. However, doing this merely shifts the burden of work to the end user for a problem the product should solve. The last thing customers want - especially as a new prospect - is to sift through lengthy CSV import documentation or even watch video tutorials to import a simple spreadsheet.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It shouldn't be your users' job to figure out why your CSV importer isn't working.",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Ultimately, customers rely on your product to extract value from it. Asking them to do extra work - whether it be using a spreadsheet template, watching a video, or reading a support article - before they’ve even seen your application working with that data is detrimental to their assessment of your product’s value.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Moreso, investing development sprints to fix an outdated data importer, or worse, building a CSV importer from scratch is now a pain of the past. Today, we’d like to plug Flatfile’s data onboarding platform, which allows engineering and product teams to revamp their entire data import flows not in weeks or months, but in minutes. Did we mention you’d save thousands of dollars in development costs?',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Common problems with CSV import experiences',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Importing CSV data is often one of the first interactions users have with a software application, especially “empty box” products. Unfortunately, there are too many ways that this data import experience can cause customer frustration, or worse, churn.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'For users, an inefficient importer experience will cause them to question the value of the product itself.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "“If the app can’t import my data easily now, what's going to happen once my data’s finally uploaded?”",
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3VW9jN15qxDxczzyCWi5m7',
                type: 'Asset',
                createdAt: '2021-08-16T23:53:03.274Z',
                updatedAt: '2021-08-16T23:53:03.274Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'CSV import errors',
                description: 'CSV import errors',
                file: {
                  url: '/img/contentful/3VW9jN15-bdiovlssyv4unw5owciw.webp',
                  details: {
                    size: 535984,
                    image: {
                      width: 1200,
                      height: 853
                    }
                  },
                  fileName: 'bdIOVLSSyv4UNW5owcIw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Your customers shouldn’t have to battle with these kind of CSV import errors (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In addition to frustrating end-users, an inefficient CSV importer strains internal team resources. Not only have you invested significant engineering time trying to build what is essentially a second product for your application, now you’re spending time dealing with:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Emails and support tickets from frustrated customers who can’t import their spreadsheets into your system.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Import errors, which your team has to manually clean in your database backend before it’s usable in your product.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'A never-ending string of data quality problems, due to lack of data normalization.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is generally not a good position to be in as a data-driven product. Users expect a seamless customer onboarding experience; their goal after converting, is really just to import their data. You of course, really want them as a customer. To make sure you meet expectations, your internal team will handle the manual work of formatting and cleaning imported data for those customers. Congratulations on your new role as a data janitor.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'What’s worse, all that effort you spent building your CSV importer could have been dedicated to building differentiating product features that move you forward in the market.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/flatfiles-data-importer-saves-digsy-up-to-10-hours-per-new-customer'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Digsy.ai shared their experience',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' with handling data imports for their real-estate CRM product prior to integrating Flatfile’s data onboarding platform. Not only was the team strained on resources from building and maintaining a proprietary data importer, Digsy’s engineers spent ten or more hours per new user cleaning up and formatting incoming customer data. Occasionally, these users would churn, rendering all that work fruitless.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Thankfully, there's an out-the-box CSV importer that can do all this on its own, and with just a few lines of code.",
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Introducing Flatfile’s data onboarding platform: The elegant import button for web apps',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'We call it ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', and it was born out of frustration from continuously re-building CSV importers, parsers, and uploaders. Flatfile provides data normalization, CSV auto-column matching, CSV validation, and a modernized UI component with a few lines of JavaScript. Many of our customers implement Flatfile in as little as a day: a massive improvement over 3-4 engineering sprints with continuous maintenance tacked on.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6pERkxMUctQ2De1AL1b2Rk',
                type: 'Asset',
                createdAt: '2021-08-16T23:54:03.419Z',
                updatedAt: '2021-08-17T15:28:35.515Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile portal animation',
                description:
                  'An illustration of some of the more frustrating CSV import experiences users have and how Flatfile Portal fixes them. (Source: Flatfile)',
                file: {
                  url: '/img/contentful/6pERkxMU-iedcrkdrm3iiptekqcmw.webp',
                  details: {
                    size: 6378029,
                    image: {
                      width: 1280,
                      height: 720
                    }
                  },
                  fileName: 'ieDCRkDRm3iiPTEkQCmw',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'An illustration of some of the more frustrating CSV import experiences users have and how Flatfile’s data onboarding platform fixes them. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Let’s look at issues associated with traditional CSV import experiences and how Flatfile’s data onboarding platform addresses them.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV import issue #1: Unclear guidance',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Users tend to struggle with CSV imports, and usually have questions before the CSV is even uploaded. Here are questions users may ask during an import:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Can I upload XLS, XLSX, or XML files?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What is UTF-8 encoding?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'What if my file is 9.7 MB?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Is it a problem if my file has special characters in column headers?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'What happens if my spreadsheet columns don’t match the required fields?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'How do I fix my data? Do I need to save a duplicate CSV and upload that file instead?',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Unless your users spend a lot of time exporting and importing spreadsheets, they’re not going to think about these situations until the moment they import their data.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "It shouldn’t be up to your users to read through intimidating data import documentation or watch a 15-minute tutorial on how to import spreadsheets into your product. Surprisingly, developers aren't spared either! Although engineers understand the complexities of importing data into an advanced system (like ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://docs.microsoft.com/en-us/azure/machine-learning/studio/import-data'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Microsoft Azure',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                '), there is still an exhaustive amount of content they need to ingest before their first import even happens.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2MOLgF1pdr2b34t8N6rMfB',
                type: 'Asset',
                createdAt: '2021-08-16T23:55:17.976Z',
                updatedAt: '2021-08-17T15:28:46.868Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Microsoft Azure import documentation',
                description:
                  'A highly technical product like Microsoft Azure attempts to reasonably present developers with extensive documentation for importing user data. (Source: Microsoft Azure)',
                file: {
                  url: '/img/contentful/2MOLgF1p-y7nx4qfvt9c72qexl1lw.webp',
                  details: {
                    size: 231383,
                    image: {
                      width: 1200,
                      height: 664
                    }
                  },
                  fileName: 'y7nX4QfvT9C72Qexl1Lw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A highly technical product like Microsoft Azure attempts to reasonably present developers with extensive documentation for importing user data. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://docs.microsoft.com/en-us/azure/machine-learning/studio/import-data'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Microsoft Azure',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Your product experience should make it simple to import CSV data without requiring users to become data scientists. The same goes for the technical understanding required to build a CSV importer to begin with, a goal we’ve dedicated reaching with ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here’s an example of a simplified CSV import solution for a CRM from Flatfile’s data onboarding platform, created in less than an hour complete with complex data validation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3vvPvxnIkWvkRlfpLRD8nq',
                type: 'Asset',
                createdAt: '2021-08-16T23:56:15.589Z',
                updatedAt: '2021-08-17T15:28:56.959Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile sandbox screenshot',
                description:
                  'A demo of how Flatfile Portal helps software engineers quickly build a data importer with a few lines of JavaScript. (Source: Flatfile)',
                file: {
                  url: '/img/contentful/3vvPvxnI-cfrmu4z3re6xnh28y9mx.webp',
                  details: {
                    size: 44699,
                    image: {
                      width: 1111,
                      height: 765
                    }
                  },
                  fileName: 'cFRMU4Z3RE6XnH28Y9Mx',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'A demo of how ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Flatfile’s data onboarding platform',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' helps software engineers quickly build a data importer with a few lines of JavaScript. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.flatfile.io/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform is standardized, responsive, and customizable to specific branding needs. With Flatfile, users will instantly know to:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Import their data using a CSV or XLS.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Match their spreadsheet columns in the next step, (if Flatfile’s data onboarding platform 95% fuzzy-matching doesn’t catch it the first time.)',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Click “Continue” to begin their data upload.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There’s no need to overwhelm the user with warnings about file encoding, incorrect date formats, or what fields are required. Flatfile’s data onboarding platform solely focuses on importing CSV data from the user, and making it a delightful experience during this first touchpoint. Mapping columns and validating data will be completed at a later stage once the importer has matched the spreadsheet header columns using human-in-the-loop machine learning.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform JS configuration allows data models to be replicated in minutes instead of weeks. The label matches a CSVs column name, and the key is how you’d like the imported data to be saved in the JSON output. Flatfile’s data onboarding platform also provides powerful validation options to work with any data model, and supports regex, data normalization, and server callbacks for those unique validation use-cases.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once the data model has been built into the JavaScript config, all that needs to be done is to trigger the importer from within your product, typically by way of a button through a JavaScript call. If your application can execute JavaScript, you can integrate a truly modernized CSV importer, in minutes.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Not only is Flatfile’s data onboarding platform engineer-friendly, end-users will massively benefit from the modernized UI that guides them through a set of simple tasks. A sharp contrast from the spreadsheet import experience we’ve all grown accustomed to going through. It’s no wonder everyone from firefighters to city government officials rely on Flatfile’s data onboarding platform for data imports.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV import issue #2: Maxing browser memory limits',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                "Let's assume that your users have successfully exported their data from another CRM and compiled it into a CSV file on their own. Then, they initiate an upload using your product’s data importer.",
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'However, after watching the upload progress for what feels like an eternity, they receive the dreaded “Upload Failed” message. Something all too common with custom data importers.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It’s often why online forums and website support centers contain question-and-answer content like this one from ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://help.go1.com/en/articles/1785527-why-has-my-csv-upload-failed'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'the Go1 website',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ':',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4LlNfBACVpo13vtR0lUHyS',
                type: 'Asset',
                createdAt: '2021-08-16T23:57:05.899Z',
                updatedAt: '2021-08-17T15:29:07.639Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Go1 FAQ screenshot',
                description:
                  'Go1’s support center answers the question “Why Has My CSV Upload Failed?”. (Source: Go1)',
                file: {
                  url: '/img/contentful/4LlNfBAC-d2xoprzaqhq6wqmebxdb.webp',
                  details: {
                    size: 93948,
                    image: {
                      width: 1111,
                      height: 642
                    }
                  },
                  fileName: 'D2xoPRZAQHq6wQMEBxDb',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Go1’s support center answers the question “Why Has My CSV Upload Failed?”. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://help.go1.com/en/articles/1785527-why-has-my-csv-upload-failed'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Go1',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Or this one on ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.nimble.com/en/articles/1571813-why-am-i-getting-an-error-message-when-uploading-my-csv-file'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'the Nimble website',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ':',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '14WdMWXYxU2Q9hVdjuGSPm',
                type: 'Asset',
                createdAt: '2021-08-16T23:58:05.278Z',
                updatedAt: '2021-08-17T15:29:16.843Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Nimble FAQ screenshot',
                description:
                  'Nimble’s support center answers the question “Why am I getting an error message when uploading my CSV file?” (Source: Nimble)',
                file: {
                  url: '/img/contentful/14WdMWXY-9yzxfmdrr6wwdgnnxz86.webp',
                  details: {
                    size: 144929,
                    image: {
                      width: 1200,
                      height: 686
                    }
                  },
                  fileName: '9YZXFmDRR6WwDgNNxZ86',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Nimble’s support center answers the question “Why am I getting an error message when uploading my CSV file?” (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://support.nimble.com/en/articles/1571813-why-am-i-getting-an-error-message-when-uploading-my-csv-file'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Nimble',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Or this one from ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.nurturehq.com/help/why-is-my-csv-file-failing-upload/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Nurture’s knowledge base',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ':',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '65OErvkvgVPcBDtXhBz20E',
                type: 'Asset',
                createdAt: '2021-08-17T15:28:10.818Z',
                updatedAt: '2021-08-17T15:28:10.818Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Nurture FAQ screenshot',
                description: 'Nurture FAQ screenshot',
                file: {
                  url: '/img/contentful/65OErvkv-kd1skfuftlaonkreqzt5.webp',
                  details: {
                    size: 119447,
                    image: {
                      width: 1200,
                      height: 473
                    }
                  },
                  fileName: 'kd1SKfufTLaoNKreQZt5',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Nurture’s Help & FAQs answers the question “Why is my CSV file failing to load?”. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.nurturehq.com/help/why-is-my-csv-file-failing-upload/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Nurture',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Ultimately, this causes your customers to:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Worry about special characters in their CSV files.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'In the case of Nurture, email your team over import issues, ultimately placing additional strain on your support team.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Download and use a spreadsheet template, since their column headers are ‘incorrect’.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'With Flatfile’s data onboarding platform, you and your users won’t have to worry about things like file sizes or formats causing problems during import. Flatfile’s data onboarding platform helps you manage imported data via the browser or through a server-side process, enabling you to split and upload large CSV and Excel files without dropping imported data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5KdrnlTRAVK2TA5ehooYfo',
                type: 'Asset',
                createdAt: '2021-08-17T19:03:54.432Z',
                updatedAt: '2021-08-17T19:03:54.432Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile multiple file demo',
                description:
                  'A Flatfile demo that shows how you can reliably split and import data from multiple files. (Source: Flatfile)',
                file: {
                  url: '/img/contentful/5KdrnlTR-jrah6fqqc6wwzd3qbfpq.webp',
                  details: {
                    size: 28177,
                    image: {
                      width: 672,
                      height: 498
                    }
                  },
                  fileName: 'JRAH6fqQc6wwzD3qbFpq',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A Flatfile demo that shows how you can reliably split and import data from multiple files. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/developers/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Flatfile allows users to import CSV data from multiple files intuitively, without dropping data or doing manual splitting.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' In this demo, users are allowed to upload CSV files containing three different sets of data. Not only will this help make their files more manageable, but it’ll make it much easier for your product team to ingest and organize customer data on your backend into a consistent structure.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV import issue #3: Vague errors',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It’s not just confusing upload instructions or stalled imports that are going to give your users a headache.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Vague error messages don’t provide enough context for users to confidently repair their issues prior to uploading their data. Without specific explanation of the problem, your users are going to be stuck working through every possible fix until they find one that works (if any).',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Take ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://confluence.atlassian.com/jirakb/error-importing-csv-file-issueid-should-not-be-null-431194331.html'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'this reported issue with Jira',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', which has a fully-fledged knowledge base article to help users with this issue:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5MPF9iwPYJn7pK2Stvb2in',
                type: 'Asset',
                createdAt: '2021-08-17T19:14:09.064Z',
                updatedAt: '2021-08-17T19:14:09.064Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Jira knowledge base screenshot CSV error',
                description:
                  'Jira knowledge base tries to help users that see the vague error message that reads “Unexpected failure occurred.” (Source: Jira)',
                file: {
                  url: '/img/contentful/5MPF9iwP-ppjphuzs2shxkq2zd0kt.webp',
                  details: {
                    size: 32309,
                    image: {
                      width: 1105,
                      height: 534
                    }
                  },
                  fileName: 'PPJPhuZS2ShXkq2zD0kT',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Jira knowledge base tries to help users that see the vague error message that reads “Unexpected failure occurred.” (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://confluence.atlassian.com/jirakb/error-importing-csv-file-issueid-should-not-be-null-431194331.html'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Jira',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The full error message reads: ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                '“Unexpected failure occurred. Importer will stop immediately. Data maybe in an unstable state.”',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This isn’t particularly helpful. Not only does the user get a message calling their data “unstable”, but they also have to work through the issue from the vague details provided on this help page. The answer actually includes this as an explanation, which we can assume is only going to add to user frustration:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '“This happens because the JIRA Importers Plugin tries to validate if the issues are valid for importing, and when the validation fails the error above is thrown.”',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Essentially, the plugin is incapable of validating “Required” CSV fields outside of the ones it labels as required. Rather than transmit that message in the importer, users have to figure that out from this knowledge base article.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Customers shouldn’t have to think here.',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' CSV importers should be designed — error messages and all — to make data import a quick and painless experience for users.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'CSV import issue #4: Inefficient CSV column mapping',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The next source of frustration often appears when poor column-matching functionality is in place.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'As an example, let’s say that a ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://mailchimp.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Mailchimp',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' user wants to load as many contact details into the email marketing software as they can. After all, it might be useful to have their business title or phone number on hand for future list segmentation.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'However, initializing the import results in some data being skipped or dropped entirely:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'pryGyVjppKAenh9dbCTJq',
                type: 'Asset',
                createdAt: '2021-08-17T19:17:36.359Z',
                updatedAt: '2021-08-17T19:17:36.359Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Mailchimp import contacts screenshot',
                description:
                  'This is how Mailchimp’s CSV field-mapping system displays unmapped data. (Source: Mailchimp)',
                file: {
                  url: '/img/contentful/pryGyVjp-roajptcqtzgpecepgxep.webp',
                  details: {
                    size: 23877,
                    image: {
                      width: 1067,
                      height: 515
                    }
                  },
                  fileName: 'rOAjPTCQTZGpEcEpgxEp',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is how Mailchimp’s CSV field-mapping system displays unmapped data. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://mailchimp.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Mailchimp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The app doesn’t recognize three of the four spreadsheet columns in our file. In order to keep the unmatched column data, the user has to go through each field and manually assign a matching label that Mailchimp accepts.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This is the case with many products that ingest user data, especially CRMs. Not all data will be used during an import, however the decision to allow custom field submissions in this case should be left to the user; rather than removing their data prematurely.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We know what you’re thinking: “Why not just provide a pre-built spreadsheet template?” However, this is hardly a solution to the problem and will only create more work and frustration for your users. Especially those that bring in thousands of rows of data, or have 40 column headers (yes, we’ve seen it!)',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'The data import experience is easier than ever: ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.io'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Start for free',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The problem here lies within the customer onboarding experience.',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' Optimizing CSV import features within a product has been a difficult and expensive project to take on for product and engineering teams. That’s where Flatfile’s ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/product/portal/'
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'machine-learning, auto column-matching solution comes in handy',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform automatically learns which incoming fields are matched to which columns from each of your users. This results in a ‘human in the loop’ machine-learning experience that is truly unique to your product’s data model. Flatfile’s data onboarding platform will automatically match imported CSV columns to your data model based on user inputs, and consistently learns over time.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The importer also caches column assignments regardless of session, so a user that uploads ten CSV files in a day will get most if not all of their columns matched automatically.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'ClickUp, powered by ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/28-onboarding-tools-for-delighting-new-users/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ', has leveraged human-in-the-loop for its productivity web app.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7pVDJ3mdgVxgqvw82YSk7p',
                type: 'Asset',
                createdAt: '2021-08-17T19:18:15.777Z',
                updatedAt: '2021-08-17T19:18:15.777Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'ClickUp Portal screenshot',
                description:
                  'The main data import modal for users that want to import tasks and projects into ClickUp. (Source: ClickUp, powered by Flatfile Portal)',
                file: {
                  url: '/img/contentful/7pVDJ3md-gkck13hrausu02xrif7i.webp',
                  details: {
                    size: 96140,
                    image: {
                      width: 1200,
                      height: 658
                    }
                  },
                  fileName: 'GkcK13HRAuSU02XRIf7I',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The main data import modal for users that want to import tasks and projects into ClickUp. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ', powered by Flatfile’s data onboarding platform)',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform is designed to help users of all technical expertise. Instructions are clearly provided as to what the user can upload, and the fields required. In addition, Flatfile’s data onboarding platform manual data entry feature allows users to preview what sort of data can be imported into the productivity software. This helps users preserve as much data as possible, rather than realize too late that the data importer didn’t recognize their columns and dropped the data out without any notice.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Configuration flags extend Flatfile’s data onboarding platform functionality even further. For example, the allowCustom flag specifies whether you’d like users to add custom columns during the matching step. Using ClickUp as an example, one could add a column for “Billable”? As a boolean field to track whether a task is billable. Allowing users to place columns on the fly results in a shift of control not seen with legacy CSV importers - shaped by a product’s unique data model requirements.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform column matching step:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2RttHUNyk3Jhdt0ddAz7L5',
                type: 'Asset',
                createdAt: '2021-08-17T19:19:05.810Z',
                updatedAt: '2021-08-17T19:19:05.810Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal column matching screenshot',
                description:
                  'Portal asks users to identify column names for accurate mapping. (Source: ClickUp)',
                file: {
                  url: '/img/contentful/2RttHUNy-p9qoy7qpr8agqvhfmw59.webp',
                  details: {
                    size: 75547,
                    image: {
                      width: 1200,
                      height: 658
                    }
                  },
                  fileName: 'p9QOy7QpR8agQVHfmW59',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile’s data onboarding platform',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' asks users to identify column names for accurate mapping. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This step asks users to indicate where their column names live. This way, the importer can more effectively match them with its own or add labels if they’re missing. Some CSV data may only contain values rather than column headers.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Next, users get a chance to confirm or reject Flatfile’s data onboarding platform column matching suggestions:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4FkqRLwYSTnUquWRNmgdkS',
                type: 'Asset',
                createdAt: '2021-08-17T19:19:58.549Z',
                updatedAt: '2021-08-17T19:19:58.549Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal column matching accept / reject screenshot',
                description:
                  'Portal uses a machine-learning column-matching system to automatically map users’ imported data. (Source: ClickUp)',
                file: {
                  url: '/img/contentful/4FkqRLwY-c4iscszgsugmqfomxdcj.webp',
                  details: {
                    size: 140309,
                    image: {
                      width: 1200,
                      height: 658
                    }
                  },
                  fileName: 'c4iscSZgSUGMQFOMxDCJ',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile’s data onboarding platform ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'uses a machine-learning column-matching system to automatically map users’ imported data. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'On the left, users will find the columns and values they’ve imported. The white tab to the right provides them with automated column matching within ClickUp’s data model. So, “Task” will become “Task name”, “Assignee” will become “Task assignee(s)”, “Status” remains as is and so on.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'If one of the labels in the CSV doesn’t have any match at all, the importer calls attention to it like this:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2Jrrpx4SV7eAXoTB4FvSRw',
                type: 'Asset',
                createdAt: '2021-08-17T19:34:25.729Z',
                updatedAt: '2021-08-17T19:34:25.729Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal no match screenshot',
                description:
                  'Flatfile Portal calls attention to labels or CSV values that don’t have an exact match in a product. (Source: ClickUp)',
                file: {
                  url: '/img/contentful/2Jrrpx4S-sutec7krauikviqmqrgx.webp',
                  details: {
                    size: 4296,
                    image: {
                      width: 883,
                      height: 196
                    }
                  },
                  fileName: 'SuTec7KRauIkVIqMQrGX',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Flatfile’s data onboarding platform',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                ' calls attention to labels or CSV values that don’t have an exact match in a product. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In this example, the Priority response of “High” was detected. But “Medium” was not. However, there’s no need for the user to guess what the correct replacement should be. The importer provides relevant options like “Urgent”, “Normal” and “Low” to replace it with. No need to re-import their CSV, or change the value prior to importing the data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Once all spreadsheet mappings have been resolved, the user can easily “Confirm Mapping” or discard the column altogether if it’s proven unnecessary.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2Z7A6Amtt2LOxG8akTvRpr',
                type: 'Asset',
                createdAt: '2021-08-17T19:35:11.009Z',
                updatedAt: '2021-08-17T19:35:11.009Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal confirm matching screenshot',
                description:
                  'Users get a chance to confirm CSV labels and clean up their spreadsheet results before importing their data. (Source: ClickUp)',
                file: {
                  url: '/img/contentful/2Z7A6Amt-bts4zvjyrhgmsrwebv8a.webp',
                  details: {
                    size: 109814,
                    image: {
                      width: 1200,
                      height: 587
                    }
                  },
                  fileName: 'bTS4zvJyRhGMsrwEbv8A',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Users get a chance to confirm CSV labels and clean up their spreadsheet results before importing their data. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Finally, users get a chance to review any errors detected with their data:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4NVzFJ7Cv6RES6cpBsP3Tb',
                type: 'Asset',
                createdAt: '2021-08-17T19:36:06.031Z',
                updatedAt: '2021-08-17T19:36:06.031Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal validation errors screenshot',
                description:
                  'Validation errors detected in ClickUp’s data import appear in red. (Source: ClickUp)',
                file: {
                  url: '/img/contentful/4NVzFJ7C-hatqznqsrsayqfdo2egw.webp',
                  details: {
                    size: 114553,
                    image: {
                      width: 1200,
                      height: 455
                    }
                  },
                  fileName: 'HaTQzNqsRSaYQFDo2Egw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Validation errors detected in ClickUp’s data import appear in red. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://clickup.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'In this ClickUp example, “Task Name” is triggered with the “isRequired: true” flag which requires users to submit data for that particular column. Whenever any validation fails in Flatfile’s data onboarding platform, you have full control over how error messages are displayed to the user - all inline within the importer.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'The “Only show rows with problems” toggle in the left-hand corner makes error rows easy to spot and address quickly.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'This keeps users from having to:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Review the original CSV file and fix errors before re-importing again.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Import the data and do the cleanup afterwards in the app.',
                      marks: [],
                      data: {}
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'How do you set up this system of column-mapping, CSV validation, and error detection? Flatfile’s data onboarding platform does most of the work for engineers.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6sqnv8WBFN9jmxPDfbZByk',
                type: 'Asset',
                createdAt: '2021-08-17T19:36:59.554Z',
                updatedAt: '2021-08-17T19:36:59.554Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal promo illustration',
                description:
                  'There’s no need to build your data importer from-scratch with Flatfile Portal. (Source: Flatfile)',
                file: {
                  url: '/img/contentful/6sqnv8WB-tld9rjkkqzqzlqerguix.webp',
                  details: {
                    size: 162289,
                    image: {
                      width: 1200,
                      height: 748
                    }
                  },
                  fileName: 'tLD9RJkKQzqZlQeRgUIx',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'There’s no need to build your data importer from-scratch with ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'Flatfile’s data onboarding platform',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: '. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform is configured via a JavaScript code snippet. Any labels, keys, or validation rules specified in this code will be reflected on the customer-facing data importer. This allows for complex validation on things like phone numbers or normalizing multiple date formats:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'Bx4ogokQPLaJhVGXnDjEE',
                type: 'Asset',
                createdAt: '2021-08-17T19:37:43.349Z',
                updatedAt: '2021-08-17T19:37:43.349Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal sandbox screenshot',
                description:
                  'This Portal demo provides the pre-written JavaScript code on the left and a sample of the importer output on the right. (Source: Flatfile)',
                file: {
                  url: '/img/contentful/Bx4ogokQ-h0y051xqrwos24hytjtc.webp',
                  details: {
                    size: 152614,
                    image: {
                      width: 1200,
                      height: 658
                    }
                  },
                  fileName: 'h0y051xQRWOS24hytjTC',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'This Flatfile’s data onboarding platform demo provides the pre-written JavaScript code on the left and a sample of the importer output on the right. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Flatfile’s data onboarding platform is truly a turn-key CSV importer built for SaaS applications. The critical part to integrating Flatfile’s data onboarding platform is configuring the JS snippet to your product’s required data model. In other words, tell Flatfile’s data onboarding platforml what data needs to upload from users, what is the correct value, and whether you’d like them to add their own custom data.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Here’s a JS snippet you might use to customize Flatfile’s data onboarding platform for a basic contact list:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '62Q28Wqp1T2wmkZ41dzfyT',
                type: 'Asset',
                createdAt: '2021-08-17T19:38:36.433Z',
                updatedAt: '2021-08-17T19:38:36.433Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal contact fields',
                description:
                  'An example from Flatfile on how to configure the JavaScript with your own keys and labels for a basic contact list import. (Source: Flatfile)',
                file: {
                  url: '/img/contentful/62Q28Wqp-nscormmasggaj7ymmajv.webp',
                  details: {
                    size: 8809,
                    image: {
                      width: 673,
                      height: 389
                    }
                  },
                  fileName: 'NSCoRMmASgGaj7yMmajv',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'An example from Flatfile on how to configure the JavaScript with your own keys and labels for a basic contact list import. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'You can then use validators to set strict rules for what can appear in the corresponding fields:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'WQVRRvjaa7OE88d0dhf8Z',
                type: 'Asset',
                createdAt: '2021-08-17T20:27:11.260Z',
                updatedAt: '2021-08-17T20:27:11.260Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Screenshot of Portal validators',
                description:
                  'An example from Flatfile on how to code in complex validators including regex for CSV imports (Source: Flatfile)',
                file: {
                  url: '/img/contentful/WQVRRvja-hr3hxnitjq3bpkmyh0kf.webp',
                  details: {
                    size: 7791,
                    image: {
                      width: 670,
                      height: 281
                    }
                  },
                  fileName: 'hR3HXNiTJq3bPkMyH0kF',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'An example from Flatfile on how to code in complex validators including regex for CSV imports. (Source: ',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.flatfile.com'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile',
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: ')',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-3',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'To recap:',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'It’s not easy building a CSV importer in-house. Integrating ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Flatfile’s data onboarding platform',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' allows you to focus on differentiating core features unique to your product’s experience, knowing that the CSV import component is taken care of.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'heading-2',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Building a seamless CSV import experience with the help of  Flatfile’s data onboarding platform',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'One of the reasons we build SaaS products is so customers can effectively manage their businesses without the costly overhead of outsourcing to a third party, or the costly practice of trying to build everything themselves.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Importing data doesn’t need to be the reason for customer frustration or churn during customer data onboarding. It’s easy to see how users can be frustrated with the inconveniences of common CSV import errors. Take advantage of a tool like Flatfile’s data onboarding platform whose sole product focus is designing faster and more seamless data import experiences for your customers, partners, and vendors.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'embedded-entry-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '67zYeeh0Ha0uF1gjAJEGmT',
                type: 'Entry',
                createdAt: '2024-04-09T21:55:35.811Z',
                updatedAt: '2024-07-30T23:58:59.592Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 45,
                revision: 11,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Stop wasting money',
                text: 'Download this free report to discover the missing piece that will help you reduce data errors and maximize revenue opportunities.',
                ctaText: 'Download now',
                href: '/resources/guides/the-missing-piece-in-enterprise-integration/',
                directSignup: false
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '62WbaphOtXbKLK4wNtstQD',
    postTitle: 'The complete guide to customer data onboarding [updated]',
    seoTitle: 'Complete Guide: Customer Data Onboarding for Enterprise',
    seoUrlSlug: 'improving-customer-data-onboarding-flatfile-concierge',
    seoMetaDescription:
      'Customer data onboarding is the process of bringing all of the customers’ required data over to a new software product in order to successfully use it.',
    category: 'Data exchange',
    tags: [
      'Customer experience',
      'Customer onboarding',
      'customer data onboarding'
    ],
    publishDate: '2020-05-22T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7dEB9UShAVDlynlfWOWI9y',
        type: 'Asset',
        createdAt: '2021-08-24T20:22:00.905Z',
        updatedAt: '2021-08-24T20:22:00.905Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Improving the customer data onboarding experience with Flatfile Concierge – Photo',
        description:
          'Improving the customer data onboarding experience with Flatfile Concierge – Photo',
        file: {
          url: '/img/contentful/7dEB9USh-vl3b6yuyqao1wqvyqwr5.webp',
          details: {
            size: 498965,
            image: {
              width: 1200,
              height: 675
            }
          },
          fileName: 'Vl3b6YUYQAO1WqvYQWr5',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Improving the customer data onboarding experience with Flatfile Concierge – Photo',
    summary:
      'Customer onboarding is a critical early stage in the overall customer experience, and customer success teams need to deliver flawless onboarding to ensure a healthy, long-term relationship. But often, onboarding can’t move forward without customer data. Sometimes, customers can’t use your product or get any value out of it if ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2dLBlxtX8ETQllCPJrcdLU',
        type: 'Entry',
        createdAt: '2021-08-13T21:28:19.412Z',
        updatedAt: '2021-10-07T04:32:30.871Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'JK Sparks',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '19PRmT7PwvC39hgE3f445U',
            type: 'Asset',
            createdAt: '2021-08-13T21:27:13.868Z',
            updatedAt: '2021-08-13T21:27:13.868Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'JK Sparks headshot',
            description: 'JK Sparks headshot',
            file: {
              url: '/img/contentful/19PRmT7P-3uyorwrxtfaobczpgisu.webp',
              details: {
                size: 40925,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: '3uYorWRxTfaoBCZpgISu',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Head of Growth Marketing',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer onboarding is a critical early stage in the overall customer experience and companies need to deliver flawless onboarding to ensure a healthy, long-term relationship. But often, onboarding can’t move forward without customer data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customers can’t use your product or get any value out of it if their data doesn’t get migrated properly. They can’t set up marketing automation without their leads. They can’t sell e-commerce products without SKUs. They can’t run payroll without accurate employee or customer profiles.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the world of customer success and onboarding, we often hear about the “aha!” moment, which is the moment when the light bulb goes off and the customer understands the true value of the product. We know how important it is to get there quickly. But what if you have to help your customers ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'migrate tons of data sets',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' over before they even get to “aha!”?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For example, one CRM implementation specialist says that migrating a 100-user account to a new customer relationship management platform can take ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://technologyadvice.com/crm/resources/what-timeline-to-expect-from-crm-buying-process/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: '11 months',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'How can you make customer data onboarding faster?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'If you ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/top-6-data-file-import-challenges-that-companies-face/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'don’t find a way to speed it up',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', customers might churn and sales might lose deals when decision-makers are concerned about migration and no one can alleviate their anxiety.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'This guide will dive deep into the data side of customer onboarding so you can get to the success side faster.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Table of contents:',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'What is customer data onboarding?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Challenges with customer data onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'How does data onboarding fit into the customer onboarding strategy?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Who manages customer data onboarding?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Why customer success teams offer high-touch customer data onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'How customer data gets migrated during high-touch onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The improved process for customer data onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What is customer data onboarding?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer data onboarding is the process of bringing all of the online and offline customer data over to a new software product, in order to successfully use that new purchase. This customer data might be sourced from a previous software vendor as well as offline data sources such as spreadsheets, employee or patient files, and activity logs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For many platforms, customer data onboarding is a necessary first step before use. ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'These are just some of the software verticals that can require complex customer data onboarding:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Ecommerce',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'HR',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Marketing',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'CRM',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Healthcare',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Manufacturing',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In some traditional industries such as healthcare and manufacturing, customer data is very likely to come from manual sources like logs, not just other software vendors.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 's4oX4lfghPUc34JCctZZQ',
                type: 'Asset',
                createdAt: '2021-08-24T20:14:41.978Z',
                updatedAt: '2021-08-24T20:14:41.978Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Clipboard with check marks',
                description: 'Clipboard with check marks',
                file: {
                  url: '/img/contentful/s4oX4lfg-t7enaolgrrewddplvgxg.webp',
                  details: {
                    size: 142237,
                    image: {
                      width: 1200,
                      height: 1204
                    }
                  },
                  fileName: 't7eNaOlgRReWdDplvGxG',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Of course, not every log ever taken will need to be onboarded, but some will. For example, if a food manufacturer is onboarding to a PLM system for the first time, they will need to onboard any manual data for the products that are currently in the innovation cycle.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Challenges with customer data onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When you don’t prioritize customer data onboarding (and don’t make sure it happens quickly), there are several challenges that can frustrate not only your customers but your internal customer success and implementation teams as well.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value:
                        'Lack of data slows the time-to-value for the customer',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' - Customers can’t experience the value of your product quickly which can lead to frustration and churn.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'bold'
                        }
                      ],
                      value:
                        'Inefficient customer data onboarding processes makes life hard for companies',
                      nodeType: 'text'
                    },
                    {
                      data: {},
                      marks: [],
                      value:
                        ' - Customer success managers and implementation specialists want to get results for customers. They’re hands-on, goal-oriented, innovative people. If they’re stuck data-onboarding individual customers, it takes longer to get to do the work they’re passionate about, like diving deeper into advanced product features or improving guides.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s why it’s critical to continually optimize the customer data onboarding process and make it a key part of your customer onboarding strategy.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'How does data onboarding fit into the customer onboarding strategy?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When it comes to customer onboarding strategy, data onboarding often gets left out of the conversation. More often, product managers and customer success managers focus on documentation, guides, training videos, one-on-one phone calls, check-in processes, etc.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Of course, these professionals know that data migration is important, however, they might not know that different tools and processes are available and so they continue to solve this data migration issue by instructing customers with guides and videos.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Let’s take a look at the role data can play in your customer onboarding strategy—whether that be a self-service or high-touch customer onboarding approach.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data migration in self-service customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For self-service customer onboarding, customers need to be able to quickly and easily load up their data into your platform.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When you optimize this customer data onboarding experience and make it as painless as possible for them, the following benefits can occur:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Decreased time to value',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'A reduced churn rate',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Users get to the ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://userpilot.com/blog/the-aha-moment-for-product-onboarding-activation/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'aha” moment',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' faster',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Increased ability to utilize onboarding metrics earlier on (such as usage of certain features, because you’re not waiting as long for customers to touch more meaningful product areas)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data migration in high-touch customer onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With high-touch customer onboarding (meaning that your team is helping the customer onboard their data), the benefits and results of optimizing data onboarding can be even greater, such as:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Decreased time to value',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Better customer experience and increased likelihood of retention',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Customer success manager and customer support staff time savings',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'More Customer Success Managers (CSMs) time allocated to impactful projects and activities (instead of manual customer data onboarding being a continual time suck)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Greater likelihood of customers purchasing more of your company’s products in the future',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Regardless of the price point of your offering, faster and easier data migration has the potential to make a big impact.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s why it should be something that you continually seek to improve upon.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5xrHUGoKTa3UGoOLee1TNk',
                type: 'Asset',
                createdAt: '2021-08-24T20:15:56.637Z',
                updatedAt: '2021-08-24T20:15:56.637Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Concierge illustration',
                description: 'Flatfile Concierge illustration',
                file: {
                  url: '/img/contentful/5xrHUGoK-uf37jsigsqe6hhcgnwjj.webp',
                  details: {
                    size: 265128,
                    image: {
                      width: 1200,
                      height: 1239
                    }
                  },
                  fileName: 'UF37jSigSQe6HhCgnWJJ',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To experience these benefits and make customer data onboarding a key part of your onboarding strategy, a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' can be used. With a data onboarding solution, companies save significant time. Key platform features might include:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Embedding data onboarding directly into your product ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'The ability to collaborate with stakeholders',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Secure data submissions',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Approval workflows',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data normalization',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data validation',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Low code or no code required ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' provides a collaborative, secure data onboarding platform to help companies speed up every part of data migration, from data submission to cleaning.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Who manages customer data onboarding?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Depending on the price point and target user of the software, customer data onboarding will be managed by product managers who seek to make the process easy for customers or by customer success managers and implementation teams who assist with the process hands-on.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Customer support staff might get involved as well, particularly in assisting in the implementation of workflows that product or IT teams have put into place.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Altogether, these are the people who might collaborate to handle data migration for a new customer:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'The customer contact',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'IT staff at the customers’ company',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Senior leaders in the relevant department at the customers’ company',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Customer success manager',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Product manager',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Customer support representative',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'IT engineers or other software developers',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With self-service data migration, your product teams should seek to innovate in ways that make data migration easier for the customer. Otherwise, your ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.profitwell.com/blog/average-churn-rate'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'churn rates',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' will be higher than they should be.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6tP2giM4UidBD7Ar7K0d3q',
                type: 'Asset',
                createdAt: '2021-08-24T20:18:45.533Z',
                updatedAt: '2021-08-24T20:18:45.533Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Screenshot of Mailerlite CSV importer',
                description: 'Screenshot of Mailerlite CSV importer',
                file: {
                  url: '/img/contentful/6tP2giM4-5m0vu1fdsskkac4xbvua.webp',
                  details: {
                    size: 75249,
                    image: {
                      width: 1200,
                      height: 486
                    }
                  },
                  fileName: '5M0VU1fdSsKkaC4xbvua',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Here’s an example of how ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.mailerlite.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Mailerlite',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', a popular email marketing solution with a generous freemium plan, helps users add subscribers manually. Their product team has included multiple options for users:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Import from a CSV or TXT file',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Copy/paste from Excel',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Add single subscriber',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Import from ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://mailchimp.com/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'Mailchimp',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: '',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But what happens when customer data onboarding isn’t so simple? Now let’s explore high-touch onboarding further.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Why companies offer high-touch customer data onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'High-touch customer data onboarding is very different from the Mailerlite example given above, where a user simply uploads a single CSV file and is off to the races.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'With the high-touch experience, some or all of these factors are at play:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Higher priced annual subscription cost',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'A large number of users on the account',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Different user roles and permissions',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Many different data sources to be migrated',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Challenging data formats (could be offline, or CSV files have very different column types and names)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Data sources are owned by different stakeholders',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Large volumes of data (such as a large number of patient profiles, for example)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Highly sensitive data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Regulatory compliance concerns (such as HIPAA or GDPR)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Customers expect custom onboarding',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When working with enterprise customers, a custom, high-touch onboarding experience is necessary. Having an extraordinary onboarding program can even become a key differentiator, helping sales teams close additional deals.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Salespeople can offer certain onboarding-related ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.servicetonic.com/tutorials/customer-based-sla/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'SLAs',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' such as how much time will be dedicated, who will support them, and in what timeframe the customer data onboarding will be completed (assuming the customer holds up to their part of the process by delivering the data in a timely fashion).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'How customer data gets migrated during high-touch onboarding',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'There are a few different options for managing customer data onboarding in a high-touch way.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'These three options get progressively more sophisticated',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ', so consider where your team falls and whether or not it’s time to implement a white glove ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data onboarding tool ',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                'to help migrate data faster without having to involve engineers.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Manually and collaboratively',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Some level of manual and collaborative work will always be involved with customer data onboarding (even when using the methods below). But when you only have manual processes at your disposal, the data onboarding process will undoubtedly take a lot longer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'This work typically includes:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Meeting with your customer contact(s) to discuss the sources of data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Requesting data sources from the customer contact(s) and following up until you have it',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'The customer emailing data to you (this isn’t secure—make sure to use a secure ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'http://flatfile.com/platform/data-onboarding/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'data onboarding workspace ',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: 'instead)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Manually cleaning up the data before uploading it',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Fixing any issues during validation one by one (use AI ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'http://flatfile.com/platform/data-onboarding/'
                      },
                      content: [
                        {
                          data: {},
                          marks: [],
                          value: 'data validation',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [],
                      value: ' instead to make this faster)',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As mentioned above, some manual work will always be required.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Depending on your software product, you might need to have anywhere from one to five phone meetings with your customer contact in order to strategize, decide upon, and gather the appropriate data sources.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If your customer is migrating from old-school, manual methods (not a competitor), then the amount of manual work required from will certainly be higher.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Using custom-built, in-house customer data onboarding tools',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Many product teams build data onboarding tools that are very similar to what SaaS companies build for their customers to use in a self-service capacity. The difference of course is that the product teams build these data onboarding tools for CSMs to use on behalf of the customer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'These custom-built internal tools might include data cleaning and validation.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'However, they don’t usually include a secure onboarding workspace for collaborating with customers, and requesting and receiving data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'But the biggest problem of course, is actually getting something like this built.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'If the company doesn’t have something like this already in place, it can be very challenging to get it prioritized given an engineers’ backlog. Engineers are swamped with customer-facing development needs so internal projects routinely get pushed to the backburner.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'That’s why, if you want to speed up the customer data onboarding process, it might be time to consider a third-party data onboarding tool.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Using a data onboarding solution that is secure, no-code, and collaborative',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Because data onboarding is so critical to customer success, many CSMs realize they need help. The faster customer data onboarding is done, the faster they can move onto helping the customer fully utilize the product and achieve the results they want.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A data onboarding platform allows companies to deliver the highest quality service while saving tremendous amounts of time on data migration.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s data onboarding platform includes key features:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Collaboration with stakeholders - Authenticated login for each collaborator, a dashboard for collaborators so they can see what data you are requesting.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Secure data submission - Instead of constantly emailing files (eek!) collaborators can submit data in a secure workspace.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Approval workflows - Data doesn’t just get migrated or imported into the client’s account automatically. First, you can approve it, make changes, or request changes.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Data validation - AI-powered validation means that data imports happen quicker and more accurately.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'No code required - Flatfile was built to be more accessible so there’s no coding needed to set up or use the platform.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While data onboarding might always be multifaceted and complex, your team should strive to make it faster.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The fact is that, at most companies, customer data onboarding takes way too long. Companies have accepted this, and so have customers. But now it’s time to raise expectations and surprise customers with fast onboarding.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Let’s take a look at what the fastest-possible customer data onboarding process looks like:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Decide on the needed data with stakeholders',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Set up a secure data onboarding workspace with the info collaborators need',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Invite collaborators to the secure workspace',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Receive and approve data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Quickly import and validate data',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When you set up your workspace, you can add what data you need from which collaborators. You can add in the data format and details you need so that collaborators can easily see what’s required of them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Working inside of the data onboarding workspace, it’s easy to review who has submitted what and what’s still missing. When you approve the data, it gets validated and cleaned up then sent over to your customer’s account.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'Flatfile’s data onboarding platform that helps companies onboard customers faster.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5TXiSbCBlYoZawYOAbeIXN',
    postTitle:
      'Flatfile helps PopBookings lean into rapid growth, exceeds expectations',
    seoTitle: 'Helping PopBookings Onboard Enterprise Clients',
    seoUrlSlug: 'flatfile-portal-helps-popbookings-scale-customer-data-imports',
    seoMetaDescription:
      'Case Study: PopBookings integrates Flatfile in 2 hours, revamping event staffing data imports. The result? Faster data onboarding for staffing customers.',
    category: 'Customer stories',
    tags: ['Case study', 'Portal', 'Customer stories'],
    publishDate: '2020-03-05T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2EvuQPoBNtC5vNa1QpBT7x',
        type: 'Asset',
        createdAt: '2021-08-11T23:51:19.926Z',
        updatedAt: '2022-01-05T12:51:46.172Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 8,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title:
          'Popbookings - Event staffing software powered by Flatfile Portal - Photo',
        description:
          'Popbookings - Event staffing software powered by Flatfile Portal - Photo',
        file: {
          url: '/img/contentful/2EvuQPoB-vlji0kf0seciuhc8nghd.webp',
          details: {
            size: 582502,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'vLjI0kf0SECIUhC8NgHD',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Popbookings - Event staffing software powered by Flatfile - Photo',
    summary:
      'PopBookings is an event staffing software that enables brands to find and manage talent to organize live events. The platform handles everything from sourcing staff to managing payments post-event. Whether you need someone to hand out flyers or facilitate a corporate event, PopBookings is your solution. We had the pleasure ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7o3d3tyla9HjXYDQ4EB8Sc',
                type: 'Asset',
                createdAt: '2021-08-11T23:52:02.409Z',
                updatedAt: '2021-08-11T23:52:02.409Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Popbookings and Flatfile logos',
                description: 'Popbookings and Flatfile logos',
                file: {
                  url: '/img/contentful/7o3d3tyl-vai3zj6irmyodkxsn8tg.webp',
                  details: {
                    size: 41533,
                    image: {
                      width: 1200,
                      height: 266
                    }
                  },
                  fileName: 'VAi3Zj6iRMyoDkXSN8tG',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'PopBookings is an event staffing software that enables brands to find and manage talent to organize live events. The platform handles everything from sourcing staff to managing payments post-event. Whether you need someone to hand out flyers or facilitate a corporate event, PopBookings is your solution.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We had the pleasure of meeting with Joe Abele, PopBookings’ co-founder and CTO, about how their customers scale their activities thanks to Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Since its launch in 2015, the PopBookings team has focused heavily on great user experience.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Joe Abele, CTO PopBookings: “We really tried to design something that people would enjoy using more than a spreadsheet where you have to fill in a whole bunch of information.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In the two-sided marketplace of event staffing, service seekers need to spend a lot of time sending out job posts to their contact lists of potential staff. In the case of ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/teams/customer-success/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'larger enterprises, this takes full teams',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to manage. At PopBookings, the process is streamlined significantly: A buyer only needs about two minutes to create an event and describe its staffing needs.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4x7ge18ienJ2j4h0XZxnUI',
                type: 'Asset',
                createdAt: '2021-08-11T23:52:52.082Z',
                updatedAt: '2021-08-11T23:52:52.082Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "Screenshot of popbookings' website",
                description: "Screenshot of popbookings' website",
                file: {
                  url: '/img/contentful/4x7ge18i-ig5nzstrpwvvq88nxuj7.webp',
                  details: {
                    size: 94121,
                    image: {
                      width: 1200,
                      height: 642
                    }
                  },
                  fileName: 'ig5nzSTRpWVVQ88NXUj7',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Even with PopBookings' friendly interface, those two minutes quickly compound for high-use customers: it’s not unusual for events to recur on a monthly, weekly, or even daily basis. PopBookings first focus was minimizing the time it takes to connect staff with the companies that need them, so it was clear that managing events and data in bulk was their next step.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Companies often rely on spreadsheets to keep track of their repeating events, so speeding up synchronization between PopBookings, legacy Excel spreadsheets, and CSV files became the focus for incoming data. Rather than needing users to manually copy information they already have from one system to another, an import feature to extract .csv data into PopBookings would drastically reduce the time needed to set up multiple events.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1fmvm7hCWi80RFdSfLOxlB',
                type: 'Asset',
                createdAt: '2021-08-11T23:53:29.906Z',
                updatedAt: '2021-08-11T23:53:29.906Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "Screenshot of popbookings' dashboard",
                description: "Screenshot of popbookings' dashboard",
                file: {
                  url: '/img/contentful/1fmvm7hC-jda1danwrsmr4jo6siiy.webp',
                  details: {
                    size: 116274,
                    image: {
                      width: 1200,
                      height: 603
                    }
                  },
                  fileName: 'JDa1DAnWRsmR4jO6siiy',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Joe (CTO and co-founder) had designed and implemented a similar importing process before. With his experience in the intricacies and requirements of setting up an import system, he didn’t want to go through it again. With his previous system, CSV files were parsed and uploaded to a SQL database for later use. It was functional but neither flexible nor scalable: the data formats used in the parsing function were strict, there was minimal error checking, and manual interventions were needed from time to time by the PopBookings internal team.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With a quick Google search, Joe found Flatfile and after seeing the demo decided to set it up himself. It was easy. In less than 2 hours, he had a working prototype for his team.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Joe: “I implemented it on our demo site and showed it to the rest of our team the same evening. Everybody was just blown away. We just all agreed it was the way to go. [...] It’s been a pleasing experience”.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'BzAa3KMzjq1JqkWjt42OC',
                type: 'Asset',
                createdAt: '2021-08-11T23:54:21.368Z',
                updatedAt: '2021-08-11T23:54:21.368Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: "Screenshot of popbookings' events importer",
                description: "Screenshot of popbookings' events importer",
                file: {
                  url: '/img/contentful/BzAa3KMz-owqieoqoszqrwwckq6kn.webp',
                  details: {
                    size: 119345,
                    image: {
                      width: 1200,
                      height: 600
                    }
                  },
                  fileName: 'owqiEoqoSzqRwWckq6KN',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'They dropped the import button directly into the PopBookings event dashboard. Usually, adding an external tool to a customer-facing part of the application can be a challenge, but Joe was happy with how seamless they were able to implement Flatfile.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Joe: “It’s minimalistic and works with our design [...] Our design team is quite picky, so we were glad Flatfile could blend in so easily.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Switching to Flatfile also increased the usability of a buyer’s dashboard immediately.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Joe: “The regex implementation is brilliant. Automatically validating and converting dates, for example, saved us a lot of time. [...] if a field doesn’t match anything, we can still automatically populate.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'More than an operational choice, adding an import feature is opening up new opportunities to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: '/blog/improving-customer-data-onboarding-flatfile-concierge/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'onboard more enterprise agencies',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Joe: “With our enterprise clients, it has been giving us the ability to grow, because we can now support some of these larger clients saying “Well, I’ve got these 500 events I’ve got to put in this week and I don’t really want to add them by hand, what can you do for me?” Bulk importing of events opens up the next level of agencies we can market to.”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Over the past few months, PopBookings is registering new levels of growth: “the numbers on our reports are literally doing that hockey-stick growth,” Joe says, “and this import feature gave us this ability to continue growing. Flatfile is an easy-to-use, easy-to-implement, and very effective tool to move data. It’s a great product. ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'We’ve tried many third-party products and this is the only one that’s exceeded my expectations.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '”',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About PopBookings',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Organizing events and looking for professional staff? Check out PopBookings innovative network yourself at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.popbookings.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'www.popbookings.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about FFlatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '7AkjDLHG7GfJq5StU53XwW',
    postTitle:
      'Flatfile Portal 2.0 - Normalizing Imported CSVs with Data Hooks',
    seoTitle: 'Portal 2.0: Normalizing Imported CSVs with Data Hooks',
    seoUrlSlug: 'flatfile-portal-normalizing-imported-csv-with-data-hooks',
    seoMetaDescription:
      'Data Hooks™ are the most powerful new addition to Flatfile. Normalize the CSV data customers are importing such as dates, zip codes, or even split names!',
    category: 'Product Features & Updates',
    tags: ['Data hooks', 'Portal'],
    publishDate: '2020-01-29T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2ROExXwFFGHu3jN0zOifMj',
        type: 'Asset',
        createdAt: '2021-08-11T17:19:56.336Z',
        updatedAt: '2021-08-11T17:19:56.336Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Normalizing data graphic',
        description: 'Normalizing data graphic',
        file: {
          url: '/img/contentful/2ROExXwF-tn8lwhy9tqsejegfe9oi.webp',
          details: {
            size: 53460,
            image: {
              width: 632,
              height: 482
            }
          },
          fileName: 'tN8lWhy9TqsEJEgfe9OI',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Flatfile Portal 2.0 - Normalizing imported CSVs with Data Hooks - photo',
    summary:
      'Normalizing with data hooks . This is part 2 of a 7-part deep dive into Flatfile Portal 2.0, view other parts here! Data Hooks™ is the most powerful new addition to Flatfile: they allow nearly infinite extensibility and customization of import flows. Today’s focus is on how you can use ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GghDtLBHpcFvmaS00K2bR',
        type: 'Entry',
        createdAt: '2021-05-26T14:15:04.956Z',
        updatedAt: '2022-04-25T20:38:50.331Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Bonilla',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6Vh25O0QaKYZELWrVza7Bs',
            type: 'Asset',
            createdAt: '2021-05-26T14:13:19.152Z',
            updatedAt: '2021-05-26T14:13:19.152Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Bonilla Headshet',
            description: 'David Bonilla Headshot',
            file: {
              url: '/img/contentful/6Vh25O0Q-david-bonilla.webp',
              details: {
                size: 46443,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'david-bonilla.jpg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Growth Marketer',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Normalizing imported CSVs with data hooks',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/datahooks/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'bold'
                    }
                  ],
                  value: 'Data Hooks™',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " is the most powerful new addition to Flatfile: they allow nearly infinite extensibility and customization of import flows. Today's focus is on how you can use Data Hooks to normalize the data your customers are dropping into the Portal. Two common use-cases we see are ",
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'names',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' and dates.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Normalizing spreadsheet names ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'A common data problem we see emerge when importing is when original sources have a full name and your system requires a first and last name (or the opposite). Using data hooks, you can easily employ awesome libraries like ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.npmjs.com/package/split-human-name?utm_campaign=Portal%202.0&utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz-9GcubQl0iPo9VfrWSL0vj2pXnKnimATcYOhcwGvZ9IXQoMgKjJqlmQjLUnbpC6_8uXwMEh'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'split-human-name',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' to normalize values and save users hours of work.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4AsllxYsixcIzJOS1R1KYZ',
                type: 'Asset',
                createdAt: '2021-08-11T17:21:02.249Z',
                updatedAt: '2021-08-11T17:21:02.249Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Normalize spreadsheet names graphic',
                description: 'Normalize spreadsheet names graphic',
                file: {
                  url: '/img/contentful/4AsllxYs-awx3kf93qclqu762ox2w.webp',
                  details: {
                    size: 25720,
                    image: {
                      width: 600,
                      height: 300
                    }
                  },
                  fileName: 'aWX3Kf93QClqu762oX2w',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'ISO formatted dates ',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "We've all seen the thousands of ways that users provide data values. Thankfully there are awesome libraries like ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://momentjs.com/?utm_campaign=Portal%202.0&utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz-9GcubQl0iPo9VfrWSL0vj2pXnKnimATcYOhcwGvZ9IXQoMgKjJqlmQjLUnbpC6_8uXwMEh'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'moment.js',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://date-fns.org/?utm_campaign=Portal%202.0&utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz-9GcubQl0iPo9VfrWSL0vj2pXnKnimATcYOhcwGvZ9IXQoMgKjJqlmQjLUnbpC6_8uXwMEh'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'date-fns',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' to help normalize human written dates into ISO formats. With data hooks, you can not only normalize the values but also run complex analysis - like preventing dates in the future.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3kaulmS2fGa4Kcaqqd3Ed1',
                type: 'Asset',
                createdAt: '2021-08-11T17:21:38.759Z',
                updatedAt: '2021-08-11T17:21:38.759Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'ISO formatted dates graphic',
                description: 'ISO formatted dates graphic',
                file: {
                  url: '/img/contentful/3kaulmS2-date_datahook_finalcomp.gif',
                  details: {
                    size: 29517,
                    image: {
                      width: 600,
                      height: 400
                    }
                  },
                  fileName:
                    'Date_DataHook_FinalComp.gif?width=1200&name=Date_DataHook_FinalComp.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '...and so many other use-cases.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Convert countries to their ISO codes.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Normalize zip and postal codes.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Convert monetary values into their currency syntax.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Automatically format product codes.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Convert values to database reference IDs.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Tokenize PII for compliance with products like ',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Append additional data automatically from an external file.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Send us your ideas!',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile Portal 2.0',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Want to get started with Flatfile Portal? ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://calendly.com/flatfile-overview/flatfile-overview-call'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Grab 15 minutes with Eric or myself',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " to review the features you need and make sure they're enabled for your account.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Cheers,',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'David',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'PS. Flatfile is built on your feedback. We appreciate you for helping us build a better experience every day. If you ever have ideas or suggestions, share them with us, or you can even schedule a call with Randy (our product lead) to discuss them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile for your CS team?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Does your success or services team spend time onboarding customer data?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "We've got something special in the works, check out ",
              nodeType: 'text'
            },
            {
              data: {
                uri: '/product/concierge/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Concierge',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', the collaborative workspace for data onboarding.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3CzUQoEx136XjG0PoepkOH',
                type: 'Asset',
                createdAt: '2021-08-11T17:23:38.816Z',
                updatedAt: '2021-08-11T17:23:38.816Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 11,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Concierge graphic',
                description: 'Concierge graphic',
                file: {
                  url: '/img/contentful/3CzUQoEx-mockinvite.webp',
                  details: {
                    size: 39812,
                    image: {
                      width: 1016,
                      height: 592
                    }
                  },
                  fileName: 'MockInvite.png?width=2032&name=MockInvite.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '4VnXj1PjqtBWq550dE6jwn',
    postTitle:
      'Flatfile Portal 2.0 - the Biggest Update to our CSV Importer Yet!',
    seoTitle: 'Portal 2.0: The Biggest Update to Our CSV Importer Yet!',
    seoUrlSlug: 'flatfile-portal-2-biggest-update-csv-importer',
    seoMetaDescription:
      'We’ve been hard at work implementing all your feedback and are excited to announce the biggest update to our CSV importer. Welcome to Flatfile Portal 2.0!',
    category: 'Product Features & Updates',
    tags: ['Flatfile Portal', 'Portal features'],
    publishDate: '2020-01-24T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2YXnl8cpk9REPMu4W7CjZz',
        type: 'Asset',
        createdAt: '2021-08-24T15:47:02.308Z',
        updatedAt: '2021-08-24T15:47:02.308Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title:
          'Introducing Flatfile Portal 2.0 - the biggest update to our CSV importer yet! - photo',
        description:
          'Introducing Flatfile Portal 2.0 - the biggest update to our CSV importer yet! - photo',
        file: {
          url: '/img/contentful/2YXnl8cp-oqrzp6slsxk74n0byij9.webp',
          details: {
            size: 40673,
            image: {
              width: 1200,
              height: 630
            }
          },
          fileName: 'oQrzP6SlSxK74N0byiJ9',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Introducing Flatfile Portal 2.0 - the biggest update to our CSV importer yet! - photo',
    summary:
      'Flatfile just got way more powerful . We’ve been hard at work implementing all your feedback and are excited to announce the biggest update to our importer yet. Welcome to Portal 2.0. This is part 1 of a 7-part deep dive into Flatfile Portal 2.0, view other parts here! 30+ ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GghDtLBHpcFvmaS00K2bR',
        type: 'Entry',
        createdAt: '2021-05-26T14:15:04.956Z',
        updatedAt: '2022-04-25T20:38:50.331Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Bonilla',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6Vh25O0QaKYZELWrVza7Bs',
            type: 'Asset',
            createdAt: '2021-05-26T14:13:19.152Z',
            updatedAt: '2021-05-26T14:13:19.152Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Bonilla Headshet',
            description: 'David Bonilla Headshot',
            file: {
              url: '/img/contentful/6Vh25O0Q-david-bonilla.webp',
              details: {
                size: 46443,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'david-bonilla.jpg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Growth Marketer',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile Portal just got way more powerful.',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’ve been hard at work implementing all your feedback and are excited to announce the biggest update to our importer yet. Welcome to Flatfile Portal 2.0.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [],
          nodeType: 'hr'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '30+ new features',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'uJGUuq20SdKyLN5XvqmAi',
                type: 'Entry',
                createdAt: '2021-08-24T15:35:18.067Z',
                updatedAt: '2021-08-24T15:35:18.067Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 17,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'table'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile Portal 2.0 Features',
                table: {
                  tableData: [
                    ['', ''],
                    ['Data Hooks', 'Review-only mode'],
                    ['Lookup fields', 'Performance boost'],
                    ['Dropzone support', 'Column rollups'],
                    ['File preloading', 'Nested data'],
                    ['Webhooks', 'Rich theming'],
                    ['Custom scripts', 'Custom fonts'],
                    ['Field splitting', 'Value merging'],
                    ['Data audit trail', 'Rich custom fields'],
                    ['Testing mode', 'Framework components'],
                    ['XLS sheet selection', 'Text customization'],
                    ['XML support', '+ dozens more']
                  ]
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Data Hooks',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'We’re giving you more power than ever before with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/javascript/datahooks/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Data Hooks',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. You can run complex validation, normalize formats into a standard, transform values in real-time, and much more.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4gz7YSVRnpI7GrERgJY2gC',
                type: 'Asset',
                createdAt: '2021-08-24T15:36:49.605Z',
                updatedAt: '2021-08-24T15:36:49.605Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Data hooks animation',
                description: 'Data hooks animation',
                file: {
                  url: '/img/contentful/4gz7YSVR-datalookupgif.gif',
                  details: {
                    size: 32787,
                    image: {
                      width: 600,
                      height: 300
                    }
                  },
                  fileName:
                    'DataLookupGif.gif?width=1200&name=DataLookupGif.gif',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Lookup Fields',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’re launching a new type of field to support a hotly requested feature: Lookup fields will allow you to link value in an import to an external API or database.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4cxPvou6YKhMaYWiGENncY',
                type: 'Asset',
                createdAt: '2021-08-24T15:40:44.843Z',
                updatedAt: '2021-08-24T15:40:44.843Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Lookup Fields illustration',
                description: 'Lookup Fields illustration',
                file: {
                  url: '/img/contentful/4cxPvou6-lookuprecord.webp',
                  details: {
                    size: 47438,
                    image: {
                      width: 1200,
                      height: 642
                    }
                  },
                  fileName: 'LookupRecord.png?width=2400&name=LookupRecord.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Design Update',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We freshened up the interface, making it cleaner and more customizable.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7dP7TdY3WleQgbdztv3hUE',
                type: 'Asset',
                createdAt: '2021-08-24T15:41:29.447Z',
                updatedAt: '2021-08-24T15:41:29.447Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Screenshot of Flatfile Portal importer',
                description: 'Screenshot of Flatfile Portal importer',
                file: {
                  url: '/img/contentful/7dP7TdY3-screen_20shot_202020-01-23_20at_204.43.36_20pm.webp',
                  details: {
                    size: 129171,
                    image: {
                      width: 2872,
                      height: 1814
                    }
                  },
                  fileName:
                    'Screen%20Shot%202020-01-23%20at%204.43.36%20PM.png?width=2872&name=Screen%20Shot%202020-01-23%20at%204.43.36%20PM.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Speed Improvements',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-3'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "The platform is beefed up as well. We process data more than 6 times faster than before, and we've improved auto-matching logic means that import column headers are correctly matched to your data model up to 95% of the time. The package size has also been optimized to be 3x smaller than before.",
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5zaRev5v7whNODnZajNrZe',
                type: 'Asset',
                createdAt: '2021-08-24T15:42:20.148Z',
                updatedAt: '2021-08-24T15:42:20.148Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatilfe Portal 1.0 / 2.0 speed comparison bar chart',
                description:
                  'Flatilfe Portal 1.0 / 2.0 speed comparison bar chart',
                file: {
                  url: '/img/contentful/5zaRev5v-bs_vers_graph.webp',
                  details: {
                    size: 13543,
                    image: {
                      width: 1200,
                      height: 440
                    }
                  },
                  fileName:
                    'BS_Vers_Graph.png?width=2400&name=BS_Vers_Graph.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'PS. Flatfile is built on your feedback. We appreciate you for helping us build a better experience every day. If you ever have ideas or suggestions, share them with us, or you can even schedule a call with Randy (our product lead) to discuss them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '484IFnG2dK9LR3qKNt3GtQ',
                type: 'Entry',
                createdAt: '2021-08-16T22:18:16.917Z',
                updatedAt: '2021-08-16T22:18:16.917Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The data import experience is easier than ever',
                ctaText: 'Start for free',
                href: 'https://app.flatfile.com/sign-up'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile for your CS team?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Does your success or services team spend time onboarding customer data?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: "We've got something special in the works, check out ",
              nodeType: 'text'
            },
            {
              data: {
                uri: '/product/concierge/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Concierge',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ', the collaborative workspace for data onboarding.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5jqXpZ7WHyMKhYFZmFOw8t',
    postTitle: 'Making a Build vs. Buy Decision',
    seoTitle: 'Building a Custom Data Importer vs. Flatifle Portal',
    seoUrlSlug: 'making-a-build-vs-buy-decision-part-1',
    seoMetaDescription:
      'Should you build a custom data importer or onboard your customer data with Flatfile’s Portal? Here’s a template for build vs buy software solutions decision-making.',
    category: 'Data Onboarding',
    tags: ['Build vs buy'],
    publishDate: '2020-01-16T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '40KfG3kkcmMDUdvoqehMQ2',
        type: 'Asset',
        createdAt: '2021-08-11T17:10:13.461Z',
        updatedAt: '2021-08-11T17:10:13.461Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 5,
        revision: 1,
        locale: 'en-US'
      },
      fields: {
        title: 'Build vs buy graphic',
        description: 'Build vs buy graphic',
        file: {
          url: '/img/contentful/40KfG3kk-wpgkyxhitgqmzjraawos.webp',
          details: {
            size: 82216,
            image: {
              width: 752,
              height: 511
            }
          },
          fileName: 'wPGKyxhiTGqmZJraAwos',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Build vs buy graphic',
    summary:
      'Our prospective customers often wonder why they should buy from us when they could develop their own data import solution. The question, however, is not whether or not you can build something: it’s about finding the best solution to your problem. Market trends According to Deloitte’s 2018 survey on global ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Our prospective customers often wonder why they should buy from us when they could develop their own ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'data import solution',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: '/blog/5-must-have-features-for-a-data-importer/'
              }
            },
            {
              nodeType: 'text',
              value: '. The question, however, is not whether or not you ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'can',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' build something: it’s about ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'finding the best solution',
              marks: [
                {
                  type: 'italic'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value: ' to your problem.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Market trends',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'According to Deloitte’s 2018 survey on global outsourcing, 9 organizations out of 10 are considering or adopting cloud solutions they cannot quickly build on their own to gain a competitive advantage. The right software drives success, but should we build those products ourselves or should we buy them?>',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'If every employee works eight hours a day, and they spend an hour each day reading emails, something as simple as an inbox filter can increase their productivity by 12%. The same principle applies to any task, and this is why we create software in the first place: to automate activities that are not worth someone’s time. A company could build its own inbox filtering app, but what about more complex pieces of software?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'According to Deloitte still, a third of the companies surveyed expect cloud services contracting to decrease their operational costs by at least 11%. Buying ready-to-use software removes the need for hiring, research, development, and maintenance costs. In the U.S. in 2017, software developers made a median salary of $50 per hour, so paying $5 per month per employee for something as complex as a project management tool like ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'ClickUp',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://clickup.com/?href=flatfile'
              }
            },
            {
              nodeType: 'text',
              value: ' becomes a no-brainer.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Why buy?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'More than a cost-saving strategy, buying a software solution drives innovation and increases operational speed: employees spend less time on each task, and it helps them adopt the industry’s best practices right away. We often underestimate the domain expertise going into a single piece of software, but the underlying complexity is still there.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Making great software is hard, though. It's not as simple as patching up some code and hope for the best: most projects take months to complete, and there is a non-negligible chance that the product requirements will change over time. A real estate brokerage building its own SaaS solution is like an elite sprinter making their own shoes: even if competitors are less talented, they reach the finish line sooner because they let people with the right expertise do their work and focus instead on training. An easy mantra to follow would be to outsource anything that's not part of your core activities.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6xNidpXLeHqVOJxlkoTI9C',
                type: 'Asset',
                createdAt: '2021-08-11T17:11:24.004Z',
                updatedAt: '2021-08-11T17:11:24.004Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Objectives for adopting cloud graphic',
                description: 'Objectives for adopting cloud graphic',
                file: {
                  url: '/img/contentful/6xNidpXL-smluqjzirqsb28opgorw.webp',
                  details: {
                    size: 34058,
                    image: {
                      width: 445,
                      height: 294
                    }
                  },
                  fileName: 'SMlUqjziRqSB28OpGOrw',
                  contentType: 'image/jpeg'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'When you’re not a tech company, buying a software product is generally the most effective solution both in the short and the long term. That being said, there are specific reasons why building a custom solution can make sense at a strategic level.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Why build?',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "If you cannot find a solution to buy, and the problem needs to be solved, you just roll out your own. Perhaps the available products don't align with your company values. Or you have demanding service-level agreements that cannot be met by a third party. Maybe a business partner doesn't have the same dedication towards solving your problem and it's hindering your organization's growth. For any of those reasons, you might need more control over the solution, making a home-made software product necessary.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Addressing your specific business needs by making by-products (intellectual property, content, domain knowledge...) can also generate unforeseen business opportunities. Basecamp started as an in-house tool used by the web design firm and ended up as a standalone business: "we tried a few tools, but they were complicated and too hard to use [...] Frustrated, we decided to build our own simple project management app," says Jason Fried, CEO of Basecamp.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'Alphabet is the most notable example of a company driving innovation thanks to its aggressive product development strategy. Even when Alphabet buys a product, they make it their own. The main reason why Google’s parent company builds almost everything in-house is straightforward: the scale is too big. Google’s engineers are the only individuals with enough know-how to solve Google’s problems. But the building is also a matter of corporate culture: Google’s 20% time policy gave birth to Gmail, for example. It’s an investment in the company’s future. Uncertain, but exciting for employees and founders alike.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3fZ2worz0jba1h9YXamYxe',
                type: 'Asset',
                createdAt: '2021-08-11T17:12:10.491Z',
                updatedAt: '2021-08-11T17:12:10.491Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Google innovation ecosystem graphic',
                description: 'Google innovation ecosystem graphic',
                file: {
                  url: '/img/contentful/3fZ2worz-zucebbwbshwnlkpgdli0.webp',
                  details: {
                    size: 98860,
                    image: {
                      width: 585,
                      height: 493
                    }
                  },
                  fileName: 'ZUCebbWBSHWNlKpgDli0',
                  contentType: 'image/jpeg'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                "Even if building your own tools might hinder your growth and won't save costs in the short term, it doesn't have to significantly increase your burn rate either. Thanks to globalization, outsourcing your software development activities has never been easier. The talent pool is bigger and more qualified, and the costs are flexible.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: 'Looking ahead',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'On the other hand, building vs. buying might soon become an outdated debate. With the rise of the no/low-code movement led by companies such as Zapier, IFTTT, or ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'TrackVia',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.trackvia.com/?href=flatfile'
              }
            },
            {
              nodeType: 'text',
              value:
                ", it's never been easier for anyone to build an app that gets things done. Programming becomes visual and intuitive. With a few hours of training, it's within anyone's reach to create basic software without knowing how to code.",
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'The tech industry is constantly pushing toward more abstraction. You still had to assemble your own hardware 50 years ago. Software isn’t much different. You can now buy low-code solutions (libraries, API services...) that will do all the heavy lifting for you, and let a smaller team of developers innovate from there. Want to build a website? Wordpress helps you do it in minutes. Need to bill customers for your services? ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: "Chargebee's APIs",
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://www.chargebee.com/?href=flatfile'
              }
            },
            {
              nodeType: 'text',
              value:
                ' will take care of that for you. The border between buying and building is blurred, and the successful company of tomorrow will have the flexibility to do both in accordance with the issue at hand.',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-asset-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'AgjkhFkiiGbZuy8sf5WLC',
                type: 'Asset',
                createdAt: '2021-08-11T17:13:33.331Z',
                updatedAt: '2021-08-11T17:13:33.331Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Build vs buy evaluation template',
                description: 'Build vs buy evaluation template',
                file: {
                  url: '/img/contentful/AgjkhFki-swtyket7qjkvikuro2fn.webp',
                  details: {
                    size: 98974,
                    image: {
                      width: 1200,
                      height: 656
                    }
                  },
                  fileName: 'swtykEt7QJKvikuRo2FN',
                  contentType: 'image/jpeg'
                }
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: "Finally, here's a ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              content: [
                {
                  nodeType: 'text',
                  value: 'template',
                  marks: [],
                  data: {}
                }
              ],
              data: {
                uri: 'https://docs.google.com/document/d/1V6Qm3JLCVVQdnF20wU5fpHppBEH8NAni_ktW1WW7TGE/edit?usp=sharing'
              }
            },
            {
              nodeType: 'text',
              value:
                ' you can use for build vs. buy decisions. Leverage this into a discussion with your team about what the right route might be!',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'Sources:',
              marks: [],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'ordered-list',
          content: [
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'D',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www2.deloitte.com/content/dam/Deloitte/us/Documents/process-and-operations/us-cons-global-outsourcing-survey.pdf'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: "eloitte's",
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www2.deloitte.com/content/dam/Deloitte/us/Documents/process-and-operations/us-cons-global-outsourcing-survey.pdf'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: ' 2018 survey on global outsourcing',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www2.deloitte.com/content/dam/Deloitte/us/Documents/process-and-operations/us-cons-global-outsourcing-survey.pdf'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Average developer salary',
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://www.indeed.com/career/software-engineer/salaries'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value: "Basecamp's story",
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://basecamp.com/about/story'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            },
            {
              nodeType: 'list-item',
              content: [
                {
                  nodeType: 'paragraph',
                  content: [
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    },
                    {
                      nodeType: 'hyperlink',
                      content: [
                        {
                          nodeType: 'text',
                          value:
                            "HBR, Reverse Engineering Google's Innovation Machine",
                          marks: [],
                          data: {}
                        }
                      ],
                      data: {
                        uri: 'https://hbr.org/2008/04/reverse-engineering-googles-innovation-machine'
                      }
                    },
                    {
                      nodeType: 'text',
                      value: '',
                      marks: [],
                      data: {}
                    }
                  ],
                  data: {}
                }
              ],
              data: {}
            }
          ],
          data: {}
        },
        {
          nodeType: 'embedded-entry-block',
          content: [],
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          }
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ],
          data: {}
        }
      ]
    }
  },
  {
    id: '1U0b5IZ2rKWlknLMcpVZAr',
    postTitle: 'EmployUS referral system employs Flatfile for imports',
    seoTitle: 'EmployUS Referral System Uses Flatfile for Data Imports',
    seoUrlSlug: 'employus-referral-system-employs-flatfile-for-data-imports',
    seoMetaDescription:
      'EmployUS employs the Flatfile’s data importer to integrate with every applicant tracking system.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Portal'],
    publishDate: '2019-10-22T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '6DVy1kq8r76LPSlefxWLsj',
        type: 'Asset',
        createdAt: '2021-08-11T23:15:04.426Z',
        updatedAt: '2022-01-05T12:17:15.602Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title:
          'EmployUs - Employee referral software powered by Flatfile - photo',
        description:
          'EmployUs - Employee referral software powered by Flatfile - photo',
        file: {
          url: '/img/contentful/6DVy1kq8-srzy1g2vrymdhytz96ov.webp',
          details: {
            size: 1018484,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'srzY1G2vRymdhYtZ96ov',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'EmployUs - Employee referral software powered by Flatfile - photo',
    summary:
      'EmployUS is a venture-backed startup that manages an automated candidate referral system for businesses. They improve both the quality and quantity of incoming applicants and hires for their customers. Prospective customers, often large enterprises, had the data needed to power EmployUs’s referral service, but that data was locked away in ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'EmployUS is a venture-backed startup that manages an automated candidate referral system for businesses. They improve both the quality and quantity of incoming applicants and hires for their customers. Prospective customers, often large enterprises, had the data needed to power EmployUs’s referral service, but that data was locked away in legacy systems. That often meant halting product development efforts and ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/3-most-common-workarounds-for-data-import-challenges/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'building one-off integrations for each new prospect.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3ohIE8VXy3L8PUUHA21Heh',
                type: 'Asset',
                createdAt: '2021-08-11T23:15:58.549Z',
                updatedAt: '2021-08-11T23:15:58.549Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'EmployUs and Flatfile logos',
                description: 'EmployUs and Flatfile logos',
                file: {
                  url: '/img/contentful/3ohIE8VX-edqazwgjsneb4vlemlai.webp',
                  details: {
                    size: 4967,
                    image: {
                      width: 458,
                      height: 50
                    }
                  },
                  fileName: 'eDqAzWGJSNeb4VLEMLAI',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Matt Cotter, CTO and Co-founder of EmployUS: “We found that every time we said the word “integration”, eight to twelve other people had to join the conversation that wouldn’t otherwise have to be a part of the buying decision.“',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Every customer requesting a new integration with a different applicant tracking system (ATS) meant more updates to EmployUs’ codebase, more review cycles, and less time building a better referral system. It wasn’t sustainable. Having identified this, EmployUS decided to explore how they could move away from bespoke integrations with ATS and towards a more efficient, repeatable solution.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Matt: “My first instinct is to always build it. But my cofounder found Flatfile and asked me to test it out. I got it set up in 30 minutes and told him ‘yeah, we’re using this.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Matt is no stranger to building integrations, having previously toiled on a custom data importer for a similar business. That project involved building a CSV importer that attempted to resolve a myriad of encoding issues. The ultimate solution put the burden of work on the end-user, with dozens of FAQ documents outlining how to import their particular document into the application.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Matt: “I’ve built a data importer before. After weeks of development time we still ran into bugs, and our users had to slog through a massive FAQ. It was a full-time job for a full team! Compare that to Flatfile, which took us less than a day to implement. And it’s powerful! Our users love it.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1jX3XMkzrOmxaRIAfkhSZ7',
                type: 'Asset',
                createdAt: '2021-08-11T23:17:41.826Z',
                updatedAt: '2021-08-11T23:17:41.826Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile bulk add UI',
                description: 'Flatfile bulk add UI',
                file: {
                  url: '/img/contentful/1jX3XMkz-aiiryauvsgogjx2z02xu.webp',
                  details: {
                    size: 74938,
                    image: {
                      width: 1000,
                      height: 536
                    }
                  },
                  fileName: 'aIIryaUVSgOGjX2Z02XU',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After configuring and testing a proof-of-concept implementation, Matt integrated Flatfile into EmployUs’ product on a Friday afternoon. By Monday, they had deployed it to all their customers. With Flatfile integrated into their client-facing solution, the team found it so easy to use that they also added the importer to their own admin portal.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Matt: “Behind the scenes, we have to migrate data from legacy customers to a new customer in a new system. Flatfile takes in a bunch of random fields, converts it to JSON, and I can pipe it through our normal functions.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'And how is it working out for EmployUs’ clients?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Matt: “Now we have no barrier for them to get started: they can always create a CSV document they want, import the users, import their jobs, update them. It’s easy.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Internally, the EmployUs no longer needs to toil over complex app integrations, and can now ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/teams/customer-success/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'focus even more on their customers.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'Matt: “We’ve replaced most of our integrations with CSV importing now. We give the entire functionality of an integration to the customer without having to address every minute edge case.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/tag/case-studies'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Success stories',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                " like EmployUS's are the reason we built Flatfile.io. Saving our customers time and effort from building custom solutions is nice, but creating a great experience for a process that used to be frustrating is what keeps us going. The Flatfile team is ambitious in our pursuit of delightful ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'underline'
                    }
                  ],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', and we look forward to working with EmployUS and all of our customers to solve any problem related to getting data into web-based software applications.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About EmployUS',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To learn more about EmployUS’s high-quality candidate referral system for agencies and corporations, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://employus.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'www.employus.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '2c3fLDLcRgCLyrowRgU4QK',
    postTitle:
      'Flatfile enables HealthSpace’s entire product suite to import thousands of data records',
    seoTitle: 'Enabling HealthSpace to Import Thousands of Data Records',
    seoUrlSlug:
      'flatfile-enables-healthspaces-entire-product-suite-to-import-thousands-of-data-records',
    seoMetaDescription:
      'By using Flatfile’s data importer, HealthSpace is now able to import thousands of data records across their product suite.',
    category: 'Customer stories',
    tags: ['Case study', 'Customer stories', 'Healthcare'],
    publishDate: '2019-09-26T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '68mphNQXMAeQrxMzy8Tyfx',
        type: 'Asset',
        createdAt: '2021-08-11T23:29:26.975Z',
        updatedAt: '2022-01-05T12:22:57.255Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 3,
        locale: 'en-US'
      },
      fields: {
        title: 'HealthSpace - Powered by Flatfile - photo',
        description: 'HealthSpace - Powered by Flatfile - photo',
        file: {
          url: '/img/contentful/68mphNQX-aqjsuslyr1kan1gro7mb.webp',
          details: {
            size: 65919,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'AqJsUsLyR1KAn1gRo7Mb',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'HealthSpace - Powered by Flatfile - photo',
    summary:
      'HealthSpace is a SaaS company that offers a suite of cloud and mobile based products to state and local government agencies. With their focus on streamlining complicated government processes, HealthSpace relies on a cloud based model to create highly configurable software packages for their clients in as little as 30 ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7F4uRryvSpnsSwvwfy7gaJ',
        type: 'Entry',
        createdAt: '2021-08-04T23:54:13.832Z',
        updatedAt: '2022-01-26T21:30:56.282Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 14,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Elizabeth Bukys',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '5qkHcfvmQ08Ss9IiOkQLHb',
            type: 'Asset',
            createdAt: '2021-08-04T23:52:26.139Z',
            updatedAt: '2021-08-04T23:52:26.139Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Elizabeth Bukys headshot',
            description: 'Elizabeth Bukys headshot',
            file: {
              url: '/img/contentful/5qkHcfvm-u17eayztt2c3sqfur1sd.webp',
              details: {
                size: 9033,
                image: {
                  width: 199,
                  height: 200
                }
              },
              fileName: 'u17EAyzTT2C3sqfur1sD',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Expert Customer Experience Strategist',
        department: 'Customer Experience'
      }
    },
    body: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'Y77ILNMoju3LY0EZZrsL8',
                type: 'Asset',
                createdAt: '2021-08-11T23:30:09.080Z',
                updatedAt: '2021-08-11T23:30:09.080Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Healthspace and Flatfile logos',
                description: 'Healthspace and Flatfile logos',
                file: {
                  url: '/img/contentful/Y77ILNMo-w6vwmagtvwragw2rup6b.webp',
                  details: {
                    size: 12427,
                    image: {
                      width: 482,
                      height: 84
                    }
                  },
                  fileName: 'W6VWmaGTVWragw2rup6b',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'HealthSpace is a SaaS company that offers a suite of cloud and mobile-based products to state and local government agencies.\n\nWith their focus on streamlining complicated government processes, HealthSpace relies on a cloud-based model to create highly configurable software packages for their clients in as little as 30 days. With massive amounts of live and historical data coming in from countless government data sources, ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/what-is-data-onboarding-everything-you-need-to-know'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'scalable customer onboarding',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' and data accuracy is a necessity. Further complicating their data import process, clients frequently have unique import requirements that aren’t able to be easily translated from one use-case to the next.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Silas Garrison, CEO, and Founder of HealthSpace says: “ Municipalities are governed by vast sets of laws that differ from the city next to them. Some of these laws are inherited from a state-level mandate, others unique to that particular city. With so many regulations at play, government entity and city must be looked at through a brand new or unique lens."',
                  marks: [],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'HealthSpace’s need for agile implementation meant attempting to migrate legacy data imports using custom SQL parameters to a more scalable self-serve option. Their priority on the user meant that their team was tasked with ever-changing import requirements that needed to be continuously adjusted. This added to the complexity of not sacrificing the user’s experience when scoping out newer data import solutions.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Silas Garrison: “The user experience was paramount. Our clients have a somewhat similar process when they’re-importing some external records from a system. We might import an Excel spreadsheet with up to 10,000 rows containing any number of columns or formatting of labels. We wanted to implement a streamlined process to create a more self-serve model for our customers."',
                  marks: [],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Things came to a head when HealthSpace partnered with a local city that had legislation requiring that every government entity use the city’s standardized billing software for all invoicing and payments. Normally an unsurmountable use-case, HealthSpace embedded the Flatfile importer directly into their accounting module. Their customer’s IT department would then send an Excel spreadsheet to import into HealthSpace, and then they would need to reconcile the spreadsheet fields through the data importer.\n',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Silas Garrison: “We were lucky we found Flatfile. Integrating the importer was super gratifying and saved us likely 100s of hours of engineering while also creating a solution that was scalable for our entire product suite, not just a one-off customer need. We’re able to receive these Excel spreadsheets from our customer’s IT department and hand it off to Flatfile. The importer decides what fields go where, and we’re done!"',
                  marks: [],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'embedded-asset-block',
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6XkNJozbSLxLyL6mqUWFBd',
                type: 'Asset',
                createdAt: '2021-08-11T23:32:50.165Z',
                updatedAt: '2021-08-11T23:32:50.165Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Bulk add 6 customers',
                description: 'Bulk add 6 customers',
                file: {
                  url: '/img/contentful/6XkNJozb-y1txpnassy6gtyexxfut.webp',
                  details: {
                    size: 1302618,
                    image: {
                      width: 1596,
                      height: 782
                    }
                  },
                  fileName: 'Y1txpNAsSY6gTyEXxFuT',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: []
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Flatfile not only cut down on engineering time for each ',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/teams/implementations/'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'implementation',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                ' but also saved build time for the solution as a whole. Implemented on HealthSpace’s existing platform, Flatfile was able to save countless integration hours that would have been spent trying to create something similar instead of buying it.',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'blockquote',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              data: {},
              content: [
                {
                  nodeType: 'text',
                  value:
                    'Silas Garrison: “Integrating our existing JSON configurations into Flatfile was seamless. Flatfile enabled all of our product suite to suck in data from a spreadsheet in just a few short hours of engineering work."',
                  marks: [],
                  data: {}
                }
              ]
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://flatfile.com/blog/tag/case-studies'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Success stories',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value:
                " like HealthSpace's are the reason we built Flatfile’s data onboarding platform. Saving our customers time and effort from building custom solutions is nice, but creating a great experience for a process that used to be frustrating is what keeps us going. We're ambitious in our pursuit of delightful data imports, and we look forward to working with HealthSpace and all of our customers to solve any problem related to getting data into web-based software applications.\n\n",
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'About HealthSpace\n\n',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                'To learn more about HealthSpace’s HSCloud Suite for government compliance and regulation, including environmental health, and agriculture, visit: gethealthspace.com.\n\n',
              marks: [],
              data: {}
            },
            {
              nodeType: 'text',
              value: 'About Flatfile\n\n',
              marks: [
                {
                  type: 'bold'
                }
              ],
              data: {}
            },
            {
              nodeType: 'text',
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about FFlatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              marks: [],
              data: {}
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'flatfile.com.',
                  marks: [],
                  data: {}
                }
              ]
            },
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {}
            }
          ]
        }
      ]
    }
  },
  {
    id: '6kt8rOAVLw7yAEV0uLA79Q',
    postTitle: "Improving the customer journey using Flatfile's data importer",
    seoTitle: "Improve Customer Journey with Flatfile's Data Importer",
    seoUrlSlug: 'improving-the-customer-journey-using-flatfiles-data-importer',
    seoMetaDescription:
      'How do your customers journey through your application? Most data import experiences are very frustrating to users, but Flatfile’s data importer will save the day.',
    category: 'Data exchange',
    tags: ['Data importer'],
    publishDate: '2019-09-19T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4H3b50IceKFPwJYpJNCBcE',
        type: 'Asset',
        createdAt: '2021-08-24T16:10:52.435Z',
        updatedAt: '2022-01-05T13:27:59.480Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Import errors upon import errors.',
        description: 'Import errors upon import errors.',
        file: {
          url: '/img/contentful/4H3b50Ic-qiua0ayeslwmepa5iquq.webp',
          details: {
            size: 2322250,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'QIUA0AyeSLWmEPa5IquQ',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Import errors upon import errors.',
    summary:
      'Close your eyes and imagine what it is like to import data into your application. Now open them. Does it look something like this? Import errors upon import errors. When creating a new or improving an existing product, building useful features is, of course, priority number one. What many forget, ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Close your eyes',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' and imagine what it is like to import data into your application. Now open them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Does it look like this?',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3VW9jN15qxDxczzyCWi5m7',
                type: 'Asset',
                createdAt: '2021-08-16T23:53:03.274Z',
                updatedAt: '2021-08-16T23:53:03.274Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'CSV import errors',
                description: 'CSV import errors',
                file: {
                  url: '/img/contentful/3VW9jN15-bdiovlssyv4unw5owciw.webp',
                  details: {
                    size: 535984,
                    image: {
                      width: 1200,
                      height: 853
                    }
                  },
                  fileName: 'bdIOVLSSyv4UNW5owcIw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Import errors upon import errors.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When creating a new or improving an existing product, building useful features is, of course, priority number one. What many forget, though, is that innovation is wasted when the product experience is not intuitive. When crafting the customer journey, a product manager must pay particular attention to the customer’s first steps.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'In many products, the data importing process is one of those early steps. Unfortunately, it is often a major pain point for the customer. This isn’t all the PM’s fault; we’ve come to expect data import to be a lousy software experience. So we keep sending customers to complex templates, long support articles, and cryptic error screens, often within the first few minutes of their journey.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Not anymore, though. Flatfile offers a simple solution: an intuitive, plug-and-play data importer. We call it, ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4FkqRLwYSTnUquWRNmgdkS',
                type: 'Asset',
                createdAt: '2021-08-17T19:19:58.549Z',
                updatedAt: '2021-08-17T19:19:58.549Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Portal column matching accept / reject screenshot',
                description:
                  'Portal uses a machine-learning column-matching system to automatically map users’ imported data. (Source: ClickUp)',
                file: {
                  url: '/img/contentful/4FkqRLwY-c4iscszgsugmqfomxdcj.webp',
                  details: {
                    size: 140309,
                    image: {
                      width: 1200,
                      height: 658
                    }
                  },
                  fileName: 'c4iscSZgSUGMQFOMxDCJ',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Streamlined. Clear. Simple. The Flatfile importer experience:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'In this post, we uncover',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ':',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'What is Flatfile?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'How does Flatfile work?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value:
                        'Why should you choose Flatfile’s data onboarding platform?',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'What is Flatfile?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Flatfile offers software companies an alternative to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/making-a-build-vs-buy-decision-part-1'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'building their own data importers.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For users, that means no more jumping through hoops to upload their data. Now, they can use Flatfile’s platform instead of a seamless, smooth, and supportive data importing experience. Flatfile is designed to support users of any technical skill level: firefighters, real estate agents, and data analysts all leverage the Flatfile Importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'For PMs, that means no more worrying about handling the UX and engineering complexities of data import. Instead of planning a whole sprint - if not several - on building a custom solution, PMs can hand their engineering team Flatfile’s documentation and get an elegant, crafted experience in a day. Put simply, Flatlife takes the pain out of the building and maintaining a data importer, and lets product teams focus on innovative, differentiating features.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How does Flatfile work?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile lets users upload their spreadsheets with just a few clicks. They can also manually enter their data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Once the data has been uploaded, Flatfile asks the user a few simple questions about how their spreadsheet matches your product, ensuring that the data is aligned with the correct field (e.g. first name, last name, email address, etc.).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The final step is data repair, where the user can review and update their import to correct any data errors. These errors appear based on validations you can pre-define, ensuring the tidiness of data before it ever hits your product database.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Once these steps are complete, the user is back in your application, and you have a clean, structured set of JSON data that’s easy to pull into any database.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    'When we were looking for solutions, we knew we could either build it ourselves or try to find something. Our product lead at the time heard of Flatfile. He presented it to the team, and ultimately ',
                  nodeType: 'text'
                },
                {
                  data: {
                    uri: 'https://flatfile.com/blog/flatfiles-data-importer-saves-digsy-up-to-10-hours-per-new-customer'
                  },
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'we decided to implement Flatfile.',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'hyperlink'
                },
                {
                  data: {},
                  marks: [],
                  value:
                    ' We didn’t see anything else on the market.” – Meghann, Product Lead at Digsy.ai',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Why should you choose Flatfile’s data onboarding platform?',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'When a user is importing data to your product, they want to use it and they want to see its value. Don’t let them get hung up on spreadsheet templates and intimidating documentation. Flatfile takes most organizations less than a week to implement, and it gives users a simple, smooth, and delightful ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/data-file-exchange-what-it-is-why-its-essential-for-businesses-today/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data exchange',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' experience.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '5PCQGkDmzYwt3ovmyrTGZS',
    postTitle:
      'Flatfile’s developer-friendly data importer saves Halligan.io weeks of effort',
    seoTitle: 'Flatfile’s Data Importer Saves Halligan Weeks of Effort',
    seoUrlSlug:
      'flatfiles-developer-friendly-data-importer-saves-halliganio-weeks-of-effort',
    seoMetaDescription:
      'The Halligan team was able to integrate Flatfile into their application within hours, saving significant amounts of developer time and cost.',
    category: 'Customer stories',
    tags: [
      'Case study',
      'Customer stories',
      'Inventory management',
      'Logistics',
      'Supply chain'
    ],
    publishDate: '2019-09-13T00:00-07:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: 'I4CSxEYi2jBlyKawcDLVx',
        type: 'Asset',
        createdAt: '2021-08-11T23:57:36.270Z',
        updatedAt: '2022-01-05T13:13:29.517Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 12,
        revision: 3,
        locale: 'en-US'
      },
      fields: {
        title:
          'Halligan - Inventory and maintenance management platform powered by Flatfile - photo',
        description:
          'Halligan - Inventory and maintenance management platform powered by Flatfile - photo',
        file: {
          url: '/img/contentful/I4CSxEYi-eoukbht6sbnuh3jmqrll.webp',
          details: {
            size: 722061,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'eOUKbHT6SbnUH3jMQRLl',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText:
      'Halligan - Inventory and maintenance management platform powered by Flatfile - photo',
    summary:
      'Halligan.io Powered by Flatfile.io, the new standard for data import. Halligan.io is a cloud-based inventory and maintenance management platform which helps first-responders, fire departments, and emergency operations keep track of critical equipment. With Halligan, emergency response departments are able to import CSVs to update data-objects...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '2GghDtLBHpcFvmaS00K2bR',
        type: 'Entry',
        createdAt: '2021-05-26T14:15:04.956Z',
        updatedAt: '2022-04-25T20:38:50.331Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 16,
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Bonilla',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '6Vh25O0QaKYZELWrVza7Bs',
            type: 'Asset',
            createdAt: '2021-05-26T14:13:19.152Z',
            updatedAt: '2021-05-26T14:13:19.152Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Bonilla Headshet',
            description: 'David Bonilla Headshot',
            file: {
              url: '/img/contentful/6Vh25O0Q-david-bonilla.webp',
              details: {
                size: 46443,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'david-bonilla.jpg',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Growth Marketer',
        department: 'Growth'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '2cTFSvU9VsJAwEI4joWmw8',
                type: 'Asset',
                createdAt: '2021-08-11T23:59:20.895Z',
                updatedAt: '2021-08-12T00:01:08.571Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 9,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Halligan.io and Flatfile logos',
                description: 'Halligan.io and Flatfile logos',
                file: {
                  url: '/img/contentful/2cTFSvU9-1_g2ab7osxexfe_mp_mbikiw.webp',
                  details: {
                    size: 7277,
                    image: {
                      width: 562,
                      height: 154
                    }
                  },
                  fileName: '1*G2aB7oSXEXfE_mp_MbikIw.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://halligan.io/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Halligan.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: ' Powered by ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: 'Flatfile’s data onboarding platform',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: ', the new standard for data import.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.halligan.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Halligan.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' is a cloud-based inventory and maintenance management platform which helps first-responders, fire departments, and emergency operations keep track of critical equipment. With Halligan, emergency response departments are able to import CSVs to update data-objects such as trucks, apparatuses, or equipment. Departments upload this data into Halligan to provide first-responders an overview of their emergency inventory.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The team understood that providing departments an intuitive data import experience would be critical to their emergency response customers, who have anything but time to spare. Halligan knew they needed a column-mapping feature in their data importer, along with the ability to translate CSV column header names into predetermined JSON data objects, as their data model frequently changed with new industry standards. Once they assessed these needs, Halligan realized that Flatfile was perfectly suited to address them.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'rANjaLa7mzrWAAKQFcHDP',
                type: 'Asset',
                createdAt: '2021-08-12T00:00:33.648Z',
                updatedAt: '2021-08-12T00:00:33.648Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Bulk add apparatuses',
                description: 'Bulk add apparatuses',
                file: {
                  url: '/img/contentful/rANjaLa7-1_ayub3i6vfy66eqitbh9rxw.webp',
                  details: {
                    size: 168440,
                    image: {
                      width: 2876,
                      height: 1526
                    }
                  },
                  fileName: '1*AYuB3I6VFY66eqITBh9rxw.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Alex, CEO and Founder of Halligan.io says:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value:
                    ' “I knew how to build the mapping functionality. I just didn’t want to build it again. We needed to give our users the ability to upload a spreadsheet with any header name in any order while letting them map their imported columns into our specified data objects.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After assessing their users’ needs, the Halligan team knew they had to create an intuitive data import experience for their customers. Given the complexity of the solution needed, the team did not want to allocate developer resources towards building and maintaining a custom data importer, so they turned to ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Alex:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    '“It’s a solution we’ve built before when out-of-box solutions hadn’t existed, but we didn’t want to dedicate developer time to build it again.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'After signing up for a developer account, the Halligan team was able to integrate Flatfile into their application within hours. Most of the time was spent ensuring that the CSV data imported correctly into their pre-built JSON objects as the team updated their database columns over time.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Alex:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    '“Implementing Flatfile took a Saturday. Most of it was server-side work. I had to set up the JSON objects to pull data from the CSV.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: 'NyIoTUXFCnedcadvZBERq',
                type: 'Asset',
                createdAt: '2021-08-12T00:02:07.725Z',
                updatedAt: '2021-08-12T00:02:07.725Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile JSON configurator',
                description: 'Flatfile JSON configurator',
                file: {
                  url: '/img/contentful/NyIoTUXF-1_jhryfa-boafnd3yljsdhsa.webp',
                  details: {
                    size: 30560,
                    image: {
                      width: 954,
                      height: 535
                    }
                  },
                  fileName: '1*JhRyFa-bOafND3YljSdHsA.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile’s data onboarding platform simple JSON configurator allows CSV fields to be mapped to specific data models seamlessly. Subsequent CSV data imports from users will adhere to this data model. The Halligan team was able to fully integrate Flatfile into their React.js application through an API connection. In addition, Halligan saved significant amounts of time by repurposing the Flatfile Javascript snippet. Due to Flatfile’s simple ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'JSON configuration',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ', the team was able to create eight separate Flatfile importers, all providing specific CSV import use-cases for each customer department. For example, one Flatfile snippet could be used for equipment imports, one for apparatus imports, and one for inventory imports. The only upkeep needed after re-using the snippet was ensuring that the CSV objects were mapped correctly to Halligan’s database through the JSON configuration.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Alex:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    '“We customized Flatfile by reusing one snippet for multiple importers — at least eight. Assuming we annotate the JSON properly, we can create a new react.js object with a new URL, place the Flatfile snippet in, and it just works.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Halligan saved significant amounts of developer time and cost by integrating Flatfile. Not only would a custom data importer take weeks to build, but it would also require updates throughout the year by a developer. This is before any unforeseen bugs or feature requests.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Alex:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    '“If we built the column-mapping ourselves, it would have taken about a month of developer time, then two weeks out of the year to do updates.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The team is extremely satisfied with Flatfile’s intuitiveness, specifically when working with multiple CSV imports. Flatfile’s import algorithm not only matches up to 95% of columns automatically, but it also remembers column mapping so users don’t have to manually map data on subsequent imports.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '6XkNJozbSLxLyL6mqUWFBd',
                type: 'Asset',
                createdAt: '2021-08-11T23:32:50.165Z',
                updatedAt: '2021-08-11T23:32:50.165Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Bulk add 6 customers',
                description: 'Bulk add 6 customers',
                file: {
                  url: '/img/contentful/6XkNJozb-y1txpnassy6gtyexxfut.webp',
                  details: {
                    size: 1302618,
                    image: {
                      width: 1596,
                      height: 782
                    }
                  },
                  fileName: 'Y1txpNAsSY6gTyEXxFuT',
                  contentType: 'image/gif'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile in action. The data importer can be integrated into any application using a JavaScript snippet. Take Flatfile for a spin at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/developers/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'https://flatfile.com/developers',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Alex:',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [],
                  value: ' ',
                  nodeType: 'text'
                },
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value:
                    '“We’re happy with Flatfile. The uploader workflow is everything that you would expect in easily uploading a CSV file. Flatfile’s caching is well done by saving column-mapping assignments. We really like how users can manually adjust data on import, and configuring incoming CSV columns to JSON objects is simple.”',
                  nodeType: 'text'
                }
              ],
              nodeType: 'paragraph'
            }
          ],
          nodeType: 'blockquote'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Success stories like Halligan’s are the reason why we built ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile.com',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. Saving our customers time and effort from building custom solutions is nice, but creating a great experience for a process that used to be frustrating is what keeps us going. The Flatfile team is ambitious in our pursuit of delightful data imports, and we look forward to working with Halligan and all of our customers to solve any problem related to getting data into web-based software applications.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3bYXdw7f0l2WTd989gtREV',
                type: 'Asset',
                createdAt: '2021-08-12T00:03:14.116Z',
                updatedAt: '2021-08-12T00:03:14.116Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title:
                  'Headshot of Alex Montgomery, CEO, and Founder of Halligan.io',
                description:
                  'Headshot of Alex Montgomery, CEO, and Founder of Halligan.io',
                file: {
                  url: '/img/contentful/3bYXdw7f-1_ampdcv_gzl7jkb7vl1qynq.webp',
                  details: {
                    size: 14809,
                    image: {
                      width: 200,
                      height: 200
                    }
                  },
                  fileName: '1*amPDCV_GZl7jkB7vl1QYnQ.jpeg',
                  contentType: 'image/jpeg'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Alex Montgomery, CEO, and Founder of Halligan.io',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Halligan',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To learn more about Halligan’s Inventory Management Platform for emergency departments, first-responders, and operations, visit ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://www.halligan.io/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'halligan.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'About Flatfile',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                "Flatfile's mission is to remove barriers between humans and data. With AI-assisted data onboarding, they eliminate repetitive work and make B2B data transactions fast, intuitive, and error-free. Flatfile automatically learns how imported data should be structured and cleaned, enabling customers and teams to spend more time using their data instead of fixing it. Flatfile has transformed over 300 million rows of data for companies like ClickUp, Blackbaud, Benevity, and Toast. To learn more about Flatfile’s data onboarding platform email hello@flatfile.io or get started for free at ",
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://c212.net/c/link/?t=0&l=en&o=2826382-1&h=4263379698&u=https%3A%2F%2Fflatfile.io%2F%3Futm_source%3Dprnewswire%26utm_medium%3Dpr&a=flatfile.io.'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'flatfile.com.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7sF8qOkGNenazpi5CSNtI5',
                type: 'Entry',
                createdAt: '2021-08-11T22:56:04.229Z',
                updatedAt: '2021-08-11T22:56:04.229Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                text: 'The elegant data import button is here',
                ctaText: 'See it in action',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '53YESUTY8JTBlYKUcQloBq',
    postTitle: 'Funding Flatfile to remove barriers between humans and data',
    seoTitle: 'Flatfile announces $2 Million in Funding',
    seoUrlSlug: 'funding-flatfileio-to-remove-barriers-between-humans-and-data',
    seoMetaDescription:
      "We're excited to announce Flatfile’s first outside funding of $2 million! Read about our decision to move from bootstrapped to venture-backed business.",
    category: 'Flatfile news',
    tags: ['Funding'],
    publishDate: '2019-09-10T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '27veALF0vjPVB9HyoC85E4',
        type: 'Asset',
        createdAt: '2021-08-24T16:18:53.190Z',
        updatedAt: '2022-01-05T13:17:27.954Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile co-founders David Boskovic and Eric Crane',
        description: 'Flatfile co-founders David Boskovic and Eric Crane',
        file: {
          url: '/img/contentful/27veALF0-sxhkx6vwshqeqabtaroy.webp',
          details: {
            size: 1854523,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 'SXhkX6vwSHqeQAbTAroy',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile co-founders David Boskovic and Eric Crane',
    summary:
      'Let’s turn messy spreadsheets into useful product data Today we are excited to announce Flatfile’s first outside funding of $2 million! The decision to move from bootstrapped to venture-backed business was not an easy one. After seeing the breadth and depth of problems that data import causes for software applications, ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '5UeNcK3ZNtaB89ewOiwd9m',
        type: 'Entry',
        createdAt: '2021-05-28T14:09:50.598Z',
        updatedAt: '2024-02-09T18:49:56.408Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 17,
        revision: 4,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'Eric Crane',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '65J7myUUvQSvBNVrTpzuvj',
            type: 'Asset',
            createdAt: '2021-05-28T14:06:38.769Z',
            updatedAt: '2021-05-28T14:06:38.769Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Headshot',
            description: "Eric's headshot photo",
            file: {
              url: '/img/contentful/65J7myUU-eric-crane.webp',
              details: {
                size: 40493,
                image: {
                  width: 200,
                  height: 200
                }
              },
              fileName: 'eric-crane.jpg',
              contentType: 'image/jpeg'
            }
          }
        },
        jobTitle: 'Co-Founder & COO',
        department: 'Product',
        socialLink: 'https://www.linkedin.com/in/ericcranetech/',
        signature: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '42UnwXoIrKifrzfZ7jDAEP',
            type: 'Asset',
            createdAt: '2021-05-28T14:09:44.282Z',
            updatedAt: '2021-05-28T14:09:44.282Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
          },
          fields: {
            title: 'Eric Crane Signature',
            description: "Eric's Signature for jobs pages",
            file: {
              url: '/img/contentful/42UnwXoI-eric-signature-butter.webp',
              details: {
                size: 10278,
                image: {
                  width: 216,
                  height: 216
                }
              },
              fileName: 'eric-signature-butter.png',
              contentType: 'image/png'
            }
          }
        }
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Let’s turn messy spreadsheets into useful product data',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Today we are excited to announce Flatfile’s first outside funding of $2 million! The decision to move from bootstrapped to venture-backed business was not an easy one. After seeing the breadth and depth of problems that data import causes for software applications, though, we knew that raising venture capital was the fastest way to tell the world about our solution to the oft-neglected data import process.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value: 'Table of contents:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'How we started',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Finding market fit',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Raising capital',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: 'Where we’re going next',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'ordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'How we started',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile started as a side project, a response to the frustration of building a data importer for the umpteenth time. Data import is as ubiquitous as billing or reporting, but previously had no standard solution in the competitive software industry where speed and execution are the only true long-term differentiators.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'My co-founder David took it upon himself to design and build a standardized import experience. He didn’t want it to only function under the best circumstances--he created something that thoughtfully allowed for real humans in the process, no matter that human’s technical abilities.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'With my abnormal affinity for spreadsheets, organization, and data analysis, I was naturally interested when David asked me to join him. The software industry as a whole had come to accept that moving data from a spreadsheet into a product was a disjointed, frustrating experience. And to me, that status quo was unacceptable.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Finding market fit',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'To validate that it wasn’t just our own personal frustrations, David and I took the initial version of Flatfile to market by running small awareness campaigns. We explicitly chose to avoid selling into our own networks right away in order to determine whether the frustration with importing data was as pervasive as we thought.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The response was overwhelmingly positive. From garage startups to publicly traded enterprises, marketing automation to software-enabled services companies, we learned that data import was fundamentally broken across the market and that we have the solution. Firefighters, real estate agents, analysts, and athletes all began using Flatfile on a daily basis.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'As we leaned into these early customer relationships, the resounding feedback we heard was how broad the problem was not just across the market, but within software teams. Data import is consistently challenging for product teams because, in order to do it well, it must be prioritized against other differentiating features. Engineering teams become frustrated when they take time away from solving new problems to resolve data import. ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/teams/customer-success/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Support teams',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' then get stuck with the aftermath of a “check-the-box” level solution, relegated to cleaning spreadsheets instead of building lasting client relationships. And design teams sit helplessly and cringe as they watch their customers struggle to simply import a spreadsheet.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3VW9jN15qxDxczzyCWi5m7',
                type: 'Asset',
                createdAt: '2021-08-16T23:53:03.274Z',
                updatedAt: '2021-08-16T23:53:03.274Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'CSV import errors',
                description: 'CSV import errors',
                file: {
                  url: '/img/contentful/3VW9jN15-bdiovlssyv4unw5owciw.webp',
                  details: {
                    size: 535984,
                    image: {
                      width: 1200,
                      height: 853
                    }
                  },
                  fileName: 'bdIOVLSSyv4UNW5owcIw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Examples of frustrating data import experiences featuring unhelpful errors',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Ultimately, these internal frustrations lead to external ones. Prospects abandon a new application when it takes forever to get set up. Users bombard support channels with the same questions over and over again, ignoring volumes of painstakingly written support docs that address every single variation. Customers lose their patience with an app and switch to a competitor when they consistently deal with frustrating experiences, thinking ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'surely someone can help me make use of my data',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: '!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Raising capital',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The aftermath of this exploration left me wanting to run through the streets with a megaphone, screaming, “stop building your data importer! We’ve got one for you already!” That kind of brand outreach isn’t particularly practical or scalable, so we decided to do the next best thing: we sought outside capital.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We started with significant evidence to support the pervasiveness of the data import problem: a set of active, paying customers who were excited about speaking with prospective investors. We also had already assembled a dedicated team of quality humans, so we knew we could move quickly as soon as the fundraising round closed. As a result, the process was, we are told, “fast” and “smooth”.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We are extremely proud to have such a strong syndicate of investors excited about us, the market opportunity, and our ability to capture it. Many thanks to Gaurav Jain and Anamitra Banerji from Afore, our lead investor, as well as David Frankel from Founder Collective, Ben Blumenfeld and Enrique Allen from Designer Fund, Michael Ma and Joe Montana from Liquid2, and MZ from Gradient Ventures (Google’s AI fund) for believing in us. Additionally, we’d like to give a shoutout to our cohort of angel investors: Nick Candito, Timothy Chen, Anthony Goldbloom, EJ Keisari, Benny Wong, and Alnoor Pirani.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '5t89r5AyCChkjU7HS7IZav',
                type: 'Asset',
                createdAt: '2021-08-24T16:14:05.474Z',
                updatedAt: '2021-08-24T16:14:05.474Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile investor logos',
                description: 'Flatfile investor logos',
                file: {
                  url: '/img/contentful/5t89r5Ay-fk2ksfortui3ptphj4ru.webp',
                  details: {
                    size: 23038,
                    image: {
                      width: 601,
                      height: 370
                    }
                  },
                  fileName: 'Fk2kSforTui3pTpHj4ru',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Investors of Flatfile: Afore Capital, Founder Collective, Gradient Ventures, DesignerFund, and Liquid2 Ventures',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Where we’re going next',
              nodeType: 'text'
            }
          ],
          nodeType: 'heading-2'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Flatfile has already helped hundreds of companies seamlessly import, clean, and consolidate more than 100 million rows of data across more than 50,000 end users. We will use this investment to further ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/welcoming-our-new-investors-to-flatfile'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'scale Flatfile to thousands of businesses',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' and millions of end-users.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '57NsqpOTpdrqbWThizGIap',
                type: 'Asset',
                createdAt: '2021-08-24T16:17:16.162Z',
                updatedAt: '2022-01-05T13:16:53.188Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title:
                  'An example of CSV field validation and cached imports, all possible with Flatfile.',
                description:
                  'An example of CSV field validation and cached imports, all possible with Flatfile.',
                file: {
                  url: '/img/contentful/57NsqpOT-9ho02n2qm600r6qxtrme.webp',
                  details: {
                    size: 147594,
                    image: {
                      width: 1200,
                      height: 716
                    }
                  },
                  fileName: '9HO02n2Qm600r6QXTRME',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'An example of CSV field validation and cached imports, all possible with ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [
                    {
                      type: 'italic'
                    }
                  ],
                  value: 'Flatfile’s data onboarding platform.',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'While we are excited about how we’ve been able to solve data import inefficiencies so far, we are not stopping here. Our team of eleven is already hard at work teaching our product to be faster and better. In the near term, expect more input sources, webhooks for instant connections, and new ways to implement Flatfile. We will be achieving compliance certifications - like our forthcoming SOC2 audit - as well as designing asynchronous import flows. And on top of it all, we will train machine learning systems with real user interactions to cut down on the effort required to import and validate data.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our ultimate goal is single-click import: seamless integration between data sets. We believe in a world where labeling and cleaning data is a long-forgotten challenge. Where data scientists spend the majority of their time learning from data, not scrubbing it. And where companies can focus on building new, unique experiences on top of quality customer data. We are excited about this first of many milestones along the way.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '7vgfonM99x7biwfq3baqvM',
                type: 'Entry',
                createdAt: '2021-08-02T17:22:37.994Z',
                updatedAt: '2023-07-12T19:46:43.190Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 14,
                revision: 3,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: ' ',
                text: 'Want to learn more about the Flatfile Data Exchange Platform?',
                ctaText: 'See how it works',
                href: '/demo/',
                directSignup: false
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  },
  {
    id: '6hDQpDrVgJbEorydUuV5qd',
    postTitle: 'Flatfile: The new standard for data import',
    seoTitle: 'Flatfile’s Importer: The New Standard for Data Import',
    seoUrlSlug: 'flatfileio-the-new-standard-for-data-import',
    seoMetaDescription:
      "What happens when you focus on data import instead of letting it be an afterthought? Answering the problem of improving imports led to Flatfile's creation.",
    category: 'Data exchange',
    tags: ['CSV import'],
    publishDate: '2019-09-09T00:00-05:00',
    featuredImage: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '7zIgbCwwAOx70SfWDmZoux',
        type: 'Asset',
        createdAt: '2021-08-24T16:44:54.438Z',
        updatedAt: '2022-01-05T13:59:18.545Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 7,
        revision: 2,
        locale: 'en-US'
      },
      fields: {
        title: 'Flatfile – The new standard in data import',
        description: 'Flatfile – The new standard in data import',
        file: {
          url: '/img/contentful/7zIgbCww-s3ysnrcmqaaqf8dxiluy.webp',
          details: {
            size: 809078,
            image: {
              width: 1920,
              height: 1080
            }
          },
          fileName: 's3ysNRcMQaaqf8dxIluy',
          contentType: 'image/png'
        }
      }
    },
    featuredImageAltText: 'Flatfile – The new standard in data import',
    summary:
      'Two years ago, I decided to explore a design experiment as a passion project that centered around answering one question. “What would a data import experience look like if it got all the attention of a full product?" Frustration played no small part in this experiment. I’ve built and re-built ...',
    author: {
      metadata: {
        tags: [],
        concepts: []
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'hjneo4qi4goj'
          }
        },
        id: '4xz6CeEoo5lotoYWaT9nK2',
        type: 'Entry',
        createdAt: '2021-08-16T23:48:29.012Z',
        updatedAt: '2021-10-07T00:07:11.818Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment'
          }
        },
        publishedVersion: 9,
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'people'
          }
        },
        locale: 'en-US'
      },
      fields: {
        fullName: 'David Boskovic',
        headshot: {
          metadata: {
            tags: [],
            concepts: []
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'hjneo4qi4goj'
              }
            },
            id: '7GR6yVBlMuiKiTrHNaPo9i',
            type: 'Asset',
            createdAt: '2021-08-16T23:47:07.004Z',
            updatedAt: '2022-09-27T14:30:18.559Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment'
              }
            },
            publishedVersion: 9,
            revision: 2,
            locale: 'en-US'
          },
          fields: {
            title: 'David Boskovic headshot',
            description: 'David Boskovic headshot',
            file: {
              url: '/img/contentful/7GR6yVBl-david.webp',
              details: {
                size: 300854,
                image: {
                  width: 800,
                  height: 800
                }
              },
              fileName: 'david.png',
              contentType: 'image/png'
            }
          }
        },
        jobTitle: 'Founder & CEO',
        department: 'Executive'
      }
    },
    body: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Two',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value:
                ' years ago, I decided to explore a design experiment as a passion project that centered around answering one question. “What would a ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/product/portal/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'data import experience',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' look like if it got all the attention of a full product?"',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Frustration played no small part in this experiment. I’ve built and re-built a file importer dozens of times over the past 15 years. But on every product I’ve ever worked on, it’s always been an afterthought. After all, there are core features to build, why invest time into a feature that’s often used once or twice by each customer? Users already expect data import; it’s not differentiating.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I began exploring major SaaS apps to see how they built their “Bulk Import” flow. What I discovered was the world’s most boring adult puzzle, with 30 step guides, and a labor-intensive process — all for people who are probably still evaluating your app.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '51iPsne0bCYKTyYEkiqZoc',
                type: 'Asset',
                createdAt: '2021-08-24T16:36:18.137Z',
                updatedAt: '2021-08-24T16:36:18.137Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 6,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Existing data import widgets',
                description: 'Existing data import widgets',
                file: {
                  url: '/img/contentful/51iPsne0-0_uyc6qzl7m9s2luuc.webp',
                  details: {
                    size: 511269,
                    image: {
                      width: 1440,
                      height: 1024
                    }
                  },
                  fileName: '0*Uyc6QZL7m9s2lUUc.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'The world’s most boring adult puzzle.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                ' When it came to error solving, things only got worse, with unhelpful errors, emailed reports that arrive hours after importing data, and straight-up rejection of nearly perfect data sets. ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '3VW9jN15qxDxczzyCWi5m7',
                type: 'Asset',
                createdAt: '2021-08-16T23:53:03.274Z',
                updatedAt: '2021-08-16T23:53:03.274Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'CSV import errors',
                description: 'CSV import errors',
                file: {
                  url: '/img/contentful/3VW9jN15-bdiovlssyv4unw5owciw.webp',
                  details: {
                    size: 535984,
                    image: {
                      width: 1200,
                      height: 853
                    }
                  },
                  fileName: 'bdIOVLSSyv4UNW5owcIw',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'I guess I won’t sign up for this then.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I used these problems as inspiration for my first set of design goals:',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'An elegant and simple mapping experience to connect the incoming data to the right fields so users don’t have to download a template.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1nWV55zCAiaHrCt6b8yfX4',
                type: 'Asset',
                createdAt: '2021-08-24T16:37:31.158Z',
                updatedAt: '2022-01-05T13:57:24.737Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 8,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Field matching UI screenshot',
                description: 'Field matching UI screenshot',
                file: {
                  url: '/img/contentful/1nWV55zC-0_9aai9ph1ezxq2swv.webp',
                  details: {
                    size: 284755,
                    image: {
                      width: 2880,
                      height: 2048
                    }
                  },
                  fileName: '0*9aAI9ph1ezxq2SWv.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Quickly column match between different files? Yes, please!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold'
                }
              ],
              value:
                'An easy way for users to see and fix issues without having to re-upload a file or wait for an asynchronous error report.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4N2vbCAqhuzsr2reYIlS0x',
                type: 'Asset',
                createdAt: '2021-08-11T23:12:32.699Z',
                updatedAt: '2021-08-11T23:12:32.699Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                locale: 'en-US'
              },
              fields: {
                title: 'Bulk adding users',
                description: 'Bulk adding users',
                file: {
                  url: '/img/contentful/4N2vbCAq-1_tgxpymbyzb0bxlepyzbpva.webp',
                  details: {
                    size: 315667,
                    image: {
                      width: 2734,
                      height: 1630
                    }
                  },
                  fileName: '1*tGxpyMbYzB0bxLePyzbPvA.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Users immediately see and fix any problems with their upload, without having to pour over the entire document.',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' ',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The designs were simple but worked. I showed them to a few friends who saw the value immediately, so I built a prototype, threw together a simple SaaS backend, put up a website, and launched a Google ad targeting people looking for a CSV importer.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'It was a hit! People started chatting in just to let us know how much they loved what they were seeing.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      value:
                        '“I think you have a great tool here. I have worked in SaaS for long enough and built this mapping functionality so many times. I’ll never ',
                      nodeType: 'text'
                    },
                    {
                      data: {
                        uri: 'https://flatfile.com/blog/making-a-build-vs-buy-decision-part-1'
                      },
                      content: [
                        {
                          data: {},
                          marks: [
                            {
                              type: 'italic'
                            }
                          ],
                          value: 'build a CSV importer',
                          nodeType: 'text'
                        }
                      ],
                      nodeType: 'hyperlink'
                    },
                    {
                      data: {},
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      value: ' again.”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      value:
                        '“You need to do some more marketing by the way. I loved the way MailChimp did their file uploads and had been looking for something similar for a project I am doing. Nothing came close until I found you guys! “',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      value:
                        '“Hi, amazing platform, kudos on a job well done. I am interested in integrating this into my software, and I have a few questions? How can we discuss them”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            },
            {
              data: {},
              content: [
                {
                  data: {},
                  content: [
                    {
                      data: {},
                      marks: [
                        {
                          type: 'italic'
                        }
                      ],
                      value:
                        '“I’ve spent the last 24 hours looking at various different scripts to do this, and they’ve all been too much work or badly written. Needed something quick and simple and that’s what you guys have got here. 100% will be recommending you guys to other developers”',
                      nodeType: 'text'
                    }
                  ],
                  nodeType: 'paragraph'
                }
              ],
              nodeType: 'list-item'
            }
          ],
          nodeType: 'unordered-list'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'The phenomenal signal to me as a founder was that all of our early customers had self-served: they had discovered us via search or ads and signed up on their own. These weren’t simply personal connections. This was replicable.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'In my excitement, I started sharing ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' with more friends. Those I spoke with started asking how they could help make this a real company, and before I knew it, I found myself surrounded by a small family of nearly a dozen incredibly skilled people from companies like Hubspot, Fullstory, Mailchimp, Netflix, and Envoy — all pitching in in our spare time. My passion project had become a startup.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Today we have dozens of paying (and hundreds of free) customers, we’ve proven there’s a market fit, and we’re already building ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/blog/optimizing-csv-import-experiences-flatfile-portal'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value:
                    "the next iteration of Flatfile's data onboarding platform",
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' based on what we’ve learned from the 15,000 uploaded files (and 50m uploaded records).',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Our focus now is on applying this solution at scale: iterating on ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'http://flatfile.com/platform/data-onboarding/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'Flatfile’s data onboarding platform',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                ' user experience to help users easily navigate imports with millions of records, automatically resolving simple issues, and providing elegant solutions for when the user has to get involved manually.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '1TOOGs3Dlq1nu0YtfSMp0z',
                type: 'Asset',
                createdAt: '2021-08-24T16:43:36.441Z',
                updatedAt: '2022-01-05T13:58:44.469Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 7,
                revision: 2,
                locale: 'en-US'
              },
              fields: {
                title: 'Flatfile error correction UI',
                description: 'Flatfile error correction UI',
                file: {
                  url: '/img/contentful/1TOOGs3D-0_lp5wruqpuvbsdmrn.webp',
                  details: {
                    size: 80475,
                    image: {
                      width: 1584,
                      height: 672
                    }
                  },
                  fileName: '0*LP5WrUqpuVbsDmrN.png',
                  contentType: 'image/png'
                }
              }
            }
          },
          content: [],
          nodeType: 'embedded-asset-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value:
                'Users know exactly why an import fails and how to fix it.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'I’m excited to share what we’ve built with you, and I would ',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [
                {
                  type: 'italic'
                }
              ],
              value: 'love',
              nodeType: 'text'
            },
            {
              data: {},
              marks: [],
              value: ' your feedback, ideas, or questions. Email me at ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'mailto:david@flatfile.io'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'david@flatfile.io',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value: ' or chat with our team on our ',
              nodeType: 'text'
            },
            {
              data: {
                uri: 'https://flatfile.com/'
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: 'website',
                  nodeType: 'text'
                }
              ],
              nodeType: 'hyperlink'
            },
            {
              data: {},
              marks: [],
              value:
                '. If you think this would be a good fit for your startup — let’s talk!',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Here’s to more delightful solutions to common, painful problems.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        },
        {
          data: {
            target: {
              metadata: {
                tags: [],
                concepts: []
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'hjneo4qi4goj'
                  }
                },
                id: '4HbsSjO3IEZZFpcrQRycC4',
                type: 'Entry',
                createdAt: '2021-08-16T23:00:28.669Z',
                updatedAt: '2021-08-16T23:00:28.669Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment'
                  }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                  sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'cta'
                  }
                },
                locale: 'en-US'
              },
              fields: {
                title: 'The elegant data import button is here',
                text: 'See it in action',
                ctaText: 'Request a demo',
                href: '/request-a-demo/'
              }
            }
          },
          content: [],
          nodeType: 'embedded-entry-block'
        },
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    }
  }
]
